webpackJsonp([151087471038741],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * String of the current PIXI version.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name VERSION
	 * @type {string}
	 */
	var VERSION = exports.VERSION = '4.8.0';
	
	/**
	 * Two Pi.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var PI_2 = exports.PI_2 = Math.PI * 2;
	
	/**
	 * Conversion factor for converting radians to degrees.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;
	
	/**
	 * Conversion factor for converting degrees to radians.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;
	
	/**
	 * Constant to identify the Renderer Type.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name RENDERER_TYPE
	 * @type {object}
	 * @property {number} UNKNOWN - Unknown render type.
	 * @property {number} WEBGL - WebGL render type.
	 * @property {number} CANVAS - Canvas render type.
	 */
	var RENDERER_TYPE = exports.RENDERER_TYPE = {
	  UNKNOWN: 0,
	  WEBGL: 1,
	  CANVAS: 2
	};
	
	/**
	 * Various blend modes supported by PIXI.
	 *
	 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
	 * Anything else will silently act like NORMAL.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name BLEND_MODES
	 * @type {object}
	 * @property {number} NORMAL
	 * @property {number} ADD
	 * @property {number} MULTIPLY
	 * @property {number} SCREEN
	 * @property {number} OVERLAY
	 * @property {number} DARKEN
	 * @property {number} LIGHTEN
	 * @property {number} COLOR_DODGE
	 * @property {number} COLOR_BURN
	 * @property {number} HARD_LIGHT
	 * @property {number} SOFT_LIGHT
	 * @property {number} DIFFERENCE
	 * @property {number} EXCLUSION
	 * @property {number} HUE
	 * @property {number} SATURATION
	 * @property {number} COLOR
	 * @property {number} LUMINOSITY
	 */
	var BLEND_MODES = exports.BLEND_MODES = {
	  NORMAL: 0,
	  ADD: 1,
	  MULTIPLY: 2,
	  SCREEN: 3,
	  OVERLAY: 4,
	  DARKEN: 5,
	  LIGHTEN: 6,
	  COLOR_DODGE: 7,
	  COLOR_BURN: 8,
	  HARD_LIGHT: 9,
	  SOFT_LIGHT: 10,
	  DIFFERENCE: 11,
	  EXCLUSION: 12,
	  HUE: 13,
	  SATURATION: 14,
	  COLOR: 15,
	  LUMINOSITY: 16,
	  NORMAL_NPM: 17,
	  ADD_NPM: 18,
	  SCREEN_NPM: 19
	};
	
	/**
	 * Various webgl draw modes. These can be used to specify which GL drawMode to use
	 * under certain situations and renderers.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name DRAW_MODES
	 * @type {object}
	 * @property {number} POINTS
	 * @property {number} LINES
	 * @property {number} LINE_LOOP
	 * @property {number} LINE_STRIP
	 * @property {number} TRIANGLES
	 * @property {number} TRIANGLE_STRIP
	 * @property {number} TRIANGLE_FAN
	 */
	var DRAW_MODES = exports.DRAW_MODES = {
	  POINTS: 0,
	  LINES: 1,
	  LINE_LOOP: 2,
	  LINE_STRIP: 3,
	  TRIANGLES: 4,
	  TRIANGLE_STRIP: 5,
	  TRIANGLE_FAN: 6
	};
	
	/**
	 * The scale modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
	 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name SCALE_MODES
	 * @type {object}
	 * @property {number} LINEAR Smooth scaling
	 * @property {number} NEAREST Pixelating scaling
	 */
	var SCALE_MODES = exports.SCALE_MODES = {
	  LINEAR: 0,
	  NEAREST: 1
	};
	
	/**
	 * The wrap modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
	 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
	 * If the texture is non power of two then clamp will be used regardless as webGL can
	 * only use REPEAT if the texture is po2.
	 *
	 * This property only affects WebGL.
	 *
	 * @static
	 * @constant
	 * @name WRAP_MODES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} CLAMP - The textures uvs are clamped
	 * @property {number} REPEAT - The texture uvs tile and repeat
	 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
	 */
	var WRAP_MODES = exports.WRAP_MODES = {
	  CLAMP: 0,
	  REPEAT: 1,
	  MIRRORED_REPEAT: 2
	};
	
	/**
	 * The gc modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
	 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
	 * used for a specified period of time they will be removed from the GPU. They will of course
	 * be uploaded again when they are required. This is a silent behind the scenes process that
	 * should ensure that the GPU does not  get filled up.
	 *
	 * Handy for mobile devices!
	 * This property only affects WebGL.
	 *
	 * @static
	 * @constant
	 * @name GC_MODES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} AUTO - Garbage collection will happen periodically automatically
	 * @property {number} MANUAL - Garbage collection will need to be called manually
	 */
	var GC_MODES = exports.GC_MODES = {
	  AUTO: 0,
	  MANUAL: 1
	};
	
	/**
	 * Regexp for image type by extension.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example `image.png`
	 */
	var URL_FILE_EXTENSION = exports.URL_FILE_EXTENSION = /\.(\w{3,4})(?:$|\?|#)/i;
	
	/**
	 * Regexp for data URI.
	 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
	 *
	 * @static
	 * @constant
	 * @name DATA_URI
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example data:image/png;base64
	 */
	var DATA_URI = exports.DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
	
	/**
	 * Regexp for SVG size.
	 *
	 * @static
	 * @constant
	 * @name SVG_SIZE
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
	 */
	var SVG_SIZE = exports.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len
	
	/**
	 * Constants that identify shapes, mainly to prevent `instanceof` calls.
	 *
	 * @static
	 * @constant
	 * @name SHAPES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} POLY Polygon
	 * @property {number} RECT Rectangle
	 * @property {number} CIRC Circle
	 * @property {number} ELIP Ellipse
	 * @property {number} RREC Rounded Rectangle
	 */
	var SHAPES = exports.SHAPES = {
	  POLY: 0,
	  RECT: 1,
	  CIRC: 2,
	  ELIP: 3,
	  RREC: 4
	};
	
	/**
	 * Constants that specify float precision in shaders.
	 *
	 * @static
	 * @constant
	 * @name PRECISION
	 * @memberof PIXI
	 * @type {object}
	 * @property {string} LOW='lowp'
	 * @property {string} MEDIUM='mediump'
	 * @property {string} HIGH='highp'
	 */
	var PRECISION = exports.PRECISION = {
	  LOW: 'lowp',
	  MEDIUM: 'mediump',
	  HIGH: 'highp'
	};
	
	/**
	 * Constants that specify the transform type.
	 *
	 * @static
	 * @constant
	 * @name TRANSFORM_MODE
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} STATIC
	 * @property {number} DYNAMIC
	 */
	var TRANSFORM_MODE = exports.TRANSFORM_MODE = {
	  STATIC: 0,
	  DYNAMIC: 1
	};
	
	/**
	 * Constants that define the type of gradient on text.
	 *
	 * @static
	 * @constant
	 * @name TEXT_GRADIENT
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} LINEAR_VERTICAL Vertical gradient
	 * @property {number} LINEAR_HORIZONTAL Linear gradient
	 */
	var TEXT_GRADIENT = exports.TEXT_GRADIENT = {
	  LINEAR_VERTICAL: 0,
	  LINEAR_HORIZONTAL: 1
	};
	
	/**
	 * Represents the update priorities used by internal PIXI classes when registered with
	 * the {@link PIXI.ticker.Ticker} object. Higher priority items are updated first and lower
	 * priority items, such as render, should go later.
	 *
	 * @static
	 * @constant
	 * @name UPDATE_PRIORITY
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.interaction.InteractionManager}
	 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.extras.AnimatedSprite}
	 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.ticker.Ticker#add}.
	 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
	 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.prepare.BasePrepare} utility.
	 */
	var UPDATE_PRIORITY = exports.UPDATE_PRIORITY = {
	  INTERACTION: 50,
	  HIGH: 25,
	  NORMAL: 0,
	  LOW: -25,
	  UTILITY: -50
	};
	//# sourceMappingURL=const.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.autoDetectRenderer = exports.Application = exports.Filter = exports.SpriteMaskFilter = exports.Quad = exports.RenderTarget = exports.ObjectRenderer = exports.WebGLManager = exports.Shader = exports.CanvasRenderTarget = exports.TextureUvs = exports.VideoBaseTexture = exports.BaseRenderTexture = exports.RenderTexture = exports.BaseTexture = exports.TextureMatrix = exports.Texture = exports.Spritesheet = exports.CanvasGraphicsRenderer = exports.GraphicsRenderer = exports.GraphicsData = exports.Graphics = exports.TextMetrics = exports.TextStyle = exports.Text = exports.SpriteRenderer = exports.CanvasTinter = exports.CanvasSpriteRenderer = exports.Sprite = exports.TransformBase = exports.TransformStatic = exports.Transform = exports.Container = exports.DisplayObject = exports.Bounds = exports.glCore = exports.WebGLRenderer = exports.CanvasRenderer = exports.ticker = exports.utils = exports.settings = undefined;
	
	var _const = __webpack_require__(3);
	
	Object.keys(_const).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _const[key];
	    }
	  });
	});
	
	var _math = __webpack_require__(7);
	
	Object.keys(_math).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _math[key];
	    }
	  });
	});
	
	var _pixiGlCore = __webpack_require__(8);
	
	Object.defineProperty(exports, 'glCore', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pixiGlCore).default;
	  }
	});
	
	var _Bounds = __webpack_require__(58);
	
	Object.defineProperty(exports, 'Bounds', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bounds).default;
	  }
	});
	
	var _DisplayObject = __webpack_require__(103);
	
	Object.defineProperty(exports, 'DisplayObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplayObject).default;
	  }
	});
	
	var _Container = __webpack_require__(27);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});
	
	var _Transform = __webpack_require__(104);
	
	Object.defineProperty(exports, 'Transform', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Transform).default;
	  }
	});
	
	var _TransformStatic = __webpack_require__(105);
	
	Object.defineProperty(exports, 'TransformStatic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransformStatic).default;
	  }
	});
	
	var _TransformBase = __webpack_require__(59);
	
	Object.defineProperty(exports, 'TransformBase', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransformBase).default;
	  }
	});
	
	var _Sprite = __webpack_require__(63);
	
	Object.defineProperty(exports, 'Sprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sprite).default;
	  }
	});
	
	var _CanvasSpriteRenderer = __webpack_require__(230);
	
	Object.defineProperty(exports, 'CanvasSpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasSpriteRenderer).default;
	  }
	});
	
	var _CanvasTinter = __webpack_require__(64);
	
	Object.defineProperty(exports, 'CanvasTinter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasTinter).default;
	  }
	});
	
	var _SpriteRenderer = __webpack_require__(232);
	
	Object.defineProperty(exports, 'SpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SpriteRenderer).default;
	  }
	});
	
	var _Text = __webpack_require__(234);
	
	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Text).default;
	  }
	});
	
	var _TextStyle = __webpack_require__(116);
	
	Object.defineProperty(exports, 'TextStyle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextStyle).default;
	  }
	});
	
	var _TextMetrics = __webpack_require__(115);
	
	Object.defineProperty(exports, 'TextMetrics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextMetrics).default;
	  }
	});
	
	var _Graphics = __webpack_require__(202);
	
	Object.defineProperty(exports, 'Graphics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Graphics).default;
	  }
	});
	
	var _GraphicsData = __webpack_require__(106);
	
	Object.defineProperty(exports, 'GraphicsData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicsData).default;
	  }
	});
	
	var _GraphicsRenderer = __webpack_require__(205);
	
	Object.defineProperty(exports, 'GraphicsRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicsRenderer).default;
	  }
	});
	
	var _CanvasGraphicsRenderer = __webpack_require__(203);
	
	Object.defineProperty(exports, 'CanvasGraphicsRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasGraphicsRenderer).default;
	  }
	});
	
	var _Spritesheet = __webpack_require__(235);
	
	Object.defineProperty(exports, 'Spritesheet', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spritesheet).default;
	  }
	});
	
	var _Texture = __webpack_require__(17);
	
	Object.defineProperty(exports, 'Texture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Texture).default;
	  }
	});
	
	var _TextureMatrix = __webpack_require__(118);
	
	Object.defineProperty(exports, 'TextureMatrix', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextureMatrix).default;
	  }
	});
	
	var _BaseTexture = __webpack_require__(24);
	
	Object.defineProperty(exports, 'BaseTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseTexture).default;
	  }
	});
	
	var _RenderTexture = __webpack_require__(65);
	
	Object.defineProperty(exports, 'RenderTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenderTexture).default;
	  }
	});
	
	var _BaseRenderTexture = __webpack_require__(117);
	
	Object.defineProperty(exports, 'BaseRenderTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseRenderTexture).default;
	  }
	});
	
	var _VideoBaseTexture = __webpack_require__(120);
	
	Object.defineProperty(exports, 'VideoBaseTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoBaseTexture).default;
	  }
	});
	
	var _TextureUvs = __webpack_require__(119);
	
	Object.defineProperty(exports, 'TextureUvs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextureUvs).default;
	  }
	});
	
	var _CanvasRenderTarget = __webpack_require__(110);
	
	Object.defineProperty(exports, 'CanvasRenderTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasRenderTarget).default;
	  }
	});
	
	var _Shader = __webpack_require__(26);
	
	Object.defineProperty(exports, 'Shader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Shader).default;
	  }
	});
	
	var _WebGLManager = __webpack_require__(29);
	
	Object.defineProperty(exports, 'WebGLManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLManager).default;
	  }
	});
	
	var _ObjectRenderer = __webpack_require__(36);
	
	Object.defineProperty(exports, 'ObjectRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ObjectRenderer).default;
	  }
	});
	
	var _RenderTarget = __webpack_require__(37);
	
	Object.defineProperty(exports, 'RenderTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenderTarget).default;
	  }
	});
	
	var _Quad = __webpack_require__(114);
	
	Object.defineProperty(exports, 'Quad', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Quad).default;
	  }
	});
	
	var _SpriteMaskFilter = __webpack_require__(113);
	
	Object.defineProperty(exports, 'SpriteMaskFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SpriteMaskFilter).default;
	  }
	});
	
	var _Filter = __webpack_require__(112);
	
	Object.defineProperty(exports, 'Filter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});
	
	var _Application = __webpack_require__(101);
	
	Object.defineProperty(exports, 'Application', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Application).default;
	  }
	});
	
	var _autoDetectRenderer = __webpack_require__(102);
	
	Object.defineProperty(exports, 'autoDetectRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _autoDetectRenderer.autoDetectRenderer;
	  }
	});
	
	var _utils = __webpack_require__(5);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _ticker = __webpack_require__(66);
	
	var ticker = _interopRequireWildcard(_ticker);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _CanvasRenderer = __webpack_require__(28);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _WebGLRenderer = __webpack_require__(35);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.settings = _settings2.default;
	exports.utils = utils;
	exports.ticker = ticker;
	exports.CanvasRenderer = _CanvasRenderer2.default;
	exports.WebGLRenderer = _WebGLRenderer2.default; /**
	                                                  * @namespace PIXI
	                                                  */
	//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.premultiplyBlendMode = exports.BaseTextureCache = exports.TextureCache = exports.earcut = exports.mixins = exports.pluginTarget = exports.EventEmitter = exports.removeItems = exports.isMobile = undefined;
	exports.uid = uid;
	exports.hex2rgb = hex2rgb;
	exports.hex2string = hex2string;
	exports.rgb2hex = rgb2hex;
	exports.getResolutionOfUrl = getResolutionOfUrl;
	exports.decomposeDataUri = decomposeDataUri;
	exports.getUrlFileExtension = getUrlFileExtension;
	exports.getSvgSize = getSvgSize;
	exports.skipHello = skipHello;
	exports.sayHello = sayHello;
	exports.isWebGLSupported = isWebGLSupported;
	exports.sign = sign;
	exports.destroyTextureCache = destroyTextureCache;
	exports.clearTextureCache = clearTextureCache;
	exports.correctBlendMode = correctBlendMode;
	exports.premultiplyTint = premultiplyTint;
	exports.premultiplyRgba = premultiplyRgba;
	exports.premultiplyTintToRgba = premultiplyTintToRgba;
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _eventemitter = __webpack_require__(19);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _pluginTarget = __webpack_require__(242);
	
	var _pluginTarget2 = _interopRequireDefault(_pluginTarget);
	
	var _mixin = __webpack_require__(241);
	
	var mixins = _interopRequireWildcard(_mixin);
	
	var _ismobilejs = __webpack_require__(56);
	
	var isMobile = _interopRequireWildcard(_ismobilejs);
	
	var _removeArrayItems = __webpack_require__(298);
	
	var _removeArrayItems2 = _interopRequireDefault(_removeArrayItems);
	
	var _mapPremultipliedBlendModes = __webpack_require__(239);
	
	var _mapPremultipliedBlendModes2 = _interopRequireDefault(_mapPremultipliedBlendModes);
	
	var _earcut = __webpack_require__(54);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nextUid = 0;
	var saidHello = false;
	
	/**
	 * Generalized convenience utilities for PIXI.
	 * @example
	 * // Extend PIXI's internal Event Emitter.
	 * class MyEmitter extends PIXI.utils.EventEmitter {
	 *   constructor() {
	 *      super();
	 *      console.log("Emitter created!");
	 *   }
	 * }
	 *
	 * // Get info on current device
	 * console.log(PIXI.utils.isMobile);
	 *
	 * // Convert hex color to string
	 * console.log(PIXI.utils.hex2string(0xff00ff)); // returns: "#ff00ff"
	 * @namespace PIXI.utils
	 */
	exports.isMobile = isMobile;
	exports.removeItems = _removeArrayItems2.default;
	exports.EventEmitter = _eventemitter2.default;
	exports.pluginTarget = _pluginTarget2.default;
	exports.mixins = mixins;
	exports.earcut = _earcut2.default;
	
	/**
	 * Gets the next unique identifier
	 *
	 * @memberof PIXI.utils
	 * @function uid
	 * @return {number} The next unique identifier to use.
	 */
	
	function uid() {
	    return ++nextUid;
	}
	
	/**
	 * Converts a hex color number to an [R, G, B] array
	 *
	 * @memberof PIXI.utils
	 * @function hex2rgb
	 * @param {number} hex - The number to convert
	 * @param  {number[]} [out=[]] If supplied, this array will be used rather than returning a new one
	 * @return {number[]} An array representing the [R, G, B] of the color.
	 */
	function hex2rgb(hex, out) {
	    out = out || [];
	
	    out[0] = (hex >> 16 & 0xFF) / 255;
	    out[1] = (hex >> 8 & 0xFF) / 255;
	    out[2] = (hex & 0xFF) / 255;
	
	    return out;
	}
	
	/**
	 * Converts a hex color number to a string.
	 *
	 * @memberof PIXI.utils
	 * @function hex2string
	 * @param {number} hex - Number in hex
	 * @return {string} The string color.
	 */
	function hex2string(hex) {
	    hex = hex.toString(16);
	    hex = '000000'.substr(0, 6 - hex.length) + hex;
	
	    return '#' + hex;
	}
	
	/**
	 * Converts a color as an [R, G, B] array to a hex number
	 *
	 * @memberof PIXI.utils
	 * @function rgb2hex
	 * @param {number[]} rgb - rgb array
	 * @return {number} The color number
	 */
	function rgb2hex(rgb) {
	    return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
	}
	
	/**
	 * get the resolution / device pixel ratio of an asset by looking for the prefix
	 * used by spritesheets and image urls
	 *
	 * @memberof PIXI.utils
	 * @function getResolutionOfUrl
	 * @param {string} url - the image path
	 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
	 * @return {number} resolution / device pixel ratio of an asset
	 */
	function getResolutionOfUrl(url, defaultValue) {
	    var resolution = _settings2.default.RETINA_PREFIX.exec(url);
	
	    if (resolution) {
	        return parseFloat(resolution[1]);
	    }
	
	    return defaultValue !== undefined ? defaultValue : 1;
	}
	
	/**
	 * Typedef for decomposeDataUri return object.
	 *
	 * @typedef {object} PIXI.utils~DecomposedDataUri
	 * @property {mediaType} Media type, eg. `image`
	 * @property {subType} Sub type, eg. `png`
	 * @property {encoding} Data encoding, eg. `base64`
	 * @property {data} The actual data
	 */
	
	/**
	 * Split a data URI into components. Returns undefined if
	 * parameter `dataUri` is not a valid data URI.
	 *
	 * @memberof PIXI.utils
	 * @function decomposeDataUri
	 * @param {string} dataUri - the data URI to check
	 * @return {PIXI.utils~DecomposedDataUri|undefined} The decomposed data uri or undefined
	 */
	function decomposeDataUri(dataUri) {
	    var dataUriMatch = _const.DATA_URI.exec(dataUri);
	
	    if (dataUriMatch) {
	        return {
	            mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
	            subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
	            charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
	            encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
	            data: dataUriMatch[5]
	        };
	    }
	
	    return undefined;
	}
	
	/**
	 * Get type of the image by regexp for extension. Returns undefined for unknown extensions.
	 *
	 * @memberof PIXI.utils
	 * @function getUrlFileExtension
	 * @param {string} url - the image path
	 * @return {string|undefined} image extension
	 */
	function getUrlFileExtension(url) {
	    var extension = _const.URL_FILE_EXTENSION.exec(url);
	
	    if (extension) {
	        return extension[1].toLowerCase();
	    }
	
	    return undefined;
	}
	
	/**
	 * Typedef for Size object.
	 *
	 * @typedef {object} PIXI.utils~Size
	 * @property {width} Width component
	 * @property {height} Height component
	 */
	
	/**
	 * Get size from an svg string using regexp.
	 *
	 * @memberof PIXI.utils
	 * @function getSvgSize
	 * @param {string} svgString - a serialized svg element
	 * @return {PIXI.utils~Size|undefined} image extension
	 */
	function getSvgSize(svgString) {
	    var sizeMatch = _const.SVG_SIZE.exec(svgString);
	    var size = {};
	
	    if (sizeMatch) {
	        size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
	        size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
	    }
	
	    return size;
	}
	
	/**
	 * Skips the hello message of renderers that are created after this is run.
	 *
	 * @function skipHello
	 * @memberof PIXI.utils
	 */
	function skipHello() {
	    saidHello = true;
	}
	
	/**
	 * Logs out the version and renderer information for this running instance of PIXI.
	 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
	 * creating your renderer. Keep in mind that doing that will forever makes you a jerk face.
	 *
	 * @static
	 * @function sayHello
	 * @memberof PIXI.utils
	 * @param {string} type - The string renderer type to log.
	 */
	function sayHello(type) {
	    if (saidHello) {
	        return;
	    }
	
	    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	        var args = ['\n %c %c %c PixiJS ' + _const.VERSION + ' - \u2730 ' + type + ' \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n', 'background: #ff66a5; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff66a5; background: #030307; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'background: #ffc3dc; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;'];
	
	        window.console.log.apply(console, args);
	    } else if (window.console) {
	        window.console.log('PixiJS ' + _const.VERSION + ' - ' + type + ' - http://www.pixijs.com/');
	    }
	
	    saidHello = true;
	}
	
	/**
	 * Helper for checking for webgl support
	 *
	 * @memberof PIXI.utils
	 * @function isWebGLSupported
	 * @return {boolean} is webgl supported
	 */
	function isWebGLSupported() {
	    var contextOptions = { stencil: true, failIfMajorPerformanceCaveat: true };
	
	    try {
	        if (!window.WebGLRenderingContext) {
	            return false;
	        }
	
	        var canvas = document.createElement('canvas');
	        var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);
	
	        var success = !!(gl && gl.getContextAttributes().stencil);
	
	        if (gl) {
	            var loseContext = gl.getExtension('WEBGL_lose_context');
	
	            if (loseContext) {
	                loseContext.loseContext();
	            }
	        }
	
	        gl = null;
	
	        return success;
	    } catch (e) {
	        return false;
	    }
	}
	
	/**
	 * Returns sign of number
	 *
	 * @memberof PIXI.utils
	 * @function sign
	 * @param {number} n - the number to check the sign of
	 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
	 */
	function sign(n) {
	    if (n === 0) return 0;
	
	    return n < 0 ? -1 : 1;
	}
	
	/**
	 * @todo Describe property usage
	 *
	 * @memberof PIXI.utils
	 * @private
	 */
	var TextureCache = exports.TextureCache = Object.create(null);
	
	/**
	 * @todo Describe property usage
	 *
	 * @memberof PIXI.utils
	 * @private
	 */
	var BaseTextureCache = exports.BaseTextureCache = Object.create(null);
	
	/**
	 * Destroys all texture in the cache
	 *
	 * @memberof PIXI.utils
	 * @function destroyTextureCache
	 */
	function destroyTextureCache() {
	    var key = void 0;
	
	    for (key in TextureCache) {
	        TextureCache[key].destroy();
	    }
	    for (key in BaseTextureCache) {
	        BaseTextureCache[key].destroy();
	    }
	}
	
	/**
	 * Removes all textures from cache, but does not destroy them
	 *
	 * @memberof PIXI.utils
	 * @function clearTextureCache
	 */
	function clearTextureCache() {
	    var key = void 0;
	
	    for (key in TextureCache) {
	        delete TextureCache[key];
	    }
	    for (key in BaseTextureCache) {
	        delete BaseTextureCache[key];
	    }
	}
	
	/**
	 * maps premultiply flag and blendMode to adjusted blendMode
	 * @memberof PIXI.utils
	 * @const premultiplyBlendMode
	 * @type {Array<number[]>}
	 */
	var premultiplyBlendMode = exports.premultiplyBlendMode = (0, _mapPremultipliedBlendModes2.default)();
	
	/**
	 * changes blendMode according to texture format
	 *
	 * @memberof PIXI.utils
	 * @function correctBlendMode
	 * @param {number} blendMode supposed blend mode
	 * @param {boolean} premultiplied  whether source is premultiplied
	 * @returns {number} true blend mode for this texture
	 */
	function correctBlendMode(blendMode, premultiplied) {
	    return premultiplyBlendMode[premultiplied ? 1 : 0][blendMode];
	}
	
	/**
	 * premultiplies tint
	 *
	 * @memberof PIXI.utils
	 * @param {number} tint integet RGB
	 * @param {number} alpha floating point alpha (0.0-1.0)
	 * @returns {number} tint multiplied by alpha
	 */
	function premultiplyTint(tint, alpha) {
	    if (alpha === 1.0) {
	        return (alpha * 255 << 24) + tint;
	    }
	    if (alpha === 0.0) {
	        return 0;
	    }
	    var R = tint >> 16 & 0xFF;
	    var G = tint >> 8 & 0xFF;
	    var B = tint & 0xFF;
	
	    R = R * alpha + 0.5 | 0;
	    G = G * alpha + 0.5 | 0;
	    B = B * alpha + 0.5 | 0;
	
	    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
	}
	
	/**
	 * combines rgb and alpha to out array
	 *
	 * @memberof PIXI.utils
	 * @param {Float32Array|number[]} rgb input rgb
	 * @param {number} alpha alpha param
	 * @param {Float32Array} [out] output
	 * @param {boolean} [premultiply=true] do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyRgba(rgb, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    if (premultiply || premultiply === undefined) {
	        out[0] = rgb[0] * alpha;
	        out[1] = rgb[1] * alpha;
	        out[2] = rgb[2] * alpha;
	    } else {
	        out[0] = rgb[0];
	        out[1] = rgb[1];
	        out[2] = rgb[2];
	    }
	    out[3] = alpha;
	
	    return out;
	}
	
	/**
	 * converts integer tint and float alpha to vec4 form, premultiplies by default
	 *
	 * @memberof PIXI.utils
	 * @param {number} tint input tint
	 * @param {number} alpha alpha param
	 * @param {Float32Array} [out] output
	 * @param {boolean} [premultiply=true] do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyTintToRgba(tint, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    out[0] = (tint >> 16 & 0xFF) / 255.0;
	    out[1] = (tint >> 8 & 0xFF) / 255.0;
	    out[2] = (tint & 0xFF) / 255.0;
	    if (premultiply || premultiply === undefined) {
	        out[0] *= alpha;
	        out[1] *= alpha;
	        out[2] *= alpha;
	    }
	    out[3] = alpha;
	
	    return out;
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _maxRecommendedTextures = __webpack_require__(240);
	
	var _maxRecommendedTextures2 = _interopRequireDefault(_maxRecommendedTextures);
	
	var _canUploadSameBuffer = __webpack_require__(238);
	
	var _canUploadSameBuffer2 = _interopRequireDefault(_canUploadSameBuffer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User's customizable globals for overriding the default PIXI settings, such
	 * as a renderer's default resolution, framerate, float percision, etc.
	 * @example
	 * // Use the native window resolution as the default resolution
	 * // will support high-density displays when rendering
	 * PIXI.settings.RESOLUTION = window.devicePixelRatio.
	 *
	 * // Disable interpolation when scaling, will make texture be pixelated
	 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
	 * @namespace PIXI.settings
	 */
	exports.default = {
	
	  /**
	   * Target frames per millisecond.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 0.06
	   */
	  TARGET_FPMS: 0.06,
	
	  /**
	   * If set to true WebGL will attempt make textures mimpaped by default.
	   * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {boolean}
	   * @default true
	   */
	  MIPMAP_TEXTURES: true,
	
	  /**
	   * Default resolution / device pixel ratio of the renderer.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 1
	   */
	  RESOLUTION: 1,
	
	  /**
	   * Default filter resolution.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 1
	   */
	  FILTER_RESOLUTION: 1,
	
	  /**
	   * The maximum textures that this device supports.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 32
	   */
	  SPRITE_MAX_TEXTURES: (0, _maxRecommendedTextures2.default)(32),
	
	  // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
	  // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
	
	  /**
	   * The default sprite batch size.
	   *
	   * The default aims to balance desktop and mobile devices.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 4096
	   */
	  SPRITE_BATCH_SIZE: 4096,
	
	  /**
	   * The prefix that denotes a URL is for a retina asset.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {RegExp}
	   * @example `@2x`
	   * @default /@([0-9\.]+)x/
	   */
	  RETINA_PREFIX: /@([0-9\.]+)x/,
	
	  /**
	   * The default render options if none are supplied to {@link PIXI.WebGLRenderer}
	   * or {@link PIXI.CanvasRenderer}.
	   *
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {object}
	   * @property {HTMLCanvasElement} view=null
	   * @property {number} resolution=1
	   * @property {boolean} antialias=false
	   * @property {boolean} forceFXAA=false
	   * @property {boolean} autoResize=false
	   * @property {boolean} transparent=false
	   * @property {number} backgroundColor=0x000000
	   * @property {boolean} clearBeforeRender=true
	   * @property {boolean} preserveDrawingBuffer=false
	   * @property {boolean} roundPixels=false
	   * @property {number} width=800
	   * @property {number} height=600
	   * @property {boolean} legacy=false
	   */
	  RENDER_OPTIONS: {
	    view: null,
	    antialias: false,
	    forceFXAA: false,
	    autoResize: false,
	    transparent: false,
	    backgroundColor: 0x000000,
	    clearBeforeRender: true,
	    preserveDrawingBuffer: false,
	    roundPixels: false,
	    width: 800,
	    height: 600,
	    legacy: false
	  },
	
	  /**
	   * Default transform type.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.TRANSFORM_MODE}
	   * @default PIXI.TRANSFORM_MODE.STATIC
	   */
	  TRANSFORM_MODE: 0,
	
	  /**
	   * Default Garbage Collection mode.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.GC_MODES}
	   * @default PIXI.GC_MODES.AUTO
	   */
	  GC_MODE: 0,
	
	  /**
	   * Default Garbage Collection max idle.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 3600
	   */
	  GC_MAX_IDLE: 60 * 60,
	
	  /**
	   * Default Garbage Collection maximum check count.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 600
	   */
	  GC_MAX_CHECK_COUNT: 60 * 10,
	
	  /**
	   * Default wrap modes that are supported by pixi.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.WRAP_MODES}
	   * @default PIXI.WRAP_MODES.CLAMP
	   */
	  WRAP_MODE: 0,
	
	  /**
	   * The scale modes that are supported by pixi.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.SCALE_MODES}
	   * @default PIXI.SCALE_MODES.LINEAR
	   */
	  SCALE_MODE: 0,
	
	  /**
	   * Default specify float precision in vertex shader.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.PRECISION}
	   * @default PIXI.PRECISION.HIGH
	   */
	  PRECISION_VERTEX: 'highp',
	
	  /**
	   * Default specify float precision in fragment shader.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.PRECISION}
	   * @default PIXI.PRECISION.MEDIUM
	   */
	  PRECISION_FRAGMENT: 'mediump',
	
	  /**
	   * Can we upload the same buffer in a single frame?
	   *
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {boolean}
	   */
	  CAN_UPLOAD_SAME_BUFFER: (0, _canUploadSameBuffer2.default)(),
	
	  /**
	   * Default Mesh `canvasPadding`.
	   *
	   * @see PIXI.mesh.Mesh#canvasPadding
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {number}
	   */
	  MESH_CANVAS_PADDING: 0
	};
	//# sourceMappingURL=settings.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Point = __webpack_require__(61);
	
	Object.defineProperty(exports, 'Point', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Point).default;
	  }
	});
	
	var _ObservablePoint = __webpack_require__(108);
	
	Object.defineProperty(exports, 'ObservablePoint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ObservablePoint).default;
	  }
	});
	
	var _Matrix = __webpack_require__(60);
	
	Object.defineProperty(exports, 'Matrix', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Matrix).default;
	  }
	});
	
	var _GroupD = __webpack_require__(107);
	
	Object.defineProperty(exports, 'GroupD8', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupD).default;
	  }
	});
	
	var _Circle = __webpack_require__(212);
	
	Object.defineProperty(exports, 'Circle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Ellipse = __webpack_require__(213);
	
	Object.defineProperty(exports, 'Ellipse', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ellipse).default;
	  }
	});
	
	var _Polygon = __webpack_require__(214);
	
	Object.defineProperty(exports, 'Polygon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polygon).default;
	  }
	});
	
	var _Rectangle = __webpack_require__(62);
	
	Object.defineProperty(exports, 'Rectangle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rectangle).default;
	  }
	});
	
	var _RoundedRectangle = __webpack_require__(215);
	
	Object.defineProperty(exports, 'RoundedRectangle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RoundedRectangle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var gl = {
	    createContext:          __webpack_require__(198),
	    setVertexAttribArrays:  __webpack_require__(92),
	    GLBuffer:               __webpack_require__(194),
	    GLFramebuffer:          __webpack_require__(195),
	    GLShader:               __webpack_require__(196),
	    GLTexture:              __webpack_require__(91),
	    VertexArrayObject:      __webpack_require__(197),
	    shader:                 __webpack_require__(199)
	};
	
	// Export for Node-compatible environments
	if (typeof module !== 'undefined' && module.exports)
	{
	    // Export the module
	    module.exports = gl;
	}
	
	// Add to the browser window pixi.gl
	if (typeof window !== 'undefined')
	{
	    // add the window object
	    window.PIXI = window.PIXI || {};
	    window.PIXI.glCore = gl;
	}


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(178)))

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseTexture = __webpack_require__(24);
	
	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
	
	var _VideoBaseTexture = __webpack_require__(120);
	
	var _VideoBaseTexture2 = _interopRequireDefault(_VideoBaseTexture);
	
	var _TextureUvs = __webpack_require__(119);
	
	var _TextureUvs2 = _interopRequireDefault(_TextureUvs);
	
	var _eventemitter = __webpack_require__(19);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _math = __webpack_require__(7);
	
	var _utils = __webpack_require__(5);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A texture stores the information that represents an image or part of an image. It cannot be added
	 * to the display list directly. Instead use it as the texture for a Sprite. If no frame is provided
	 * then the whole image is used.
	 *
	 * You can directly create a texture from an image and then reuse it multiple times like this :
	 *
	 * ```js
	 * let texture = PIXI.Texture.fromImage('assets/image.png');
	 * let sprite1 = new PIXI.Sprite(texture);
	 * let sprite2 = new PIXI.Sprite(texture);
	 * ```
	 *
	 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
	 * You can check for this by checking the sprite's _textureID property.
	 * ```js
	 * var texture = PIXI.Texture.fromImage('assets/image.svg');
	 * var sprite1 = new PIXI.Sprite(texture);
	 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
	 * ```
	 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var Texture = function (_EventEmitter) {
	    _inherits(Texture, _EventEmitter);
	
	    /**
	     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     * @param {PIXI.Rectangle} [orig] - The area of original texture
	     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
	     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.GroupD8}
	     */
	    function Texture(baseTexture, frame, orig, trim, rotate) {
	        _classCallCheck(this, Texture);
	
	        /**
	         * Does this Texture have any frame data assigned to it?
	         *
	         * @member {boolean}
	         */
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        _this.noFrame = false;
	
	        if (!frame) {
	            _this.noFrame = true;
	            frame = new _math.Rectangle(0, 0, 1, 1);
	        }
	
	        if (baseTexture instanceof Texture) {
	            baseTexture = baseTexture.baseTexture;
	        }
	
	        /**
	         * The base texture that this texture uses.
	         *
	         * @member {PIXI.BaseTexture}
	         */
	        _this.baseTexture = baseTexture;
	
	        /**
	         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
	         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this._frame = frame;
	
	        /**
	         * This is the trimmed area of original texture, before it was put in atlas
	         * Please call `_updateUvs()` after you change coordinates of `trim` manually.
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.trim = trim;
	
	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = false;
	
	        /**
	         * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
	         *
	         * @member {boolean}
	         */
	        _this.requiresUpdate = false;
	
	        /**
	         * The WebGL UV data cache.
	         *
	         * @member {PIXI.TextureUvs}
	         * @private
	         */
	        _this._uvs = null;
	
	        /**
	         * This is the area of original texture, before it was put in atlas
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);
	
	        _this._rotate = Number(rotate || 0);
	
	        if (rotate === true) {
	            // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
	            _this._rotate = 2;
	        } else if (_this._rotate % 2 !== 0) {
	            throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
	        }
	
	        if (baseTexture.hasLoaded) {
	            if (_this.noFrame) {
	                frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	
	                // if there is no frame we should monitor for any base texture changes..
	                baseTexture.on('update', _this.onBaseTextureUpdated, _this);
	            }
	            _this.frame = frame;
	        } else {
	            baseTexture.once('loaded', _this.onBaseTextureLoaded, _this);
	        }
	
	        /**
	         * Fired when the texture is updated. This happens if the frame or the baseTexture is updated.
	         *
	         * @event PIXI.Texture#update
	         * @protected
	         * @param {PIXI.Texture} texture - Instance of texture being updated.
	         */
	
	        _this._updateID = 0;
	
	        /**
	         * Contains data for uvs. May contain clamp settings and some matrices.
	         * Its a bit heavy, so by default that object is not created.
	         * @type {PIXI.TextureMatrix}
	         * @default null
	         */
	        _this.transform = null;
	
	        /**
	         * The ids under which this Texture has been added to the texture cache. This is
	         * automatically set as long as Texture.addToCache is used, but may not be set if a
	         * Texture is added directly to the TextureCache array.
	         *
	         * @member {string[]}
	         */
	        _this.textureCacheIds = [];
	        return _this;
	    }
	
	    /**
	     * Updates this texture on the gpu.
	     *
	     */
	
	
	    Texture.prototype.update = function update() {
	        this.baseTexture.update();
	    };
	
	    /**
	     * Called when the base texture is loaded
	     *
	     * @private
	     * @param {PIXI.BaseTexture} baseTexture - The base texture.
	     */
	
	
	    Texture.prototype.onBaseTextureLoaded = function onBaseTextureLoaded(baseTexture) {
	        this._updateID++;
	
	        // TODO this code looks confusing.. boo to abusing getters and setters!
	        if (this.noFrame) {
	            this.frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	        } else {
	            this.frame = this._frame;
	        }
	
	        this.baseTexture.on('update', this.onBaseTextureUpdated, this);
	        this.emit('update', this);
	    };
	
	    /**
	     * Called when the base texture is updated
	     *
	     * @private
	     * @param {PIXI.BaseTexture} baseTexture - The base texture.
	     */
	
	
	    Texture.prototype.onBaseTextureUpdated = function onBaseTextureUpdated(baseTexture) {
	        this._updateID++;
	
	        this._frame.width = baseTexture.width;
	        this._frame.height = baseTexture.height;
	
	        this.emit('update', this);
	    };
	
	    /**
	     * Destroys this texture
	     *
	     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
	     */
	
	
	    Texture.prototype.destroy = function destroy(destroyBase) {
	        if (this.baseTexture) {
	            if (destroyBase) {
	                // delete the texture if it exists in the texture cache..
	                // this only needs to be removed if the base texture is actually destroyed too..
	                if (_utils.TextureCache[this.baseTexture.imageUrl]) {
	                    Texture.removeFromCache(this.baseTexture.imageUrl);
	                }
	
	                this.baseTexture.destroy();
	            }
	
	            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
	            this.baseTexture.off('loaded', this.onBaseTextureLoaded, this);
	
	            this.baseTexture = null;
	        }
	
	        this._frame = null;
	        this._uvs = null;
	        this.trim = null;
	        this.orig = null;
	
	        this.valid = false;
	
	        Texture.removeFromCache(this);
	        this.textureCacheIds = null;
	    };
	
	    /**
	     * Creates a new texture object that acts the same as this one.
	     *
	     * @return {PIXI.Texture} The new texture
	     */
	
	
	    Texture.prototype.clone = function clone() {
	        return new Texture(this.baseTexture, this.frame, this.orig, this.trim, this.rotate);
	    };
	
	    /**
	     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
	     */
	
	
	    Texture.prototype._updateUvs = function _updateUvs() {
	        if (!this._uvs) {
	            this._uvs = new _TextureUvs2.default();
	        }
	
	        this._uvs.set(this._frame, this.baseTexture, this.rotate);
	
	        this._updateID++;
	    };
	
	    /**
	     * Helper function that creates a Texture object from the given image url.
	     * If the image is not in the texture cache it will be  created and loaded.
	     *
	     * @static
	     * @param {string} imageUrl - The image url of the texture
	     * @param {boolean} [crossorigin] - Whether requests should be treated as crossorigin
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with SVG images.
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
	        var texture = _utils.TextureCache[imageUrl];
	
	        if (!texture) {
	            texture = new Texture(_BaseTexture2.default.fromImage(imageUrl, crossorigin, scaleMode, sourceScale));
	            Texture.addToCache(texture, imageUrl);
	        }
	
	        return texture;
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromFrame = function fromFrame(frameId) {
	        var texture = _utils.TextureCache[frameId];
	
	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	        }
	
	        return texture;
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the given canvas element.
	     *
	     * @static
	     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {string} [origin='canvas'] - A string origin of who created the base texture
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromCanvas = function fromCanvas(canvas, scaleMode) {
	        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';
	
	        return new Texture(_BaseTexture2.default.fromCanvas(canvas, scaleMode, origin));
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the given video element.
	     *
	     * @static
	     * @param {HTMLVideoElement|string} video - The URL or actual element of the video
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromVideo = function fromVideo(video, scaleMode) {
	        if (typeof video === 'string') {
	            return Texture.fromVideoUrl(video, scaleMode);
	        }
	
	        return new Texture(_VideoBaseTexture2.default.fromVideo(video, scaleMode));
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the video url.
	     *
	     * @static
	     * @param {string} videoUrl - URL of the video
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.fromVideoUrl = function fromVideoUrl(videoUrl, scaleMode) {
	        return new Texture(_VideoBaseTexture2.default.fromUrl(videoUrl, scaleMode));
	    };
	
	    /**
	     * Helper function that creates a new Texture based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture}
	     *        source - Source to create texture from
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    Texture.from = function from(source) {
	        // TODO auto detect cross origin..
	        // TODO pass in scale mode?
	        if (typeof source === 'string') {
	            var texture = _utils.TextureCache[source];
	
	            if (!texture) {
	                // check if its a video..
	                var isVideo = source.match(/\.(mp4|webm|ogg|h264|avi|mov)$/) !== null;
	
	                if (isVideo) {
	                    return Texture.fromVideoUrl(source);
	                }
	
	                return Texture.fromImage(source);
	            }
	
	            return texture;
	        } else if (source instanceof HTMLImageElement) {
	            return new Texture(_BaseTexture2.default.from(source));
	        } else if (source instanceof HTMLCanvasElement) {
	            return Texture.fromCanvas(source, _settings2.default.SCALE_MODE, 'HTMLCanvasElement');
	        } else if (source instanceof HTMLVideoElement) {
	            return Texture.fromVideo(source);
	        } else if (source instanceof _BaseTexture2.default) {
	            return new Texture(source);
	        }
	
	        // lets assume its a texture!
	        return source;
	    };
	
	    /**
	     * Create a texture from a source and add to the cache.
	     *
	     * @static
	     * @param {HTMLImageElement|HTMLCanvasElement} source - The input source.
	     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
	     * @param {String} [name] - Human readible name for the texture cache. If no name is
	     *        specified, only `imageUrl` will be used as the cache ID.
	     * @return {PIXI.Texture} Output texture
	     */
	
	
	    Texture.fromLoader = function fromLoader(source, imageUrl, name) {
	        var baseTexture = new _BaseTexture2.default(source, undefined, (0, _utils.getResolutionOfUrl)(imageUrl));
	        var texture = new Texture(baseTexture);
	
	        baseTexture.imageUrl = imageUrl;
	
	        // No name, use imageUrl instead
	        if (!name) {
	            name = imageUrl;
	        }
	
	        // lets also add the frame to pixi's global cache for fromFrame and fromImage fucntions
	        _BaseTexture2.default.addToCache(texture.baseTexture, name);
	        Texture.addToCache(texture, name);
	
	        // also add references by url if they are different.
	        if (name !== imageUrl) {
	            _BaseTexture2.default.addToCache(texture.baseTexture, imageUrl);
	            Texture.addToCache(texture, imageUrl);
	        }
	
	        return texture;
	    };
	
	    /**
	     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.Texture} texture - The Texture to add to the cache.
	     * @param {string} id - The id that the Texture will be stored against.
	     */
	
	
	    Texture.addToCache = function addToCache(texture, id) {
	        if (id) {
	            if (texture.textureCacheIds.indexOf(id) === -1) {
	                texture.textureCacheIds.push(id);
	            }
	
	            // @if DEBUG
	            /* eslint-disable no-console */
	            if (_utils.TextureCache[id]) {
	                console.warn('Texture added to the cache with an id [' + id + '] that already had an entry');
	            }
	            /* eslint-enable no-console */
	            // @endif
	
	            _utils.TextureCache[id] = texture;
	        }
	    };
	
	    /**
	     * Remove a Texture from the global TextureCache.
	     *
	     * @static
	     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
	     * @return {PIXI.Texture|null} The Texture that was removed
	     */
	
	
	    Texture.removeFromCache = function removeFromCache(texture) {
	        if (typeof texture === 'string') {
	            var textureFromCache = _utils.TextureCache[texture];
	
	            if (textureFromCache) {
	                var index = textureFromCache.textureCacheIds.indexOf(texture);
	
	                if (index > -1) {
	                    textureFromCache.textureCacheIds.splice(index, 1);
	                }
	
	                delete _utils.TextureCache[texture];
	
	                return textureFromCache;
	            }
	        } else if (texture && texture.textureCacheIds) {
	            for (var i = 0; i < texture.textureCacheIds.length; ++i) {
	                // Check that texture matches the one being passed in before deleting it from the cache.
	                if (_utils.TextureCache[texture.textureCacheIds[i]] === texture) {
	                    delete _utils.TextureCache[texture.textureCacheIds[i]];
	                }
	            }
	
	            texture.textureCacheIds.length = 0;
	
	            return texture;
	        }
	
	        return null;
	    };
	
	    /**
	     * The frame specifies the region of the base texture that this texture uses.
	     * Please call `_updateUvs()` after you change coordinates of `frame` manually.
	     *
	     * @member {PIXI.Rectangle}
	     */
	
	
	    _createClass(Texture, [{
	        key: 'frame',
	        get: function get() {
	            return this._frame;
	        },
	        set: function set(frame) // eslint-disable-line require-jsdoc
	        {
	            this._frame = frame;
	
	            this.noFrame = false;
	
	            var x = frame.x,
	                y = frame.y,
	                width = frame.width,
	                height = frame.height;
	
	            var xNotFit = x + width > this.baseTexture.width;
	            var yNotFit = y + height > this.baseTexture.height;
	
	            if (xNotFit || yNotFit) {
	                var relationship = xNotFit && yNotFit ? 'and' : 'or';
	                var errorX = 'X: ' + x + ' + ' + width + ' = ' + (x + width) + ' > ' + this.baseTexture.width;
	                var errorY = 'Y: ' + y + ' + ' + height + ' = ' + (y + height) + ' > ' + this.baseTexture.height;
	
	                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + (errorX + ' ' + relationship + ' ' + errorY));
	            }
	
	            // this.valid = width && height && this.baseTexture.source && this.baseTexture.hasLoaded;
	            this.valid = width && height && this.baseTexture.hasLoaded;
	
	            if (!this.trim && !this.rotate) {
	                this.orig = frame;
	            }
	
	            if (this.valid) {
	                this._updateUvs();
	            }
	        }
	
	        /**
	         * Indicates whether the texture is rotated inside the atlas
	         * set to 2 to compensate for texture packer rotation
	         * set to 6 to compensate for spine packer rotation
	         * can be used to rotate or mirror sprites
	         * See {@link PIXI.GroupD8} for explanation
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'rotate',
	        get: function get() {
	            return this._rotate;
	        },
	        set: function set(rotate) // eslint-disable-line require-jsdoc
	        {
	            this._rotate = rotate;
	            if (this.valid) {
	                this._updateUvs();
	            }
	        }
	
	        /**
	         * The width of the Texture in pixels.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'width',
	        get: function get() {
	            return this.orig.width;
	        }
	
	        /**
	         * The height of the Texture in pixels.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this.orig.height;
	        }
	    }]);
	
	    return Texture;
	}(_eventemitter2.default);
	
	exports.default = Texture;
	
	
	function createWhiteTexture() {
	    var canvas = document.createElement('canvas');
	
	    canvas.width = 10;
	    canvas.height = 10;
	
	    var context = canvas.getContext('2d');
	
	    context.fillStyle = 'white';
	    context.fillRect(0, 0, 10, 10);
	
	    return new Texture(new _BaseTexture2.default(canvas));
	}
	
	function removeAllHandlers(tex) {
	    tex.destroy = function _emptyDestroy() {/* empty */};
	    tex.on = function _emptyOn() {/* empty */};
	    tex.once = function _emptyOnce() {/* empty */};
	    tex.emit = function _emptyEmit() {/* empty */};
	}
	
	/**
	 * An empty texture, used often to not have to create multiple empty textures.
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 */
	Texture.EMPTY = new Texture(new _BaseTexture2.default());
	removeAllHandlers(Texture.EMPTY);
	removeAllHandlers(Texture.EMPTY.baseTexture);
	
	/**
	 * A white texture of 10x10 size, used for graphics and other things
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 */
	Texture.WHITE = createWhiteTexture();
	removeAllHandlers(Texture.WHITE);
	removeAllHandlers(Texture.WHITE.baseTexture);
	//# sourceMappingURL=Texture.js.map

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(5);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _eventemitter = __webpack_require__(19);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _determineCrossOrigin = __webpack_require__(121);
	
	var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);
	
	var _bitTwiddle = __webpack_require__(50);
	
	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A texture stores the information that represents an image. All textures have a base texture.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var BaseTexture = function (_EventEmitter) {
	    _inherits(BaseTexture, _EventEmitter);
	
	    /**
	     * @param {HTMLImageElement|HTMLCanvasElement} [source] - the source object of the texture.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture
	     */
	    function BaseTexture(source, scaleMode, resolution) {
	        _classCallCheck(this, BaseTexture);
	
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        _this.uid = (0, _utils.uid)();
	
	        _this.touched = 0;
	
	        /**
	         * The resolution / device pixel ratio of the texture
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = resolution || _settings2.default.RESOLUTION;
	
	        /**
	         * The width of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.width = 100;
	
	        /**
	         * The height of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.height = 100;
	
	        // TODO docs
	        // used to store the actual dimensions of the source
	        /**
	         * Used to store the actual width of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.realWidth = 100;
	        /**
	         * Used to store the actual height of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.realHeight = 100;
	
	        /**
	         * The scale mode to apply when scaling this texture
	         *
	         * @member {number}
	         * @default PIXI.settings.SCALE_MODE
	         * @see PIXI.SCALE_MODES
	         */
	        _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
	
	        /**
	         * Set to true once the base texture has successfully loaded.
	         *
	         * This is never true if the underlying source fails to load or has no texture data.
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.hasLoaded = false;
	
	        /**
	         * Set to true if the source is currently loading.
	         *
	         * If an Image source is loading the 'loaded' or 'error' event will be
	         * dispatched when the operation ends. An underyling source that is
	         * immediately-available bypasses loading entirely.
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.isLoading = false;
	
	        /**
	         * The image source that is used to create the texture.
	         *
	         * TODO: Make this a setter that calls loadSource();
	         *
	         * @readonly
	         * @member {HTMLImageElement|HTMLCanvasElement}
	         */
	        _this.source = null; // set in loadSource, if at all
	
	        /**
	         * The image source that is used to create the texture. This is used to
	         * store the original Svg source when it is replaced with a canvas element.
	         *
	         * TODO: Currently not in use but could be used when re-scaling svg.
	         *
	         * @readonly
	         * @member {Image}
	         */
	        _this.origSource = null; // set in loadSvg, if at all
	
	        /**
	         * Type of image defined in source, eg. `png` or `svg`
	         *
	         * @readonly
	         * @member {string}
	         */
	        _this.imageType = null; // set in updateImageType
	
	        /**
	         * Scale for source image. Used with Svg images to scale them before rasterization.
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.sourceScale = 1.0;
	
	        /**
	         * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
	         * All blend modes, and shaders written for default value. Change it on your own risk.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.premultipliedAlpha = true;
	
	        /**
	         * The image url of the texture
	         *
	         * @member {string}
	         */
	        _this.imageUrl = null;
	
	        /**
	         * Whether or not the texture is a power of two, try to use power of two textures as much
	         * as you can
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.isPowerOfTwo = false;
	
	        // used for webGL
	
	        /**
	         *
	         * Set this to true if a mipmap of this texture needs to be generated. This value needs
	         * to be set before the texture is used
	         * Also the texture must be a power of two size to work
	         *
	         * @member {boolean}
	         * @see PIXI.MIPMAP_TEXTURES
	         */
	        _this.mipmap = _settings2.default.MIPMAP_TEXTURES;
	
	        /**
	         *
	         * WebGL Texture wrap mode
	         *
	         * @member {number}
	         * @see PIXI.WRAP_MODES
	         */
	        _this.wrapMode = _settings2.default.WRAP_MODE;
	
	        /**
	         * A map of renderer IDs to webgl textures
	         *
	         * @private
	         * @member {object<number, WebGLTexture>}
	         */
	        _this._glTextures = {};
	
	        _this._enabled = 0;
	        _this._virtalBoundId = -1;
	
	        /**
	         * If the object has been destroyed via destroy(). If true, it should not be used.
	         *
	         * @member {boolean}
	         * @private
	         * @readonly
	         */
	        _this._destroyed = false;
	
	        /**
	         * The ids under which this BaseTexture has been added to the base texture cache. This is
	         * automatically set as long as BaseTexture.addToCache is used, but may not be set if a
	         * BaseTexture is added directly to the BaseTextureCache array.
	         *
	         * @member {string[]}
	         */
	        _this.textureCacheIds = [];
	
	        // if no source passed don't try to load
	        if (source) {
	            _this.loadSource(source);
	        }
	
	        /**
	         * Fired when a not-immediately-available source finishes loading.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#loaded
	         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
	         */
	
	        /**
	         * Fired when a not-immediately-available source fails to load.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#error
	         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
	         */
	
	        /**
	         * Fired when BaseTexture is updated.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#update
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
	         */
	
	        /**
	         * Fired when BaseTexture is destroyed.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#dispose
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
	         */
	        return _this;
	    }
	
	    /**
	     * Updates the texture on all the webgl renderers, this also assumes the src has changed.
	     *
	     * @fires PIXI.BaseTexture#update
	     */
	
	
	    BaseTexture.prototype.update = function update() {
	        // Svg size is handled during load
	        if (this.imageType !== 'svg') {
	            this.realWidth = this.source.naturalWidth || this.source.videoWidth || this.source.width;
	            this.realHeight = this.source.naturalHeight || this.source.videoHeight || this.source.height;
	
	            this._updateDimensions();
	        }
	
	        this.emit('update', this);
	    };
	
	    /**
	     * Update dimensions from real values
	     */
	
	
	    BaseTexture.prototype._updateDimensions = function _updateDimensions() {
	        this.width = this.realWidth / this.resolution;
	        this.height = this.realHeight / this.resolution;
	
	        this.isPowerOfTwo = _bitTwiddle2.default.isPow2(this.realWidth) && _bitTwiddle2.default.isPow2(this.realHeight);
	    };
	
	    /**
	     * Load a source.
	     *
	     * If the source is not-immediately-available, such as an image that needs to be
	     * downloaded, then the 'loaded' or 'error' event will be dispatched in the future
	     * and `hasLoaded` will remain false after this call.
	     *
	     * The logic state after calling `loadSource` directly or indirectly (eg. `fromImage`, `new BaseTexture`) is:
	     *
	     *     if (texture.hasLoaded) {
	     *        // texture ready for use
	     *     } else if (texture.isLoading) {
	     *        // listen to 'loaded' and/or 'error' events on texture
	     *     } else {
	     *        // not loading, not going to load UNLESS the source is reloaded
	     *        // (it may still make sense to listen to the events)
	     *     }
	     *
	     * @protected
	     * @param {HTMLImageElement|HTMLCanvasElement} source - the source object of the texture.
	     */
	
	
	    BaseTexture.prototype.loadSource = function loadSource(source) {
	        var wasLoading = this.isLoading;
	
	        this.hasLoaded = false;
	        this.isLoading = false;
	
	        if (wasLoading && this.source) {
	            this.source.onload = null;
	            this.source.onerror = null;
	        }
	
	        var firstSourceLoaded = !this.source;
	
	        this.source = source;
	
	        // Apply source if loaded. Otherwise setup appropriate loading monitors.
	        if ((source.src && source.complete || source.getContext) && source.width && source.height) {
	            this._updateImageType();
	
	            if (this.imageType === 'svg') {
	                this._loadSvgSource();
	            } else {
	                this._sourceLoaded();
	            }
	
	            if (firstSourceLoaded) {
	                // send loaded event if previous source was null and we have been passed a pre-loaded IMG element
	                this.emit('loaded', this);
	            }
	        } else if (!source.getContext) {
	            // Image fail / not ready
	            this.isLoading = true;
	
	            var scope = this;
	
	            source.onload = function () {
	                scope._updateImageType();
	                source.onload = null;
	                source.onerror = null;
	
	                if (!scope.isLoading) {
	                    return;
	                }
	
	                scope.isLoading = false;
	                scope._sourceLoaded();
	
	                if (scope.imageType === 'svg') {
	                    scope._loadSvgSource();
	
	                    return;
	                }
	
	                scope.emit('loaded', scope);
	            };
	
	            source.onerror = function () {
	                source.onload = null;
	                source.onerror = null;
	
	                if (!scope.isLoading) {
	                    return;
	                }
	
	                scope.isLoading = false;
	                scope.emit('error', scope);
	            };
	
	            // Per http://www.w3.org/TR/html5/embedded-content-0.html#the-img-element
	            //   "The value of `complete` can thus change while a script is executing."
	            // So complete needs to be re-checked after the callbacks have been added..
	            // NOTE: complete will be true if the image has no src so best to check if the src is set.
	            if (source.complete && source.src) {
	                // ..and if we're complete now, no need for callbacks
	                source.onload = null;
	                source.onerror = null;
	
	                if (scope.imageType === 'svg') {
	                    scope._loadSvgSource();
	
	                    return;
	                }
	
	                this.isLoading = false;
	
	                if (source.width && source.height) {
	                    this._sourceLoaded();
	
	                    // If any previous subscribers possible
	                    if (wasLoading) {
	                        this.emit('loaded', this);
	                    }
	                }
	                // If any previous subscribers possible
	                else if (wasLoading) {
	                        this.emit('error', this);
	                    }
	            }
	        }
	    };
	
	    /**
	     * Updates type of the source image.
	     */
	
	
	    BaseTexture.prototype._updateImageType = function _updateImageType() {
	        if (!this.imageUrl) {
	            return;
	        }
	
	        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
	        var imageType = void 0;
	
	        if (dataUri && dataUri.mediaType === 'image') {
	            // Check for subType validity
	            var firstSubType = dataUri.subType.split('+')[0];
	
	            imageType = (0, _utils.getUrlFileExtension)('.' + firstSubType);
	
	            if (!imageType) {
	                throw new Error('Invalid image type in data URI.');
	            }
	        } else {
	            imageType = (0, _utils.getUrlFileExtension)(this.imageUrl);
	
	            if (!imageType) {
	                imageType = 'png';
	            }
	        }
	
	        this.imageType = imageType;
	    };
	
	    /**
	     * Checks if `source` is an SVG image and whether it's loaded via a URL or a data URI. Then calls
	     * `_loadSvgSourceUsingDataUri` or `_loadSvgSourceUsingXhr`.
	     */
	
	
	    BaseTexture.prototype._loadSvgSource = function _loadSvgSource() {
	        if (this.imageType !== 'svg') {
	            // Do nothing if source is not svg
	            return;
	        }
	
	        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
	
	        if (dataUri) {
	            this._loadSvgSourceUsingDataUri(dataUri);
	        } else {
	            // We got an URL, so we need to do an XHR to check the svg size
	            this._loadSvgSourceUsingXhr();
	        }
	    };
	
	    /**
	     * Reads an SVG string from data URI and then calls `_loadSvgSourceUsingString`.
	     *
	     * @param {string} dataUri - The data uri to load from.
	     */
	
	
	    BaseTexture.prototype._loadSvgSourceUsingDataUri = function _loadSvgSourceUsingDataUri(dataUri) {
	        var svgString = void 0;
	
	        if (dataUri.encoding === 'base64') {
	            if (!atob) {
	                throw new Error('Your browser doesn\'t support base64 conversions.');
	            }
	            svgString = atob(dataUri.data);
	        } else {
	            svgString = dataUri.data;
	        }
	
	        this._loadSvgSourceUsingString(svgString);
	    };
	
	    /**
	     * Loads an SVG string from `imageUrl` using XHR and then calls `_loadSvgSourceUsingString`.
	     */
	
	
	    BaseTexture.prototype._loadSvgSourceUsingXhr = function _loadSvgSourceUsingXhr() {
	        var _this2 = this;
	
	        var svgXhr = new XMLHttpRequest();
	
	        // This throws error on IE, so SVG Document can't be used
	        // svgXhr.responseType = 'document';
	
	        // This is not needed since we load the svg as string (breaks IE too)
	        // but overrideMimeType() can be used to force the response to be parsed as XML
	        // svgXhr.overrideMimeType('image/svg+xml');
	
	        svgXhr.onload = function () {
	            if (svgXhr.readyState !== svgXhr.DONE || svgXhr.status !== 200) {
	                throw new Error('Failed to load SVG using XHR.');
	            }
	
	            _this2._loadSvgSourceUsingString(svgXhr.response);
	        };
	
	        svgXhr.onerror = function () {
	            return _this2.emit('error', _this2);
	        };
	
	        svgXhr.open('GET', this.imageUrl, true);
	        svgXhr.send();
	    };
	
	    /**
	     * Loads texture using an SVG string. The original SVG Image is stored as `origSource` and the
	     * created canvas is the new `source`. The SVG is scaled using `sourceScale`. Called by
	     * `_loadSvgSourceUsingXhr` or `_loadSvgSourceUsingDataUri`.
	     *
	     * @param  {string} svgString SVG source as string
	     *
	     * @fires PIXI.BaseTexture#loaded
	     */
	
	
	    BaseTexture.prototype._loadSvgSourceUsingString = function _loadSvgSourceUsingString(svgString) {
	        var svgSize = (0, _utils.getSvgSize)(svgString);
	
	        var svgWidth = svgSize.width;
	        var svgHeight = svgSize.height;
	
	        if (!svgWidth || !svgHeight) {
	            throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
	        }
	
	        // Scale realWidth and realHeight
	        this.realWidth = Math.round(svgWidth * this.sourceScale);
	        this.realHeight = Math.round(svgHeight * this.sourceScale);
	
	        this._updateDimensions();
	
	        // Create a canvas element
	        var canvas = document.createElement('canvas');
	
	        canvas.width = this.realWidth;
	        canvas.height = this.realHeight;
	        canvas._pixiId = 'canvas_' + (0, _utils.uid)();
	
	        // Draw the Svg to the canvas
	        canvas.getContext('2d').drawImage(this.source, 0, 0, svgWidth, svgHeight, 0, 0, this.realWidth, this.realHeight);
	
	        // Replace the original source image with the canvas
	        this.origSource = this.source;
	        this.source = canvas;
	
	        // Add also the canvas in cache (destroy clears by `imageUrl` and `source._pixiId`)
	        BaseTexture.addToCache(this, canvas._pixiId);
	
	        this.isLoading = false;
	        this._sourceLoaded();
	        this.emit('loaded', this);
	    };
	
	    /**
	     * Used internally to update the width, height, and some other tracking vars once
	     * a source has successfully loaded.
	     *
	     * @private
	     */
	
	
	    BaseTexture.prototype._sourceLoaded = function _sourceLoaded() {
	        this.hasLoaded = true;
	        this.update();
	    };
	
	    /**
	     * Destroys this base texture
	     *
	     */
	
	
	    BaseTexture.prototype.destroy = function destroy() {
	        if (this.imageUrl) {
	            delete _utils.TextureCache[this.imageUrl];
	
	            this.imageUrl = null;
	
	            if (!navigator.isCocoonJS) {
	                this.source.src = '';
	            }
	        }
	
	        this.source = null;
	
	        this.dispose();
	
	        BaseTexture.removeFromCache(this);
	        this.textureCacheIds = null;
	
	        this._destroyed = true;
	    };
	
	    /**
	     * Frees the texture from WebGL memory without destroying this texture object.
	     * This means you can still use the texture later which will upload it to GPU
	     * memory again.
	     *
	     * @fires PIXI.BaseTexture#dispose
	     */
	
	
	    BaseTexture.prototype.dispose = function dispose() {
	        this.emit('dispose', this);
	    };
	
	    /**
	     * Changes the source image of the texture.
	     * The original source must be an Image element.
	     *
	     * @param {string} newSrc - the path of the image
	     */
	
	
	    BaseTexture.prototype.updateSourceImage = function updateSourceImage(newSrc) {
	        this.source.src = newSrc;
	
	        this.loadSource(this.source);
	    };
	
	    /**
	     * Helper function that creates a base texture from the given image url.
	     * If the image is not in the base texture cache it will be created and loaded.
	     *
	     * @static
	     * @param {string} imageUrl - The image url of the texture
	     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
	     * @return {PIXI.BaseTexture} The new base texture.
	     */
	
	
	    BaseTexture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
	        var baseTexture = _utils.BaseTextureCache[imageUrl];
	
	        if (!baseTexture) {
	            // new Image() breaks tex loading in some versions of Chrome.
	            // See https://code.google.com/p/chromium/issues/detail?id=238071
	            var image = new Image(); // document.createElement('img');
	
	            if (crossorigin === undefined && imageUrl.indexOf('data:') !== 0) {
	                image.crossOrigin = (0, _determineCrossOrigin2.default)(imageUrl);
	            } else if (crossorigin) {
	                image.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
	            }
	
	            baseTexture = new BaseTexture(image, scaleMode);
	            baseTexture.imageUrl = imageUrl;
	
	            if (sourceScale) {
	                baseTexture.sourceScale = sourceScale;
	            }
	
	            // if there is an @2x at the end of the url we are going to assume its a highres image
	            baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);
	
	            image.src = imageUrl; // Setting this triggers load
	
	            BaseTexture.addToCache(baseTexture, imageUrl);
	        }
	
	        return baseTexture;
	    };
	
	    /**
	     * Helper function that creates a base texture from the given canvas element.
	     *
	     * @static
	     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
	     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {string} [origin='canvas'] - A string origin of who created the base texture
	     * @return {PIXI.BaseTexture} The new base texture.
	     */
	
	
	    BaseTexture.fromCanvas = function fromCanvas(canvas, scaleMode) {
	        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';
	
	        if (!canvas._pixiId) {
	            canvas._pixiId = origin + '_' + (0, _utils.uid)();
	        }
	
	        var baseTexture = _utils.BaseTextureCache[canvas._pixiId];
	
	        if (!baseTexture) {
	            baseTexture = new BaseTexture(canvas, scaleMode);
	            BaseTexture.addToCache(baseTexture, canvas._pixiId);
	        }
	
	        return baseTexture;
	    };
	
	    /**
	     * Helper function that creates a base texture based on the source you provide.
	     * The source can be - image url, image element, canvas element. If the
	     * source is an image url or an image element and not in the base texture
	     * cache, it will be created and loaded.
	     *
	     * @static
	     * @param {string|HTMLImageElement|HTMLCanvasElement} source - The source to create base texture from.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
	     * @return {PIXI.BaseTexture} The new base texture.
	     */
	
	
	    BaseTexture.from = function from(source, scaleMode, sourceScale) {
	        if (typeof source === 'string') {
	            return BaseTexture.fromImage(source, undefined, scaleMode, sourceScale);
	        } else if (source instanceof HTMLImageElement) {
	            var imageUrl = source.src;
	            var baseTexture = _utils.BaseTextureCache[imageUrl];
	
	            if (!baseTexture) {
	                baseTexture = new BaseTexture(source, scaleMode);
	                baseTexture.imageUrl = imageUrl;
	
	                if (sourceScale) {
	                    baseTexture.sourceScale = sourceScale;
	                }
	
	                // if there is an @2x at the end of the url we are going to assume its a highres image
	                baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);
	
	                BaseTexture.addToCache(baseTexture, imageUrl);
	            }
	
	            return baseTexture;
	        } else if (source instanceof HTMLCanvasElement) {
	            return BaseTexture.fromCanvas(source, scaleMode);
	        }
	
	        // lets assume its a base texture!
	        return source;
	    };
	
	    /**
	     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
	     * @param {string} id - The id that the BaseTexture will be stored against.
	     */
	
	
	    BaseTexture.addToCache = function addToCache(baseTexture, id) {
	        if (id) {
	            if (baseTexture.textureCacheIds.indexOf(id) === -1) {
	                baseTexture.textureCacheIds.push(id);
	            }
	
	            // @if DEBUG
	            /* eslint-disable no-console */
	            if (_utils.BaseTextureCache[id]) {
	                console.warn('BaseTexture added to the cache with an id [' + id + '] that already had an entry');
	            }
	            /* eslint-enable no-console */
	            // @endif
	
	            _utils.BaseTextureCache[id] = baseTexture;
	        }
	    };
	
	    /**
	     * Remove a BaseTexture from the global BaseTextureCache.
	     *
	     * @static
	     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
	     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
	     */
	
	
	    BaseTexture.removeFromCache = function removeFromCache(baseTexture) {
	        if (typeof baseTexture === 'string') {
	            var baseTextureFromCache = _utils.BaseTextureCache[baseTexture];
	
	            if (baseTextureFromCache) {
	                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
	
	                if (index > -1) {
	                    baseTextureFromCache.textureCacheIds.splice(index, 1);
	                }
	
	                delete _utils.BaseTextureCache[baseTexture];
	
	                return baseTextureFromCache;
	            }
	        } else if (baseTexture && baseTexture.textureCacheIds) {
	            for (var i = 0; i < baseTexture.textureCacheIds.length; ++i) {
	                delete _utils.BaseTextureCache[baseTexture.textureCacheIds[i]];
	            }
	
	            baseTexture.textureCacheIds.length = 0;
	
	            return baseTexture;
	        }
	
	        return null;
	    };
	
	    return BaseTexture;
	}(_eventemitter2.default);
	
	exports.default = BaseTexture;
	//# sourceMappingURL=BaseTexture.js.map

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function checkPrecision(src, def) {
	    if (src instanceof Array) {
	        if (src[0].substring(0, 9) !== 'precision') {
	            var copy = src.slice(0);
	
	            copy.unshift('precision ' + def + ' float;');
	
	            return copy;
	        }
	    } else if (src.trim().substring(0, 9) !== 'precision') {
	        return 'precision ' + def + ' float;\n' + src;
	    }
	
	    return src;
	}
	
	/**
	 * Wrapper class, webGL Shader for Pixi.
	 * Adds precision string if vertexSrc or fragmentSrc have no mention of it.
	 *
	 * @class
	 * @extends GLShader
	 * @memberof PIXI
	 */
	
	var Shader = function (_GLShader) {
	    _inherits(Shader, _GLShader);
	
	    /**
	     *
	     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
	     * @param {string|string[]} vertexSrc - The vertex shader source as an array of strings.
	     * @param {string|string[]} fragmentSrc - The fragment shader source as an array of strings.
	     * @param {object} [attributeLocations] - A key value pair showing which location eact attribute should sit.
	                       e.g. {position:0, uvs:1}.
	     * @param {string} [precision] - The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	     */
	    function Shader(gl, vertexSrc, fragmentSrc, attributeLocations, precision) {
	        _classCallCheck(this, Shader);
	
	        return _possibleConstructorReturn(this, _GLShader.call(this, gl, checkPrecision(vertexSrc, precision || _settings2.default.PRECISION_VERTEX), checkPrecision(fragmentSrc, precision || _settings2.default.PRECISION_FRAGMENT), undefined, attributeLocations));
	    }
	
	    return Shader;
	}(_pixiGlCore.GLShader);
	
	exports.default = Shader;
	//# sourceMappingURL=Shader.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(5);
	
	var _DisplayObject2 = __webpack_require__(103);
	
	var _DisplayObject3 = _interopRequireDefault(_DisplayObject2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A Container represents a collection of display objects.
	 * It is the base class of all display objects that act as a container for other objects.
	 *
	 *```js
	 * let container = new PIXI.Container();
	 * container.addChild(sprite);
	 * ```
	 *
	 * @class
	 * @extends PIXI.DisplayObject
	 * @memberof PIXI
	 */
	var Container = function (_DisplayObject) {
	    _inherits(Container, _DisplayObject);
	
	    /**
	     *
	     */
	    function Container() {
	        _classCallCheck(this, Container);
	
	        /**
	         * The array of children of this container.
	         *
	         * @member {PIXI.DisplayObject[]}
	         * @readonly
	         */
	        var _this = _possibleConstructorReturn(this, _DisplayObject.call(this));
	
	        _this.children = [];
	        return _this;
	    }
	
	    /**
	     * Overridable method that can be used by Container subclasses whenever the children array is modified
	     *
	     * @private
	     */
	
	
	    Container.prototype.onChildrenChange = function onChildrenChange() {}
	    /* empty */
	
	
	    /**
	     * Adds one or more children to the container.
	     *
	     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
	     *
	     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to add to the container
	     * @return {PIXI.DisplayObject} The first child that was added.
	     */
	    ;
	
	    Container.prototype.addChild = function addChild(child) {
	        var argumentsLength = arguments.length;
	
	        // if there is only one argument we can bypass looping through the them
	        if (argumentsLength > 1) {
	            // loop through the arguments property and add all children
	            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	            for (var i = 0; i < argumentsLength; i++) {
	                this.addChild(arguments[i]);
	            }
	        } else {
	            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
	            if (child.parent) {
	                child.parent.removeChild(child);
	            }
	
	            child.parent = this;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;
	
	            this.children.push(child);
	
	            // ensure bounds will be recalculated
	            this._boundsID++;
	
	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(this.children.length - 1);
	            child.emit('added', this);
	        }
	
	        return child;
	    };
	
	    /**
	     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
	     *
	     * @param {PIXI.DisplayObject} child - The child to add
	     * @param {number} index - The index to place the child in
	     * @return {PIXI.DisplayObject} The child that was added.
	     */
	
	
	    Container.prototype.addChildAt = function addChildAt(child, index) {
	        if (index < 0 || index > this.children.length) {
	            throw new Error(child + 'addChildAt: The index ' + index + ' supplied is out of bounds ' + this.children.length);
	        }
	
	        if (child.parent) {
	            child.parent.removeChild(child);
	        }
	
	        child.parent = this;
	        // ensure child transform will be recalculated
	        child.transform._parentID = -1;
	
	        this.children.splice(index, 0, child);
	
	        // ensure bounds will be recalculated
	        this._boundsID++;
	
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('added', this);
	
	        return child;
	    };
	
	    /**
	     * Swaps the position of 2 Display Objects within this container.
	     *
	     * @param {PIXI.DisplayObject} child - First display object to swap
	     * @param {PIXI.DisplayObject} child2 - Second display object to swap
	     */
	
	
	    Container.prototype.swapChildren = function swapChildren(child, child2) {
	        if (child === child2) {
	            return;
	        }
	
	        var index1 = this.getChildIndex(child);
	        var index2 = this.getChildIndex(child2);
	
	        this.children[index1] = child2;
	        this.children[index2] = child;
	        this.onChildrenChange(index1 < index2 ? index1 : index2);
	    };
	
	    /**
	     * Returns the index position of a child DisplayObject instance
	     *
	     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
	     * @return {number} The index position of the child display object to identify
	     */
	
	
	    Container.prototype.getChildIndex = function getChildIndex(child) {
	        var index = this.children.indexOf(child);
	
	        if (index === -1) {
	            throw new Error('The supplied DisplayObject must be a child of the caller');
	        }
	
	        return index;
	    };
	
	    /**
	     * Changes the position of an existing child in the display object container
	     *
	     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
	     * @param {number} index - The resulting index number for the child display object
	     */
	
	
	    Container.prototype.setChildIndex = function setChildIndex(child, index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('The index ' + index + ' supplied is out of bounds ' + this.children.length);
	        }
	
	        var currentIndex = this.getChildIndex(child);
	
	        (0, _utils.removeItems)(this.children, currentIndex, 1); // remove from old position
	        this.children.splice(index, 0, child); // add at new position
	
	        this.onChildrenChange(index);
	    };
	
	    /**
	     * Returns the child at the specified index
	     *
	     * @param {number} index - The index to get the child at
	     * @return {PIXI.DisplayObject} The child at the given index, if any.
	     */
	
	
	    Container.prototype.getChildAt = function getChildAt(index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('getChildAt: Index (' + index + ') does not exist.');
	        }
	
	        return this.children[index];
	    };
	
	    /**
	     * Removes one or more children from the container.
	     *
	     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to remove
	     * @return {PIXI.DisplayObject} The first child that was removed.
	     */
	
	
	    Container.prototype.removeChild = function removeChild(child) {
	        var argumentsLength = arguments.length;
	
	        // if there is only one argument we can bypass looping through the them
	        if (argumentsLength > 1) {
	            // loop through the arguments property and add all children
	            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	            for (var i = 0; i < argumentsLength; i++) {
	                this.removeChild(arguments[i]);
	            }
	        } else {
	            var index = this.children.indexOf(child);
	
	            if (index === -1) return null;
	
	            child.parent = null;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;
	            (0, _utils.removeItems)(this.children, index, 1);
	
	            // ensure bounds will be recalculated
	            this._boundsID++;
	
	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(index);
	            child.emit('removed', this);
	        }
	
	        return child;
	    };
	
	    /**
	     * Removes a child from the specified index position.
	     *
	     * @param {number} index - The index to get the child from
	     * @return {PIXI.DisplayObject} The child that was removed.
	     */
	
	
	    Container.prototype.removeChildAt = function removeChildAt(index) {
	        var child = this.getChildAt(index);
	
	        // ensure child transform will be recalculated..
	        child.parent = null;
	        child.transform._parentID = -1;
	        (0, _utils.removeItems)(this.children, index, 1);
	
	        // ensure bounds will be recalculated
	        this._boundsID++;
	
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('removed', this);
	
	        return child;
	    };
	
	    /**
	     * Removes all children from this container that are within the begin and end indexes.
	     *
	     * @param {number} [beginIndex=0] - The beginning position.
	     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
	     * @returns {DisplayObject[]} List of removed children
	     */
	
	
	    Container.prototype.removeChildren = function removeChildren() {
	        var beginIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var endIndex = arguments[1];
	
	        var begin = beginIndex;
	        var end = typeof endIndex === 'number' ? endIndex : this.children.length;
	        var range = end - begin;
	        var removed = void 0;
	
	        if (range > 0 && range <= end) {
	            removed = this.children.splice(begin, range);
	
	            for (var i = 0; i < removed.length; ++i) {
	                removed[i].parent = null;
	                if (removed[i].transform) {
	                    removed[i].transform._parentID = -1;
	                }
	            }
	
	            this._boundsID++;
	
	            this.onChildrenChange(beginIndex);
	
	            for (var _i = 0; _i < removed.length; ++_i) {
	                removed[_i].emit('removed', this);
	            }
	
	            return removed;
	        } else if (range === 0 && this.children.length === 0) {
	            return [];
	        }
	
	        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
	    };
	
	    /**
	     * Updates the transform on all children of this container for rendering
	     */
	
	
	    Container.prototype.updateTransform = function updateTransform() {
	        this._boundsID++;
	
	        this.transform.updateTransform(this.parent.transform);
	
	        // TODO: check render flags, how to process stuff here
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;
	
	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            var child = this.children[i];
	
	            if (child.visible) {
	                child.updateTransform();
	            }
	        }
	    };
	
	    /**
	     * Recalculates the bounds of the container.
	     *
	     */
	
	
	    Container.prototype.calculateBounds = function calculateBounds() {
	        this._bounds.clear();
	
	        this._calculateBounds();
	
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	
	            if (!child.visible || !child.renderable) {
	                continue;
	            }
	
	            child.calculateBounds();
	
	            // TODO: filter+mask, need to mask both somehow
	            if (child._mask) {
	                child._mask.calculateBounds();
	                this._bounds.addBoundsMask(child._bounds, child._mask._bounds);
	            } else if (child.filterArea) {
	                this._bounds.addBoundsArea(child._bounds, child.filterArea);
	            } else {
	                this._bounds.addBounds(child._bounds);
	            }
	        }
	
	        this._lastBoundsID = this._boundsID;
	    };
	
	    /**
	     * Recalculates the bounds of the object. Override this to
	     * calculate the bounds of the specific object (not including children).
	     *
	     */
	
	
	    Container.prototype._calculateBounds = function _calculateBounds() {}
	    // FILL IN//
	
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	    ;
	
	    Container.prototype.renderWebGL = function renderWebGL(renderer) {
	        // if the object is not visible or the alpha is 0 then no need to render this element
	        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	            return;
	        }
	
	        // do a quick check to see if this element has a mask or a filter.
	        if (this._mask || this._filters) {
	            this.renderAdvancedWebGL(renderer);
	        } else {
	            this._renderWebGL(renderer);
	
	            // simple render children!
	            for (var i = 0, j = this.children.length; i < j; ++i) {
	                this.children[i].renderWebGL(renderer);
	            }
	        }
	    };
	
	    /**
	     * Render the object using the WebGL renderer and advanced features.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Container.prototype.renderAdvancedWebGL = function renderAdvancedWebGL(renderer) {
	        renderer.flush();
	
	        var filters = this._filters;
	        var mask = this._mask;
	
	        // push filter first as we need to ensure the stencil buffer is correct for any masking
	        if (filters) {
	            if (!this._enabledFilters) {
	                this._enabledFilters = [];
	            }
	
	            this._enabledFilters.length = 0;
	
	            for (var i = 0; i < filters.length; i++) {
	                if (filters[i].enabled) {
	                    this._enabledFilters.push(filters[i]);
	                }
	            }
	
	            if (this._enabledFilters.length) {
	                renderer.filterManager.pushFilter(this, this._enabledFilters);
	            }
	        }
	
	        if (mask) {
	            renderer.maskManager.pushMask(this, this._mask);
	        }
	
	        // add this object to the batch, only rendered if it has a texture.
	        this._renderWebGL(renderer);
	
	        // now loop through the children and make sure they get rendered
	        for (var _i2 = 0, j = this.children.length; _i2 < j; _i2++) {
	            this.children[_i2].renderWebGL(renderer);
	        }
	
	        renderer.flush();
	
	        if (mask) {
	            renderer.maskManager.popMask(this, this._mask);
	        }
	
	        if (filters && this._enabledFilters && this._enabledFilters.length) {
	            renderer.filterManager.popFilter();
	        }
	    };
	
	    /**
	     * To be overridden by the subclasses.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Container.prototype._renderWebGL = function _renderWebGL(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // this is where content itself gets rendered...
	
	
	    /**
	     * To be overridden by the subclass
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;
	
	    Container.prototype._renderCanvas = function _renderCanvas(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // this is where content itself gets rendered...
	
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;
	
	    Container.prototype.renderCanvas = function renderCanvas(renderer) {
	        // if not visible or the alpha is 0 then no need to render this
	        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	            return;
	        }
	
	        if (this._mask) {
	            renderer.maskManager.pushMask(this._mask);
	        }
	
	        this._renderCanvas(renderer);
	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            this.children[i].renderCanvas(renderer);
	        }
	
	        if (this._mask) {
	            renderer.maskManager.popMask(renderer);
	        }
	    };
	
	    /**
	     * Removes all internal references and listeners as well as removes children from the display list.
	     * Do not use a Container after calling `destroy`.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	
	
	    Container.prototype.destroy = function destroy(options) {
	        _DisplayObject.prototype.destroy.call(this);
	
	        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;
	
	        var oldChildren = this.removeChildren(0, this.children.length);
	
	        if (destroyChildren) {
	            for (var i = 0; i < oldChildren.length; ++i) {
	                oldChildren[i].destroy(options);
	            }
	        }
	    };
	
	    /**
	     * The width of the Container, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(Container, [{
	        key: 'width',
	        get: function get() {
	            return this.scale.x * this.getLocalBounds().width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var width = this.getLocalBounds().width;
	
	            if (width !== 0) {
	                this.scale.x = value / width;
	            } else {
	                this.scale.x = 1;
	            }
	
	            this._width = value;
	        }
	
	        /**
	         * The height of the Container, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this.scale.y * this.getLocalBounds().height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var height = this.getLocalBounds().height;
	
	            if (height !== 0) {
	                this.scale.y = value / height;
	            } else {
	                this.scale.y = 1;
	            }
	
	            this._height = value;
	        }
	    }]);
	
	    return Container;
	}(_DisplayObject3.default);
	
	// performance increase to avoid using call.. (10x faster)
	
	
	exports.default = Container;
	Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
	//# sourceMappingURL=Container.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SystemRenderer2 = __webpack_require__(109);
	
	var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);
	
	var _CanvasMaskManager = __webpack_require__(216);
	
	var _CanvasMaskManager2 = _interopRequireDefault(_CanvasMaskManager);
	
	var _CanvasRenderTarget = __webpack_require__(110);
	
	var _CanvasRenderTarget2 = _interopRequireDefault(_CanvasRenderTarget);
	
	var _mapCanvasBlendModesToPixi = __webpack_require__(217);
	
	var _mapCanvasBlendModesToPixi2 = _interopRequireDefault(_mapCanvasBlendModesToPixi);
	
	var _utils = __webpack_require__(5);
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should
	 * be used for browsers that do not support WebGL. Don't forget to add the CanvasRenderer.view to
	 * your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 */
	var CanvasRenderer = function (_SystemRenderer) {
	    _inherits(CanvasRenderer, _SystemRenderer);
	
	    // eslint-disable-next-line valid-jsdoc
	    /**
	     * @param {object} [options] - The optional renderer parameters
	     * @param {number} [options.width=800] - the width of the screen
	     * @param {number} [options.height=600] - the height of the screen
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	     *  resolution of the renderer retina would be 2.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the webgl context.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *      not before the new render pass.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	     *  stopping pixel interpolation.
	     */
	    function CanvasRenderer(options, arg2, arg3) {
	        _classCallCheck(this, CanvasRenderer);
	
	        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'Canvas', options, arg2, arg3));
	
	        _this.type = _const.RENDERER_TYPE.CANVAS;
	
	        /**
	         * The root canvas 2d context that everything is drawn with.
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.rootContext = _this.view.getContext('2d', { alpha: _this.transparent });
	
	        /**
	         * The currently active canvas 2d context (could change with renderTextures)
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.rootContext;
	
	        /**
	         * Boolean flag controlling canvas refresh.
	         *
	         * @member {boolean}
	         */
	        _this.refresh = true;
	
	        /**
	         * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
	         *
	         * @member {PIXI.CanvasMaskManager}
	         */
	        _this.maskManager = new _CanvasMaskManager2.default(_this);
	
	        /**
	         * The canvas property used to set the canvas smoothing property.
	         *
	         * @member {string}
	         */
	        _this.smoothProperty = 'imageSmoothingEnabled';
	
	        if (!_this.rootContext.imageSmoothingEnabled) {
	            if (_this.rootContext.webkitImageSmoothingEnabled) {
	                _this.smoothProperty = 'webkitImageSmoothingEnabled';
	            } else if (_this.rootContext.mozImageSmoothingEnabled) {
	                _this.smoothProperty = 'mozImageSmoothingEnabled';
	            } else if (_this.rootContext.oImageSmoothingEnabled) {
	                _this.smoothProperty = 'oImageSmoothingEnabled';
	            } else if (_this.rootContext.msImageSmoothingEnabled) {
	                _this.smoothProperty = 'msImageSmoothingEnabled';
	            }
	        }
	
	        _this.initPlugins();
	
	        _this.blendModes = (0, _mapCanvasBlendModesToPixi2.default)();
	        _this._activeBlendMode = null;
	
	        _this.renderingToScreen = false;
	
	        _this.resize(_this.options.width, _this.options.height);
	
	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.CanvasRenderer#postrender
	         */
	
	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.CanvasRenderer#prerender
	         */
	        return _this;
	    }
	
	    /**
	     * Renders the object to this canvas view
	     *
	     * @param {PIXI.DisplayObject} displayObject - The object to be rendered
	     * @param {PIXI.RenderTexture} [renderTexture] - A render texture to be rendered to.
	     *  If unset, it will render to the root context.
	     * @param {boolean} [clear=false] - Whether to clear the canvas before drawing
	     * @param {PIXI.Transform} [transform] - A transformation to be applied
	     * @param {boolean} [skipUpdateTransform=false] - Whether to skip the update transform
	     */
	
	
	    CanvasRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        if (!this.view) {
	            return;
	        }
	
	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;
	
	        this.emit('prerender');
	
	        var rootResolution = this.resolution;
	
	        if (renderTexture) {
	            renderTexture = renderTexture.baseTexture || renderTexture;
	
	            if (!renderTexture._canvasRenderTarget) {
	                renderTexture._canvasRenderTarget = new _CanvasRenderTarget2.default(renderTexture.width, renderTexture.height, renderTexture.resolution);
	                renderTexture.source = renderTexture._canvasRenderTarget.canvas;
	                renderTexture.valid = true;
	            }
	
	            this.context = renderTexture._canvasRenderTarget.context;
	            this.resolution = renderTexture._canvasRenderTarget.resolution;
	        } else {
	            this.context = this.rootContext;
	        }
	
	        var context = this.context;
	
	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }
	
	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.parent;
	            var tempWt = this._tempDisplayObjectParent.transform.worldTransform;
	
	            if (transform) {
	                transform.copy(tempWt);
	
	                // lets not forget to flag the parent transform as dirty...
	                this._tempDisplayObjectParent.transform._worldID = -1;
	            } else {
	                tempWt.identity();
	            }
	
	            displayObject.parent = this._tempDisplayObjectParent;
	
	            displayObject.updateTransform();
	            displayObject.parent = cacheParent;
	            // displayObject.hitArea = //TODO add a temp hit area
	        }
	
	        context.save();
	        context.setTransform(1, 0, 0, 1, 0, 0);
	        context.globalAlpha = 1;
	        this._activeBlendMode = _const.BLEND_MODES.NORMAL;
	        context.globalCompositeOperation = this.blendModes[_const.BLEND_MODES.NORMAL];
	
	        if (navigator.isCocoonJS && this.view.screencanvas) {
	            context.fillStyle = 'black';
	            context.clear();
	        }
	
	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            if (this.renderingToScreen) {
	                if (this.transparent) {
	                    context.clearRect(0, 0, this.width, this.height);
	                } else {
	                    context.fillStyle = this._backgroundColorString;
	                    context.fillRect(0, 0, this.width, this.height);
	                }
	            } // else {
	            // TODO: implement background for CanvasRenderTarget or RenderTexture?
	            // }
	        }
	
	        // TODO RENDER TARGET STUFF HERE..
	        var tempContext = this.context;
	
	        this.context = context;
	        displayObject.renderCanvas(this);
	        this.context = tempContext;
	
	        context.restore();
	
	        this.resolution = rootResolution;
	
	        this.emit('postrender');
	    };
	
	    /**
	     * Clear the canvas of renderer.
	     *
	     * @param {string} [clearColor] - Clear the canvas with this color, except the canvas is transparent.
	     */
	
	
	    CanvasRenderer.prototype.clear = function clear(clearColor) {
	        var context = this.context;
	
	        clearColor = clearColor || this._backgroundColorString;
	
	        if (!this.transparent && clearColor) {
	            context.fillStyle = clearColor;
	            context.fillRect(0, 0, this.width, this.height);
	        } else {
	            context.clearRect(0, 0, this.width, this.height);
	        }
	    };
	
	    /**
	     * Sets the blend mode of the renderer.
	     *
	     * @param {number} blendMode - See {@link PIXI.BLEND_MODES} for valid values.
	     */
	
	
	    CanvasRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
	        if (this._activeBlendMode === blendMode) {
	            return;
	        }
	
	        this._activeBlendMode = blendMode;
	        this.context.globalCompositeOperation = this.blendModes[blendMode];
	    };
	
	    /**
	     * Removes everything from the renderer and optionally removes the Canvas DOM element.
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     */
	
	
	    CanvasRenderer.prototype.destroy = function destroy(removeView) {
	        this.destroyPlugins();
	
	        // call the base destroy
	        _SystemRenderer.prototype.destroy.call(this, removeView);
	
	        this.context = null;
	
	        this.refresh = true;
	
	        this.maskManager.destroy();
	        this.maskManager = null;
	
	        this.smoothProperty = null;
	    };
	
	    /**
	     * Resizes the canvas view to the specified width and height.
	     *
	     * @extends PIXI.SystemRenderer#resize
	     *
	     * @param {number} screenWidth - the new width of the screen
	     * @param {number} screenHeight - the new height of the screen
	     */
	
	
	    CanvasRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	        _SystemRenderer.prototype.resize.call(this, screenWidth, screenHeight);
	
	        // reset the scale mode.. oddly this seems to be reset when the canvas is resized.
	        // surely a browser bug?? Let PixiJS fix that for you..
	        if (this.smoothProperty) {
	            this.rootContext[this.smoothProperty] = _settings2.default.SCALE_MODE === _const.SCALE_MODES.LINEAR;
	        }
	    };
	
	    /**
	     * Checks if blend mode has changed.
	     */
	
	
	    CanvasRenderer.prototype.invalidateBlendMode = function invalidateBlendMode() {
	        this._activeBlendMode = this.blendModes.indexOf(this.context.globalCompositeOperation);
	    };
	
	    return CanvasRenderer;
	}(_SystemRenderer3.default);
	
	/**
	 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
	 * by creating a custom build. Consult the README for more information about creating custom
	 * builds and excluding plugins.
	 * @name PIXI.CanvasRenderer#plugins
	 * @type {object}
	 * @readonly
	 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
	 * @property {PIXI.extract.CanvasExtract} extract Extract image data from renderer.
	 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
	 * @property {PIXI.prepare.CanvasPrepare} prepare Pre-render display objects.
	 */
	
	/**
	 * Adds a plugin to the renderer.
	 *
	 * @method PIXI.CanvasRenderer#registerPlugin
	 * @param {string} pluginName - The name of the plugin.
	 * @param {Function} ctor - The constructor function or class for the plugin.
	 */
	
	exports.default = CanvasRenderer;
	_utils.pluginTarget.mixin(CanvasRenderer);
	//# sourceMappingURL=CanvasRenderer.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var WebGLManager = function () {
	  /**
	   * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	   */
	  function WebGLManager(renderer) {
	    _classCallCheck(this, WebGLManager);
	
	    /**
	     * The renderer this manager works for.
	     *
	     * @member {PIXI.WebGLRenderer}
	     */
	    this.renderer = renderer;
	
	    this.renderer.on('context', this.onContextChange, this);
	  }
	
	  /**
	   * Generic method called when there is a WebGL context change.
	   *
	   */
	
	
	  WebGLManager.prototype.onContextChange = function onContextChange() {}
	  // do some codes init!
	
	
	  /**
	   * Generic destroy methods to be overridden by the subclass
	   *
	   */
	  ;
	
	  WebGLManager.prototype.destroy = function destroy() {
	    this.renderer.off('context', this.onContextChange, this);
	
	    this.renderer = null;
	  };
	
	  return WebGLManager;
	}();
	
	exports.default = WebGLManager;
	//# sourceMappingURL=WebGLManager.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _Texture = __webpack_require__(17);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempPoint = new core.Point();
	var tempPolygon = new core.Polygon();
	
	/**
	 * Base mesh class
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.mesh
	 */
	
	var Mesh = function (_core$Container) {
	    _inherits(Mesh, _core$Container);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use
	     * @param {Float32Array} [vertices] - if you want to specify the vertices
	     * @param {Float32Array} [uvs] - if you want to specify the uvs
	     * @param {Uint16Array} [indices] - if you want to specify the indices
	     * @param {number} [drawMode] - the drawMode, can be any of the Mesh.DRAW_MODES consts
	     */
	    function Mesh(texture, vertices, uvs, indices, drawMode) {
	        _classCallCheck(this, Mesh);
	
	        /**
	         * The texture of the Mesh
	         *
	         * @member {PIXI.Texture}
	         * @default PIXI.Texture.EMPTY
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));
	
	        _this._texture = texture || _Texture2.default.EMPTY;
	
	        /**
	         * The Uvs of the Mesh
	         *
	         * @member {Float32Array}
	         */
	        _this.uvs = uvs || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
	
	        /**
	         * An array of vertices
	         *
	         * @member {Float32Array}
	         */
	        _this.vertices = vertices || new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);
	
	        /**
	         * An array containing the indices of the vertices
	         *
	         * @member {Uint16Array}
	         */
	        //  TODO auto generate this based on draw mode!
	        _this.indices = indices || new Uint16Array([0, 1, 3, 2]);
	
	        /**
	         * Version of mesh uvs are dirty or not
	         *
	         * @member {number}
	         */
	        _this.dirty = 0;
	
	        /**
	         * Version of mesh indices
	         *
	         * @member {number}
	         */
	        _this.indexDirty = 0;
	
	        /**
	         * Version of mesh verticies array
	         *
	         * @member {number}
	         */
	        _this.vertexDirty = 0;
	
	        /**
	         * For backwards compatibility the default is to re-upload verticies each render call.
	         * Set this to `false` and increase `vertexDirty` to manually re-upload the buffer.
	         *
	         * @member {boolean}
	         */
	        _this.autoUpdate = true;
	
	        /**
	         * The blend mode to be applied to the sprite. Set to `PIXI.BLEND_MODES.NORMAL` to remove
	         * any blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = core.BLEND_MODES.NORMAL;
	
	        /**
	         * Triangles in canvas mode are automatically antialiased, use this value to force triangles
	         * to overlap a bit with each other.
	         *
	         * @member {number}
	         */
	        _this.canvasPadding = core.settings.MESH_CANVAS_PADDING;
	
	        /**
	         * The way the Mesh should be drawn, can be any of the {@link PIXI.mesh.Mesh.DRAW_MODES} consts
	         *
	         * @member {number}
	         * @see PIXI.mesh.Mesh.DRAW_MODES
	         */
	        _this.drawMode = drawMode || Mesh.DRAW_MODES.TRIANGLE_MESH;
	
	        /**
	         * The default shader that is used if a mesh doesn't have a more specific one.
	         *
	         * @member {PIXI.Shader}
	         */
	        _this.shader = null;
	
	        /**
	         * The tint applied to the mesh. This is a [r,g,b] value. A value of [1,1,1] will remove any
	         * tint effect.
	         *
	         * @member {number}
	         */
	        _this.tintRgb = new Float32Array([1, 1, 1]);
	
	        /**
	         * A map of renderer IDs to webgl render data
	         *
	         * @private
	         * @member {object<number, object>}
	         */
	        _this._glDatas = {};
	
	        /**
	         * transform that is applied to UV to get the texture coords
	         * its updated independently from texture uvTransform
	         * updates of uvs are tied to that thing
	         *
	         * @member {PIXI.TextureMatrix}
	         * @private
	         */
	        _this._uvTransform = new core.TextureMatrix(_this._texture);
	
	        /**
	         * whether or not upload uvTransform to shader
	         * if its false, then uvs should be pre-multiplied
	         * if you change it for generated mesh, please call 'refresh(true)'
	         * @member {boolean}
	         * @default false
	         */
	        _this.uploadUvTransform = false;
	
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
	         * @member {string}
	         * @default 'mesh'
	         */
	        _this.pluginName = 'mesh';
	        return _this;
	    }
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - a reference to the WebGL renderer
	     */
	
	
	    Mesh.prototype._renderWebGL = function _renderWebGL(renderer) {
	        this.refresh();
	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	     */
	
	
	    Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
	        this.refresh();
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @private
	     */
	
	
	    Mesh.prototype._onTextureUpdate = function _onTextureUpdate() {
	        this._uvTransform.texture = this._texture;
	        this.refresh();
	    };
	
	    /**
	     * multiplies uvs only if uploadUvTransform is false
	     * call it after you change uvs manually
	     * make sure that texture is valid
	     */
	
	
	    Mesh.prototype.multiplyUvs = function multiplyUvs() {
	        if (!this.uploadUvTransform) {
	            this._uvTransform.multiplyUvs(this.uvs);
	        }
	    };
	
	    /**
	     * Refreshes uvs for generated meshes (rope, plane)
	     * sometimes refreshes vertices too
	     *
	     * @param {boolean} [forceUpdate=false] if true, matrices will be updated any case
	     */
	
	
	    Mesh.prototype.refresh = function refresh(forceUpdate) {
	        if (this.autoUpdate) {
	            this.vertexDirty++;
	        }
	        if (this._uvTransform.update(forceUpdate)) {
	            this._refresh();
	        }
	    };
	
	    /**
	     * re-calculates mesh coords
	     * @protected
	     */
	
	
	    Mesh.prototype._refresh = function _refresh() {}
	    /* empty */
	
	
	    /**
	     * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
	     *
	     */
	    ;
	
	    Mesh.prototype._calculateBounds = function _calculateBounds() {
	        // TODO - we can cache local bounds and use them if they are dirty (like graphics)
	        this._bounds.addVertices(this.transform, this.vertices, 0, this.vertices.length);
	    };
	
	    /**
	     * Tests if a point is inside this mesh. Works only for TRIANGLE_MESH
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */
	
	
	    Mesh.prototype.containsPoint = function containsPoint(point) {
	        if (!this.getBounds().contains(point.x, point.y)) {
	            return false;
	        }
	
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var vertices = this.vertices;
	        var points = tempPolygon.points;
	        var indices = this.indices;
	        var len = this.indices.length;
	        var step = this.drawMode === Mesh.DRAW_MODES.TRIANGLES ? 3 : 1;
	
	        for (var i = 0; i + 2 < len; i += step) {
	            var ind0 = indices[i] * 2;
	            var ind1 = indices[i + 1] * 2;
	            var ind2 = indices[i + 2] * 2;
	
	            points[0] = vertices[ind0];
	            points[1] = vertices[ind0 + 1];
	            points[2] = vertices[ind1];
	            points[3] = vertices[ind1 + 1];
	            points[4] = vertices[ind2];
	            points[5] = vertices[ind2 + 1];
	
	            if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * The texture that the mesh uses.
	     *
	     * @member {PIXI.Texture}
	     */
	
	
	    /**
	     * Destroys the Mesh object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	    Mesh.prototype.destroy = function destroy(options) {
	        // for each webgl data entry, destroy the WebGLGraphicsData
	        for (var id in this._glDatas) {
	            var data = this._glDatas[id];
	
	            if (data.destroy) {
	                data.destroy();
	            } else {
	                if (data.vertexBuffer) {
	                    data.vertexBuffer.destroy();
	                    data.vertexBuffer = null;
	                }
	                if (data.indexBuffer) {
	                    data.indexBuffer.destroy();
	                    data.indexBuffer = null;
	                }
	                if (data.uvBuffer) {
	                    data.uvBuffer.destroy();
	                    data.uvBuffer = null;
	                }
	                if (data.vao) {
	                    data.vao.destroy();
	                    data.vao = null;
	                }
	            }
	        }
	
	        this._glDatas = null;
	
	        _core$Container.prototype.destroy.call(this, options);
	    };
	
	    _createClass(Mesh, [{
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._texture === value) {
	                return;
	            }
	
	            this._texture = value;
	
	            if (value) {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded) {
	                    this._onTextureUpdate();
	                } else {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }
	
	        /**
	         * The tint applied to the mesh. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	
	    }, {
	        key: 'tint',
	        get: function get() {
	            return core.utils.rgb2hex(this.tintRgb);
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tintRgb = core.utils.hex2rgb(value, this.tintRgb);
	        }
	    }]);
	
	    return Mesh;
	}(core.Container);
	
	/**
	 * Different drawing buffer modes supported
	 *
	 * @static
	 * @constant
	 * @type {object}
	 * @property {number} TRIANGLE_MESH
	 * @property {number} TRIANGLES
	 */
	
	
	exports.default = Mesh;
	Mesh.DRAW_MODES = {
	    TRIANGLE_MESH: 0,
	    TRIANGLES: 1
	};
	//# sourceMappingURL=Mesh.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// import Loader from './Loader';
	// import Resource from './Resource';
	// import * as async from './async';
	// import * as b64 from './b64';
	
	/* eslint-disable no-undef */
	
	var Loader = __webpack_require__(299).default;
	var Resource = __webpack_require__(70).default;
	var async = __webpack_require__(137);
	var b64 = __webpack_require__(138);
	
	Loader.Resource = Resource;
	Loader.async = async;
	Loader.base64 = b64;
	
	// export manually, and also as default
	module.exports = Loader;
	// export default Loader;
	module.exports.default = Loader;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.loader = exports.prepare = exports.particles = exports.mesh = exports.loaders = exports.interaction = exports.filters = exports.extras = exports.extract = exports.accessibility = undefined;
	
	var _polyfill = __webpack_require__(279);
	
	Object.keys(_polyfill).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _polyfill[key];
	        }
	    });
	});
	
	var _core = __webpack_require__(4);
	
	Object.keys(_core).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _core[key];
	        }
	    });
	});
	
	var _deprecation = __webpack_require__(244);
	
	var _deprecation2 = _interopRequireDefault(_deprecation);
	
	var _accessibility = __webpack_require__(201);
	
	var accessibility = _interopRequireWildcard(_accessibility);
	
	var _extract = __webpack_require__(246);
	
	var extract = _interopRequireWildcard(_extract);
	
	var _extras = __webpack_require__(122);
	
	var extras = _interopRequireWildcard(_extras);
	
	var _filters = __webpack_require__(260);
	
	var filters = _interopRequireWildcard(_filters);
	
	var _interaction = __webpack_require__(263);
	
	var interaction = _interopRequireWildcard(_interaction);
	
	var _loaders = __webpack_require__(264);
	
	var loaders = _interopRequireWildcard(_loaders);
	
	var _mesh = __webpack_require__(269);
	
	var mesh = _interopRequireWildcard(_mesh);
	
	var _particles = __webpack_require__(272);
	
	var particles = _interopRequireWildcard(_particles);
	
	var _prepare = __webpack_require__(282);
	
	var prepare = _interopRequireWildcard(_prepare);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// export core
	_core.utils.mixins.performMixins();
	
	/**
	 * Alias for {@link PIXI.loaders.shared}.
	 * @name loader
	 * @memberof PIXI
	 * @type {PIXI.loader.Loader}
	 */
	
	
	// handle mixins now, after all code has been added, including deprecation
	
	
	// export libs
	// import polyfills. Done as an export to make sure polyfills are imported first
	var loader = loaders.shared || null;
	
	exports.accessibility = accessibility;
	exports.extract = extract;
	exports.extras = extras;
	exports.filters = filters;
	exports.interaction = interaction;
	exports.loaders = loaders;
	exports.mesh = mesh;
	exports.particles = particles;
	exports.prepare = prepare;
	exports.loader = loader;
	
	// Apply the deprecations
	
	if (typeof _deprecation2.default === 'function') {
	    (0, _deprecation2.default)(exports);
	}
	
	// Always export PixiJS globally.
	global.PIXI = exports; // eslint-disable-line
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (graphicsData, webGLData, webGLDataNativeLines) {
	    if (graphicsData.nativeLines) {
	        buildNativeLine(graphicsData, webGLDataNativeLines);
	    } else {
	        buildLine(graphicsData, webGLData);
	    }
	};
	
	var _math = __webpack_require__(7);
	
	var _utils = __webpack_require__(5);
	
	/**
	 * Builds a line to draw using the poligon method.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 */
	function buildLine(graphicsData, webGLData) {
	    // TODO OPTIMISE!
	    var points = graphicsData.points;
	
	    if (points.length === 0) {
	        return;
	    }
	    // if the line width is an odd number add 0.5 to align to a whole pixel
	    // commenting this out fixes #711 and #1620
	    // if (graphicsData.lineWidth%2)
	    // {
	    //     for (i = 0; i < points.length; i++)
	    //     {
	    //         points[i] += 0.5;
	    //     }
	    // }
	
	    // get first and last point.. figure out the middle!
	    var firstPoint = new _math.Point(points[0], points[1]);
	    var lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);
	
	    // if the first point is the last point - gonna have issues :)
	    if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y) {
	        // need to clone as we are going to slightly modify the shape..
	        points = points.slice();
	
	        points.pop();
	        points.pop();
	
	        lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);
	
	        var midPointX = lastPoint.x + (firstPoint.x - lastPoint.x) * 0.5;
	        var midPointY = lastPoint.y + (firstPoint.y - lastPoint.y) * 0.5;
	
	        points.unshift(midPointX, midPointY);
	        points.push(midPointX, midPointY);
	    }
	
	    var verts = webGLData.points;
	    var indices = webGLData.indices;
	    var length = points.length / 2;
	    var indexCount = points.length;
	    var indexStart = verts.length / 6;
	
	    // DRAW the Line
	    var width = graphicsData.lineWidth / 2;
	
	    // sort color
	    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
	    var alpha = graphicsData.lineAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;
	
	    var p1x = points[0];
	    var p1y = points[1];
	    var p2x = points[2];
	    var p2y = points[3];
	    var p3x = 0;
	    var p3y = 0;
	
	    var perpx = -(p1y - p2y);
	    var perpy = p1x - p2x;
	    var perp2x = 0;
	    var perp2y = 0;
	    var perp3x = 0;
	    var perp3y = 0;
	
	    var dist = Math.sqrt(perpx * perpx + perpy * perpy);
	
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	
	    var ratio = graphicsData.lineAlignment; // 0.5;
	    var r1 = (1 - ratio) * 2;
	    var r2 = ratio * 2;
	
	    // start
	    verts.push(p1x - perpx * r1, p1y - perpy * r1, r, g, b, alpha);
	
	    verts.push(p1x + perpx * r2, p1y + perpy * r2, r, g, b, alpha);
	
	    for (var i = 1; i < length - 1; ++i) {
	        p1x = points[(i - 1) * 2];
	        p1y = points[(i - 1) * 2 + 1];
	
	        p2x = points[i * 2];
	        p2y = points[i * 2 + 1];
	
	        p3x = points[(i + 1) * 2];
	        p3y = points[(i + 1) * 2 + 1];
	
	        perpx = -(p1y - p2y);
	        perpy = p1x - p2x;
	
	        dist = Math.sqrt(perpx * perpx + perpy * perpy);
	        perpx /= dist;
	        perpy /= dist;
	        perpx *= width;
	        perpy *= width;
	
	        perp2x = -(p2y - p3y);
	        perp2y = p2x - p3x;
	
	        dist = Math.sqrt(perp2x * perp2x + perp2y * perp2y);
	        perp2x /= dist;
	        perp2y /= dist;
	        perp2x *= width;
	        perp2y *= width;
	
	        var a1 = -perpy + p1y - (-perpy + p2y);
	        var b1 = -perpx + p2x - (-perpx + p1x);
	        var c1 = (-perpx + p1x) * (-perpy + p2y) - (-perpx + p2x) * (-perpy + p1y);
	        var a2 = -perp2y + p3y - (-perp2y + p2y);
	        var b2 = -perp2x + p2x - (-perp2x + p3x);
	        var c2 = (-perp2x + p3x) * (-perp2y + p2y) - (-perp2x + p2x) * (-perp2y + p3y);
	
	        var denom = a1 * b2 - a2 * b1;
	
	        if (Math.abs(denom) < 0.1) {
	            denom += 10.1;
	            verts.push(p2x - perpx * r1, p2y - perpy * r1, r, g, b, alpha);
	
	            verts.push(p2x + perpx * r2, p2y + perpy * r2, r, g, b, alpha);
	
	            continue;
	        }
	
	        var px = (b1 * c2 - b2 * c1) / denom;
	        var py = (a2 * c1 - a1 * c2) / denom;
	        var pdist = (px - p2x) * (px - p2x) + (py - p2y) * (py - p2y);
	
	        if (pdist > 196 * width * width) {
	            perp3x = perpx - perp2x;
	            perp3y = perpy - perp2y;
	
	            dist = Math.sqrt(perp3x * perp3x + perp3y * perp3y);
	            perp3x /= dist;
	            perp3y /= dist;
	            perp3x *= width;
	            perp3y *= width;
	
	            verts.push(p2x - perp3x * r1, p2y - perp3y * r1);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x + perp3x * r2, p2y + perp3y * r2);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x - perp3x * r2 * r1, p2y - perp3y * r1);
	            verts.push(r, g, b, alpha);
	
	            indexCount++;
	        } else {
	            verts.push(p2x + (px - p2x) * r1, p2y + (py - p2y) * r1);
	            verts.push(r, g, b, alpha);
	
	            verts.push(p2x - (px - p2x) * r2, p2y - (py - p2y) * r2);
	            verts.push(r, g, b, alpha);
	        }
	    }
	
	    p1x = points[(length - 2) * 2];
	    p1y = points[(length - 2) * 2 + 1];
	
	    p2x = points[(length - 1) * 2];
	    p2y = points[(length - 1) * 2 + 1];
	
	    perpx = -(p1y - p2y);
	    perpy = p1x - p2x;
	
	    dist = Math.sqrt(perpx * perpx + perpy * perpy);
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	
	    verts.push(p2x - perpx * r1, p2y - perpy * r1);
	    verts.push(r, g, b, alpha);
	
	    verts.push(p2x + perpx * r2, p2y + perpy * r2);
	    verts.push(r, g, b, alpha);
	
	    indices.push(indexStart);
	
	    for (var _i = 0; _i < indexCount; ++_i) {
	        indices.push(indexStart++);
	    }
	
	    indices.push(indexStart - 1);
	}
	
	/**
	 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 */
	
	
	/**
	 * Builds a line to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildNativeLine(graphicsData, webGLData) {
	    var i = 0;
	    var points = graphicsData.points;
	
	    if (points.length === 0) return;
	
	    var verts = webGLData.points;
	    var length = points.length / 2;
	
	    // sort color
	    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
	    var alpha = graphicsData.lineAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;
	
	    for (i = 1; i < length; i++) {
	        var p1x = points[(i - 1) * 2];
	        var p1y = points[(i - 1) * 2 + 1];
	
	        var p2x = points[i * 2];
	        var p2y = points[i * 2 + 1];
	
	        verts.push(p1x, p1y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(p2x, p2y);
	        verts.push(r, g, b, alpha);
	    }
	}
	//# sourceMappingURL=buildLine.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SystemRenderer2 = __webpack_require__(109);
	
	var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);
	
	var _MaskManager = __webpack_require__(224);
	
	var _MaskManager2 = _interopRequireDefault(_MaskManager);
	
	var _StencilManager = __webpack_require__(225);
	
	var _StencilManager2 = _interopRequireDefault(_StencilManager);
	
	var _FilterManager = __webpack_require__(223);
	
	var _FilterManager2 = _interopRequireDefault(_FilterManager);
	
	var _RenderTarget = __webpack_require__(37);
	
	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
	
	var _ObjectRenderer = __webpack_require__(36);
	
	var _ObjectRenderer2 = _interopRequireDefault(_ObjectRenderer);
	
	var _TextureManager = __webpack_require__(219);
	
	var _TextureManager2 = _interopRequireDefault(_TextureManager);
	
	var _BaseTexture = __webpack_require__(24);
	
	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
	
	var _TextureGarbageCollector = __webpack_require__(218);
	
	var _TextureGarbageCollector2 = _interopRequireDefault(_TextureGarbageCollector);
	
	var _WebGLState = __webpack_require__(220);
	
	var _WebGLState2 = _interopRequireDefault(_WebGLState);
	
	var _mapWebGLDrawModesToPixi = __webpack_require__(228);
	
	var _mapWebGLDrawModesToPixi2 = _interopRequireDefault(_mapWebGLDrawModesToPixi);
	
	var _validateContext = __webpack_require__(229);
	
	var _validateContext2 = _interopRequireDefault(_validateContext);
	
	var _utils = __webpack_require__(5);
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _const = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTEXT_UID = 0;
	
	/**
	 * The WebGLRenderer draws the scene and all its content onto a webGL enabled canvas. This renderer
	 * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
	 * So no need for Sprite Batches or Sprite Clouds.
	 * Don't forget to add the view to your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 */
	
	var WebGLRenderer = function (_SystemRenderer) {
	    _inherits(WebGLRenderer, _SystemRenderer);
	
	    // eslint-disable-next-line valid-jsdoc
	    /**
	     *
	     * @param {object} [options] - The optional renderer parameters
	     * @param {number} [options.width=800] - the width of the screen
	     * @param {number} [options.height=600] - the height of the screen
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	     * @param {boolean} [options.antialias=false] - sets antialias. If not available natively then FXAA
	     *  antialiasing is used
	     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	     *  FXAA is faster, but may not always look as great
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer.
	     *  The resolution of the renderer retina would be 2.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
	     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
	     *  preserveDrawingBuffer to `true`.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the webgl context.
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when
	     *  rendering, stopping pixel interpolation.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.legacy=false] - If true PixiJS will aim to ensure compatibility
	     *  with older / less advanced devices. If you experiance unexplained flickering try setting this to true.
	     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	     *  for devices with dual graphics card
	     */
	    function WebGLRenderer(options, arg2, arg3) {
	        _classCallCheck(this, WebGLRenderer);
	
	        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'WebGL', options, arg2, arg3));
	
	        _this.legacy = _this.options.legacy;
	
	        if (_this.legacy) {
	            _pixiGlCore2.default.VertexArrayObject.FORCE_NATIVE = true;
	        }
	
	        /**
	         * The type of this renderer as a standardised const
	         *
	         * @member {number}
	         * @see PIXI.RENDERER_TYPE
	         */
	        _this.type = _const.RENDERER_TYPE.WEBGL;
	
	        _this.handleContextLost = _this.handleContextLost.bind(_this);
	        _this.handleContextRestored = _this.handleContextRestored.bind(_this);
	
	        _this.view.addEventListener('webglcontextlost', _this.handleContextLost, false);
	        _this.view.addEventListener('webglcontextrestored', _this.handleContextRestored, false);
	
	        /**
	         * The options passed in to create a new webgl context.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._contextOptions = {
	            alpha: _this.transparent,
	            antialias: _this.options.antialias,
	            premultipliedAlpha: _this.transparent && _this.transparent !== 'notMultiplied',
	            stencil: true,
	            preserveDrawingBuffer: _this.options.preserveDrawingBuffer,
	            powerPreference: _this.options.powerPreference
	        };
	
	        _this._backgroundColorRgba[3] = _this.transparent ? 0 : 1;
	
	        /**
	         * Manages the masks using the stencil buffer.
	         *
	         * @member {PIXI.MaskManager}
	         */
	        _this.maskManager = new _MaskManager2.default(_this);
	
	        /**
	         * Manages the stencil buffer.
	         *
	         * @member {PIXI.StencilManager}
	         */
	        _this.stencilManager = new _StencilManager2.default(_this);
	
	        /**
	         * An empty renderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.emptyRenderer = new _ObjectRenderer2.default(_this);
	
	        /**
	         * The currently active ObjectRenderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.currentRenderer = _this.emptyRenderer;
	
	        /**
	         * Manages textures
	         * @member {PIXI.TextureManager}
	         */
	        _this.textureManager = null;
	
	        /**
	         * Manages the filters.
	         *
	         * @member {PIXI.FilterManager}
	         */
	        _this.filterManager = null;
	
	        _this.initPlugins();
	
	        /**
	         * The current WebGL rendering context, it is created here
	         *
	         * @member {WebGLRenderingContext}
	         */
	        // initialize the context so it is ready for the managers.
	        if (_this.options.context) {
	            // checks to see if a context is valid..
	            (0, _validateContext2.default)(_this.options.context);
	        }
	
	        _this.gl = _this.options.context || _pixiGlCore2.default.createContext(_this.view, _this._contextOptions);
	
	        _this.CONTEXT_UID = CONTEXT_UID++;
	
	        /**
	         * The currently active ObjectRenderer.
	         *
	         * @member {PIXI.WebGLState}
	         */
	        _this.state = new _WebGLState2.default(_this.gl);
	
	        _this.renderingToScreen = true;
	
	        /**
	         * Holds the current state of textures bound to the GPU.
	         * @type {Array}
	         */
	        _this.boundTextures = null;
	
	        /**
	         * Holds the current shader
	         *
	         * @member {PIXI.Shader}
	         */
	        _this._activeShader = null;
	
	        _this._activeVao = null;
	
	        /**
	         * Holds the current render target
	         *
	         * @member {PIXI.RenderTarget}
	         */
	        _this._activeRenderTarget = null;
	
	        _this._initContext();
	
	        // map some webGL blend and drawmodes..
	        _this.drawModes = (0, _mapWebGLDrawModesToPixi2.default)(_this.gl);
	
	        _this._nextTextureLocation = 0;
	
	        _this.setBlendMode(0);
	
	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.WebGLRenderer#postrender
	         */
	
	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.WebGLRenderer#prerender
	         */
	
	        /**
	         * Fired when the WebGL context is set.
	         *
	         * @event PIXI.WebGLRenderer#context
	         * @param {WebGLRenderingContext} gl - WebGL context.
	         */
	        return _this;
	    }
	
	    /**
	     * Creates the WebGL context
	     *
	     * @private
	     */
	
	
	    WebGLRenderer.prototype._initContext = function _initContext() {
	        var gl = this.gl;
	
	        // restore a context if it was previously lost
	        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) {
	            gl.getExtension('WEBGL_lose_context').restoreContext();
	        }
	
	        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
	
	        this._activeShader = null;
	        this._activeVao = null;
	
	        this.boundTextures = new Array(maxTextures);
	        this.emptyTextures = new Array(maxTextures);
	
	        // create a texture manager...
	        this.textureManager = new _TextureManager2.default(this);
	        this.filterManager = new _FilterManager2.default(this);
	        this.textureGC = new _TextureGarbageCollector2.default(this);
	
	        this.state.resetToDefault();
	
	        this.rootRenderTarget = new _RenderTarget2.default(gl, this.width, this.height, null, this.resolution, true);
	        this.rootRenderTarget.clearColor = this._backgroundColorRgba;
	
	        this.bindRenderTarget(this.rootRenderTarget);
	
	        // now lets fill up the textures with empty ones!
	        var emptyGLTexture = new _pixiGlCore2.default.GLTexture.fromData(gl, null, 1, 1);
	
	        var tempObj = { _glTextures: {} };
	
	        tempObj._glTextures[this.CONTEXT_UID] = {};
	
	        for (var i = 0; i < maxTextures; i++) {
	            var empty = new _BaseTexture2.default();
	
	            empty._glTextures[this.CONTEXT_UID] = emptyGLTexture;
	
	            this.boundTextures[i] = tempObj;
	            this.emptyTextures[i] = empty;
	            this.bindTexture(null, i);
	        }
	
	        this.emit('context', gl);
	
	        // setup the width/height properties and gl viewport
	        this.resize(this.screen.width, this.screen.height);
	    };
	
	    /**
	     * Renders the object to its webGL view
	     *
	     * @param {PIXI.DisplayObject} displayObject - the object to be rendered
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to render to.
	     * @param {boolean} [clear] - Should the canvas be cleared before the new render
	     * @param {PIXI.Transform} [transform] - A transform to apply to the render texture before rendering.
	     * @param {boolean} [skipUpdateTransform] - Should we skip the update transform pass?
	     */
	
	
	    WebGLRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;
	
	        this.emit('prerender');
	
	        // no point rendering if our context has been blown up!
	        if (!this.gl || this.gl.isContextLost()) {
	            return;
	        }
	
	        this._nextTextureLocation = 0;
	
	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }
	
	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.parent;
	
	            displayObject.parent = this._tempDisplayObjectParent;
	            displayObject.updateTransform();
	            displayObject.parent = cacheParent;
	            // displayObject.hitArea = //TODO add a temp hit area
	        }
	
	        this.bindRenderTexture(renderTexture, transform);
	
	        this.currentRenderer.start();
	
	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            this._activeRenderTarget.clear();
	        }
	
	        displayObject.renderWebGL(this);
	
	        // apply transform..
	        this.currentRenderer.flush();
	
	        // this.setObjectRenderer(this.emptyRenderer);
	
	        this.textureGC.update();
	
	        this.emit('postrender');
	    };
	
	    /**
	     * Changes the current renderer to the one given in parameter
	     *
	     * @param {PIXI.ObjectRenderer} objectRenderer - The object renderer to use.
	     */
	
	
	    WebGLRenderer.prototype.setObjectRenderer = function setObjectRenderer(objectRenderer) {
	        if (this.currentRenderer === objectRenderer) {
	            return;
	        }
	
	        this.currentRenderer.stop();
	        this.currentRenderer = objectRenderer;
	        this.currentRenderer.start();
	    };
	
	    /**
	     * This should be called if you wish to do some custom rendering
	     * It will basically render anything that may be batched up such as sprites
	     *
	     */
	
	
	    WebGLRenderer.prototype.flush = function flush() {
	        this.setObjectRenderer(this.emptyRenderer);
	    };
	
	    /**
	     * Resizes the webGL view to the specified width and height.
	     *
	     * @param {number} screenWidth - the new width of the screen
	     * @param {number} screenHeight - the new height of the screen
	     */
	
	
	    WebGLRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	        //  if(width * this.resolution === this.width && height * this.resolution === this.height)return;
	
	        _SystemRenderer3.default.prototype.resize.call(this, screenWidth, screenHeight);
	
	        this.rootRenderTarget.resize(screenWidth, screenHeight);
	
	        if (this._activeRenderTarget === this.rootRenderTarget) {
	            this.rootRenderTarget.activate();
	
	            if (this._activeShader) {
	                this._activeShader.uniforms.projectionMatrix = this.rootRenderTarget.projectionMatrix.toArray(true);
	            }
	        }
	    };
	
	    /**
	     * Resizes the webGL view to the specified width and height.
	     *
	     * @param {number} blendMode - the desired blend mode
	     */
	
	
	    WebGLRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
	        this.state.setBlendMode(blendMode);
	    };
	
	    /**
	     * Erases the active render target and fills the drawing area with a colour
	     *
	     * @param {number} [clearColor] - The colour
	     */
	
	
	    WebGLRenderer.prototype.clear = function clear(clearColor) {
	        this._activeRenderTarget.clear(clearColor);
	    };
	
	    /**
	     * Sets the transform of the active render target to the given matrix
	     *
	     * @param {PIXI.Matrix} matrix - The transformation matrix
	     */
	
	
	    WebGLRenderer.prototype.setTransform = function setTransform(matrix) {
	        this._activeRenderTarget.transform = matrix;
	    };
	
	    /**
	     * Erases the render texture and fills the drawing area with a colour
	     *
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to clear
	     * @param {number} [clearColor] - The colour
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.clearRenderTexture = function clearRenderTexture(renderTexture, clearColor) {
	        var baseTexture = renderTexture.baseTexture;
	        var renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
	
	        if (renderTarget) {
	            renderTarget.clear(clearColor);
	        }
	
	        return this;
	    };
	
	    /**
	     * Binds a render texture for rendering
	     *
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to render
	     * @param {PIXI.Transform} transform - The transform to be applied to the render texture
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindRenderTexture = function bindRenderTexture(renderTexture, transform) {
	        var renderTarget = void 0;
	
	        if (renderTexture) {
	            var baseTexture = renderTexture.baseTexture;
	
	            if (!baseTexture._glRenderTargets[this.CONTEXT_UID]) {
	                // bind the current texture
	                this.textureManager.updateTexture(baseTexture, 0);
	            }
	
	            this.unbindTexture(baseTexture);
	
	            renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
	            renderTarget.setFrame(renderTexture.frame);
	        } else {
	            renderTarget = this.rootRenderTarget;
	        }
	
	        renderTarget.transform = transform;
	        this.bindRenderTarget(renderTarget);
	
	        return this;
	    };
	
	    /**
	     * Changes the current render target to the one given in parameter
	     *
	     * @param {PIXI.RenderTarget} renderTarget - the new render target
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindRenderTarget = function bindRenderTarget(renderTarget) {
	        if (renderTarget !== this._activeRenderTarget) {
	            this._activeRenderTarget = renderTarget;
	            renderTarget.activate();
	
	            if (this._activeShader) {
	                this._activeShader.uniforms.projectionMatrix = renderTarget.projectionMatrix.toArray(true);
	            }
	
	            this.stencilManager.setMaskStack(renderTarget.stencilMaskStack);
	        }
	
	        return this;
	    };
	
	    /**
	     * Changes the current shader to the one given in parameter
	     *
	     * @param {PIXI.Shader} shader - the new shader
	     * @param {boolean} [autoProject=true] - Whether automatically set the projection matrix
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindShader = function bindShader(shader, autoProject) {
	        // TODO cache
	        if (this._activeShader !== shader) {
	            this._activeShader = shader;
	            shader.bind();
	
	            // `autoProject` normally would be a default parameter set to true
	            // but because of how Babel transpiles default parameters
	            // it hinders the performance of this method.
	            if (autoProject !== false) {
	                // automatically set the projection matrix
	                shader.uniforms.projectionMatrix = this._activeRenderTarget.projectionMatrix.toArray(true);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Binds the texture. This will return the location of the bound texture.
	     * It may not be the same as the one you pass in. This is due to optimisation that prevents
	     * needless binding of textures. For example if the texture is already bound it will return the
	     * current location of the texture instead of the one provided. To bypass this use force location
	     *
	     * @param {PIXI.Texture} texture - the new texture
	     * @param {number} location - the suggested texture location
	     * @param {boolean} forceLocation - force the location
	     * @return {number} bound texture location
	     */
	
	
	    WebGLRenderer.prototype.bindTexture = function bindTexture(texture, location, forceLocation) {
	        texture = texture || this.emptyTextures[location];
	        texture = texture.baseTexture || texture;
	        texture.touched = this.textureGC.count;
	
	        if (!forceLocation) {
	            // TODO - maybe look into adding boundIds.. save us the loop?
	            for (var i = 0; i < this.boundTextures.length; i++) {
	                if (this.boundTextures[i] === texture) {
	                    return i;
	                }
	            }
	
	            if (location === undefined) {
	                this._nextTextureLocation++;
	                this._nextTextureLocation %= this.boundTextures.length;
	                location = this.boundTextures.length - this._nextTextureLocation - 1;
	            }
	        } else {
	            location = location || 0;
	        }
	
	        var gl = this.gl;
	        var glTexture = texture._glTextures[this.CONTEXT_UID];
	
	        if (!glTexture) {
	            // this will also bind the texture..
	            this.textureManager.updateTexture(texture, location);
	        } else {
	            // bind the current texture
	            this.boundTextures[location] = texture;
	            gl.activeTexture(gl.TEXTURE0 + location);
	            gl.bindTexture(gl.TEXTURE_2D, glTexture.texture);
	        }
	
	        return location;
	    };
	
	    /**
	    * unbinds the texture ...
	    *
	    * @param {PIXI.Texture} texture - the texture to unbind
	    * @return {PIXI.WebGLRenderer} Returns itself.
	    */
	
	
	    WebGLRenderer.prototype.unbindTexture = function unbindTexture(texture) {
	        var gl = this.gl;
	
	        texture = texture.baseTexture || texture;
	
	        for (var i = 0; i < this.boundTextures.length; i++) {
	            if (this.boundTextures[i] === texture) {
	                this.boundTextures[i] = this.emptyTextures[i];
	
	                gl.activeTexture(gl.TEXTURE0 + i);
	                gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[i]._glTextures[this.CONTEXT_UID].texture);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Creates a new VAO from this renderer's context and state.
	     *
	     * @return {VertexArrayObject} The new VAO.
	     */
	
	
	    WebGLRenderer.prototype.createVao = function createVao() {
	        return new _pixiGlCore2.default.VertexArrayObject(this.gl, this.state.attribState);
	    };
	
	    /**
	     * Changes the current Vao to the one given in parameter
	     *
	     * @param {PIXI.VertexArrayObject} vao - the new Vao
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.bindVao = function bindVao(vao) {
	        if (this._activeVao === vao) {
	            return this;
	        }
	
	        if (vao) {
	            vao.bind();
	        } else if (this._activeVao) {
	            // TODO this should always be true i think?
	            this._activeVao.unbind();
	        }
	
	        this._activeVao = vao;
	
	        return this;
	    };
	
	    /**
	     * Resets the WebGL state so you can render things however you fancy!
	     *
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */
	
	
	    WebGLRenderer.prototype.reset = function reset() {
	        this.setObjectRenderer(this.emptyRenderer);
	
	        this.bindVao(null);
	        this._activeShader = null;
	        this._activeRenderTarget = this.rootRenderTarget;
	
	        for (var i = 0; i < this.boundTextures.length; i++) {
	            this.boundTextures[i] = this.emptyTextures[i];
	        }
	
	        // bind the main frame buffer (the screen);
	        this.rootRenderTarget.activate();
	
	        this.state.resetToDefault();
	
	        return this;
	    };
	
	    /**
	     * Handles a lost webgl context
	     *
	     * @private
	     * @param {WebGLContextEvent} event - The context lost event.
	     */
	
	
	    WebGLRenderer.prototype.handleContextLost = function handleContextLost(event) {
	        event.preventDefault();
	    };
	
	    /**
	     * Handles a restored webgl context
	     *
	     * @private
	     */
	
	
	    WebGLRenderer.prototype.handleContextRestored = function handleContextRestored() {
	        this.textureManager.removeAll();
	        this.filterManager.destroy(true);
	        this._initContext();
	    };
	
	    /**
	     * Removes everything from the renderer (event listeners, spritebatch, etc...)
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     *  See: https://github.com/pixijs/pixi.js/issues/2233
	     */
	
	
	    WebGLRenderer.prototype.destroy = function destroy(removeView) {
	        this.destroyPlugins();
	
	        // remove listeners
	        this.view.removeEventListener('webglcontextlost', this.handleContextLost);
	        this.view.removeEventListener('webglcontextrestored', this.handleContextRestored);
	
	        this.textureManager.destroy();
	
	        // call base destroy
	        _SystemRenderer.prototype.destroy.call(this, removeView);
	
	        this.uid = 0;
	
	        // destroy the managers
	        this.maskManager.destroy();
	        this.stencilManager.destroy();
	        this.filterManager.destroy();
	
	        this.maskManager = null;
	        this.filterManager = null;
	        this.textureManager = null;
	        this.currentRenderer = null;
	
	        this.handleContextLost = null;
	        this.handleContextRestored = null;
	
	        this._contextOptions = null;
	        this.gl.useProgram(null);
	
	        if (this.gl.getExtension('WEBGL_lose_context')) {
	            this.gl.getExtension('WEBGL_lose_context').loseContext();
	        }
	
	        this.gl = null;
	
	        // this = null;
	    };
	
	    return WebGLRenderer;
	}(_SystemRenderer3.default);
	
	/**
	 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
	 * by creating a custom build. Consult the README for more information about creating custom
	 * builds and excluding plugins.
	 * @name PIXI.WebGLRenderer#plugins
	 * @type {object}
	 * @readonly
	 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
	 * @property {PIXI.extract.WebGLExtract} extract Extract image data from renderer.
	 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
	 * @property {PIXI.prepare.WebGLPrepare} prepare Pre-render display objects.
	 */
	
	/**
	 * Adds a plugin to the renderer.
	 *
	 * @method PIXI.WebGLRenderer#registerPlugin
	 * @param {string} pluginName - The name of the plugin.
	 * @param {Function} ctor - The constructor function or class for the plugin.
	 */
	
	exports.default = WebGLRenderer;
	_utils.pluginTarget.mixin(WebGLRenderer);
	//# sourceMappingURL=WebGLRenderer.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(29);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Base for a common object renderer that can be used as a system renderer plugin.
	 *
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var ObjectRenderer = function (_WebGLManager) {
	  _inherits(ObjectRenderer, _WebGLManager);
	
	  function ObjectRenderer() {
	    _classCallCheck(this, ObjectRenderer);
	
	    return _possibleConstructorReturn(this, _WebGLManager.apply(this, arguments));
	  }
	
	  /**
	   * Starts the renderer and sets the shader
	   *
	   */
	  ObjectRenderer.prototype.start = function start() {}
	  // set the shader..
	
	
	  /**
	   * Stops the renderer
	   *
	   */
	  ;
	
	  ObjectRenderer.prototype.stop = function stop() {
	    this.flush();
	  };
	
	  /**
	   * Stub method for rendering content and emptying the current batch.
	   *
	   */
	
	
	  ObjectRenderer.prototype.flush = function flush() {}
	  // flush!
	
	
	  /**
	   * Renders an object
	   *
	   * @param {PIXI.DisplayObject} object - The object to render.
	   */
	  ;
	
	  ObjectRenderer.prototype.render = function render(object) // eslint-disable-line no-unused-vars
	  {
	    // render the object
	  };
	
	  return ObjectRenderer;
	}(_WebGLManager3.default);
	
	exports.default = ObjectRenderer;
	//# sourceMappingURL=ObjectRenderer.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _math = __webpack_require__(7);
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _pixiGlCore = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var RenderTarget = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	   * @param {number} [width=0] - the horizontal range of the filter
	   * @param {number} [height=0] - the vertical range of the filter
	   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	   * @param {number} [resolution=1] - The current resolution / device pixel ratio
	   * @param {boolean} [root=false] - Whether this object is the root element or not
	   */
	  function RenderTarget(gl, width, height, scaleMode, resolution, root) {
	    _classCallCheck(this, RenderTarget);
	
	    // TODO Resolution could go here ( eg low res blurs )
	
	    /**
	     * The current WebGL drawing context.
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    // next time to create a frame buffer and texture
	
	    /**
	     * A frame buffer
	     *
	     * @member {PIXI.glCore.GLFramebuffer}
	     */
	    this.frameBuffer = null;
	
	    /**
	     * The texture
	     *
	     * @member {PIXI.glCore.GLTexture}
	     */
	    this.texture = null;
	
	    /**
	     * The background colour of this render target, as an array of [r,g,b,a] values
	     *
	     * @member {number[]}
	     */
	    this.clearColor = [0, 0, 0, 0];
	
	    /**
	     * The size of the object as a rectangle
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.size = new _math.Rectangle(0, 0, 1, 1);
	
	    /**
	     * The current resolution / device pixel ratio
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.resolution = resolution || _settings2.default.RESOLUTION;
	
	    /**
	     * The projection matrix
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.projectionMatrix = new _math.Matrix();
	
	    /**
	     * The object's transform
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.transform = null;
	
	    /**
	     * The frame.
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.frame = null;
	
	    /**
	     * The stencil buffer stores masking data for the render target
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.defaultFrame = new _math.Rectangle();
	    this.destinationFrame = null;
	    this.sourceFrame = null;
	
	    /**
	     * The stencil buffer stores masking data for the render target
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.stencilBuffer = null;
	
	    /**
	     * The data structure for the stencil masks
	     *
	     * @member {PIXI.Graphics[]}
	     */
	    this.stencilMaskStack = [];
	
	    /**
	     * Stores filter data for the render target
	     *
	     * @member {object[]}
	     */
	    this.filterData = null;
	
	    /**
	     * The key for pooled texture of FilterSystem
	     * @private
	     * @member {string}
	     */
	    this.filterPoolKey = '';
	
	    /**
	     * The scale mode.
	     *
	     * @member {number}
	     * @default PIXI.settings.SCALE_MODE
	     * @see PIXI.SCALE_MODES
	     */
	    this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
	
	    /**
	     * Whether this object is the root element or not
	     *
	     * @member {boolean}
	     */
	    this.root = root;
	
	    if (!this.root) {
	      this.frameBuffer = _pixiGlCore.GLFramebuffer.createRGBA(gl, 100, 100);
	
	      if (this.scaleMode === _const.SCALE_MODES.NEAREST) {
	        this.frameBuffer.texture.enableNearestScaling();
	      } else {
	        this.frameBuffer.texture.enableLinearScaling();
	      }
	      /*
	          A frame buffer needs a target to render to..
	          create a texture and bind it attach it to the framebuffer..
	       */
	
	      // this is used by the base texture
	      this.texture = this.frameBuffer.texture;
	    } else {
	      // make it a null framebuffer..
	      this.frameBuffer = new _pixiGlCore.GLFramebuffer(gl, 100, 100);
	      this.frameBuffer.framebuffer = null;
	    }
	
	    this.setFrame();
	
	    this.resize(width, height);
	  }
	
	  /**
	   * Clears the filter texture.
	   *
	   * @param {number[]} [clearColor=this.clearColor] - Array of [r,g,b,a] to clear the framebuffer
	   */
	
	
	  RenderTarget.prototype.clear = function clear(clearColor) {
	    var cc = clearColor || this.clearColor;
	
	    this.frameBuffer.clear(cc[0], cc[1], cc[2], cc[3]); // r,g,b,a);
	  };
	
	  /**
	   * Binds the stencil buffer.
	   *
	   */
	
	
	  RenderTarget.prototype.attachStencilBuffer = function attachStencilBuffer() {
	    // TODO check if stencil is done?
	    /**
	     * The stencil buffer is used for masking in pixi
	     * lets create one and then add attach it to the framebuffer..
	     */
	    if (!this.root) {
	      this.frameBuffer.enableStencil();
	    }
	  };
	
	  /**
	   * Sets the frame of the render target.
	   *
	   * @param {Rectangle} destinationFrame - The destination frame.
	   * @param {Rectangle} sourceFrame - The source frame.
	   */
	
	
	  RenderTarget.prototype.setFrame = function setFrame(destinationFrame, sourceFrame) {
	    this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
	    this.sourceFrame = sourceFrame || this.sourceFrame || this.destinationFrame;
	  };
	
	  /**
	   * Binds the buffers and initialises the viewport.
	   *
	   */
	
	
	  RenderTarget.prototype.activate = function activate() {
	    // TOOD refactor usage of frame..
	    var gl = this.gl;
	
	    // make sure the texture is unbound!
	    this.frameBuffer.bind();
	
	    this.calculateProjection(this.destinationFrame, this.sourceFrame);
	
	    if (this.transform) {
	      this.projectionMatrix.append(this.transform);
	    }
	
	    // TODO add a check as them may be the same!
	    if (this.destinationFrame !== this.sourceFrame) {
	      gl.enable(gl.SCISSOR_TEST);
	      gl.scissor(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
	    } else {
	      gl.disable(gl.SCISSOR_TEST);
	    }
	
	    // TODO - does not need to be updated all the time??
	    gl.viewport(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
	  };
	
	  /**
	   * Updates the projection matrix based on a projection frame (which is a rectangle)
	   *
	   * @param {Rectangle} destinationFrame - The destination frame.
	   * @param {Rectangle} sourceFrame - The source frame.
	   */
	
	
	  RenderTarget.prototype.calculateProjection = function calculateProjection(destinationFrame, sourceFrame) {
	    var pm = this.projectionMatrix;
	
	    sourceFrame = sourceFrame || destinationFrame;
	
	    pm.identity();
	
	    // TODO: make dest scale source
	    if (!this.root) {
	      pm.a = 1 / destinationFrame.width * 2;
	      pm.d = 1 / destinationFrame.height * 2;
	
	      pm.tx = -1 - sourceFrame.x * pm.a;
	      pm.ty = -1 - sourceFrame.y * pm.d;
	    } else {
	      pm.a = 1 / destinationFrame.width * 2;
	      pm.d = -1 / destinationFrame.height * 2;
	
	      pm.tx = -1 - sourceFrame.x * pm.a;
	      pm.ty = 1 - sourceFrame.y * pm.d;
	    }
	  };
	
	  /**
	   * Resizes the texture to the specified width and height
	   *
	   * @param {number} width - the new width of the texture
	   * @param {number} height - the new height of the texture
	   */
	
	
	  RenderTarget.prototype.resize = function resize(width, height) {
	    width = width | 0;
	    height = height | 0;
	
	    if (this.size.width === width && this.size.height === height) {
	      return;
	    }
	
	    this.size.width = width;
	    this.size.height = height;
	
	    this.defaultFrame.width = width;
	    this.defaultFrame.height = height;
	
	    this.frameBuffer.resize(width * this.resolution, height * this.resolution);
	
	    var projectionFrame = this.frame || this.size;
	
	    this.calculateProjection(projectionFrame);
	  };
	
	  /**
	   * Destroys the render target.
	   *
	   */
	
	
	  RenderTarget.prototype.destroy = function destroy() {
	    this.frameBuffer.destroy();
	
	    this.frameBuffer = null;
	    this.texture = null;
	  };
	
	  return RenderTarget;
	}();
	
	exports.default = RenderTarget;
	//# sourceMappingURL=RenderTarget.js.map

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

	/**
	 * Bit twiddling hacks for JavaScript.
	 *
	 * Author: Mikola Lysenko
	 *
	 * Ported from Stanford bit twiddling hack library:
	 *    http://graphics.stanford.edu/~seander/bithacks.html
	 */
	
	"use strict"; "use restrict";
	
	//Number of bits in an integer
	var INT_BITS = 32;
	
	//Constants
	exports.INT_BITS  = INT_BITS;
	exports.INT_MAX   =  0x7fffffff;
	exports.INT_MIN   = -1<<(INT_BITS-1);
	
	//Returns -1, 0, +1 depending on sign of x
	exports.sign = function(v) {
	  return (v > 0) - (v < 0);
	}
	
	//Computes absolute value of integer
	exports.abs = function(v) {
	  var mask = v >> (INT_BITS-1);
	  return (v ^ mask) - mask;
	}
	
	//Computes minimum of integers x and y
	exports.min = function(x, y) {
	  return y ^ ((x ^ y) & -(x < y));
	}
	
	//Computes maximum of integers x and y
	exports.max = function(x, y) {
	  return x ^ ((x ^ y) & -(x < y));
	}
	
	//Checks if a number is a power of two
	exports.isPow2 = function(v) {
	  return !(v & (v-1)) && (!!v);
	}
	
	//Computes log base 2 of v
	exports.log2 = function(v) {
	  var r, shift;
	  r =     (v > 0xFFFF) << 4; v >>>= r;
	  shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
	  shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
	  shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
	  return r | (v >> 1);
	}
	
	//Computes log base 10 of v
	exports.log10 = function(v) {
	  return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
	          (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
	          (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
	}
	
	//Counts number of bits
	exports.popCount = function(v) {
	  v = v - ((v >>> 1) & 0x55555555);
	  v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
	  return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
	}
	
	//Counts number of trailing zeros
	function countTrailingZeros(v) {
	  var c = 32;
	  v &= -v;
	  if (v) c--;
	  if (v & 0x0000FFFF) c -= 16;
	  if (v & 0x00FF00FF) c -= 8;
	  if (v & 0x0F0F0F0F) c -= 4;
	  if (v & 0x33333333) c -= 2;
	  if (v & 0x55555555) c -= 1;
	  return c;
	}
	exports.countTrailingZeros = countTrailingZeros;
	
	//Rounds to next power of 2
	exports.nextPow2 = function(v) {
	  v += v === 0;
	  --v;
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v + 1;
	}
	
	//Rounds down to previous power of 2
	exports.prevPow2 = function(v) {
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v - (v>>>1);
	}
	
	//Computes parity of word
	exports.parity = function(v) {
	  v ^= v >>> 16;
	  v ^= v >>> 8;
	  v ^= v >>> 4;
	  v &= 0xf;
	  return (0x6996 >>> v) & 1;
	}
	
	var REVERSE_TABLE = new Array(256);
	
	(function(tab) {
	  for(var i=0; i<256; ++i) {
	    var v = i, r = i, s = 7;
	    for (v >>>= 1; v; v >>>= 1) {
	      r <<= 1;
	      r |= v & 1;
	      --s;
	    }
	    tab[i] = (r << s) & 0xff;
	  }
	})(REVERSE_TABLE);
	
	//Reverse bits in a 32 bit word
	exports.reverse = function(v) {
	  return  (REVERSE_TABLE[ v         & 0xff] << 24) |
	          (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
	          (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
	           REVERSE_TABLE[(v >>> 24) & 0xff];
	}
	
	//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
	exports.interleave2 = function(x, y) {
	  x &= 0xFFFF;
	  x = (x | (x << 8)) & 0x00FF00FF;
	  x = (x | (x << 4)) & 0x0F0F0F0F;
	  x = (x | (x << 2)) & 0x33333333;
	  x = (x | (x << 1)) & 0x55555555;
	
	  y &= 0xFFFF;
	  y = (y | (y << 8)) & 0x00FF00FF;
	  y = (y | (y << 4)) & 0x0F0F0F0F;
	  y = (y | (y << 2)) & 0x33333333;
	  y = (y | (y << 1)) & 0x55555555;
	
	  return x | (y << 1);
	}
	
	//Extracts the nth interleaved component
	exports.deinterleave2 = function(v, n) {
	  v = (v >>> n) & 0x55555555;
	  v = (v | (v >>> 1))  & 0x33333333;
	  v = (v | (v >>> 2))  & 0x0F0F0F0F;
	  v = (v | (v >>> 4))  & 0x00FF00FF;
	  v = (v | (v >>> 16)) & 0x000FFFF;
	  return (v << 16) >> 16;
	}
	
	
	//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
	exports.interleave3 = function(x, y, z) {
	  x &= 0x3FF;
	  x  = (x | (x<<16)) & 4278190335;
	  x  = (x | (x<<8))  & 251719695;
	  x  = (x | (x<<4))  & 3272356035;
	  x  = (x | (x<<2))  & 1227133513;
	
	  y &= 0x3FF;
	  y  = (y | (y<<16)) & 4278190335;
	  y  = (y | (y<<8))  & 251719695;
	  y  = (y | (y<<4))  & 3272356035;
	  y  = (y | (y<<2))  & 1227133513;
	  x |= (y << 1);
	  
	  z &= 0x3FF;
	  z  = (z | (z<<16)) & 4278190335;
	  z  = (z | (z<<8))  & 251719695;
	  z  = (z | (z<<4))  & 3272356035;
	  z  = (z | (z<<2))  & 1227133513;
	  
	  return x | (z << 2);
	}
	
	//Extracts nth interleaved component of a 3-tuple
	exports.deinterleave3 = function(v, n) {
	  v = (v >>> n)       & 1227133513;
	  v = (v | (v>>>2))   & 3272356035;
	  v = (v | (v>>>4))   & 251719695;
	  v = (v | (v>>>8))   & 4278190335;
	  v = (v | (v>>>16))  & 0x3FF;
	  return (v<<22)>>22;
	}
	
	//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
	exports.nextCombination = function(v) {
	  var t = v | (v - 1);
	  return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
	}
	


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = earcut;
	module.exports.default = earcut;
	
	function earcut(data, holeIndices, dim) {
	
	    dim = dim || 2;
	
	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];
	
	    if (!outerNode) return triangles;
	
	    var minX, minY, maxX, maxY, x, y, invSize;
	
	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	
	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];
	
	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }
	
	        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
	        invSize = Math.max(maxX - minX, maxY - minY);
	        invSize = invSize !== 0 ? 1 / invSize : 0;
	    }
	
	    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
	
	    return triangles;
	}
	
	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;
	
	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }
	
	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }
	
	    return last;
	}
	
	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;
	
	    var p = start,
	        again;
	    do {
	        again = false;
	
	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) break;
	            again = true;
	
	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);
	
	    return end;
	}
	
	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	    if (!ear) return;
	
	    // interlink polygon nodes in z-order
	    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
	
	    var stop = ear,
	        prev, next;
	
	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;
	
	        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);
	
	            removeNode(ear);
	
	            // skipping the next vertice leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;
	
	            continue;
	        }
	
	        ear = next;
	
	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
	
	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(ear, triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
	
	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, invSize);
	            }
	
	            break;
	        }
	    }
	}
	
	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;
	
	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }
	
	    return true;
	}
	
	function isEarHashed(ear, minX, minY, invSize) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
	
	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
	
	    var p = ear.prevZ,
	        n = ear.nextZ;
	
	    // look for points inside the triangle in both directions
	    while (p && p.z >= minZ && n && n.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    // look for remaining points in decreasing z-order
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }
	
	    // look for remaining points in increasing z-order
	    while (n && n.z <= maxZ) {
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }
	
	    return true;
	}
	
	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;
	
	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	
	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);
	
	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);
	
	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);
	
	    return p;
	}
	
	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);
	
	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);
	
	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, invSize);
	                earcutLinked(c, triangles, dim, minX, minY, invSize);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}
	
	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;
	
	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }
	
	    queue.sort(compareX);
	
	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }
	
	    return outerNode;
	}
	
	function compareX(a, b) {
	    return a.x - b.x;
	}
	
	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    outerNode = findHoleBridge(hole, outerNode);
	    if (outerNode) {
	        var b = splitPolygon(outerNode, hole);
	        filterPoints(b, b.next);
	    }
	}
	
	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;
	
	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);
	
	    if (!m) return null;
	
	    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint
	
	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point
	
	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;
	
	    p = m.next;
	
	    while (p !== stop) {
	        if (hx >= p.x && p.x >= mx && hx !== p.x &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	
	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
	
	            if ((tan < tanMin || (tan === tanMin && p.x > m.x)) && locallyInside(p, hole)) {
	                m = p;
	                tanMin = tan;
	            }
	        }
	
	        p = p.next;
	    }
	
	    return m;
	}
	
	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, invSize) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);
	
	    p.prevZ.nextZ = null;
	    p.prevZ = null;
	
	    sortLinked(p);
	}
	
	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;
	
	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;
	
	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	            qSize = inSize;
	
	            while (pSize > 0 || (qSize > 0 && q)) {
	
	                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }
	
	                if (tail) tail.nextZ = e;
	                else list = e;
	
	                e.prevZ = tail;
	                tail = e;
	            }
	
	            p = q;
	        }
	
	        tail.nextZ = null;
	        inSize *= 2;
	
	    } while (numMerges > 1);
	
	    return list;
	}
	
	// z-order of a point given coords and inverse of the longer side of data bbox
	function zOrder(x, y, minX, minY, invSize) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) * invSize;
	    y = 32767 * (y - minY) * invSize;
	
	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;
	
	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;
	
	    return x | (y << 1);
	}
	
	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x) leftmost = p;
	        p = p.next;
	    } while (p !== start);
	
	    return leftmost;
	}
	
	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}
	
	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) &&
	           locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b);
	}
	
	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}
	
	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}
	
	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    if ((equals(p1, q1) && equals(p2, q2)) ||
	        (equals(p1, q2) && equals(p2, q1))) return true;
	    return area(p1, q1, p2) > 0 !== area(p1, q1, q2) > 0 &&
	           area(p2, q2, p1) > 0 !== area(p2, q2, q1) > 0;
	}
	
	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);
	
	    return false;
	}
	
	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}
	
	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
	                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);
	
	    return inside;
	}
	
	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;
	
	    a.next = b;
	    b.prev = a;
	
	    a2.next = an;
	    an.prev = a2;
	
	    b2.next = a2;
	    a2.prev = b2;
	
	    bp.next = b2;
	    b2.prev = bp;
	
	    return b2;
	}
	
	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);
	
	    if (!last) {
	        p.prev = p;
	        p.next = p;
	
	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}
	
	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;
	
	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}
	
	function Node(i, x, y) {
	    // vertice index in coordinates array
	    this.i = i;
	
	    // vertex coordinates
	    this.x = x;
	    this.y = y;
	
	    // previous and next vertice nodes in a polygon ring
	    this.prev = null;
	    this.next = null;
	
	    // z-order curve value
	    this.z = null;
	
	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;
	
	    // indicates whether this is a steiner point
	    this.steiner = false;
	}
	
	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	
	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }
	
	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }
	
	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};
	
	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}
	
	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * isMobile.js v0.4.1
	 *
	 * A simple library to detect Apple phones and tablets,
	 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
	 * and any kind of seven inch device, via user agent sniffing.
	 *
	 * @author: Kai Mallea (kmallea@gmail.com)
	 *
	 * @license: http://creativecommons.org/publicdomain/zero/1.0/
	 */
	(function (global) {
	
	    var apple_phone         = /iPhone/i,
	        apple_ipod          = /iPod/i,
	        apple_tablet        = /iPad/i,
	        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
	        android_tablet      = /Android/i,
	        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
	        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
	        windows_phone       = /Windows Phone/i,
	        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
	        other_blackberry    = /BlackBerry/i,
	        other_blackberry_10 = /BB10/i,
	        other_opera         = /Opera Mini/i,
	        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
	        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
	        seven_inch = new RegExp(
	            '(?:' +         // Non-capturing group
	
	            'Nexus 7' +     // Nexus 7
	
	            '|' +           // OR
	
	            'BNTV250' +     // B&N Nook Tablet 7 inch
	
	            '|' +           // OR
	
	            'Kindle Fire' + // Kindle Fire
	
	            '|' +           // OR
	
	            'Silk' +        // Kindle Fire, Silk Accelerated
	
	            '|' +           // OR
	
	            'GT-P1000' +    // Galaxy Tab 7 inch
	
	            ')',            // End non-capturing group
	
	            'i');           // Case-insensitive matching
	
	    var match = function(regex, userAgent) {
	        return regex.test(userAgent);
	    };
	
	    var IsMobileClass = function(userAgent) {
	        var ua = userAgent || navigator.userAgent;
	
	        // Facebook mobile app's integrated browser adds a bunch of strings that
	        // match everything. Strip it out if it exists.
	        var tmp = ua.split('[FBAN');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
	        // iPhone" string. Same probable happens on other tablet platforms.
	        // This will confuse detection so strip it out if it exists.
	        tmp = ua.split('Twitter');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        this.apple = {
	            phone:  match(apple_phone, ua),
	            ipod:   match(apple_ipod, ua),
	            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
	            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
	        };
	        this.amazon = {
	            phone:  match(amazon_phone, ua),
	            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
	        };
	        this.android = {
	            phone:  match(amazon_phone, ua) || match(android_phone, ua),
	            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
	        };
	        this.windows = {
	            phone:  match(windows_phone, ua),
	            tablet: match(windows_tablet, ua),
	            device: match(windows_phone, ua) || match(windows_tablet, ua)
	        };
	        this.other = {
	            blackberry:   match(other_blackberry, ua),
	            blackberry10: match(other_blackberry_10, ua),
	            opera:        match(other_opera, ua),
	            firefox:      match(other_firefox, ua),
	            chrome:       match(other_chrome, ua),
	            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
	        };
	        this.seven_inch = match(seven_inch, ua);
	        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;
	
	        // excludes 'other' devices and ipods, targeting touchscreen phones
	        this.phone = this.apple.phone || this.android.phone || this.windows.phone;
	
	        // excludes 7 inch devices, classifying as phone or tablet is left to the user
	        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;
	
	        if (typeof window === 'undefined') {
	            return this;
	        }
	    };
	
	    var instantiate = function() {
	        var IM = new IsMobileClass();
	        IM.Class = IsMobileClass;
	        return IM;
	    };
	
	    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
	        //node
	        module.exports = IsMobileClass;
	    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
	        //browserify
	        module.exports = instantiate();
	    } else if (true) {
	        //AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        global.isMobile = instantiate();
	    }
	
	})(this);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	
	
	var mapType = function(gl, type) 
	{
	    if(!GL_TABLE) 
	    {
	        var typeNames = Object.keys(GL_TO_GLSL_TYPES);
	
	        GL_TABLE = {};
	
	        for(var i = 0; i < typeNames.length; ++i) 
	        {
	            var tn = typeNames[i];
	            GL_TABLE[ gl[tn] ] = GL_TO_GLSL_TYPES[tn];
	        }
	    }
	
	  return GL_TABLE[type];
	};
	
	var GL_TABLE = null;
	
	var GL_TO_GLSL_TYPES = {
	  'FLOAT':       'float',
	  'FLOAT_VEC2':  'vec2',
	  'FLOAT_VEC3':  'vec3',
	  'FLOAT_VEC4':  'vec4',
	
	  'INT':         'int',
	  'INT_VEC2':    'ivec2',
	  'INT_VEC3':    'ivec3',
	  'INT_VEC4':    'ivec4',
	  
	  'BOOL':        'bool',
	  'BOOL_VEC2':   'bvec2',
	  'BOOL_VEC3':   'bvec3',
	  'BOOL_VEC4':   'bvec4',
	  
	  'FLOAT_MAT2':  'mat2',
	  'FLOAT_MAT3':  'mat3',
	  'FLOAT_MAT4':  'mat4',
	  
	  'SAMPLER_2D':  'sampler2D'  
	};
	
	module.exports = mapType;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _math = __webpack_require__(7);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * 'Builder' pattern for bounds rectangles
	 * Axis-Aligned Bounding Box
	 * It is not a shape! Its mutable thing, no 'EMPTY' or that kind of problems
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Bounds = function () {
	    /**
	     *
	     */
	    function Bounds() {
	        _classCallCheck(this, Bounds);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minX = Infinity;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minY = Infinity;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxX = -Infinity;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxY = -Infinity;
	
	        this.rect = null;
	    }
	
	    /**
	     * Checks if bounds are empty.
	     *
	     * @return {boolean} True if empty.
	     */
	
	
	    Bounds.prototype.isEmpty = function isEmpty() {
	        return this.minX > this.maxX || this.minY > this.maxY;
	    };
	
	    /**
	     * Clears the bounds and resets.
	     *
	     */
	
	
	    Bounds.prototype.clear = function clear() {
	        this.updateID++;
	
	        this.minX = Infinity;
	        this.minY = Infinity;
	        this.maxX = -Infinity;
	        this.maxY = -Infinity;
	    };
	
	    /**
	     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
	     * It is not guaranteed that it will return tempRect
	     *
	     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
	     * @returns {PIXI.Rectangle} A rectangle of the bounds
	     */
	
	
	    Bounds.prototype.getRectangle = function getRectangle(rect) {
	        if (this.minX > this.maxX || this.minY > this.maxY) {
	            return _math.Rectangle.EMPTY;
	        }
	
	        rect = rect || new _math.Rectangle(0, 0, 1, 1);
	
	        rect.x = this.minX;
	        rect.y = this.minY;
	        rect.width = this.maxX - this.minX;
	        rect.height = this.maxY - this.minY;
	
	        return rect;
	    };
	
	    /**
	     * This function should be inlined when its possible.
	     *
	     * @param {PIXI.Point} point - The point to add.
	     */
	
	
	    Bounds.prototype.addPoint = function addPoint(point) {
	        this.minX = Math.min(this.minX, point.x);
	        this.maxX = Math.max(this.maxX, point.x);
	        this.minY = Math.min(this.minY, point.y);
	        this.maxY = Math.max(this.maxY, point.y);
	    };
	
	    /**
	     * Adds a quad, not transformed
	     *
	     * @param {Float32Array} vertices - The verts to add.
	     */
	
	
	    Bounds.prototype.addQuad = function addQuad(vertices) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        var x = vertices[0];
	        var y = vertices[1];
	
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = vertices[2];
	        y = vertices[3];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = vertices[4];
	        y = vertices[5];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = vertices[6];
	        y = vertices[7];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	
	    /**
	     * Adds sprite frame, transformed.
	     *
	     * @param {PIXI.TransformBase} transform - TODO
	     * @param {number} x0 - TODO
	     * @param {number} y0 - TODO
	     * @param {number} x1 - TODO
	     * @param {number} y1 - TODO
	     */
	
	
	    Bounds.prototype.addFrame = function addFrame(transform, x0, y0, x1, y1) {
	        var matrix = transform.worldTransform;
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;
	
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        var x = a * x0 + c * y0 + tx;
	        var y = b * x0 + d * y0 + ty;
	
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = a * x1 + c * y0 + tx;
	        y = b * x1 + d * y0 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = a * x0 + c * y1 + tx;
	        y = b * x0 + d * y1 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        x = a * x1 + c * y1 + tx;
	        y = b * x1 + d * y1 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	
	    /**
	     * Add an array of vertices
	     *
	     * @param {PIXI.TransformBase} transform - TODO
	     * @param {Float32Array} vertices - TODO
	     * @param {number} beginOffset - TODO
	     * @param {number} endOffset - TODO
	     */
	
	
	    Bounds.prototype.addVertices = function addVertices(transform, vertices, beginOffset, endOffset) {
	        var matrix = transform.worldTransform;
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;
	
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        for (var i = beginOffset; i < endOffset; i += 2) {
	            var rawX = vertices[i];
	            var rawY = vertices[i + 1];
	            var x = a * rawX + c * rawY + tx;
	            var y = d * rawY + b * rawX + ty;
	
	            minX = x < minX ? x : minX;
	            minY = y < minY ? y : minY;
	            maxX = x > maxX ? x : maxX;
	            maxY = y > maxY ? y : maxY;
	        }
	
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	
	    /**
	     * Adds other Bounds
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     */
	
	
	    Bounds.prototype.addBounds = function addBounds(bounds) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	
	        this.minX = bounds.minX < minX ? bounds.minX : minX;
	        this.minY = bounds.minY < minY ? bounds.minY : minY;
	        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
	        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
	    };
	
	    /**
	     * Adds other Bounds, masked with Bounds
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     * @param {PIXI.Bounds} mask - TODO
	     */
	
	
	    Bounds.prototype.addBoundsMask = function addBoundsMask(bounds, mask) {
	        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
	        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
	        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
	        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
	
	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;
	
	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };
	
	    /**
	     * Adds other Bounds, masked with Rectangle
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     * @param {PIXI.Rectangle} area - TODO
	     */
	
	
	    Bounds.prototype.addBoundsArea = function addBoundsArea(bounds, area) {
	        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
	        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
	        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
	        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
	
	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;
	
	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };
	
	    return Bounds;
	}();
	
	exports.default = Bounds;
	//# sourceMappingURL=Bounds.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _math = __webpack_require__(7);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Generic class to deal with traditional 2D matrix transforms
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TransformBase = function () {
	  /**
	   *
	   */
	  function TransformBase() {
	    _classCallCheck(this, TransformBase);
	
	    /**
	     * The global matrix transform. It can be swapped temporarily by some functions like getLocalBounds()
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.worldTransform = new _math.Matrix();
	
	    /**
	     * The local matrix transform
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.localTransform = new _math.Matrix();
	
	    this._worldID = 0;
	    this._parentID = 0;
	  }
	
	  /**
	   * TransformBase does not have decomposition, so this function wont do anything
	   */
	
	
	  TransformBase.prototype.updateLocalTransform = function updateLocalTransform() {}
	  // empty
	
	
	  /**
	   * Updates the values of the object and applies the parent's transform.
	   *
	   * @param {PIXI.TransformBase} parentTransform - The transform of the parent of this object
	   */
	  ;
	
	  TransformBase.prototype.updateTransform = function updateTransform(parentTransform) {
	    var pt = parentTransform.worldTransform;
	    var wt = this.worldTransform;
	    var lt = this.localTransform;
	
	    // concat the parent matrix with the objects transform.
	    wt.a = lt.a * pt.a + lt.b * pt.c;
	    wt.b = lt.a * pt.b + lt.b * pt.d;
	    wt.c = lt.c * pt.a + lt.d * pt.c;
	    wt.d = lt.c * pt.b + lt.d * pt.d;
	    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
	
	    this._worldID++;
	  };
	
	  return TransformBase;
	}();
	
	/**
	 * Updates the values of the object and applies the parent's transform.
	 * @param  parentTransform {PIXI.Transform} The transform of the parent of this object
	 *
	 */
	
	
	exports.default = TransformBase;
	TransformBase.prototype.updateWorldTransform = TransformBase.prototype.updateTransform;
	
	TransformBase.IDENTITY = new TransformBase();
	//# sourceMappingURL=TransformBase.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Point = __webpack_require__(61);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _const = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The PixiJS Matrix class as an object, which makes it a lot faster,
	 * here is a representation of it :
	 * | a | c | tx|
	 * | b | d | ty|
	 * | 0 | 0 | 1 |
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Matrix = function () {
	    /**
	     * @param {number} [a=1] - x scale
	     * @param {number} [b=0] - x skew
	     * @param {number} [c=0] - y skew
	     * @param {number} [d=1] - y scale
	     * @param {number} [tx=0] - x translation
	     * @param {number} [ty=0] - y translation
	     */
	    function Matrix() {
	        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	        var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	        var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	        _classCallCheck(this, Matrix);
	
	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.a = a;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.b = b;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.c = c;
	
	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.d = d;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.tx = tx;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.ty = ty;
	
	        this.array = null;
	    }
	
	    /**
	     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
	     *
	     * a = array[0]
	     * b = array[1]
	     * c = array[3]
	     * d = array[4]
	     * tx = array[2]
	     * ty = array[5]
	     *
	     * @param {number[]} array - The array that the matrix will be populated from.
	     */
	
	
	    Matrix.prototype.fromArray = function fromArray(array) {
	        this.a = array[0];
	        this.b = array[1];
	        this.c = array[3];
	        this.d = array[4];
	        this.tx = array[2];
	        this.ty = array[5];
	    };
	
	    /**
	     * sets the matrix properties
	     *
	     * @param {number} a - Matrix component
	     * @param {number} b - Matrix component
	     * @param {number} c - Matrix component
	     * @param {number} d - Matrix component
	     * @param {number} tx - Matrix component
	     * @param {number} ty - Matrix component
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.set = function set(a, b, c, d, tx, ty) {
	        this.a = a;
	        this.b = b;
	        this.c = c;
	        this.d = d;
	        this.tx = tx;
	        this.ty = ty;
	
	        return this;
	    };
	
	    /**
	     * Creates an array from the current Matrix object.
	     *
	     * @param {boolean} transpose - Whether we need to transpose the matrix or not
	     * @param {Float32Array} [out=new Float32Array(9)] - If provided the array will be assigned to out
	     * @return {number[]} the newly created array which contains the matrix
	     */
	
	
	    Matrix.prototype.toArray = function toArray(transpose, out) {
	        if (!this.array) {
	            this.array = new Float32Array(9);
	        }
	
	        var array = out || this.array;
	
	        if (transpose) {
	            array[0] = this.a;
	            array[1] = this.b;
	            array[2] = 0;
	            array[3] = this.c;
	            array[4] = this.d;
	            array[5] = 0;
	            array[6] = this.tx;
	            array[7] = this.ty;
	            array[8] = 1;
	        } else {
	            array[0] = this.a;
	            array[1] = this.c;
	            array[2] = this.tx;
	            array[3] = this.b;
	            array[4] = this.d;
	            array[5] = this.ty;
	            array[6] = 0;
	            array[7] = 0;
	            array[8] = 1;
	        }
	
	        return array;
	    };
	
	    /**
	     * Get a new position with the current transformation applied.
	     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
	     *
	     * @param {PIXI.Point} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, transformed through this matrix
	     */
	
	
	    Matrix.prototype.apply = function apply(pos, newPos) {
	        newPos = newPos || new _Point2.default();
	
	        var x = pos.x;
	        var y = pos.y;
	
	        newPos.x = this.a * x + this.c * y + this.tx;
	        newPos.y = this.b * x + this.d * y + this.ty;
	
	        return newPos;
	    };
	
	    /**
	     * Get a new position with the inverse of the current transformation applied.
	     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
	     *
	     * @param {PIXI.Point} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
	     */
	
	
	    Matrix.prototype.applyInverse = function applyInverse(pos, newPos) {
	        newPos = newPos || new _Point2.default();
	
	        var id = 1 / (this.a * this.d + this.c * -this.b);
	
	        var x = pos.x;
	        var y = pos.y;
	
	        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
	        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
	
	        return newPos;
	    };
	
	    /**
	     * Translates the matrix on the x and y.
	     *
	     * @param {number} x How much to translate x by
	     * @param {number} y How much to translate y by
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.translate = function translate(x, y) {
	        this.tx += x;
	        this.ty += y;
	
	        return this;
	    };
	
	    /**
	     * Applies a scale transformation to the matrix.
	     *
	     * @param {number} x The amount to scale horizontally
	     * @param {number} y The amount to scale vertically
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.scale = function scale(x, y) {
	        this.a *= x;
	        this.d *= y;
	        this.c *= x;
	        this.b *= y;
	        this.tx *= x;
	        this.ty *= y;
	
	        return this;
	    };
	
	    /**
	     * Applies a rotation transformation to the matrix.
	     *
	     * @param {number} angle - The angle in radians.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.rotate = function rotate(angle) {
	        var cos = Math.cos(angle);
	        var sin = Math.sin(angle);
	
	        var a1 = this.a;
	        var c1 = this.c;
	        var tx1 = this.tx;
	
	        this.a = a1 * cos - this.b * sin;
	        this.b = a1 * sin + this.b * cos;
	        this.c = c1 * cos - this.d * sin;
	        this.d = c1 * sin + this.d * cos;
	        this.tx = tx1 * cos - this.ty * sin;
	        this.ty = tx1 * sin + this.ty * cos;
	
	        return this;
	    };
	
	    /**
	     * Appends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to append.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.append = function append(matrix) {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;
	
	        this.a = matrix.a * a1 + matrix.b * c1;
	        this.b = matrix.a * b1 + matrix.b * d1;
	        this.c = matrix.c * a1 + matrix.d * c1;
	        this.d = matrix.c * b1 + matrix.d * d1;
	
	        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
	        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
	
	        return this;
	    };
	
	    /**
	     * Sets the matrix based on all the available properties
	     *
	     * @param {number} x - Position on the x axis
	     * @param {number} y - Position on the y axis
	     * @param {number} pivotX - Pivot on the x axis
	     * @param {number} pivotY - Pivot on the y axis
	     * @param {number} scaleX - Scale on the x axis
	     * @param {number} scaleY - Scale on the y axis
	     * @param {number} rotation - Rotation in radians
	     * @param {number} skewX - Skew on the x axis
	     * @param {number} skewY - Skew on the y axis
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.setTransform = function setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
	        this.a = Math.cos(rotation + skewY) * scaleX;
	        this.b = Math.sin(rotation + skewY) * scaleX;
	        this.c = -Math.sin(rotation - skewX) * scaleY;
	        this.d = Math.cos(rotation - skewX) * scaleY;
	
	        this.tx = x - (pivotX * this.a + pivotY * this.c);
	        this.ty = y - (pivotX * this.b + pivotY * this.d);
	
	        return this;
	    };
	
	    /**
	     * Prepends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to prepend
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.prepend = function prepend(matrix) {
	        var tx1 = this.tx;
	
	        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
	            var a1 = this.a;
	            var c1 = this.c;
	
	            this.a = a1 * matrix.a + this.b * matrix.c;
	            this.b = a1 * matrix.b + this.b * matrix.d;
	            this.c = c1 * matrix.a + this.d * matrix.c;
	            this.d = c1 * matrix.b + this.d * matrix.d;
	        }
	
	        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
	        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
	
	        return this;
	    };
	
	    /**
	     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
	     *
	     * @param {PIXI.Transform|PIXI.TransformStatic} transform - The transform to apply the properties to.
	     * @return {PIXI.Transform|PIXI.TransformStatic} The transform with the newly applied properties
	     */
	
	
	    Matrix.prototype.decompose = function decompose(transform) {
	        // sort out rotation / skew..
	        var a = this.a;
	        var b = this.b;
	        var c = this.c;
	        var d = this.d;
	
	        var skewX = -Math.atan2(-c, d);
	        var skewY = Math.atan2(b, a);
	
	        var delta = Math.abs(skewX + skewY);
	
	        if (delta < 0.00001 || Math.abs(_const.PI_2 - delta) < 0.00001) {
	            transform.rotation = skewY;
	
	            if (a < 0 && d >= 0) {
	                transform.rotation += transform.rotation <= 0 ? Math.PI : -Math.PI;
	            }
	
	            transform.skew.x = transform.skew.y = 0;
	        } else {
	            transform.rotation = 0;
	            transform.skew.x = skewX;
	            transform.skew.y = skewY;
	        }
	
	        // next set scale
	        transform.scale.x = Math.sqrt(a * a + b * b);
	        transform.scale.y = Math.sqrt(c * c + d * d);
	
	        // next set position
	        transform.position.x = this.tx;
	        transform.position.y = this.ty;
	
	        return transform;
	    };
	
	    /**
	     * Inverts this matrix
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.invert = function invert() {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;
	        var tx1 = this.tx;
	        var n = a1 * d1 - b1 * c1;
	
	        this.a = d1 / n;
	        this.b = -b1 / n;
	        this.c = -c1 / n;
	        this.d = a1 / n;
	        this.tx = (c1 * this.ty - d1 * tx1) / n;
	        this.ty = -(a1 * this.ty - b1 * tx1) / n;
	
	        return this;
	    };
	
	    /**
	     * Resets this Matix to an identity (default) matrix.
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.identity = function identity() {
	        this.a = 1;
	        this.b = 0;
	        this.c = 0;
	        this.d = 1;
	        this.tx = 0;
	        this.ty = 0;
	
	        return this;
	    };
	
	    /**
	     * Creates a new Matrix object with the same values as this one.
	     *
	     * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
	     */
	
	
	    Matrix.prototype.clone = function clone() {
	        var matrix = new Matrix();
	
	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;
	
	        return matrix;
	    };
	
	    /**
	     * Changes the values of the given matrix to be the same as the ones in this matrix
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to copy from.
	     * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
	     */
	
	
	    Matrix.prototype.copy = function copy(matrix) {
	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;
	
	        return matrix;
	    };
	
	    /**
	     * A default (identity) matrix
	     *
	     * @static
	     * @const
	     */
	
	
	    _createClass(Matrix, null, [{
	        key: 'IDENTITY',
	        get: function get() {
	            return new Matrix();
	        }
	
	        /**
	         * A temp matrix
	         *
	         * @static
	         * @const
	         */
	
	    }, {
	        key: 'TEMP_MATRIX',
	        get: function get() {
	            return new Matrix();
	        }
	    }]);
	
	    return Matrix;
	}();
	
	exports.default = Matrix;
	//# sourceMappingURL=Matrix.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Point = function () {
	  /**
	   * @param {number} [x=0] - position of the point on the x axis
	   * @param {number} [y=0] - position of the point on the y axis
	   */
	  function Point() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    _classCallCheck(this, Point);
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;
	  }
	
	  /**
	   * Creates a clone of this point
	   *
	   * @return {PIXI.Point} a copy of the point
	   */
	
	
	  Point.prototype.clone = function clone() {
	    return new Point(this.x, this.y);
	  };
	
	  /**
	   * Copies x and y from the given point
	   *
	   * @param {PIXI.Point} p - The point to copy.
	   */
	
	
	  Point.prototype.copy = function copy(p) {
	    this.set(p.x, p.y);
	  };
	
	  /**
	   * Returns true if the given point is equal to this point
	   *
	   * @param {PIXI.Point} p - The point to check
	   * @returns {boolean} Whether the given point equal to this point
	   */
	
	
	  Point.prototype.equals = function equals(p) {
	    return p.x === this.x && p.y === this.y;
	  };
	
	  /**
	   * Sets the point to a new x and y position.
	   * If y is omitted, both x and y will be set to x.
	   *
	   * @param {number} [x=0] - position of the point on the x axis
	   * @param {number} [y=0] - position of the point on the y axis
	   */
	
	
	  Point.prototype.set = function set(x, y) {
	    this.x = x || 0;
	    this.y = y || (y !== 0 ? this.x : 0);
	  };
	
	  return Point;
	}();
	
	exports.default = Point;
	//# sourceMappingURL=Point.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _const = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Rectangle object is an area defined by its position, as indicated by its top-left corner
	 * point (x, y) and by its width and its height.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Rectangle = function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rectangle
	     * @param {number} [width=0] - The overall width of this rectangle
	     * @param {number} [height=0] - The overall height of this rectangle
	     */
	    function Rectangle() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	        _classCallCheck(this, Rectangle);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = Number(x);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = Number(y);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = Number(width);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = Number(height);
	
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.RECT
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.RECT;
	    }
	
	    /**
	     * returns the left edge of the rectangle
	     *
	     * @member {number}
	     */
	
	
	    /**
	     * Creates a clone of this Rectangle
	     *
	     * @return {PIXI.Rectangle} a copy of the rectangle
	     */
	    Rectangle.prototype.clone = function clone() {
	        return new Rectangle(this.x, this.y, this.width, this.height);
	    };
	
	    /**
	     * Copies another rectangle to this one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to copy.
	     * @return {PIXI.Rectangle} Returns itself.
	     */
	
	
	    Rectangle.prototype.copy = function copy(rectangle) {
	        this.x = rectangle.x;
	        this.y = rectangle.y;
	        this.width = rectangle.width;
	        this.height = rectangle.height;
	
	        return this;
	    };
	
	    /**
	     * Checks whether the x and y coordinates given are contained within this Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rectangle
	     */
	
	
	    Rectangle.prototype.contains = function contains(x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	
	        if (x >= this.x && x < this.x + this.width) {
	            if (y >= this.y && y < this.y + this.height) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Pads the rectangle making it grow in all directions.
	     *
	     * @param {number} paddingX - The horizontal padding amount.
	     * @param {number} [paddingY] - The vertical padding amount.
	     */
	
	
	    Rectangle.prototype.pad = function pad(paddingX, paddingY) {
	        paddingX = paddingX || 0;
	        paddingY = paddingY || (paddingY !== 0 ? paddingX : 0);
	
	        this.x -= paddingX;
	        this.y -= paddingY;
	
	        this.width += paddingX * 2;
	        this.height += paddingY * 2;
	    };
	
	    /**
	     * Fits this rectangle around the passed one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to fit.
	     */
	
	
	    Rectangle.prototype.fit = function fit(rectangle) {
	        if (this.x < rectangle.x) {
	            this.width += this.x;
	            if (this.width < 0) {
	                this.width = 0;
	            }
	
	            this.x = rectangle.x;
	        }
	
	        if (this.y < rectangle.y) {
	            this.height += this.y;
	            if (this.height < 0) {
	                this.height = 0;
	            }
	            this.y = rectangle.y;
	        }
	
	        if (this.x + this.width > rectangle.x + rectangle.width) {
	            this.width = rectangle.width - this.x;
	            if (this.width < 0) {
	                this.width = 0;
	            }
	        }
	
	        if (this.y + this.height > rectangle.y + rectangle.height) {
	            this.height = rectangle.height - this.y;
	            if (this.height < 0) {
	                this.height = 0;
	            }
	        }
	    };
	
	    /**
	     * Enlarges this rectangle to include the passed rectangle.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to include.
	     */
	
	
	    Rectangle.prototype.enlarge = function enlarge(rectangle) {
	        var x1 = Math.min(this.x, rectangle.x);
	        var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
	        var y1 = Math.min(this.y, rectangle.y);
	        var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
	
	        this.x = x1;
	        this.width = x2 - x1;
	        this.y = y1;
	        this.height = y2 - y1;
	    };
	
	    _createClass(Rectangle, [{
	        key: 'left',
	        get: function get() {
	            return this.x;
	        }
	
	        /**
	         * returns the right edge of the rectangle
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'right',
	        get: function get() {
	            return this.x + this.width;
	        }
	
	        /**
	         * returns the top edge of the rectangle
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'top',
	        get: function get() {
	            return this.y;
	        }
	
	        /**
	         * returns the bottom edge of the rectangle
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'bottom',
	        get: function get() {
	            return this.y + this.height;
	        }
	
	        /**
	         * A constant empty rectangle.
	         *
	         * @static
	         * @constant
	         */
	
	    }], [{
	        key: 'EMPTY',
	        get: function get() {
	            return new Rectangle(0, 0, 0, 0);
	        }
	    }]);
	
	    return Rectangle;
	}();
	
	exports.default = Rectangle;
	//# sourceMappingURL=Rectangle.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _math = __webpack_require__(7);
	
	var _utils = __webpack_require__(5);
	
	var _const = __webpack_require__(3);
	
	var _Texture = __webpack_require__(17);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _Container2 = __webpack_require__(27);
	
	var _Container3 = _interopRequireDefault(_Container2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempPoint = new _math.Point();
	
	/**
	 * The Sprite object is the base for all textured objects that are rendered to the screen
	 *
	 * A sprite can be created directly from an image like this:
	 *
	 * ```js
	 * let sprite = new PIXI.Sprite.fromImage('assets/image.png');
	 * ```
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	
	var Sprite = function (_Container) {
	    _inherits(Sprite, _Container);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture for this sprite
	     */
	    function Sprite(texture) {
	        _classCallCheck(this, Sprite);
	
	        /**
	         * The anchor sets the origin point of the texture.
	         * The default is 0,0 this means the texture's origin is the top left
	         * Setting the anchor to 0.5,0.5 means the texture's origin is centered
	         * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner
	         *
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _Container.call(this));
	
	        _this._anchor = new _math.ObservablePoint(_this._onAnchorUpdate, _this);
	
	        /**
	         * The texture that the sprite is using
	         *
	         * @private
	         * @member {PIXI.Texture}
	         */
	        _this._texture = null;
	
	        /**
	         * The width of the sprite (this is initially set by the texture)
	         *
	         * @private
	         * @member {number}
	         */
	        _this._width = 0;
	
	        /**
	         * The height of the sprite (this is initially set by the texture)
	         *
	         * @private
	         * @member {number}
	         */
	        _this._height = 0;
	
	        /**
	         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = null;
	        _this._tintRGB = null;
	        _this.tint = 0xFFFFFF;
	
	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = _const.BLEND_MODES.NORMAL;
	
	        /**
	         * The shader that will be used to render the sprite. Set to null to remove a current shader.
	         *
	         * @member {PIXI.Filter|PIXI.Shader}
	         */
	        _this.shader = null;
	
	        /**
	         * An internal cached value of the tint.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this.cachedTint = 0xFFFFFF;
	
	        // call texture setter
	        _this.texture = texture || _Texture2.default.EMPTY;
	
	        /**
	         * this is used to store the vertex data of the sprite (basically a quad)
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexData = new Float32Array(8);
	
	        /**
	         * This is used to calculate the bounds of the object IF it is a trimmed sprite
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexTrimmedData = null;
	
	        _this._transformID = -1;
	        _this._textureID = -1;
	
	        _this._transformTrimmedID = -1;
	        _this._textureTrimmedID = -1;
	
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
	         *
	         * @member {string}
	         * @default 'sprite'
	         */
	        _this.pluginName = 'sprite';
	        return _this;
	    }
	
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @private
	     */
	
	
	    Sprite.prototype._onTextureUpdate = function _onTextureUpdate() {
	        this._textureID = -1;
	        this._textureTrimmedID = -1;
	        this.cachedTint = 0xFFFFFF;
	
	        // so if _width is 0 then width was not set..
	        if (this._width) {
	            this.scale.x = (0, _utils.sign)(this.scale.x) * this._width / this._texture.orig.width;
	        }
	
	        if (this._height) {
	            this.scale.y = (0, _utils.sign)(this.scale.y) * this._height / this._texture.orig.height;
	        }
	    };
	
	    /**
	     * Called when the anchor position updates.
	     *
	     * @private
	     */
	
	
	    Sprite.prototype._onAnchorUpdate = function _onAnchorUpdate() {
	        this._transformID = -1;
	        this._transformTrimmedID = -1;
	    };
	
	    /**
	     * calculates worldTransform * vertices, store it in vertexData
	     */
	
	
	    Sprite.prototype.calculateVertices = function calculateVertices() {
	        if (this._transformID === this.transform._worldID && this._textureID === this._texture._updateID) {
	            return;
	        }
	
	        this._transformID = this.transform._worldID;
	        this._textureID = this._texture._updateID;
	
	        // set the vertex data
	
	        var texture = this._texture;
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	        var vertexData = this.vertexData;
	        var trim = texture.trim;
	        var orig = texture.orig;
	        var anchor = this._anchor;
	
	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;
	
	        if (trim) {
	            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
	            // space before transforming the sprite coords.
	            w1 = trim.x - anchor._x * orig.width;
	            w0 = w1 + trim.width;
	
	            h1 = trim.y - anchor._y * orig.height;
	            h0 = h1 + trim.height;
	        } else {
	            w1 = -anchor._x * orig.width;
	            w0 = w1 + orig.width;
	
	            h1 = -anchor._y * orig.height;
	            h0 = h1 + orig.height;
	        }
	
	        // xy
	        vertexData[0] = a * w1 + c * h1 + tx;
	        vertexData[1] = d * h1 + b * w1 + ty;
	
	        // xy
	        vertexData[2] = a * w0 + c * h1 + tx;
	        vertexData[3] = d * h1 + b * w0 + ty;
	
	        // xy
	        vertexData[4] = a * w0 + c * h0 + tx;
	        vertexData[5] = d * h0 + b * w0 + ty;
	
	        // xy
	        vertexData[6] = a * w1 + c * h0 + tx;
	        vertexData[7] = d * h0 + b * w1 + ty;
	    };
	
	    /**
	     * calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData
	     * This is used to ensure that the true width and height of a trimmed texture is respected
	     */
	
	
	    Sprite.prototype.calculateTrimmedVertices = function calculateTrimmedVertices() {
	        if (!this.vertexTrimmedData) {
	            this.vertexTrimmedData = new Float32Array(8);
	        } else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) {
	            return;
	        }
	
	        this._transformTrimmedID = this.transform._worldID;
	        this._textureTrimmedID = this._texture._updateID;
	
	        // lets do some special trim code!
	        var texture = this._texture;
	        var vertexData = this.vertexTrimmedData;
	        var orig = texture.orig;
	        var anchor = this._anchor;
	
	        // lets calculate the new untrimmed bounds..
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	
	        var w1 = -anchor._x * orig.width;
	        var w0 = w1 + orig.width;
	
	        var h1 = -anchor._y * orig.height;
	        var h0 = h1 + orig.height;
	
	        // xy
	        vertexData[0] = a * w1 + c * h1 + tx;
	        vertexData[1] = d * h1 + b * w1 + ty;
	
	        // xy
	        vertexData[2] = a * w0 + c * h1 + tx;
	        vertexData[3] = d * h1 + b * w0 + ty;
	
	        // xy
	        vertexData[4] = a * w0 + c * h0 + tx;
	        vertexData[5] = d * h0 + b * w0 + ty;
	
	        // xy
	        vertexData[6] = a * w1 + c * h0 + tx;
	        vertexData[7] = d * h0 + b * w1 + ty;
	    };
	
	    /**
	    *
	    * Renders the object using the WebGL renderer
	    *
	    * @private
	    * @param {PIXI.WebGLRenderer} renderer - The webgl renderer to use.
	    */
	
	
	    Sprite.prototype._renderWebGL = function _renderWebGL(renderer) {
	        this.calculateVertices();
	
	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	    * Renders the object using the Canvas renderer
	    *
	    * @private
	    * @param {PIXI.CanvasRenderer} renderer - The renderer
	    */
	
	
	    Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * Updates the bounds of the sprite.
	     *
	     * @private
	     */
	
	
	    Sprite.prototype._calculateBounds = function _calculateBounds() {
	        var trim = this._texture.trim;
	        var orig = this._texture.orig;
	
	        // First lets check to see if the current texture has a trim..
	        if (!trim || trim.width === orig.width && trim.height === orig.height) {
	            // no trim! lets use the usual calculations..
	            this.calculateVertices();
	            this._bounds.addQuad(this.vertexData);
	        } else {
	            // lets calculate a special trimmed bounds...
	            this.calculateTrimmedVertices();
	            this._bounds.addQuad(this.vertexTrimmedData);
	        }
	    };
	
	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */
	
	
	    Sprite.prototype.getLocalBounds = function getLocalBounds(rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._texture.orig.width * -this._anchor._x;
	            this._bounds.minY = this._texture.orig.height * -this._anchor._y;
	            this._bounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
	            this._bounds.maxY = this._texture.orig.height * (1 - this._anchor._y);
	
	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new _math.Rectangle();
	                }
	
	                rect = this._localBoundsRect;
	            }
	
	            return this._bounds.getRectangle(rect);
	        }
	
	        return _Container.prototype.getLocalBounds.call(this, rect);
	    };
	
	    /**
	     * Tests if a point is inside this sprite
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */
	
	
	    Sprite.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var width = this._texture.orig.width;
	        var height = this._texture.orig.height;
	        var x1 = -width * this.anchor.x;
	        var y1 = 0;
	
	        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
	            y1 = -height * this.anchor.y;
	
	            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    Sprite.prototype.destroy = function destroy(options) {
	        _Container.prototype.destroy.call(this, options);
	
	        this._anchor = null;
	
	        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;
	
	        if (destroyTexture) {
	            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;
	
	            this._texture.destroy(!!destroyBaseTexture);
	        }
	
	        this._texture = null;
	        this.shader = null;
	    };
	
	    // some helper functions..
	
	    /**
	     * Helper function that creates a new sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source Source to create texture from
	     * @return {PIXI.Sprite} The newly created sprite
	     */
	
	
	    Sprite.from = function from(source) {
	        return new Sprite(_Texture2.default.from(source));
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the frameId
	     */
	
	
	    Sprite.fromFrame = function fromFrame(frameId) {
	        var texture = _utils.TextureCache[frameId];
	
	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	        }
	
	        return new Sprite(texture);
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture based on an image url
	     * If the image is not in the texture cache it will be loaded
	     *
	     * @static
	     * @param {string} imageId - The image url of the texture
	     * @param {boolean} [crossorigin=(auto)] - if you want to specify the cross-origin parameter
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
	     *  see {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the image id
	     */
	
	
	    Sprite.fromImage = function fromImage(imageId, crossorigin, scaleMode) {
	        return new Sprite(_Texture2.default.fromImage(imageId, crossorigin, scaleMode));
	    };
	
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(Sprite, [{
	        key: 'width',
	        get: function get() {
	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var s = (0, _utils.sign)(this.scale.x) || 1;
	
	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        }
	
	        /**
	         * The height of the sprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var s = (0, _utils.sign)(this.scale.y) || 1;
	
	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        }
	
	        /**
	         * The anchor sets the origin point of the texture.
	         * The default is 0,0 this means the texture's origin is the top left
	         * Setting the anchor to 0.5,0.5 means the texture's origin is centered
	         * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'anchor',
	        get: function get() {
	            return this._anchor;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._anchor.copy(value);
	        }
	
	        /**
	         * The tint applied to the sprite. This is a hex value.
	         * A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	
	    }, {
	        key: 'tint',
	        get: function get() {
	            return this._tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._tint = value;
	            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
	        }
	
	        /**
	         * The texture that the sprite is using
	         *
	         * @member {PIXI.Texture}
	         */
	
	    }, {
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._texture === value) {
	                return;
	            }
	
	            this._texture = value;
	            this.cachedTint = 0xFFFFFF;
	
	            this._textureID = -1;
	            this._textureTrimmedID = -1;
	
	            if (value) {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded) {
	                    this._onTextureUpdate();
	                } else {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }
	    }]);
	
	    return Sprite;
	}(_Container3.default);
	
	exports.default = Sprite;
	//# sourceMappingURL=Sprite.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(5);
	
	var _canUseNewCanvasBlendModes = __webpack_require__(111);
	
	var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Utility methods for Sprite/Texture tinting.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasTinter = {
	    /**
	     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Sprite} sprite - the sprite to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @return {HTMLCanvasElement} The tinted canvas
	     */
	    getTintedTexture: function getTintedTexture(sprite, color) {
	        var texture = sprite._texture;
	
	        color = CanvasTinter.roundColor(color);
	
	        var stringColor = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
	
	        texture.tintCache = texture.tintCache || {};
	
	        var cachedTexture = texture.tintCache[stringColor];
	
	        var canvas = void 0;
	
	        if (cachedTexture) {
	            if (cachedTexture.tintId === texture._updateID) {
	                return texture.tintCache[stringColor];
	            }
	
	            canvas = texture.tintCache[stringColor];
	        } else {
	            canvas = CanvasTinter.canvas || document.createElement('canvas');
	        }
	
	        CanvasTinter.tintMethod(texture, color, canvas);
	
	        canvas.tintId = texture._updateID;
	
	        if (CanvasTinter.convertTintToImage) {
	            // is this better?
	            var tintImage = new Image();
	
	            tintImage.src = canvas.toDataURL();
	
	            texture.tintCache[stringColor] = tintImage;
	        } else {
	            texture.tintCache[stringColor] = canvas;
	            // if we are not converting the texture to an image then we need to lose the reference to the canvas
	            CanvasTinter.canvas = null;
	        }
	
	        return canvas;
	    },
	
	    /**
	     * Tint a texture using the 'multiply' operation.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithMultiply: function tintWithMultiply(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	
	        context.save();
	        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
	
	        context.fillRect(0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = 'multiply';
	
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = 'destination-atop';
	
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();
	    },
	
	    /**
	     * Tint a texture using the 'overlay' operation.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithOverlay: function tintWithOverlay(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	
	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
	        context.fillRect(0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = 'destination-atop';
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	
	        // context.globalCompositeOperation = 'copy';
	        context.restore();
	    },
	
	
	    /**
	     * Tint a texture pixel per pixel.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithPerPixel: function tintWithPerPixel(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	
	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();
	
	        var rgbValues = (0, _utils.hex2rgb)(color);
	        var r = rgbValues[0];
	        var g = rgbValues[1];
	        var b = rgbValues[2];
	
	        var pixelData = context.getImageData(0, 0, crop.width, crop.height);
	
	        var pixels = pixelData.data;
	
	        for (var i = 0; i < pixels.length; i += 4) {
	            pixels[i + 0] *= r;
	            pixels[i + 1] *= g;
	            pixels[i + 2] *= b;
	        }
	
	        context.putImageData(pixelData, 0, 0);
	    },
	
	    /**
	     * Rounds the specified color according to the CanvasTinter.cacheStepsPerColorChannel.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {number} color - the color to round, should be a hex color
	     * @return {number} The rounded color.
	     */
	    roundColor: function roundColor(color) {
	        var step = CanvasTinter.cacheStepsPerColorChannel;
	
	        var rgbValues = (0, _utils.hex2rgb)(color);
	
	        rgbValues[0] = Math.min(255, rgbValues[0] / step * step);
	        rgbValues[1] = Math.min(255, rgbValues[1] / step * step);
	        rgbValues[2] = Math.min(255, rgbValues[2] / step * step);
	
	        return (0, _utils.rgb2hex)(rgbValues);
	    },
	
	    /**
	     * Number of steps which will be used as a cap when rounding colors.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {number}
	     */
	    cacheStepsPerColorChannel: 8,
	
	    /**
	     * Tint cache boolean flag.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {boolean}
	     */
	    convertTintToImage: false,
	
	    /**
	     * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {boolean}
	     */
	    canUseMultiply: (0, _canUseNewCanvasBlendModes2.default)(),
	
	    /**
	     * The tinting method that will be used.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {tintMethodFunctionType}
	     */
	    tintMethod: 0
	};
	
	CanvasTinter.tintMethod = CanvasTinter.canUseMultiply ? CanvasTinter.tintWithMultiply : CanvasTinter.tintWithPerPixel;
	
	/**
	 * The tintMethod type.
	 *
	 * @memberof PIXI.CanvasTinter
	 * @callback tintMethodFunctionType
	 * @param texture {PIXI.Texture} the texture to tint
	 * @param color {number} the color to use to tint the sprite with
	 * @param canvas {HTMLCanvasElement} the current canvas
	 */
	
	exports.default = CanvasTinter;
	//# sourceMappingURL=CanvasTinter.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BaseRenderTexture = __webpack_require__(117);
	
	var _BaseRenderTexture2 = _interopRequireDefault(_BaseRenderTexture);
	
	var _Texture2 = __webpack_require__(17);
	
	var _Texture3 = _interopRequireDefault(_Texture2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
	 * let renderTexture = PIXI.RenderTexture.create(800, 600);
	 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * renderer.render(sprite, renderTexture);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let renderTexture = new PIXI.RenderTexture.create(100, 100);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.Texture
	 * @memberof PIXI
	 */
	var RenderTexture = function (_Texture) {
	    _inherits(RenderTexture, _Texture);
	
	    /**
	     * @param {PIXI.BaseRenderTexture} baseRenderTexture - The renderer used for this RenderTexture
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     */
	    function RenderTexture(baseRenderTexture, frame) {
	        _classCallCheck(this, RenderTexture);
	
	        // support for legacy..
	        var _legacyRenderer = null;
	
	        if (!(baseRenderTexture instanceof _BaseRenderTexture2.default)) {
	            /* eslint-disable prefer-rest-params, no-console */
	            var width = arguments[1];
	            var height = arguments[2];
	            var scaleMode = arguments[3];
	            var resolution = arguments[4];
	
	            // we have an old render texture..
	            console.warn('Please use RenderTexture.create(' + width + ', ' + height + ') instead of the ctor directly.');
	            _legacyRenderer = arguments[0];
	            /* eslint-enable prefer-rest-params, no-console */
	
	            frame = null;
	            baseRenderTexture = new _BaseRenderTexture2.default(width, height, scaleMode, resolution);
	        }
	
	        /**
	         * The base texture object that this texture uses
	         *
	         * @member {BaseTexture}
	         */
	
	        var _this = _possibleConstructorReturn(this, _Texture.call(this, baseRenderTexture, frame));
	
	        _this.legacyRenderer = _legacyRenderer;
	
	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = true;
	
	        _this._updateUvs();
	        return _this;
	    }
	
	    /**
	     * Resizes the RenderTexture.
	     *
	     * @param {number} width - The width to resize to.
	     * @param {number} height - The height to resize to.
	     * @param {boolean} doNotResizeBaseTexture - Should the baseTexture.width and height values be resized as well?
	     */
	
	
	    RenderTexture.prototype.resize = function resize(width, height, doNotResizeBaseTexture) {
	        width = Math.ceil(width);
	        height = Math.ceil(height);
	
	        // TODO - could be not required..
	        this.valid = width > 0 && height > 0;
	
	        this._frame.width = this.orig.width = width;
	        this._frame.height = this.orig.height = height;
	
	        if (!doNotResizeBaseTexture) {
	            this.baseTexture.resize(width, height);
	        }
	
	        this._updateUvs();
	    };
	
	    /**
	     * A short hand way of creating a render texture.
	     *
	     * @param {number} [width=100] - The width of the render texture
	     * @param {number} [height=100] - The height of the render texture
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
	     * @return {PIXI.RenderTexture} The new render texture
	     */
	
	
	    RenderTexture.create = function create(width, height, scaleMode, resolution) {
	        return new RenderTexture(new _BaseRenderTexture2.default(width, height, scaleMode, resolution));
	    };
	
	    return RenderTexture;
	}(_Texture3.default);
	
	exports.default = RenderTexture;
	//# sourceMappingURL=RenderTexture.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Ticker = exports.shared = undefined;
	
	var _Ticker = __webpack_require__(236);
	
	var _Ticker2 = _interopRequireDefault(_Ticker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The shared ticker instance used by {@link PIXI.extras.AnimatedSprite}.
	 * and by {@link PIXI.interaction.InteractionManager}.
	 * The property {@link PIXI.ticker.Ticker#autoStart} is set to `true`
	 * for this instance. Please follow the examples for usage, including
	 * how to opt-out of auto-starting the shared ticker.
	 *
	 * @example
	 * let ticker = PIXI.ticker.shared;
	 * // Set this to prevent starting this ticker when listeners are added.
	 * // By default this is true only for the PIXI.ticker.shared instance.
	 * ticker.autoStart = false;
	 * // FYI, call this to ensure the ticker is stopped. It should be stopped
	 * // if you have not attempted to render anything yet.
	 * ticker.stop();
	 * // Call this when you are ready for a running shared ticker.
	 * ticker.start();
	 *
	 * @example
	 * // You may use the shared ticker to render...
	 * let renderer = PIXI.autoDetectRenderer(800, 600);
	 * let stage = new PIXI.Container();
	 * let interactionManager = PIXI.interaction.InteractionManager(renderer);
	 * document.body.appendChild(renderer.view);
	 * ticker.add(function (time) {
	 *     renderer.render(stage);
	 * });
	 *
	 * @example
	 * // Or you can just update it manually.
	 * ticker.autoStart = false;
	 * ticker.stop();
	 * function animate(time) {
	 *     ticker.update(time);
	 *     renderer.render(stage);
	 *     requestAnimationFrame(animate);
	 * }
	 * animate(performance.now());
	 *
	 * @type {PIXI.ticker.Ticker}
	 * @memberof PIXI.ticker
	 */
	var shared = new _Ticker2.default();
	
	shared.autoStart = true;
	shared.destroy = function () {
	  // protect destroying shared ticker
	  // this is used by other internal systems
	  // like AnimatedSprite and InteractionManager
	};
	
	/**
	 * This namespace contains an API for interacting with PIXI's internal global update loop.
	 *
	 * This ticker is used for rendering, {@link PIXI.extras.AnimatedSprite AnimatedSprite},
	 * {@link PIXI.interaction.InteractionManager InteractionManager} and many other time-based PIXI systems.
	 * @example
	 * const ticker = new PIXI.ticker.Ticker();
	 * ticker.stop();
	 * ticker.add((deltaTime) => {
	 *   // do something every frame
	 * });
	 * ticker.start();
	 * @namespace PIXI.ticker
	 */
	exports.shared = shared;
	exports.Ticker = _Ticker2.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = createIndicesForQuads;
	/**
	 * Generic Mask Stack data structure
	 *
	 * @memberof PIXI
	 * @function createIndicesForQuads
	 * @private
	 * @param {number} size - Number of quads
	 * @return {Uint16Array} indices
	 */
	function createIndicesForQuads(size) {
	    // the total number of indices in our array, there are 6 points per quad.
	
	    var totalIndices = size * 6;
	
	    var indices = new Uint16Array(totalIndices);
	
	    // fill the indices with the quads to draw
	    for (var i = 0, j = 0; i < totalIndices; i += 6, j += 4) {
	        indices[i + 0] = j + 0;
	        indices[i + 1] = j + 1;
	        indices[i + 2] = j + 2;
	        indices[i + 3] = j + 0;
	        indices[i + 4] = j + 2;
	        indices[i + 5] = j + 3;
	    }
	
	    return indices;
	}
	//# sourceMappingURL=createIndicesForQuads.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _CountLimiter = __webpack_require__(136);
	
	var _CountLimiter2 = _interopRequireDefault(_CountLimiter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SharedTicker = core.ticker.shared;
	
	/**
	 * Default number of uploads per frame using prepare plugin.
	 *
	 * @static
	 * @memberof PIXI.settings
	 * @name UPLOADS_PER_FRAME
	 * @type {number}
	 * @default 4
	 */
	core.settings.UPLOADS_PER_FRAME = 4;
	
	/**
	 * The prepare manager provides functionality to upload content to the GPU. BasePrepare handles
	 * basic queuing functionality and is extended by {@link PIXI.prepare.WebGLPrepare} and {@link PIXI.prepare.CanvasPrepare}
	 * to provide preparation capabilities specific to their respective renderers.
	 *
	 * @example
	 * // Create a sprite
	 * const sprite = new PIXI.Sprite.fromImage('something.png');
	 *
	 * // Load object into GPU
	 * app.renderer.plugins.prepare.upload(sprite, () => {
	 *
	 *     //Texture(s) has been uploaded to GPU
	 *     app.stage.addChild(sprite);
	 *
	 * })
	 *
	 * @abstract
	 * @class
	 * @memberof PIXI.prepare
	 */
	
	var BasePrepare = function () {
	    /**
	     * @param {PIXI.SystemRenderer} renderer - A reference to the current renderer
	     */
	    function BasePrepare(renderer) {
	        var _this = this;
	
	        _classCallCheck(this, BasePrepare);
	
	        /**
	         * The limiter to be used to control how quickly items are prepared.
	         * @type {PIXI.prepare.CountLimiter|PIXI.prepare.TimeLimiter}
	         */
	        this.limiter = new _CountLimiter2.default(core.settings.UPLOADS_PER_FRAME);
	
	        /**
	         * Reference to the renderer.
	         * @type {PIXI.SystemRenderer}
	         * @protected
	         */
	        this.renderer = renderer;
	
	        /**
	         * The only real difference between CanvasPrepare and WebGLPrepare is what they pass
	         * to upload hooks. That different parameter is stored here.
	         * @type {PIXI.prepare.CanvasPrepare|PIXI.WebGLRenderer}
	         * @protected
	         */
	        this.uploadHookHelper = null;
	
	        /**
	         * Collection of items to uploads at once.
	         * @type {Array<*>}
	         * @private
	         */
	        this.queue = [];
	
	        /**
	         * Collection of additional hooks for finding assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.addHooks = [];
	
	        /**
	         * Collection of additional hooks for processing assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.uploadHooks = [];
	
	        /**
	         * Callback to call after completed.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.completes = [];
	
	        /**
	         * If prepare is ticking (running).
	         * @type {boolean}
	         * @private
	         */
	        this.ticking = false;
	
	        /**
	         * 'bound' call for prepareItems().
	         * @type {Function}
	         * @private
	         */
	        this.delayedTick = function () {
	            // unlikely, but in case we were destroyed between tick() and delayedTick()
	            if (!_this.queue) {
	                return;
	            }
	            _this.prepareItems();
	        };
	
	        // hooks to find the correct texture
	        this.registerFindHook(findText);
	        this.registerFindHook(findTextStyle);
	        this.registerFindHook(findMultipleBaseTextures);
	        this.registerFindHook(findBaseTexture);
	        this.registerFindHook(findTexture);
	
	        // upload hooks
	        this.registerUploadHook(drawText);
	        this.registerUploadHook(calculateTextStyle);
	    }
	
	    /**
	     * Upload all the textures and graphics to the GPU.
	     *
	     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
	     *        Either the container or display object to search for items to upload, the items to upload themselves,
	     *        or the callback function, if items have been added using `prepare.add`.
	     * @param {Function} [done] - Optional callback when all queued uploads have completed
	     */
	
	
	    BasePrepare.prototype.upload = function upload(item, done) {
	        if (typeof item === 'function') {
	            done = item;
	            item = null;
	        }
	
	        // If a display object, search for items
	        // that we could upload
	        if (item) {
	            this.add(item);
	        }
	
	        // Get the items for upload from the display
	        if (this.queue.length) {
	            if (done) {
	                this.completes.push(done);
	            }
	
	            if (!this.ticking) {
	                this.ticking = true;
	                SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
	            }
	        } else if (done) {
	            done();
	        }
	    };
	
	    /**
	     * Handle tick update
	     *
	     * @private
	     */
	
	
	    BasePrepare.prototype.tick = function tick() {
	        setTimeout(this.delayedTick, 0);
	    };
	
	    /**
	     * Actually prepare items. This is handled outside of the tick because it will take a while
	     * and we do NOT want to block the current animation frame from rendering.
	     *
	     * @private
	     */
	
	
	    BasePrepare.prototype.prepareItems = function prepareItems() {
	        this.limiter.beginFrame();
	        // Upload the graphics
	        while (this.queue.length && this.limiter.allowedToUpload()) {
	            var item = this.queue[0];
	            var uploaded = false;
	
	            if (item && !item._destroyed) {
	                for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
	                    if (this.uploadHooks[i](this.uploadHookHelper, item)) {
	                        this.queue.shift();
	                        uploaded = true;
	                        break;
	                    }
	                }
	            }
	
	            if (!uploaded) {
	                this.queue.shift();
	            }
	        }
	
	        // We're finished
	        if (!this.queue.length) {
	            this.ticking = false;
	
	            var completes = this.completes.slice(0);
	
	            this.completes.length = 0;
	
	            for (var _i = 0, _len = completes.length; _i < _len; _i++) {
	                completes[_i]();
	            }
	        } else {
	            // if we are not finished, on the next rAF do this again
	            SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
	        }
	    };
	
	    /**
	     * Adds hooks for finding items.
	     *
	     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
	     *          function must return `true` if it was able to add item to the queue.
	     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	     */
	
	
	    BasePrepare.prototype.registerFindHook = function registerFindHook(addHook) {
	        if (addHook) {
	            this.addHooks.push(addHook);
	        }
	
	        return this;
	    };
	
	    /**
	     * Adds hooks for uploading items.
	     *
	     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
	     *          function must return `true` if it was able to handle upload of item.
	     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	     */
	
	
	    BasePrepare.prototype.registerUploadHook = function registerUploadHook(uploadHook) {
	        if (uploadHook) {
	            this.uploadHooks.push(uploadHook);
	        }
	
	        return this;
	    };
	
	    /**
	     * Manually add an item to the uploading queue.
	     *
	     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
	     *        add to the queue
	     * @return {PIXI.CanvasPrepare} Instance of plugin for chaining.
	     */
	
	
	    BasePrepare.prototype.add = function add(item) {
	        // Add additional hooks for finding elements on special
	        // types of objects that
	        for (var i = 0, len = this.addHooks.length; i < len; i++) {
	            if (this.addHooks[i](item, this.queue)) {
	                break;
	            }
	        }
	
	        // Get childen recursively
	        if (item instanceof core.Container) {
	            for (var _i2 = item.children.length - 1; _i2 >= 0; _i2--) {
	                this.add(item.children[_i2]);
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */
	
	
	    BasePrepare.prototype.destroy = function destroy() {
	        if (this.ticking) {
	            SharedTicker.remove(this.tick, this);
	        }
	        this.ticking = false;
	        this.addHooks = null;
	        this.uploadHooks = null;
	        this.renderer = null;
	        this.completes = null;
	        this.queue = null;
	        this.limiter = null;
	        this.uploadHookHelper = null;
	    };
	
	    return BasePrepare;
	}();
	
	/**
	 * Built-in hook to find multiple textures from objects like AnimatedSprites.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	
	
	exports.default = BasePrepare;
	function findMultipleBaseTextures(item, queue) {
	    var result = false;
	
	    // Objects with mutliple textures
	    if (item && item._textures && item._textures.length) {
	        for (var i = 0; i < item._textures.length; i++) {
	            if (item._textures[i] instanceof core.Texture) {
	                var baseTexture = item._textures[i].baseTexture;
	
	                if (queue.indexOf(baseTexture) === -1) {
	                    queue.push(baseTexture);
	                    result = true;
	                }
	            }
	        }
	    }
	
	    return result;
	}
	
	/**
	 * Built-in hook to find BaseTextures from Sprites.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findBaseTexture(item, queue) {
	    // Objects with textures, like Sprites/Text
	    if (item instanceof core.BaseTexture) {
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find textures from objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findTexture(item, queue) {
	    if (item._texture && item._texture instanceof core.Texture) {
	        var texture = item._texture.baseTexture;
	
	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to draw PIXI.Text to its texture.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function drawText(helper, item) {
	    if (item instanceof core.Text) {
	        // updating text will return early if it is not dirty
	        item.updateText(true);
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to calculate a text style for a PIXI.Text object.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function calculateTextStyle(helper, item) {
	    if (item instanceof core.TextStyle) {
	        var font = item.toFontString();
	
	        core.TextMetrics.measureFont(font);
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find Text objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Text object was found.
	 */
	function findText(item, queue) {
	    if (item instanceof core.Text) {
	        // push the text style to prepare it - this can be really expensive
	        if (queue.indexOf(item.style) === -1) {
	            queue.push(item.style);
	        }
	        // also push the text object so that we can render it (to canvas/texture) if needed
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	        // also push the Text's texture for upload to GPU
	        var texture = item._texture.baseTexture;
	
	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find TextStyle objects.
	 *
	 * @private
	 * @param {PIXI.TextStyle} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.TextStyle object was found.
	 */
	function findTextStyle(item, queue) {
	    if (item instanceof core.TextStyle) {
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	//# sourceMappingURL=BasePrepare.js.map

/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parseUri = __webpack_require__(90);
	
	var _parseUri2 = _interopRequireDefault(_parseUri);
	
	var _miniSignals = __webpack_require__(89);
	
	var _miniSignals2 = _interopRequireDefault(_miniSignals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// tests is CORS is supported in XHR, if not we need to use XDR
	var useXdr = !!(window.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
	var tempAnchor = null;
	
	// some status constants
	var STATUS_NONE = 0;
	var STATUS_OK = 200;
	var STATUS_EMPTY = 204;
	var STATUS_IE_BUG_EMPTY = 1223;
	var STATUS_TYPE_OK = 2;
	
	// noop
	function _noop() {} /* empty */
	
	/**
	 * Manages the state and loading of a resource and all child resources.
	 *
	 * @class
	 */
	
	var Resource = function () {
	    /**
	     * Sets the load type to be used for a specific extension.
	     *
	     * @static
	     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	     * @param {Resource.LOAD_TYPE} loadType - The load type to set it to.
	     */
	    Resource.setExtensionLoadType = function setExtensionLoadType(extname, loadType) {
	        setExtMap(Resource._loadTypeMap, extname, loadType);
	    };
	
	    /**
	     * Sets the load type to be used for a specific extension.
	     *
	     * @static
	     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	     * @param {Resource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
	     */
	
	
	    Resource.setExtensionXhrType = function setExtensionXhrType(extname, xhrType) {
	        setExtMap(Resource._xhrTypeMap, extname, xhrType);
	    };
	
	    /**
	     * @param {string} name - The name of the resource to load.
	     * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
	     *      an array of sources.
	     * @param {object} [options] - The options for the load.
	     * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
	     *      determine automatically.
	     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource
	     *      be loaded?
	     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
	     *      should the data being loaded be interpreted when using XHR?
	     * @param {object} [options.metadata] - Extra configuration for middleware and the Resource object.
	     * @param {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [options.metadata.loadElement=null] - The
	     *      element to use for loading, instead of creating one.
	     * @param {boolean} [options.metadata.skipSource=false] - Skips adding source(s) to the load element. This
	     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
	     * @param {string|string[]} [options.metadata.mimeType] - The mime type to use for the source element of a video/audio
	     *      elment. If the urls are an array, you can pass this as an array as well where each index is the mime type to
	     *      use for the corresponding url index.
	     */
	
	
	    function Resource(name, url, options) {
	        _classCallCheck(this, Resource);
	
	        if (typeof name !== 'string' || typeof url !== 'string') {
	            throw new Error('Both name and url are required for constructing a resource.');
	        }
	
	        options = options || {};
	
	        /**
	         * The state flags of this resource.
	         *
	         * @member {number}
	         */
	        this._flags = 0;
	
	        // set data url flag, needs to be set early for some _determineX checks to work.
	        this._setFlag(Resource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);
	
	        /**
	         * The name of this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.name = name;
	
	        /**
	         * The url used to load this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.url = url;
	
	        /**
	         * The extension used to load this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.extension = this._getExtension();
	
	        /**
	         * The data that was loaded by the resource.
	         *
	         * @member {any}
	         */
	        this.data = null;
	
	        /**
	         * Is this request cross-origin? If unset, determined automatically.
	         *
	         * @member {string}
	         */
	        this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;
	
	        /**
	         * The method of loading to use for this resource.
	         *
	         * @member {Resource.LOAD_TYPE}
	         */
	        this.loadType = options.loadType || this._determineLoadType();
	
	        /**
	         * The type used to load the resource via XHR. If unset, determined automatically.
	         *
	         * @member {string}
	         */
	        this.xhrType = options.xhrType;
	
	        /**
	         * Extra info for middleware, and controlling specifics about how the resource loads.
	         *
	         * Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
	         * Meaning it will modify it as it sees fit.
	         *
	         * @member {object}
	         * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
	         *  element to use for loading, instead of creating one.
	         * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
	         *  is useful if you want to pass in a `loadElement` that you already added load sources
	         *  to.
	         */
	        this.metadata = options.metadata || {};
	
	        /**
	         * The error that occurred while loading (if any).
	         *
	         * @member {Error}
	         * @readonly
	         */
	        this.error = null;
	
	        /**
	         * The XHR object that was used to load this resource. This is only set
	         * when `loadType` is `Resource.LOAD_TYPE.XHR`.
	         *
	         * @member {XMLHttpRequest}
	         * @readonly
	         */
	        this.xhr = null;
	
	        /**
	         * The child resources this resource owns.
	         *
	         * @member {Resource[]}
	         * @readonly
	         */
	        this.children = [];
	
	        /**
	         * The resource type.
	         *
	         * @member {Resource.TYPE}
	         * @readonly
	         */
	        this.type = Resource.TYPE.UNKNOWN;
	
	        /**
	         * The progress chunk owned by this resource.
	         *
	         * @member {number}
	         * @readonly
	         */
	        this.progressChunk = 0;
	
	        /**
	         * The `dequeue` method that will be used a storage place for the async queue dequeue method
	         * used privately by the loader.
	         *
	         * @private
	         * @member {function}
	         */
	        this._dequeue = _noop;
	
	        /**
	         * Used a storage place for the on load binding used privately by the loader.
	         *
	         * @private
	         * @member {function}
	         */
	        this._onLoadBinding = null;
	
	        /**
	         * The `complete` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundComplete = this.complete.bind(this);
	
	        /**
	         * The `_onError` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundOnError = this._onError.bind(this);
	
	        /**
	         * The `_onProgress` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundOnProgress = this._onProgress.bind(this);
	
	        // xhr callbacks
	        this._boundXhrOnError = this._xhrOnError.bind(this);
	        this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
	        this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
	        this._boundXdrOnTimeout = this._xdrOnTimeout.bind(this);
	
	        /**
	         * Dispatched when the resource beings to load.
	         *
	         * The callback looks like {@link Resource.OnStartSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onStart = new _miniSignals2.default();
	
	        /**
	         * Dispatched each time progress of this resource load updates.
	         * Not all resources types and loader systems can support this event
	         * so sometimes it may not be available. If the resource
	         * is being loaded on a modern browser, using XHR, and the remote server
	         * properly sets Content-Length headers, then this will be available.
	         *
	         * The callback looks like {@link Resource.OnProgressSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onProgress = new _miniSignals2.default();
	
	        /**
	         * Dispatched once this resource has loaded, if there was an error it will
	         * be in the `error` property.
	         *
	         * The callback looks like {@link Resource.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onComplete = new _miniSignals2.default();
	
	        /**
	         * Dispatched after this resource has had all the *after* middleware run on it.
	         *
	         * The callback looks like {@link Resource.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onAfterMiddleware = new _miniSignals2.default();
	
	        /**
	         * When the resource starts to load.
	         *
	         * @memberof Resource
	         * @callback OnStartSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         */
	
	        /**
	         * When the resource reports loading progress.
	         *
	         * @memberof Resource
	         * @callback OnProgressSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         * @param {number} percentage - The progress of the load in the range [0, 1].
	         */
	
	        /**
	         * When the resource finishes loading.
	         *
	         * @memberof Resource
	         * @callback OnCompleteSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         */
	    }
	
	    /**
	     * Stores whether or not this url is a data url.
	     *
	     * @member {boolean}
	     * @readonly
	     */
	
	
	    /**
	     * Marks the resource as complete.
	     *
	     */
	    Resource.prototype.complete = function complete() {
	        // TODO: Clean this up in a wrapper or something...gross....
	        if (this.data && this.data.removeEventListener) {
	            this.data.removeEventListener('error', this._boundOnError, false);
	            this.data.removeEventListener('load', this._boundComplete, false);
	            this.data.removeEventListener('progress', this._boundOnProgress, false);
	            this.data.removeEventListener('canplaythrough', this._boundComplete, false);
	        }
	
	        if (this.xhr) {
	            if (this.xhr.removeEventListener) {
	                this.xhr.removeEventListener('error', this._boundXhrOnError, false);
	                this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
	                this.xhr.removeEventListener('progress', this._boundOnProgress, false);
	                this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
	            } else {
	                this.xhr.onerror = null;
	                this.xhr.ontimeout = null;
	                this.xhr.onprogress = null;
	                this.xhr.onload = null;
	            }
	        }
	
	        if (this.isComplete) {
	            throw new Error('Complete called again for an already completed resource.');
	        }
	
	        this._setFlag(Resource.STATUS_FLAGS.COMPLETE, true);
	        this._setFlag(Resource.STATUS_FLAGS.LOADING, false);
	
	        this.onComplete.dispatch(this);
	    };
	
	    /**
	     * Aborts the loading of this resource, with an optional message.
	     *
	     * @param {string} message - The message to use for the error
	     */
	
	
	    Resource.prototype.abort = function abort(message) {
	        // abort can be called multiple times, ignore subsequent calls.
	        if (this.error) {
	            return;
	        }
	
	        // store error
	        this.error = new Error(message);
	
	        // abort the actual loading
	        if (this.xhr) {
	            this.xhr.abort();
	        } else if (this.xdr) {
	            this.xdr.abort();
	        } else if (this.data) {
	            // single source
	            if (this.data.src) {
	                this.data.src = Resource.EMPTY_GIF;
	            }
	            // multi-source
	            else {
	                    while (this.data.firstChild) {
	                        this.data.removeChild(this.data.firstChild);
	                    }
	                }
	        }
	
	        // done now.
	        this.complete();
	    };
	
	    /**
	     * Kicks off loading of this resource. This method is asynchronous.
	     *
	     * @param {function} [cb] - Optional callback to call once the resource is loaded.
	     */
	
	
	    Resource.prototype.load = function load(cb) {
	        var _this = this;
	
	        if (this.isLoading) {
	            return;
	        }
	
	        if (this.isComplete) {
	            if (cb) {
	                setTimeout(function () {
	                    return cb(_this);
	                }, 1);
	            }
	
	            return;
	        } else if (cb) {
	            this.onComplete.once(cb);
	        }
	
	        this._setFlag(Resource.STATUS_FLAGS.LOADING, true);
	
	        this.onStart.dispatch(this);
	
	        // if unset, determine the value
	        if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
	            this.crossOrigin = this._determineCrossOrigin(this.url);
	        }
	
	        switch (this.loadType) {
	            case Resource.LOAD_TYPE.IMAGE:
	                this.type = Resource.TYPE.IMAGE;
	                this._loadElement('image');
	                break;
	
	            case Resource.LOAD_TYPE.AUDIO:
	                this.type = Resource.TYPE.AUDIO;
	                this._loadSourceElement('audio');
	                break;
	
	            case Resource.LOAD_TYPE.VIDEO:
	                this.type = Resource.TYPE.VIDEO;
	                this._loadSourceElement('video');
	                break;
	
	            case Resource.LOAD_TYPE.XHR:
	            /* falls through */
	            default:
	                if (useXdr && this.crossOrigin) {
	                    this._loadXdr();
	                } else {
	                    this._loadXhr();
	                }
	                break;
	        }
	    };
	
	    /**
	     * Checks if the flag is set.
	     *
	     * @private
	     * @param {number} flag - The flag to check.
	     * @return {boolean} True if the flag is set.
	     */
	
	
	    Resource.prototype._hasFlag = function _hasFlag(flag) {
	        return !!(this._flags & flag);
	    };
	
	    /**
	     * (Un)Sets the flag.
	     *
	     * @private
	     * @param {number} flag - The flag to (un)set.
	     * @param {boolean} value - Whether to set or (un)set the flag.
	     */
	
	
	    Resource.prototype._setFlag = function _setFlag(flag, value) {
	        this._flags = value ? this._flags | flag : this._flags & ~flag;
	    };
	
	    /**
	     * Loads this resources using an element that has a single source,
	     * like an HTMLImageElement.
	     *
	     * @private
	     * @param {string} type - The type of element to use.
	     */
	
	
	    Resource.prototype._loadElement = function _loadElement(type) {
	        if (this.metadata.loadElement) {
	            this.data = this.metadata.loadElement;
	        } else if (type === 'image' && typeof window.Image !== 'undefined') {
	            this.data = new Image();
	        } else {
	            this.data = document.createElement(type);
	        }
	
	        if (this.crossOrigin) {
	            this.data.crossOrigin = this.crossOrigin;
	        }
	
	        if (!this.metadata.skipSource) {
	            this.data.src = this.url;
	        }
	
	        this.data.addEventListener('error', this._boundOnError, false);
	        this.data.addEventListener('load', this._boundComplete, false);
	        this.data.addEventListener('progress', this._boundOnProgress, false);
	    };
	
	    /**
	     * Loads this resources using an element that has multiple sources,
	     * like an HTMLAudioElement or HTMLVideoElement.
	     *
	     * @private
	     * @param {string} type - The type of element to use.
	     */
	
	
	    Resource.prototype._loadSourceElement = function _loadSourceElement(type) {
	        if (this.metadata.loadElement) {
	            this.data = this.metadata.loadElement;
	        } else if (type === 'audio' && typeof window.Audio !== 'undefined') {
	            this.data = new Audio();
	        } else {
	            this.data = document.createElement(type);
	        }
	
	        if (this.data === null) {
	            this.abort('Unsupported element: ' + type);
	
	            return;
	        }
	
	        if (!this.metadata.skipSource) {
	            // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
	            if (navigator.isCocoonJS) {
	                this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
	            } else if (Array.isArray(this.url)) {
	                var mimeTypes = this.metadata.mimeType;
	
	                for (var i = 0; i < this.url.length; ++i) {
	                    this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
	                }
	            } else {
	                var _mimeTypes = this.metadata.mimeType;
	
	                this.data.appendChild(this._createSource(type, this.url, Array.isArray(_mimeTypes) ? _mimeTypes[0] : _mimeTypes));
	            }
	        }
	
	        this.data.addEventListener('error', this._boundOnError, false);
	        this.data.addEventListener('load', this._boundComplete, false);
	        this.data.addEventListener('progress', this._boundOnProgress, false);
	        this.data.addEventListener('canplaythrough', this._boundComplete, false);
	
	        this.data.load();
	    };
	
	    /**
	     * Loads this resources using an XMLHttpRequest.
	     *
	     * @private
	     */
	
	
	    Resource.prototype._loadXhr = function _loadXhr() {
	        // if unset, determine the value
	        if (typeof this.xhrType !== 'string') {
	            this.xhrType = this._determineXhrType();
	        }
	
	        var xhr = this.xhr = new XMLHttpRequest();
	
	        // set the request type and url
	        xhr.open('GET', this.url, true);
	
	        // load json as text and parse it ourselves. We do this because some browsers
	        // *cough* safari *cough* can't deal with it.
	        if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	            xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
	        } else {
	            xhr.responseType = this.xhrType;
	        }
	
	        xhr.addEventListener('error', this._boundXhrOnError, false);
	        xhr.addEventListener('abort', this._boundXhrOnAbort, false);
	        xhr.addEventListener('progress', this._boundOnProgress, false);
	        xhr.addEventListener('load', this._boundXhrOnLoad, false);
	
	        xhr.send();
	    };
	
	    /**
	     * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
	     *
	     * @private
	     */
	
	
	    Resource.prototype._loadXdr = function _loadXdr() {
	        // if unset, determine the value
	        if (typeof this.xhrType !== 'string') {
	            this.xhrType = this._determineXhrType();
	        }
	
	        var xdr = this.xhr = new XDomainRequest();
	
	        // XDomainRequest has a few quirks. Occasionally it will abort requests
	        // A way to avoid this is to make sure ALL callbacks are set even if not used
	        // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
	        xdr.timeout = 5000;
	
	        xdr.onerror = this._boundXhrOnError;
	        xdr.ontimeout = this._boundXdrOnTimeout;
	        xdr.onprogress = this._boundOnProgress;
	        xdr.onload = this._boundXhrOnLoad;
	
	        xdr.open('GET', this.url, true);
	
	        // Note: The xdr.send() call is wrapped in a timeout to prevent an
	        // issue with the interface where some requests are lost if multiple
	        // XDomainRequests are being sent at the same time.
	        // Some info here: https://github.com/photonstorm/phaser/issues/1248
	        setTimeout(function () {
	            return xdr.send();
	        }, 1);
	    };
	
	    /**
	     * Creates a source used in loading via an element.
	     *
	     * @private
	     * @param {string} type - The element type (video or audio).
	     * @param {string} url - The source URL to load from.
	     * @param {string} [mime] - The mime type of the video
	     * @return {HTMLSourceElement} The source element.
	     */
	
	
	    Resource.prototype._createSource = function _createSource(type, url, mime) {
	        if (!mime) {
	            mime = type + '/' + this._getExtension(url);
	        }
	
	        var source = document.createElement('source');
	
	        source.src = url;
	        source.type = mime;
	
	        return source;
	    };
	
	    /**
	     * Called if a load errors out.
	     *
	     * @param {Event} event - The error event from the element that emits it.
	     * @private
	     */
	
	
	    Resource.prototype._onError = function _onError(event) {
	        this.abort('Failed to load element using: ' + event.target.nodeName);
	    };
	
	    /**
	     * Called if a load progress event fires for xhr/xdr.
	     *
	     * @private
	     * @param {XMLHttpRequestProgressEvent|Event} event - Progress event.
	     */
	
	
	    Resource.prototype._onProgress = function _onProgress(event) {
	        if (event && event.lengthComputable) {
	            this.onProgress.dispatch(this, event.loaded / event.total);
	        }
	    };
	
	    /**
	     * Called if an error event fires for xhr/xdr.
	     *
	     * @private
	     * @param {XMLHttpRequestErrorEvent|Event} event - Error event.
	     */
	
	
	    Resource.prototype._xhrOnError = function _xhrOnError() {
	        var xhr = this.xhr;
	
	        this.abort(reqType(xhr) + ' Request failed. Status: ' + xhr.status + ', text: "' + xhr.statusText + '"');
	    };
	
	    /**
	     * Called if an abort event fires for xhr.
	     *
	     * @private
	     * @param {XMLHttpRequestAbortEvent} event - Abort Event
	     */
	
	
	    Resource.prototype._xhrOnAbort = function _xhrOnAbort() {
	        this.abort(reqType(this.xhr) + ' Request was aborted by the user.');
	    };
	
	    /**
	     * Called if a timeout event fires for xdr.
	     *
	     * @private
	     * @param {Event} event - Timeout event.
	     */
	
	
	    Resource.prototype._xdrOnTimeout = function _xdrOnTimeout() {
	        this.abort(reqType(this.xhr) + ' Request timed out.');
	    };
	
	    /**
	     * Called when data successfully loads from an xhr/xdr request.
	     *
	     * @private
	     * @param {XMLHttpRequestLoadEvent|Event} event - Load event
	     */
	
	
	    Resource.prototype._xhrOnLoad = function _xhrOnLoad() {
	        var xhr = this.xhr;
	        var text = '';
	        var status = typeof xhr.status === 'undefined' ? STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.
	
	        // responseText is accessible only if responseType is '' or 'text' and on older browsers
	        if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') {
	            text = xhr.responseText;
	        }
	
	        // status can be 0 when using the `file://` protocol so we also check if a response is set.
	        // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
	        if (status === STATUS_NONE && (text.length > 0 || xhr.responseType === Resource.XHR_RESPONSE_TYPE.BUFFER)) {
	            status = STATUS_OK;
	        }
	        // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	        else if (status === STATUS_IE_BUG_EMPTY) {
	                status = STATUS_EMPTY;
	            }
	
	        var statusType = status / 100 | 0;
	
	        if (statusType === STATUS_TYPE_OK) {
	            // if text, just return it
	            if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
	                this.data = text;
	                this.type = Resource.TYPE.TEXT;
	            }
	            // if json, parse into json object
	            else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
	                    try {
	                        this.data = JSON.parse(text);
	                        this.type = Resource.TYPE.JSON;
	                    } catch (e) {
	                        this.abort('Error trying to parse loaded json: ' + e);
	
	                        return;
	                    }
	                }
	                // if xml, parse into an xml document or div element
	                else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	                        try {
	                            if (window.DOMParser) {
	                                var domparser = new DOMParser();
	
	                                this.data = domparser.parseFromString(text, 'text/xml');
	                            } else {
	                                var div = document.createElement('div');
	
	                                div.innerHTML = text;
	
	                                this.data = div;
	                            }
	
	                            this.type = Resource.TYPE.XML;
	                        } catch (e) {
	                            this.abort('Error trying to parse loaded xml: ' + e);
	
	                            return;
	                        }
	                    }
	                    // other types just return the response
	                    else {
	                            this.data = xhr.response || text;
	                        }
	        } else {
	            this.abort('[' + xhr.status + '] ' + xhr.statusText + ': ' + xhr.responseURL);
	
	            return;
	        }
	
	        this.complete();
	    };
	
	    /**
	     * Sets the `crossOrigin` property for this resource based on if the url
	     * for this resource is cross-origin. If crossOrigin was manually set, this
	     * function does nothing.
	     *
	     * @private
	     * @param {string} url - The url to test.
	     * @param {object} [loc=window.location] - The location object to test against.
	     * @return {string} The crossOrigin value to use (or empty string for none).
	     */
	
	
	    Resource.prototype._determineCrossOrigin = function _determineCrossOrigin(url, loc) {
	        // data: and javascript: urls are considered same-origin
	        if (url.indexOf('data:') === 0) {
	            return '';
	        }
	
	        // default is window.location
	        loc = loc || window.location;
	
	        if (!tempAnchor) {
	            tempAnchor = document.createElement('a');
	        }
	
	        // let the browser determine the full href for the url of this resource and then
	        // parse with the node url lib, we can't use the properties of the anchor element
	        // because they don't work in IE9 :(
	        tempAnchor.href = url;
	        url = (0, _parseUri2.default)(tempAnchor.href, { strictMode: true });
	
	        var samePort = !url.port && loc.port === '' || url.port === loc.port;
	        var protocol = url.protocol ? url.protocol + ':' : '';
	
	        // if cross origin
	        if (url.host !== loc.hostname || !samePort || protocol !== loc.protocol) {
	            return 'anonymous';
	        }
	
	        return '';
	    };
	
	    /**
	     * Determines the responseType of an XHR request based on the extension of the
	     * resource being loaded.
	     *
	     * @private
	     * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
	     */
	
	
	    Resource.prototype._determineXhrType = function _determineXhrType() {
	        return Resource._xhrTypeMap[this.extension] || Resource.XHR_RESPONSE_TYPE.TEXT;
	    };
	
	    /**
	     * Determines the loadType of a resource based on the extension of the
	     * resource being loaded.
	     *
	     * @private
	     * @return {Resource.LOAD_TYPE} The loadType to use.
	     */
	
	
	    Resource.prototype._determineLoadType = function _determineLoadType() {
	        return Resource._loadTypeMap[this.extension] || Resource.LOAD_TYPE.XHR;
	    };
	
	    /**
	     * Extracts the extension (sans '.') of the file being loaded by the resource.
	     *
	     * @private
	     * @return {string} The extension.
	     */
	
	
	    Resource.prototype._getExtension = function _getExtension() {
	        var url = this.url;
	        var ext = '';
	
	        if (this.isDataUrl) {
	            var slashIndex = url.indexOf('/');
	
	            ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
	        } else {
	            var queryStart = url.indexOf('?');
	            var hashStart = url.indexOf('#');
	            var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);
	
	            url = url.substring(0, index);
	            ext = url.substring(url.lastIndexOf('.') + 1);
	        }
	
	        return ext.toLowerCase();
	    };
	
	    /**
	     * Determines the mime type of an XHR request based on the responseType of
	     * resource being loaded.
	     *
	     * @private
	     * @param {Resource.XHR_RESPONSE_TYPE} type - The type to get a mime type for.
	     * @return {string} The mime type to use.
	     */
	
	
	    Resource.prototype._getMimeFromXhrType = function _getMimeFromXhrType(type) {
	        switch (type) {
	            case Resource.XHR_RESPONSE_TYPE.BUFFER:
	                return 'application/octet-binary';
	
	            case Resource.XHR_RESPONSE_TYPE.BLOB:
	                return 'application/blob';
	
	            case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
	                return 'application/xml';
	
	            case Resource.XHR_RESPONSE_TYPE.JSON:
	                return 'application/json';
	
	            case Resource.XHR_RESPONSE_TYPE.DEFAULT:
	            case Resource.XHR_RESPONSE_TYPE.TEXT:
	            /* falls through */
	            default:
	                return 'text/plain';
	
	        }
	    };
	
	    _createClass(Resource, [{
	        key: 'isDataUrl',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.DATA_URL);
	        }
	
	        /**
	         * Describes if this resource has finished loading. Is true when the resource has completely
	         * loaded.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	
	    }, {
	        key: 'isComplete',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.COMPLETE);
	        }
	
	        /**
	         * Describes if this resource is currently loading. Is true when the resource starts loading,
	         * and is false again when complete.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	
	    }, {
	        key: 'isLoading',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.LOADING);
	        }
	    }]);
	
	    return Resource;
	}();
	
	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	
	
	exports.default = Resource;
	Resource.STATUS_FLAGS = {
	    NONE: 0,
	    DATA_URL: 1 << 0,
	    COMPLETE: 1 << 1,
	    LOADING: 1 << 2
	};
	
	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	Resource.TYPE = {
	    UNKNOWN: 0,
	    JSON: 1,
	    XML: 2,
	    IMAGE: 3,
	    AUDIO: 4,
	    VIDEO: 5,
	    TEXT: 6
	};
	
	/**
	 * The types of loading a resource can use.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	Resource.LOAD_TYPE = {
	    /** Uses XMLHttpRequest to load the resource. */
	    XHR: 1,
	    /** Uses an `Image` object to load the resource. */
	    IMAGE: 2,
	    /** Uses an `Audio` object to load the resource. */
	    AUDIO: 3,
	    /** Uses a `Video` object to load the resource. */
	    VIDEO: 4
	};
	
	/**
	 * The XHR ready states, used internally.
	 *
	 * @static
	 * @readonly
	 * @enum {string}
	 */
	Resource.XHR_RESPONSE_TYPE = {
	    /** string */
	    DEFAULT: 'text',
	    /** ArrayBuffer */
	    BUFFER: 'arraybuffer',
	    /** Blob */
	    BLOB: 'blob',
	    /** Document */
	    DOCUMENT: 'document',
	    /** Object */
	    JSON: 'json',
	    /** String */
	    TEXT: 'text'
	};
	
	Resource._loadTypeMap = {
	    // images
	    gif: Resource.LOAD_TYPE.IMAGE,
	    png: Resource.LOAD_TYPE.IMAGE,
	    bmp: Resource.LOAD_TYPE.IMAGE,
	    jpg: Resource.LOAD_TYPE.IMAGE,
	    jpeg: Resource.LOAD_TYPE.IMAGE,
	    tif: Resource.LOAD_TYPE.IMAGE,
	    tiff: Resource.LOAD_TYPE.IMAGE,
	    webp: Resource.LOAD_TYPE.IMAGE,
	    tga: Resource.LOAD_TYPE.IMAGE,
	    svg: Resource.LOAD_TYPE.IMAGE,
	    'svg+xml': Resource.LOAD_TYPE.IMAGE, // for SVG data urls
	
	    // audio
	    mp3: Resource.LOAD_TYPE.AUDIO,
	    ogg: Resource.LOAD_TYPE.AUDIO,
	    wav: Resource.LOAD_TYPE.AUDIO,
	
	    // videos
	    mp4: Resource.LOAD_TYPE.VIDEO,
	    webm: Resource.LOAD_TYPE.VIDEO
	};
	
	Resource._xhrTypeMap = {
	    // xml
	    xhtml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    html: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    htm: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    xml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    tmx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    svg: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	
	    // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
	    // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
	    // this should probably be fine.
	    tsx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	
	    // images
	    gif: Resource.XHR_RESPONSE_TYPE.BLOB,
	    png: Resource.XHR_RESPONSE_TYPE.BLOB,
	    bmp: Resource.XHR_RESPONSE_TYPE.BLOB,
	    jpg: Resource.XHR_RESPONSE_TYPE.BLOB,
	    jpeg: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tif: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tiff: Resource.XHR_RESPONSE_TYPE.BLOB,
	    webp: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tga: Resource.XHR_RESPONSE_TYPE.BLOB,
	
	    // json
	    json: Resource.XHR_RESPONSE_TYPE.JSON,
	
	    // text
	    text: Resource.XHR_RESPONSE_TYPE.TEXT,
	    txt: Resource.XHR_RESPONSE_TYPE.TEXT,
	
	    // fonts
	    ttf: Resource.XHR_RESPONSE_TYPE.BUFFER,
	    otf: Resource.XHR_RESPONSE_TYPE.BUFFER
	};
	
	// We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
	Resource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
	
	/**
	 * Quick helper to set a value on one of the extension maps. Ensures there is no
	 * dot at the start of the extension.
	 *
	 * @ignore
	 * @param {object} map - The map to set on.
	 * @param {string} extname - The extension (or key) to set.
	 * @param {number} val - The value to set.
	 */
	function setExtMap(map, extname, val) {
	    if (extname && extname.indexOf('.') === 0) {
	        extname = extname.substring(1);
	    }
	
	    if (!extname) {
	        return;
	    }
	
	    map[extname] = val;
	}
	
	/**
	 * Quick helper to get string xhr type.
	 *
	 * @ignore
	 * @param {XMLHttpRequest|XDomainRequest} xhr - The request to check.
	 * @return {string} The type.
	 */
	function reqType(xhr) {
	    return xhr.toString().replace('object ', '');
	}
	//# sourceMappingURL=Resource.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(11);
	
	var _PlayPauseButtonModule = __webpack_require__(157);
	
	var _PlayPauseButtonModule2 = _interopRequireDefault(_PlayPauseButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MorphSVG = void 0;
	
	var PlayPauseButton = function (_Component) {
	  _inherits(PlayPauseButton, _Component);
	
	  function PlayPauseButton() {
	    _classCallCheck(this, PlayPauseButton);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PlayPauseButton.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      MorphSVG = __webpack_require__(143);
	    }
	
	    // Play/Pause button animation
	    this.playPauseAnim = new TimelineMax({
	      paused: true
	    });
	
	    this.playPauseAnim.to(this.playPauseLeft, 0.3, {
	      x: 2.2,
	      morphSVG: '7.5,12.9 7.5,12.9 0,17 0,8.5 0,0 7.5,4.2 7.5,4.2 7.5,8.5',
	      ease: Cubic.easeInOut
	    }).to(this.playPauseRight, 0.3, {
	      x: 2,
	      morphSVG: '15,8.5 7.5,12.9 7.5,12.9 7.5,8.5 7.5,4.2 7.5,4.2 15,8.5 15,8.5',
	      ease: Cubic.easeInOut
	    }, '-=0.3');
	
	    if (this.props.isVideoPaused || this.props.isAudioPaused || this.props.isPaused) {
	      this.playPauseAnim.progress(1);
	    }
	  };
	
	  PlayPauseButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // Play/Pause Button Animation
	    if (this.props.isVideoPaused !== nextProps.isVideoPaused || this.props.isAudioPaused !== nextProps.isAudioPaused || this.props.isPaused !== nextProps.isPaused) {
	      if (nextProps.isVideoPaused || nextProps.isAudioPaused || nextProps.isPaused) {
	        this.playPauseAnim.play();
	      } else {
	        this.playPauseAnim.reverse();
	      }
	    }
	  };
	
	  PlayPauseButton.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        className: 'play-pause-button ' + _PlayPauseButtonModule2.default.playPauseButton + ' ' + (!this.props.noBorder ? _PlayPauseButtonModule2.default.playPauseBorder : '') + ' ' + (!this.props.noBackground ? 'play-pause-bg ' + _PlayPauseButtonModule2.default.playPauseBackground : '') + ' ' + (this.props.largeButton ? _PlayPauseButtonModule2.default.playPauseLarge : '') + ' ' + (this.props.colorTheme ? _PlayPauseButtonModule2.default['color-' + this.props.colorTheme] : ''),
	        onClick: this.props.onPlayPauseClick
	      },
	      _react2.default.createElement(
	        'svg',
	        {
	          xmlns: 'http://www.w3.org/2000/svg',
	          width: '15',
	          height: '17',
	          viewBox: '0 0 15 17',
	          overflow: 'visible'
	        },
	        _react2.default.createElement(
	          'title',
	          null,
	          'Play/Pause Button'
	        ),
	        _react2.default.createElement('polygon', {
	          ref: function ref(el) {
	            return _this2.playPauseLeft = el;
	          },
	          points: '5,17 2.5,17 0,17 0,8.5 0,0 2.5,0 5,0 5,8.5 '
	        }),
	        _react2.default.createElement('polygon', {
	          ref: function ref(el) {
	            return _this2.playPauseRight = el;
	          },
	          points: '15,17 12.5,17 10,17 10,8.5 10,0 12.5,0 15,0 15,8.5 '
	        }),
	        !this.props.noBorder && _react2.default.createElement('circle', {
	          stroke: 'white',
	          strokeWidth: '2',
	          fill: 'none',
	          cx: '50%',
	          cy: '50%',
	          r: '135%'
	        })
	      )
	    );
	  };
	
	  return PlayPauseButton;
	}(_react.Component);
	
	exports.default = PlayPauseButton;
	module.exports = exports['default'];

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gsap = __webpack_require__(11);
	
	var _CustomEase = __webpack_require__(142);
	
	var _CustomEase2 = _interopRequireDefault(_CustomEase);
	
	var _PixiPlugin = __webpack_require__(160);
	
	var _PixiPlugin2 = _interopRequireDefault(_PixiPlugin);
	
	var _getCoverSize2 = __webpack_require__(186);
	
	var _getCoverSize3 = _interopRequireDefault(_getCoverSize2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PIXI = void 0;
	if (typeof window !== 'undefined') {
	  PIXI = __webpack_require__(33);
	}
	
	
	_CustomEase2.default.create('swoop', '0.5, 0, 0.5, 1');
	var tabletBreakpoint = 992;
	var mobileBreakpoint = 768;
	var AUTOPLAYER_HEIGHT = 45;
	
	var FramedImage = function () {
	  function FramedImage(app, imgSrc, addSelfToStage) {
	    var focalX = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
	
	    var _this = this;
	
	    var focalY = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.5;
	    var screenAlpha = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	    _classCallCheck(this, FramedImage);
	
	    this.setup = function (callback) {
	      _this.sprite = new PIXI.Sprite(_this.loader.resources[_this.imgSrc].texture);
	      _this.imgContainer = new PIXI.Container();
	      _this.imgContainer.addChild(_this.sprite);
	      _this.mask = new PIXI.Graphics();
	      _this.mask.beginFill(0x000000);
	      _this.mask.drawRect(0, 0, 1, 1);
	      _this.mask.endFill();
	
	      _this.screen = new PIXI.Graphics();
	      _this.screen.beginFill(0x000000);
	      _this.screen.drawRect(0, 0, 1, 1);
	      _this.screen.endFill();
	      _this.screen.scale.x = window.innerWidth;
	      _this.screen.scale.y = window.innerHeight;
	
	      _this.screen.alpha = _this.screenAlpha;
	      _this.imgContainer.addChild(_this.screen);
	      _this.imgContainer.mask = _this.mask;
	
	      if (_this.addSelfToStage) {
	        _this.app.stage.addChild(_this.mask);
	        _this.app.stage.addChild(_this.imgContainer);
	      }
	
	      _this.naturalSize = {
	        width: _this.sprite.texture.orig.width,
	        height: _this.sprite.texture.orig.height
	      };
	      _this.imgContainer.visible = false;
	      if (callback) {
	        callback();
	      }
	    };
	
	    // reference to PIXI app
	    this.addSelfToStage = addSelfToStage;
	    this.app = app;
	    this.imgSrc = imgSrc;
	    this.screenAlpha = screenAlpha;
	    this.focalPoint = { x: focalX, y: focalY };
	    this.isContracted = false;
	    // how much does slide contract during slider transition
	    this.frameContractAmount = 0.87;
	    this.imgContractAmount = 0.95;
	
	    this.loader = new PIXI.loaders.Loader();
	  }
	
	  FramedImage.prototype.load = function load() {
	    var _this2 = this;
	
	    return new Promise(function (resolve, reject) {
	      if (!_this2.loader.resources[_this2.imgSrc]) {
	        _this2.loader.add(_this2.imgSrc).load(function () {
	          _this2.setup(resolve);
	        });
	      } else {
	        _this2.setup(resolve);
	      }
	    });
	  };
	
	  FramedImage.prototype.sliderSize = function sliderSize(contracted) {
	    // if contracted, get the size it woudl be in the contracted slider
	    var windowWidth = window.innerWidth;
	    var windowHeight = window.innerHeight;
	    var width = void 0,
	        height = void 0,
	        x = void 0,
	        y = void 0;
	
	    if (windowWidth >= tabletBreakpoint) {
	      // desktop size
	      // 62% of a centered 92% container
	      var containerSize = windowWidth * 0.92;
	
	      width = containerSize * 0.62 - containerSize * 0.07;
	      height = windowHeight - (170 + AUTOPLAYER_HEIGHT); //100px from top and 70px from bottom
	      // x = windowWidth * 0.4 + windowWidth * 0.92 * 0.38;
	      x = windowWidth * 0.04 + containerSize * 0.38;
	      y = 100 + AUTOPLAYER_HEIGHT * 0.5;
	    } else if (windowWidth >= mobileBreakpoint) {
	      width = windowWidth - 60;
	      height = windowHeight - (130 + AUTOPLAYER_HEIGHT);
	      x = 30;
	      y = 100;
	    } else {
	      // mobile: 30px pad
	      width = windowWidth - 40;
	      height = windowHeight - (127 + AUTOPLAYER_HEIGHT);
	      x = 20;
	      y = 107;
	    }
	    if (contracted) {
	      width *= this.frameContractAmount;
	      height *= this.frameContractAmount;
	      x += (1 - this.frameContractAmount) * width / 2;
	      y += (1 - this.frameContractAmount) * height / 2;
	    }
	    return [width, height, x, y];
	  };
	  // contract and expand between for slider transition
	
	
	  FramedImage.prototype.contract = function contract() {
	    var inverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.75;
	
	    if (this.isContracted && !inverse || !this.isContracted && inverse) {
	      return;
	    }
	    this.isContracted = !inverse;
	    var scaleAmount = inverse ? 1 / this.frameContractAmount : this.frameContractAmount;
	    var startLeft = this.mask.position.x;
	    var startTop = this.mask.position.y;
	    var startWidth = this.mask.scale.x;
	    var startHeight = this.mask.scale.y;
	    var scaleX = this.mask.scale.x * scaleAmount;
	    var scaleY = this.mask.scale.y * scaleAmount;
	    _gsap.TweenLite.to(this.mask, duration, {
	      pixi: {
	        x: startLeft + (startWidth - scaleX) / 2,
	        y: startTop + (startHeight - scaleY) / 2,
	        scaleX: scaleX,
	        scaleY: scaleY
	      },
	      ease: Power1.easeInOut
	    });
	
	    var imgScaleAmount = inverse ? 1 / this.imgContractAmount : this.imgContractAmount;
	    var imgStartScale = this.sprite.scale.x;
	    var imgStartLeft = this.sprite.position.x;
	    var imgStartTop = this.sprite.position.y;
	    var imgStartWidth = this.naturalSize.width * imgStartScale;
	    var imgStartHeight = this.naturalSize.height * imgStartScale;
	    var imgScale = this.sprite.scale.x * imgScaleAmount;
	    var imgFinishWidth = this.naturalSize.width * imgScale;
	    var imgFinishHeight = this.naturalSize.height * imgScale;
	
	    _gsap.TweenLite.to(this.sprite, duration, {
	      pixi: {
	        scale: imgScale,
	        x: imgStartLeft - (imgFinishWidth - imgStartWidth) / 2,
	        y: imgStartTop - (imgFinishHeight - imgStartHeight) / 2
	      },
	      ease: Power1.easeInOut
	    });
	  };
	
	  FramedImage.prototype.expand = function expand(duration) {
	    // inverse of contract
	    this.contract(true, duration);
	  };
	
	  FramedImage.prototype.setVisible = function setVisible() {
	    var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    this.imgContainer.visible = bool;
	  };
	
	  FramedImage.prototype.drawAtSliderSize = function drawAtSliderSize() {
	    var alpha = window.innerWidth < tabletBreakpoint ? 0.4 : 0;
	    this.setImageSize(this.getStartSize('full'));
	    this.panDownTo.apply(this, this.sliderSize().concat([0, null, alpha]));
	
	    this.imgContainer.visible = true;
	  };
	
	  FramedImage.prototype.screenToSlider = function screenToSlider(type, drawCallback, completeCallback) {
	    var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
	    var startScreenAlpha = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.4;
	
	    var _this3 = this;
	
	    var endScreenAlpha = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	    var currentSlideIndex = arguments[6];
	
	    // promise so you can chain with .then
	    return new Promise(function (resolve, reject) {
	      var startSize = _this3.getStartSize(type, currentSlideIndex);
	      _this3.setImageSize(startSize);
	      _this3.screen.alpha = startScreenAlpha;
	      _this3.imgContainer.visible = true;
	      if (drawCallback) {
	        drawCallback();
	      }
	      _this3.panDownTo.apply(_this3, _this3.sliderSize(true).concat([duration, resolve, endScreenAlpha]));
	    });
	  };
	
	  FramedImage.prototype.chapterOpenPan = function chapterOpenPan(onComplete) {
	    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var size = this.getCoverSize({
	      width: window.innerWidth,
	      height: window.innerHeight,
	      x: 0,
	      y: 0
	    });
	
	    this.panTo(size.imgSize.scale, size.imgSize.transform.x, size.imgSize.transform.y, size.frameSize.width, size.frameSize.height, size.frameSize.x, size.frameSize.y, 1, onComplete, alpha, 'swoop');
	  };
	  // {width: , height: , x: , y: ,}
	
	
	  FramedImage.prototype.panToCoverSize = function panToCoverSize(size) {
	    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    var onComplete = arguments[2];
	    var isImageFixed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    var screenAlpha = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	    var coverSize = this.getCoverSize(size);
	    var imgFullSize = this.getCoverSize({
	      width: window.innerWidth,
	      height: window.innerHeight,
	      x: 0,
	      y: 0
	    });
	
	    this.panTo(isImageFixed ? imgFullSize.imgSize.scale : coverSize.imgSize.scale, isImageFixed ? imgFullSize.imgSize.transform.x : coverSize.imgSize.transform.x, isImageFixed ? imgFullSize.imgSize.transform.y : coverSize.imgSize.transform.y, coverSize.frameSize.width, coverSize.frameSize.height, coverSize.frameSize.x, coverSize.frameSize.y, duration, onComplete, screenAlpha);
	  };
	
	  FramedImage.prototype.panDownTo = function panDownTo(width, height) {
	    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var duration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.25;
	    var callback = arguments[5];
	    var alpha = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	    var ease = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : Power3.easeInOut;
	
	    // Pan from fullwidth size to a new size, using focal point
	
	    // for now, go from what is full bleed scale to 90% of that
	    var scaleAmount = 0.9;
	
	    var targetScale = this.sprite.scale.x * scaleAmount;
	    var frameCenter = {
	      x: x + width / 2,
	      y: y + height / 2
	    };
	    var scaledWidth = this.naturalSize.width * targetScale;
	    var scaledHeight = this.naturalSize.height * targetScale;
	    var imgX = void 0,
	        imgY = void 0;
	
	    // figure out if at its scaled size, if you centered the focal point of the image
	    // would you end up seeing the edge. If so, push it back to be flush agasint that edge
	    if (scaledWidth * this.focalPoint.x <= width / 2) {
	      // make it flush left
	      imgX = x;
	    } else if (scaledWidth * (1 - this.focalPoint.x) <= width / 2) {
	      // make it flush right
	      imgX = width + x - scaledWidth;
	    } else {
	      // center focal x
	      imgX = frameCenter.x - scaledWidth * this.focalPoint.x;
	    }
	    if (scaledHeight * this.focalPoint.y <= height / 2) {
	      // make it flush top
	      imgY = y;
	    } else if (scaledHeight * (1 - this.focalPoint.y) <= height / 2) {
	      // make it flush bottom
	      imgY = height + y - scaledHeight;
	    } else {
	      // center focal y
	      imgY = frameCenter.y - scaledHeight * this.focalPoint.y;
	    }
	    this.panTo(targetScale, imgX, imgY, width, height, x, y, duration, callback, alpha, ease);
	  };
	
	  FramedImage.prototype.panTo = function panTo(imgScale, imgX, imgY, maskWidth, maskHeight, maskX, maskY) {
	    var duration = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1;
	    var callback = arguments[8];
	    var screenAlpha = arguments[9];
	    var ease = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 'swoop';
	
	    _gsap.TweenLite.to(this.screen, duration, {
	      pixi: {
	        alpha: screenAlpha
	      },
	      ease: ease
	    });
	    _gsap.TweenLite.to(this.sprite, duration, {
	      pixi: {
	        scale: imgScale,
	        x: imgX,
	        y: imgY
	      },
	      ease: ease,
	      onComplete: function onComplete() {
	        if (callback) callback();
	      }
	    });
	    _gsap.TweenLite.to(this.mask, duration, {
	      pixi: {
	        x: maskX,
	        y: maskY,
	        scaleX: maskWidth,
	        scaleY: maskHeight
	      },
	      ease: ease
	    });
	  };
	
	  FramedImage.prototype.getStartSize = function getStartSize(type, currentSlideIndex) {
	    var windowWidth = window.innerWidth;
	    var windowHeight = window.innerHeight;
	    switch (type) {
	      case 'half-left':
	        if (windowWidth <= 768) {
	          if (typeof currentSlideIndex !== 'undefined') {
	            if (currentSlideIndex === 0) {
	              return {
	                width: windowWidth,
	                height: windowHeight,
	                x: 0,
	                y: 0
	              };
	            }
	          }
	          return {
	            width: windowWidth,
	            height: windowHeight * 0.7,
	            x: 0,
	            y: 0
	          };
	        } else if (currentSlideIndex === 0) {
	          return {
	            width: windowWidth,
	            height: windowHeight,
	            x: 0,
	            y: 0
	          };
	        }
	        return {
	          width: windowWidth / 2,
	          height: windowHeight,
	          x: 0,
	          y: 0
	        };
	      case 'half-right':
	        if (windowWidth <= 768) {
	          if (typeof currentSlideIndex !== 'undefined') {
	            if (currentSlideIndex === 0) {
	              return {
	                width: windowWidth,
	                height: windowHeight,
	                x: 0,
	                y: 0
	              };
	            }
	          }
	          return {
	            width: windowWidth,
	            height: windowHeight * 0.7,
	            x: 0,
	            y: 0
	          };
	        } else if (currentSlideIndex === 0) {
	          return {
	            width: windowWidth,
	            height: windowHeight,
	            x: 0,
	            y: 0
	          };
	        }
	        return {
	          width: windowWidth / 2,
	          height: windowHeight,
	          x: windowWidth / 2,
	          y: 0
	        };
	      case 'center':
	        return {
	          width: windowWidth * 0.46,
	          height: windowHeight,
	          x: windowWidth * 0.27,
	          y: 0
	        };
	      default:
	        // full width
	        return {
	          width: window.innerWidth,
	          height: window.innerHeight,
	          x: 0,
	          y: 0
	        };
	    }
	  };
	  // { width:_ , height:_, x:_, y:_ }
	
	
	  FramedImage.prototype.setImageSize = function setImageSize(frameSize) {
	    var isImageFixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var screenAlpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    var dimensions = this.getCoverSize(frameSize);
	    this.mask.scale.set(dimensions.frameSize.width, dimensions.frameSize.height);
	    this.mask.position.set(dimensions.frameSize.x, dimensions.frameSize.y);
	    this.screen.alpha = screenAlpha;
	    this.screen.scale.x = window.innerWidth;
	    this.screen.scale.y = window.innerHeight;
	    if (isImageFixed) {
	      var imgDimensions = this.getCoverSize({
	        width: window.innerWidth,
	        height: window.innerHeight,
	        x: 0,
	        y: 0
	      });
	      this.sprite.scale.set(imgDimensions.imgSize.scale);
	      this.sprite.position.set(imgDimensions.imgSize.transform.x, imgDimensions.imgSize.transform.y);
	    } else {
	      this.sprite.scale.set(dimensions.imgSize.scale);
	      this.sprite.position.set(dimensions.imgSize.transform.x, dimensions.imgSize.transform.y);
	    }
	  };
	
	  // { width:_ , height:_, x:_, y:_ }
	
	
	  FramedImage.prototype.getCoverSize = function getCoverSize(frameSize) {
	    // given a frame size and position, get the image transform and scale to match
	    // a CSS cover
	    return {
	      frameSize: frameSize,
	      imgSize: (0, _getCoverSize3.default)(frameSize, this.naturalSize)
	    };
	  };
	
	  return FramedImage;
	}();
	
	exports.default = FramedImage;
	module.exports = exports['default'];

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var MiniSignalBinding = (function () {
	  function MiniSignalBinding(fn, once, thisArg) {
	    if (once === undefined) once = false;
	
	    _classCallCheck(this, MiniSignalBinding);
	
	    this._fn = fn;
	    this._once = once;
	    this._thisArg = thisArg;
	    this._next = this._prev = this._owner = null;
	  }
	
	  _createClass(MiniSignalBinding, [{
	    key: 'detach',
	    value: function detach() {
	      if (this._owner === null) return false;
	      this._owner.detach(this);
	      return true;
	    }
	  }]);
	
	  return MiniSignalBinding;
	})();
	
	function _addMiniSignalBinding(self, node) {
	  if (!self._head) {
	    self._head = node;
	    self._tail = node;
	  } else {
	    self._tail._next = node;
	    node._prev = self._tail;
	    self._tail = node;
	  }
	
	  node._owner = self;
	
	  return node;
	}
	
	var MiniSignal = (function () {
	  function MiniSignal() {
	    _classCallCheck(this, MiniSignal);
	
	    this._head = this._tail = undefined;
	  }
	
	  _createClass(MiniSignal, [{
	    key: 'handlers',
	    value: function handlers() {
	      var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      var node = this._head;
	
	      if (exists) return !!node;
	
	      var ee = [];
	
	      while (node) {
	        ee.push(node);
	        node = node._next;
	      }
	
	      return ee;
	    }
	  }, {
	    key: 'has',
	    value: function has(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
	      }
	
	      return node._owner === this;
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch() {
	      var node = this._head;
	
	      if (!node) return false;
	
	      while (node) {
	        if (node._once) this.detach(node);
	        node._fn.apply(node._thisArg, arguments);
	        node = node._next;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'add',
	    value: function add(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#add(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
	    }
	  }, {
	    key: 'once',
	    value: function once(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#once(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
	    }
	  }, {
	    key: 'detach',
	    value: function detach(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
	      }
	      if (node._owner !== this) return this;
	
	      if (node._prev) node._prev._next = node._next;
	      if (node._next) node._next._prev = node._prev;
	
	      if (node === this._head) {
	        this._head = node._next;
	        if (node._next === null) {
	          this._tail = null;
	        }
	      } else if (node === this._tail) {
	        this._tail = node._prev;
	        this._tail._next = null;
	      }
	
	      node._owner = null;
	      return this;
	    }
	  }, {
	    key: 'detachAll',
	    value: function detachAll() {
	      var node = this._head;
	      if (!node) return this;
	
	      this._head = this._tail = null;
	
	      while (node) {
	        node._owner = null;
	        node = node._next;
	      }
	      return this;
	    }
	  }]);
	
	  return MiniSignal;
	})();
	
	MiniSignal.MiniSignalBinding = MiniSignalBinding;
	
	exports['default'] = MiniSignal;
	module.exports = exports['default'];


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = function parseURI (str, opts) {
	  opts = opts || {}
	
	  var o = {
	    key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
	    q: {
	      name: 'queryKey',
	      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	    },
	    parser: {
	      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
	      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	    }
	  }
	
	  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str)
	  var uri = {}
	  var i = 14
	
	  while (i--) uri[o.key[i]] = m[i] || ''
	
	  uri[o.q.name] = {}
	  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
	    if ($1) uri[o.q.name][$1] = $2
	  })
	
	  return uri
	}


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	
	/**
	 * Helper class to create a WebGL Texture
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param width {number} the width of the texture
	 * @param height {number} the height of the texture
	 * @param format {number} the pixel format of the texture. defaults to gl.RGBA
	 * @param type {number} the gl type of the texture. defaults to gl.UNSIGNED_BYTE
	 */
	var Texture = function(gl, width, height, format, type)
	{
		/**
		 * The current WebGL rendering context
		 *
		 * @member {WebGLRenderingContext}
		 */
		this.gl = gl;
	
	
		/**
		 * The WebGL texture
		 *
		 * @member {WebGLTexture}
		 */
		this.texture = gl.createTexture();
	
		/**
		 * If mipmapping was used for this texture, enable and disable with enableMipmap()
		 *
		 * @member {Boolean}
		 */
		// some settings..
		this.mipmap = false;
	
	
		/**
		 * Set to true to enable pre-multiplied alpha
		 *
		 * @member {Boolean}
		 */
		this.premultiplyAlpha = false;
	
		/**
		 * The width of texture
		 *
		 * @member {Number}
		 */
		this.width = width || -1;
		/**
		 * The height of texture
		 *
		 * @member {Number}
		 */
		this.height = height || -1;
	
		/**
		 * The pixel format of the texture. defaults to gl.RGBA
		 *
		 * @member {Number}
		 */
		this.format = format || gl.RGBA;
	
		/**
		 * The gl type of the texture. defaults to gl.UNSIGNED_BYTE
		 *
		 * @member {Number}
		 */
		this.type = type || gl.UNSIGNED_BYTE;
	
	
	};
	
	/**
	 * Uploads this texture to the GPU
	 * @param source {HTMLImageElement|ImageData|HTMLVideoElement} the source image of the texture
	 */
	Texture.prototype.upload = function(source)
	{
		this.bind();
	
		var gl = this.gl;
	
	
		gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
	
		var newWidth = source.videoWidth || source.width;
		var newHeight = source.videoHeight || source.height;
	
		if(newHeight !== this.height || newWidth !== this.width)
		{
			gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, source);
		}
		else
		{
	    	gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.format, this.type, source);
		}
	
		// if the source is a video, we need to use the videoWidth / videoHeight properties as width / height will be incorrect.
		this.width = newWidth;
		this.height = newHeight;
	
	};
	
	var FLOATING_POINT_AVAILABLE = false;
	
	/**
	 * Use a data source and uploads this texture to the GPU
	 * @param data {TypedArray} the data to upload to the texture
	 * @param width {number} the new width of the texture
	 * @param height {number} the new height of the texture
	 */
	Texture.prototype.uploadData = function(data, width, height)
	{
		this.bind();
	
		var gl = this.gl;
	
	
		if(data instanceof Float32Array)
		{
			if(!FLOATING_POINT_AVAILABLE)
			{
				var ext = gl.getExtension("OES_texture_float");
	
				if(ext)
				{
					FLOATING_POINT_AVAILABLE = true;
				}
				else
				{
					throw new Error('floating point textures not available');
				}
			}
	
			this.type = gl.FLOAT;
		}
		else
		{
			// TODO support for other types
			this.type = this.type || gl.UNSIGNED_BYTE;
		}
	
		// what type of data?
		gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
	
	
		if(width !== this.width || height !== this.height)
		{
			gl.texImage2D(gl.TEXTURE_2D, 0, this.format,  width, height, 0, this.format, this.type, data || null);
		}
		else
		{
			gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, this.format, this.type, data || null);
		}
	
		this.width = width;
		this.height = height;
	
	
	//	texSubImage2D
	};
	
	/**
	 * Binds the texture
	 * @param  location
	 */
	Texture.prototype.bind = function(location)
	{
		var gl = this.gl;
	
		if(location !== undefined)
		{
			gl.activeTexture(gl.TEXTURE0 + location);
		}
	
		gl.bindTexture(gl.TEXTURE_2D, this.texture);
	};
	
	/**
	 * Unbinds the texture
	 */
	Texture.prototype.unbind = function()
	{
		var gl = this.gl;
		gl.bindTexture(gl.TEXTURE_2D, null);
	};
	
	/**
	 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
	 */
	Texture.prototype.minFilter = function( linear )
	{
		var gl = this.gl;
	
		this.bind();
	
		if(this.mipmap)
		{
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
		}
		else
		{
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR : gl.NEAREST);
		}
	};
	
	/**
	 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
	 */
	Texture.prototype.magFilter = function( linear )
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, linear ? gl.LINEAR : gl.NEAREST);
	};
	
	/**
	 * Enables mipmapping
	 */
	Texture.prototype.enableMipmap = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		this.mipmap = true;
	
		gl.generateMipmap(gl.TEXTURE_2D);
	};
	
	/**
	 * Enables linear filtering
	 */
	Texture.prototype.enableLinearScaling = function()
	{
		this.minFilter(true);
		this.magFilter(true);
	};
	
	/**
	 * Enables nearest neighbour interpolation
	 */
	Texture.prototype.enableNearestScaling = function()
	{
		this.minFilter(false);
		this.magFilter(false);
	};
	
	/**
	 * Enables clamping on the texture so WebGL will not repeat it
	 */
	Texture.prototype.enableWrapClamp = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	};
	
	/**
	 * Enable tiling on the texture
	 */
	Texture.prototype.enableWrapRepeat = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
	};
	
	Texture.prototype.enableWrapMirrorRepeat = function()
	{
		var gl = this.gl;
	
		this.bind();
	
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
	};
	
	
	/**
	 * Destroys this texture
	 */
	Texture.prototype.destroy = function()
	{
		var gl = this.gl;
		//TODO
		gl.deleteTexture(this.texture);
	};
	
	/**
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param source {HTMLImageElement|ImageData} the source image of the texture
	 * @param premultiplyAlpha {Boolean} If we want to use pre-multiplied alpha
	 */
	Texture.fromSource = function(gl, source, premultiplyAlpha)
	{
		var texture = new Texture(gl);
		texture.premultiplyAlpha = premultiplyAlpha || false;
		texture.upload(source);
	
		return texture;
	};
	
	/**
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param data {TypedArray} the data to upload to the texture
	 * @param width {number} the new width of the texture
	 * @param height {number} the new height of the texture
	 */
	Texture.fromData = function(gl, data, width, height)
	{
		//console.log(data, width, height);
		var texture = new Texture(gl);
		texture.uploadData(data, width, height);
	
		return texture;
	};
	
	
	module.exports = Texture;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// var GL_MAP = {};
	
	/**
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param attribs {*}
	 * @param state {*}
	 */
	var setVertexAttribArrays = function (gl, attribs, state)
	{
	    var i;
	    if(state)
	    {
	        var tempAttribState = state.tempAttribState,
	            attribState = state.attribState;
	
	        for (i = 0; i < tempAttribState.length; i++)
	        {
	            tempAttribState[i] = false;
	        }
	
	        // set the new attribs
	        for (i = 0; i < attribs.length; i++)
	        {
	            tempAttribState[attribs[i].attribute.location] = true;
	        }
	
	        for (i = 0; i < attribState.length; i++)
	        {
	            if (attribState[i] !== tempAttribState[i])
	            {
	                attribState[i] = tempAttribState[i];
	
	                if (state.attribState[i])
	                {
	                    gl.enableVertexAttribArray(i);
	                }
	                else
	                {
	                    gl.disableVertexAttribArray(i);
	                }
	            }
	        }
	
	    }
	    else
	    {
	        for (i = 0; i < attribs.length; i++)
	        {
	            var attrib = attribs[i];
	            gl.enableVertexAttribArray(attrib.attribute.location);
	        }
	    }
	};
	
	module.exports = setVertexAttribArrays;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	
	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param attributeLocations {Object} An attribute location map that lets you manually set the attribute locations
	 * @return {WebGLProgram} the shader program
	 */
	var compileProgram = function(gl, vertexSrc, fragmentSrc, attributeLocations)
	{
	    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
	    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);
	
	    var program = gl.createProgram();
	
	    gl.attachShader(program, glVertShader);
	    gl.attachShader(program, glFragShader);
	
	    // optionally, set the attributes manually for the program rather than letting WebGL decide..
	    if(attributeLocations)
	    {
	        for(var i in attributeLocations)
	        {
	            gl.bindAttribLocation(program, attributeLocations[i], i);
	        }
	    }
	
	
	    gl.linkProgram(program);
	
	    // if linking fails, then log and cleanup
	    if (!gl.getProgramParameter(program, gl.LINK_STATUS))
	    {
	        console.error('Pixi.js Error: Could not initialize shader.');
	        console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
	        console.error('gl.getError()', gl.getError());
	
	        // if there is a program info log, log it
	        if (gl.getProgramInfoLog(program) !== '')
	        {
	            console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
	        }
	
	        gl.deleteProgram(program);
	        program = null;
	    }
	
	    // clean up some shaders
	    gl.deleteShader(glVertShader);
	    gl.deleteShader(glFragShader);
	
	    return program;
	};
	
	/**
	 * @private
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param type {Number} the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @return {WebGLShader} the shader
	 */
	var compileShader = function (gl, type, src)
	{
	    var shader = gl.createShader(type);
	
	    gl.shaderSource(shader, src);
	    gl.compileShader(shader);
	
	    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
	    {
	        console.log(gl.getShaderInfoLog(shader));
	        return null;
	    }
	
	    return shader;
	};
	
	module.exports = compileProgram;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param type {String} Type of value
	 * @param size {Number}
	 */
	var defaultValue = function(type, size) 
	{
	    switch (type)
	    {
	        case 'float':
	            return 0;
	
	        case 'vec2': 
	            return new Float32Array(2 * size);
	
	        case 'vec3':
	            return new Float32Array(3 * size);
	
	        case 'vec4':     
	            return new Float32Array(4 * size);
	            
	        case 'int':
	        case 'sampler2D':
	            return 0;
	
	        case 'ivec2':   
	            return new Int32Array(2 * size);
	
	        case 'ivec3':
	            return new Int32Array(3 * size);
	
	        case 'ivec4': 
	            return new Int32Array(4 * size);
	
	        case 'bool':     
	            return false;
	
	        case 'bvec2':
	
	            return booleanArray( 2 * size);
	
	        case 'bvec3':
	            return booleanArray(3 * size);
	
	        case 'bvec4':
	            return booleanArray(4 * size);
	
	        case 'mat2':
	            return new Float32Array([1, 0,
	                                     0, 1]);
	
	        case 'mat3': 
	            return new Float32Array([1, 0, 0,
	                                     0, 1, 0,
	                                     0, 0, 1]);
	
	        case 'mat4':
	            return new Float32Array([1, 0, 0, 0,
	                                     0, 1, 0, 0,
	                                     0, 0, 1, 0,
	                                     0, 0, 0, 1]);
	    }
	};
	
	var booleanArray = function(size)
	{
	    var array = new Array(size);
	
	    for (var i = 0; i < array.length; i++) 
	    {
	        array[i] = false;
	    }
	
	    return array;
	};
	
	module.exports = defaultValue;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	
	var mapType = __webpack_require__(57);
	var mapSize = __webpack_require__(98);
	
	/**
	 * Extracts the attributes
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param program {WebGLProgram} The shader program to get the attributes from
	 * @return attributes {Object}
	 */
	var extractAttributes = function(gl, program)
	{
	    var attributes = {};
	
	    var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
	
	    for (var i = 0; i < totalAttributes; i++)
	    {
	        var attribData = gl.getActiveAttrib(program, i);
	        var type = mapType(gl, attribData.type);
	
	        attributes[attribData.name] = {
	            type:type,
	            size:mapSize(type),
	            location:gl.getAttribLocation(program, attribData.name),
	            //TODO - make an attribute object
	            pointer: pointer
	        };
	    }
	
	    return attributes;
	};
	
	var pointer = function(type, normalized, stride, start){
	    // console.log(this.location)
	    gl.vertexAttribPointer(this.location,this.size, type || gl.FLOAT, normalized || false, stride || 0, start || 0);
	};
	
	module.exports = extractAttributes;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var mapType = __webpack_require__(57);
	var defaultValue = __webpack_require__(94);
	
	/**
	 * Extracts the uniforms
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param program {WebGLProgram} The shader program to get the uniforms from
	 * @return uniforms {Object}
	 */
	var extractUniforms = function(gl, program)
	{
		var uniforms = {};
	
	    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
	
	    for (var i = 0; i < totalUniforms; i++)
	    {
	    	var uniformData = gl.getActiveUniform(program, i);
	    	var name = uniformData.name.replace(/\[.*?\]/, "");
	        var type = mapType(gl, uniformData.type );
	
	    	uniforms[name] = {
	    		type:type,
	    		size:uniformData.size,
	    		location:gl.getUniformLocation(program, name),
	    		value:defaultValue(type, uniformData.size)
	    	};
	    }
	
		return uniforms;
	};
	
	module.exports = extractUniforms;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	/**
	 * Extracts the attributes
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param uniforms {Array} @mat ?
	 * @return attributes {Object}
	 */
	var generateUniformAccessObject = function(gl, uniformData)
	{
	    // this is the object we will be sending back.
	    // an object hierachy will be created for structs
	    var uniforms = {data:{}};
	
	    uniforms.gl = gl;
	
	    var uniformKeys= Object.keys(uniformData);
	
	    for (var i = 0; i < uniformKeys.length; i++)
	    {
	        var fullName = uniformKeys[i];
	
	        var nameTokens = fullName.split('.');
	        var name = nameTokens[nameTokens.length - 1];
	
	
	        var uniformGroup = getUniformGroup(nameTokens, uniforms);
	
	        var uniform =  uniformData[fullName];
	        uniformGroup.data[name] = uniform;
	
	        uniformGroup.gl = gl;
	
	        Object.defineProperty(uniformGroup, name, {
	            get: generateGetter(name),
	            set: generateSetter(name, uniform)
	        });
	    }
	
	    return uniforms;
	};
	
	var generateGetter = function(name)
	{
	    return function() {
	        return this.data[name].value;
	    };
	};
	
	var GLSL_SINGLE_SETTERS = {
	    float: function setSingleFloat(gl, location, value) { gl.uniform1f(location, value); },
	    vec2: function setSingleVec2(gl, location, value) { gl.uniform2f(location, value[0], value[1]); },
	    vec3: function setSingleVec3(gl, location, value) { gl.uniform3f(location, value[0], value[1], value[2]); },
	    vec4: function setSingleVec4(gl, location, value) { gl.uniform4f(location, value[0], value[1], value[2], value[3]); },
	
	    int: function setSingleInt(gl, location, value) { gl.uniform1i(location, value); },
	    ivec2: function setSingleIvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
	    ivec3: function setSingleIvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
	    ivec4: function setSingleIvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },
	
	    bool: function setSingleBool(gl, location, value) { gl.uniform1i(location, value); },
	    bvec2: function setSingleBvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
	    bvec3: function setSingleBvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
	    bvec4: function setSingleBvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },
	
	    mat2: function setSingleMat2(gl, location, value) { gl.uniformMatrix2fv(location, false, value); },
	    mat3: function setSingleMat3(gl, location, value) { gl.uniformMatrix3fv(location, false, value); },
	    mat4: function setSingleMat4(gl, location, value) { gl.uniformMatrix4fv(location, false, value); },
	
	    sampler2D: function setSingleSampler2D(gl, location, value) { gl.uniform1i(location, value); },
	};
	
	var GLSL_ARRAY_SETTERS = {
	    float: function setFloatArray(gl, location, value) { gl.uniform1fv(location, value); },
	    vec2: function setVec2Array(gl, location, value) { gl.uniform2fv(location, value); },
	    vec3: function setVec3Array(gl, location, value) { gl.uniform3fv(location, value); },
	    vec4: function setVec4Array(gl, location, value) { gl.uniform4fv(location, value); },
	    int: function setIntArray(gl, location, value) { gl.uniform1iv(location, value); },
	    ivec2: function setIvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
	    ivec3: function setIvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
	    ivec4: function setIvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
	    bool: function setBoolArray(gl, location, value) { gl.uniform1iv(location, value); },
	    bvec2: function setBvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
	    bvec3: function setBvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
	    bvec4: function setBvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
	    sampler2D: function setSampler2DArray(gl, location, value) { gl.uniform1iv(location, value); },
	};
	
	function generateSetter(name, uniform)
	{
	    return function(value) {
	        this.data[name].value = value;
	        var location = this.data[name].location;
	        if (uniform.size === 1)
	        {
	            GLSL_SINGLE_SETTERS[uniform.type](this.gl, location, value);
	        }
	        else
	        {
	            // glslSetArray(gl, location, type, value) {
	            GLSL_ARRAY_SETTERS[uniform.type](this.gl, location, value);
	        }
	    };
	}
	
	function getUniformGroup(nameTokens, uniform)
	{
	    var cur = uniform;
	
	    for (var i = 0; i < nameTokens.length - 1; i++)
	    {
	        var o = cur[nameTokens[i]] || {data:{}};
	        cur[nameTokens[i]] = o;
	        cur = o;
	    }
	
	    return cur;
	}
	
	
	module.exports = generateUniformAccessObject;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param type {String}
	 * @return {Number}
	 */
	var mapSize = function(type) 
	{ 
	    return GLSL_TO_SIZE[type];
	};
	
	
	var GLSL_TO_SIZE = {
	    'float':    1,
	    'vec2':     2,
	    'vec3':     3,
	    'vec4':     4,
	
	    'int':      1,
	    'ivec2':    2,
	    'ivec3':    3,
	    'ivec4':    4,
	
	    'bool':     1,
	    'bvec2':    2,
	    'bvec3':    3,
	    'bvec4':    4,
	
	    'mat2':     4,
	    'mat3':     9,
	    'mat4':     16,
	
	    'sampler2D':  1
	};
	
	module.exports = mapSize;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	/**
	 * Sets the float precision on the shader. If the precision is already present this function will do nothing
	 * @param {string} src       the shader source
	 * @param {string} precision The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	 *
	 * @return {string} modified shader source
	 */
	var setPrecision = function(src, precision)
	{
	    if(src.substring(0, 9) !== 'precision')
	    {
	        return 'precision ' + precision + ' float;\n' + src;
	    }
	
	    return src;
	};
	
	module.exports = setPrecision;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Default property values of accessible objects
	 * used by {@link PIXI.accessibility.AccessibilityManager}.
	 *
	 * @function accessibleTarget
	 * @memberof PIXI.accessibility
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          MyObject.prototype,
	 *          PIXI.accessibility.accessibleTarget
	 *      );
	 */
	exports.default = {
	  /**
	   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
	   *   shadow div with attributes set
	   *
	   * @member {boolean}
	   */
	  accessible: false,
	
	  /**
	   * Sets the title attribute of the shadow div
	   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
	   *
	   * @member {string}
	   */
	  accessibleTitle: null,
	
	  /**
	   * Sets the aria-label attribute of the shadow div
	   *
	   * @member {string}
	   */
	  accessibleHint: null,
	
	  /**
	   * @todo Needs docs.
	   */
	  tabIndex: 0,
	
	  /**
	   * @todo Needs docs.
	   */
	  _accessibleActive: false,
	
	  /**
	   * @todo Needs docs.
	   */
	  _accessibleDiv: false
	};
	//# sourceMappingURL=accessibleTarget.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _autoDetectRenderer = __webpack_require__(102);
	
	var _Container = __webpack_require__(27);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ticker = __webpack_require__(66);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _const = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Convenience class to create a new PIXI application.
	 * This class automatically creates the renderer, ticker
	 * and root container.
	 *
	 * @example
	 * // Create the application
	 * const app = new PIXI.Application();
	 *
	 * // Add the view to the DOM
	 * document.body.appendChild(app.view);
	 *
	 * // ex, add display objects
	 * app.stage.addChild(PIXI.Sprite.fromImage('something.png'));
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Application = function () {
	    // eslint-disable-next-line valid-jsdoc
	    /**
	     * @param {object} [options] - The optional renderer parameters
	     * @param {boolean} [options.autoStart=true] - automatically starts the rendering after the construction.
	     *     Note that setting this parameter to false does NOT stop the shared ticker even if you set
	     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
	     * @param {number} [options.width=800] - the width of the renderers view
	     * @param {number} [options.height=600] - the height of the renderers view
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
	     *  need to call toDataUrl on the webgl context
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
	     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *   not before the new render pass.
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	     *  stopping pixel interpolation.
	     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	     *  FXAA is faster, but may not always look as great **webgl only**
	     * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
	     *  If you experience unexplained flickering try setting this to true. **webgl only**
	     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	     *  for devices with dual graphics card **webgl only**
	     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.ticker.shared, `false` to create new ticker.
	     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.loaders.shared, `false` to create new Loader.
	     */
	    function Application(options, arg2, arg3, arg4, arg5) {
	        _classCallCheck(this, Application);
	
	        // Support for constructor(width, height, options, noWebGL, useSharedTicker)
	        if (typeof options === 'number') {
	            options = Object.assign({
	                width: options,
	                height: arg2 || _settings2.default.RENDER_OPTIONS.height,
	                forceCanvas: !!arg4,
	                sharedTicker: !!arg5
	            }, arg3);
	        }
	
	        /**
	         * The default options, so we mixin functionality later.
	         * @member {object}
	         * @protected
	         */
	        this._options = options = Object.assign({
	            autoStart: true,
	            sharedTicker: false,
	            forceCanvas: false,
	            sharedLoader: false
	        }, options);
	
	        /**
	         * WebGL renderer if available, otherwise CanvasRenderer
	         * @member {PIXI.WebGLRenderer|PIXI.CanvasRenderer}
	         */
	        this.renderer = (0, _autoDetectRenderer.autoDetectRenderer)(options);
	
	        /**
	         * The root display container that's rendered.
	         * @member {PIXI.Container}
	         */
	        this.stage = new _Container2.default();
	
	        /**
	         * Internal reference to the ticker
	         * @member {PIXI.ticker.Ticker}
	         * @private
	         */
	        this._ticker = null;
	
	        /**
	         * Ticker for doing render updates.
	         * @member {PIXI.ticker.Ticker}
	         * @default PIXI.ticker.shared
	         */
	        this.ticker = options.sharedTicker ? _ticker.shared : new _ticker.Ticker();
	
	        // Start the rendering
	        if (options.autoStart) {
	            this.start();
	        }
	    }
	
	    /**
	     * Render the current stage.
	     */
	    Application.prototype.render = function render() {
	        this.renderer.render(this.stage);
	    };
	
	    /**
	     * Convenience method for stopping the render.
	     */
	
	
	    Application.prototype.stop = function stop() {
	        this._ticker.stop();
	    };
	
	    /**
	     * Convenience method for starting the render.
	     */
	
	
	    Application.prototype.start = function start() {
	        this._ticker.start();
	    };
	
	    /**
	     * Reference to the renderer's canvas element.
	     * @member {HTMLCanvasElement}
	     * @readonly
	     */
	
	
	    /**
	     * Destroy and don't use after this.
	     * @param {Boolean} [removeView=false] Automatically remove canvas from DOM.
	     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'stageOptions' will be passed on to those calls.
	     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the texture of the child sprite
	     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the base texture of the child sprite
	     */
	    Application.prototype.destroy = function destroy(removeView, stageOptions) {
	        if (this._ticker) {
	            var oldTicker = this._ticker;
	
	            this.ticker = null;
	            oldTicker.destroy();
	        }
	
	        this.stage.destroy(stageOptions);
	        this.stage = null;
	
	        this.renderer.destroy(removeView);
	        this.renderer = null;
	
	        this._options = null;
	    };
	
	    _createClass(Application, [{
	        key: 'ticker',
	        set: function set(ticker) // eslint-disable-line require-jsdoc
	        {
	            if (this._ticker) {
	                this._ticker.remove(this.render, this);
	            }
	            this._ticker = ticker;
	            if (ticker) {
	                ticker.add(this.render, this, _const.UPDATE_PRIORITY.LOW);
	            }
	        },
	        get: function get() // eslint-disable-line require-jsdoc
	        {
	            return this._ticker;
	        }
	    }, {
	        key: 'view',
	        get: function get() {
	            return this.renderer.view;
	        }
	
	        /**
	         * Reference to the renderer's screen rectangle. Its safe to use as filterArea or hitArea for whole screen
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	
	    }, {
	        key: 'screen',
	        get: function get() {
	            return this.renderer.screen;
	        }
	    }]);
	
	    return Application;
	}();
	
	exports.default = Application;
	//# sourceMappingURL=Application.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.autoDetectRenderer = autoDetectRenderer;
	
	var _utils = __webpack_require__(5);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _CanvasRenderer = __webpack_require__(28);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _WebGLRenderer = __webpack_require__(35);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// eslint-disable-next-line valid-jsdoc
	/**
	 * This helper function will automatically detect which renderer you should be using.
	 * WebGL is the preferred renderer as it is a lot faster. If webGL is not supported by
	 * the browser then this function will return a canvas renderer
	 *
	 * @memberof PIXI
	 * @function autoDetectRenderer
	 * @param {object} [options] - The optional renderer parameters
	 * @param {number} [options.width=800] - the width of the renderers view
	 * @param {number} [options.height=600] - the height of the renderers view
	 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	 * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	 * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
	 *  need to call toDataUrl on the webgl context
	 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	 *  (shown if not transparent).
	 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	 *   not before the new render pass.
	 * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
	 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
	 * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	 *  stopping pixel interpolation.
	 * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	 *  FXAA is faster, but may not always look as great **webgl only**
	 * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
	 *  If you experience unexplained flickering try setting this to true. **webgl only**
	 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	 *  for devices with dual graphics card **webgl only**
	 * @return {PIXI.WebGLRenderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
	 */
	function autoDetectRenderer(options, arg1, arg2, arg3) {
	    // Backward-compatible support for noWebGL option
	    var forceCanvas = options && options.forceCanvas;
	
	    if (arg3 !== undefined) {
	        forceCanvas = arg3;
	    }
	
	    if (!forceCanvas && utils.isWebGLSupported()) {
	        return new _WebGLRenderer2.default(options, arg1, arg2);
	    }
	
	    return new _CanvasRenderer2.default(options, arg1, arg2);
	}
	//# sourceMappingURL=autoDetectRenderer.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventemitter = __webpack_require__(19);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _TransformStatic = __webpack_require__(105);
	
	var _TransformStatic2 = _interopRequireDefault(_TransformStatic);
	
	var _Transform = __webpack_require__(104);
	
	var _Transform2 = _interopRequireDefault(_Transform);
	
	var _Bounds = __webpack_require__(58);
	
	var _Bounds2 = _interopRequireDefault(_Bounds);
	
	var _math = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// _tempDisplayObjectParent = new DisplayObject();
	
	/**
	 * The base class for all objects that are rendered on the screen.
	 * This is an abstract class and should not be used on its own rather it should be extended.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var DisplayObject = function (_EventEmitter) {
	    _inherits(DisplayObject, _EventEmitter);
	
	    /**
	     *
	     */
	    function DisplayObject() {
	        _classCallCheck(this, DisplayObject);
	
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        var TransformClass = _settings2.default.TRANSFORM_MODE === _const.TRANSFORM_MODE.STATIC ? _TransformStatic2.default : _Transform2.default;
	
	        _this.tempDisplayObjectParent = null;
	
	        // TODO: need to create Transform from factory
	        /**
	         * World transform and local transform of this object.
	         * This will become read-only later, please do not assign anything there unless you know what are you doing
	         *
	         * @member {PIXI.TransformBase}
	         */
	        _this.transform = new TransformClass();
	
	        /**
	         * The opacity of the object.
	         *
	         * @member {number}
	         */
	        _this.alpha = 1;
	
	        /**
	         * The visibility of the object. If false the object will not be drawn, and
	         * the updateTransform function will not be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually
	         *
	         * @member {boolean}
	         */
	        _this.visible = true;
	
	        /**
	         * Can this object be rendered, if false the object will not be drawn but the updateTransform
	         * methods will still be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds manually
	         *
	         * @member {boolean}
	         */
	        _this.renderable = true;
	
	        /**
	         * The display object container that contains this display object.
	         *
	         * @member {PIXI.Container}
	         * @readonly
	         */
	        _this.parent = null;
	
	        /**
	         * The multiplied alpha of the displayObject
	         *
	         * @member {number}
	         * @readonly
	         */
	        _this.worldAlpha = 1;
	
	        /**
	         * The area the filter is applied to. This is used as more of an optimisation
	         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle
	         *
	         * Also works as an interaction mask
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.filterArea = null;
	
	        _this._filters = null;
	        _this._enabledFilters = null;
	
	        /**
	         * The bounds object, this is used to calculate and store the bounds of the displayObject
	         *
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        _this._bounds = new _Bounds2.default();
	        _this._boundsID = 0;
	        _this._lastBoundsID = -1;
	        _this._boundsRect = null;
	        _this._localBoundsRect = null;
	
	        /**
	         * The original, cached mask of the object
	         *
	         * @member {PIXI.Graphics|PIXI.Sprite}
	         * @private
	         */
	        _this._mask = null;
	
	        /**
	         * If the object has been destroyed via destroy(). If true, it should not be used.
	         *
	         * @member {boolean}
	         * @private
	         * @readonly
	         */
	        _this._destroyed = false;
	
	        /**
	         * Fired when this DisplayObject is added to a Container.
	         *
	         * @event PIXI.DisplayObject#added
	         * @param {PIXI.Container} container - The container added to.
	         */
	
	        /**
	         * Fired when this DisplayObject is removed from a Container.
	         *
	         * @event PIXI.DisplayObject#removed
	         * @param {PIXI.Container} container - The container removed from.
	         */
	        return _this;
	    }
	
	    /**
	     * @private
	     * @member {PIXI.DisplayObject}
	     */
	
	
	    /**
	     * Updates the object transform for rendering
	     *
	     * TODO - Optimization pass!
	     */
	    DisplayObject.prototype.updateTransform = function updateTransform() {
	        this.transform.updateTransform(this.parent.transform);
	        // multiply the alphas..
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;
	
	        this._bounds.updateID++;
	    };
	
	    /**
	     * recursively updates transform of all objects from the root to this one
	     * internal function for toLocal()
	     */
	
	
	    DisplayObject.prototype._recursivePostUpdateTransform = function _recursivePostUpdateTransform() {
	        if (this.parent) {
	            this.parent._recursivePostUpdateTransform();
	            this.transform.updateTransform(this.parent.transform);
	        } else {
	            this.transform.updateTransform(this._tempDisplayObjectParent.transform);
	        }
	    };
	
	    /**
	     * Retrieves the bounds of the displayObject as a rectangle object.
	     *
	     * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
	     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	     *  nice performance boost
	     * @param {PIXI.Rectangle} rect - Optional rectangle to store the result of the bounds calculation
	     * @return {PIXI.Rectangle} the rectangular bounding area
	     */
	
	
	    DisplayObject.prototype.getBounds = function getBounds(skipUpdate, rect) {
	        if (!skipUpdate) {
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.updateTransform();
	                this.parent = null;
	            } else {
	                this._recursivePostUpdateTransform();
	                this.updateTransform();
	            }
	        }
	
	        if (this._boundsID !== this._lastBoundsID) {
	            this.calculateBounds();
	        }
	
	        if (!rect) {
	            if (!this._boundsRect) {
	                this._boundsRect = new _math.Rectangle();
	            }
	
	            rect = this._boundsRect;
	        }
	
	        return this._bounds.getRectangle(rect);
	    };
	
	    /**
	     * Retrieves the local bounds of the displayObject as a rectangle object
	     *
	     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation
	     * @return {PIXI.Rectangle} the rectangular bounding area
	     */
	
	
	    DisplayObject.prototype.getLocalBounds = function getLocalBounds(rect) {
	        var transformRef = this.transform;
	        var parentRef = this.parent;
	
	        this.parent = null;
	        this.transform = this._tempDisplayObjectParent.transform;
	
	        if (!rect) {
	            if (!this._localBoundsRect) {
	                this._localBoundsRect = new _math.Rectangle();
	            }
	
	            rect = this._localBoundsRect;
	        }
	
	        var bounds = this.getBounds(false, rect);
	
	        this.parent = parentRef;
	        this.transform = transformRef;
	
	        return bounds;
	    };
	
	    /**
	     * Calculates the global position of the display object
	     *
	     * @param {PIXI.Point} position - The world origin to calculate from
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point)
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
	     * @return {PIXI.Point} A point object representing the position of this object
	     */
	
	
	    DisplayObject.prototype.toGlobal = function toGlobal(position, point) {
	        var skipUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();
	
	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            } else {
	                this.displayObjectUpdateTransform();
	            }
	        }
	
	        // don't need to update the lot
	        return this.worldTransform.apply(position, point);
	    };
	
	    /**
	     * Calculates the local position of the display object relative to another point
	     *
	     * @param {PIXI.Point} position - The world origin to calculate from
	     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point)
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
	     * @return {PIXI.Point} A point object representing the position of this object
	     */
	
	
	    DisplayObject.prototype.toLocal = function toLocal(position, from, point, skipUpdate) {
	        if (from) {
	            position = from.toGlobal(position, point, skipUpdate);
	        }
	
	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();
	
	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            } else {
	                this.displayObjectUpdateTransform();
	            }
	        }
	
	        // simply apply the matrix..
	        return this.worldTransform.applyInverse(position, point);
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    DisplayObject.prototype.renderWebGL = function renderWebGL(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // OVERWRITE;
	
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;
	
	    DisplayObject.prototype.renderCanvas = function renderCanvas(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // OVERWRITE;
	
	
	    /**
	     * Set the parent Container of this DisplayObject
	     *
	     * @param {PIXI.Container} container - The Container to add this DisplayObject to
	     * @return {PIXI.Container} The Container that this DisplayObject was added to
	     */
	    ;
	
	    DisplayObject.prototype.setParent = function setParent(container) {
	        if (!container || !container.addChild) {
	            throw new Error('setParent: Argument must be a Container');
	        }
	
	        container.addChild(this);
	
	        return container;
	    };
	
	    /**
	     * Convenience function to set the position, scale, skew and pivot at once.
	     *
	     * @param {number} [x=0] - The X position
	     * @param {number} [y=0] - The Y position
	     * @param {number} [scaleX=1] - The X scale value
	     * @param {number} [scaleY=1] - The Y scale value
	     * @param {number} [rotation=0] - The rotation
	     * @param {number} [skewX=0] - The X skew value
	     * @param {number} [skewY=0] - The Y skew value
	     * @param {number} [pivotX=0] - The X pivot value
	     * @param {number} [pivotY=0] - The Y pivot value
	     * @return {PIXI.DisplayObject} The DisplayObject instance
	     */
	
	
	    DisplayObject.prototype.setTransform = function setTransform() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	        var scaleY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	        var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	        var skewX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	        var skewY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	        var pivotX = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
	        var pivotY = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
	
	        this.position.x = x;
	        this.position.y = y;
	        this.scale.x = !scaleX ? 1 : scaleX;
	        this.scale.y = !scaleY ? 1 : scaleY;
	        this.rotation = rotation;
	        this.skew.x = skewX;
	        this.skew.y = skewY;
	        this.pivot.x = pivotX;
	        this.pivot.y = pivotY;
	
	        return this;
	    };
	
	    /**
	     * Base destroy method for generic display objects. This will automatically
	     * remove the display object from its parent Container as well as remove
	     * all current event listeners and internal references. Do not use a DisplayObject
	     * after calling `destroy`.
	     *
	     */
	
	
	    DisplayObject.prototype.destroy = function destroy() {
	        this.removeAllListeners();
	        if (this.parent) {
	            this.parent.removeChild(this);
	        }
	        this.transform = null;
	
	        this.parent = null;
	
	        this._bounds = null;
	        this._currentBounds = null;
	        this._mask = null;
	
	        this.filterArea = null;
	
	        this.interactive = false;
	        this.interactiveChildren = false;
	
	        this._destroyed = true;
	    };
	
	    /**
	     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	     * An alias to position.x
	     *
	     * @member {number}
	     */
	
	
	    _createClass(DisplayObject, [{
	        key: '_tempDisplayObjectParent',
	        get: function get() {
	            if (this.tempDisplayObjectParent === null) {
	                this.tempDisplayObjectParent = new DisplayObject();
	            }
	
	            return this.tempDisplayObjectParent;
	        }
	    }, {
	        key: 'x',
	        get: function get() {
	            return this.position.x;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.x = value;
	        }
	
	        /**
	         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
	         * An alias to position.y
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'y',
	        get: function get() {
	            return this.position.y;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.y = value;
	        }
	
	        /**
	         * Current transform of the object based on world (parent) factors
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	
	    }, {
	        key: 'worldTransform',
	        get: function get() {
	            return this.transform.worldTransform;
	        }
	
	        /**
	         * Current transform of the object based on local factors: position, scale, other stuff
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	
	    }, {
	        key: 'localTransform',
	        get: function get() {
	            return this.transform.localTransform;
	        }
	
	        /**
	         * The coordinate of the object relative to the local coordinates of the parent.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'position',
	        get: function get() {
	            return this.transform.position;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.copy(value);
	        }
	
	        /**
	         * The scale factor of the object.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'scale',
	        get: function get() {
	            return this.transform.scale;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.scale.copy(value);
	        }
	
	        /**
	         * The pivot point of the displayObject that it rotates around
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'pivot',
	        get: function get() {
	            return this.transform.pivot;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.pivot.copy(value);
	        }
	
	        /**
	         * The skew factor for the object in radians.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'skew',
	        get: function get() {
	            return this.transform.skew;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.skew.copy(value);
	        }
	
	        /**
	         * The rotation of the object in radians.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'rotation',
	        get: function get() {
	            return this.transform.rotation;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.rotation = value;
	        }
	
	        /**
	         * Indicates if the object is globally visible.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	
	    }, {
	        key: 'worldVisible',
	        get: function get() {
	            var item = this;
	
	            do {
	                if (!item.visible) {
	                    return false;
	                }
	
	                item = item.parent;
	            } while (item);
	
	            return true;
	        }
	
	        /**
	         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
	         * object to the shape of the mask applied to it. In PIXI a regular mask must be a
	         * PIXI.Graphics or a PIXI.Sprite object. This allows for much faster masking in canvas as it
	         * utilises shape clipping. To remove a mask, set this property to null.
	         *
	         * @todo For the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
	         *
	         * @member {PIXI.Graphics|PIXI.Sprite}
	         */
	
	    }, {
	        key: 'mask',
	        get: function get() {
	            return this._mask;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._mask) {
	                this._mask.renderable = true;
	                this._mask.isMask = false;
	            }
	
	            this._mask = value;
	
	            if (this._mask) {
	                this._mask.renderable = false;
	                this._mask.isMask = true;
	            }
	        }
	
	        /**
	         * Sets the filters for the displayObject.
	         * * IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
	         * To remove filters simply set this property to 'null'
	         *
	         * @member {PIXI.Filter[]}
	         */
	
	    }, {
	        key: 'filters',
	        get: function get() {
	            return this._filters && this._filters.slice();
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._filters = value && value.slice();
	        }
	    }]);
	
	    return DisplayObject;
	}(_eventemitter2.default);
	
	// performance increase to avoid using call.. (10x faster)
	
	
	exports.default = DisplayObject;
	DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
	//# sourceMappingURL=DisplayObject.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _math = __webpack_require__(7);
	
	var _TransformBase2 = __webpack_require__(59);
	
	var _TransformBase3 = _interopRequireDefault(_TransformBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Generic class to deal with traditional 2D matrix transforms
	 * local transformation is calculated from position,scale,skew and rotation
	 *
	 * @class
	 * @extends PIXI.TransformBase
	 * @memberof PIXI
	 */
	var Transform = function (_TransformBase) {
	  _inherits(Transform, _TransformBase);
	
	  /**
	   *
	   */
	  function Transform() {
	    _classCallCheck(this, Transform);
	
	    /**
	    * The coordinate of the object relative to the local coordinates of the parent.
	    *
	    * @member {PIXI.Point}
	    */
	    var _this = _possibleConstructorReturn(this, _TransformBase.call(this));
	
	    _this.position = new _math.Point(0, 0);
	
	    /**
	     * The scale factor of the object.
	     *
	     * @member {PIXI.Point}
	     */
	    _this.scale = new _math.Point(1, 1);
	
	    /**
	     * The skew amount, on the x and y axis.
	     *
	     * @member {PIXI.ObservablePoint}
	     */
	    _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);
	
	    /**
	     * The pivot point of the displayObject that it rotates around
	     *
	     * @member {PIXI.Point}
	     */
	    _this.pivot = new _math.Point(0, 0);
	
	    /**
	     * The rotation value of the object, in radians
	     *
	     * @member {Number}
	     * @private
	     */
	    _this._rotation = 0;
	
	    _this._cx = 1; // cos rotation + skewY;
	    _this._sx = 0; // sin rotation + skewY;
	    _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
	    _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
	    return _this;
	  }
	
	  /**
	   * Updates the skew values when the skew or rotation changes.
	   *
	   * @private
	   */
	
	
	  Transform.prototype.updateSkew = function updateSkew() {
	    this._cx = Math.cos(this._rotation + this.skew._y);
	    this._sx = Math.sin(this._rotation + this.skew._y);
	    this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
	    this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
	  };
	
	  /**
	   * Updates only local matrix
	   */
	
	
	  Transform.prototype.updateLocalTransform = function updateLocalTransform() {
	    var lt = this.localTransform;
	
	    lt.a = this._cx * this.scale.x;
	    lt.b = this._sx * this.scale.x;
	    lt.c = this._cy * this.scale.y;
	    lt.d = this._sy * this.scale.y;
	
	    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
	    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
	  };
	
	  /**
	   * Updates the values of the object and applies the parent's transform.
	   *
	   * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
	   */
	
	
	  Transform.prototype.updateTransform = function updateTransform(parentTransform) {
	    var lt = this.localTransform;
	
	    lt.a = this._cx * this.scale.x;
	    lt.b = this._sx * this.scale.x;
	    lt.c = this._cy * this.scale.y;
	    lt.d = this._sy * this.scale.y;
	
	    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
	    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
	
	    // concat the parent matrix with the objects transform.
	    var pt = parentTransform.worldTransform;
	    var wt = this.worldTransform;
	
	    wt.a = lt.a * pt.a + lt.b * pt.c;
	    wt.b = lt.a * pt.b + lt.b * pt.d;
	    wt.c = lt.c * pt.a + lt.d * pt.c;
	    wt.d = lt.c * pt.b + lt.d * pt.d;
	    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
	
	    this._worldID++;
	  };
	
	  /**
	   * Decomposes a matrix and sets the transforms properties based on it.
	   *
	   * @param {PIXI.Matrix} matrix - The matrix to decompose
	   */
	
	
	  Transform.prototype.setFromMatrix = function setFromMatrix(matrix) {
	    matrix.decompose(this);
	  };
	
	  /**
	   * The rotation of the object in radians.
	   *
	   * @member {number}
	   */
	
	
	  _createClass(Transform, [{
	    key: 'rotation',
	    get: function get() {
	      return this._rotation;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._rotation = value;
	      this.updateSkew();
	    }
	  }]);
	
	  return Transform;
	}(_TransformBase3.default);
	
	exports.default = Transform;
	//# sourceMappingURL=Transform.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _math = __webpack_require__(7);
	
	var _TransformBase2 = __webpack_require__(59);
	
	var _TransformBase3 = _interopRequireDefault(_TransformBase2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Transform that takes care about its versions
	 *
	 * @class
	 * @extends PIXI.TransformBase
	 * @memberof PIXI
	 */
	var TransformStatic = function (_TransformBase) {
	    _inherits(TransformStatic, _TransformBase);
	
	    /**
	     *
	     */
	    function TransformStatic() {
	        _classCallCheck(this, TransformStatic);
	
	        /**
	        * The coordinate of the object relative to the local coordinates of the parent.
	        *
	        * @member {PIXI.ObservablePoint}
	        */
	        var _this = _possibleConstructorReturn(this, _TransformBase.call(this));
	
	        _this.position = new _math.ObservablePoint(_this.onChange, _this, 0, 0);
	
	        /**
	         * The scale factor of the object.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.scale = new _math.ObservablePoint(_this.onChange, _this, 1, 1);
	
	        /**
	         * The pivot point of the displayObject that it rotates around
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.pivot = new _math.ObservablePoint(_this.onChange, _this, 0, 0);
	
	        /**
	         * The skew amount, on the x and y axis.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);
	
	        _this._rotation = 0;
	
	        _this._cx = 1; // cos rotation + skewY;
	        _this._sx = 0; // sin rotation + skewY;
	        _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
	        _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
	
	        _this._localID = 0;
	        _this._currentLocalID = 0;
	        return _this;
	    }
	
	    /**
	     * Called when a value changes.
	     *
	     * @private
	     */
	
	
	    TransformStatic.prototype.onChange = function onChange() {
	        this._localID++;
	    };
	
	    /**
	     * Called when skew or rotation changes
	     *
	     * @private
	     */
	
	
	    TransformStatic.prototype.updateSkew = function updateSkew() {
	        this._cx = Math.cos(this._rotation + this.skew._y);
	        this._sx = Math.sin(this._rotation + this.skew._y);
	        this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
	        this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
	
	        this._localID++;
	    };
	
	    /**
	     * Updates only local matrix
	     */
	
	
	    TransformStatic.prototype.updateLocalTransform = function updateLocalTransform() {
	        var lt = this.localTransform;
	
	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale._x;
	            lt.b = this._sx * this.scale._x;
	            lt.c = this._cy * this.scale._y;
	            lt.d = this._sy * this.scale._y;
	
	            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
	            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
	            this._currentLocalID = this._localID;
	
	            // force an update..
	            this._parentID = -1;
	        }
	    };
	
	    /**
	     * Updates the values of the object and applies the parent's transform.
	     *
	     * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
	     */
	
	
	    TransformStatic.prototype.updateTransform = function updateTransform(parentTransform) {
	        var lt = this.localTransform;
	
	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale._x;
	            lt.b = this._sx * this.scale._x;
	            lt.c = this._cy * this.scale._y;
	            lt.d = this._sy * this.scale._y;
	
	            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
	            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
	            this._currentLocalID = this._localID;
	
	            // force an update..
	            this._parentID = -1;
	        }
	
	        if (this._parentID !== parentTransform._worldID) {
	            // concat the parent matrix with the objects transform.
	            var pt = parentTransform.worldTransform;
	            var wt = this.worldTransform;
	
	            wt.a = lt.a * pt.a + lt.b * pt.c;
	            wt.b = lt.a * pt.b + lt.b * pt.d;
	            wt.c = lt.c * pt.a + lt.d * pt.c;
	            wt.d = lt.c * pt.b + lt.d * pt.d;
	            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
	
	            this._parentID = parentTransform._worldID;
	
	            // update the id of the transform..
	            this._worldID++;
	        }
	    };
	
	    /**
	     * Decomposes a matrix and sets the transforms properties based on it.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to decompose
	     */
	
	
	    TransformStatic.prototype.setFromMatrix = function setFromMatrix(matrix) {
	        matrix.decompose(this);
	        this._localID++;
	    };
	
	    /**
	     * The rotation of the object in radians.
	     *
	     * @member {number}
	     */
	
	
	    _createClass(TransformStatic, [{
	        key: 'rotation',
	        get: function get() {
	            return this._rotation;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._rotation = value;
	            this.updateSkew();
	        }
	    }]);
	
	    return TransformStatic;
	}(_TransformBase3.default);
	
	exports.default = TransformStatic;
	//# sourceMappingURL=TransformStatic.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A GraphicsData object.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var GraphicsData = function () {
	  /**
	   *
	   * @param {number} lineWidth - the width of the line to draw
	   * @param {number} lineColor - the color of the line to draw
	   * @param {number} lineAlpha - the alpha of the line to draw
	   * @param {number} fillColor - the color of the fill
	   * @param {number} fillAlpha - the alpha of the fill
	   * @param {boolean} fill - whether or not the shape is filled with a colour
	   * @param {boolean} nativeLines - the method for drawing lines
	   * @param {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Polygon} shape - The shape object to draw.
	   * @param {number} lineAlignment - the alignment of the line.
	   */
	  function GraphicsData(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, nativeLines, shape, lineAlignment) {
	    _classCallCheck(this, GraphicsData);
	
	    /**
	     * the width of the line to draw
	     * @member {number}
	     */
	    this.lineWidth = lineWidth;
	
	    /**
	     * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
	     *
	     * @member {number}
	     * @default 0
	     */
	    this.lineAlignment = lineAlignment;
	
	    /**
	     * if true the liens will be draw using LINES instead of TRIANGLE_STRIP
	     * @member {boolean}
	     */
	    this.nativeLines = nativeLines;
	
	    /**
	     * the color of the line to draw
	     * @member {number}
	     */
	    this.lineColor = lineColor;
	
	    /**
	     * the alpha of the line to draw
	     * @member {number}
	     */
	    this.lineAlpha = lineAlpha;
	
	    /**
	     * cached tint of the line to draw
	     * @member {number}
	     * @private
	     */
	    this._lineTint = lineColor;
	
	    /**
	     * the color of the fill
	     * @member {number}
	     */
	    this.fillColor = fillColor;
	
	    /**
	     * the alpha of the fill
	     * @member {number}
	     */
	    this.fillAlpha = fillAlpha;
	
	    /**
	     * cached tint of the fill
	     * @member {number}
	     * @private
	     */
	    this._fillTint = fillColor;
	
	    /**
	     * whether or not the shape is filled with a colour
	     * @member {boolean}
	     */
	    this.fill = fill;
	
	    this.holes = [];
	
	    /**
	     * The shape object to draw.
	     * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
	     */
	    this.shape = shape;
	
	    /**
	     * The type of the shape, see the Const.Shapes file for all the existing types,
	     * @member {number}
	     */
	    this.type = shape.type;
	  }
	
	  /**
	   * Creates a new GraphicsData object with the same values as this one.
	   *
	   * @return {PIXI.GraphicsData} Cloned GraphicsData object
	   */
	
	
	  GraphicsData.prototype.clone = function clone() {
	    return new GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.fill, this.nativeLines, this.shape);
	  };
	
	  /**
	   * Adds a hole to the shape.
	   *
	   * @param {PIXI.Rectangle|PIXI.Circle} shape - The shape of the hole.
	   */
	
	
	  GraphicsData.prototype.addHole = function addHole(shape) {
	    this.holes.push(shape);
	  };
	
	  /**
	   * Destroys the Graphics data.
	   */
	
	
	  GraphicsData.prototype.destroy = function destroy() {
	    this.shape = null;
	    this.holes = null;
	  };
	
	  return GraphicsData;
	}();
	
	exports.default = GraphicsData;
	//# sourceMappingURL=GraphicsData.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Matrix = __webpack_require__(60);
	
	var _Matrix2 = _interopRequireDefault(_Matrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1]; // Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group of order 16
	
	var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
	var tempMatrices = [];
	
	var mul = [];
	
	function signum(x) {
	    if (x < 0) {
	        return -1;
	    }
	    if (x > 0) {
	        return 1;
	    }
	
	    return 0;
	}
	
	function init() {
	    for (var i = 0; i < 16; i++) {
	        var row = [];
	
	        mul.push(row);
	
	        for (var j = 0; j < 16; j++) {
	            var _ux = signum(ux[i] * ux[j] + vx[i] * uy[j]);
	            var _uy = signum(uy[i] * ux[j] + vy[i] * uy[j]);
	            var _vx = signum(ux[i] * vx[j] + vx[i] * vy[j]);
	            var _vy = signum(uy[i] * vx[j] + vy[i] * vy[j]);
	
	            for (var k = 0; k < 16; k++) {
	                if (ux[k] === _ux && uy[k] === _uy && vx[k] === _vx && vy[k] === _vy) {
	                    row.push(k);
	                    break;
	                }
	            }
	        }
	    }
	
	    for (var _i = 0; _i < 16; _i++) {
	        var mat = new _Matrix2.default();
	
	        mat.set(ux[_i], uy[_i], vx[_i], vy[_i], 0, 0);
	        tempMatrices.push(mat);
	    }
	}
	
	init();
	
	/**
	 * Implements Dihedral Group D_8, see [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html},
	 * D8 is the same but with diagonals. Used for texture rotations.
	 *
	 * Vector xX(i), xY(i) is U-axis of sprite with rotation i
	 * Vector yY(i), yY(i) is V-axis of sprite with rotation i
	 * Rotations: 0 grad (0), 90 grad (2), 180 grad (4), 270 grad (6)
	 * Mirrors: vertical (8), main diagonal (10), horizontal (12), reverse diagonal (14)
	 * This is the small part of gameofbombs.com portal system. It works.
	 *
	 * @author Ivan @ivanpopelyshev
	 * @class
	 * @memberof PIXI
	 */
	var GroupD8 = {
	    E: 0,
	    SE: 1,
	    S: 2,
	    SW: 3,
	    W: 4,
	    NW: 5,
	    N: 6,
	    NE: 7,
	    MIRROR_VERTICAL: 8,
	    MIRROR_HORIZONTAL: 12,
	    uX: function uX(ind) {
	        return ux[ind];
	    },
	    uY: function uY(ind) {
	        return uy[ind];
	    },
	    vX: function vX(ind) {
	        return vx[ind];
	    },
	    vY: function vY(ind) {
	        return vy[ind];
	    },
	    inv: function inv(rotation) {
	        if (rotation & 8) {
	            return rotation & 15;
	        }
	
	        return -rotation & 7;
	    },
	    add: function add(rotationSecond, rotationFirst) {
	        return mul[rotationSecond][rotationFirst];
	    },
	    sub: function sub(rotationSecond, rotationFirst) {
	        return mul[rotationSecond][GroupD8.inv(rotationFirst)];
	    },
	
	    /**
	     * Adds 180 degrees to rotation. Commutative operation.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {number} rotation - The number to rotate.
	     * @returns {number} rotated number
	     */
	    rotate180: function rotate180(rotation) {
	        return rotation ^ 4;
	    },
	
	    /**
	     * Direction of main vector can be horizontal, vertical or diagonal.
	     * Some objects work with vertical directions different.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {number} rotation - The number to check.
	     * @returns {boolean} Whether or not the direction is vertical
	     */
	    isVertical: function isVertical(rotation) {
	        return (rotation & 3) === 2;
	    },
	
	    /**
	     * @memberof PIXI.GroupD8
	     * @param {number} dx - TODO
	     * @param {number} dy - TODO
	     *
	     * @return {number} TODO
	     */
	    byDirection: function byDirection(dx, dy) {
	        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
	            if (dy >= 0) {
	                return GroupD8.S;
	            }
	
	            return GroupD8.N;
	        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
	            if (dx > 0) {
	                return GroupD8.E;
	            }
	
	            return GroupD8.W;
	        } else if (dy > 0) {
	            if (dx > 0) {
	                return GroupD8.SE;
	            }
	
	            return GroupD8.SW;
	        } else if (dx > 0) {
	            return GroupD8.NE;
	        }
	
	        return GroupD8.NW;
	    },
	
	    /**
	     * Helps sprite to compensate texture packer rotation.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {PIXI.Matrix} matrix - sprite world matrix
	     * @param {number} rotation - The rotation factor to use.
	     * @param {number} tx - sprite anchoring
	     * @param {number} ty - sprite anchoring
	     */
	    matrixAppendRotationInv: function matrixAppendRotationInv(matrix, rotation) {
	        var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var ty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	        // Packer used "rotation", we use "inv(rotation)"
	        var mat = tempMatrices[GroupD8.inv(rotation)];
	
	        mat.tx = tx;
	        mat.ty = ty;
	        matrix.append(mat);
	    }
	};
	
	exports.default = GroupD8;
	//# sourceMappingURL=GroupD8.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 * An observable point is a point that triggers a callback when the point's position is changed.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var ObservablePoint = function () {
	    /**
	     * @param {Function} cb - callback when changed
	     * @param {object} scope - owner of callback
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */
	    function ObservablePoint(cb, scope) {
	        var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	        _classCallCheck(this, ObservablePoint);
	
	        this._x = x;
	        this._y = y;
	
	        this.cb = cb;
	        this.scope = scope;
	    }
	
	    /**
	     * Sets the point to a new x and y position.
	     * If y is omitted, both x and y will be set to x.
	     *
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */
	
	
	    ObservablePoint.prototype.set = function set(x, y) {
	        var _x = x || 0;
	        var _y = y || (y !== 0 ? _x : 0);
	
	        if (this._x !== _x || this._y !== _y) {
	            this._x = _x;
	            this._y = _y;
	            this.cb.call(this.scope);
	        }
	    };
	
	    /**
	     * Copies the data from another point
	     *
	     * @param {PIXI.Point|PIXI.ObservablePoint} point - point to copy from
	     */
	
	
	    ObservablePoint.prototype.copy = function copy(point) {
	        if (this._x !== point.x || this._y !== point.y) {
	            this._x = point.x;
	            this._y = point.y;
	            this.cb.call(this.scope);
	        }
	    };
	
	    /**
	     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	     *
	     * @member {number}
	     */
	
	
	    _createClass(ObservablePoint, [{
	        key: "x",
	        get: function get() {
	            return this._x;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._x !== value) {
	                this._x = value;
	                this.cb.call(this.scope);
	            }
	        }
	
	        /**
	         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: "y",
	        get: function get() {
	            return this._y;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._y !== value) {
	                this._y = value;
	                this.cb.call(this.scope);
	            }
	        }
	    }]);
	
	    return ObservablePoint;
	}();
	
	exports.default = ObservablePoint;
	//# sourceMappingURL=ObservablePoint.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(5);
	
	var _math = __webpack_require__(7);
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _Container = __webpack_require__(27);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _RenderTexture = __webpack_require__(65);
	
	var _RenderTexture2 = _interopRequireDefault(_RenderTexture);
	
	var _eventemitter = __webpack_require__(19);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempMatrix = new _math.Matrix();
	
	/**
	 * The SystemRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
	 * and {@link PIXI.WebGLRenderer} which can be used for rendering a PixiJS scene.
	 *
	 * @abstract
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	
	var SystemRenderer = function (_EventEmitter) {
	  _inherits(SystemRenderer, _EventEmitter);
	
	  // eslint-disable-next-line valid-jsdoc
	  /**
	   * @param {string} system - The name of the system this renderer is for.
	   * @param {object} [options] - The optional renderer parameters
	   * @param {number} [options.width=800] - the width of the screen
	   * @param {number} [options.height=600] - the height of the screen
	   * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	   * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	   * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	   * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	   * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	   *  resolution of the renderer retina would be 2.
	   * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	   *  enable this if you need to call toDataUrl on the webgl context.
	   * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	   *      not before the new render pass.
	   * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	   *  (shown if not transparent).
	   * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	   *  stopping pixel interpolation.
	   */
	  function SystemRenderer(system, options, arg2, arg3) {
	    _classCallCheck(this, SystemRenderer);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    (0, _utils.sayHello)(system);
	
	    // Support for constructor(system, screenWidth, screenHeight, options)
	    if (typeof options === 'number') {
	      options = Object.assign({
	        width: options,
	        height: arg2 || _settings2.default.RENDER_OPTIONS.height
	      }, arg3);
	    }
	
	    // Add the default render options
	    options = Object.assign({}, _settings2.default.RENDER_OPTIONS, options);
	
	    /**
	     * The supplied constructor options.
	     *
	     * @member {Object}
	     * @readOnly
	     */
	    _this.options = options;
	
	    /**
	     * The type of the renderer.
	     *
	     * @member {number}
	     * @default PIXI.RENDERER_TYPE.UNKNOWN
	     * @see PIXI.RENDERER_TYPE
	     */
	    _this.type = _const.RENDERER_TYPE.UNKNOWN;
	
	    /**
	     * Measurements of the screen. (0, 0, screenWidth, screenHeight)
	     *
	     * Its safe to use as filterArea or hitArea for whole stage
	     *
	     * @member {PIXI.Rectangle}
	     */
	    _this.screen = new _math.Rectangle(0, 0, options.width, options.height);
	
	    /**
	     * The canvas element that everything is drawn to
	     *
	     * @member {HTMLCanvasElement}
	     */
	    _this.view = options.view || document.createElement('canvas');
	
	    /**
	     * The resolution / device pixel ratio of the renderer
	     *
	     * @member {number}
	     * @default 1
	     */
	    _this.resolution = options.resolution || _settings2.default.RESOLUTION;
	
	    /**
	     * Whether the render view is transparent
	     *
	     * @member {boolean}
	     */
	    _this.transparent = options.transparent;
	
	    /**
	     * Whether css dimensions of canvas view should be resized to screen dimensions automatically
	     *
	     * @member {boolean}
	     */
	    _this.autoResize = options.autoResize || false;
	
	    /**
	     * Tracks the blend modes useful for this renderer.
	     *
	     * @member {object<string, mixed>}
	     */
	    _this.blendModes = null;
	
	    /**
	     * The value of the preserveDrawingBuffer flag affects whether or not the contents of
	     * the stencil buffer is retained after rendering.
	     *
	     * @member {boolean}
	     */
	    _this.preserveDrawingBuffer = options.preserveDrawingBuffer;
	
	    /**
	     * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
	     * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
	     * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
	     * to clear the canvas every frame. Disable this by setting this to false. For example if
	     * your game has a canvas filling background image you often don't need this set.
	     *
	     * @member {boolean}
	     * @default
	     */
	    _this.clearBeforeRender = options.clearBeforeRender;
	
	    /**
	     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	     * Handy for crisp pixel art and speed on legacy devices.
	     *
	     * @member {boolean}
	     */
	    _this.roundPixels = options.roundPixels;
	
	    /**
	     * The background color as a number.
	     *
	     * @member {number}
	     * @private
	     */
	    _this._backgroundColor = 0x000000;
	
	    /**
	     * The background color as an [R, G, B] array.
	     *
	     * @member {number[]}
	     * @private
	     */
	    _this._backgroundColorRgba = [0, 0, 0, 0];
	
	    /**
	     * The background color as a string.
	     *
	     * @member {string}
	     * @private
	     */
	    _this._backgroundColorString = '#000000';
	
	    _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter
	
	    /**
	     * This temporary display object used as the parent of the currently being rendered item
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    _this._tempDisplayObjectParent = new _Container2.default();
	
	    /**
	     * The last root object that the renderer tried to render.
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    _this._lastObjectRendered = _this._tempDisplayObjectParent;
	    return _this;
	  }
	
	  /**
	   * Same as view.width, actual number of pixels in the canvas by horizontal
	   *
	   * @member {number}
	   * @readonly
	   * @default 800
	   */
	
	
	  /**
	   * Resizes the screen and canvas to the specified width and height
	   * Canvas dimensions are multiplied by resolution
	   *
	   * @param {number} screenWidth - the new width of the screen
	   * @param {number} screenHeight - the new height of the screen
	   */
	  SystemRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	    this.screen.width = screenWidth;
	    this.screen.height = screenHeight;
	
	    this.view.width = screenWidth * this.resolution;
	    this.view.height = screenHeight * this.resolution;
	
	    if (this.autoResize) {
	      this.view.style.width = screenWidth + 'px';
	      this.view.style.height = screenHeight + 'px';
	    }
	  };
	
	  /**
	   * Useful function that returns a texture of the display object that can then be used to create sprites
	   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
	   *
	   * @param {PIXI.DisplayObject} displayObject - The displayObject the object will be generated from
	   * @param {number} scaleMode - Should be one of the scaleMode consts
	   * @param {number} resolution - The resolution / device pixel ratio of the texture being generated
	   * @param {PIXI.Rectangle} [region] - The region of the displayObject, that shall be rendered,
	   *        if no region is specified, defaults to the local bounds of the displayObject.
	   * @return {PIXI.Texture} a texture of the graphics object
	   */
	
	
	  SystemRenderer.prototype.generateTexture = function generateTexture(displayObject, scaleMode, resolution, region) {
	    region = region || displayObject.getLocalBounds();
	
	    var renderTexture = _RenderTexture2.default.create(region.width | 0, region.height | 0, scaleMode, resolution);
	
	    tempMatrix.tx = -region.x;
	    tempMatrix.ty = -region.y;
	
	    this.render(displayObject, renderTexture, false, tempMatrix, true);
	
	    return renderTexture;
	  };
	
	  /**
	   * Removes everything from the renderer and optionally removes the Canvas DOM element.
	   *
	   * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	   */
	
	
	  SystemRenderer.prototype.destroy = function destroy(removeView) {
	    if (removeView && this.view.parentNode) {
	      this.view.parentNode.removeChild(this.view);
	    }
	
	    this.type = _const.RENDERER_TYPE.UNKNOWN;
	
	    this.view = null;
	
	    this.screen = null;
	
	    this.resolution = 0;
	
	    this.transparent = false;
	
	    this.autoResize = false;
	
	    this.blendModes = null;
	
	    this.options = null;
	
	    this.preserveDrawingBuffer = false;
	    this.clearBeforeRender = false;
	
	    this.roundPixels = false;
	
	    this._backgroundColor = 0;
	    this._backgroundColorRgba = null;
	    this._backgroundColorString = null;
	
	    this._tempDisplayObjectParent = null;
	    this._lastObjectRendered = null;
	  };
	
	  /**
	   * The background color to fill if not transparent
	   *
	   * @member {number}
	   */
	
	
	  _createClass(SystemRenderer, [{
	    key: 'width',
	    get: function get() {
	      return this.view.width;
	    }
	
	    /**
	     * Same as view.height, actual number of pixels in the canvas by vertical
	     *
	     * @member {number}
	     * @readonly
	     * @default 600
	     */
	
	  }, {
	    key: 'height',
	    get: function get() {
	      return this.view.height;
	    }
	  }, {
	    key: 'backgroundColor',
	    get: function get() {
	      return this._backgroundColor;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._backgroundColor = value;
	      this._backgroundColorString = (0, _utils.hex2string)(value);
	      (0, _utils.hex2rgb)(value, this._backgroundColorRgba);
	    }
	  }]);
	
	  return SystemRenderer;
	}(_eventemitter2.default);
	
	exports.default = SystemRenderer;
	//# sourceMappingURL=SystemRenderer.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Creates a Canvas element of the given size.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasRenderTarget = function () {
	  /**
	   * @param {number} width - the width for the newly created canvas
	   * @param {number} height - the height for the newly created canvas
	   * @param {number} [resolution=1] - The resolution / device pixel ratio of the canvas
	   */
	  function CanvasRenderTarget(width, height, resolution) {
	    _classCallCheck(this, CanvasRenderTarget);
	
	    /**
	     * The Canvas object that belongs to this CanvasRenderTarget.
	     *
	     * @member {HTMLCanvasElement}
	     */
	    this.canvas = document.createElement('canvas');
	
	    /**
	     * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
	     *
	     * @member {CanvasRenderingContext2D}
	     */
	    this.context = this.canvas.getContext('2d');
	
	    this.resolution = resolution || _settings2.default.RESOLUTION;
	
	    this.resize(width, height);
	  }
	
	  /**
	   * Clears the canvas that was created by the CanvasRenderTarget class.
	   *
	   * @private
	   */
	
	
	  CanvasRenderTarget.prototype.clear = function clear() {
	    this.context.setTransform(1, 0, 0, 1, 0, 0);
	    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	  };
	
	  /**
	   * Resizes the canvas to the specified width and height.
	   *
	   * @param {number} width - the new width of the canvas
	   * @param {number} height - the new height of the canvas
	   */
	
	
	  CanvasRenderTarget.prototype.resize = function resize(width, height) {
	    this.canvas.width = width * this.resolution;
	    this.canvas.height = height * this.resolution;
	  };
	
	  /**
	   * Destroys this canvas.
	   *
	   */
	
	
	  CanvasRenderTarget.prototype.destroy = function destroy() {
	    this.context = null;
	    this.canvas = null;
	  };
	
	  /**
	   * The width of the canvas buffer in pixels.
	   *
	   * @member {number}
	   */
	
	
	  _createClass(CanvasRenderTarget, [{
	    key: 'width',
	    get: function get() {
	      return this.canvas.width;
	    },
	    set: function set(val) // eslint-disable-line require-jsdoc
	    {
	      this.canvas.width = val;
	    }
	
	    /**
	     * The height of the canvas buffer in pixels.
	     *
	     * @member {number}
	     */
	
	  }, {
	    key: 'height',
	    get: function get() {
	      return this.canvas.height;
	    },
	    set: function set(val) // eslint-disable-line require-jsdoc
	    {
	      this.canvas.height = val;
	    }
	  }]);
	
	  return CanvasRenderTarget;
	}();
	
	exports.default = CanvasRenderTarget;
	//# sourceMappingURL=CanvasRenderTarget.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = canUseNewCanvasBlendModes;
	/**
	 * Creates a little colored canvas
	 *
	 * @ignore
	 * @param {string} color - The color to make the canvas
	 * @return {canvas} a small canvas element
	 */
	function createColoredCanvas(color) {
	    var canvas = document.createElement('canvas');
	
	    canvas.width = 6;
	    canvas.height = 1;
	
	    var context = canvas.getContext('2d');
	
	    context.fillStyle = color;
	    context.fillRect(0, 0, 6, 1);
	
	    return canvas;
	}
	
	/**
	 * Checks whether the Canvas BlendModes are supported by the current browser
	 *
	 * @return {boolean} whether they are supported
	 */
	function canUseNewCanvasBlendModes() {
	    if (typeof document === 'undefined') {
	        return false;
	    }
	
	    var magenta = createColoredCanvas('#ff00ff');
	    var yellow = createColoredCanvas('#ffff00');
	
	    var canvas = document.createElement('canvas');
	
	    canvas.width = 6;
	    canvas.height = 1;
	
	    var context = canvas.getContext('2d');
	
	    context.globalCompositeOperation = 'multiply';
	    context.drawImage(magenta, 0, 0);
	    context.drawImage(yellow, 2, 0);
	
	    var imageData = context.getImageData(2, 0, 1, 1);
	
	    if (!imageData) {
	        return false;
	    }
	
	    var data = imageData.data;
	
	    return data[0] === 255 && data[1] === 0 && data[2] === 0;
	}
	//# sourceMappingURL=canUseNewCanvasBlendModes.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extractUniformsFromSrc = __webpack_require__(221);
	
	var _extractUniformsFromSrc2 = _interopRequireDefault(_extractUniformsFromSrc);
	
	var _utils = __webpack_require__(5);
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SOURCE_KEY_MAP = {};
	
	// let math = require('../../../math');
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */
	
	var Filter = function () {
	  /**
	   * @param {string} [vertexSrc] - The source of the vertex shader.
	   * @param {string} [fragmentSrc] - The source of the fragment shader.
	   * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
	   */
	  function Filter(vertexSrc, fragmentSrc, uniforms) {
	    _classCallCheck(this, Filter);
	
	    /**
	     * The vertex shader.
	     *
	     * @member {string}
	     */
	    this.vertexSrc = vertexSrc || Filter.defaultVertexSrc;
	
	    /**
	     * The fragment shader.
	     *
	     * @member {string}
	     */
	    this.fragmentSrc = fragmentSrc || Filter.defaultFragmentSrc;
	
	    this._blendMode = _const.BLEND_MODES.NORMAL;
	
	    this.uniformData = uniforms || (0, _extractUniformsFromSrc2.default)(this.vertexSrc, this.fragmentSrc, 'projectionMatrix|uSampler');
	
	    /**
	     * An object containing the current values of custom uniforms.
	     * @example <caption>Updating the value of a custom uniform</caption>
	     * filter.uniforms.time = performance.now();
	     *
	     * @member {object}
	     */
	    this.uniforms = {};
	
	    for (var i in this.uniformData) {
	      this.uniforms[i] = this.uniformData[i].value;
	      if (this.uniformData[i].type) {
	        this.uniformData[i].type = this.uniformData[i].type.toLowerCase();
	      }
	    }
	
	    // this is where we store shader references..
	    // TODO we could cache this!
	    this.glShaders = {};
	
	    // used for cacheing.. sure there is a better way!
	    if (!SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc]) {
	      SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc] = (0, _utils.uid)();
	    }
	
	    this.glShaderKey = SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc];
	
	    /**
	     * The padding of the filter. Some filters require extra space to breath such as a blur.
	     * Increasing this will add extra width and height to the bounds of the object that the
	     * filter is applied to.
	     *
	     * @member {number}
	     */
	    this.padding = 4;
	
	    /**
	     * The resolution of the filter. Setting this to be lower will lower the quality but
	     * increase the performance of the filter.
	     *
	     * @member {number}
	     */
	    this.resolution = _settings2.default.FILTER_RESOLUTION;
	
	    /**
	     * If enabled is true the filter is applied, if false it will not.
	     *
	     * @member {boolean}
	     */
	    this.enabled = true;
	
	    /**
	     * If enabled, PixiJS will fit the filter area into boundaries for better performance.
	     * Switch it off if it does not work for specific shader.
	     *
	     * @member {boolean}
	     */
	    this.autoFit = true;
	  }
	
	  /**
	   * Applies the filter
	   *
	   * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
	   * @param {PIXI.RenderTarget} input - The input render target.
	   * @param {PIXI.RenderTarget} output - The target to output to.
	   * @param {boolean} clear - Should the output be cleared before rendering to it
	   * @param {object} [currentState] - It's current state of filter.
	   *        There are some useful properties in the currentState :
	   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
	   */
	
	
	  Filter.prototype.apply = function apply(filterManager, input, output, clear, currentState) // eslint-disable-line no-unused-vars
	  {
	    // --- //
	    //  this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(tempMatrix, window.panda );
	
	    // do as you please!
	
	    filterManager.applyFilter(this, input, output, clear);
	
	    // or just do a regular render..
	  };
	
	  /**
	   * Sets the blendmode of the filter
	   *
	   * @member {number}
	   * @default PIXI.BLEND_MODES.NORMAL
	   */
	
	
	  _createClass(Filter, [{
	    key: 'blendMode',
	    get: function get() {
	      return this._blendMode;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._blendMode = value;
	    }
	
	    /**
	     * The default vertex shader source
	     *
	     * @static
	     * @constant
	     */
	
	  }], [{
	    key: 'defaultVertexSrc',
	    get: function get() {
	      return ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform mat3 projectionMatrix;', 'uniform mat3 filterMatrix;', 'varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;', '   vTextureCoord = aTextureCoord ;', '}'].join('\n');
	    }
	
	    /**
	     * The default fragment shader source
	     *
	     * @static
	     * @constant
	     */
	
	  }, {
	    key: 'defaultFragmentSrc',
	    get: function get() {
	      return ['varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'uniform sampler2D uSampler;', 'uniform sampler2D filterSampler;', 'void main(void){', '   vec4 masky = texture2D(filterSampler, vFilterCoord);', '   vec4 sample = texture2D(uSampler, vTextureCoord);', '   vec4 color;', '   if(mod(vFilterCoord.x, 1.0) > 0.5)', '   {', '     color = vec4(1.0, 0.0, 0.0, 1.0);', '   }', '   else', '   {', '     color = vec4(0.0, 1.0, 0.0, 1.0);', '   }',
	      // '   gl_FragColor = vec4(mod(vFilterCoord.x, 1.5), vFilterCoord.y,0.0,1.0);',
	      '   gl_FragColor = mix(sample, masky, 0.5);', '   gl_FragColor *= sample.a;', '}'].join('\n');
	    }
	  }]);
	
	  return Filter;
	}();
	
	exports.default = Filter;
	//# sourceMappingURL=Filter.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Filter2 = __webpack_require__(112);
	
	var _Filter3 = _interopRequireDefault(_Filter2);
	
	var _math = __webpack_require__(7);
	
	var _path = __webpack_require__(13);
	
	var _TextureMatrix = __webpack_require__(118);
	
	var _TextureMatrix2 = _interopRequireDefault(_TextureMatrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The SpriteMaskFilter class
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI
	 */
	var SpriteMaskFilter = function (_Filter) {
	    _inherits(SpriteMaskFilter, _Filter);
	
	    /**
	     * @param {PIXI.Sprite} sprite - the target sprite
	     */
	    function SpriteMaskFilter(sprite) {
	        _classCallCheck(this, SpriteMaskFilter);
	
	        var maskMatrix = new _math.Matrix();
	
	        var _this = _possibleConstructorReturn(this, _Filter.call(this, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n', 'varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n\n    original *= (masky.r * masky.a * alpha * clip);\n\n    gl_FragColor = original;\n}\n'));
	
	        sprite.renderable = false;
	
	        _this.maskSprite = sprite;
	        _this.maskMatrix = maskMatrix;
	        return _this;
	    }
	
	    /**
	     * Applies the filter
	     *
	     * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
	     * @param {PIXI.RenderTarget} input - The input render target.
	     * @param {PIXI.RenderTarget} output - The target to output to.
	     */
	
	
	    SpriteMaskFilter.prototype.apply = function apply(filterManager, input, output) {
	        var maskSprite = this.maskSprite;
	        var tex = this.maskSprite.texture;
	
	        if (!tex.valid) {
	            return;
	        }
	        if (!tex.transform) {
	            // margin = 0.0, let it bleed a bit, shader code becomes easier
	            // assuming that atlas textures were made with 1-pixel padding
	            tex.transform = new _TextureMatrix2.default(tex, 0.0);
	        }
	        tex.transform.update();
	
	        this.uniforms.mask = tex;
	        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.transform.mapCoord);
	        this.uniforms.alpha = maskSprite.worldAlpha;
	        this.uniforms.maskClamp = tex.transform.uClampFrame;
	
	        filterManager.applyFilter(this, input, output);
	    };
	
	    return SpriteMaskFilter;
	}(_Filter3.default);
	
	exports.default = SpriteMaskFilter;
	//# sourceMappingURL=SpriteMaskFilter.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _createIndicesForQuads = __webpack_require__(67);
	
	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Helper class to create a quad
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Quad = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The gl context for this quad to use.
	   * @param {object} state - TODO: Description
	   */
	  function Quad(gl, state) {
	    _classCallCheck(this, Quad);
	
	    /**
	     * the current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    /**
	     * An array of vertices
	     *
	     * @member {Float32Array}
	     */
	    this.vertices = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]);
	
	    /**
	     * The Uvs of the quad
	     *
	     * @member {Float32Array}
	     */
	    this.uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
	
	    this.interleaved = new Float32Array(8 * 2);
	
	    for (var i = 0; i < 4; i++) {
	      this.interleaved[i * 4] = this.vertices[i * 2];
	      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
	      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
	      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
	    }
	
	    /**
	     * An array containing the indices of the vertices
	     *
	     * @member {Uint16Array}
	     */
	    this.indices = (0, _createIndicesForQuads2.default)(1);
	
	    /**
	     * The vertex buffer
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.vertexBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.interleaved, gl.STATIC_DRAW);
	
	    /**
	     * The index buffer
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
	
	    /**
	     * The vertex array object
	     *
	     * @member {glCore.VertexArrayObject}
	     */
	    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, state);
	  }
	
	  /**
	   * Initialises the vaos and uses the shader.
	   *
	   * @param {PIXI.Shader} shader - the shader to use
	   */
	
	
	  Quad.prototype.initVao = function initVao(shader) {
	    this.vao.clear().addIndex(this.indexBuffer).addAttribute(this.vertexBuffer, shader.attributes.aVertexPosition, this.gl.FLOAT, false, 4 * 4, 0).addAttribute(this.vertexBuffer, shader.attributes.aTextureCoord, this.gl.FLOAT, false, 4 * 4, 2 * 4);
	  };
	
	  /**
	   * Maps two Rectangle to the quad.
	   *
	   * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
	   * @param {PIXI.Rectangle} destinationFrame - the second rectangle
	   * @return {PIXI.Quad} Returns itself.
	   */
	
	
	  Quad.prototype.map = function map(targetTextureFrame, destinationFrame) {
	    var x = 0; // destinationFrame.x / targetTextureFrame.width;
	    var y = 0; // destinationFrame.y / targetTextureFrame.height;
	
	    this.uvs[0] = x;
	    this.uvs[1] = y;
	
	    this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
	    this.uvs[3] = y;
	
	    this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
	    this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;
	
	    this.uvs[6] = x;
	    this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;
	
	    x = destinationFrame.x;
	    y = destinationFrame.y;
	
	    this.vertices[0] = x;
	    this.vertices[1] = y;
	
	    this.vertices[2] = x + destinationFrame.width;
	    this.vertices[3] = y;
	
	    this.vertices[4] = x + destinationFrame.width;
	    this.vertices[5] = y + destinationFrame.height;
	
	    this.vertices[6] = x;
	    this.vertices[7] = y + destinationFrame.height;
	
	    return this;
	  };
	
	  /**
	   * Binds the buffer and uploads the data
	   *
	   * @return {PIXI.Quad} Returns itself.
	   */
	
	
	  Quad.prototype.upload = function upload() {
	    for (var i = 0; i < 4; i++) {
	      this.interleaved[i * 4] = this.vertices[i * 2];
	      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
	      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
	      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
	    }
	
	    this.vertexBuffer.upload(this.interleaved);
	
	    return this;
	  };
	
	  /**
	   * Removes this quad from WebGL
	   */
	
	
	  Quad.prototype.destroy = function destroy() {
	    var gl = this.gl;
	
	    gl.deleteBuffer(this.vertexBuffer);
	    gl.deleteBuffer(this.indexBuffer);
	  };
	
	  return Quad;
	}();
	
	exports.default = Quad;
	//# sourceMappingURL=Quad.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The TextMetrics object represents the measurement of a block of text with a specified style.
	 *
	 * ```js
	 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
	 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
	 * ```
	 *
	 * @class
	 * @memberOf PIXI
	 */
	var TextMetrics = function () {
	    /**
	     * @param {string} text - the text that was measured
	     * @param {PIXI.TextStyle} style - the style that was measured
	     * @param {number} width - the measured width of the text
	     * @param {number} height - the measured height of the text
	     * @param {array} lines - an array of the lines of text broken by new lines and wrapping if specified in style
	     * @param {array} lineWidths - an array of the line widths for each line matched to `lines`
	     * @param {number} lineHeight - the measured line height for this style
	     * @param {number} maxLineWidth - the maximum line width for all measured lines
	     * @param {Object} fontProperties - the font properties object from TextMetrics.measureFont
	     */
	    function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
	        _classCallCheck(this, TextMetrics);
	
	        this.text = text;
	        this.style = style;
	        this.width = width;
	        this.height = height;
	        this.lines = lines;
	        this.lineWidths = lineWidths;
	        this.lineHeight = lineHeight;
	        this.maxLineWidth = maxLineWidth;
	        this.fontProperties = fontProperties;
	    }
	
	    /**
	     * Measures the supplied string of text and returns a Rectangle.
	     *
	     * @param {string} text - the text to measure.
	     * @param {PIXI.TextStyle} style - the text style to use for measuring
	     * @param {boolean} [wordWrap] - optional override for if word-wrap should be applied to the text.
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {PIXI.TextMetrics} measured width and height of the text.
	     */
	
	
	    TextMetrics.measureText = function measureText(text, style, wordWrap) {
	        var canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TextMetrics._canvas;
	
	        wordWrap = wordWrap || style.wordWrap;
	        var font = style.toFontString();
	        var fontProperties = TextMetrics.measureFont(font);
	        var context = canvas.getContext('2d');
	
	        context.font = font;
	
	        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
	        var lines = outputText.split(/(?:\r\n|\r|\n)/);
	        var lineWidths = new Array(lines.length);
	        var maxLineWidth = 0;
	
	        for (var i = 0; i < lines.length; i++) {
	            var lineWidth = context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;
	
	            lineWidths[i] = lineWidth;
	            maxLineWidth = Math.max(maxLineWidth, lineWidth);
	        }
	        var width = maxLineWidth + style.strokeThickness;
	
	        if (style.dropShadow) {
	            width += style.dropShadowDistance;
	        }
	
	        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
	        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * (lineHeight + style.leading);
	
	        if (style.dropShadow) {
	            height += style.dropShadowDistance;
	        }
	
	        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
	    };
	
	    /**
	     * Applies newlines to a string to have it optimally fit into the horizontal
	     * bounds set by the Text object's wordWrapWidth property.
	     *
	     * @private
	     * @param {string} text - String to apply word wrapping to
	     * @param {PIXI.TextStyle} style - the style to use when wrapping
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {string} New string with new lines applied where required
	     */
	
	
	    TextMetrics.wordWrap = function wordWrap(text, style) {
	        var canvas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TextMetrics._canvas;
	
	        var context = canvas.getContext('2d');
	
	        var width = 0;
	        var line = '';
	        var lines = '';
	
	        var cache = {};
	        var letterSpacing = style.letterSpacing,
	            whiteSpace = style.whiteSpace;
	
	        // How to handle whitespaces
	
	        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
	        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);
	
	        // whether or not spaces may be added to the beginning of lines
	        var canPrependSpaces = !collapseSpaces;
	
	        // There is letterSpacing after every char except the last one
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
	        // so for convenience the above needs to be compared to width + 1 extra letterSpace
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
	        // ________________________________________________
	        // And then the final space is simply no appended to each line
	        var wordWrapWidth = style.wordWrapWidth + letterSpacing;
	
	        // break text into words, spaces and newline chars
	        var tokens = TextMetrics.tokenize(text);
	
	        for (var i = 0; i < tokens.length; i++) {
	            // get the word, space or newlineChar
	            var token = tokens[i];
	
	            // if word is a new line
	            if (TextMetrics.isNewline(token)) {
	                // keep the new line
	                if (!collapseNewlines) {
	                    lines += TextMetrics.addLine(line);
	                    canPrependSpaces = !collapseSpaces;
	                    line = '';
	                    width = 0;
	                    continue;
	                }
	
	                // if we should collapse new lines
	                // we simply convert it into a space
	                token = ' ';
	            }
	
	            // if we should collapse repeated whitespaces
	            if (collapseSpaces) {
	                // check both this and the last tokens for spaces
	                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
	                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);
	
	                if (currIsBreakingSpace && lastIsBreakingSpace) {
	                    continue;
	                }
	            }
	
	            // get word width from cache if possible
	            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);
	
	            // word is longer than desired bounds
	            if (tokenWidth > wordWrapWidth) {
	                // if we are not already at the beginning of a line
	                if (line !== '') {
	                    // start newlines for overflow words
	                    lines += TextMetrics.addLine(line);
	                    line = '';
	                    width = 0;
	                }
	
	                // break large word over multiple lines
	                if (TextMetrics.canBreakWords(token, style.breakWords)) {
	                    // break word into characters
	                    var characters = token.split('');
	
	                    // loop the characters
	                    for (var j = 0; j < characters.length; j++) {
	                        var char = characters[j];
	
	                        var k = 1;
	                        // we are not at the end of the token
	
	                        while (characters[j + k]) {
	                            var nextChar = characters[j + k];
	                            var lastChar = char[char.length - 1];
	
	                            // should not split chars
	                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) {
	                                // combine chars & move forward one
	                                char += nextChar;
	                            } else {
	                                break;
	                            }
	
	                            k++;
	                        }
	
	                        j += char.length - 1;
	
	                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);
	
	                        if (characterWidth + width > wordWrapWidth) {
	                            lines += TextMetrics.addLine(line);
	                            canPrependSpaces = false;
	                            line = '';
	                            width = 0;
	                        }
	
	                        line += char;
	                        width += characterWidth;
	                    }
	                }
	
	                // run word out of the bounds
	                else {
	                        // if there are words in this line already
	                        // finish that line and start a new one
	                        if (line.length > 0) {
	                            lines += TextMetrics.addLine(line);
	                            line = '';
	                            width = 0;
	                        }
	
	                        // give it its own line
	                        lines += TextMetrics.addLine(token);
	                        canPrependSpaces = false;
	                        line = '';
	                        width = 0;
	                    }
	            }
	
	            // word could fit
	            else {
	                    // word won't fit because of existing words
	                    // start a new line
	                    if (tokenWidth + width > wordWrapWidth) {
	                        // if its a space we don't want it
	                        canPrependSpaces = false;
	
	                        // add a new line
	                        lines += TextMetrics.addLine(line);
	
	                        // start a new line
	                        line = '';
	                        width = 0;
	                    }
	
	                    // don't add spaces to the beginning of lines
	                    if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
	                        // add the word to the current line
	                        line += token;
	
	                        // update width counter
	                        width += tokenWidth;
	                    }
	                }
	        }
	
	        lines += TextMetrics.addLine(line, false);
	
	        return lines;
	    };
	
	    /**
	     * Convienience function for logging each line added during the wordWrap
	     * method
	     *
	     * @private
	     * @param  {string}   line        - The line of text to add
	     * @param  {boolean}  newLine     - Add new line character to end
	     * @return {string}   A formatted line
	     */
	
	
	    TextMetrics.addLine = function addLine(line) {
	        var newLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        line = TextMetrics.trimRight(line);
	
	        line = newLine ? line + '\n' : line;
	
	        return line;
	    };
	
	    /**
	     * Gets & sets the widths of calculated characters in a cache object
	     *
	     * @private
	     * @param  {string}                    key            The key
	     * @param  {number}                    letterSpacing  The letter spacing
	     * @param  {object}                    cache          The cache
	     * @param  {CanvasRenderingContext2D}  context        The canvas context
	     * @return {number}                    The from cache.
	     */
	
	
	    TextMetrics.getFromCache = function getFromCache(key, letterSpacing, cache, context) {
	        var width = cache[key];
	
	        if (width === undefined) {
	            var spacing = key.length * letterSpacing;
	
	            width = context.measureText(key).width + spacing;
	            cache[key] = width;
	        }
	
	        return width;
	    };
	
	    /**
	     * Determines whether we should collapse breaking spaces
	     *
	     * @private
	     * @param  {string}   whiteSpace  The TextStyle property whiteSpace
	     * @return {boolean}  should collapse
	     */
	
	
	    TextMetrics.collapseSpaces = function collapseSpaces(whiteSpace) {
	        return whiteSpace === 'normal' || whiteSpace === 'pre-line';
	    };
	
	    /**
	     * Determines whether we should collapse newLine chars
	     *
	     * @private
	     * @param  {string}   whiteSpace  The white space
	     * @return {boolean}  should collapse
	     */
	
	
	    TextMetrics.collapseNewlines = function collapseNewlines(whiteSpace) {
	        return whiteSpace === 'normal';
	    };
	
	    /**
	     * trims breaking whitespaces from string
	     *
	     * @private
	     * @param  {string}  text  The text
	     * @return {string}  trimmed string
	     */
	
	
	    TextMetrics.trimRight = function trimRight(text) {
	        if (typeof text !== 'string') {
	            return '';
	        }
	
	        for (var i = text.length - 1; i >= 0; i--) {
	            var char = text[i];
	
	            if (!TextMetrics.isBreakingSpace(char)) {
	                break;
	            }
	
	            text = text.slice(0, -1);
	        }
	
	        return text;
	    };
	
	    /**
	     * Determines if char is a newline.
	     *
	     * @private
	     * @param  {string}  char  The character
	     * @return {boolean}  True if newline, False otherwise.
	     */
	
	
	    TextMetrics.isNewline = function isNewline(char) {
	        if (typeof char !== 'string') {
	            return false;
	        }
	
	        return TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0;
	    };
	
	    /**
	     * Determines if char is a breaking whitespace.
	     *
	     * @private
	     * @param  {string}  char  The character
	     * @return {boolean}  True if whitespace, False otherwise.
	     */
	
	
	    TextMetrics.isBreakingSpace = function isBreakingSpace(char) {
	        if (typeof char !== 'string') {
	            return false;
	        }
	
	        return TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0;
	    };
	
	    /**
	     * Splits a string into words, breaking-spaces and newLine characters
	     *
	     * @private
	     * @param  {string}  text       The text
	     * @return {array}  A tokenized array
	     */
	
	
	    TextMetrics.tokenize = function tokenize(text) {
	        var tokens = [];
	        var token = '';
	
	        if (typeof text !== 'string') {
	            return tokens;
	        }
	
	        for (var i = 0; i < text.length; i++) {
	            var char = text[i];
	
	            if (TextMetrics.isBreakingSpace(char) || TextMetrics.isNewline(char)) {
	                if (token !== '') {
	                    tokens.push(token);
	                    token = '';
	                }
	
	                tokens.push(char);
	
	                continue;
	            }
	
	            token += char;
	        }
	
	        if (token !== '') {
	            tokens.push(token);
	        }
	
	        return tokens;
	    };
	
	    /**
	     * This method exists to be easily overridden
	     * It allows one to customise which words should break
	     * Examples are if the token is CJK or numbers.
	     * It must return a boolean.
	     *
	     * @private
	     * @param  {string}  token       The token
	     * @param  {boolean}  breakWords  The style attr break words
	     * @return {boolean} whether to break word or not
	     */
	
	
	    TextMetrics.canBreakWords = function canBreakWords(token, breakWords) {
	        return breakWords;
	    };
	
	    /**
	     * This method exists to be easily overridden
	     * It allows one to determine whether a pair of characters
	     * should be broken by newlines
	     * For example certain characters in CJK langs or numbers.
	     * It must return a boolean.
	     *
	     * @private
	     * @param  {string}  char      The character
	     * @param  {string}  nextChar  The next character
	     * @param  {string}  token     The token/word the characters are from
	     * @param  {number}  index     The index in the token of the char
	     * @param  {boolean}  breakWords  The style attr break words
	     * @return {boolean} whether to break word or not
	     */
	
	
	    TextMetrics.canBreakChars = function canBreakChars(char, nextChar, token, index, breakWords) // eslint-disable-line no-unused-vars
	    {
	        return true;
	    };
	
	    /**
	     * Calculates the ascent, descent and fontSize of a given font-style
	     *
	     * @static
	     * @param {string} font - String representing the style of the font
	     * @return {PIXI.TextMetrics~FontMetrics} Font properties object
	     */
	
	
	    TextMetrics.measureFont = function measureFont(font) {
	        // as this method is used for preparing assets, don't recalculate things if we don't need to
	        if (TextMetrics._fonts[font]) {
	            return TextMetrics._fonts[font];
	        }
	
	        var properties = {};
	
	        var canvas = TextMetrics._canvas;
	        var context = TextMetrics._context;
	
	        context.font = font;
	
	        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
	        var width = Math.ceil(context.measureText(metricsString).width);
	        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
	        var height = 2 * baseline;
	
	        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;
	
	        canvas.width = width;
	        canvas.height = height;
	
	        context.fillStyle = '#f00';
	        context.fillRect(0, 0, width, height);
	
	        context.font = font;
	
	        context.textBaseline = 'alphabetic';
	        context.fillStyle = '#000';
	        context.fillText(metricsString, 0, baseline);
	
	        var imagedata = context.getImageData(0, 0, width, height).data;
	        var pixels = imagedata.length;
	        var line = width * 4;
	
	        var i = 0;
	        var idx = 0;
	        var stop = false;
	
	        // ascent. scan from top to bottom until we find a non red pixel
	        for (i = 0; i < baseline; ++i) {
	            for (var j = 0; j < line; j += 4) {
	                if (imagedata[idx + j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }
	            if (!stop) {
	                idx += line;
	            } else {
	                break;
	            }
	        }
	
	        properties.ascent = baseline - i;
	
	        idx = pixels - line;
	        stop = false;
	
	        // descent. scan from bottom to top until we find a non red pixel
	        for (i = height; i > baseline; --i) {
	            for (var _j = 0; _j < line; _j += 4) {
	                if (imagedata[idx + _j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }
	
	            if (!stop) {
	                idx -= line;
	            } else {
	                break;
	            }
	        }
	
	        properties.descent = i - baseline;
	        properties.fontSize = properties.ascent + properties.descent;
	
	        TextMetrics._fonts[font] = properties;
	
	        return properties;
	    };
	
	    /**
	     * Clear font metrics in metrics cache.
	     *
	     * @static
	     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
	     */
	
	
	    TextMetrics.clearMetrics = function clearMetrics() {
	        var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	        if (font) {
	            delete TextMetrics._fonts[font];
	        } else {
	            TextMetrics._fonts = {};
	        }
	    };
	
	    return TextMetrics;
	}();
	
	/**
	 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
	 * @class FontMetrics
	 * @memberof PIXI.TextMetrics~
	 * @property {number} ascent - The ascent distance
	 * @property {number} descent - The descent distance
	 * @property {number} fontSize - Font size from ascent to descent
	 */
	
	exports.default = TextMetrics;
	var canvas = document.createElement('canvas');
	
	canvas.width = canvas.height = 10;
	
	/**
	 * Cached canvas element for measuring text
	 * @memberof PIXI.TextMetrics
	 * @type {HTMLCanvasElement}
	 * @private
	 */
	TextMetrics._canvas = canvas;
	
	/**
	 * Cache for context to use.
	 * @memberof PIXI.TextMetrics
	 * @type {CanvasRenderingContext2D}
	 * @private
	 */
	TextMetrics._context = canvas.getContext('2d');
	
	/**
	 * Cache of PIXI.TextMetrics~FontMetrics objects.
	 * @memberof PIXI.TextMetrics
	 * @type {Object}
	 * @private
	 */
	TextMetrics._fonts = {};
	
	/**
	 * String used for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name METRICS_STRING
	 * @type {string}
	 * @default |Éq
	 */
	TextMetrics.METRICS_STRING = '|Éq';
	
	/**
	 * Baseline symbol for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_SYMBOL
	 * @type {string}
	 * @default M
	 */
	TextMetrics.BASELINE_SYMBOL = 'M';
	
	/**
	 * Baseline multiplier for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_MULTIPLIER
	 * @type {number}
	 * @default 1.4
	 */
	TextMetrics.BASELINE_MULTIPLIER = 1.4;
	
	/**
	 * Cache of new line chars.
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._newlines = [0x000A, // line feed
	0x000D];
	
	/**
	 * Cache of breaking spaces.
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._breakingSpaces = [0x0009, // character tabulation
	0x0020, // space
	0x2000, // en quad
	0x2001, // em quad
	0x2002, // en space
	0x2003, // em space
	0x2004, // three-per-em space
	0x2005, // four-per-em space
	0x2006, // six-per-em space
	0x2008, // punctuation space
	0x2009, // thin space
	0x200A, // hair space
	0x205F, // medium mathematical space
	0x3000];
	//# sourceMappingURL=TextMetrics.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // disabling eslint for now, going to rewrite this in v5
	/* eslint-disable */
	
	var _const = __webpack_require__(3);
	
	var _utils = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultStyle = {
	    align: 'left',
	    breakWords: false,
	    dropShadow: false,
	    dropShadowAlpha: 1,
	    dropShadowAngle: Math.PI / 6,
	    dropShadowBlur: 0,
	    dropShadowColor: 'black',
	    dropShadowDistance: 5,
	    fill: 'black',
	    fillGradientType: _const.TEXT_GRADIENT.LINEAR_VERTICAL,
	    fillGradientStops: [],
	    fontFamily: 'Arial',
	    fontSize: 26,
	    fontStyle: 'normal',
	    fontVariant: 'normal',
	    fontWeight: 'normal',
	    letterSpacing: 0,
	    lineHeight: 0,
	    lineJoin: 'miter',
	    miterLimit: 10,
	    padding: 0,
	    stroke: 'black',
	    strokeThickness: 0,
	    textBaseline: 'alphabetic',
	    trim: false,
	    whiteSpace: 'pre',
	    wordWrap: false,
	    wordWrapWidth: 100,
	    leading: 0
	};
	
	/**
	 * A TextStyle Object decorates a Text Object. It can be shared between
	 * multiple Text objects. Changing the style will update all text objects using it.
	 *
	 * @class
	 * @memberof PIXI
	 */
	
	var TextStyle = function () {
	    /**
	     * @param {object} [style] - The style parameters
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
	     *  does not affect single line text
	     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
	     *  needs wordWrap to be set to true
	     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
	     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
	     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
	     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
	     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
	     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
	     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
	     *  eg ['#000000','#FFFFFF']
	     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
	     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
	     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
	     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
	     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
	     *  equivalents are '26px','20pt','160%' or '1.6em')
	     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
	     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
	     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
	     *  '200', '300', '400', '500', '600', '700', 800' or '900')
	     * @param {number} [style.leading=0] - The space between lines
	     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
	     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
	     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
	     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
	     *      (creates a squared corner).
	     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
	     *      or increase the spikiness of rendered text.
	     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
	     *     happening by adding padding to all sides of the text.
	     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
	     *  e.g 'blue', '#FCFF00'
	     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
	     *  Default is 0 (no stroke)
	     * @param {boolean} [style.trim=false] - Trim transparent borders
	     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
	     * @param {boolean} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
	     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
	     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
	     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
	     */
	    function TextStyle(style) {
	        _classCallCheck(this, TextStyle);
	
	        this.styleID = 0;
	
	        this.reset();
	
	        deepCopyProperties(this, style, style);
	    }
	
	    /**
	     * Creates a new TextStyle object with the same values as this one.
	     * Note that the only the properties of the object are cloned.
	     *
	     * @return {PIXI.TextStyle} New cloned TextStyle object
	     */
	
	
	    TextStyle.prototype.clone = function clone() {
	        var clonedProperties = {};
	
	        deepCopyProperties(clonedProperties, this, defaultStyle);
	
	        return new TextStyle(clonedProperties);
	    };
	
	    /**
	     * Resets all properties to the defaults specified in TextStyle.prototype._default
	     */
	
	
	    TextStyle.prototype.reset = function reset() {
	        deepCopyProperties(this, defaultStyle, defaultStyle);
	    };
	
	    /**
	     * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
	     *
	     * @member {string}
	     */
	
	
	    /**
	     * Generates a font style string to use for `TextMetrics.measureFont()`.
	     *
	     * @return {string} Font style string, for passing to `TextMetrics.measureFont()`
	     */
	    TextStyle.prototype.toFontString = function toFontString() {
	        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
	        var fontSizeString = typeof this.fontSize === 'number' ? this.fontSize + 'px' : this.fontSize;
	
	        // Clean-up fontFamily property by quoting each font name
	        // this will support font names with spaces
	        var fontFamilies = this.fontFamily;
	
	        if (!Array.isArray(this.fontFamily)) {
	            fontFamilies = this.fontFamily.split(',');
	        }
	
	        for (var i = fontFamilies.length - 1; i >= 0; i--) {
	            // Trim any extra white-space
	            var fontFamily = fontFamilies[i].trim();
	
	            // Check if font already contains strings
	            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily)) {
	                fontFamily = '"' + fontFamily + '"';
	            }
	            fontFamilies[i] = fontFamily;
	        }
	
	        return this.fontStyle + ' ' + this.fontVariant + ' ' + this.fontWeight + ' ' + fontSizeString + ' ' + fontFamilies.join(',');
	    };
	
	    _createClass(TextStyle, [{
	        key: 'align',
	        get: function get() {
	            return this._align;
	        },
	        set: function set(align) // eslint-disable-line require-jsdoc
	        {
	            if (this._align !== align) {
	                this._align = align;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Indicates if lines can be wrapped within words, it needs wordWrap to be set to true
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'breakWords',
	        get: function get() {
	            return this._breakWords;
	        },
	        set: function set(breakWords) // eslint-disable-line require-jsdoc
	        {
	            if (this._breakWords !== breakWords) {
	                this._breakWords = breakWords;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a drop shadow for the text
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'dropShadow',
	        get: function get() {
	            return this._dropShadow;
	        },
	        set: function set(dropShadow) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadow !== dropShadow) {
	                this._dropShadow = dropShadow;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set alpha for the drop shadow
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowAlpha',
	        get: function get() {
	            return this._dropShadowAlpha;
	        },
	        set: function set(dropShadowAlpha) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowAlpha !== dropShadowAlpha) {
	                this._dropShadowAlpha = dropShadowAlpha;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a angle of the drop shadow
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowAngle',
	        get: function get() {
	            return this._dropShadowAngle;
	        },
	        set: function set(dropShadowAngle) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowAngle !== dropShadowAngle) {
	                this._dropShadowAngle = dropShadowAngle;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a shadow blur radius
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowBlur',
	        get: function get() {
	            return this._dropShadowBlur;
	        },
	        set: function set(dropShadowBlur) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowBlur !== dropShadowBlur) {
	                this._dropShadowBlur = dropShadowBlur;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	         *
	         * @member {string|number}
	         */
	
	    }, {
	        key: 'dropShadowColor',
	        get: function get() {
	            return this._dropShadowColor;
	        },
	        set: function set(dropShadowColor) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(dropShadowColor);
	            if (this._dropShadowColor !== outputColor) {
	                this._dropShadowColor = outputColor;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Set a distance of the drop shadow
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'dropShadowDistance',
	        get: function get() {
	            return this._dropShadowDistance;
	        },
	        set: function set(dropShadowDistance) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowDistance !== dropShadowDistance) {
	                this._dropShadowDistance = dropShadowDistance;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
	         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
	         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	         *
	         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
	         */
	
	    }, {
	        key: 'fill',
	        get: function get() {
	            return this._fill;
	        },
	        set: function set(fill) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(fill);
	            if (this._fill !== outputColor) {
	                this._fill = outputColor;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
	         * See {@link PIXI.TEXT_GRADIENT}
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'fillGradientType',
	        get: function get() {
	            return this._fillGradientType;
	        },
	        set: function set(fillGradientType) // eslint-disable-line require-jsdoc
	        {
	            if (this._fillGradientType !== fillGradientType) {
	                this._fillGradientType = fillGradientType;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * If fill is an array of colours to create a gradient, this array can set the stop points
	         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	         *
	         * @member {number[]}
	         */
	
	    }, {
	        key: 'fillGradientStops',
	        get: function get() {
	            return this._fillGradientStops;
	        },
	        set: function set(fillGradientStops) // eslint-disable-line require-jsdoc
	        {
	            if (!areArraysEqual(this._fillGradientStops, fillGradientStops)) {
	                this._fillGradientStops = fillGradientStops;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font family
	         *
	         * @member {string|string[]}
	         */
	
	    }, {
	        key: 'fontFamily',
	        get: function get() {
	            return this._fontFamily;
	        },
	        set: function set(fontFamily) // eslint-disable-line require-jsdoc
	        {
	            if (this.fontFamily !== fontFamily) {
	                this._fontFamily = fontFamily;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font size
	         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
	         *
	         * @member {number|string}
	         */
	
	    }, {
	        key: 'fontSize',
	        get: function get() {
	            return this._fontSize;
	        },
	        set: function set(fontSize) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontSize !== fontSize) {
	                this._fontSize = fontSize;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font style
	         * ('normal', 'italic' or 'oblique')
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'fontStyle',
	        get: function get() {
	            return this._fontStyle;
	        },
	        set: function set(fontStyle) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontStyle !== fontStyle) {
	                this._fontStyle = fontStyle;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font variant
	         * ('normal' or 'small-caps')
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'fontVariant',
	        get: function get() {
	            return this._fontVariant;
	        },
	        set: function set(fontVariant) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontVariant !== fontVariant) {
	                this._fontVariant = fontVariant;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The font weight
	         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'fontWeight',
	        get: function get() {
	            return this._fontWeight;
	        },
	        set: function set(fontWeight) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontWeight !== fontWeight) {
	                this._fontWeight = fontWeight;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The amount of spacing between letters, default is 0
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'letterSpacing',
	        get: function get() {
	            return this._letterSpacing;
	        },
	        set: function set(letterSpacing) // eslint-disable-line require-jsdoc
	        {
	            if (this._letterSpacing !== letterSpacing) {
	                this._letterSpacing = letterSpacing;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The line height, a number that represents the vertical space that a letter uses
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'lineHeight',
	        get: function get() {
	            return this._lineHeight;
	        },
	        set: function set(lineHeight) // eslint-disable-line require-jsdoc
	        {
	            if (this._lineHeight !== lineHeight) {
	                this._lineHeight = lineHeight;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The space between lines
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'leading',
	        get: function get() {
	            return this._leading;
	        },
	        set: function set(leading) // eslint-disable-line require-jsdoc
	        {
	            if (this._leading !== leading) {
	                this._leading = leading;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
	         * Default is 'miter' (creates a sharp corner).
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'lineJoin',
	        get: function get() {
	            return this._lineJoin;
	        },
	        set: function set(lineJoin) // eslint-disable-line require-jsdoc
	        {
	            if (this._lineJoin !== lineJoin) {
	                this._lineJoin = lineJoin;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The miter limit to use when using the 'miter' lineJoin mode
	         * This can reduce or increase the spikiness of rendered text.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'miterLimit',
	        get: function get() {
	            return this._miterLimit;
	        },
	        set: function set(miterLimit) // eslint-disable-line require-jsdoc
	        {
	            if (this._miterLimit !== miterLimit) {
	                this._miterLimit = miterLimit;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
	         * by adding padding to all sides of the text.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'padding',
	        get: function get() {
	            return this._padding;
	        },
	        set: function set(padding) // eslint-disable-line require-jsdoc
	        {
	            if (this._padding !== padding) {
	                this._padding = padding;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A canvas fillstyle that will be used on the text stroke
	         * e.g 'blue', '#FCFF00'
	         *
	         * @member {string|number}
	         */
	
	    }, {
	        key: 'stroke',
	        get: function get() {
	            return this._stroke;
	        },
	        set: function set(stroke) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(stroke);
	            if (this._stroke !== outputColor) {
	                this._stroke = outputColor;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * A number that represents the thickness of the stroke.
	         * Default is 0 (no stroke)
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'strokeThickness',
	        get: function get() {
	            return this._strokeThickness;
	        },
	        set: function set(strokeThickness) // eslint-disable-line require-jsdoc
	        {
	            if (this._strokeThickness !== strokeThickness) {
	                this._strokeThickness = strokeThickness;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The baseline of the text that is rendered.
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'textBaseline',
	        get: function get() {
	            return this._textBaseline;
	        },
	        set: function set(textBaseline) // eslint-disable-line require-jsdoc
	        {
	            if (this._textBaseline !== textBaseline) {
	                this._textBaseline = textBaseline;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Trim transparent borders
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'trim',
	        get: function get() {
	            return this._trim;
	        },
	        set: function set(trim) // eslint-disable-line require-jsdoc
	        {
	            if (this._trim !== trim) {
	                this._trim = trim;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * How newlines and spaces should be handled.
	         * Default is 'pre' (preserve, preserve).
	         *
	         *  value       | New lines     |   Spaces
	         *  ---         | ---           |   ---
	         * 'normal'     | Collapse      |   Collapse
	         * 'pre'        | Preserve      |   Preserve
	         * 'pre-line'   | Preserve      |   Collapse
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'whiteSpace',
	        get: function get() {
	            return this._whiteSpace;
	        },
	        set: function set(whiteSpace) // eslint-disable-line require-jsdoc
	        {
	            if (this._whiteSpace !== whiteSpace) {
	                this._whiteSpace = whiteSpace;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * Indicates if word wrap should be used
	         *
	         * @member {boolean}
	         */
	
	    }, {
	        key: 'wordWrap',
	        get: function get() {
	            return this._wordWrap;
	        },
	        set: function set(wordWrap) // eslint-disable-line require-jsdoc
	        {
	            if (this._wordWrap !== wordWrap) {
	                this._wordWrap = wordWrap;
	                this.styleID++;
	            }
	        }
	
	        /**
	         * The width at which text will wrap, it needs wordWrap to be set to true
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'wordWrapWidth',
	        get: function get() {
	            return this._wordWrapWidth;
	        },
	        set: function set(wordWrapWidth) // eslint-disable-line require-jsdoc
	        {
	            if (this._wordWrapWidth !== wordWrapWidth) {
	                this._wordWrapWidth = wordWrapWidth;
	                this.styleID++;
	            }
	        }
	    }]);
	
	    return TextStyle;
	}();
	
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * @private
	 * @param {number|number[]} color
	 * @return {string} The color as a string.
	 */
	
	
	exports.default = TextStyle;
	function getSingleColor(color) {
	    if (typeof color === 'number') {
	        return (0, _utils.hex2string)(color);
	    } else if (typeof color === 'string') {
	        if (color.indexOf('0x') === 0) {
	            color = color.replace('0x', '#');
	        }
	    }
	
	    return color;
	}
	
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * This version can also convert array of colors
	 * @private
	 * @param {number|number[]} color
	 * @return {string} The color as a string.
	 */
	function getColor(color) {
	    if (!Array.isArray(color)) {
	        return getSingleColor(color);
	    } else {
	        for (var i = 0; i < color.length; ++i) {
	            color[i] = getSingleColor(color[i]);
	        }
	
	        return color;
	    }
	}
	
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * This version can also convert array of colors
	 * @private
	 * @param {Array} array1 First array to compare
	 * @param {Array} array2 Second array to compare
	 * @return {boolean} Do the arrays contain the same values in the same order
	 */
	function areArraysEqual(array1, array2) {
	    if (!Array.isArray(array1) || !Array.isArray(array2)) {
	        return false;
	    }
	
	    if (array1.length !== array2.length) {
	        return false;
	    }
	
	    for (var i = 0; i < array1.length; ++i) {
	        if (array1[i] !== array2[i]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	/**
	 * Utility function to ensure that object properties are copied by value, and not by reference
	 * @private
	 * @param {Object} target Target object to copy properties into
	 * @param {Object} source Source object for the proporties to copy
	 * @param {string} propertyObj Object containing properties names we want to loop over
	 */
	function deepCopyProperties(target, source, propertyObj) {
	    for (var prop in propertyObj) {
	        if (Array.isArray(source[prop])) {
	            target[prop] = source[prop].slice();
	        } else {
	            target[prop] = source[prop];
	        }
	    }
	}
	//# sourceMappingURL=TextStyle.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BaseTexture2 = __webpack_require__(24);
	
	var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
	 * and rotation of the given Display Objects is ignored. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
	 * let baseRenderTexture = new PIXI.BaseRenderTexture(renderer, 800, 600);
	 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * baseRenderTexture.render(sprite);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let baseRenderTexture = new PIXI.BaseRenderTexture(100, 100);
	 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 */
	var BaseRenderTexture = function (_BaseTexture) {
	  _inherits(BaseRenderTexture, _BaseTexture);
	
	  /**
	   * @param {number} [width=100] - The width of the base render texture
	   * @param {number} [height=100] - The height of the base render texture
	   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	   * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
	   */
	  function BaseRenderTexture() {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
	    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	    var scaleMode = arguments[2];
	    var resolution = arguments[3];
	
	    _classCallCheck(this, BaseRenderTexture);
	
	    var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, null, scaleMode));
	
	    _this.resolution = resolution || _settings2.default.RESOLUTION;
	
	    _this.width = Math.ceil(width);
	    _this.height = Math.ceil(height);
	
	    _this.realWidth = _this.width * _this.resolution;
	    _this.realHeight = _this.height * _this.resolution;
	
	    _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
	    _this.hasLoaded = true;
	
	    /**
	     * A map of renderer IDs to webgl renderTargets
	     *
	     * @private
	     * @member {object<number, WebGLTexture>}
	     */
	    _this._glRenderTargets = {};
	
	    /**
	     * A reference to the canvas render target (we only need one as this can be shared across renderers)
	     *
	     * @private
	     * @member {object<number, WebGLTexture>}
	     */
	    _this._canvasRenderTarget = null;
	
	    /**
	     * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	     *
	     * @member {boolean}
	     */
	    _this.valid = false;
	    return _this;
	  }
	
	  /**
	   * Resizes the BaseRenderTexture.
	   *
	   * @param {number} width - The width to resize to.
	   * @param {number} height - The height to resize to.
	   */
	
	
	  BaseRenderTexture.prototype.resize = function resize(width, height) {
	    width = Math.ceil(width);
	    height = Math.ceil(height);
	
	    if (width === this.width && height === this.height) {
	      return;
	    }
	
	    this.valid = width > 0 && height > 0;
	
	    this.width = width;
	    this.height = height;
	
	    this.realWidth = this.width * this.resolution;
	    this.realHeight = this.height * this.resolution;
	
	    if (!this.valid) {
	      return;
	    }
	
	    this.emit('update', this);
	  };
	
	  /**
	   * Destroys this texture
	   *
	   */
	
	
	  BaseRenderTexture.prototype.destroy = function destroy() {
	    _BaseTexture.prototype.destroy.call(this, true);
	    this.renderer = null;
	  };
	
	  return BaseRenderTexture;
	}(_BaseTexture3.default);
	
	exports.default = BaseRenderTexture;
	//# sourceMappingURL=BaseRenderTexture.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Matrix = __webpack_require__(60);
	
	var _Matrix2 = _interopRequireDefault(_Matrix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var tempMat = new _Matrix2.default();
	
	/**
	 * Class controls uv transform and frame clamp for texture
	 * Can be used in Texture "transform" field, or separately, you can use different clamp settings on the same texture.
	 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
	 *
	 * @see PIXI.Texture
	 * @see PIXI.mesh.Mesh
	 * @see PIXI.extras.TilingSprite
	 * @class
	 * @memberof PIXI
	 */
	
	var TextureMatrix = function () {
	    /**
	     *
	     * @param {PIXI.Texture} texture observed texture
	     * @param {number} [clampMargin] Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
	     * @constructor
	     */
	    function TextureMatrix(texture, clampMargin) {
	        _classCallCheck(this, TextureMatrix);
	
	        this._texture = texture;
	
	        this.mapCoord = new _Matrix2.default();
	
	        this.uClampFrame = new Float32Array(4);
	
	        this.uClampOffset = new Float32Array(2);
	
	        this._lastTextureID = -1;
	
	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
	         *
	         * @default 0
	         * @member {number}
	         */
	        this.clampOffset = 0;
	
	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	         *
	         * @default 0.5
	         * @member {number}
	         */
	        this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
	    }
	
	    /**
	     * texture property
	     * @member {PIXI.Texture}
	     */
	
	
	    /**
	     * Multiplies uvs array to transform
	     * @param {Float32Array} uvs mesh uvs
	     * @param {Float32Array} [out=uvs] output
	     * @returns {Float32Array} output
	     */
	    TextureMatrix.prototype.multiplyUvs = function multiplyUvs(uvs, out) {
	        if (out === undefined) {
	            out = uvs;
	        }
	
	        var mat = this.mapCoord;
	
	        for (var i = 0; i < uvs.length; i += 2) {
	            var x = uvs[i];
	            var y = uvs[i + 1];
	
	            out[i] = x * mat.a + y * mat.c + mat.tx;
	            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
	        }
	
	        return out;
	    };
	
	    /**
	     * updates matrices if texture was changed
	     * @param {boolean} forceUpdate if true, matrices will be updated any case
	     * @returns {boolean} whether or not it was updated
	     */
	
	
	    TextureMatrix.prototype.update = function update(forceUpdate) {
	        var tex = this._texture;
	
	        if (!tex || !tex.valid) {
	            return false;
	        }
	
	        if (!forceUpdate && this._lastTextureID === tex._updateID) {
	            return false;
	        }
	
	        this._lastTextureID = tex._updateID;
	
	        var uvs = tex._uvs;
	
	        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
	
	        var orig = tex.orig;
	        var trim = tex.trim;
	
	        if (trim) {
	            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
	            this.mapCoord.append(tempMat);
	        }
	
	        var texBase = tex.baseTexture;
	        var frame = this.uClampFrame;
	        var margin = this.clampMargin / texBase.resolution;
	        var offset = this.clampOffset;
	
	        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
	        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
	        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
	        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
	        this.uClampOffset[0] = offset / texBase.realWidth;
	        this.uClampOffset[1] = offset / texBase.realHeight;
	
	        return true;
	    };
	
	    _createClass(TextureMatrix, [{
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._texture = value;
	            this._lastTextureID = -1;
	        }
	    }]);
	
	    return TextureMatrix;
	}();
	
	exports.default = TextureMatrix;
	//# sourceMappingURL=TextureMatrix.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _GroupD = __webpack_require__(107);
	
	var _GroupD2 = _interopRequireDefault(_GroupD);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A standard object to store the Uvs of a texture
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var TextureUvs = function () {
	    /**
	     *
	     */
	    function TextureUvs() {
	        _classCallCheck(this, TextureUvs);
	
	        this.x0 = 0;
	        this.y0 = 0;
	
	        this.x1 = 1;
	        this.y1 = 0;
	
	        this.x2 = 1;
	        this.y2 = 1;
	
	        this.x3 = 0;
	        this.y3 = 1;
	
	        this.uvsUint32 = new Uint32Array(4);
	    }
	
	    /**
	     * Sets the texture Uvs based on the given frame information.
	     *
	     * @private
	     * @param {PIXI.Rectangle} frame - The frame of the texture
	     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
	     * @param {number} rotate - Rotation of frame, see {@link PIXI.GroupD8}
	     */
	
	
	    TextureUvs.prototype.set = function set(frame, baseFrame, rotate) {
	        var tw = baseFrame.width;
	        var th = baseFrame.height;
	
	        if (rotate) {
	            // width and height div 2 div baseFrame size
	            var w2 = frame.width / 2 / tw;
	            var h2 = frame.height / 2 / th;
	
	            // coordinates of center
	            var cX = frame.x / tw + w2;
	            var cY = frame.y / th + h2;
	
	            rotate = _GroupD2.default.add(rotate, _GroupD2.default.NW); // NW is top-left corner
	            this.x0 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y0 = cY + h2 * _GroupD2.default.uY(rotate);
	
	            rotate = _GroupD2.default.add(rotate, 2); // rotate 90 degrees clockwise
	            this.x1 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y1 = cY + h2 * _GroupD2.default.uY(rotate);
	
	            rotate = _GroupD2.default.add(rotate, 2);
	            this.x2 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y2 = cY + h2 * _GroupD2.default.uY(rotate);
	
	            rotate = _GroupD2.default.add(rotate, 2);
	            this.x3 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y3 = cY + h2 * _GroupD2.default.uY(rotate);
	        } else {
	            this.x0 = frame.x / tw;
	            this.y0 = frame.y / th;
	
	            this.x1 = (frame.x + frame.width) / tw;
	            this.y1 = frame.y / th;
	
	            this.x2 = (frame.x + frame.width) / tw;
	            this.y2 = (frame.y + frame.height) / th;
	
	            this.x3 = frame.x / tw;
	            this.y3 = (frame.y + frame.height) / th;
	        }
	
	        this.uvsUint32[0] = (this.y0 * 65535 & 0xFFFF) << 16 | this.x0 * 65535 & 0xFFFF;
	        this.uvsUint32[1] = (this.y1 * 65535 & 0xFFFF) << 16 | this.x1 * 65535 & 0xFFFF;
	        this.uvsUint32[2] = (this.y2 * 65535 & 0xFFFF) << 16 | this.x2 * 65535 & 0xFFFF;
	        this.uvsUint32[3] = (this.y3 * 65535 & 0xFFFF) << 16 | this.x3 * 65535 & 0xFFFF;
	    };
	
	    return TextureUvs;
	}();
	
	exports.default = TextureUvs;
	//# sourceMappingURL=TextureUvs.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseTexture2 = __webpack_require__(24);
	
	var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);
	
	var _utils = __webpack_require__(5);
	
	var _ticker = __webpack_require__(66);
	
	var _const = __webpack_require__(3);
	
	var _determineCrossOrigin = __webpack_require__(121);
	
	var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A texture of a [playing] Video.
	 *
	 * Video base textures mimic PixiJS BaseTexture.from.... method in their creation process.
	 *
	 * This can be used in several ways, such as:
	 *
	 * ```js
	 * let texture = PIXI.VideoBaseTexture.fromUrl('http://mydomain.com/video.mp4');
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrl({ src: 'http://mydomain.com/video.mp4', mime: 'video/mp4' });
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrls(['/video.webm', '/video.mp4']);
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrls([
	 *     { src: '/video.webm', mime: 'video/webm' },
	 *     { src: '/video.mp4', mime: 'video/mp4' }
	 * ]);
	 * ```
	 *
	 * See the ["deus" demo](http://www.goodboydigital.com/pixijs/examples/deus/).
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 */
	var VideoBaseTexture = function (_BaseTexture) {
	    _inherits(VideoBaseTexture, _BaseTexture);
	
	    /**
	     * @param {HTMLVideoElement} source - Video source
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     */
	    function VideoBaseTexture(source, scaleMode) {
	        _classCallCheck(this, VideoBaseTexture);
	
	        if (!source) {
	            throw new Error('No video source element specified.');
	        }
	
	        // hook in here to check if video is already available.
	        // BaseTexture looks for a source.complete boolean, plus width & height.
	
	        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) {
	            source.complete = true;
	        }
	
	        var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, source, scaleMode));
	
	        _this.width = source.videoWidth;
	        _this.height = source.videoHeight;
	
	        _this._autoUpdate = true;
	        _this._isAutoUpdating = false;
	
	        /**
	         * When set to true will automatically play videos used by this texture once
	         * they are loaded. If false, it will not modify the playing state.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPlay = true;
	
	        _this.update = _this.update.bind(_this);
	        _this._onCanPlay = _this._onCanPlay.bind(_this);
	
	        source.addEventListener('play', _this._onPlayStart.bind(_this));
	        source.addEventListener('pause', _this._onPlayStop.bind(_this));
	        _this.hasLoaded = false;
	        _this.__loaded = false;
	
	        if (!_this._isSourceReady()) {
	            source.addEventListener('canplay', _this._onCanPlay);
	            source.addEventListener('canplaythrough', _this._onCanPlay);
	        } else {
	            _this._onCanPlay();
	        }
	        return _this;
	    }
	
	    /**
	     * Returns true if the underlying source is playing.
	     *
	     * @private
	     * @return {boolean} True if playing.
	     */
	
	
	    VideoBaseTexture.prototype._isSourcePlaying = function _isSourcePlaying() {
	        var source = this.source;
	
	        return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
	    };
	
	    /**
	     * Returns true if the underlying source is ready for playing.
	     *
	     * @private
	     * @return {boolean} True if ready.
	     */
	
	
	    VideoBaseTexture.prototype._isSourceReady = function _isSourceReady() {
	        return this.source.readyState === 3 || this.source.readyState === 4;
	    };
	
	    /**
	     * Runs the update loop when the video is ready to play
	     *
	     * @private
	     */
	
	
	    VideoBaseTexture.prototype._onPlayStart = function _onPlayStart() {
	        // Just in case the video has not received its can play even yet..
	        if (!this.hasLoaded) {
	            this._onCanPlay();
	        }
	
	        if (!this._isAutoUpdating && this.autoUpdate) {
	            _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
	            this._isAutoUpdating = true;
	        }
	    };
	
	    /**
	     * Fired when a pause event is triggered, stops the update loop
	     *
	     * @private
	     */
	
	
	    VideoBaseTexture.prototype._onPlayStop = function _onPlayStop() {
	        if (this._isAutoUpdating) {
	            _ticker.shared.remove(this.update, this);
	            this._isAutoUpdating = false;
	        }
	    };
	
	    /**
	     * Fired when the video is loaded and ready to play
	     *
	     * @private
	     */
	
	
	    VideoBaseTexture.prototype._onCanPlay = function _onCanPlay() {
	        this.hasLoaded = true;
	
	        if (this.source) {
	            this.source.removeEventListener('canplay', this._onCanPlay);
	            this.source.removeEventListener('canplaythrough', this._onCanPlay);
	
	            this.width = this.source.videoWidth;
	            this.height = this.source.videoHeight;
	
	            // prevent multiple loaded dispatches..
	            if (!this.__loaded) {
	                this.__loaded = true;
	                this.emit('loaded', this);
	            }
	
	            if (this._isSourcePlaying()) {
	                this._onPlayStart();
	            } else if (this.autoPlay) {
	                this.source.play();
	            }
	        }
	    };
	
	    /**
	     * Destroys this texture
	     *
	     */
	
	
	    VideoBaseTexture.prototype.destroy = function destroy() {
	        if (this._isAutoUpdating) {
	            _ticker.shared.remove(this.update, this);
	        }
	
	        if (this.source && this.source._pixiId) {
	            _BaseTexture3.default.removeFromCache(this.source._pixiId);
	            delete this.source._pixiId;
	
	            this.source.pause();
	            this.source.src = '';
	            this.source.load();
	        }
	
	        _BaseTexture.prototype.destroy.call(this);
	    };
	
	    /**
	     * Mimic PixiJS BaseTexture.from.... method.
	     *
	     * @static
	     * @param {HTMLVideoElement} video - Video to create texture from
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
	     */
	
	
	    VideoBaseTexture.fromVideo = function fromVideo(video, scaleMode) {
	        if (!video._pixiId) {
	            video._pixiId = 'video_' + (0, _utils.uid)();
	        }
	
	        var baseTexture = _utils.BaseTextureCache[video._pixiId];
	
	        if (!baseTexture) {
	            baseTexture = new VideoBaseTexture(video, scaleMode);
	            _BaseTexture3.default.addToCache(baseTexture, video._pixiId);
	        }
	
	        return baseTexture;
	    };
	
	    /**
	     * Helper function that creates a new BaseTexture based on the given video element.
	     * This BaseTexture can then be used to create a texture
	     *
	     * @static
	     * @param {string|object|string[]|object[]} videoSrc - The URL(s) for the video.
	     * @param {string} [videoSrc.src] - One of the source urls for the video
	     * @param {string} [videoSrc.mime] - The mimetype of the video (e.g. 'video/mp4'). If not specified
	     *  the url's extension will be used as the second part of the mime type.
	     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
	     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
	     */
	
	
	    VideoBaseTexture.fromUrl = function fromUrl(videoSrc, scaleMode, crossorigin) {
	        var video = document.createElement('video');
	
	        video.setAttribute('webkit-playsinline', '');
	        video.setAttribute('playsinline', '');
	
	        var url = Array.isArray(videoSrc) ? videoSrc[0].src || videoSrc[0] : videoSrc.src || videoSrc;
	
	        if (crossorigin === undefined && url.indexOf('data:') !== 0) {
	            video.crossOrigin = (0, _determineCrossOrigin2.default)(url);
	        } else if (crossorigin) {
	            video.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
	        }
	
	        // array of objects or strings
	        if (Array.isArray(videoSrc)) {
	            for (var i = 0; i < videoSrc.length; ++i) {
	                video.appendChild(createSource(videoSrc[i].src || videoSrc[i], videoSrc[i].mime));
	            }
	        }
	        // single object or string
	        else {
	                video.appendChild(createSource(url, videoSrc.mime));
	            }
	
	        video.load();
	
	        return VideoBaseTexture.fromVideo(video, scaleMode);
	    };
	
	    /**
	     * Should the base texture automatically update itself, set to true by default
	     *
	     * @member {boolean}
	     */
	
	
	    _createClass(VideoBaseTexture, [{
	        key: 'autoUpdate',
	        get: function get() {
	            return this._autoUpdate;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (value !== this._autoUpdate) {
	                this._autoUpdate = value;
	
	                if (!this._autoUpdate && this._isAutoUpdating) {
	                    _ticker.shared.remove(this.update, this);
	                    this._isAutoUpdating = false;
	                } else if (this._autoUpdate && !this._isAutoUpdating) {
	                    _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
	                    this._isAutoUpdating = true;
	                }
	            }
	        }
	    }]);
	
	    return VideoBaseTexture;
	}(_BaseTexture3.default);
	
	exports.default = VideoBaseTexture;
	
	
	VideoBaseTexture.fromUrls = VideoBaseTexture.fromUrl;
	
	function createSource(path, type) {
	    if (!type) {
	        type = 'video/' + path.substr(path.lastIndexOf('.') + 1);
	    }
	
	    var source = document.createElement('source');
	
	    source.src = path;
	    source.type = type;
	
	    return source;
	}
	//# sourceMappingURL=VideoBaseTexture.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = determineCrossOrigin;
	
	var _url2 = __webpack_require__(139);
	
	var _url3 = _interopRequireDefault(_url2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tempAnchor = void 0;
	
	/**
	 * Sets the `crossOrigin` property for this resource based on if the url
	 * for this resource is cross-origin. If crossOrigin was manually set, this
	 * function does nothing.
	 * Nipped from the resource loader!
	 *
	 * @ignore
	 * @param {string} url - The url to test.
	 * @param {object} [loc=window.location] - The location object to test against.
	 * @return {string} The crossOrigin value to use (or empty string for none).
	 */
	function determineCrossOrigin(url) {
	    var loc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
	
	    // data: and javascript: urls are considered same-origin
	    if (url.indexOf('data:') === 0) {
	        return '';
	    }
	
	    // default is window.location
	    loc = loc || window.location;
	
	    if (!tempAnchor) {
	        tempAnchor = document.createElement('a');
	    }
	
	    // let the browser determine the full href for the url of this resource and then
	    // parse with the node url lib, we can't use the properties of the anchor element
	    // because they don't work in IE9 :(
	    tempAnchor.href = url;
	    url = _url3.default.parse(tempAnchor.href);
	
	    var samePort = !url.port && loc.port === '' || url.port === loc.port;
	
	    // if cross origin
	    if (url.hostname !== loc.hostname || !samePort || url.protocol !== loc.protocol) {
	        return 'anonymous';
	    }
	
	    return '';
	}
	//# sourceMappingURL=determineCrossOrigin.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BitmapText = exports.TilingSpriteRenderer = exports.TilingSprite = exports.AnimatedSprite = undefined;
	
	var _AnimatedSprite = __webpack_require__(248);
	
	Object.defineProperty(exports, 'AnimatedSprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AnimatedSprite).default;
	  }
	});
	
	var _TilingSprite = __webpack_require__(250);
	
	Object.defineProperty(exports, 'TilingSprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TilingSprite).default;
	  }
	});
	
	var _TilingSpriteRenderer = __webpack_require__(254);
	
	Object.defineProperty(exports, 'TilingSpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TilingSpriteRenderer).default;
	  }
	});
	
	var _BitmapText = __webpack_require__(249);
	
	Object.defineProperty(exports, 'BitmapText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BitmapText).default;
	  }
	});
	
	__webpack_require__(251);
	
	__webpack_require__(252);
	
	__webpack_require__(253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// imported for side effect of extending the prototype only, contains no exports
	//# sourceMappingURL=index.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _generateBlurVertSource = __webpack_require__(126);
	
	var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);
	
	var _generateBlurFragSource = __webpack_require__(125);
	
	var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);
	
	var _getMaxBlurKernelSize = __webpack_require__(127);
	
	var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The BlurXFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurXFilter = function (_core$Filter) {
	    _inherits(BlurXFilter, _core$Filter);
	
	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurXFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurXFilter);
	
	        kernelSize = kernelSize || 5;
	        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
	        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        vertSrc,
	        // fragment shader
	        fragSrc));
	
	        _this.resolution = resolution || core.settings.RESOLUTION;
	
	        _this._quality = 0;
	
	        _this.quality = quality || 4;
	        _this.strength = strength || 8;
	
	        _this.firstRun = true;
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     * @param {boolean} clear - Should the output be cleared before rendering?
	     */
	
	
	    BlurXFilter.prototype.apply = function apply(filterManager, input, output, clear) {
	        if (this.firstRun) {
	            var gl = filterManager.renderer.gl;
	            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);
	
	            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
	            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	            this.firstRun = false;
	        }
	
	        this.uniforms.strength = 1 / output.size.width * (output.size.width / input.size.width);
	
	        // screen space!
	        this.uniforms.strength *= this.strength;
	        this.uniforms.strength /= this.passes; // / this.passes//Math.pow(1, this.passes);
	
	        if (this.passes === 1) {
	            filterManager.applyFilter(this, input, output, clear);
	        } else {
	            var renderTarget = filterManager.getRenderTarget(true);
	            var flip = input;
	            var flop = renderTarget;
	
	            for (var i = 0; i < this.passes - 1; i++) {
	                filterManager.applyFilter(this, flip, flop, true);
	
	                var temp = flop;
	
	                flop = flip;
	                flip = temp;
	            }
	
	            filterManager.applyFilter(this, flip, output, clear);
	
	            filterManager.returnRenderTarget(renderTarget);
	        }
	    };
	
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @default 16
	     */
	
	
	    _createClass(BlurXFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.strength;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.padding = Math.abs(value) * 2;
	            this.strength = value;
	        }
	
	        /**
	        * Sets the quality of the blur by modifying the number of passes. More passes means higher
	        * quaility bluring but the lower the performance.
	        *
	        * @member {number}
	        * @default 4
	        */
	
	    }, {
	        key: 'quality',
	        get: function get() {
	            return this._quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._quality = value;
	            this.passes = value;
	        }
	    }]);
	
	    return BlurXFilter;
	}(core.Filter);
	
	exports.default = BlurXFilter;
	//# sourceMappingURL=BlurXFilter.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _generateBlurVertSource = __webpack_require__(126);
	
	var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);
	
	var _generateBlurFragSource = __webpack_require__(125);
	
	var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);
	
	var _getMaxBlurKernelSize = __webpack_require__(127);
	
	var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The BlurYFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurYFilter = function (_core$Filter) {
	    _inherits(BlurYFilter, _core$Filter);
	
	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurYFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurYFilter);
	
	        kernelSize = kernelSize || 5;
	        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
	        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        vertSrc,
	        // fragment shader
	        fragSrc));
	
	        _this.resolution = resolution || core.settings.RESOLUTION;
	
	        _this._quality = 0;
	
	        _this.quality = quality || 4;
	        _this.strength = strength || 8;
	
	        _this.firstRun = true;
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     * @param {boolean} clear - Should the output be cleared before rendering?
	     */
	
	
	    BlurYFilter.prototype.apply = function apply(filterManager, input, output, clear) {
	        if (this.firstRun) {
	            var gl = filterManager.renderer.gl;
	            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);
	
	            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
	            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);
	
	            this.firstRun = false;
	        }
	
	        this.uniforms.strength = 1 / output.size.height * (output.size.height / input.size.height);
	
	        this.uniforms.strength *= this.strength;
	        this.uniforms.strength /= this.passes;
	
	        if (this.passes === 1) {
	            filterManager.applyFilter(this, input, output, clear);
	        } else {
	            var renderTarget = filterManager.getRenderTarget(true);
	            var flip = input;
	            var flop = renderTarget;
	
	            for (var i = 0; i < this.passes - 1; i++) {
	                filterManager.applyFilter(this, flip, flop, true);
	
	                var temp = flop;
	
	                flop = flip;
	                flip = temp;
	            }
	
	            filterManager.applyFilter(this, flip, output, clear);
	
	            filterManager.returnRenderTarget(renderTarget);
	        }
	    };
	
	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @default 2
	     */
	
	
	    _createClass(BlurYFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.strength;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.padding = Math.abs(value) * 2;
	            this.strength = value;
	        }
	
	        /**
	         * Sets the quality of the blur by modifying the number of passes. More passes means higher
	         * quaility bluring but the lower the performance.
	         *
	         * @member {number}
	         * @default 4
	         */
	
	    }, {
	        key: 'quality',
	        get: function get() {
	            return this._quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._quality = value;
	            this.passes = value;
	        }
	    }]);
	
	    return BlurYFilter;
	}(core.Filter);
	
	exports.default = BlurYFilter;
	//# sourceMappingURL=BlurYFilter.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateFragBlurSource;
	var GAUSSIAN_VALUES = {
	    5: [0.153388, 0.221461, 0.250301],
	    7: [0.071303, 0.131514, 0.189879, 0.214607],
	    9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
	    11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
	    13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
	    15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
	};
	
	var fragTemplate = ['varying vec2 vBlurTexCoords[%size%];', 'uniform sampler2D uSampler;', 'void main(void)', '{', '    gl_FragColor = vec4(0.0);', '    %blur%', '}'].join('\n');
	
	function generateFragBlurSource(kernelSize) {
	    var kernel = GAUSSIAN_VALUES[kernelSize];
	    var halfLength = kernel.length;
	
	    var fragSource = fragTemplate;
	
	    var blurLoop = '';
	    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
	    var value = void 0;
	
	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i);
	
	        value = i;
	
	        if (i >= halfLength) {
	            value = kernelSize - i - 1;
	        }
	
	        blur = blur.replace('%value%', kernel[value]);
	
	        blurLoop += blur;
	        blurLoop += '\n';
	    }
	
	    fragSource = fragSource.replace('%blur%', blurLoop);
	    fragSource = fragSource.replace('%size%', kernelSize);
	
	    return fragSource;
	}
	//# sourceMappingURL=generateBlurFragSource.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateVertBlurSource;
	var vertTemplate = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform float strength;', 'uniform mat3 projectionMatrix;', 'varying vec2 vBlurTexCoords[%size%];', 'void main(void)', '{', 'gl_Position = vec4((projectionMatrix * vec3((aVertexPosition), 1.0)).xy, 0.0, 1.0);', '%blur%', '}'].join('\n');
	
	function generateVertBlurSource(kernelSize, x) {
	    var halfLength = Math.ceil(kernelSize / 2);
	
	    var vertSource = vertTemplate;
	
	    var blurLoop = '';
	    var template = void 0;
	    // let value;
	
	    if (x) {
	        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(%sampleIndex% * strength, 0.0);';
	    } else {
	        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(0.0, %sampleIndex% * strength);';
	    }
	
	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i);
	
	        // value = i;
	
	        // if(i >= halfLength)
	        // {
	        //     value = kernelSize - i - 1;
	        // }
	
	        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + '.0');
	
	        blurLoop += blur;
	        blurLoop += '\n';
	    }
	
	    vertSource = vertSource.replace('%blur%', blurLoop);
	    vertSource = vertSource.replace('%size%', kernelSize);
	
	    return vertSource;
	}
	//# sourceMappingURL=generateBlurVertSource.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getMaxKernelSize;
	function getMaxKernelSize(gl) {
	    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
	    var kernelSize = 15;
	
	    while (kernelSize > maxVaryings) {
	        kernelSize -= 2;
	    }
	
	    return kernelSize;
	}
	//# sourceMappingURL=getMaxBlurKernelSize.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Holds all information related to an Interaction event
	 *
	 * @class
	 * @memberof PIXI.interaction
	 */
	var InteractionData = function () {
	  /**
	   *
	   */
	  function InteractionData() {
	    _classCallCheck(this, InteractionData);
	
	    /**
	     * This point stores the global coords of where the touch/mouse event happened
	     *
	     * @member {PIXI.Point}
	     */
	    this.global = new core.Point();
	
	    /**
	     * The target DisplayObject that was interacted with
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.target = null;
	
	    /**
	     * When passed to an event handler, this will be the original DOM Event that was captured
	     *
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
	     * @member {MouseEvent|TouchEvent|PointerEvent}
	     */
	    this.originalEvent = null;
	
	    /**
	     * Unique identifier for this interaction
	     *
	     * @member {number}
	     */
	    this.identifier = null;
	
	    /**
	     * Indicates whether or not the pointer device that created the event is the primary pointer.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
	     * @type {Boolean}
	     */
	    this.isPrimary = false;
	
	    /**
	     * Indicates which button was pressed on the mouse or pointer device to trigger the event.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
	     * @type {number}
	     */
	    this.button = 0;
	
	    /**
	     * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
	     * @type {number}
	     */
	    this.buttons = 0;
	
	    /**
	     * The width of the pointer's contact along the x-axis, measured in CSS pixels.
	     * radiusX of TouchEvents will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
	     * @type {number}
	     */
	    this.width = 0;
	
	    /**
	     * The height of the pointer's contact along the y-axis, measured in CSS pixels.
	     * radiusY of TouchEvents will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
	     * @type {number}
	     */
	    this.height = 0;
	
	    /**
	     * The angle, in degrees, between the pointer device and the screen.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
	     * @type {number}
	     */
	    this.tiltX = 0;
	
	    /**
	     * The angle, in degrees, between the pointer device and the screen.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
	     * @type {number}
	     */
	    this.tiltY = 0;
	
	    /**
	     * The type of pointer that triggered the event.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
	     * @type {string}
	     */
	    this.pointerType = null;
	
	    /**
	     * Pressure applied by the pointing device during the event. A Touch's force property
	     * will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
	     * @type {number}
	     */
	    this.pressure = 0;
	
	    /**
	     * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
	     * @type {number}
	     */
	    this.rotationAngle = 0;
	
	    /**
	     * Twist of a stylus pointer.
	     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	     * @type {number}
	     */
	    this.twist = 0;
	
	    /**
	     * Barrel pressure on a stylus pointer.
	     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	     * @type {number}
	     */
	    this.tangentialPressure = 0;
	  }
	
	  /**
	   * The unique identifier of the pointer. It will be the same as `identifier`.
	   * @readonly
	   * @member {number}
	   * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
	   */
	
	
	  /**
	   * This will return the local coordinates of the specified displayObject for this InteractionData
	   *
	   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
	   *  coords off
	   * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
	   *  will create a new point)
	   * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
	   *  (otherwise will use the current global coords)
	   * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
	   *  to the DisplayObject
	   */
	  InteractionData.prototype.getLocalPosition = function getLocalPosition(displayObject, point, globalPos) {
	    return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
	  };
	
	  /**
	   * Copies properties from normalized event data.
	   *
	   * @param {Touch|MouseEvent|PointerEvent} event The normalized event data
	   */
	
	
	  InteractionData.prototype.copyEvent = function copyEvent(event) {
	    // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
	    // it with "false" on later events when our shim for it on touch events might not be
	    // accurate
	    if (event.isPrimary) {
	      this.isPrimary = true;
	    }
	    this.button = event.button;
	    // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
	    // event.which property instead, which conveys the same information.
	    this.buttons = Number.isInteger(event.buttons) ? event.buttons : event.which;
	    this.width = event.width;
	    this.height = event.height;
	    this.tiltX = event.tiltX;
	    this.tiltY = event.tiltY;
	    this.pointerType = event.pointerType;
	    this.pressure = event.pressure;
	    this.rotationAngle = event.rotationAngle;
	    this.twist = event.twist || 0;
	    this.tangentialPressure = event.tangentialPressure || 0;
	  };
	
	  /**
	   * Resets the data for pooling.
	   */
	
	
	  InteractionData.prototype.reset = function reset() {
	    // isPrimary is the only property that we really need to reset - everything else is
	    // guaranteed to be overwritten
	    this.isPrimary = false;
	  };
	
	  _createClass(InteractionData, [{
	    key: 'pointerId',
	    get: function get() {
	      return this.identifier;
	    }
	  }]);
	
	  return InteractionData;
	}();
	
	exports.default = InteractionData;
	//# sourceMappingURL=InteractionData.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Event class that mimics native DOM events.
	 *
	 * @class
	 * @memberof PIXI.interaction
	 */
	var InteractionEvent = function () {
	  /**
	   *
	   */
	  function InteractionEvent() {
	    _classCallCheck(this, InteractionEvent);
	
	    /**
	     * Whether this event will continue propagating in the tree
	     *
	     * @member {boolean}
	     */
	    this.stopped = false;
	
	    /**
	     * The object which caused this event to be dispatched.
	     * For listener callback see {@link PIXI.interaction.InteractionEvent.currentTarget}.
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.target = null;
	
	    /**
	     * The object whose event listener’s callback is currently being invoked.
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.currentTarget = null;
	
	    /**
	     * Type of the event
	     *
	     * @member {string}
	     */
	    this.type = null;
	
	    /**
	     * InteractionData related to this event
	     *
	     * @member {PIXI.interaction.InteractionData}
	     */
	    this.data = null;
	  }
	
	  /**
	   * Prevents event from reaching any objects other than the current object.
	   *
	   */
	
	
	  InteractionEvent.prototype.stopPropagation = function stopPropagation() {
	    this.stopped = true;
	  };
	
	  /**
	   * Resets the event.
	   */
	
	
	  InteractionEvent.prototype.reset = function reset() {
	    this.stopped = false;
	    this.currentTarget = null;
	    this.target = null;
	  };
	
	  return InteractionEvent;
	}();
	
	exports.default = InteractionEvent;
	//# sourceMappingURL=InteractionEvent.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * DisplayObjects with the {@link PIXI.interaction.interactiveTarget} mixin use this class to track interactions
	 *
	 * @class
	 * @private
	 * @memberof PIXI.interaction
	 */
	var InteractionTrackingData = function () {
	    /**
	     * @param {number} pointerId - Unique pointer id of the event
	     */
	    function InteractionTrackingData(pointerId) {
	        _classCallCheck(this, InteractionTrackingData);
	
	        this._pointerId = pointerId;
	        this._flags = InteractionTrackingData.FLAGS.NONE;
	    }
	
	    /**
	     *
	     * @private
	     * @param {number} flag - The interaction flag to set
	     * @param {boolean} yn - Should the flag be set or unset
	     */
	
	
	    InteractionTrackingData.prototype._doSet = function _doSet(flag, yn) {
	        if (yn) {
	            this._flags = this._flags | flag;
	        } else {
	            this._flags = this._flags & ~flag;
	        }
	    };
	
	    /**
	     * Unique pointer id of the event
	     *
	     * @readonly
	     * @member {number}
	     */
	
	
	    _createClass(InteractionTrackingData, [{
	        key: "pointerId",
	        get: function get() {
	            return this._pointerId;
	        }
	
	        /**
	         * State of the tracking data, expressed as bit flags
	         *
	         * @member {number}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "flags",
	        get: function get() {
	            return this._flags;
	        }
	
	        /**
	         * Set the flags for the tracking data
	         *
	         * @param {number} flags - Flags to set
	         */
	        ,
	        set: function set(flags) {
	            this._flags = flags;
	        }
	
	        /**
	         * Is the tracked event inactive (not over or down)?
	         *
	         * @member {number}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "none",
	        get: function get() {
	            return this._flags === this.constructor.FLAGS.NONE;
	        }
	
	        /**
	         * Is the tracked event over the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "over",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.OVER) !== 0;
	        }
	
	        /**
	         * Set the over flag
	         *
	         * @param {boolean} yn - Is the event over?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.OVER, yn);
	        }
	
	        /**
	         * Did the right mouse button come down in the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "rightDown",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.RIGHT_DOWN) !== 0;
	        }
	
	        /**
	         * Set the right down flag
	         *
	         * @param {boolean} yn - Is the right mouse button down?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.RIGHT_DOWN, yn);
	        }
	
	        /**
	         * Did the left mouse button come down in the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */
	
	    }, {
	        key: "leftDown",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.LEFT_DOWN) !== 0;
	        }
	
	        /**
	         * Set the left down flag
	         *
	         * @param {boolean} yn - Is the left mouse button down?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.LEFT_DOWN, yn);
	        }
	    }]);
	
	    return InteractionTrackingData;
	}();
	
	exports.default = InteractionTrackingData;
	
	
	InteractionTrackingData.FLAGS = Object.freeze({
	    NONE: 0,
	    OVER: 1 << 0,
	    LEFT_DOWN: 1 << 1,
	    RIGHT_DOWN: 1 << 2
	});
	//# sourceMappingURL=InteractionTrackingData.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Default property values of interactive objects
	 * Used by {@link PIXI.interaction.InteractionManager} to automatically give all DisplayObjects these properties
	 *
	 * @private
	 * @name interactiveTarget
	 * @memberof PIXI.interaction
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          core.DisplayObject.prototype,
	 *          PIXI.interaction.interactiveTarget
	 *      );
	 */
	exports.default = {
	
	  /**
	   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
	   * events will not be emitted unless `interactive` is set to `true`.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.on('tap', (event) => {
	   *    //handle event
	   * });
	   * @member {boolean}
	   * @memberof PIXI.DisplayObject#
	   */
	  interactive: false,
	
	  /**
	   * Determines if the children to the displayObject can be clicked/touched
	   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
	   *
	   * @member {boolean}
	   * @memberof PIXI.Container#
	   */
	  interactiveChildren: true,
	
	  /**
	   * Interaction shape. Children will be hit first, then this shape will be checked.
	   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.hitArea = new PIXI.Rectangle(0, 0, 100, 100);
	   * @member {PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle}
	   * @memberof PIXI.DisplayObject#
	   */
	  hitArea: null,
	
	  /**
	   * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
	   * Setting this changes the 'cursor' property to `'pointer'`.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.buttonMode = true;
	   * @member {boolean}
	   * @memberof PIXI.DisplayObject#
	   */
	  get buttonMode() {
	    return this.cursor === 'pointer';
	  },
	  set buttonMode(value) {
	    if (value) {
	      this.cursor = 'pointer';
	    } else if (this.cursor === 'pointer') {
	      this.cursor = null;
	    }
	  },
	
	  /**
	   * This defines what cursor mode is used when the mouse cursor
	   * is hovered over the displayObject.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.cursor = 'wait';
	   * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
	   *
	   * @member {string}
	   * @memberof PIXI.DisplayObject#
	   */
	  cursor: null,
	
	  /**
	   * Internal set of all active pointers, by identifier
	   *
	   * @member {Map<number, InteractionTrackingData>}
	   * @memberof PIXI.DisplayObject#
	   * @private
	   */
	  get trackedPointers() {
	    if (this._trackedPointers === undefined) this._trackedPointers = {};
	
	    return this._trackedPointers;
	  },
	
	  /**
	   * Map of all tracked pointers, by identifier. Use trackedPointers to access.
	   *
	   * @private
	   * @type {Map<number, InteractionTrackingData>}
	   */
	  _trackedPointers: undefined
	};
	//# sourceMappingURL=interactiveTarget.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.parse = parse;
	
	exports.default = function () {
	    return function bitmapFontParser(resource, next) {
	        // skip if no data or not xml data
	        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.XML) {
	            next();
	
	            return;
	        }
	
	        // skip if not bitmap font data, using some silly duck-typing
	        if (resource.data.getElementsByTagName('page').length === 0 || resource.data.getElementsByTagName('info').length === 0 || resource.data.getElementsByTagName('info')[0].getAttribute('face') === null) {
	            next();
	
	            return;
	        }
	
	        var xmlUrl = !resource.isDataUrl ? path.dirname(resource.url) : '';
	
	        if (resource.isDataUrl) {
	            if (xmlUrl === '.') {
	                xmlUrl = '';
	            }
	
	            if (this.baseUrl && xmlUrl) {
	                // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
	                if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
	                    xmlUrl += '/';
	                }
	            }
	        }
	
	        // remove baseUrl from xmlUrl
	        xmlUrl = xmlUrl.replace(this.baseUrl, '');
	
	        // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
	        if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
	            xmlUrl += '/';
	        }
	
	        var pages = resource.data.getElementsByTagName('page');
	        var textures = [];
	        var loadOptions = {
	            crossOrigin: resource.crossOrigin,
	            loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
	            metadata: resource.metadata.imageMetadata,
	            parentResource: resource
	        };
	
	        for (var x = 0; x < pages.length; ++x) {
	            var textureUrl = xmlUrl + pages[x].getAttribute('file');
	
	            if (_core.utils.TextureCache[textureUrl]) {
	                textures.push(_core.utils.TextureCache[textureUrl]);
	            } else {
	                // load the texture for the font
	                this.add(resource.name + '_image' + x, textureUrl, loadOptions, function () {
	                    var nextTextures = [];
	
	                    for (var _x = 0; _x < pages.length; ++_x) {
	                        var nextTextureUrl = xmlUrl + pages[_x].getAttribute('file');
	
	                        if (_core.utils.TextureCache[nextTextureUrl]) {
	                            nextTextures.push(_core.utils.TextureCache[nextTextureUrl]);
	                        } else {
	                            return;
	                        }
	                    }
	                    parse(resource, nextTextures);
	                    next();
	                });
	            }
	        }
	
	        if (textures.length === pages.length) {
	            parse(resource, textures);
	            next();
	        }
	    };
	};
	
	var _path = __webpack_require__(13);
	
	var path = _interopRequireWildcard(_path);
	
	var _core = __webpack_require__(4);
	
	var _resourceLoader = __webpack_require__(31);
	
	var _extras = __webpack_require__(122);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Register a BitmapText font from loader resource.
	 *
	 * @function parseBitmapFontData
	 * @memberof PIXI.loaders
	 * @param {PIXI.loaders.Resource} resource - Loader resource.
	 * @param {PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
	 */
	function parse(resource, textures) {
	    resource.bitmapFont = _extras.BitmapText.registerFont(resource.data, textures);
	}
	//# sourceMappingURL=bitmapFontParser.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	    return function spritesheetParser(resource, next) {
	        var imageResourceName = resource.name + '_image';
	
	        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
	        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.JSON || !resource.data.frames || this.resources[imageResourceName]) {
	            next();
	
	            return;
	        }
	
	        var loadOptions = {
	            crossOrigin: resource.crossOrigin,
	            metadata: resource.metadata.imageMetadata,
	            parentResource: resource
	        };
	
	        var resourcePath = getResourcePath(resource, this.baseUrl);
	
	        // load the image for this sheet
	        this.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
	            if (res.error) {
	                next(res.error);
	
	                return;
	            }
	
	            var spritesheet = new _core.Spritesheet(res.texture.baseTexture, resource.data, resource.url);
	
	            spritesheet.parse(function () {
	                resource.spritesheet = spritesheet;
	                resource.textures = spritesheet.textures;
	                next();
	            });
	        });
	    };
	};
	
	exports.getResourcePath = getResourcePath;
	
	var _resourceLoader = __webpack_require__(31);
	
	var _url = __webpack_require__(139);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _core = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getResourcePath(resource, baseUrl) {
	    // Prepend url path unless the resource image is a data url
	    if (resource.isDataUrl) {
	        return resource.data.meta.image;
	    }
	
	    return _url2.default.resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
	}
	//# sourceMappingURL=spritesheetParser.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	    return function textureParser(resource, next) {
	        // create a new texture if the data is an Image object
	        if (resource.data && resource.type === _resourceLoader.Resource.TYPE.IMAGE) {
	            resource.texture = _Texture2.default.fromLoader(resource.data, resource.url, resource.name);
	        }
	        next();
	    };
	};
	
	var _resourceLoader = __webpack_require__(31);
	
	var _Texture = __webpack_require__(17);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=textureParser.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mesh2 = __webpack_require__(30);
	
	var _Mesh3 = _interopRequireDefault(_Mesh2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Plane allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let Plane = new PIXI.Plane(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 *
	 */
	var Plane = function (_Mesh) {
	    _inherits(Plane, _Mesh);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the Plane.
	     * @param {number} verticesX - The number of vertices in the x-axis
	     * @param {number} verticesY - The number of vertices in the y-axis
	     */
	    function Plane(texture, verticesX, verticesY) {
	        _classCallCheck(this, Plane);
	
	        /**
	         * Tracker for if the Plane is ready to be drawn. Needed because Mesh ctor can
	         * call _onTextureUpdated which could call refresh too early.
	         *
	         * @member {boolean}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));
	
	        _this._ready = true;
	
	        _this.verticesX = verticesX || 10;
	        _this.verticesY = verticesY || 10;
	
	        _this.drawMode = _Mesh3.default.DRAW_MODES.TRIANGLES;
	        _this.refresh();
	        return _this;
	    }
	
	    /**
	     * Refreshes plane coordinates
	     *
	     */
	
	
	    Plane.prototype._refresh = function _refresh() {
	        var texture = this._texture;
	        var total = this.verticesX * this.verticesY;
	        var verts = [];
	        var colors = [];
	        var uvs = [];
	        var indices = [];
	
	        var segmentsX = this.verticesX - 1;
	        var segmentsY = this.verticesY - 1;
	
	        var sizeX = texture.width / segmentsX;
	        var sizeY = texture.height / segmentsY;
	
	        for (var i = 0; i < total; i++) {
	            var x = i % this.verticesX;
	            var y = i / this.verticesX | 0;
	
	            verts.push(x * sizeX, y * sizeY);
	
	            uvs.push(x / segmentsX, y / segmentsY);
	        }
	
	        //  cons
	
	        var totalSub = segmentsX * segmentsY;
	
	        for (var _i = 0; _i < totalSub; _i++) {
	            var xpos = _i % segmentsX;
	            var ypos = _i / segmentsX | 0;
	
	            var value = ypos * this.verticesX + xpos;
	            var value2 = ypos * this.verticesX + xpos + 1;
	            var value3 = (ypos + 1) * this.verticesX + xpos;
	            var value4 = (ypos + 1) * this.verticesX + xpos + 1;
	
	            indices.push(value, value2, value3);
	            indices.push(value2, value4, value3);
	        }
	
	        // console.log(indices)
	        this.vertices = new Float32Array(verts);
	        this.uvs = new Float32Array(uvs);
	        this.colors = new Float32Array(colors);
	        this.indices = new Uint16Array(indices);
	
	        this.dirty++;
	        this.indexDirty++;
	
	        this.multiplyUvs();
	    };
	
	    /**
	     * Clear texture UVs when new texture is set
	     *
	     * @private
	     */
	
	
	    Plane.prototype._onTextureUpdate = function _onTextureUpdate() {
	        _Mesh3.default.prototype._onTextureUpdate.call(this);
	
	        // wait for the Plane ctor to finish before calling refresh
	        if (this._ready) {
	            this.refresh();
	        }
	    };
	
	    return Plane;
	}(_Mesh3.default);
	
	exports.default = Plane;
	//# sourceMappingURL=Plane.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * CountLimiter limits the number of items handled by a {@link PIXI.prepare.BasePrepare} to a specified
	 * number of items per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CountLimiter = function () {
	  /**
	   * @param {number} maxItemsPerFrame - The maximum number of items that can be prepared each frame.
	   */
	  function CountLimiter(maxItemsPerFrame) {
	    _classCallCheck(this, CountLimiter);
	
	    /**
	     * The maximum number of items that can be prepared each frame.
	     * @private
	     */
	    this.maxItemsPerFrame = maxItemsPerFrame;
	    /**
	     * The number of items that can be prepared in the current frame.
	     * @type {number}
	     * @private
	     */
	    this.itemsLeft = 0;
	  }
	
	  /**
	   * Resets any counting properties to start fresh on a new frame.
	   */
	
	
	  CountLimiter.prototype.beginFrame = function beginFrame() {
	    this.itemsLeft = this.maxItemsPerFrame;
	  };
	
	  /**
	   * Checks to see if another item can be uploaded. This should only be called once per item.
	   * @return {boolean} If the item is allowed to be uploaded.
	   */
	
	
	  CountLimiter.prototype.allowedToUpload = function allowedToUpload() {
	    return this.itemsLeft-- > 0;
	  };
	
	  return CountLimiter;
	}();
	
	exports.default = CountLimiter;
	//# sourceMappingURL=CountLimiter.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.eachSeries = eachSeries;
	exports.queue = queue;
	/**
	 * Smaller version of the async library constructs.
	 *
	 */
	function _noop() {} /* empty */
	
	/**
	 * Iterates an array in series.
	 *
	 * @param {Array.<*>} array - Array to iterate.
	 * @param {function} iterator - Function to call for each element.
	 * @param {function} callback - Function to call when done, or on error.
	 * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
	 */
	function eachSeries(array, iterator, callback, deferNext) {
	    var i = 0;
	    var len = array.length;
	
	    (function next(err) {
	        if (err || i === len) {
	            if (callback) {
	                callback(err);
	            }
	
	            return;
	        }
	
	        if (deferNext) {
	            setTimeout(function () {
	                iterator(array[i++], next);
	            }, 1);
	        } else {
	            iterator(array[i++], next);
	        }
	    })();
	}
	
	/**
	 * Ensures a function is only called once.
	 *
	 * @param {function} fn - The function to wrap.
	 * @return {function} The wrapping function.
	 */
	function onlyOnce(fn) {
	    return function onceWrapper() {
	        if (fn === null) {
	            throw new Error('Callback was already called.');
	        }
	
	        var callFn = fn;
	
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	/**
	 * Async queue implementation,
	 *
	 * @param {function} worker - The worker function to call for each task.
	 * @param {number} concurrency - How many workers to run in parrallel.
	 * @return {*} The async queue object.
	 */
	function queue(worker, concurrency) {
	    if (concurrency == null) {
	        // eslint-disable-line no-eq-null,eqeqeq
	        concurrency = 1;
	    } else if (concurrency === 0) {
	        throw new Error('Concurrency must not be zero');
	    }
	
	    var workers = 0;
	    var q = {
	        _tasks: [],
	        concurrency: concurrency,
	        saturated: _noop,
	        unsaturated: _noop,
	        buffer: concurrency / 4,
	        empty: _noop,
	        drain: _noop,
	        error: _noop,
	        started: false,
	        paused: false,
	        push: function push(data, callback) {
	            _insert(data, false, callback);
	        },
	        kill: function kill() {
	            workers = 0;
	            q.drain = _noop;
	            q.started = false;
	            q._tasks = [];
	        },
	        unshift: function unshift(data, callback) {
	            _insert(data, true, callback);
	        },
	        process: function process() {
	            while (!q.paused && workers < q.concurrency && q._tasks.length) {
	                var task = q._tasks.shift();
	
	                if (q._tasks.length === 0) {
	                    q.empty();
	                }
	
	                workers += 1;
	
	                if (workers === q.concurrency) {
	                    q.saturated();
	                }
	
	                worker(task.data, onlyOnce(_next(task)));
	            }
	        },
	        length: function length() {
	            return q._tasks.length;
	        },
	        running: function running() {
	            return workers;
	        },
	        idle: function idle() {
	            return q._tasks.length + workers === 0;
	        },
	        pause: function pause() {
	            if (q.paused === true) {
	                return;
	            }
	
	            q.paused = true;
	        },
	        resume: function resume() {
	            if (q.paused === false) {
	                return;
	            }
	
	            q.paused = false;
	
	            // Need to call q.process once per concurrent
	            // worker to preserve full concurrency after pause
	            for (var w = 1; w <= q.concurrency; w++) {
	                q.process();
	            }
	        }
	    };
	
	    function _insert(data, insertAtFront, callback) {
	        if (callback != null && typeof callback !== 'function') {
	            // eslint-disable-line no-eq-null,eqeqeq
	            throw new Error('task callback must be a function');
	        }
	
	        q.started = true;
	
	        if (data == null && q.idle()) {
	            // eslint-disable-line no-eq-null,eqeqeq
	            // call drain immediately if there are no tasks
	            setTimeout(function () {
	                return q.drain();
	            }, 1);
	
	            return;
	        }
	
	        var item = {
	            data: data,
	            callback: typeof callback === 'function' ? callback : _noop
	        };
	
	        if (insertAtFront) {
	            q._tasks.unshift(item);
	        } else {
	            q._tasks.push(item);
	        }
	
	        setTimeout(function () {
	            return q.process();
	        }, 1);
	    }
	
	    function _next(task) {
	        return function next() {
	            workers -= 1;
	
	            task.callback.apply(task, arguments);
	
	            if (arguments[0] != null) {
	                // eslint-disable-line no-eq-null,eqeqeq
	                q.error(arguments[0], task.data);
	            }
	
	            if (workers <= q.concurrency - q.buffer) {
	                q.unsaturated();
	            }
	
	            if (q.idle()) {
	                q.drain();
	            }
	
	            q.process();
	        };
	    }
	
	    return q;
	}
	//# sourceMappingURL=async.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.encodeBinary = encodeBinary;
	var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function encodeBinary(input) {
	    var output = '';
	    var inx = 0;
	
	    while (inx < input.length) {
	        // Fill byte buffer array
	        var bytebuffer = [0, 0, 0];
	        var encodedCharIndexes = [0, 0, 0, 0];
	
	        for (var jnx = 0; jnx < bytebuffer.length; ++jnx) {
	            if (inx < input.length) {
	                // throw away high-order byte, as documented at:
	                // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
	                bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
	            } else {
	                bytebuffer[jnx] = 0;
	            }
	        }
	
	        // Get each encoded character, 6 bits at a time
	        // index 1: first 6 bits
	        encodedCharIndexes[0] = bytebuffer[0] >> 2;
	
	        // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
	        encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;
	
	        // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
	        encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;
	
	        // index 3: forth 6 bits (6 least significant bits from input byte 3)
	        encodedCharIndexes[3] = bytebuffer[2] & 0x3f;
	
	        // Determine whether padding happened, and adjust accordingly
	        var paddingBytes = inx - (input.length - 1);
	
	        switch (paddingBytes) {
	            case 2:
	                // Set last 2 characters to padding char
	                encodedCharIndexes[3] = 64;
	                encodedCharIndexes[2] = 64;
	                break;
	
	            case 1:
	                // Set last character to padding char
	                encodedCharIndexes[3] = 64;
	                break;
	
	            default:
	                break; // No padding - proceed
	        }
	
	        // Now we will grab each appropriate character out of our keystring
	        // based on our index array and append it to the output string
	        for (var _jnx = 0; _jnx < encodedCharIndexes.length; ++_jnx) {
	            output += _keyStr.charAt(encodedCharIndexes[_jnx]);
	        }
	    }
	
	    return output;
	}
	//# sourceMappingURL=b64.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(301);
	var util = __webpack_require__(302);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(288);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _swipeListener = __webpack_require__(145);
	
	var _swipeListener2 = _interopRequireDefault(_swipeListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var minXSwipe = 50;
	
	var SwipeNextPrev = function (_Component) {
	  _inherits(SwipeNextPrev, _Component);
	
	  function SwipeNextPrev() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SwipeNextPrev);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleSwipeEnd = function () {
	      _this.reset();
	    }, _this.handleSwipe = function (e) {
	      var swipeXCoord = e.detail.x[1];
	      if (!_this.isSwiping) {
	        // start
	        _this.isSwiping = true;
	        _this.start = swipeXCoord;
	      } else {
	        var diff = swipeXCoord - _this.start;
	        if (Math.abs(diff) > minXSwipe && !_this.fired) {
	          _this.fired = true;
	          if (diff > 0) {
	            _this.props.prev();
	          } else {
	            _this.props.next();
	          }
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SwipeNextPrev.prototype.componentDidMount = function componentDidMount() {
	    this.element = this.props.element ? this.props.element : window;
	    this.listener = (0, _swipeListener2.default)(this.element, {
	      // minHorizontal: 50,
	      // minVertical: 50,
	      // deltaHorizontal: 50,
	      lockAxis: true
	    });
	    // element.addEventListener('swipe', this.handleSwipe);
	    this.element.addEventListener('swiping', this.handleSwipe);
	    this.element.addEventListener('swiperelease', this.handleSwipeEnd);
	
	    this.reset();
	  };
	
	  SwipeNextPrev.prototype.reset = function reset() {
	    this.start = 0;
	    this.isSwiping = false;
	    this.fired = false;
	  };
	
	  SwipeNextPrev.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.element.removeEventListener('swiping', this.handleSwipe);
	    this.element.removeEventListener('swiperelease', this.handleSwipeEnd);
	    this.listener.off();
	  };
	
	  SwipeNextPrev.prototype.render = function render() {
	    return null;
	  };
	
	  return SwipeNextPrev;
	}(_react.Component);
	
	exports.default = SwipeNextPrev;
	module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	/*!
	 * VERSION: 0.2.2
	 * DATE: 2018-02-15
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 *
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = typeof module !== "undefined" && module.exports && typeof global !== "undefined" ? global : undefined || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
	
		"use strict";
	
		_gsScope._gsDefine("easing.CustomEase", ["easing.Ease"], function (Ease) {
	
			var _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			    _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
			    _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig,
			    _needsParsingExp = /[cLlsS]/g,
			    _bezierError = "CustomEase only accepts Cubic Bezier data.",
			    _bezierToPoints = function _bezierToPoints(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
				var x12 = (x1 + x2) / 2,
				    y12 = (y1 + y2) / 2,
				    x23 = (x2 + x3) / 2,
				    y23 = (y2 + y3) / 2,
				    x34 = (x3 + x4) / 2,
				    y34 = (y3 + y4) / 2,
				    x123 = (x12 + x23) / 2,
				    y123 = (y12 + y23) / 2,
				    x234 = (x23 + x34) / 2,
				    y234 = (y23 + y34) / 2,
				    x1234 = (x123 + x234) / 2,
				    y1234 = (y123 + y234) / 2,
				    dx = x4 - x1,
				    dy = y4 - y1,
				    d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx),
				    d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx),
				    length;
				if (!points) {
					points = [{ x: x1, y: y1 }, { x: x4, y: y4 }];
					index = 1;
				}
				points.splice(index || points.length - 1, 0, { x: x1234, y: y1234 });
				if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
					length = points.length;
					_bezierToPoints(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
					_bezierToPoints(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
				}
				return points;
			},
			    _pathDataToBezier = function _pathDataToBezier(d) {
				var a = (d + "").replace(_scientific, function (m) {
					var n = +m;
					return n < 0.0001 && n > -0.0001 ? 0 : n;
				}).match(_svgPathExp) || [],
				    //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
				path = [],
				    relativeX = 0,
				    relativeY = 0,
				    elements = a.length,
				    l = 2,
				    i,
				    x,
				    y,
				    command,
				    isRelative,
				    segment,
				    startX,
				    startY,
				    prevCommand,
				    difX,
				    difY;
				for (i = 0; i < elements; i++) {
					prevCommand = command;
					if (isNaN(a[i])) {
						command = a[i].toUpperCase();
						isRelative = command !== a[i]; //lower case means relative
					} else {
						//commands like "C" can be strung together without any new command characters between.
						i--;
					}
					x = +a[i + 1];
					y = +a[i + 2];
					if (isRelative) {
						x += relativeX;
						y += relativeY;
					}
					if (!i) {
						startX = x;
						startY = y;
					}
					if (command === "M") {
						if (segment && segment.length < 8) {
							//if the path data was funky and just had a M with no actual drawing anywhere, skip it.
							path.length -= 1;
							l = 0;
						}
						relativeX = startX = x;
						relativeY = startY = y;
						segment = [x, y];
						l = 2;
						path.push(segment);
						i += 2;
						command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
					} else if (command === "C") {
						if (!segment) {
							segment = [0, 0];
						}
						segment[l++] = x;
						segment[l++] = y;
						if (!isRelative) {
							relativeX = relativeY = 0;
						}
						segment[l++] = relativeX + a[i + 3] * 1; //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
						segment[l++] = relativeY + a[i + 4] * 1;
						segment[l++] = relativeX = relativeX + a[i + 5] * 1;
						segment[l++] = relativeY = relativeY + a[i + 6] * 1;
						i += 6;
					} else if (command === "S") {
						if (prevCommand === "C" || prevCommand === "S") {
							difX = relativeX - segment[l - 4];
							difY = relativeY - segment[l - 3];
							segment[l++] = relativeX + difX;
							segment[l++] = relativeY + difY;
						} else {
							segment[l++] = relativeX;
							segment[l++] = relativeY;
						}
						segment[l++] = x;
						segment[l++] = y;
						if (!isRelative) {
							relativeX = relativeY = 0;
						}
						segment[l++] = relativeX = relativeX + a[i + 3] * 1;
						segment[l++] = relativeY = relativeY + a[i + 4] * 1;
						i += 4;
					} else if (command === "L" || command === "Z") {
						if (command === "Z") {
							x = startX;
							y = startY;
							segment.closed = true;
						}
						if (command === "L" || Math.abs(relativeX - x) > 0.5 || Math.abs(relativeY - y) > 0.5) {
							segment[l++] = relativeX + (x - relativeX) / 3;
							segment[l++] = relativeY + (y - relativeY) / 3;
							segment[l++] = relativeX + (x - relativeX) * 2 / 3;
							segment[l++] = relativeY + (y - relativeY) * 2 / 3;
							segment[l++] = x;
							segment[l++] = y;
							if (command === "L") {
								i += 2;
							}
						}
						relativeX = x;
						relativeY = y;
					} else {
						throw _bezierError;
					}
				}
				return path[0];
			},
			    _findMinimum = function _findMinimum(values) {
				var l = values.length,
				    min = 999999999999,
				    i;
				for (i = 1; i < l; i += 6) {
					if (+values[i] < min) {
						min = +values[i];
					}
				}
				return min;
			},
			    _normalize = function _normalize(values, height, originY) {
				//takes all the points and translates/scales them so that the x starts at 0 and ends at 1.
				if (!originY && originY !== 0) {
					originY = Math.max(+values[values.length - 1], +values[1]);
				}
				var tx = +values[0] * -1,
				    ty = -originY,
				    l = values.length,
				    sx = 1 / (+values[l - 2] + tx),
				    sy = -height || (Math.abs(+values[l - 1] - +values[1]) < 0.01 * (+values[l - 2] - +values[0]) ? _findMinimum(values) + ty : +values[l - 1] + ty),
				    i;
				if (sy) {
					//typically y ends at 1 (so that the end values are reached)
					sy = 1 / sy;
				} else {
					//in case the ease returns to its beginning value, scale everything proportionally
					sy = -sx;
				}
				for (i = 0; i < l; i += 2) {
					values[i] = (+values[i] + tx) * sx;
					values[i + 1] = (+values[i + 1] + ty) * sy;
				}
			},
			    _getRatio = function _getRatio(p) {
				var point = this.lookup[p * this.l | 0] || this.lookup[this.l - 1];
				if (point.nx < p) {
					point = point.n;
				}
				return point.y + (p - point.x) / point.cx * point.cy;
			},
			    CustomEase = function CustomEase(id, data, config) {
				this._calcEnd = true;
				this.id = id;
				if (id) {
					Ease.map[id] = this;
				}
				this.getRatio = _getRatio; //speed optimization, faster lookups.
				this.setData(data, config);
			},
			    p = CustomEase.prototype = new Ease();
	
			p.constructor = CustomEase;
	
			p.setData = function (data, config) {
				data = data || "0,0,1,1";
				var values = data.match(_numbersExp),
				    closest = 1,
				    points = [],
				    l,
				    a1,
				    a2,
				    i,
				    inc,
				    j,
				    point,
				    prevPoint,
				    p,
				    precision;
				config = config || {};
				precision = config.precision || 1;
				this.data = data;
				this.lookup = [];
				this.points = points;
				this.fast = precision <= 1;
				if (_needsParsingExp.test(data) || data.indexOf("M") !== -1 && data.indexOf("C") === -1) {
					values = _pathDataToBezier(data);
				}
				l = values.length;
				if (l === 4) {
					values.unshift(0, 0);
					values.push(1, 1);
					l = 8;
				} else if ((l - 2) % 6) {
					throw _bezierError;
				}
				if (+values[0] !== 0 || +values[l - 2] !== 1) {
					_normalize(values, config.height, config.originY);
				}
	
				this.rawBezier = values;
	
				for (i = 2; i < l; i += 6) {
					a1 = { x: +values[i - 2], y: +values[i - 1] };
					a2 = { x: +values[i + 4], y: +values[i + 5] };
					points.push(a1, a2);
					_bezierToPoints(a1.x, a1.y, +values[i], +values[i + 1], +values[i + 2], +values[i + 3], a2.x, a2.y, 1 / (precision * 200000), points, points.length - 1);
				}
				l = points.length;
				for (i = 0; i < l; i++) {
					point = points[i];
					prevPoint = points[i - 1] || point;
					if (point.x > prevPoint.x || prevPoint.y !== point.y && prevPoint.x === point.x || point === prevPoint) {
						//if a point goes BACKWARD in time or is a duplicate, just drop it.
						prevPoint.cx = point.x - prevPoint.x; //change in x between this point and the next point (performance optimization)
						prevPoint.cy = point.y - prevPoint.y;
						prevPoint.n = point;
						prevPoint.nx = point.x; //next point's x value (performance optimization, making lookups faster in getRatio()). Remember, the lookup will always land on a spot where it's either this point or the very next one (never beyond that)
						if (this.fast && i > 1 && Math.abs(prevPoint.cy / prevPoint.cx - points[i - 2].cy / points[i - 2].cx) > 2) {
							//if there's a sudden change in direction, prioritize accuracy over speed. Like a bounce ease - you don't want to risk the sampling chunks landing on each side of the bounce anchor and having it clipped off.
							this.fast = false;
						}
						if (prevPoint.cx < closest) {
							if (!prevPoint.cx) {
								prevPoint.cx = 0.001; //avoids math problems in getRatio() (dividing by zero)
								if (i === l - 1) {
									//in case the final segment goes vertical RIGHT at the end, make sure we end at the end.
									prevPoint.x -= 0.001;
									closest = Math.min(closest, 0.001);
									this.fast = false;
								}
							} else {
								closest = prevPoint.cx;
							}
						}
					} else {
						points.splice(i--, 1);
						l--;
					}
				}
				l = 1 / closest + 1 | 0;
				this.l = l; //record for speed optimization
				inc = 1 / l;
				j = 0;
				point = points[0];
				if (this.fast) {
					for (i = 0; i < l; i++) {
						//for fastest lookups, we just sample along the path at equal x (time) distance. Uses more memory and is slightly less accurate for anchors that don't land on the sampling points, but for the vast majority of eases it's excellent (and fast).
						p = i * inc;
						if (point.nx < p) {
							point = points[++j];
						}
						a1 = point.y + (p - point.x) / point.cx * point.cy;
						this.lookup[i] = { x: p, cx: inc, y: a1, cy: 0, nx: 9 };
						if (i) {
							this.lookup[i - 1].cy = a1 - this.lookup[i - 1].y;
						}
					}
					this.lookup[l - 1].cy = points[points.length - 1].y - a1;
				} else {
					//this option is more accurate, ensuring that EVERY anchor is hit perfectly. Clipping across a bounce, for example, would never happen.
					for (i = 0; i < l; i++) {
						//build a lookup table based on the smallest distance so that we can instantly find the appropriate point (well, it'll either be that point or the very next one). We'll look up based on the linear progress. So it's it's 0.5 and the lookup table has 100 elements, it'd be like lookup[Math.floor(0.5 * 100)]
						if (point.nx < i * inc) {
							point = points[++j];
						}
						this.lookup[i] = point;
					}
	
					if (j < points.length - 1) {
						this.lookup[i - 1] = points[points.length - 2];
					}
				}
				this._calcEnd = points[points.length - 1].y !== 1 || points[0].y !== 0; //ensures that we don't run into floating point errors. As long as we're starting at 0 and ending at 1, tell GSAP to skip the final calculation and use 0/1 as the factor.
				return this;
			};
	
			p.getRatio = _getRatio;
	
			p.getSVGData = function (config) {
				return CustomEase.getSVGData(this, config);
			};
	
			CustomEase.create = function (id, data, config) {
				return new CustomEase(id, data, config);
			};
	
			CustomEase.version = "0.2.2";
	
			CustomEase.bezierToPoints = _bezierToPoints;
			CustomEase.get = function (id) {
				return Ease.map[id];
			};
			CustomEase.getSVGData = function (ease, config) {
				config = config || {};
				var rnd = 1000,
				    width = config.width || 100,
				    height = config.height || 100,
				    x = config.x || 0,
				    y = (config.y || 0) + height,
				    e = config.path,
				    a,
				    slope,
				    i,
				    inc,
				    tx,
				    ty,
				    precision,
				    threshold,
				    prevX,
				    prevY;
				if (config.invert) {
					height = -height;
					y = 0;
				}
				ease = ease.getRatio ? ease : Ease.map[ease] || console.log("No ease found: ", ease);
				if (!ease.rawBezier) {
					a = ["M" + x + "," + y];
					precision = Math.max(5, (config.precision || 1) * 200);
					inc = 1 / precision;
					precision += 2;
					threshold = 5 / precision;
					prevX = ((x + inc * width) * rnd | 0) / rnd;
					prevY = ((y + ease.getRatio(inc) * -height) * rnd | 0) / rnd;
					slope = (prevY - y) / (prevX - x);
					for (i = 2; i < precision; i++) {
						tx = ((x + i * inc * width) * rnd | 0) / rnd;
						ty = ((y + ease.getRatio(i * inc) * -height) * rnd | 0) / rnd;
						if (Math.abs((ty - prevY) / (tx - prevX) - slope) > threshold || i === precision - 1) {
							//only add points when the slope changes beyond the threshold
							a.push(prevX + "," + prevY);
							slope = (ty - prevY) / (tx - prevX);
						}
						prevX = tx;
						prevY = ty;
					}
				} else {
					a = [];
					precision = ease.rawBezier.length;
					for (i = 0; i < precision; i += 2) {
						a.push(((x + ease.rawBezier[i] * width) * rnd | 0) / rnd + "," + ((y + ease.rawBezier[i + 1] * -height) * rnd | 0) / rnd);
					}
					a[0] = "M" + a[0];
					a[1] = "C" + a[1];
				}
				if (e) {
					(typeof e === "string" ? document.querySelector(e) : e).setAttribute("d", a.join(" "));
				}
				return a.join(" ");
			};
	
			return CustomEase;
		}, true);
	});if (_gsScope._gsDefine) {
		_gsScope._gsQueue.pop()();
	}
	
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function (name) {
		"use strict";
	
		var getGlobal = function getGlobal() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof module !== "undefined" && module.exports) {
			//node
			__webpack_require__(16);
			module.exports = getGlobal();
		} else if (true) {
			//AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	})("CustomEase");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * VERSION: 0.8.11
	 * DATE: 2018-02-15
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * MorphSVGPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
	 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
	 * This work is subject to the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = typeof module !== "undefined" && module.exports && typeof global !== "undefined" ? global : undefined || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
	
		"use strict";
	
		var _DEG2RAD = Math.PI / 180,
		    _RAD2DEG = 180 / Math.PI,
		    _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
		    _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
		    _selectorExp = /(^[#\.][a-z]|[a-y][a-z])/gi,
		    _commands = /[achlmqstvz]/ig,
		    _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig,
	
		//_attrExp = /(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/gi, //finds all the attribute name/value pairs in an HTML element
		//_outerTagExp = /^<([A-Za-z0-9_\-]+)((?:\s+[A-Za-z0-9_\-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/i, //takes the outerHTML and pulls out [0] - the first tag, [1] - the tag name, and [2] - the attribute name/value pairs (space-delimited)
		//_wrappingQuotesExp = /^["']|["']$/g,
		TweenLite = _gsScope._gsDefine.globals.TweenLite,
	
		//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
	
		_log = function _log(message) {
			if (_gsScope.console) {
				console.log(message);
			}
		},
	
	
		// translates an arc into a normalized array of cubic beziers excluding the starting x/y. The circle the arc follows will be centered at 0,0 and have a radius of 1 (hence normalized). Each bezier covers no more than 90 degrees; the arc will be divided evenly into a maximum of four curves.
		_normalizedArcToBeziers = function _normalizedArcToBeziers(angleStart, angleExtent) {
			var segments = Math.ceil(Math.abs(angleExtent) / 90),
			    l = 0,
			    a = [],
			    angleIncrement,
			    controlLength,
			    angle,
			    dx,
			    dy,
			    i;
			angleStart *= _DEG2RAD;
			angleExtent *= _DEG2RAD;
			angleIncrement = angleExtent / segments;
			controlLength = 4 / 3 * Math.sin(angleIncrement / 2) / (1 + Math.cos(angleIncrement / 2));
			for (i = 0; i < segments; i++) {
				angle = angleStart + i * angleIncrement;
				dx = Math.cos(angle);
				dy = Math.sin(angle);
				a[l++] = dx - controlLength * dy;
				a[l++] = dy + controlLength * dx;
				angle += angleIncrement;
				dx = Math.cos(angle);
				dy = Math.sin(angle);
				a[l++] = dx + controlLength * dy;
				a[l++] = dy - controlLength * dx;
				a[l++] = dx;
				a[l++] = dy;
			}
			return a;
		},
	
	
		// translates SVG arc data into an array of cubic beziers
		_arcToBeziers = function _arcToBeziers(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
			if (lastX === x && lastY === y) {
				return;
			}
			rx = Math.abs(rx);
			ry = Math.abs(ry);
			var angleRad = angle % 360 * _DEG2RAD,
			    cosAngle = Math.cos(angleRad),
			    sinAngle = Math.sin(angleRad),
			    dx2 = (lastX - x) / 2,
			    dy2 = (lastY - y) / 2,
			    x1 = cosAngle * dx2 + sinAngle * dy2,
			    y1 = -sinAngle * dx2 + cosAngle * dy2,
			    rx_sq = rx * rx,
			    ry_sq = ry * ry,
			    x1_sq = x1 * x1,
			    y1_sq = y1 * y1,
			    radiiCheck = x1_sq / rx_sq + y1_sq / ry_sq;
			if (radiiCheck > 1) {
				rx = Math.sqrt(radiiCheck) * rx;
				ry = Math.sqrt(radiiCheck) * ry;
				rx_sq = rx * rx;
				ry_sq = ry * ry;
			}
			var sign = largeArcFlag === sweepFlag ? -1 : 1,
			    sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
			if (sq < 0) {
				sq = 0;
			}
			var coef = sign * Math.sqrt(sq),
			    cx1 = coef * (rx * y1 / ry),
			    cy1 = coef * -(ry * x1 / rx),
			    sx2 = (lastX + x) / 2,
			    sy2 = (lastY + y) / 2,
			    cx = sx2 + (cosAngle * cx1 - sinAngle * cy1),
			    cy = sy2 + (sinAngle * cx1 + cosAngle * cy1),
			    ux = (x1 - cx1) / rx,
			    uy = (y1 - cy1) / ry,
			    vx = (-x1 - cx1) / rx,
			    vy = (-y1 - cy1) / ry,
			    n = Math.sqrt(ux * ux + uy * uy),
			    p = ux;
			sign = uy < 0 ? -1 : 1;
			var angleStart = sign * Math.acos(p / n) * _RAD2DEG;
	
			n = Math.sqrt((ux * ux + uy * uy) * (vx * vx + vy * vy));
			p = ux * vx + uy * vy;
			sign = ux * vy - uy * vx < 0 ? -1 : 1;
			var angleExtent = sign * Math.acos(p / n) * _RAD2DEG;
			if (!sweepFlag && angleExtent > 0) {
				angleExtent -= 360;
			} else if (sweepFlag && angleExtent < 0) {
				angleExtent += 360;
			}
			angleExtent %= 360;
			angleStart %= 360;
	
			var bezierPoints = _normalizedArcToBeziers(angleStart, angleExtent),
			    a = cosAngle * rx,
			    b = sinAngle * rx,
			    c = sinAngle * -ry,
			    d = cosAngle * ry,
			    l = bezierPoints.length - 2,
			    i,
			    px,
			    py;
			//translate all the bezier points according to the matrix...
			for (i = 0; i < l; i += 2) {
				px = bezierPoints[i];
				py = bezierPoints[i + 1];
				bezierPoints[i] = px * a + py * c + cx;
				bezierPoints[i + 1] = px * b + py * d + cy;
			}
			bezierPoints[bezierPoints.length - 2] = x; //always set the end to exactly where it's supposed to be
			bezierPoints[bezierPoints.length - 1] = y;
			return bezierPoints;
		},
	
	
		//Spits back an array of cubic Bezier segments that use absolute coordinates. Each segment starts with a "moveTo" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.
		_pathDataToBezier = function _pathDataToBezier(d) {
			var a = (d + "").replace(_scientific, function (m) {
				var n = +m;return n < 0.0001 && n > -0.0001 ? 0 : n;
			}).match(_svgPathExp) || [],
			    //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
			path = [],
			    relativeX = 0,
			    relativeY = 0,
			    elements = a.length,
			    l = 2,
			    points = 0,
			    i,
			    j,
			    x,
			    y,
			    command,
			    isRelative,
			    segment,
			    startX,
			    startY,
			    difX,
			    difY,
			    beziers,
			    prevCommand;
			if (!d || !isNaN(a[0]) || isNaN(a[1])) {
				_log("ERROR: malformed path data: " + d);
				return path;
			}
			for (i = 0; i < elements; i++) {
				prevCommand = command;
				if (isNaN(a[i])) {
					command = a[i].toUpperCase();
					isRelative = command !== a[i]; //lower case means relative
				} else {
					//commands like "C" can be strung together without any new command characters between.
					i--;
				}
				x = +a[i + 1];
				y = +a[i + 2];
				if (isRelative) {
					x += relativeX;
					y += relativeY;
				}
				if (i === 0) {
					startX = x;
					startY = y;
				}
	
				// "M" (move)
				if (command === "M") {
					if (segment && segment.length < 8) {
						//if the path data was funky and just had a M with no actual drawing anywhere, skip it.
						path.length -= 1;
						l = 0;
					}
					relativeX = startX = x;
					relativeY = startY = y;
					segment = [x, y];
					points += l;
					l = 2;
					path.push(segment);
					i += 2;
					command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
	
					// "C" (cubic bezier)
				} else if (command === "C") {
					if (!segment) {
						segment = [0, 0];
					}
					segment[l++] = x;
					segment[l++] = y;
					if (!isRelative) {
						relativeX = relativeY = 0;
					}
					segment[l++] = relativeX + a[i + 3] * 1; //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
					segment[l++] = relativeY + a[i + 4] * 1;
					segment[l++] = relativeX = relativeX + a[i + 5] * 1;
					segment[l++] = relativeY = relativeY + a[i + 6] * 1;
					//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.
					//	segment.length = l = l-6;
					//}
					i += 6;
	
					// "S" (continuation of cubic bezier)
				} else if (command === "S") {
					if (prevCommand === "C" || prevCommand === "S") {
						difX = relativeX - segment[l - 4];
						difY = relativeY - segment[l - 3];
						segment[l++] = relativeX + difX;
						segment[l++] = relativeY + difY;
					} else {
						segment[l++] = relativeX;
						segment[l++] = relativeY;
					}
					segment[l++] = x;
					segment[l++] = y;
					if (!isRelative) {
						relativeX = relativeY = 0;
					}
					segment[l++] = relativeX = relativeX + a[i + 3] * 1;
					segment[l++] = relativeY = relativeY + a[i + 4] * 1;
					//if (y === segment[l-1] && y === segment[l-3] && x === segment[l-2] && x === segment[l-4]) { //if all the values are the same, eliminate the waste.
					//	segment.length = l = l-6;
					//}
					i += 4;
	
					// "Q" (quadratic bezier)
				} else if (command === "Q") {
					difX = x - relativeX;
					difY = y - relativeY;
					segment[l++] = relativeX + difX * 2 / 3;
					segment[l++] = relativeY + difY * 2 / 3;
					if (!isRelative) {
						relativeX = relativeY = 0;
					}
					relativeX = relativeX + a[i + 3] * 1;
					relativeY = relativeY + a[i + 4] * 1;
					difX = x - relativeX;
					difY = y - relativeY;
					segment[l++] = relativeX + difX * 2 / 3;
					segment[l++] = relativeY + difY * 2 / 3;
					segment[l++] = relativeX;
					segment[l++] = relativeY;
	
					i += 4;
	
					// "T" (continuation of quadratic bezier)
				} else if (command === "T") {
					difX = relativeX - segment[l - 4];
					difY = relativeY - segment[l - 3];
					segment[l++] = relativeX + difX;
					segment[l++] = relativeY + difY;
					difX = relativeX + difX * 1.5 - x;
					difY = relativeY + difY * 1.5 - y;
					segment[l++] = x + difX * 2 / 3;
					segment[l++] = y + difY * 2 / 3;
					segment[l++] = relativeX = x;
					segment[l++] = relativeY = y;
	
					i += 2;
	
					// "H" (horizontal line)
				} else if (command === "H") {
					y = relativeY;
					//if (x !== relativeX) {
					segment[l++] = relativeX + (x - relativeX) / 3;
					segment[l++] = relativeY + (y - relativeY) / 3;
					segment[l++] = relativeX + (x - relativeX) * 2 / 3;
					segment[l++] = relativeY + (y - relativeY) * 2 / 3;
					segment[l++] = relativeX = x;
					segment[l++] = y;
					//}
					i += 1;
	
					// "V" (horizontal line)
				} else if (command === "V") {
					y = x; //adjust values because the first (and only one) isn't x in this case, it's y.
					x = relativeX;
					if (isRelative) {
						y += relativeY - relativeX;
					}
					//if (y !== relativeY) {
					segment[l++] = x;
					segment[l++] = relativeY + (y - relativeY) / 3;
					segment[l++] = x;
					segment[l++] = relativeY + (y - relativeY) * 2 / 3;
					segment[l++] = x;
					segment[l++] = relativeY = y;
					//}
					i += 1;
	
					// "L" (line) or "Z" (close)
				} else if (command === "L" || command === "Z") {
					if (command === "Z") {
						x = startX;
						y = startY;
						segment.closed = true;
					}
					if (command === "L" || Math.abs(relativeX - x) > 0.5 || Math.abs(relativeY - y) > 0.5) {
						segment[l++] = relativeX + (x - relativeX) / 3;
						segment[l++] = relativeY + (y - relativeY) / 3;
						segment[l++] = relativeX + (x - relativeX) * 2 / 3;
						segment[l++] = relativeY + (y - relativeY) * 2 / 3;
						segment[l++] = x;
						segment[l++] = y;
						if (command === "L") {
							i += 2;
						}
					}
					relativeX = x;
					relativeY = y;
	
					// "A" (arc)
				} else if (command === "A") {
					beziers = _arcToBeziers(relativeX, relativeY, a[i + 1] * 1, a[i + 2] * 1, a[i + 3] * 1, a[i + 4] * 1, a[i + 5] * 1, (isRelative ? relativeX : 0) + a[i + 6] * 1, (isRelative ? relativeY : 0) + a[i + 7] * 1);
					if (beziers) {
						for (j = 0; j < beziers.length; j++) {
							segment[l++] = beziers[j];
						}
					}
					relativeX = segment[l - 2];
					relativeY = segment[l - 1];
					i += 7;
				} else {
					_log("Error: malformed path data: " + d);
				}
			}
			path.totalPoints = points + l;
			return path;
		},
	
	
		//adds a certain number of Beziers while maintaining the path shape (so that the start/end values can have a matching quantity of points to animate). Only pass in ONE segment of the Bezier at a time. Format: [xAnchor, yAnchor, xControlPoint1, yControlPoint1, xControlPoint2, yControlPoint2, xAnchor, yAnchor, xControlPoint1, etc...]
		_subdivideBezier = function _subdivideBezier(bezier, quantity) {
			var tally = 0,
			    max = 0.999999,
			    l = bezier.length,
			    newPointsPerSegment = quantity / ((l - 2) / 6),
			    ax,
			    ay,
			    cp1x,
			    cp1y,
			    cp2x,
			    cp2y,
			    bx,
			    by,
			    x1,
			    y1,
			    x2,
			    y2,
			    i,
			    t;
			for (i = 2; i < l; i += 6) {
				tally += newPointsPerSegment;
				while (tally > max) {
					//compare with 0.99999 instead of 1 in order to prevent rounding errors
					ax = bezier[i - 2];
					ay = bezier[i - 1];
					cp1x = bezier[i];
					cp1y = bezier[i + 1];
					cp2x = bezier[i + 2];
					cp2y = bezier[i + 3];
					bx = bezier[i + 4];
					by = bezier[i + 5];
					t = 1 / (Math.floor(tally) + 1); //progress along the bezier (value between 0 and 1)
	
					x1 = ax + (cp1x - ax) * t;
					x2 = cp1x + (cp2x - cp1x) * t;
					x1 += (x2 - x1) * t;
					x2 += (cp2x + (bx - cp2x) * t - x2) * t;
	
					y1 = ay + (cp1y - ay) * t;
					y2 = cp1y + (cp2y - cp1y) * t;
					y1 += (y2 - y1) * t;
					y2 += (cp2y + (by - cp2y) * t - y2) * t;
	
					bezier.splice(i, 4, ax + (cp1x - ax) * t, //first control point
					ay + (cp1y - ay) * t, x1, //second control point
					y1, x1 + (x2 - x1) * t, //new fabricated anchor on line
					y1 + (y2 - y1) * t, x2, //third control point
					y2, cp2x + (bx - cp2x) * t, //fourth control point
					cp2y + (by - cp2y) * t);
					i += 6;
					l += 6;
					tally--;
				}
			}
			return bezier;
		},
		    _bezierToPathData = function _bezierToPathData(beziers) {
			var data = "",
			    l = beziers.length,
			    rnd = 100,
			    sl,
			    s,
			    i,
			    segment;
			for (s = 0; s < l; s++) {
				segment = beziers[s];
				data += "M" + segment[0] + "," + segment[1] + " C";
				sl = segment.length;
				for (i = 2; i < sl; i++) {
					data += (segment[i++] * rnd | 0) / rnd + "," + (segment[i++] * rnd | 0) / rnd + " " + (segment[i++] * rnd | 0) / rnd + "," + (segment[i++] * rnd | 0) / rnd + " " + (segment[i++] * rnd | 0) / rnd + "," + (segment[i] * rnd | 0) / rnd + " ";
				}
				if (segment.closed) {
					data += "z";
				}
			}
			return data;
		},
		    _reverseBezier = function _reverseBezier(bezier) {
			var a = [],
			    i = bezier.length - 1,
			    l = 0;
			while (--i > -1) {
				a[l++] = bezier[i];
				a[l++] = bezier[i + 1];
				i--;
			}
			for (i = 0; i < l; i++) {
				bezier[i] = a[i];
			}
			bezier.reversed = bezier.reversed ? false : true;
		},
		    _getAverageXY = function _getAverageXY(bezier) {
			var l = bezier.length,
			    x = 0,
			    y = 0,
			    i;
			for (i = 0; i < l; i++) {
				x += bezier[i++];
				y += bezier[i];
			}
			return [x / (l / 2), y / (l / 2)];
		},
		    _getSize = function _getSize(bezier) {
			//rough estimate of the bounding box (based solely on the anchors) of a single segment. sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
			var l = bezier.length,
			    xMax = bezier[0],
			    xMin = xMax,
			    yMax = bezier[1],
			    yMin = yMax,
			    x,
			    y,
			    i;
			for (i = 6; i < l; i += 6) {
				x = bezier[i];
				y = bezier[i + 1];
				if (x > xMax) {
					xMax = x;
				} else if (x < xMin) {
					xMin = x;
				}
				if (y > yMax) {
					yMax = y;
				} else if (y < yMin) {
					yMin = y;
				}
			}
			bezier.centerX = (xMax + xMin) / 2;
			bezier.centerY = (yMax + yMin) / 2;
			return bezier.size = (xMax - xMin) * (yMax - yMin);
		},
		    _getTotalSize = function _getTotalSize(bezier) {
			//rough estimate of the bounding box of the entire list of Bezier segments (based solely on the anchors). sets "size", "centerX", and "centerY" properties on the bezier array itself, and returns the size (width * height)
			var segment = bezier.length,
			    xMax = bezier[0][0],
			    xMin = xMax,
			    yMax = bezier[0][1],
			    yMin = yMax,
			    l,
			    x,
			    y,
			    i,
			    b;
			while (--segment > -1) {
				b = bezier[segment];
				l = b.length;
				for (i = 6; i < l; i += 6) {
					x = b[i];
					y = b[i + 1];
					if (x > xMax) {
						xMax = x;
					} else if (x < xMin) {
						xMin = x;
					}
					if (y > yMax) {
						yMax = y;
					} else if (y < yMin) {
						yMin = y;
					}
				}
			}
			bezier.centerX = (xMax + xMin) / 2;
			bezier.centerY = (yMax + yMin) / 2;
			return bezier.size = (xMax - xMin) * (yMax - yMin);
		},
		    _sortByComplexity = function _sortByComplexity(a, b) {
			return b.length - a.length;
		},
		    _sortBySize = function _sortBySize(a, b) {
			var sizeA = a.size || _getSize(a),
			    sizeB = b.size || _getSize(b);
			return Math.abs(sizeB - sizeA) < (sizeA + sizeB) / 20 ? b.centerX - a.centerX || b.centerY - a.centerY : sizeB - sizeA; //if the size is within 10% of each other, prioritize position from left to right, then top to bottom.
		},
		    _offsetBezier = function _offsetBezier(bezier, shapeIndex) {
			var a = bezier.slice(0),
			    l = bezier.length,
			    wrap = l - 2,
			    i,
			    index;
			shapeIndex = shapeIndex | 0;
			for (i = 0; i < l; i++) {
				index = (i + shapeIndex) % wrap;
				bezier[i++] = a[index];
				bezier[i] = a[index + 1];
			}
		},
		    _getTotalMovement = function _getTotalMovement(sb, eb, shapeIndex, offsetX, offsetY) {
			var l = sb.length,
			    d = 0,
			    wrap = l - 2,
			    index,
			    i,
			    x,
			    y;
			shapeIndex *= 6;
			for (i = 0; i < l; i += 6) {
				index = (i + shapeIndex) % wrap;
				y = sb[index] - (eb[i] - offsetX);
				x = sb[index + 1] - (eb[i + 1] - offsetY);
				d += Math.sqrt(x * x + y * y);
			}
			return d;
		},
		    _getClosestShapeIndex = function _getClosestShapeIndex(sb, eb, checkReverse) {
			//finds the index in a closed cubic bezier array that's closest to the angle provided (angle measured from the center or average x/y).
			var l = sb.length,
			    sCenter = _getAverageXY(sb),
			    //when comparing distances, adjust the coordinates as if the shapes are centered with each other.
			eCenter = _getAverageXY(eb),
			    offsetX = eCenter[0] - sCenter[0],
			    offsetY = eCenter[1] - sCenter[1],
			    min = _getTotalMovement(sb, eb, 0, offsetX, offsetY),
			    minIndex = 0,
			    copy,
			    d,
			    i;
			for (i = 6; i < l; i += 6) {
				d = _getTotalMovement(sb, eb, i / 6, offsetX, offsetY);
				if (d < min) {
					min = d;
					minIndex = i;
				}
			}
			if (checkReverse) {
				copy = sb.slice(0);
				_reverseBezier(copy);
				for (i = 6; i < l; i += 6) {
					d = _getTotalMovement(copy, eb, i / 6, offsetX, offsetY);
					if (d < min) {
						min = d;
						minIndex = -i;
					}
				}
			}
			return minIndex / 6;
		},
		    _getClosestAnchor = function _getClosestAnchor(bezier, x, y) {
			//finds the x/y of the anchor that's closest to the provided x/y coordinate (returns an array, like [x, y]). The bezier should be the top-level type that contains an array for each segment.
			var j = bezier.length,
			    closestDistance = 99999999999,
			    closestX = 0,
			    closestY = 0,
			    b,
			    dx,
			    dy,
			    d,
			    i,
			    l;
			while (--j > -1) {
				b = bezier[j];
				l = b.length;
				for (i = 0; i < l; i += 6) {
					dx = b[i] - x;
					dy = b[i + 1] - y;
					d = Math.sqrt(dx * dx + dy * dy);
					if (d < closestDistance) {
						closestDistance = d;
						closestX = b[i];
						closestY = b[i + 1];
					}
				}
			}
			return [closestX, closestY];
		},
		    _getClosestSegment = function _getClosestSegment(bezier, pool, startIndex, sortRatio, offsetX, offsetY) {
			//matches the bezier to the closest one in a pool (array) of beziers, assuming they are in order of size and we shouldn't drop more than 20% of the size, otherwise prioritizing location (total distance to the center). Extracts the segment out of the pool array and returns it.
			var l = pool.length,
			    index = 0,
			    minSize = Math.min(bezier.size || _getSize(bezier), pool[startIndex].size || _getSize(pool[startIndex])) * sortRatio,
			    //limit things based on a percentage of the size of either the bezier or the next element in the array, whichever is smaller.
			min = 999999999999,
			    cx = bezier.centerX + offsetX,
			    cy = bezier.centerY + offsetY,
			    size,
			    i,
			    dx,
			    dy,
			    d;
			for (i = startIndex; i < l; i++) {
				size = pool[i].size || _getSize(pool[i]);
				if (size < minSize) {
					break;
				}
				dx = pool[i].centerX - cx;
				dy = pool[i].centerY - cy;
				d = Math.sqrt(dx * dx + dy * dy);
				if (d < min) {
					index = i;
					min = d;
				}
			}
			d = pool[index];
			pool.splice(index, 1);
			return d;
		},
		    _equalizeSegmentQuantity = function _equalizeSegmentQuantity(start, end, shapeIndex, map) {
			//returns an array of shape indexes, 1 for each segment.
			var dif = end.length - start.length,
			    longer = dif > 0 ? end : start,
			    shorter = dif > 0 ? start : end,
			    added = 0,
			    sortMethod = map === "complexity" ? _sortByComplexity : _sortBySize,
			    sortRatio = map === "position" ? 0 : typeof map === "number" ? map : 0.8,
			    i = shorter.length,
			    shapeIndices = (typeof shapeIndex === "undefined" ? "undefined" : _typeof(shapeIndex)) === "object" && shapeIndex.push ? shapeIndex.slice(0) : [shapeIndex],
			    reverse = shapeIndices[0] === "reverse" || shapeIndices[0] < 0,
			    log = shapeIndex === "log",
			    eb,
			    sb,
			    b,
			    x,
			    y,
			    offsetX,
			    offsetY;
			if (!shorter[0]) {
				return;
			}
			if (longer.length > 1) {
				start.sort(sortMethod);
				end.sort(sortMethod);
				offsetX = longer.size || _getTotalSize(longer); //ensures centerX and centerY are defined (used below).
				offsetX = shorter.size || _getTotalSize(shorter);
				offsetX = longer.centerX - shorter.centerX;
				offsetY = longer.centerY - shorter.centerY;
				if (sortMethod === _sortBySize) {
					for (i = 0; i < shorter.length; i++) {
						longer.splice(i, 0, _getClosestSegment(shorter[i], longer, i, sortRatio, offsetX, offsetY));
					}
				}
			}
			if (dif) {
				if (dif < 0) {
					dif = -dif;
				}
				if (longer[0].length > shorter[0].length) {
					//since we use shorter[0] as the one to map the origination point of any brand new fabricated segments, do any subdividing first so that there are more points to choose from (if necessary)
					_subdivideBezier(shorter[0], (longer[0].length - shorter[0].length) / 6 | 0);
				}
				i = shorter.length;
				while (added < dif) {
					x = longer[i].size || _getSize(longer[i]); //just to ensure centerX and centerY are calculated which we use on the next line.
					b = _getClosestAnchor(shorter, longer[i].centerX, longer[i].centerY);
					x = b[0];
					y = b[1];
					shorter[i++] = [x, y, x, y, x, y, x, y];
					shorter.totalPoints += 8;
					added++;
				}
			}
			for (i = 0; i < start.length; i++) {
				eb = end[i];
				sb = start[i];
				dif = eb.length - sb.length;
				if (dif < 0) {
					_subdivideBezier(eb, -dif / 6 | 0);
				} else if (dif > 0) {
					_subdivideBezier(sb, dif / 6 | 0);
				}
				if (reverse && !sb.reversed) {
					_reverseBezier(sb);
				}
				shapeIndex = shapeIndices[i] || shapeIndices[i] === 0 ? shapeIndices[i] : "auto";
				if (shapeIndex) {
					//if start shape is closed, find the closest point to the start/end, and re-organize the bezier points accordingly so that the shape morphs in a more intuitive way.
					if (sb.closed || Math.abs(sb[0] - sb[sb.length - 2]) < 0.5 && Math.abs(sb[1] - sb[sb.length - 1]) < 0.5) {
						if (shapeIndex === "auto" || shapeIndex === "log") {
							shapeIndices[i] = shapeIndex = _getClosestShapeIndex(sb, eb, i === 0);
							if (shapeIndex < 0) {
								reverse = true;
								_reverseBezier(sb);
								shapeIndex = -shapeIndex;
							}
							_offsetBezier(sb, shapeIndex * 6);
						} else if (shapeIndex !== "reverse") {
							if (i && shapeIndex < 0) {
								//only happens if an array is passed as shapeIndex and a negative value is defined for an index beyond 0. Very rare, but helpful sometimes.
								_reverseBezier(sb);
							}
							_offsetBezier(sb, (shapeIndex < 0 ? -shapeIndex : shapeIndex) * 6);
						}
						//otherwise, if it's not a closed shape, consider reversing it if that would make the overall travel less
					} else if (!reverse && (shapeIndex === "auto" && Math.abs(eb[0] - sb[0]) + Math.abs(eb[1] - sb[1]) + Math.abs(eb[eb.length - 2] - sb[sb.length - 2]) + Math.abs(eb[eb.length - 1] - sb[sb.length - 1]) > Math.abs(eb[0] - sb[sb.length - 2]) + Math.abs(eb[1] - sb[sb.length - 1]) + Math.abs(eb[eb.length - 2] - sb[0]) + Math.abs(eb[eb.length - 1] - sb[1]) || shapeIndex % 2)) {
						_reverseBezier(sb);
						shapeIndices[i] = -1;
						reverse = true;
					} else if (shapeIndex === "auto") {
						shapeIndices[i] = 0;
					} else if (shapeIndex === "reverse") {
						shapeIndices[i] = -1;
					}
					if (sb.closed !== eb.closed) {
						//if one is closed and one isn't, don't close either one otherwise the tweening will look weird (but remember, the beginning and final states will honor the actual values, so this only affects the inbetween state)
						sb.closed = eb.closed = false;
					}
				}
			}
			if (log) {
				_log("shapeIndex:[" + shapeIndices.join(",") + "]");
			}
			return shapeIndices;
		},
		    _pathFilter = function _pathFilter(a, shapeIndex, map, precompile) {
			var start = _pathDataToBezier(a[0]),
			    end = _pathDataToBezier(a[1]);
			if (!_equalizeSegmentQuantity(start, end, shapeIndex || shapeIndex === 0 ? shapeIndex : "auto", map)) {
				return; //malformed path data or null target
			}
			a[0] = _bezierToPathData(start);
			a[1] = _bezierToPathData(end);
			if (precompile === "log" || precompile === true) {
				_log('precompile:["' + a[0] + '","' + a[1] + '"]');
			}
		},
		    _buildPathFilter = function _buildPathFilter(shapeIndex, map, precompile) {
			return map || precompile || shapeIndex || shapeIndex === 0 ? function (a) {
				_pathFilter(a, shapeIndex, map, precompile);
			} : _pathFilter;
		},
		    _offsetPoints = function _offsetPoints(text, offset) {
			if (!offset) {
				return text;
			}
			var a = text.match(_numbersExp) || [],
			    l = a.length,
			    s = "",
			    inc,
			    i,
			    j;
			if (offset === "reverse") {
				i = l - 1;
				inc = -2;
			} else {
				i = ((parseInt(offset, 10) || 0) * 2 + 1 + l * 100) % l;
				inc = 2;
			}
			for (j = 0; j < l; j += 2) {
				s += a[i - 1] + "," + a[i] + " ";
				i = (i + inc) % l;
			}
			return s;
		},
	
		//adds a certain number of points while maintaining the polygon/polyline shape (so that the start/end values can have a matching quantity of points to animate). Returns the revised string.
		_equalizePointQuantity = function _equalizePointQuantity(a, quantity) {
			var tally = 0,
			    x = parseFloat(a[0]),
			    y = parseFloat(a[1]),
			    s = x + "," + y + " ",
			    max = 0.999999,
			    newPointsPerSegment,
			    i,
			    l,
			    j,
			    factor,
			    nextX,
			    nextY;
			l = a.length;
			newPointsPerSegment = quantity * 0.5 / (l * 0.5 - 1);
			for (i = 0; i < l - 2; i += 2) {
				tally += newPointsPerSegment;
				nextX = parseFloat(a[i + 2]);
				nextY = parseFloat(a[i + 3]);
				if (tally > max) {
					//compare with 0.99999 instead of 1 in order to prevent rounding errors
					factor = 1 / (Math.floor(tally) + 1);
					j = 1;
					while (tally > max) {
						s += (x + (nextX - x) * factor * j).toFixed(2) + "," + (y + (nextY - y) * factor * j).toFixed(2) + " ";
						tally--;
						j++;
					}
				}
				s += nextX + "," + nextY + " ";
				x = nextX;
				y = nextY;
			}
			return s;
		},
		    _pointsFilter = function _pointsFilter(a) {
			var startNums = a[0].match(_numbersExp) || [],
			    endNums = a[1].match(_numbersExp) || [],
			    dif = endNums.length - startNums.length;
			if (dif > 0) {
				a[0] = _equalizePointQuantity(startNums, dif);
			} else {
				a[1] = _equalizePointQuantity(endNums, -dif);
			}
		},
		    _buildPointsFilter = function _buildPointsFilter(shapeIndex) {
			return !isNaN(shapeIndex) ? function (a) {
				_pointsFilter(a);
				a[1] = _offsetPoints(a[1], parseInt(shapeIndex, 10));
			} : _pointsFilter;
		},
		    _createPath = function _createPath(e, ignore) {
			var path = _gsScope.document.createElementNS("http://www.w3.org/2000/svg", "path"),
			    attr = Array.prototype.slice.call(e.attributes),
			    i = attr.length,
			    name;
			ignore = "," + ignore + ",";
			while (--i > -1) {
				name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
				if (ignore.indexOf("," + name + ",") === -1) {
					path.setAttributeNS(null, name, attr[i].nodeValue);
				}
			}
			return path;
		},
		    _convertToPath = function _convertToPath(e, swap) {
			var type = e.tagName.toLowerCase(),
			    circ = 0.552284749831,
			    data,
			    x,
			    y,
			    r,
			    ry,
			    path,
			    rcirc,
			    rycirc,
			    points,
			    w,
			    h,
			    x2,
			    x3,
			    x4,
			    x5,
			    x6,
			    y2,
			    y3,
			    y4,
			    y5,
			    y6;
			if (type === "path" || !e.getBBox) {
				return e;
			}
			path = _createPath(e, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
			if (type === "rect") {
				r = +e.getAttribute("rx") || 0;
				ry = +e.getAttribute("ry") || 0;
				x = +e.getAttribute("x") || 0;
				y = +e.getAttribute("y") || 0;
				w = (+e.getAttribute("width") || 0) - r * 2;
				h = (+e.getAttribute("height") || 0) - ry * 2;
				if (r || ry) {
					//if there are rounded corners, render cubic beziers
					x2 = x + r * (1 - circ);
					x3 = x + r;
					x4 = x3 + w;
					x5 = x4 + r * circ;
					x6 = x4 + r;
					y2 = y + ry * (1 - circ);
					y3 = y + ry;
					y4 = y3 + h;
					y5 = y4 + ry * circ;
					y6 = y4 + ry;
					data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [x6, y5, x5, y6, x4, y6, x4 - (x4 - x3) / 3, y6, x3 + (x4 - x3) / 3, y6, x3, y6, x2, y6, x, y5, x, y4, x, y4 - (y4 - y3) / 3, x, y3 + (y4 - y3) / 3, x, y3, x, y2, x2, y, x3, y, x3 + (x4 - x3) / 3, y, x4 - (x4 - x3) / 3, y, x4, y, x5, y, x6, y2, x6, y3].join(",") + "z";
				} else {
					data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
				}
			} else if (type === "circle" || type === "ellipse") {
				if (type === "circle") {
					r = ry = +e.getAttribute("r") || 0;
					rycirc = r * circ;
				} else {
					r = +e.getAttribute("rx") || 0;
					ry = +e.getAttribute("ry") || 0;
					rycirc = ry * circ;
				}
				x = +e.getAttribute("cx") || 0;
				y = +e.getAttribute("cy") || 0;
				rcirc = r * circ;
				data = "M" + (x + r) + "," + y + " C" + [x + r, y + rycirc, x + rcirc, y + ry, x, y + ry, x - rcirc, y + ry, x - r, y + rycirc, x - r, y, x - r, y - rycirc, x - rcirc, y - ry, x, y - ry, x + rcirc, y - ry, x + r, y - rycirc, x + r, y].join(",") + "z";
			} else if (type === "line") {
				data = _bezierToPathData(_pathDataToBezier("M" + (e.getAttribute("x1") || 0) + "," + (e.getAttribute("y1") || 0) + " L" + (e.getAttribute("x2") || 0) + "," + (e.getAttribute("y2") || 0))); //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
			} else if (type === "polyline" || type === "polygon") {
				points = (e.getAttribute("points") + "").match(_numbersExp) || [];
				x = points.shift();
				y = points.shift();
				data = "M" + x + "," + y + " L" + points.join(",");
				if (type === "polygon") {
					data += "," + x + "," + y + "z";
				}
			}
			path.setAttribute("d", data);
			if (swap && e.parentNode) {
				e.parentNode.insertBefore(path, e);
				e.parentNode.removeChild(e);
			}
	
			return path;
		},
		    _parseShape = function _parseShape(shape, forcePath, target) {
			var isString = typeof shape === "string",
			    e,
			    type;
			if (!isString || _selectorExp.test(shape) || (shape.match(_numbersExp) || []).length < 3) {
				e = isString ? TweenLite.selector(shape) : shape && shape[0] ? shape : [shape]; //allow array-like objects like jQuery objects.
				if (e && e[0]) {
					e = e[0];
					type = e.nodeName.toUpperCase();
					if (forcePath && type !== "PATH") {
						//if we were passed an element (or selector text for an element) that isn't a path, convert it.
						e = _convertToPath(e, false);
						type = "PATH";
					}
					shape = e.getAttribute(type === "PATH" ? "d" : "points") || "";
					if (e === target) {
						//if the shape matches the target element, the user wants to revert to the original which should have been stored in the data-original attribute
						shape = e.getAttributeNS(null, "data-original") || shape;
					}
				} else {
					_log("WARNING: invalid morph to: " + shape);
					shape = false;
				}
			}
			return shape;
		},
		    _morphMessage = "Use MorphSVGPlugin.convertToPath(elementOrSelectorText) to convert to a path before morphing.",
		    MorphSVGPlugin = _gsScope._gsDefine.plugin({
			propName: "morphSVG",
			API: 2,
			global: true,
			version: "0.8.11",
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function init(target, value, tween, index) {
				var type, p, pt, shape, isPoly;
				if (typeof target.setAttribute !== "function") {
					return false;
				}
				if (typeof value === "function") {
					value = value(index, target);
				}
				type = target.nodeName.toUpperCase();
				isPoly = type === "POLYLINE" || type === "POLYGON";
				if (type !== "PATH" && !isPoly) {
					_log("WARNING: cannot morph a <" + type + "> SVG element. " + _morphMessage);
					return false;
				}
				p = type === "PATH" ? "d" : "points";
				if (typeof value === "string" || value.getBBox || value[0]) {
					value = { shape: value };
				}
				shape = _parseShape(value.shape || value.d || value.points || "", p === "d", target);
				if (isPoly && _commands.test(shape)) {
					_log("WARNING: a <" + type + "> cannot accept path data. " + _morphMessage);
					return false;
				}
				if (shape) {
					this._target = target;
					if (!target.getAttributeNS(null, "data-original")) {
						target.setAttributeNS(null, "data-original", target.getAttribute(p)); //record the original state in a data-original attribute so that we can revert to it later.
					}
					pt = this._addTween(target, "setAttribute", target.getAttribute(p) + "", shape + "", "morphSVG", false, p, _typeof(value.precompile) === "object" ? function (a) {
						a[0] = value.precompile[0];a[1] = value.precompile[1];
					} : p === "d" ? _buildPathFilter(value.shapeIndex, value.map || MorphSVGPlugin.defaultMap, value.precompile) : _buildPointsFilter(value.shapeIndex));
					if (pt) {
						this._overwriteProps.push("morphSVG");
						pt.end = shape;
						pt.endProp = p;
					}
				}
				return true;
			},
	
			set: function set(ratio) {
				var pt;
				this._super.setRatio.call(this, ratio);
				if (ratio === 1) {
					pt = this._firstPT;
					while (pt) {
						if (pt.end) {
							this._target.setAttribute(pt.endProp, pt.end); //make sure the end value is exactly as specified (in case we had to add fabricated points during the tween)
						}
						pt = pt._next;
					}
				}
			}
	
		});
	
		MorphSVGPlugin.pathFilter = _pathFilter;
		MorphSVGPlugin.pointsFilter = _pointsFilter;
		MorphSVGPlugin.subdivideRawBezier = _subdivideBezier;
		MorphSVGPlugin.defaultMap = "size";
		MorphSVGPlugin.pathDataToRawBezier = function (data) {
			return _pathDataToBezier(_parseShape(data, true));
		};
		MorphSVGPlugin.equalizeSegmentQuantity = _equalizeSegmentQuantity;
	
		MorphSVGPlugin.convertToPath = function (targets, swap) {
			if (typeof targets === "string") {
				targets = TweenLite.selector(targets);
			}
			var a = !targets || targets.length === 0 ? [] : targets.length && targets[0] && targets[0].nodeType ? Array.prototype.slice.call(targets, 0) : [targets],
			    i = a.length;
			while (--i > -1) {
				a[i] = _convertToPath(a[i], swap !== false);
			}
			return a;
		};
	
		MorphSVGPlugin.pathDataToBezier = function (data, vars) {
			//converts SVG path data into an array of {x, y} objects that can be plugged directly into a bezier tween. You can optionally pass in a 2D matrix like [a, b, c, d, tx, ty] containing numbers that should transform each point.
			var bezier = _pathDataToBezier(_parseShape(data, true))[0] || [],
			    prefix = 0,
			    a,
			    i,
			    l,
			    matrix,
			    offsetX,
			    offsetY,
			    bbox,
			    e;
			vars = vars || {};
			e = vars.align || vars.relative;
			matrix = vars.matrix || [1, 0, 0, 1, 0, 0];
			offsetX = vars.offsetX || 0;
			offsetY = vars.offsetY || 0;
			if (e === "relative" || e === true) {
				offsetX -= bezier[0] * matrix[0] + bezier[1] * matrix[2];
				offsetY -= bezier[0] * matrix[1] + bezier[1] * matrix[3];
				prefix = "+=";
			} else {
				offsetX += matrix[4];
				offsetY += matrix[5];
				if (e) {
					e = typeof e === "string" ? TweenLite.selector(e) : e && e[0] ? e : [e]; //allow array-like objects like jQuery objects.
					if (e && e[0]) {
						bbox = e[0].getBBox() || { x: 0, y: 0 };
						offsetX -= bbox.x;
						offsetY -= bbox.y;
					}
				}
			}
			a = [];
			l = bezier.length;
			if (matrix && matrix.join(",") !== "1,0,0,1,0,0") {
				for (i = 0; i < l; i += 2) {
					a.push({ x: prefix + (bezier[i] * matrix[0] + bezier[i + 1] * matrix[2] + offsetX), y: prefix + (bezier[i] * matrix[1] + bezier[i + 1] * matrix[3] + offsetY) });
				}
			} else {
				for (i = 0; i < l; i += 2) {
					a.push({ x: prefix + (bezier[i] + offsetX), y: prefix + (bezier[i + 1] + offsetY) });
				}
			}
			return a;
		};
	});if (_gsScope._gsDefine) {
		_gsScope._gsQueue.pop()();
	}
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function (name) {
		"use strict";
	
		var getGlobal = function getGlobal() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof module !== "undefined" && module.exports) {
			//node
			__webpack_require__(16);
			module.exports = getGlobal();
		} else if (true) {
			//AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	})("MorphSVGPlugin");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var SwipeListener = function SwipeListener(element, options) {
	  if (!element) return;
	
	  // CustomEvent polyfill
	  if (typeof window !== 'undefined') {
	    (function () {
	      if (typeof window.CustomEvent === 'function') return false;
	      function CustomEvent(event, params) {
	        params = params || {
	          bubbles: false,
	          cancelable: false,
	          detail: undefined
	        };
	        var evt = document.createEvent('CustomEvent');
	        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	        return evt;
	      }
	      CustomEvent.prototype = window.Event.prototype;
	      window.CustomEvent = CustomEvent;
	    })();
	  }
	
	  var defaultOpts = {
	    minHorizontal: 10, // Minimum number of pixels traveled to count as a horizontal swipe.
	    minVertical: 10, // Minimum number of pixels traveled to count as a vertical swipe.
	    deltaHorizontal: 3, // Delta for horizontal swipe
	    deltaVertical: 5, // Delta for vertical swipe
	    preventScroll: false, // Prevents scrolling when swiping.
	    lockAxis: true // Select only one axis to be true instead of multiple.
	  };
	
	  // Set options
	  if (!options) {
	    options = {};
	  }
	  options = _extends({}, defaultOpts, options);
	
	  // Store the touches
	  var touches = [];
	
	  // Not dragging by default.
	  var dragging = false;
	
	  // When mouse-click is started, make dragging true.
	  var _mousedown = function _mousedown(e) {
	    dragging = true;
	  };
	  element.addEventListener('mousedown', _mousedown);
	
	  // When mouse-click is released, make dragging false and signify end by imitating `touchend`.
	  var _mouseup = function _mouseup(e) {
	    dragging = false;
	    _touchend(e);
	  };
	  element.addEventListener('mouseup', _mouseup);
	
	  // When mouse is moved while being clicked, imitate a `touchmove`.
	  var _mousemove = function _mousemove(e) {
	    if (dragging) {
	      e.changedTouches = [{
	        clientX: e.clientX,
	        clientY: e.clientY
	      }];
	      _touchmove(e);
	    }
	  };
	  element.addEventListener('mousemove', _mousemove);
	
	  // When the swipe is completed, calculate the direction.
	  var _touchend = function _touchend(e) {
	    if (!touches.length) return;
	
	    var x = [],
	        y = [];
	
	    var directions = {
	      top: false,
	      right: false,
	      bottom: false,
	      left: false
	    };
	
	    for (var i = 0; i < touches.length; i++) {
	      x.push(touches[i].x);
	      y.push(touches[i].y);
	    }
	
	    var xs = x[0],
	        xe = x[x.length - 1],
	        // Start and end x-coords
	    ys = y[0],
	        ye = y[y.length - 1]; // Start and end y-coords
	
	    var eventCoords = {
	      x: [xs, xe],
	      y: [ys, ye]
	    };
	
	    if (touches.length > 1) {
	      var swipeReleaseEventData = {
	        detail: eventCoords
	      };
	
	      var swipeReleaseEvent = new CustomEvent('swiperelease', swipeReleaseEventData);
	      element.dispatchEvent(swipeReleaseEvent);
	    }
	
	    // Determine left or right
	    var diff = x[0] - x[x.length - 1];
	    var swipe = 'none';
	    if (diff > 0) {
	      swipe = 'left';
	    } else {
	      swipe = 'right';
	    }
	
	    var min = Math.min.apply(Math, x),
	        max = Math.max.apply(Math, x),
	        _diff = void 0;
	
	    // If minimum horizontal distance was travelled
	    if (Math.abs(diff) >= options.minHorizontal) {
	      switch (swipe) {
	        case 'left':
	          _diff = Math.abs(min - x[x.length - 1]);
	          if (_diff <= options.deltaHorizontal) {
	            directions.left = true;
	          }
	          break;
	        case 'right':
	          _diff = Math.abs(max - x[x.length - 1]);
	          if (_diff <= options.deltaHorizontal) {
	            directions.right = true;
	          }
	          break;
	      }
	    }
	
	    // Determine top or bottom
	    diff = y[0] - y[y.length - 1];
	    swipe = 'none';
	    if (diff > 0) {
	      swipe = 'top';
	    } else {
	      swipe = 'bottom';
	    }
	
	    min = Math.min.apply(Math, y);
	    max = Math.max.apply(Math, y);
	
	    // If minimum vertical distance was travelled
	    if (Math.abs(diff) >= options.minVertical) {
	      switch (swipe) {
	        case 'top':
	          _diff = Math.abs(min - y[y.length - 1]);
	          if (_diff <= options.deltaVertical) {
	            directions.top = true;
	          }
	          break;
	        case 'bottom':
	          _diff = Math.abs(max - y[y.length - 1]);
	          if (_diff <= options.deltaVertical) {
	            directions.bottom = true;
	          }
	          break;
	      }
	    }
	
	    // Clear touches array.
	    touches = [];
	
	    // If there is a swipe direction, emit an event.
	    if (directions.top || directions.right || directions.bottom || directions.left) {
	      /**
	       * If lockAxis is true, determine which axis to select.
	       * The axis with the most travel is selected.
	       * TODO: Factor in for the orientation of the device
	       * and use it as a weight to determine the travel along an axis.
	       */
	      if (options.lockAxis) {
	        if ((directions.left || directions.right) && Math.abs(xs - xe) > Math.abs(ys - ye)) {
	          directions.top = directions.bottom = false;
	        } else if ((directions.top || directions.bottom) && Math.abs(xs - xe) < Math.abs(ys - ye)) {
	          directions.left = directions.right = false;
	        }
	      }
	
	      var eventData = {
	        detail: _extends({
	          directions: directions
	        }, eventCoords)
	      };
	
	      var event = new CustomEvent('swipe', eventData);
	      element.dispatchEvent(event);
	    } else {
	      var cancelEvent = new CustomEvent('swipecancel', {
	        detail: eventCoords
	      });
	      element.dispatchEvent(cancelEvent);
	    }
	  };
	
	  // When a swipe is performed, store the coords.
	  var _touchmove = function _touchmove(e) {
	    if (options.preventScroll) {
	      e.preventDefault();
	    }
	    var touch = e.changedTouches[0];
	    touches.push({
	      x: touch.clientX,
	      y: touch.clientY
	    });
	
	    // Emit a `swiping` event if there are more than one touch-points.
	    if (touches.length > 1) {
	      var xs = touches[0].x,
	          // Start and end x-coords
	      xe = touches[touches.length - 1].x,
	          ys = touches[0].y,
	          // Start and end y-coords
	      ye = touches[touches.length - 1].y,
	          eventData = {
	        detail: {
	          x: [xs, xe],
	          y: [ys, ye]
	        }
	      };
	      var event = new CustomEvent('swiping', eventData);
	      element.dispatchEvent(event);
	    }
	  };
	
	  // Test via a getter in the options object to see if the passive property is accessed
	  var passiveOptions = false;
	  try {
	    var testOptions = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        passiveOptions = { passive: !options.preventScroll };
	      }
	    });
	    window.addEventListener('testPassive', null, testOptions);
	    window.removeEventListener('testPassive', null, testOptions);
	  } catch (e) {}
	
	  element.addEventListener('touchmove', _touchmove, passiveOptions);
	  element.addEventListener('touchend', _touchend);
	
	  return {
	    off: function off() {
	      element.removeEventListener('touchmove', _touchmove, passiveOptions);
	      element.removeEventListener('touchend', _touchend);
	      element.removeEventListener('mousedown', _mousedown);
	      element.removeEventListener('mouseup', _mouseup);
	      element.removeEventListener('mousemove', _mousemove);
	    }
	  };
	};
	
	module.exports = SwipeListener;

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"playPauseButton":"src-components-ui----PlayPauseButton-module---playPauseButton---2kFGi","playPauseBackground":"src-components-ui----PlayPauseButton-module---playPauseBackground---1IcCm","playPauseLarge":"src-components-ui----PlayPauseButton-module---playPauseLarge---z_qtV","color-red":"src-components-ui----PlayPauseButton-module---color-red---3PlYW","color-blue":"src-components-ui----PlayPauseButton-module---color-blue---YFr-B","color-yellow":"src-components-ui----PlayPauseButton-module---color-yellow---3oOaE","color-green":"src-components-ui----PlayPauseButton-module---color-green---2Ugyl","fadeIn":"src-components-ui----PlayPauseButton-module---fadeIn---hJgSk","fadeInUp":"src-components-ui----PlayPauseButton-module---fadeInUp---CFhFT","fadeInUpCenter":"src-components-ui----PlayPauseButton-module---fadeInUpCenter---2NweF","fadeInUpSmall":"src-components-ui----PlayPauseButton-module---fadeInUpSmall---1m3jW","textCoverIn":"src-components-ui----PlayPauseButton-module---textCoverIn---1P0rg","textCoverOut":"src-components-ui----PlayPauseButton-module---textCoverOut---2o-vA"};

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 0.2.1
	 * DATE: 2018-02-15
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * PixiPlugin is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 *
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = (typeof module !== "undefined" && module.exports && typeof global !== "undefined") ? global : this || window;
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
	    "use strict";
	
	    var _numExp = /(\d|\.)+/g,
			_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
			_colorLookup = {aqua:[0,255,255],
				lime:[0,255,0],
				silver:[192,192,192],
				black:[0,0,0],
				maroon:[128,0,0],
				teal:[0,128,128],
				blue:[0,0,255],
				navy:[0,0,128],
				white:[255,255,255],
				fuchsia:[255,0,255],
				olive:[128,128,0],
				yellow:[255,255,0],
				orange:[255,165,0],
				gray:[128,128,128],
				purple:[128,0,128],
				green:[0,128,0],
				red:[255,0,0],
				pink:[255,192,203],
				cyan:[0,255,255],
				transparent:[255,255,255,0]},
			_hue = function(h, m1, m2) {
				h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
				return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
			},
			/**
			 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if "format" parameter is "hsl", it will populate the array with hue, saturation, and lightness values. Or if "format" is "number", it'll return a number like 0xFF0000 instead of an array. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
			 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
			 * @param {(string)} format If "hsl", an hsl() or hsla() value will be returned instead of rgb() or rgba(). Or if "number", then a numeric value will be returned, like 0xFF0000. Default is rgb.
			 * @return {(array|number)} An array containing red, green, and blue (and optionally alpha) in that order, or if the format parameter was "hsl", the array will contain hue, saturation and lightness (and optionally alpha) in that order. Or if "format" is defined as "number", it'll return a number like 0xFF0000. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and "format" is "hsl".
			 */
			_parseColor = function(v, format) {
				var toHSL = (format === "hsl"),
					a, r, g, b, h, s, l, max, min, d, wasHSL;
				if (!v) {
					a = _colorLookup.black;
				} else if (typeof(v) === "number") {
					a = [v >> 16, (v >> 8) & 255, v & 255];
				} else {
					if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
						v = v.substr(0, v.length - 1);
					}
					if (_colorLookup[v]) {
						a = _colorLookup[v];
					} else if (v.charAt(0) === "#") {
						if (v.length === 4) { //for shorthand like #9F0
							r = v.charAt(1);
							g = v.charAt(2);
							b = v.charAt(3);
							v = "#" + r + r + g + g + b + b;
						}
						v = parseInt(v.substr(1), 16);
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else if (v.substr(0, 3) === "hsl") {
						a = wasHSL = v.match(_numExp);
						if (!toHSL) {
							h = (Number(a[0]) % 360) / 360;
							s = Number(a[1]) / 100;
							l = Number(a[2]) / 100;
							g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
							r = l * 2 - g;
							if (a.length > 3) {
								a[3] = Number(v[3]);
							}
							a[0] = _hue(h + 1 / 3, r, g);
							a[1] = _hue(h, r, g);
							a[2] = _hue(h - 1 / 3, r, g);
						} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
							return v.match(_relNumExp);
						}
					} else {
						a = v.match(_numExp) || _colorLookup.transparent;
					}
					a[0] = Number(a[0]);
					a[1] = Number(a[1]);
					a[2] = Number(a[2]);
					if (a.length > 3) {
						a[3] = Number(a[3]);
					}
				}
				if (toHSL && !wasHSL) {
					r = a[0] / 255;
					g = a[1] / 255;
					b = a[2] / 255;
					max = Math.max(r, g, b);
					min = Math.min(r, g, b);
					l = (max + min) / 2;
					if (max === min) {
						h = s = 0;
					} else {
						d = max - min;
						s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
						h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
						h *= 60;
					}
					a[0] = (h + 0.5) | 0;
					a[1] = (s * 100 + 0.5) | 0;
					a[2] = (l * 100 + 0.5) | 0;
				}
				return (format === "number") ? (a[0] << 16 | a[1] << 8 | a[2]) : a;
			},
			_formatColors = function(s, toHSL) {
				var colors = (s + "").match(_colorExp) || [],
					charIndex = 0,
					parsed = "",
					i, color, temp;
				if (!colors.length) {
					return s;
				}
				for (i = 0; i < colors.length; i++) {
					color = colors[i];
					temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
					charIndex += temp.length + color.length;
					color = _parseColor(color, (toHSL ? "hsl" : "rgb"));
					if (color.length === 3) {
						color.push(1);
					}
					parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
				}
				return parsed + s.substr(charIndex);
			}, _colorStringFilter,
			TweenLite = (_gsScope.GreenSockGlobals || _gsScope).TweenLite,
			_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			_idMatrix = [1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0],
			_lumR = 0.212671,
			_lumG = 0.715160,
			_lumB = 0.072169,
	
			_applyMatrix = function(m, m2) {
				var temp = [],
					i = 0,
					z = 0,
					y, x;
				for (y = 0; y < 4; y++) {
					for (x = 0; x < 5; x++) {
						z = (x === 4) ? m[i + 4] : 0;
						temp[i + x] = m[i]   * m2[x] + m[i+1] * m2[x + 5] +	m[i+2] * m2[x + 10] + m[i+3] * m2[x + 15] +	z;
					}
					i += 5;
				}
				return temp;
			},
	
			_setSaturation = function(m, n) {
				var inv = 1 - n,
					r = inv * _lumR,
					g = inv * _lumG,
					b = inv * _lumB;
				return _applyMatrix([r + n, g, b, 0, 0, r, g + n, b, 0, 0, r, g, b + n, 0, 0, 0, 0, 0, 1, 0], m);
			},
	
			_colorize = function(m, color, amount) {
				var c = _parseColor(color),
					r = c[0] / 255,
					g = c[1] / 255,
					b = c[2] / 255,
					inv = 1 - amount;
				return _applyMatrix([inv + amount * r * _lumR, amount * r * _lumG, amount * r * _lumB, 0, 0, amount * g * _lumR, inv + amount * g * _lumG, amount * g * _lumB, 0, 0, amount * b * _lumR, amount * b * _lumG, inv + amount * b * _lumB, 0, 0, 0, 0, 0, 1, 0], m);
			},
	
			_setHue = function(m, n) {
				n *= Math.PI / 180;
				var c = Math.cos(n),
					s = Math.sin(n);
				return _applyMatrix([(_lumR + (c * (1 - _lumR))) + (s * (-_lumR)), (_lumG + (c * (-_lumG))) + (s * (-_lumG)), (_lumB + (c * (-_lumB))) + (s * (1 - _lumB)), 0, 0, (_lumR + (c * (-_lumR))) + (s * 0.143), (_lumG + (c * (1 - _lumG))) + (s * 0.14), (_lumB + (c * (-_lumB))) + (s * -0.283), 0, 0, (_lumR + (c * (-_lumR))) + (s * (-(1 - _lumR))), (_lumG + (c * (-_lumG))) + (s * _lumG), (_lumB + (c * (1 - _lumB))) + (s * _lumB), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], m);
			},
	
			_setContrast = function(m, n) {
				return _applyMatrix([n,0,0,0,0.5 * (1 - n), 0,n,0,0,0.5 * (1 - n), 0,0,n,0,0.5 * (1 - n), 0,0,0,1,0], m);
			},
	
			_getFilter = function(t, type) {
				var filterClass = _gsScope.PIXI.filters[type],
					filters = t.filters || [],
					i = filters.length,
					filter;
				if (!filterClass) {
					throw("PixiPlugin error: " + type + " isn't present.");
				}
				while (--i > -1) {
					if (filters[i] instanceof filterClass) {
						return filters[i];
					}
				}
				filter = new filterClass();
				if (type === "BlurFilter") {
					filter.blur = 0;
				}
				filters.push(filter);
				t.filters = filters;
				return filter;
			},
	
			_addColorMatrixFilterCacheTween = function(p, pg, cache, vars) { //we cache the ColorMatrixFilter components in a _gsColorMatrixFilter object attached to the target object so that it's easy to grab the current value at any time.
				pg._addTween(cache, p, cache[p], vars[p], p);
				pg._overwriteProps.push(p);
			},
	
			_applyBrightnessToMatrix = function(brightness, matrix) {
				var temp = new _gsScope.PIXI.filters.ColorMatrixFilter();
				temp.matrix = matrix;
				temp.brightness(brightness, true);
				return temp.matrix;
			},
	
			_CMFdefaults = {contrast:1, saturation:1, colorizeAmount:0, colorize:"rgb(255,255,255)", hue:0, brightness:1},
	
			_parseColorMatrixFilter = function(t, v, pg) {
				var filter = _getFilter(t, "ColorMatrixFilter"),
					cache = t._gsColorMatrixFilter = t._gsColorMatrixFilter || {contrast:1, saturation:1, colorizeAmount:0, colorize:"rgb(255,255,255)", hue:0, brightness:1},
					combine = v.combineCMF && !("colorMatrixFilter" in v && !v.colorMatrixFilter),
					i, matrix, startMatrix;
				startMatrix = filter.matrix;
				if (v.resolution) {
					filter.resolution = v.resolution;
				}
				if (v.matrix && v.matrix.length === startMatrix.length) {
					matrix = v.matrix;
					if (cache.contrast !== 1) {
						_addColorMatrixFilterCacheTween("contrast", pg, cache, _CMFdefaults);
					}
					if (cache.hue) {
						_addColorMatrixFilterCacheTween("hue", pg, cache, _CMFdefaults);
					}
					if (cache.brightness !== 1) {
						_addColorMatrixFilterCacheTween("brightness", pg, cache, _CMFdefaults);
					}
					if (cache.colorizeAmount) {
						_addColorMatrixFilterCacheTween("colorize", pg, cache, _CMFdefaults);
						_addColorMatrixFilterCacheTween("colorizeAmount", pg, cache, _CMFdefaults);
					}
					if (cache.saturation !== 1) {
						_addColorMatrixFilterCacheTween("saturation", pg, cache, _CMFdefaults);
					}
	
				} else {
					matrix = _idMatrix.slice();
					if (v.contrast != null) {
						matrix = _setContrast(matrix, Number(v.contrast));
						_addColorMatrixFilterCacheTween("contrast", pg, cache, v);
					} else if (cache.contrast !== 1) {
						if (combine) {
							matrix = _setContrast(matrix, cache.contrast);
						} else {
							_addColorMatrixFilterCacheTween("contrast", pg, cache, _CMFdefaults);
						}
					}
					if (v.hue != null) {
						matrix = _setHue(matrix, Number(v.hue));
						_addColorMatrixFilterCacheTween("hue", pg, cache, v);
					} else if (cache.hue) {
						if (combine) {
							matrix = _setHue(matrix, cache.hue);
						} else {
							_addColorMatrixFilterCacheTween("hue", pg, cache, _CMFdefaults);
						}
					}
					if (v.brightness != null) {
						matrix = _applyBrightnessToMatrix(Number(v.brightness), matrix);
						_addColorMatrixFilterCacheTween("brightness", pg, cache, v);
					} else if (cache.brightness !== 1) {
						if (combine) {
							matrix = _applyBrightnessToMatrix(cache.brightness, matrix);
						} else {
							_addColorMatrixFilterCacheTween("brightness", pg, cache, _CMFdefaults);
						}
					}
					if (v.colorize != null) {
						v.colorizeAmount = ("colorizeAmount" in v) ? Number(v.colorizeAmount) : 1;
						matrix = _colorize(matrix, v.colorize, v.colorizeAmount);
						_addColorMatrixFilterCacheTween("colorize", pg, cache, v);
						_addColorMatrixFilterCacheTween("colorizeAmount", pg, cache, v);
					} else if (cache.colorizeAmount) {
						if (combine) {
							matrix = _colorize(matrix, cache.colorize, cache.colorizeAmount);
						} else {
							_addColorMatrixFilterCacheTween("colorize", pg, cache, _CMFdefaults);
							_addColorMatrixFilterCacheTween("colorizeAmount", pg, cache, _CMFdefaults);
						}
					}
					if (v.saturation != null) {
						matrix = _setSaturation(matrix, Number(v.saturation));
						_addColorMatrixFilterCacheTween("saturation", pg, cache, v);
					} else if (cache.saturation !== 1) {
						if (combine) {
							matrix = _setSaturation(matrix, cache.saturation);
						} else {
							_addColorMatrixFilterCacheTween("saturation", pg, cache, _CMFdefaults);
						}
					}
				}
				i = matrix.length;
				while (--i > -1) {
					if (matrix[i] !== startMatrix[i]) {
						pg._addTween(startMatrix, i, startMatrix[i], matrix[i], "colorMatrixFilter");
					}
				}
				pg._overwriteProps.push("colorMatrixFilter");
			},
	
			_addColorTween = function(target, p, value, colorSetter, plugin) {
				var pt = colorSetter._firstPT = {_next:colorSetter._firstPT, t:target, p:p, proxy:{}, f:(typeof(target[p]) === "function")};
				pt.proxy[p] = "rgb(" + _parseColor(!pt.f ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]()).join(",") + ")";
				plugin._addTween(pt.proxy, p, "get", ((typeof(value) === "number") ? "rgb(" + _parseColor(value, false).join(",") + ")" : value), p, null, null, _colorStringFilter);
			},
	
			//to improve performance, when a color is sensed, we hijack the setRatio() method of the plugin instance with a new function that this method spits back. This is a special method that handles parsing color values on-the-fly and turns them into numeric values which PixiJS requires. In other words, instead of "rgb(255, 0, 0)", PixiJS wants 0xFF0000. This also works with hsl() values.
			_buildColorSetter = function(tween, plugin) {
				var setRatio = plugin.setRatio, //save the original (super) setRatio() function
					func = function(v) {
						var pt = func._firstPT,
							val;
						setRatio.call(plugin, v);
						while (pt) {
							val = _parseColor(pt.proxy[pt.p], "number");
							if (pt.f) {
								pt.t[pt.p](val);
							} else {
								pt.t[pt.p] = val;
							}
							pt = pt._next;
						}
						if (func.graphics) { //in order for PixiJS to actually redraw GraphicsData, we've gotta increment the "dirty" and "clearDirty" values. If we don't do this, the values will be tween properly, but not rendered.
							func.graphics.dirty++;
							func.graphics.clearDirty++;
						}
					};
				plugin.setRatio = func;
				return func;
			},
	
	
			_colorProps = {tint:1, lineColor:1, fillColor:1},
			_xyContexts = "position,scale,skew,pivot,anchor,tilePosition,tileScale".split(","),
			_contexts = {x:"position", y:"position", tileX:"tilePosition", tileY:"tilePosition"},
			_colorMatrixFilterProps = {colorMatrixFilter:1, saturation:1, contrast:1, hue:1, colorize:1, colorizeAmount:1, brightness:1, combineCMF:1},
			_DEG2RAD = Math.PI / 180,
	        _degreesToRadians = function(value) {
				return (typeof(value) === "string" && value.charAt(1) === "=") ? value.substr(0, 2) + (parseFloat(value.substr(2)) * _DEG2RAD) : value * _DEG2RAD;
	        }, i, p;
	
		//context setup...
		for (i = 0; i < _xyContexts.length; i++) {
			p = _xyContexts[i];
			_contexts[p + "X"] = p;
			_contexts[p + "Y"] = p;
	    }
	
	    //color parsing setup...
		for (p in _colorLookup) {
			_colorExp += "|" + p + "\\b";
		}
		_colorExp = new RegExp(_colorExp+")", "gi");
		_colorStringFilter = function(a) {
			var combined = a[0] + " " + a[1],
				toHSL;
			_colorExp.lastIndex = 0;
			if (_colorExp.test(combined)) {
				toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
				a[0] = _formatColors(a[0], toHSL);
				a[1] = _formatColors(a[1], toHSL);
			}
		};
	
		if (!TweenLite.defaultStringFilter) {
			TweenLite.defaultStringFilter = _colorStringFilter;
		}
	
	    var PixiPlugin = _gsScope._gsDefine.plugin({
	        propName: "pixi",
	        priority: 0,
	        API: 2,
			global: true,
	        version: "0.2.1",
	
	        init: function (target, values, tween, index) {
	            if (!target instanceof _gsScope.PIXI.DisplayObject) {
	                return false;
	            }
	            var context, axis, value, colorMatrix, filter, p, padding, colorSetter, i, data, pt;
	            for (p in values) {
	                context = _contexts[p];
	                value = values[p];
	                if (typeof(value) === "function") {
	                    value = value(index || 0, target);
	                }
	                if (context) {
	                    axis = (p.charAt(p.length-1).toLowerCase().indexOf("x") !== -1) ? "x" : "y";
						this._addTween(target[context], axis, target[context][axis], (context === "skew") ? _degreesToRadians(value) : value, p);
	                } else if (p === "scale" || p === "anchor" || p === "pivot" || p === "tileScale") {
						this._addTween(target[p], "x", target[p].x, value, p + "X");
						this._addTween(target[p], "y", target[p].y, value, p + "Y");
	                } else if (p === "rotation") { //PIXI expects rotation in radians, but as a convenience we let folks define it in degrees and we do the conversion.
						this._addTween(target, p, target.rotation, _degreesToRadians(value), p);
	
	                } else if (_colorMatrixFilterProps[p]) {
						if (!colorMatrix) {
							_parseColorMatrixFilter(target, values.colorMatrixFilter || values, this);
							colorMatrix = true;
						}
	                } else if (p === "blur" || p === "blurX" || p === "blurY" || p === "blurPadding") {
						filter = _getFilter(target, "BlurFilter");
						this._addTween(filter, p, filter[p], value, p);
						if (values.blurPadding !== 0) {
							padding = values.blurPadding || Math.max(filter[p], value) * 2;
							i = target.filters.length;
							while (--i > -1) {
								target.filters[i].padding = Math.max(target.filters[i].padding, padding); //if we don't expand the padding on all the filters, it can look clipped.
							}
						}
	                } else if (_colorProps[p]) {
						if (!colorSetter) {
							colorSetter = _buildColorSetter(tween, this);
						}
						if ((p === "lineColor" || p === "fillColor") && target instanceof _gsScope.PIXI.Graphics) {
							data = target.graphicsData;
							i = data.length;
							while (--i > -1) {
								_addColorTween(data[i], p, value, colorSetter, this);
							}
							colorSetter.graphics = target;
						} else {
							_addColorTween(target, p, value, colorSetter, this);
						}
	                } else if (p === "autoAlpha") {
						this._firstPT = pt = {t: {setRatio:function() { target.visible = !!target.alpha; }}, p: "setRatio", s: 0, c: 1, f: 1, pg: 0, n: "visible", pr: 0, m: 0, _next:this._firstPT};
						if (pt._next) {
							pt._next._prev = pt;
						}
						this._addTween(target, "alpha", target.alpha, value, "alpha");
						this._overwriteProps.push("alpha", "visible");
	                } else {
						this._addTween(target, p, target[p], value, p);
	                }
					this._overwriteProps.push(p);
	            }
	            return true;
	        }
	    });
	
		PixiPlugin.colorProps = _colorProps;
		PixiPlugin.parseColor = _parseColor;
		PixiPlugin.formatColors = _formatColors;
		PixiPlugin.colorStringFilter = _colorStringFilter;
	
	
	}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }
	
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function(name) {
		"use strict";
		var getGlobal = function() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof(module) !== "undefined" && module.exports) { //node
			__webpack_require__(16);
			module.exports = getGlobal();
		} else if (true) { //AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	}("PixiPlugin"));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30.66 24.21" },
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "title",
	      null,
	      "Quote Matks"
	    ),
	    _react2.default.createElement("path", {
	      fill: "#d6434f",
	      d: "M13.66,18.42a5.78,5.78,0,0,1-.82,3.08,5.46,5.46,0,0,1-2.2,2,6.43,6.43,0,0,1-2.91.7,7.2,7.2,0,0,1-5.26-2.64C.82,19.81,0,17.35,0,14.17A13.84,13.84,0,0,1,3.42,4.69Q6.86.8,13.15,0V3.37A14.36,14.36,0,0,0,6.57,6.21a6.52,6.52,0,0,0-2.51,5.25q0,1.8,1.29,1.8a17.94,17.94,0,0,1,3-.37A5.2,5.2,0,0,1,12,14.46,5.28,5.28,0,0,1,13.66,18.42Z"
	    }),
	    _react2.default.createElement("path", {
	      fill: "#d6434f",
	      d: "M30.66,18.42a5.78,5.78,0,0,1-.82,3.08,5.46,5.46,0,0,1-2.2,2,6.43,6.43,0,0,1-2.91.7,7.2,7.2,0,0,1-5.26-2.64C17.82,19.81,17,17.35,17,14.17a13.84,13.84,0,0,1,3.42-9.48Q23.86.8,30.15,0V3.37a14.36,14.36,0,0,0-6.58,2.84,6.52,6.52,0,0,0-2.51,5.25q0,1.8,1.29,1.8a17.94,17.94,0,0,1,3-.37A5.2,5.2,0,0,1,29,14.46,5.28,5.28,0,0,1,30.66,18.42Z"
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadImage = __webpack_require__(187);
	
	var _loadImage2 = _interopRequireDefault(_loadImage);
	
	var _ScreenedImageCoverModule = __webpack_require__(405);
	
	var _ScreenedImageCoverModule2 = _interopRequireDefault(_ScreenedImageCoverModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScreenedImageCover = function (_Component) {
	  _inherits(ScreenedImageCover, _Component);
	
	  function ScreenedImageCover() {
	    _classCallCheck(this, ScreenedImageCover);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      loaded: false,
	      reveal: false
	    };
	    return _this;
	  }
	
	  ScreenedImageCover.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.startedLoad && prevProps.load !== this.props.load && this.props.load) {
	      this.load();
	    }
	  };
	
	  ScreenedImageCover.prototype.componentDidMount = function componentDidMount() {
	    // if no load prop, or its true, load
	    if (typeof this.props.load === 'undefined' || this.props.load) {
	      this.load();
	    }
	  };
	  // componentWillReceiveProps(nextProps) {
	  //   if (!this.startedLoad && !this.props.revealed && nextProps.revealed) {
	  //     this.load();
	  //   }
	  // }
	
	
	  ScreenedImageCover.prototype.load = function load() {
	    var _this2 = this;
	
	    this.startedLoad = true;
	    (0, _loadImage2.default)(this.props.url).then(function (img) {
	      _this2.setState({ loaded: true }, function () {
	        setTimeout(function () {
	          _this2.setState({ reveal: true });
	        }, 1);
	      });
	    });
	  };
	
	  ScreenedImageCover.prototype.render = function render() {
	    var display = this.state.reveal;
	
	    return _react2.default.createElement('div', {
	      className: _ScreenedImageCoverModule2.default.image,
	      style: {
	        backgroundImage: 'url(' + (this.state.loaded ? this.props.url : '') + ')',
	        opacity: this.state.reveal && !this.props.hide ? 1 : 0
	      }
	    });
	  };
	
	  return ScreenedImageCover;
	}(_react.Component);
	
	exports.default = ScreenedImageCover;
	module.exports = exports['default'];

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BackToChapterButtonModule = __webpack_require__(395);
	
	var _BackToChapterButtonModule2 = _interopRequireDefault(_BackToChapterButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackToChapterButton = function BackToChapterButton(_ref) {
	  var onChapterClose = _ref.onChapterClose,
	      onVideoClose = _ref.onVideoClose,
	      isPlaylistOpen = _ref.isPlaylistOpen,
	      isVideoOpen = _ref.isVideoOpen;
	
	  var handleChapterClose = function handleChapterClose() {
	    if (isPlaylistOpen) {
	      onChapterClose();
	    } else if (isVideoOpen) {
	      onVideoClose();
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'back-to-chapter ' + _BackToChapterButtonModule2.default.backToChapter,
	      style: { pointerEvents: isPlaylistOpen || isVideoOpen ? 'auto' : 'none' },
	      onClick: handleChapterClose
	    },
	    _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: '27',
	        height: '24',
	        viewBox: '0 0 27 24',
	        className: _BackToChapterButtonModule2.default.navArrow
	      },
	      _react2.default.createElement(
	        'title',
	        null,
	        'Left Arrow'
	      ),
	      _react2.default.createElement('polygon', { points: '3.891 10.946 26.267 10.946 26.267 12.592 3.917 12.592 13.92 22.171 12.776 23.267 .755 11.756 12.776 .245 13.92 1.341' }),
	      _react2.default.createElement('circle', { cx: '50%', cy: '50%', r: '50%' })
	    ),
	    'Back to the Chapter'
	  );
	};
	
	exports.default = BackToChapterButton;
	module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var plyr = void 0;
	
	var PlyrComponent = function (_Component) {
	  _inherits(PlyrComponent, _Component);
	
	  function PlyrComponent() {
	    _classCallCheck(this, PlyrComponent);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PlyrComponent.prototype.componentWillMount = function componentWillMount() {
	    var id = void 0;
	    if (this.props.videoData.vimeo_id) {
	      id = this.props.videoData.vimeo_id;
	    } else if (this.props.videoData.youtube_id) {
	      id = this.props.videoData.youtube_id;
	    } else if (this.props.videoData.video_file) {
	      id = this.props.videoData.video_file.id ? this.props.videoData.video_file.id : this.props.videoData.video_file.url;
	    }
	    this.videoId = id;
	  };
	
	  PlyrComponent.prototype.componentDidMount = function componentDidMount() {
	    if (typeof document !== 'undefined') {
	      plyr = __webpack_require__(285);
	    }
	    this.plyr = plyr.setup('#player-' + this.videoId, this.props.options);
	  };
	
	  PlyrComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.isVideoOpen !== this.props.isVideoOpen) {
	      if (this.props.isVideoOpen) {
	        this.plyr[0].play();
	      } else {
	        this.plyr[0].stop();
	      }
	    }
	  };
	
	  // plyr has a bug where destroy on unmount throws an error.
	  // we'll see if we run into any issue here.
	  // componentWillUnmount() {
	  //   if (this.plyr[0] && this.plyr[0].destroy) {
	  //     this.plyr[0].stop();
	  //     this.plyr[0].destroy();
	  //   }
	  // }
	
	  PlyrComponent.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { height: this.props.isChapter ? '100%' : '' } },
	      this.props.videoData.video_source === 'vimeo' && _react2.default.createElement(
	        'div',
	        { className: 'plyr__video-embed', id: 'player-' + this.videoId },
	        _react2.default.createElement('iframe', {
	          src: 'https://player.vimeo.com/video/' + this.videoId + '?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media',
	          allowFullScreen: true,
	          allowtransparency: 'true',
	          allow: 'autoplay'
	        })
	      ),
	      this.props.videoData.video_source === 'youtube' && _react2.default.createElement(
	        'div',
	        { className: 'plyr__video-embed', id: 'player-' + this.videoId },
	        _react2.default.createElement('iframe', {
	          src: 'https://www.youtube.com/embed/' + this.videoId + '?iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1',
	          allowFullScreen: true,
	          allowtransparency: 'true',
	          allow: 'autoplay'
	        })
	      ),
	      this.props.videoData.video_source === 'mp4_upload' && _react2.default.createElement(
	        'video',
	        {
	          poster: this.props.videoData.image.url,
	          id: 'player-' + this.videoId,
	          playsInline: true,
	          controls: true
	        },
	        _react2.default.createElement('source', {
	          src: this.props.videoData.video_file.url,
	          type: 'video/mp4'
	        })
	      )
	    );
	  };
	
	  return PlyrComponent;
	}(_react.Component);
	
	exports.default = PlyrComponent;
	module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlaylistButtonModule = __webpack_require__(400);
	
	var _PlaylistButtonModule2 = _interopRequireDefault(_PlaylistButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlaylistButton = function PlaylistButton(_ref) {
	  var handleMouseDown = _ref.handleMouseDown,
	      handleMouseUp = _ref.handleMouseUp,
	      registerProgressBar = _ref.registerProgressBar,
	      index = _ref.index,
	      allowScroll = _ref.allowScroll,
	      disallowScroll = _ref.disallowScroll;
	  return _react2.default.createElement(
	    'div',
	    { className: 'scaleDown playlist-button ' + _PlaylistButtonModule2.default.viewButtonWrapper },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'view-button ' + _PlaylistButtonModule2.default.viewButton,
	        onMouseDown: handleMouseDown,
	        onTouchStart: function onTouchStart(e) {
	          if (disallowScroll) {
	            disallowScroll();
	          }
	          handleMouseDown(e);
	        },
	        onMouseUp: handleMouseUp,
	        onTouchEnd: function onTouchEnd(e) {
	          if (allowScroll) {
	            allowScroll();
	          }
	          handleMouseUp(e);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _PlaylistButtonModule2.default.pulse },
	        _react2.default.createElement('div', { className: _PlaylistButtonModule2.default.pulseInner }),
	        _react2.default.createElement('div', { className: _PlaylistButtonModule2.default.pulseInner2 })
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        'HOLD'
	      )
	    ),
	    _react2.default.createElement(
	      'svg',
	      { xmlns: 'http://www.w3.org/2000/svg', className: _PlaylistButtonModule2.default.progressWrapper },
	      _react2.default.createElement('circle', { className: '' + _PlaylistButtonModule2.default.progressBar, cx: '50%', cy: '50%', r: '48%' }),
	      _react2.default.createElement('circle', {
	        className: _PlaylistButtonModule2.default.progress + ' view-button-progress progressBar' + index,
	        ref: function ref(el) {
	          return registerProgressBar(el, index);
	        },
	        cx: '50%',
	        cy: '50%',
	        r: '48%'
	      })
	    )
	  );
	};
	
	exports.default = PlaylistButton;
	module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var progressListener = function () {
	  function progressListener() {
	    _classCallCheck(this, progressListener);
	
	    this.callbacks = [];
	  }
	
	  progressListener.prototype.subscribe = function subscribe(callback) {
	    var _this = this;
	
	    this.callbacks.push(callback);
	    return function () {
	      _this.callbacks = _this.callbacks.filter(function (eventCallback) {
	        return eventCallback !== callback;
	      });
	    };
	  };
	
	  progressListener.prototype.progress = function progress(currentTime, duration) {
	    this.callbacks.forEach(function (fn) {
	      fn(currentTime, duration);
	    });
	  };
	
	  return progressListener;
	}();
	
	exports.default = new progressListener();
	module.exports = exports["default"];

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getCoverSize;
	// Given a frame size and image size, gets the scale, and x,y, coords
	// to match CSS background cover, background-position center
	function getCoverSize(frameSize, imgSize) {
	  var frameRatio = frameSize.width / frameSize.height;
	  var sourceRatio = imgSize.width / imgSize.height;
	  var scale = void 0,
	      transform = void 0;
	  if (frameRatio > sourceRatio) {
	    // frame wider
	    scale = frameSize.width / imgSize.width;
	    var imgHeight = imgSize.height * scale;
	    var imgY = -(imgHeight - frameSize.height) / 2;
	    transform = { x: 0 + frameSize.x, y: imgY + frameSize.y };
	  } else {
	    // image wider
	    scale = frameSize.height / imgSize.height;
	    var imgWidth = imgSize.width * scale;
	    var imgX = -(imgWidth - frameSize.width) / 2;
	    transform = { x: imgX + frameSize.x, y: 0 + frameSize.y };
	  }
	  return { scale: scale, transform: transform };
	}
	module.exports = exports["default"];

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var loadImage = function loadImage(url, loadCallback) {
	  return new Promise(function (resolve, reject) {
	    var image = new Image();
	    image.onload = function () {
	      if (loadCallback) {
	        loadCallback();
	      }
	      resolve(image);
	    };
	    image.onerror = function () {
	      var message = 'Could not load image at ' + url;
	      reject(url);
	    };
	    image.src = url;
	  });
	};
	
	exports.default = loadImage;
	module.exports = exports['default'];

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"storyTitle":"src-components-chapter----ChapterSectionPressPlay-module---storyTitle---2sYq0","sectionWrapper":"src-components-chapter----ChapterSectionPressPlay-module---sectionWrapper---3hQS0","playlistWrapper":"src-components-chapter----ChapterSectionPressPlay-module---playlistWrapper---TmsiL","storyIntro":"src-components-chapter----ChapterSectionPressPlay-module---storyIntro---xLggb","storyLabel":"src-components-chapter----ChapterSectionPressPlay-module---storyLabel---3PNpF","maskDownWrapper":"src-components-chapter----ChapterSectionPressPlay-module---maskDownWrapper---38GpE","storyWatermark":"src-components-chapter----ChapterSectionPressPlay-module---storyWatermark---3QSy2","storyInstructions":"src-components-chapter----ChapterSectionPressPlay-module---storyInstructions---oY-C-","introImage":"src-components-chapter----ChapterSectionPressPlay-module---introImage---372Ph","tourIntroImage":"src-components-chapter----ChapterSectionPressPlay-module---tourIntroImage---1iS88","currentPlaylistImage":"src-components-chapter----ChapterSectionPressPlay-module---currentPlaylistImage---2kzfR","inactivePlaylist":"src-components-chapter----ChapterSectionPressPlay-module---inactivePlaylist---2lT8v","activePlaylist":"src-components-chapter----ChapterSectionPressPlay-module---activePlaylist---rYra0 src-components-chapter----ChapterSectionPressPlay-module---inactivePlaylist---2lT8v","arrowWrap":"src-components-chapter----ChapterSectionPressPlay-module---arrowWrap---LEDaB","arrowWrapRight":"src-components-chapter----ChapterSectionPressPlay-module---arrowWrapRight---1Mgz_ src-components-chapter----ChapterSectionPressPlay-module---arrowWrap---LEDaB","fadeIn":"src-components-chapter----ChapterSectionPressPlay-module---fadeIn---2q3Nb","fadeInUp":"src-components-chapter----ChapterSectionPressPlay-module---fadeInUp---39mAB","fadeInUpCenter":"src-components-chapter----ChapterSectionPressPlay-module---fadeInUpCenter---2b4gD","fadeInUpSmall":"src-components-chapter----ChapterSectionPressPlay-module---fadeInUpSmall---3Gls6","textCoverIn":"src-components-chapter----ChapterSectionPressPlay-module---textCoverIn---3ouMK","textCoverOut":"src-components-chapter----ChapterSectionPressPlay-module---textCoverOut---2R3Cf"};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	var EMPTY_ARRAY_BUFFER = new ArrayBuffer(0);
	
	/**
	 * Helper class to create a webGL buffer
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param type {gl.ARRAY_BUFFER | gl.ELEMENT_ARRAY_BUFFER} @mat
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 * @param drawType {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
	 */
	var Buffer = function(gl, type, data, drawType)
	{
	
		/**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
		this.gl = gl;
	
		/**
	     * The WebGL buffer, created upon instantiation
	     *
	     * @member {WebGLBuffer}
	     */
		this.buffer = gl.createBuffer();
	
		/**
	     * The type of the buffer
	     *
	     * @member {gl.ARRAY_BUFFER|gl.ELEMENT_ARRAY_BUFFER}
	     */
		this.type = type || gl.ARRAY_BUFFER;
	
		/**
	     * The draw type of the buffer
	     *
	     * @member {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
	     */
		this.drawType = drawType || gl.STATIC_DRAW;
	
		/**
	     * The data in the buffer, as a typed array
	     *
	     * @member {ArrayBuffer| SharedArrayBuffer|ArrayBufferView}
	     */
		this.data = EMPTY_ARRAY_BUFFER;
	
		if(data)
		{
			this.upload(data);
		}
	
		this._updateID = 0;
	};
	
	/**
	 * Uploads the buffer to the GPU
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data to upload
	 * @param offset {Number} if only a subset of the data should be uploaded, this is the amount of data to subtract
	 * @param dontBind {Boolean} whether to bind the buffer before uploading it
	 */
	Buffer.prototype.upload = function(data, offset, dontBind)
	{
		// todo - needed?
		if(!dontBind) this.bind();
	
		var gl = this.gl;
	
		data = data || this.data;
		offset = offset || 0;
	
		if(this.data.byteLength >= data.byteLength)
		{
			gl.bufferSubData(this.type, offset, data);
		}
		else
		{
			gl.bufferData(this.type, data, this.drawType);
		}
	
		this.data = data;
	};
	/**
	 * Binds the buffer
	 *
	 */
	Buffer.prototype.bind = function()
	{
		var gl = this.gl;
		gl.bindBuffer(this.type, this.buffer);
	};
	
	Buffer.createVertexBuffer = function(gl, data, drawType)
	{
		return new Buffer(gl, gl.ARRAY_BUFFER, data, drawType);
	};
	
	Buffer.createIndexBuffer = function(gl, data, drawType)
	{
		return new Buffer(gl, gl.ELEMENT_ARRAY_BUFFER, data, drawType);
	};
	
	Buffer.create = function(gl, type, data, drawType)
	{
		return new Buffer(gl, type, data, drawType);
	};
	
	/**
	 * Destroys the buffer
	 *
	 */
	Buffer.prototype.destroy = function(){
		this.gl.deleteBuffer(this.buffer);
	};
	
	module.exports = Buffer;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	
	var Texture = __webpack_require__(91);
	
	/**
	 * Helper class to create a webGL Framebuffer
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 */
	var Framebuffer = function(gl, width, height)
	{
	    /**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    /**
	     * The frame buffer
	     *
	     * @member {WebGLFramebuffer}
	     */
	    this.framebuffer = gl.createFramebuffer();
	
	    /**
	     * The stencil buffer
	     *
	     * @member {WebGLRenderbuffer}
	     */
	    this.stencil = null;
	
	    /**
	     * The stencil buffer
	     *
	     * @member {PIXI.glCore.GLTexture}
	     */
	    this.texture = null;
	
	    /**
	     * The width of the drawing area of the buffer
	     *
	     * @member {Number}
	     */
	    this.width = width || 100;
	    /**
	     * The height of the drawing area of the buffer
	     *
	     * @member {Number}
	     */
	    this.height = height || 100;
	};
	
	/**
	 * Adds a texture to the frame buffer
	 * @param texture {PIXI.glCore.GLTexture}
	 */
	Framebuffer.prototype.enableTexture = function(texture)
	{
	    var gl = this.gl;
	
	    this.texture = texture || new Texture(gl);
	
	    this.texture.bind();
	
	    //gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	
	    this.bind();
	
	    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture.texture, 0);
	};
	
	/**
	 * Initialises the stencil buffer
	 */
	Framebuffer.prototype.enableStencil = function()
	{
	    if(this.stencil)return;
	
	    var gl = this.gl;
	
	    this.stencil = gl.createRenderbuffer();
	
	    gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
	
	    // TODO.. this is depth AND stencil?
	    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.stencil);
	    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,  this.width  , this.height );
	
	
	};
	
	/**
	 * Erases the drawing area and fills it with a colour
	 * @param  r {Number} the red value of the clearing colour
	 * @param  g {Number} the green value of the clearing colour
	 * @param  b {Number} the blue value of the clearing colour
	 * @param  a {Number} the alpha value of the clearing colour
	 */
	Framebuffer.prototype.clear = function( r, g, b, a )
	{
	    this.bind();
	
	    var gl = this.gl;
	
	    gl.clearColor(r, g, b, a);
	    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	};
	
	/**
	 * Binds the frame buffer to the WebGL context
	 */
	Framebuffer.prototype.bind = function()
	{
	    var gl = this.gl;
	    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer );
	};
	
	/**
	 * Unbinds the frame buffer to the WebGL context
	 */
	Framebuffer.prototype.unbind = function()
	{
	    var gl = this.gl;
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null );
	};
	/**
	 * Resizes the drawing area of the buffer to the given width and height
	 * @param  width  {Number} the new width
	 * @param  height {Number} the new height
	 */
	Framebuffer.prototype.resize = function(width, height)
	{
	    var gl = this.gl;
	
	    this.width = width;
	    this.height = height;
	
	    if ( this.texture )
	    {
	        this.texture.uploadData(null, width, height);
	    }
	
	    if ( this.stencil )
	    {
	        // update the stencil buffer width and height
	        gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
	        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
	    }
	};
	
	/**
	 * Destroys this buffer
	 */
	Framebuffer.prototype.destroy = function()
	{
	    var gl = this.gl;
	
	    //TODO
	    if(this.texture)
	    {
	        this.texture.destroy();
	    }
	
	    gl.deleteFramebuffer(this.framebuffer);
	
	    this.gl = null;
	
	    this.stencil = null;
	    this.texture = null;
	};
	
	/**
	 * Creates a frame buffer with a texture containing the given data
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 */
	Framebuffer.createRGBA = function(gl, width, height, data)
	{
	    var texture = Texture.fromData(gl, null, width, height);
	    texture.enableNearestScaling();
	    texture.enableWrapClamp();
	
	    //now create the framebuffer object and attach the texture to it.
	    var fbo = new Framebuffer(gl, width, height);
	    fbo.enableTexture(texture);
	    //fbo.enableStencil(); // get this back on soon!
	
	    //fbo.enableStencil(); // get this back on soon!
	
	    fbo.unbind();
	
	    return fbo;
	};
	
	/**
	 * Creates a frame buffer with a texture containing the given data
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 */
	Framebuffer.createFloat32 = function(gl, width, height, data)
	{
	    // create a new texture..
	    var texture = new Texture.fromData(gl, data, width, height);
	    texture.enableNearestScaling();
	    texture.enableWrapClamp();
	
	    //now create the framebuffer object and attach the texture to it.
	    var fbo = new Framebuffer(gl, width, height);
	    fbo.enableTexture(texture);
	
	    fbo.unbind();
	
	    return fbo;
	};
	
	module.exports = Framebuffer;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	
	var compileProgram = __webpack_require__(93),
		extractAttributes = __webpack_require__(95),
		extractUniforms = __webpack_require__(96),
		setPrecision = __webpack_require__(99),
		generateUniformAccessObject = __webpack_require__(97);
	
	/**
	 * Helper class to create a webGL Shader
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext}
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param precision {string} The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	 * @param attributeLocations {object} A key value pair showing which location eact attribute should sit eg {position:0, uvs:1}
	 */
	var Shader = function(gl, vertexSrc, fragmentSrc, precision, attributeLocations)
	{
		/**
		 * The current WebGL rendering context
		 *
		 * @member {WebGLRenderingContext}
		 */
		this.gl = gl;
	
		if(precision)
		{
			vertexSrc = setPrecision(vertexSrc, precision);
			fragmentSrc = setPrecision(fragmentSrc, precision);
		}
	
		/**
		 * The shader program
		 *
		 * @member {WebGLProgram}
		 */
		// First compile the program..
		this.program = compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations);
	
		/**
		 * The attributes of the shader as an object containing the following properties
		 * {
		 * 	type,
		 * 	size,
		 * 	location,
		 * 	pointer
		 * }
		 * @member {Object}
		 */
		// next extract the attributes
		this.attributes = extractAttributes(gl, this.program);
	
	    this.uniformData = extractUniforms(gl, this.program);
	
		/**
		 * The uniforms of the shader as an object containing the following properties
		 * {
		 * 	gl,
		 * 	data
		 * }
		 * @member {Object}
		 */
		this.uniforms = generateUniformAccessObject( gl, this.uniformData );
	
	};
	/**
	 * Uses this shader
	 * 
	 * @return {PIXI.glCore.GLShader} Returns itself.
	 */
	Shader.prototype.bind = function()
	{
		this.gl.useProgram(this.program);
		return this;
	};
	
	/**
	 * Destroys this shader
	 * TODO
	 */
	Shader.prototype.destroy = function()
	{
		this.attributes = null;
		this.uniformData = null;
		this.uniforms = null;
	
		var gl = this.gl;
		gl.deleteProgram(this.program);
	};
	
	
	module.exports = Shader;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	
	// state object//
	var setVertexAttribArrays = __webpack_require__( 92 );
	
	/**
	 * Helper class to work with WebGL VertexArrayObjects (vaos)
	 * Only works if WebGL extensions are enabled (they usually are)
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 */
	function VertexArrayObject(gl, state)
	{
	    this.nativeVaoExtension = null;
	
	    if(!VertexArrayObject.FORCE_NATIVE)
	    {
	        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') ||
	                                  gl.getExtension('MOZ_OES_vertex_array_object') ||
	                                  gl.getExtension('WEBKIT_OES_vertex_array_object');
	    }
	
	    this.nativeState = state;
	
	    if(this.nativeVaoExtension)
	    {
	        this.nativeVao = this.nativeVaoExtension.createVertexArrayOES();
	
	        var maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
	
	        // VAO - overwrite the state..
	        this.nativeState = {
	            tempAttribState: new Array(maxAttribs),
	            attribState: new Array(maxAttribs)
	        };
	    }
	
	    /**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    /**
	     * An array of attributes
	     *
	     * @member {Array}
	     */
	    this.attributes = [];
	
	    /**
	     * @member {PIXI.glCore.GLBuffer}
	     */
	    this.indexBuffer = null;
	
	    /**
	     * A boolean flag
	     *
	     * @member {Boolean}
	     */
	    this.dirty = false;
	}
	
	VertexArrayObject.prototype.constructor = VertexArrayObject;
	module.exports = VertexArrayObject;
	
	/**
	* Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
	* If you find on older devices that things have gone a bit weird then set this to true.
	*/
	/**
	 * Lets the VAO know if you should use the WebGL extension or the native methods.
	 * Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
	 * If you find on older devices that things have gone a bit weird then set this to true.
	 * @static
	 * @property {Boolean} FORCE_NATIVE
	 */
	VertexArrayObject.FORCE_NATIVE = false;
	
	/**
	 * Binds the buffer
	 */
	VertexArrayObject.prototype.bind = function()
	{
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
	
	        if(this.dirty)
	        {
	            this.dirty = false;
	            this.activate();
	            return this;
	        }
	        if (this.indexBuffer)
	        {
	            this.indexBuffer.bind();
	        }
	    }
	    else
	    {
	        this.activate();
	    }
	
	    return this;
	};
	
	/**
	 * Unbinds the buffer
	 */
	VertexArrayObject.prototype.unbind = function()
	{
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(null);
	    }
	
	    return this;
	};
	
	/**
	 * Uses this vao
	 */
	VertexArrayObject.prototype.activate = function()
	{
	
	    var gl = this.gl;
	    var lastBuffer = null;
	
	    for (var i = 0; i < this.attributes.length; i++)
	    {
	        var attrib = this.attributes[i];
	
	        if(lastBuffer !== attrib.buffer)
	        {
	            attrib.buffer.bind();
	            lastBuffer = attrib.buffer;
	        }
	
	        gl.vertexAttribPointer(attrib.attribute.location,
	                               attrib.attribute.size,
	                               attrib.type || gl.FLOAT,
	                               attrib.normalized || false,
	                               attrib.stride || 0,
	                               attrib.start || 0);
	    }
	
	    setVertexAttribArrays(gl, this.attributes, this.nativeState);
	
	    if(this.indexBuffer)
	    {
	        this.indexBuffer.bind();
	    }
	
	    return this;
	};
	
	/**
	 *
	 * @param buffer     {PIXI.gl.GLBuffer}
	 * @param attribute  {*}
	 * @param type       {String}
	 * @param normalized {Boolean}
	 * @param stride     {Number}
	 * @param start      {Number}
	 */
	VertexArrayObject.prototype.addAttribute = function(buffer, attribute, type, normalized, stride, start)
	{
	    this.attributes.push({
	        buffer:     buffer,
	        attribute:  attribute,
	
	        location:   attribute.location,
	        type:       type || this.gl.FLOAT,
	        normalized: normalized || false,
	        stride:     stride || 0,
	        start:      start || 0
	    });
	
	    this.dirty = true;
	
	    return this;
	};
	
	/**
	 *
	 * @param buffer   {PIXI.gl.GLBuffer}
	 */
	VertexArrayObject.prototype.addIndex = function(buffer/*, options*/)
	{
	    this.indexBuffer = buffer;
	
	    this.dirty = true;
	
	    return this;
	};
	
	/**
	 * Unbinds this vao and disables it
	 */
	VertexArrayObject.prototype.clear = function()
	{
	    // var gl = this.gl;
	
	    // TODO - should this function unbind after clear?
	    // for now, no but lets see what happens in the real world!
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
	    }
	
	    this.attributes.length = 0;
	    this.indexBuffer = null;
	
	    return this;
	};
	
	/**
	 * @param type  {Number}
	 * @param size  {Number}
	 * @param start {Number}
	 */
	VertexArrayObject.prototype.draw = function(type, size, start)
	{
	    var gl = this.gl;
	
	    if(this.indexBuffer)
	    {
	        gl.drawElements(type, size || this.indexBuffer.data.length, gl.UNSIGNED_SHORT, (start || 0) * 2 );
	    }
	    else
	    {
	        // TODO need a better way to calculate size..
	        gl.drawArrays(type, start, size || this.getSize());
	    }
	
	    return this;
	};
	
	/**
	 * Destroy this vao
	 */
	VertexArrayObject.prototype.destroy = function()
	{
	    // lose references
	    this.gl = null;
	    this.indexBuffer = null;
	    this.attributes = null;
	    this.nativeState = null;
	
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.deleteVertexArrayOES(this.nativeVao);
	    }
	
	    this.nativeVaoExtension = null;
	    this.nativeVao = null;
	};
	
	VertexArrayObject.prototype.getSize = function()
	{
	    var attrib = this.attributes[0];
	    return attrib.buffer.data.length / (( attrib.stride/4 ) || attrib.attribute.size);
	};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	
	/**
	 * Helper class to create a webGL Context
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param canvas {HTMLCanvasElement} the canvas element that we will get the context from
	 * @param options {Object} An options object that gets passed in to the canvas element containing the context attributes,
	 *                         see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext for the options available
	 * @return {WebGLRenderingContext} the WebGL context
	 */
	var createContext = function(canvas, options)
	{
	    var gl = canvas.getContext('webgl', options) || 
	         canvas.getContext('experimental-webgl', options);
	
	    if (!gl)
	    {
	        // fail, not able to get a context
	        throw new Error('This browser does not support webGL. Try using the canvas renderer');
	    }
	
	    return gl;
	};
	
	module.exports = createContext;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	    compileProgram: __webpack_require__(93),
	    defaultValue: __webpack_require__(94),
	    extractAttributes: __webpack_require__(95),
	    extractUniforms: __webpack_require__(96),
	    generateUniformAccessObject: __webpack_require__(97),
	    setPrecision: __webpack_require__(99),
	    mapSize: __webpack_require__(98),
	    mapType: __webpack_require__(57)
	};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _ismobilejs = __webpack_require__(56);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	var _accessibleTarget = __webpack_require__(100);
	
	var _accessibleTarget2 = _interopRequireDefault(_accessibleTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// add some extra variables to the container..
	core.utils.mixins.delayMixin(core.DisplayObject.prototype, _accessibleTarget2.default);
	
	var KEY_CODE_TAB = 9;
	
	var DIV_TOUCH_SIZE = 100;
	var DIV_TOUCH_POS_X = 0;
	var DIV_TOUCH_POS_Y = 0;
	var DIV_TOUCH_ZINDEX = 2;
	
	var DIV_HOOK_SIZE = 1;
	var DIV_HOOK_POS_X = -1000;
	var DIV_HOOK_POS_Y = -1000;
	var DIV_HOOK_ZINDEX = 2;
	
	/**
	 * The Accessibility manager recreates the ability to tab and have content read by screen
	 * readers. This is very important as it can possibly help people with disabilities access pixi
	 * content.
	 *
	 * Much like interaction any DisplayObject can be made accessible. This manager will map the
	 * events as if the mouse was being used, minimizing the effort required to implement.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.accessibility
	 *
	 * @class
	 * @memberof PIXI.accessibility
	 */
	
	var AccessibilityManager = function () {
	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function AccessibilityManager(renderer) {
	        _classCallCheck(this, AccessibilityManager);
	
	        if ((_ismobilejs2.default.tablet || _ismobilejs2.default.phone) && !navigator.isCocoonJS) {
	            this.createTouchHook();
	        }
	
	        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
	        var div = document.createElement('div');
	
	        div.style.width = DIV_TOUCH_SIZE + 'px';
	        div.style.height = DIV_TOUCH_SIZE + 'px';
	        div.style.position = 'absolute';
	        div.style.top = DIV_TOUCH_POS_X + 'px';
	        div.style.left = DIV_TOUCH_POS_Y + 'px';
	        div.style.zIndex = DIV_TOUCH_ZINDEX;
	
	        /**
	         * This is the dom element that will sit over the PixiJS element. This is where the div overlays will go.
	         *
	         * @type {HTMLElement}
	         * @private
	         */
	        this.div = div;
	
	        /**
	         * A simple pool for storing divs.
	         *
	         * @type {*}
	         * @private
	         */
	        this.pool = [];
	
	        /**
	         * This is a tick used to check if an object is no longer being rendered.
	         *
	         * @type {Number}
	         * @private
	         */
	        this.renderId = 0;
	
	        /**
	         * Setting this to true will visually show the divs.
	         *
	         * @type {boolean}
	         */
	        this.debug = false;
	
	        /**
	         * The renderer this accessibility manager works for.
	         *
	         * @member {PIXI.SystemRenderer}
	         */
	        this.renderer = renderer;
	
	        /**
	         * The array of currently active accessible items.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.children = [];
	
	        /**
	         * pre-bind the functions
	         *
	         * @private
	         */
	        this._onKeyDown = this._onKeyDown.bind(this);
	        this._onMouseMove = this._onMouseMove.bind(this);
	
	        /**
	         * stores the state of the manager. If there are no accessible objects or the mouse is moving, this will be false.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.isActive = false;
	        this.isMobileAccessabillity = false;
	
	        // let listen for tab.. once pressed we can fire up and show the accessibility layer
	        window.addEventListener('keydown', this._onKeyDown, false);
	    }
	
	    /**
	     * Creates the touch hooks.
	     *
	     */
	
	
	    AccessibilityManager.prototype.createTouchHook = function createTouchHook() {
	        var _this = this;
	
	        var hookDiv = document.createElement('button');
	
	        hookDiv.style.width = DIV_HOOK_SIZE + 'px';
	        hookDiv.style.height = DIV_HOOK_SIZE + 'px';
	        hookDiv.style.position = 'absolute';
	        hookDiv.style.top = DIV_HOOK_POS_X + 'px';
	        hookDiv.style.left = DIV_HOOK_POS_Y + 'px';
	        hookDiv.style.zIndex = DIV_HOOK_ZINDEX;
	        hookDiv.style.backgroundColor = '#FF0000';
	        hookDiv.title = 'HOOK DIV';
	
	        hookDiv.addEventListener('focus', function () {
	            _this.isMobileAccessabillity = true;
	            _this.activate();
	            document.body.removeChild(hookDiv);
	        });
	
	        document.body.appendChild(hookDiv);
	    };
	
	    /**
	     * Activating will cause the Accessibility layer to be shown. This is called when a user
	     * preses the tab key.
	     *
	     * @private
	     */
	
	
	    AccessibilityManager.prototype.activate = function activate() {
	        if (this.isActive) {
	            return;
	        }
	
	        this.isActive = true;
	
	        window.document.addEventListener('mousemove', this._onMouseMove, true);
	        window.removeEventListener('keydown', this._onKeyDown, false);
	
	        this.renderer.on('postrender', this.update, this);
	
	        if (this.renderer.view.parentNode) {
	            this.renderer.view.parentNode.appendChild(this.div);
	        }
	    };
	
	    /**
	     * Deactivating will cause the Accessibility layer to be hidden. This is called when a user moves
	     * the mouse.
	     *
	     * @private
	     */
	
	
	    AccessibilityManager.prototype.deactivate = function deactivate() {
	        if (!this.isActive || this.isMobileAccessabillity) {
	            return;
	        }
	
	        this.isActive = false;
	
	        window.document.removeEventListener('mousemove', this._onMouseMove);
	        window.addEventListener('keydown', this._onKeyDown, false);
	
	        this.renderer.off('postrender', this.update);
	
	        if (this.div.parentNode) {
	            this.div.parentNode.removeChild(this.div);
	        }
	    };
	
	    /**
	     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
	     *
	     * @private
	     * @param {PIXI.Container} displayObject - The DisplayObject to check.
	     */
	
	
	    AccessibilityManager.prototype.updateAccessibleObjects = function updateAccessibleObjects(displayObject) {
	        if (!displayObject.visible) {
	            return;
	        }
	
	        if (displayObject.accessible && displayObject.interactive) {
	            if (!displayObject._accessibleActive) {
	                this.addChild(displayObject);
	            }
	
	            displayObject.renderId = this.renderId;
	        }
	
	        var children = displayObject.children;
	
	        for (var i = 0; i < children.length; i++) {
	            this.updateAccessibleObjects(children[i]);
	        }
	    };
	
	    /**
	     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
	     *
	     * @private
	     */
	
	
	    AccessibilityManager.prototype.update = function update() {
	        if (!this.renderer.renderingToScreen) {
	            return;
	        }
	
	        // update children...
	        this.updateAccessibleObjects(this.renderer._lastObjectRendered);
	
	        var rect = this.renderer.view.getBoundingClientRect();
	        var sx = rect.width / this.renderer.width;
	        var sy = rect.height / this.renderer.height;
	
	        var div = this.div;
	
	        div.style.left = rect.left + 'px';
	        div.style.top = rect.top + 'px';
	        div.style.width = this.renderer.width + 'px';
	        div.style.height = this.renderer.height + 'px';
	
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	
	            if (child.renderId !== this.renderId) {
	                child._accessibleActive = false;
	
	                core.utils.removeItems(this.children, i, 1);
	                this.div.removeChild(child._accessibleDiv);
	                this.pool.push(child._accessibleDiv);
	                child._accessibleDiv = null;
	
	                i--;
	
	                if (this.children.length === 0) {
	                    this.deactivate();
	                }
	            } else {
	                // map div to display..
	                div = child._accessibleDiv;
	                var hitArea = child.hitArea;
	                var wt = child.worldTransform;
	
	                if (child.hitArea) {
	                    div.style.left = (wt.tx + hitArea.x * wt.a) * sx + 'px';
	                    div.style.top = (wt.ty + hitArea.y * wt.d) * sy + 'px';
	
	                    div.style.width = hitArea.width * wt.a * sx + 'px';
	                    div.style.height = hitArea.height * wt.d * sy + 'px';
	                } else {
	                    hitArea = child.getBounds();
	
	                    this.capHitArea(hitArea);
	
	                    div.style.left = hitArea.x * sx + 'px';
	                    div.style.top = hitArea.y * sy + 'px';
	
	                    div.style.width = hitArea.width * sx + 'px';
	                    div.style.height = hitArea.height * sy + 'px';
	
	                    // update button titles and hints if they exist and they've changed
	                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) {
	                        div.title = child.accessibleTitle;
	                    }
	                    if (div.getAttribute('aria-label') !== child.accessibleHint && child.accessibleHint !== null) {
	                        div.setAttribute('aria-label', child.accessibleHint);
	                    }
	                }
	            }
	        }
	
	        // increment the render id..
	        this.renderId++;
	    };
	
	    /**
	     * TODO: docs.
	     *
	     * @param {Rectangle} hitArea - TODO docs
	     */
	
	
	    AccessibilityManager.prototype.capHitArea = function capHitArea(hitArea) {
	        if (hitArea.x < 0) {
	            hitArea.width += hitArea.x;
	            hitArea.x = 0;
	        }
	
	        if (hitArea.y < 0) {
	            hitArea.height += hitArea.y;
	            hitArea.y = 0;
	        }
	
	        if (hitArea.x + hitArea.width > this.renderer.width) {
	            hitArea.width = this.renderer.width - hitArea.x;
	        }
	
	        if (hitArea.y + hitArea.height > this.renderer.height) {
	            hitArea.height = this.renderer.height - hitArea.y;
	        }
	    };
	
	    /**
	     * Adds a DisplayObject to the accessibility manager
	     *
	     * @private
	     * @param {DisplayObject} displayObject - The child to make accessible.
	     */
	
	
	    AccessibilityManager.prototype.addChild = function addChild(displayObject) {
	        //    this.activate();
	
	        var div = this.pool.pop();
	
	        if (!div) {
	            div = document.createElement('button');
	
	            div.style.width = DIV_TOUCH_SIZE + 'px';
	            div.style.height = DIV_TOUCH_SIZE + 'px';
	            div.style.backgroundColor = this.debug ? 'rgba(255,0,0,0.5)' : 'transparent';
	            div.style.position = 'absolute';
	            div.style.zIndex = DIV_TOUCH_ZINDEX;
	            div.style.borderStyle = 'none';
	
	            // ARIA attributes ensure that button title and hint updates are announced properly
	            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	                // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
	                div.setAttribute('aria-live', 'off');
	            } else {
	                div.setAttribute('aria-live', 'polite');
	            }
	
	            if (navigator.userAgent.match(/rv:.*Gecko\//)) {
	                // FireFox needs this to announce only the new button name
	                div.setAttribute('aria-relevant', 'additions');
	            } else {
	                // required by IE, other browsers don't much care
	                div.setAttribute('aria-relevant', 'text');
	            }
	
	            div.addEventListener('click', this._onClick.bind(this));
	            div.addEventListener('focus', this._onFocus.bind(this));
	            div.addEventListener('focusout', this._onFocusOut.bind(this));
	        }
	
	        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) {
	            div.title = displayObject.accessibleTitle;
	        } else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) {
	            div.title = 'displayObject ' + displayObject.tabIndex;
	        }
	
	        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) {
	            div.setAttribute('aria-label', displayObject.accessibleHint);
	        }
	
	        //
	
	        displayObject._accessibleActive = true;
	        displayObject._accessibleDiv = div;
	        div.displayObject = displayObject;
	
	        this.children.push(displayObject);
	        this.div.appendChild(displayObject._accessibleDiv);
	        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
	    };
	
	    /**
	     * Maps the div button press to pixi's InteractionManager (click)
	     *
	     * @private
	     * @param {MouseEvent} e - The click event.
	     */
	
	
	    AccessibilityManager.prototype._onClick = function _onClick(e) {
	        var interactionManager = this.renderer.plugins.interaction;
	
	        interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
	    };
	
	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseover)
	     *
	     * @private
	     * @param {FocusEvent} e - The focus event.
	     */
	
	
	    AccessibilityManager.prototype._onFocus = function _onFocus(e) {
	        if (!e.target.getAttribute('aria-live', 'off')) {
	            e.target.setAttribute('aria-live', 'assertive');
	        }
	        var interactionManager = this.renderer.plugins.interaction;
	
	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
	    };
	
	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseout)
	     *
	     * @private
	     * @param {FocusEvent} e - The focusout event.
	     */
	
	
	    AccessibilityManager.prototype._onFocusOut = function _onFocusOut(e) {
	        if (!e.target.getAttribute('aria-live', 'off')) {
	            e.target.setAttribute('aria-live', 'polite');
	        }
	        var interactionManager = this.renderer.plugins.interaction;
	
	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
	    };
	
	    /**
	     * Is called when a key is pressed
	     *
	     * @private
	     * @param {KeyboardEvent} e - The keydown event.
	     */
	
	
	    AccessibilityManager.prototype._onKeyDown = function _onKeyDown(e) {
	        if (e.keyCode !== KEY_CODE_TAB) {
	            return;
	        }
	
	        this.activate();
	    };
	
	    /**
	     * Is called when the mouse moves across the renderer element
	     *
	     * @private
	     * @param {MouseEvent} e - The mouse event.
	     */
	
	
	    AccessibilityManager.prototype._onMouseMove = function _onMouseMove(e) {
	        if (e.movementX === 0 && e.movementY === 0) {
	            return;
	        }
	
	        this.deactivate();
	    };
	
	    /**
	     * Destroys the accessibility manager
	     *
	     */
	
	
	    AccessibilityManager.prototype.destroy = function destroy() {
	        this.div = null;
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i].div = null;
	        }
	
	        window.document.removeEventListener('mousemove', this._onMouseMove);
	        window.removeEventListener('keydown', this._onKeyDown);
	
	        this.pool = null;
	        this.children = null;
	        this.renderer = null;
	    };
	
	    return AccessibilityManager;
	}();
	
	exports.default = AccessibilityManager;
	
	
	core.WebGLRenderer.registerPlugin('accessibility', AccessibilityManager);
	core.CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
	//# sourceMappingURL=AccessibilityManager.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _accessibleTarget = __webpack_require__(100);
	
	Object.defineProperty(exports, 'accessibleTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accessibleTarget).default;
	  }
	});
	
	var _AccessibilityManager = __webpack_require__(200);
	
	Object.defineProperty(exports, 'AccessibilityManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibilityManager).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Container2 = __webpack_require__(27);
	
	var _Container3 = _interopRequireDefault(_Container2);
	
	var _RenderTexture = __webpack_require__(65);
	
	var _RenderTexture2 = _interopRequireDefault(_RenderTexture);
	
	var _Texture = __webpack_require__(17);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _GraphicsData = __webpack_require__(106);
	
	var _GraphicsData2 = _interopRequireDefault(_GraphicsData);
	
	var _Sprite = __webpack_require__(63);
	
	var _Sprite2 = _interopRequireDefault(_Sprite);
	
	var _math = __webpack_require__(7);
	
	var _utils = __webpack_require__(5);
	
	var _const = __webpack_require__(3);
	
	var _Bounds = __webpack_require__(58);
	
	var _Bounds2 = _interopRequireDefault(_Bounds);
	
	var _bezierCurveTo2 = __webpack_require__(204);
	
	var _bezierCurveTo3 = _interopRequireDefault(_bezierCurveTo2);
	
	var _CanvasRenderer = __webpack_require__(28);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var canvasRenderer = void 0;
	var tempMatrix = new _math.Matrix();
	var tempPoint = new _math.Point();
	var tempColor1 = new Float32Array(4);
	var tempColor2 = new Float32Array(4);
	
	/**
	 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
	 * rectangles to the display, and to color and fill them.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	
	var Graphics = function (_Container) {
	    _inherits(Graphics, _Container);
	
	    /**
	     *
	     * @param {boolean} [nativeLines=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	     */
	    function Graphics() {
	        var nativeLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        _classCallCheck(this, Graphics);
	
	        /**
	         * The alpha value used when filling the Graphics object.
	         *
	         * @member {number}
	         * @default 1
	         */
	        var _this = _possibleConstructorReturn(this, _Container.call(this));
	
	        _this.fillAlpha = 1;
	
	        /**
	         * The width (thickness) of any lines drawn.
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.lineWidth = 0;
	
	        /**
	         * If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	         *
	         * @member {boolean}
	         */
	        _this.nativeLines = nativeLines;
	
	        /**
	         * The color of any lines drawn.
	         *
	         * @member {string}
	         * @default 0
	         */
	        _this.lineColor = 0;
	
	        /**
	         * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.lineAlignment = 0.5;
	
	        /**
	         * Graphics data
	         *
	         * @member {PIXI.GraphicsData[]}
	         * @private
	         */
	        _this.graphicsData = [];
	
	        /**
	         * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to
	         * reset the tint.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this.tint = 0xFFFFFF;
	
	        /**
	         * The previous tint applied to the graphic shape. Used to compare to the current tint and
	         * check if theres change.
	         *
	         * @member {number}
	         * @private
	         * @default 0xFFFFFF
	         */
	        _this._prevTint = 0xFFFFFF;
	
	        /**
	         * The blend mode to be applied to the graphic shape. Apply a value of
	         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL;
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = _const.BLEND_MODES.NORMAL;
	
	        /**
	         * Current path
	         *
	         * @member {PIXI.GraphicsData}
	         * @private
	         */
	        _this.currentPath = null;
	
	        /**
	         * Array containing some WebGL-related properties used by the WebGL renderer.
	         *
	         * @member {object<number, object>}
	         * @private
	         */
	        // TODO - _webgl should use a prototype object, not a random undocumented object...
	        _this._webGL = {};
	
	        /**
	         * Whether this shape is being used as a mask.
	         *
	         * @member {boolean}
	         */
	        _this.isMask = false;
	
	        /**
	         * The bounds' padding used for bounds calculation.
	         *
	         * @member {number}
	         */
	        _this.boundsPadding = 0;
	
	        /**
	         * A cache of the local bounds to prevent recalculation.
	         *
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        _this._localBounds = new _Bounds2.default();
	
	        /**
	         * Used to detect if the graphics object has changed. If this is set to true then the graphics
	         * object will be recalculated.
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this.dirty = 0;
	
	        /**
	         * Used to detect if we need to do a fast rect check using the id compare method
	         * @type {Number}
	         */
	        _this.fastRectDirty = -1;
	
	        /**
	         * Used to detect if we clear the graphics webGL data
	         * @type {Number}
	         */
	        _this.clearDirty = 0;
	
	        /**
	         * Used to detect if we we need to recalculate local bounds
	         * @type {Number}
	         */
	        _this.boundsDirty = -1;
	
	        /**
	         * Used to detect if the cached sprite object needs to be updated.
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this.cachedSpriteDirty = false;
	
	        _this._spriteRect = null;
	        _this._fastRect = false;
	
	        /**
	         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
	         * This is useful if your graphics element does not change often, as it will speed up the rendering
	         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
	         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
	         * you are constantly redrawing the graphics element.
	         *
	         * @name cacheAsBitmap
	         * @member {boolean}
	         * @memberof PIXI.Graphics#
	         * @default false
	         */
	        return _this;
	    }
	
	    /**
	     * Creates a new Graphics object with the same values as this one.
	     * Note that the only the properties of the object are cloned, not its transform (position,scale,etc)
	     *
	     * @return {PIXI.Graphics} A clone of the graphics object
	     */
	
	
	    Graphics.prototype.clone = function clone() {
	        var clone = new Graphics();
	
	        clone.renderable = this.renderable;
	        clone.fillAlpha = this.fillAlpha;
	        clone.lineWidth = this.lineWidth;
	        clone.lineColor = this.lineColor;
	        clone.lineAlignment = this.lineAlignment;
	        clone.tint = this.tint;
	        clone.blendMode = this.blendMode;
	        clone.isMask = this.isMask;
	        clone.boundsPadding = this.boundsPadding;
	        clone.dirty = 0;
	        clone.cachedSpriteDirty = this.cachedSpriteDirty;
	
	        // copy graphics data
	        for (var i = 0; i < this.graphicsData.length; ++i) {
	            clone.graphicsData.push(this.graphicsData[i].clone());
	        }
	
	        clone.currentPath = clone.graphicsData[clone.graphicsData.length - 1];
	
	        clone.updateLocalBounds();
	
	        return clone;
	    };
	
	    /**
	     * Calculate length of quadratic curve
	     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
	     * for the detailed explanation of math behind this.
	     *
	     * @private
	     * @param {number} fromX - x-coordinate of curve start point
	     * @param {number} fromY - y-coordinate of curve start point
	     * @param {number} cpX - x-coordinate of curve control point
	     * @param {number} cpY - y-coordinate of curve control point
	     * @param {number} toX - x-coordinate of curve end point
	     * @param {number} toY - y-coordinate of curve end point
	     * @return {number} Length of quadratic curve
	     */
	
	
	    Graphics.prototype._quadraticCurveLength = function _quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY) {
	        var ax = fromX - (2.0 * cpX + toX);
	        var ay = fromY - (2.0 * cpY + toY);
	        var bx = 2.0 * ((cpX - 2.0) * fromX);
	        var by = 2.0 * ((cpY - 2.0) * fromY);
	        var a = 4.0 * (ax * ax + ay * ay);
	        var b = 4.0 * (ax * bx + ay * by);
	        var c = bx * bx + by * by;
	
	        var s = 2.0 * Math.sqrt(a + b + c);
	        var a2 = Math.sqrt(a);
	        var a32 = 2.0 * a * a2;
	        var c2 = 2.0 * Math.sqrt(c);
	        var ba = b / a2;
	
	        return (a32 * s + a2 * b * (s - c2) + (4.0 * c * a - b * b) * Math.log((2.0 * a2 + ba + s) / (ba + c2))) / (4.0 * a32);
	    };
	
	    /**
	     * Calculate length of bezier curve.
	     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
	     * Therefore numerical solution is used.
	     *
	     * @private
	     * @param {number} fromX - Starting point x
	     * @param {number} fromY - Starting point y
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {number} Length of bezier curve
	     */
	
	
	    Graphics.prototype._bezierCurveLength = function _bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
	        var n = 10;
	        var result = 0.0;
	        var t = 0.0;
	        var t2 = 0.0;
	        var t3 = 0.0;
	        var nt = 0.0;
	        var nt2 = 0.0;
	        var nt3 = 0.0;
	        var x = 0.0;
	        var y = 0.0;
	        var dx = 0.0;
	        var dy = 0.0;
	        var prevX = fromX;
	        var prevY = fromY;
	
	        for (var i = 1; i <= n; ++i) {
	            t = i / n;
	            t2 = t * t;
	            t3 = t2 * t;
	            nt = 1.0 - t;
	            nt2 = nt * nt;
	            nt3 = nt2 * nt;
	
	            x = nt3 * fromX + 3.0 * nt2 * t * cpX + 3.0 * nt * t2 * cpX2 + t3 * toX;
	            y = nt3 * fromY + 3.0 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
	            dx = prevX - x;
	            dy = prevY - y;
	            prevX = x;
	            prevY = y;
	
	            result += Math.sqrt(dx * dx + dy * dy);
	        }
	
	        return result;
	    };
	
	    /**
	     * Calculate number of segments for the curve based on its length to ensure its smoothness.
	     *
	     * @private
	     * @param {number} length - length of curve
	     * @return {number} Number of segments
	     */
	
	
	    Graphics.prototype._segmentsCount = function _segmentsCount(length) {
	        var result = Math.ceil(length / Graphics.CURVES.maxLength);
	
	        if (result < Graphics.CURVES.minSegments) {
	            result = Graphics.CURVES.minSegments;
	        } else if (result > Graphics.CURVES.maxSegments) {
	            result = Graphics.CURVES.maxSegments;
	        }
	
	        return result;
	    };
	
	    /**
	     * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
	     * method or the drawCircle() method.
	     *
	     * @param {number} [lineWidth=0] - width of the line to draw, will update the objects stored style
	     * @param {number} [color=0] - color of the line to draw, will update the objects stored style
	     * @param {number} [alpha=1] - alpha of the line to draw, will update the objects stored style
	     * @param {number} [alignment=1] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.lineStyle = function lineStyle() {
	        var lineWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	        var alignment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
	
	        this.lineWidth = lineWidth;
	        this.lineColor = color;
	        this.lineAlpha = alpha;
	        this.lineAlignment = alignment;
	
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length) {
	                // halfway through a line? start a new one!
	                var shape = new _math.Polygon(this.currentPath.shape.points.slice(-2));
	
	                shape.closed = false;
	
	                this.drawShape(shape);
	            } else {
	                // otherwise its empty so lets just set the line properties
	                this.currentPath.lineWidth = this.lineWidth;
	                this.currentPath.lineColor = this.lineColor;
	                this.currentPath.lineAlpha = this.lineAlpha;
	                this.currentPath.lineAlignment = this.lineAlignment;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Moves the current drawing position to x, y.
	     *
	     * @param {number} x - the X coordinate to move to
	     * @param {number} y - the Y coordinate to move to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.moveTo = function moveTo(x, y) {
	        var shape = new _math.Polygon([x, y]);
	
	        shape.closed = false;
	        this.drawShape(shape);
	
	        return this;
	    };
	
	    /**
	     * Draws a line using the current line style from the current drawing position to (x, y);
	     * The current drawing position is then set to (x, y).
	     *
	     * @param {number} x - the X coordinate to draw to
	     * @param {number} y - the Y coordinate to draw to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.lineTo = function lineTo(x, y) {
	        this.currentPath.shape.points.push(x, y);
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * Calculate the points for a quadratic bezier curve and then draws it.
	     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.quadraticCurveTo = function quadraticCurveTo(cpX, cpY, toX, toY) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points = [0, 0];
	            }
	        } else {
	            this.moveTo(0, 0);
	        }
	
	        var points = this.currentPath.shape.points;
	        var xa = 0;
	        var ya = 0;
	
	        if (points.length === 0) {
	            this.moveTo(0, 0);
	        }
	
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY)) : 20;
	
	        for (var i = 1; i <= n; ++i) {
	            var j = i / n;
	
	            xa = fromX + (cpX - fromX) * j;
	            ya = fromY + (cpY - fromY) * j;
	
	            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
	        }
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * Calculate the points for a bezier curve and then draws it.
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.bezierCurveTo = function bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points = [0, 0];
	            }
	        } else {
	            this.moveTo(0, 0);
	        }
	
	        var points = this.currentPath.shape.points;
	
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	
	        points.length -= 2;
	
	        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY)) : 20;
	
	        (0, _bezierCurveTo3.default)(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n, points);
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * The arcTo() method creates an arc/curve between two tangents on the canvas.
	     *
	     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
	     *
	     * @param {number} x1 - The x-coordinate of the beginning of the arc
	     * @param {number} y1 - The y-coordinate of the beginning of the arc
	     * @param {number} x2 - The x-coordinate of the end of the arc
	     * @param {number} y2 - The y-coordinate of the end of the arc
	     * @param {number} radius - The radius of the arc
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.arcTo = function arcTo(x1, y1, x2, y2, radius) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points.push(x1, y1);
	            }
	        } else {
	            this.moveTo(x1, y1);
	        }
	
	        var points = this.currentPath.shape.points;
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var a1 = fromY - y1;
	        var b1 = fromX - x1;
	        var a2 = y2 - y1;
	        var b2 = x2 - x1;
	        var mm = Math.abs(a1 * b2 - b1 * a2);
	
	        if (mm < 1.0e-8 || radius === 0) {
	            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
	                points.push(x1, y1);
	            }
	        } else {
	            var dd = a1 * a1 + b1 * b1;
	            var cc = a2 * a2 + b2 * b2;
	            var tt = a1 * a2 + b1 * b2;
	            var k1 = radius * Math.sqrt(dd) / mm;
	            var k2 = radius * Math.sqrt(cc) / mm;
	            var j1 = k1 * tt / dd;
	            var j2 = k2 * tt / cc;
	            var cx = k1 * b2 + k2 * b1;
	            var cy = k1 * a2 + k2 * a1;
	            var px = b1 * (k2 + j1);
	            var py = a1 * (k2 + j1);
	            var qx = b2 * (k1 + j2);
	            var qy = a2 * (k1 + j2);
	            var startAngle = Math.atan2(py - cy, px - cx);
	            var endAngle = Math.atan2(qy - cy, qx - cx);
	
	            this.arc(cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
	        }
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * The arc method creates an arc/curve (used to create circles, or parts of circles).
	     *
	     * @param {number} cx - The x-coordinate of the center of the circle
	     * @param {number} cy - The y-coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
	     *  of the arc's circle)
	     * @param {number} endAngle - The ending angle, in radians
	     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
	     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
	     *  indicates counter-clockwise.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.arc = function arc(cx, cy, radius, startAngle, endAngle) {
	        var anticlockwise = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	        if (startAngle === endAngle) {
	            return this;
	        }
	
	        if (!anticlockwise && endAngle <= startAngle) {
	            endAngle += _const.PI_2;
	        } else if (anticlockwise && startAngle <= endAngle) {
	            startAngle += _const.PI_2;
	        }
	
	        var sweep = endAngle - startAngle;
	        var segs = Graphics.CURVES.adaptive ? this._segmentsCount(Math.abs(sweep) * radius) : Math.ceil(Math.abs(sweep) / _const.PI_2) * 40;
	
	        if (sweep === 0) {
	            return this;
	        }
	
	        var startX = cx + Math.cos(startAngle) * radius;
	        var startY = cy + Math.sin(startAngle) * radius;
	
	        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
	        var points = this.currentPath ? this.currentPath.shape.points : null;
	
	        if (points) {
	            if (points[points.length - 2] !== startX || points[points.length - 1] !== startY) {
	                points.push(startX, startY);
	            }
	        } else {
	            this.moveTo(startX, startY);
	            points = this.currentPath.shape.points;
	        }
	
	        var theta = sweep / (segs * 2);
	        var theta2 = theta * 2;
	
	        var cTheta = Math.cos(theta);
	        var sTheta = Math.sin(theta);
	
	        var segMinus = segs - 1;
	
	        var remainder = segMinus % 1 / segMinus;
	
	        for (var i = 0; i <= segMinus; ++i) {
	            var real = i + remainder * i;
	
	            var angle = theta + startAngle + theta2 * real;
	
	            var c = Math.cos(angle);
	            var s = -Math.sin(angle);
	
	            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
	        }
	
	        this.dirty++;
	
	        return this;
	    };
	
	    /**
	     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
	     * (such as lineTo() or drawCircle()) use when drawing.
	     *
	     * @param {number} [color=0] - the color of the fill
	     * @param {number} [alpha=1] - the alpha of the fill
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.beginFill = function beginFill() {
	        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        this.filling = true;
	        this.fillColor = color;
	        this.fillAlpha = alpha;
	
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length <= 2) {
	                this.currentPath.fill = this.filling;
	                this.currentPath.fillColor = this.fillColor;
	                this.currentPath.fillAlpha = this.fillAlpha;
	            }
	        }
	
	        return this;
	    };
	
	    /**
	     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.endFill = function endFill() {
	        this.filling = false;
	        this.fillColor = null;
	        this.fillAlpha = 1;
	
	        return this;
	    };
	
	    /**
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawRect = function drawRect(x, y, width, height) {
	        this.drawShape(new _math.Rectangle(x, y, width, height));
	
	        return this;
	    };
	
	    /**
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @param {number} radius - Radius of the rectangle corners
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawRoundedRect = function drawRoundedRect(x, y, width, height, radius) {
	        this.drawShape(new _math.RoundedRectangle(x, y, width, height, radius));
	
	        return this;
	    };
	
	    /**
	     * Draws a circle.
	     *
	     * @param {number} x - The X coordinate of the center of the circle
	     * @param {number} y - The Y coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawCircle = function drawCircle(x, y, radius) {
	        this.drawShape(new _math.Circle(x, y, radius));
	
	        return this;
	    };
	
	    /**
	     * Draws an ellipse.
	     *
	     * @param {number} x - The X coordinate of the center of the ellipse
	     * @param {number} y - The Y coordinate of the center of the ellipse
	     * @param {number} width - The half width of the ellipse
	     * @param {number} height - The half height of the ellipse
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawEllipse = function drawEllipse(x, y, width, height) {
	        this.drawShape(new _math.Ellipse(x, y, width, height));
	
	        return this;
	    };
	
	    /**
	     * Draws a polygon using the given path.
	     *
	     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawPolygon = function drawPolygon(path) {
	        // prevents an argument assignment deopt
	        // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	        var points = path;
	
	        var closed = true;
	
	        if (points instanceof _math.Polygon) {
	            closed = points.closed;
	            points = points.points;
	        }
	
	        if (!Array.isArray(points)) {
	            // prevents an argument leak deopt
	            // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	            points = new Array(arguments.length);
	
	            for (var i = 0; i < points.length; ++i) {
	                points[i] = arguments[i]; // eslint-disable-line prefer-rest-params
	            }
	        }
	
	        var shape = new _math.Polygon(points);
	
	        shape.closed = closed;
	
	        this.drawShape(shape);
	
	        return this;
	    };
	
	    /**
	     * Draw a star shape with an abitrary number of points.
	     *
	     * @param {number} x - Center X position of the star
	     * @param {number} y - Center Y position of the star
	     * @param {number} points - The number of points of the star, must be > 1
	     * @param {number} radius - The outer radius of the star
	     * @param {number} [innerRadius] - The inner radius between points, default half `radius`
	     * @param {number} [rotation=0] - The rotation of the star in radians, where 0 is vertical
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.drawStar = function drawStar(x, y, points, radius, innerRadius) {
	        var rotation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	        innerRadius = innerRadius || radius / 2;
	
	        var startAngle = -1 * Math.PI / 2 + rotation;
	        var len = points * 2;
	        var delta = _const.PI_2 / len;
	        var polygon = [];
	
	        for (var i = 0; i < len; i++) {
	            var r = i % 2 ? innerRadius : radius;
	            var angle = i * delta + startAngle;
	
	            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
	        }
	
	        return this.drawPolygon(polygon);
	    };
	
	    /**
	     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	
	
	    Graphics.prototype.clear = function clear() {
	        if (this.lineWidth || this.filling || this.graphicsData.length > 0) {
	            this.lineWidth = 0;
	            this.lineAlignment = 0.5;
	
	            this.filling = false;
	
	            this.boundsDirty = -1;
	            this.dirty++;
	            this.clearDirty++;
	            this.graphicsData.length = 0;
	        }
	
	        this.currentPath = null;
	        this._spriteRect = null;
	
	        return this;
	    };
	
	    /**
	     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
	     * masked with gl.scissor.
	     *
	     * @returns {boolean} True if only 1 rect.
	     */
	
	
	    Graphics.prototype.isFastRect = function isFastRect() {
	        return this.graphicsData.length === 1 && this.graphicsData[0].shape.type === _const.SHAPES.RECT && !this.graphicsData[0].lineWidth;
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Graphics.prototype._renderWebGL = function _renderWebGL(renderer) {
	        // if the sprite is not visible or the alpha is 0 then no need to render this element
	        if (this.dirty !== this.fastRectDirty) {
	            this.fastRectDirty = this.dirty;
	            this._fastRect = this.isFastRect();
	        }
	
	        // TODO this check can be moved to dirty?
	        if (this._fastRect) {
	            this._renderSpriteRect(renderer);
	        } else {
	            renderer.setObjectRenderer(renderer.plugins.graphics);
	            renderer.plugins.graphics.render(this);
	        }
	    };
	
	    /**
	     * Renders a sprite rectangle.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Graphics.prototype._renderSpriteRect = function _renderSpriteRect(renderer) {
	        var rect = this.graphicsData[0].shape;
	
	        if (!this._spriteRect) {
	            this._spriteRect = new _Sprite2.default(new _Texture2.default(_Texture2.default.WHITE));
	        }
	
	        var sprite = this._spriteRect;
	
	        if (this.tint === 0xffffff) {
	            sprite.tint = this.graphicsData[0].fillColor;
	        } else {
	            var t1 = tempColor1;
	            var t2 = tempColor2;
	
	            (0, _utils.hex2rgb)(this.graphicsData[0].fillColor, t1);
	            (0, _utils.hex2rgb)(this.tint, t2);
	
	            t1[0] *= t2[0];
	            t1[1] *= t2[1];
	            t1[2] *= t2[2];
	
	            sprite.tint = (0, _utils.rgb2hex)(t1);
	        }
	        sprite.alpha = this.graphicsData[0].fillAlpha;
	        sprite.worldAlpha = this.worldAlpha * sprite.alpha;
	        sprite.blendMode = this.blendMode;
	
	        sprite._texture._frame.width = rect.width;
	        sprite._texture._frame.height = rect.height;
	
	        sprite.transform.worldTransform = this.transform.worldTransform;
	
	        sprite.anchor.set(-rect.x / rect.width, -rect.y / rect.height);
	        sprite._onAnchorUpdate();
	
	        sprite._renderWebGL(renderer);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	
	
	    Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
	        if (this.isMask === true) {
	            return;
	        }
	
	        renderer.plugins.graphics.render(this);
	    };
	
	    /**
	     * Retrieves the bounds of the graphic shape as a rectangle object
	     *
	     * @private
	     */
	
	
	    Graphics.prototype._calculateBounds = function _calculateBounds() {
	        if (this.boundsDirty !== this.dirty) {
	            this.boundsDirty = this.dirty;
	            this.updateLocalBounds();
	
	            this.cachedSpriteDirty = true;
	        }
	
	        var lb = this._localBounds;
	
	        this._bounds.addFrame(this.transform, lb.minX, lb.minY, lb.maxX, lb.maxY);
	    };
	
	    /**
	     * Tests if a point is inside this graphics object
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */
	
	
	    Graphics.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var graphicsData = this.graphicsData;
	
	        for (var i = 0; i < graphicsData.length; ++i) {
	            var data = graphicsData[i];
	
	            if (!data.fill) {
	                continue;
	            }
	
	            // only deal with fills..
	            if (data.shape) {
	                if (data.shape.contains(tempPoint.x, tempPoint.y)) {
	                    if (data.holes) {
	                        for (var _i = 0; _i < data.holes.length; _i++) {
	                            var hole = data.holes[_i];
	
	                            if (hole.contains(tempPoint.x, tempPoint.y)) {
	                                return false;
	                            }
	                        }
	                    }
	
	                    return true;
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Update the bounds of the object
	     *
	     */
	
	
	    Graphics.prototype.updateLocalBounds = function updateLocalBounds() {
	        var minX = Infinity;
	        var maxX = -Infinity;
	
	        var minY = Infinity;
	        var maxY = -Infinity;
	
	        if (this.graphicsData.length) {
	            var shape = 0;
	            var x = 0;
	            var y = 0;
	            var w = 0;
	            var h = 0;
	
	            for (var i = 0; i < this.graphicsData.length; i++) {
	                var data = this.graphicsData[i];
	                var type = data.type;
	                var lineWidth = data.lineWidth;
	
	                shape = data.shape;
	
	                if (type === _const.SHAPES.RECT || type === _const.SHAPES.RREC) {
	                    x = shape.x - lineWidth / 2;
	                    y = shape.y - lineWidth / 2;
	                    w = shape.width + lineWidth;
	                    h = shape.height + lineWidth;
	
	                    minX = x < minX ? x : minX;
	                    maxX = x + w > maxX ? x + w : maxX;
	
	                    minY = y < minY ? y : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else if (type === _const.SHAPES.CIRC) {
	                    x = shape.x;
	                    y = shape.y;
	                    w = shape.radius + lineWidth / 2;
	                    h = shape.radius + lineWidth / 2;
	
	                    minX = x - w < minX ? x - w : minX;
	                    maxX = x + w > maxX ? x + w : maxX;
	
	                    minY = y - h < minY ? y - h : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else if (type === _const.SHAPES.ELIP) {
	                    x = shape.x;
	                    y = shape.y;
	                    w = shape.width + lineWidth / 2;
	                    h = shape.height + lineWidth / 2;
	
	                    minX = x - w < minX ? x - w : minX;
	                    maxX = x + w > maxX ? x + w : maxX;
	
	                    minY = y - h < minY ? y - h : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else {
	                    // POLY
	                    var points = shape.points;
	                    var x2 = 0;
	                    var y2 = 0;
	                    var dx = 0;
	                    var dy = 0;
	                    var rw = 0;
	                    var rh = 0;
	                    var cx = 0;
	                    var cy = 0;
	
	                    for (var j = 0; j + 2 < points.length; j += 2) {
	                        x = points[j];
	                        y = points[j + 1];
	                        x2 = points[j + 2];
	                        y2 = points[j + 3];
	                        dx = Math.abs(x2 - x);
	                        dy = Math.abs(y2 - y);
	                        h = lineWidth;
	                        w = Math.sqrt(dx * dx + dy * dy);
	
	                        if (w < 1e-9) {
	                            continue;
	                        }
	
	                        rw = (h / w * dy + dx) / 2;
	                        rh = (h / w * dx + dy) / 2;
	                        cx = (x2 + x) / 2;
	                        cy = (y2 + y) / 2;
	
	                        minX = cx - rw < minX ? cx - rw : minX;
	                        maxX = cx + rw > maxX ? cx + rw : maxX;
	
	                        minY = cy - rh < minY ? cy - rh : minY;
	                        maxY = cy + rh > maxY ? cy + rh : maxY;
	                    }
	                }
	            }
	        } else {
	            minX = 0;
	            maxX = 0;
	            minY = 0;
	            maxY = 0;
	        }
	
	        var padding = this.boundsPadding;
	
	        this._localBounds.minX = minX - padding;
	        this._localBounds.maxX = maxX + padding;
	
	        this._localBounds.minY = minY - padding;
	        this._localBounds.maxY = maxY + padding;
	    };
	
	    /**
	     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
	     *
	     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
	     * @return {PIXI.GraphicsData} The generated GraphicsData object.
	     */
	
	
	    Graphics.prototype.drawShape = function drawShape(shape) {
	        if (this.currentPath) {
	            // check current path!
	            if (this.currentPath.shape.points.length <= 2) {
	                this.graphicsData.pop();
	            }
	        }
	
	        this.currentPath = null;
	
	        var data = new _GraphicsData2.default(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, this.nativeLines, shape, this.lineAlignment);
	
	        this.graphicsData.push(data);
	
	        if (data.type === _const.SHAPES.POLY) {
	            data.shape.closed = data.shape.closed || this.filling;
	            this.currentPath = data;
	        }
	
	        this.dirty++;
	
	        return data;
	    };
	
	    /**
	     * Generates a canvas texture.
	     *
	     * @param {number} scaleMode - The scale mode of the texture.
	     * @param {number} resolution - The resolution of the texture.
	     * @return {PIXI.Texture} The new texture.
	     */
	
	
	    Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode) {
	        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        var bounds = this.getLocalBounds();
	
	        var canvasBuffer = _RenderTexture2.default.create(bounds.width, bounds.height, scaleMode, resolution);
	
	        if (!canvasRenderer) {
	            canvasRenderer = new _CanvasRenderer2.default();
	        }
	
	        this.transform.updateLocalTransform();
	        this.transform.localTransform.copy(tempMatrix);
	
	        tempMatrix.invert();
	
	        tempMatrix.tx -= bounds.x;
	        tempMatrix.ty -= bounds.y;
	
	        canvasRenderer.render(this, canvasBuffer, true, tempMatrix);
	
	        var texture = _Texture2.default.fromCanvas(canvasBuffer.baseTexture._canvasRenderTarget.canvas, scaleMode, 'graphics');
	
	        texture.baseTexture.resolution = resolution;
	        texture.baseTexture.update();
	
	        return texture;
	    };
	
	    /**
	     * Closes the current path.
	     *
	     * @return {PIXI.Graphics} Returns itself.
	     */
	
	
	    Graphics.prototype.closePath = function closePath() {
	        // ok so close path assumes next one is a hole!
	        var currentPath = this.currentPath;
	
	        if (currentPath && currentPath.shape) {
	            currentPath.shape.close();
	        }
	
	        return this;
	    };
	
	    /**
	     * Adds a hole in the current path.
	     *
	     * @return {PIXI.Graphics} Returns itself.
	     */
	
	
	    Graphics.prototype.addHole = function addHole() {
	        // this is a hole!
	        var hole = this.graphicsData.pop();
	
	        this.currentPath = this.graphicsData[this.graphicsData.length - 1];
	
	        this.currentPath.addHole(hole.shape);
	        this.currentPath = null;
	
	        return this;
	    };
	
	    /**
	     * Destroys the Graphics object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	
	
	    Graphics.prototype.destroy = function destroy(options) {
	        _Container.prototype.destroy.call(this, options);
	
	        // destroy each of the GraphicsData objects
	        for (var i = 0; i < this.graphicsData.length; ++i) {
	            this.graphicsData[i].destroy();
	        }
	
	        // for each webgl data entry, destroy the WebGLGraphicsData
	        for (var id in this._webGL) {
	            for (var j = 0; j < this._webGL[id].data.length; ++j) {
	                this._webGL[id].data[j].destroy();
	            }
	        }
	
	        if (this._spriteRect) {
	            this._spriteRect.destroy();
	        }
	
	        this.graphicsData = null;
	
	        this.currentPath = null;
	        this._webGL = null;
	        this._localBounds = null;
	    };
	
	    return Graphics;
	}(_Container3.default);
	
	exports.default = Graphics;
	
	
	Graphics._SPRITE_TEXTURE = null;
	
	/**
	 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
	 * the resolution is calculated based on the curve's length to ensure better visual quality.
	 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI.Graphics
	 * @name CURVES
	 * @type {object}
	 * @property {boolean} adaptive=false - flag indicating if the resolution should be adaptive
	 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
	 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
	 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
	 */
	Graphics.CURVES = {
	    adaptive: false,
	    maxLength: 10,
	    minSegments: 8,
	    maxSegments: 2048
	};
	//# sourceMappingURL=Graphics.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CanvasRenderer = __webpack_require__(28);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _const = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they
	 * now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasGraphicsRenderer:
	 * https://github.com/libgdx/libgdx/blob/1.0.0/gdx/src/com/badlogic/gdx/graphics/glutils/ShapeRenderer.java
	 */
	
	/**
	 * Renderer dedicated to drawing and batching graphics objects.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var CanvasGraphicsRenderer = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The current PIXI renderer.
	     */
	    function CanvasGraphicsRenderer(renderer) {
	        _classCallCheck(this, CanvasGraphicsRenderer);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * Renders a Graphics object to a canvas.
	     *
	     * @param {PIXI.Graphics} graphics - the actual graphics object to render
	     */
	
	
	    CanvasGraphicsRenderer.prototype.render = function render(graphics) {
	        var renderer = this.renderer;
	        var context = renderer.context;
	        var worldAlpha = graphics.worldAlpha;
	        var transform = graphics.transform.worldTransform;
	        var resolution = renderer.resolution;
	
	        // if the tint has changed, set the graphics object to dirty.
	        if (this._prevTint !== this.tint) {
	            this.dirty = true;
	        }
	
	        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
	
	        if (graphics.dirty) {
	            this.updateGraphicsTint(graphics);
	            graphics.dirty = false;
	        }
	
	        renderer.setBlendMode(graphics.blendMode);
	
	        for (var i = 0; i < graphics.graphicsData.length; i++) {
	            var data = graphics.graphicsData[i];
	            var shape = data.shape;
	
	            var fillColor = data._fillTint;
	            var lineColor = data._lineTint;
	
	            context.lineWidth = data.lineWidth;
	
	            if (data.type === _const.SHAPES.POLY) {
	                context.beginPath();
	
	                this.renderPolygon(shape.points, shape.closed, context);
	
	                for (var j = 0; j < data.holes.length; j++) {
	                    this.renderPolygon(data.holes[j].points, true, context);
	                }
	
	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.RECT) {
	                if (data.fillColor || data.fillColor === 0) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fillRect(shape.x, shape.y, shape.width, shape.height);
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.strokeRect(shape.x, shape.y, shape.width, shape.height);
	                }
	            } else if (data.type === _const.SHAPES.CIRC) {
	                // TODO - need to be Undefined!
	                context.beginPath();
	                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	                context.closePath();
	
	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	
	                var w = shape.width * 2;
	                var h = shape.height * 2;
	
	                var x = shape.x - w / 2;
	                var y = shape.y - h / 2;
	
	                context.beginPath();
	
	                var kappa = 0.5522848;
	                var ox = w / 2 * kappa; // control point offset horizontal
	                var oy = h / 2 * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + w / 2; // x-middle
	                var ym = y + h / 2; // y-middle
	
	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	
	                context.closePath();
	
	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.RREC) {
	                var rx = shape.x;
	                var ry = shape.y;
	                var width = shape.width;
	                var height = shape.height;
	                var radius = shape.radius;
	
	                var maxRadius = Math.min(width, height) / 2 | 0;
	
	                radius = radius > maxRadius ? maxRadius : radius;
	
	                context.beginPath();
	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();
	
	                if (data.fillColor || data.fillColor === 0) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            }
	        }
	    };
	
	    /**
	     * Updates the tint of a graphics object
	     *
	     * @private
	     * @param {PIXI.Graphics} graphics - the graphics that will have its tint updated
	     */
	
	
	    CanvasGraphicsRenderer.prototype.updateGraphicsTint = function updateGraphicsTint(graphics) {
	        graphics._prevTint = graphics.tint;
	
	        var tintR = (graphics.tint >> 16 & 0xFF) / 255;
	        var tintG = (graphics.tint >> 8 & 0xFF) / 255;
	        var tintB = (graphics.tint & 0xFF) / 255;
	
	        for (var i = 0; i < graphics.graphicsData.length; ++i) {
	            var data = graphics.graphicsData[i];
	
	            var fillColor = data.fillColor | 0;
	            var lineColor = data.lineColor | 0;
	
	            // super inline, cos optimization :)
	            data._fillTint = ((fillColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((fillColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (fillColor & 0xFF) / 255 * tintB * 255;
	
	            data._lineTint = ((lineColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((lineColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (lineColor & 0xFF) / 255 * tintB * 255;
	        }
	    };
	
	    /**
	     * Renders a polygon.
	     *
	     * @param {PIXI.Point[]} points - The points to render
	     * @param {boolean} close - Should the polygon be closed
	     * @param {CanvasRenderingContext2D} context - The rendering context to use
	     */
	
	
	    CanvasGraphicsRenderer.prototype.renderPolygon = function renderPolygon(points, close, context) {
	        context.moveTo(points[0], points[1]);
	
	        for (var j = 1; j < points.length / 2; ++j) {
	            context.lineTo(points[j * 2], points[j * 2 + 1]);
	        }
	
	        if (close) {
	            context.closePath();
	        }
	    };
	
	    /**
	     * destroy graphics object
	     *
	     */
	
	
	    CanvasGraphicsRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };
	
	    return CanvasGraphicsRenderer;
	}();
	
	exports.default = CanvasGraphicsRenderer;
	
	
	_CanvasRenderer2.default.registerPlugin('graphics', CanvasGraphicsRenderer);
	//# sourceMappingURL=CanvasGraphicsRenderer.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = bezierCurveTo;
	/**
	 * Calculate the points for a bezier curve and then draws it.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @param {number} fromX - Starting point x
	 * @param {number} fromY - Starting point y
	 * @param {number} cpX - Control point x
	 * @param {number} cpY - Control point y
	 * @param {number} cpX2 - Second Control point x
	 * @param {number} cpY2 - Second Control point y
	 * @param {number} toX - Destination point x
	 * @param {number} toY - Destination point y
	 * @param {number} n - Number of segments approximating the bezier curve
	 * @param {number[]} [path=[]] - Path array to push points into
	 * @return {number[]} Array of points of the curve
	 */
	function bezierCurveTo(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n) {
	    var path = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : [];
	
	    var dt = 0;
	    var dt2 = 0;
	    var dt3 = 0;
	    var t2 = 0;
	    var t3 = 0;
	
	    path.push(fromX, fromY);
	
	    for (var i = 1, j = 0; i <= n; ++i) {
	        j = i / n;
	
	        dt = 1 - j;
	        dt2 = dt * dt;
	        dt3 = dt2 * dt;
	
	        t2 = j * j;
	        t3 = t2 * j;
	
	        path.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
	    }
	
	    return path;
	}
	//# sourceMappingURL=bezierCurveTo.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(5);
	
	var _const = __webpack_require__(3);
	
	var _ObjectRenderer2 = __webpack_require__(36);
	
	var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);
	
	var _WebGLRenderer = __webpack_require__(35);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	var _WebGLGraphicsData = __webpack_require__(206);
	
	var _WebGLGraphicsData2 = _interopRequireDefault(_WebGLGraphicsData);
	
	var _PrimitiveShader = __webpack_require__(207);
	
	var _PrimitiveShader2 = _interopRequireDefault(_PrimitiveShader);
	
	var _buildPoly = __webpack_require__(209);
	
	var _buildPoly2 = _interopRequireDefault(_buildPoly);
	
	var _buildRectangle = __webpack_require__(210);
	
	var _buildRectangle2 = _interopRequireDefault(_buildRectangle);
	
	var _buildRoundedRectangle = __webpack_require__(211);
	
	var _buildRoundedRectangle2 = _interopRequireDefault(_buildRoundedRectangle);
	
	var _buildCircle = __webpack_require__(208);
	
	var _buildCircle2 = _interopRequireDefault(_buildCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders the graphics object.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	var GraphicsRenderer = function (_ObjectRenderer) {
	    _inherits(GraphicsRenderer, _ObjectRenderer);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this object renderer works for.
	     */
	    function GraphicsRenderer(renderer) {
	        _classCallCheck(this, GraphicsRenderer);
	
	        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));
	
	        _this.graphicsDataPool = [];
	
	        _this.primitiveShader = null;
	
	        _this.gl = renderer.gl;
	
	        // easy access!
	        _this.CONTEXT_UID = 0;
	        return _this;
	    }
	
	    /**
	     * Called when there is a WebGL context change
	     *
	     * @private
	     *
	     */
	
	
	    GraphicsRenderer.prototype.onContextChange = function onContextChange() {
	        this.gl = this.renderer.gl;
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	        this.primitiveShader = new _PrimitiveShader2.default(this.gl);
	    };
	
	    /**
	     * Destroys this renderer.
	     *
	     */
	
	
	    GraphicsRenderer.prototype.destroy = function destroy() {
	        _ObjectRenderer3.default.prototype.destroy.call(this);
	
	        for (var i = 0; i < this.graphicsDataPool.length; ++i) {
	            this.graphicsDataPool[i].destroy();
	        }
	
	        this.graphicsDataPool = null;
	    };
	
	    /**
	     * Renders a graphics object.
	     *
	     * @param {PIXI.Graphics} graphics - The graphics object to render.
	     */
	
	
	    GraphicsRenderer.prototype.render = function render(graphics) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;
	
	        var webGLData = void 0;
	        var webGL = graphics._webGL[this.CONTEXT_UID];
	
	        if (!webGL || graphics.dirty !== webGL.dirty) {
	            this.updateGraphics(graphics);
	
	            webGL = graphics._webGL[this.CONTEXT_UID];
	        }
	
	        // This  could be speeded up for sure!
	        var shader = this.primitiveShader;
	
	        renderer.bindShader(shader);
	        renderer.state.setBlendMode(graphics.blendMode);
	
	        for (var i = 0, n = webGL.data.length; i < n; i++) {
	            webGLData = webGL.data[i];
	            var shaderTemp = webGLData.shader;
	
	            renderer.bindShader(shaderTemp);
	            shaderTemp.uniforms.translationMatrix = graphics.transform.worldTransform.toArray(true);
	            shaderTemp.uniforms.tint = (0, _utils.hex2rgb)(graphics.tint);
	            shaderTemp.uniforms.alpha = graphics.worldAlpha;
	
	            renderer.bindVao(webGLData.vao);
	
	            if (webGLData.nativeLines) {
	                gl.drawArrays(gl.LINES, 0, webGLData.points.length / 6);
	            } else {
	                webGLData.vao.draw(gl.TRIANGLE_STRIP, webGLData.indices.length);
	            }
	        }
	    };
	
	    /**
	     * Updates the graphics object
	     *
	     * @private
	     * @param {PIXI.Graphics} graphics - The graphics object to update
	     */
	
	
	    GraphicsRenderer.prototype.updateGraphics = function updateGraphics(graphics) {
	        var gl = this.renderer.gl;
	
	        // get the contexts graphics object
	        var webGL = graphics._webGL[this.CONTEXT_UID];
	
	        // if the graphics object does not exist in the webGL context time to create it!
	        if (!webGL) {
	            webGL = graphics._webGL[this.CONTEXT_UID] = { lastIndex: 0, data: [], gl: gl, clearDirty: -1, dirty: -1 };
	        }
	
	        // flag the graphics as not dirty as we are about to update it...
	        webGL.dirty = graphics.dirty;
	
	        // if the user cleared the graphics object we will need to clear every object
	        if (graphics.clearDirty !== webGL.clearDirty) {
	            webGL.clearDirty = graphics.clearDirty;
	
	            // loop through and return all the webGLDatas to the object pool so than can be reused later on
	            for (var i = 0; i < webGL.data.length; i++) {
	                this.graphicsDataPool.push(webGL.data[i]);
	            }
	
	            // clear the array and reset the index..
	            webGL.data.length = 0;
	            webGL.lastIndex = 0;
	        }
	
	        var webGLData = void 0;
	        var webGLDataNativeLines = void 0;
	
	        // loop through the graphics datas and construct each one..
	        // if the object is a complex fill then the new stencil buffer technique will be used
	        // other wise graphics objects will be pushed into a batch..
	        for (var _i = webGL.lastIndex; _i < graphics.graphicsData.length; _i++) {
	            var data = graphics.graphicsData[_i];
	
	            // TODO - this can be simplified
	            webGLData = this.getWebGLData(webGL, 0);
	
	            if (data.nativeLines && data.lineWidth) {
	                webGLDataNativeLines = this.getWebGLData(webGL, 0, true);
	                webGL.lastIndex++;
	            }
	
	            if (data.type === _const.SHAPES.POLY) {
	                (0, _buildPoly2.default)(data, webGLData, webGLDataNativeLines);
	            }
	            if (data.type === _const.SHAPES.RECT) {
	                (0, _buildRectangle2.default)(data, webGLData, webGLDataNativeLines);
	            } else if (data.type === _const.SHAPES.CIRC || data.type === _const.SHAPES.ELIP) {
	                (0, _buildCircle2.default)(data, webGLData, webGLDataNativeLines);
	            } else if (data.type === _const.SHAPES.RREC) {
	                (0, _buildRoundedRectangle2.default)(data, webGLData, webGLDataNativeLines);
	            }
	
	            webGL.lastIndex++;
	        }
	
	        this.renderer.bindVao(null);
	
	        // upload all the dirty data...
	        for (var _i2 = 0; _i2 < webGL.data.length; _i2++) {
	            webGLData = webGL.data[_i2];
	
	            if (webGLData.dirty) {
	                webGLData.upload();
	            }
	        }
	    };
	
	    /**
	     *
	     * @private
	     * @param {WebGLRenderingContext} gl - the current WebGL drawing context
	     * @param {number} type - TODO @Alvin
	     * @param {number} nativeLines - indicate whether the webGLData use for nativeLines.
	     * @return {*} TODO
	     */
	
	
	    GraphicsRenderer.prototype.getWebGLData = function getWebGLData(gl, type, nativeLines) {
	        var webGLData = gl.data[gl.data.length - 1];
	
	        if (!webGLData || webGLData.nativeLines !== nativeLines || webGLData.points.length > 320000) {
	            webGLData = this.graphicsDataPool.pop() || new _WebGLGraphicsData2.default(this.renderer.gl, this.primitiveShader, this.renderer.state.attribsState);
	            webGLData.nativeLines = nativeLines;
	            webGLData.reset(type);
	            gl.data.push(webGLData);
	        }
	
	        webGLData.dirty = true;
	
	        return webGLData;
	    };
	
	    return GraphicsRenderer;
	}(_ObjectRenderer3.default);
	
	exports.default = GraphicsRenderer;
	
	
	_WebGLRenderer2.default.registerPlugin('graphics', GraphicsRenderer);
	//# sourceMappingURL=GraphicsRenderer.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * An object containing WebGL specific properties to be used by the WebGL renderer
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var WebGLGraphicsData = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	   * @param {PIXI.Shader} shader - The shader
	   * @param {object} attribsState - The state for the VAO
	   */
	  function WebGLGraphicsData(gl, shader, attribsState) {
	    _classCallCheck(this, WebGLGraphicsData);
	
	    /**
	     * The current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;
	
	    // TODO does this need to be split before uploading??
	    /**
	     * An array of color components (r,g,b)
	     * @member {number[]}
	     */
	    this.color = [0, 0, 0]; // color split!
	
	    /**
	     * An array of points to draw
	     * @member {PIXI.Point[]}
	     */
	    this.points = [];
	
	    /**
	     * The indices of the vertices
	     * @member {number[]}
	     */
	    this.indices = [];
	    /**
	     * The main buffer
	     * @member {WebGLBuffer}
	     */
	    this.buffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl);
	
	    /**
	     * The index buffer
	     * @member {WebGLBuffer}
	     */
	    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl);
	
	    /**
	     * Whether this graphics is dirty or not
	     * @member {boolean}
	     */
	    this.dirty = true;
	
	    /**
	     * Whether this graphics is nativeLines or not
	     * @member {boolean}
	     */
	    this.nativeLines = false;
	
	    this.glPoints = null;
	    this.glIndices = null;
	
	    /**
	     *
	     * @member {PIXI.Shader}
	     */
	    this.shader = shader;
	
	    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, attribsState).addIndex(this.indexBuffer).addAttribute(this.buffer, shader.attributes.aVertexPosition, gl.FLOAT, false, 4 * 6, 0).addAttribute(this.buffer, shader.attributes.aColor, gl.FLOAT, false, 4 * 6, 2 * 4);
	  }
	
	  /**
	   * Resets the vertices and the indices
	   */
	
	
	  WebGLGraphicsData.prototype.reset = function reset() {
	    this.points.length = 0;
	    this.indices.length = 0;
	  };
	
	  /**
	   * Binds the buffers and uploads the data
	   */
	
	
	  WebGLGraphicsData.prototype.upload = function upload() {
	    this.glPoints = new Float32Array(this.points);
	    this.buffer.upload(this.glPoints);
	
	    this.glIndices = new Uint16Array(this.indices);
	    this.indexBuffer.upload(this.glIndices);
	
	    this.dirty = false;
	  };
	
	  /**
	   * Empties all the data
	   */
	
	
	  WebGLGraphicsData.prototype.destroy = function destroy() {
	    this.color = null;
	    this.points = null;
	    this.indices = null;
	
	    this.vao.destroy();
	    this.buffer.destroy();
	    this.indexBuffer.destroy();
	
	    this.gl = null;
	
	    this.buffer = null;
	    this.indexBuffer = null;
	
	    this.glPoints = null;
	    this.glIndices = null;
	  };
	
	  return WebGLGraphicsData;
	}();
	
	exports.default = WebGLGraphicsData;
	//# sourceMappingURL=WebGLGraphicsData.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Shader2 = __webpack_require__(26);
	
	var _Shader3 = _interopRequireDefault(_Shader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This shader is used to draw simple primitive shapes for {@link PIXI.Graphics}.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */
	var PrimitiveShader = function (_Shader) {
	    _inherits(PrimitiveShader, _Shader);
	
	    /**
	     * @param {WebGLRenderingContext} gl - The webgl shader manager this shader works for.
	     */
	    function PrimitiveShader(gl) {
	        _classCallCheck(this, PrimitiveShader);
	
	        return _possibleConstructorReturn(this, _Shader.call(this, gl,
	        // vertex shader
	        ['attribute vec2 aVertexPosition;', 'attribute vec4 aColor;', 'uniform mat3 translationMatrix;', 'uniform mat3 projectionMatrix;', 'uniform float alpha;', 'uniform vec3 tint;', 'varying vec4 vColor;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vColor = aColor * vec4(tint * alpha, alpha);', '}'].join('\n'),
	        // fragment shader
	        ['varying vec4 vColor;', 'void main(void){', '   gl_FragColor = vColor;', '}'].join('\n')));
	    }
	
	    return PrimitiveShader;
	}(_Shader3.default);
	
	exports.default = PrimitiveShader;
	//# sourceMappingURL=PrimitiveShader.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildCircle;
	
	var _buildLine = __webpack_require__(34);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _const = __webpack_require__(3);
	
	var _utils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a circle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildCircle(graphicsData, webGLData, webGLDataNativeLines) {
	    // need to convert points to a nice regular data
	    var circleData = graphicsData.shape;
	    var x = circleData.x;
	    var y = circleData.y;
	    var width = void 0;
	    var height = void 0;
	
	    // TODO - bit hacky??
	    if (graphicsData.type === _const.SHAPES.CIRC) {
	        width = circleData.radius;
	        height = circleData.radius;
	    } else {
	        width = circleData.width;
	        height = circleData.height;
	    }
	
	    if (width === 0 || height === 0) {
	        return;
	    }
	
	    var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(circleData.width + circleData.height));
	
	    var seg = Math.PI * 2 / totalSegs;
	
	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vecPos = verts.length / 6;
	
	        indices.push(vecPos);
	
	        for (var i = 0; i < totalSegs + 1; i++) {
	            verts.push(x, y, r, g, b, alpha);
	
	            verts.push(x + Math.sin(seg * i) * width, y + Math.cos(seg * i) * height, r, g, b, alpha);
	
	            indices.push(vecPos++, vecPos++);
	        }
	
	        indices.push(vecPos - 1);
	    }
	
	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = [];
	
	        for (var _i = 0; _i < totalSegs + 1; _i++) {
	            graphicsData.points.push(x + Math.sin(seg * -_i) * width, y + Math.cos(seg * -_i) * height);
	        }
	
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	
	        graphicsData.points = tempPoints;
	    }
	}
	//# sourceMappingURL=buildCircle.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildPoly;
	
	var _buildLine = __webpack_require__(34);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _utils = __webpack_require__(5);
	
	var _earcut = __webpack_require__(54);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a polygon to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildPoly(graphicsData, webGLData, webGLDataNativeLines) {
	    graphicsData.points = graphicsData.shape.points.slice();
	
	    var points = graphicsData.points;
	
	    if (graphicsData.fill && points.length >= 6) {
	        var holeArray = [];
	        // Process holes..
	        var holes = graphicsData.holes;
	
	        for (var i = 0; i < holes.length; i++) {
	            var hole = holes[i];
	
	            holeArray.push(points.length / 2);
	
	            points = points.concat(hole.points);
	        }
	
	        // get first and last point.. figure out the middle!
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var length = points.length / 2;
	
	        // sort color
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var triangles = (0, _earcut2.default)(points, holeArray, 2);
	
	        if (!triangles) {
	            return;
	        }
	
	        var vertPos = verts.length / 6;
	
	        for (var _i = 0; _i < triangles.length; _i += 3) {
	            indices.push(triangles[_i] + vertPos);
	            indices.push(triangles[_i] + vertPos);
	            indices.push(triangles[_i + 1] + vertPos);
	            indices.push(triangles[_i + 2] + vertPos);
	            indices.push(triangles[_i + 2] + vertPos);
	        }
	
	        for (var _i2 = 0; _i2 < length; _i2++) {
	            verts.push(points[_i2 * 2], points[_i2 * 2 + 1], r, g, b, alpha);
	        }
	    }
	
	    if (graphicsData.lineWidth > 0) {
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	    }
	}
	//# sourceMappingURL=buildPoly.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildRectangle;
	
	var _buildLine = __webpack_require__(34);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _utils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildRectangle(graphicsData, webGLData, webGLDataNativeLines) {
	    // --- //
	    // need to convert points to a nice regular data
	    //
	    var rectData = graphicsData.shape;
	    var x = rectData.x;
	    var y = rectData.y;
	    var width = rectData.width;
	    var height = rectData.height;
	
	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vertPos = verts.length / 6;
	
	        // start
	        verts.push(x, y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x + width, y);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x, y + height);
	        verts.push(r, g, b, alpha);
	
	        verts.push(x + width, y + height);
	        verts.push(r, g, b, alpha);
	
	        // insert 2 dead triangles..
	        indices.push(vertPos, vertPos, vertPos + 1, vertPos + 2, vertPos + 3, vertPos + 3);
	    }
	
	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = [x, y, x + width, y, x + width, y + height, x, y + height, x, y];
	
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	
	        graphicsData.points = tempPoints;
	    }
	}
	//# sourceMappingURL=buildRectangle.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = buildRoundedRectangle;
	
	var _earcut = __webpack_require__(54);
	
	var _earcut2 = _interopRequireDefault(_earcut);
	
	var _buildLine = __webpack_require__(34);
	
	var _buildLine2 = _interopRequireDefault(_buildLine);
	
	var _utils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Builds a rounded rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildRoundedRectangle(graphicsData, webGLData, webGLDataNativeLines) {
	    var rrectData = graphicsData.shape;
	    var x = rrectData.x;
	    var y = rrectData.y;
	    var width = rrectData.width;
	    var height = rrectData.height;
	
	    var radius = rrectData.radius;
	
	    var recPoints = [];
	
	    recPoints.push(x, y + radius);
	    quadraticBezierCurve(x, y + height - radius, x, y + height, x + radius, y + height, recPoints);
	    quadraticBezierCurve(x + width - radius, y + height, x + width, y + height, x + width, y + height - radius, recPoints);
	    quadraticBezierCurve(x + width, y + radius, x + width, y, x + width - radius, y, recPoints);
	    quadraticBezierCurve(x + radius, y, x, y, x, y + radius + 0.0000000001, recPoints);
	
	    // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
	    // TODO - fix this properly, this is not very elegant.. but it works for now.
	
	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;
	
	        var verts = webGLData.points;
	        var indices = webGLData.indices;
	
	        var vecPos = verts.length / 6;
	
	        var triangles = (0, _earcut2.default)(recPoints, null, 2);
	
	        for (var i = 0, j = triangles.length; i < j; i += 3) {
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i + 1] + vecPos);
	            indices.push(triangles[i + 2] + vecPos);
	            indices.push(triangles[i + 2] + vecPos);
	        }
	
	        for (var _i = 0, _j = recPoints.length; _i < _j; _i++) {
	            verts.push(recPoints[_i], recPoints[++_i], r, g, b, alpha);
	        }
	    }
	
	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;
	
	        graphicsData.points = recPoints;
	
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	
	        graphicsData.points = tempPoints;
	    }
	}
	
	/**
	 * Calculate a single point for a quadratic bezier curve.
	 * Utility function used by quadraticBezierCurve.
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} n1 - first number
	 * @param {number} n2 - second number
	 * @param {number} perc - percentage
	 * @return {number} the result
	 *
	 */
	function getPt(n1, n2, perc) {
	    var diff = n2 - n1;
	
	    return n1 + diff * perc;
	}
	
	/**
	 * Calculate the points for a quadratic bezier curve. (helper function..)
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} fromX - Origin point x
	 * @param {number} fromY - Origin point x
	 * @param {number} cpX - Control point x
	 * @param {number} cpY - Control point y
	 * @param {number} toX - Destination point x
	 * @param {number} toY - Destination point y
	 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
	 * @return {number[]} an array of points
	 */
	function quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY) {
	    var out = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
	
	    var n = 20;
	    var points = out;
	
	    var xa = 0;
	    var ya = 0;
	    var xb = 0;
	    var yb = 0;
	    var x = 0;
	    var y = 0;
	
	    for (var i = 0, j = 0; i <= n; ++i) {
	        j = i / n;
	
	        // The Green Line
	        xa = getPt(fromX, cpX, j);
	        ya = getPt(fromY, cpY, j);
	        xb = getPt(cpX, toX, j);
	        yb = getPt(cpY, toY, j);
	
	        // The Black Dot
	        x = getPt(xa, xb, j);
	        y = getPt(ya, yb, j);
	
	        points.push(x, y);
	    }
	
	    return points;
	}
	//# sourceMappingURL=buildRoundedRectangle.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Rectangle = __webpack_require__(62);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _const = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Circle object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Circle = function () {
	  /**
	   * @param {number} [x=0] - The X coordinate of the center of this circle
	   * @param {number} [y=0] - The Y coordinate of the center of this circle
	   * @param {number} [radius=0] - The radius of the circle
	   */
	  function Circle() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    _classCallCheck(this, Circle);
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.radius = radius;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     * @readOnly
	     * @default PIXI.SHAPES.CIRC
	     * @see PIXI.SHAPES
	     */
	    this.type = _const.SHAPES.CIRC;
	  }
	
	  /**
	   * Creates a clone of this Circle instance
	   *
	   * @return {PIXI.Circle} a copy of the Circle
	   */
	
	
	  Circle.prototype.clone = function clone() {
	    return new Circle(this.x, this.y, this.radius);
	  };
	
	  /**
	   * Checks whether the x and y coordinates given are contained within this circle
	   *
	   * @param {number} x - The X coordinate of the point to test
	   * @param {number} y - The Y coordinate of the point to test
	   * @return {boolean} Whether the x/y coordinates are within this Circle
	   */
	
	
	  Circle.prototype.contains = function contains(x, y) {
	    if (this.radius <= 0) {
	      return false;
	    }
	
	    var r2 = this.radius * this.radius;
	    var dx = this.x - x;
	    var dy = this.y - y;
	
	    dx *= dx;
	    dy *= dy;
	
	    return dx + dy <= r2;
	  };
	
	  /**
	  * Returns the framing rectangle of the circle as a Rectangle object
	  *
	  * @return {PIXI.Rectangle} the framing rectangle
	  */
	
	
	  Circle.prototype.getBounds = function getBounds() {
	    return new _Rectangle2.default(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
	  };
	
	  return Circle;
	}();
	
	exports.default = Circle;
	//# sourceMappingURL=Circle.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Rectangle = __webpack_require__(62);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _const = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Ellipse object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Ellipse = function () {
	  /**
	   * @param {number} [x=0] - The X coordinate of the center of this circle
	   * @param {number} [y=0] - The Y coordinate of the center of this circle
	   * @param {number} [width=0] - The half width of this ellipse
	   * @param {number} [height=0] - The half height of this ellipse
	   */
	  function Ellipse() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    _classCallCheck(this, Ellipse);
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.width = width;
	
	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.height = height;
	
	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     * @readOnly
	     * @default PIXI.SHAPES.ELIP
	     * @see PIXI.SHAPES
	     */
	    this.type = _const.SHAPES.ELIP;
	  }
	
	  /**
	   * Creates a clone of this Ellipse instance
	   *
	   * @return {PIXI.Ellipse} a copy of the ellipse
	   */
	
	
	  Ellipse.prototype.clone = function clone() {
	    return new Ellipse(this.x, this.y, this.width, this.height);
	  };
	
	  /**
	   * Checks whether the x and y coordinates given are contained within this ellipse
	   *
	   * @param {number} x - The X coordinate of the point to test
	   * @param {number} y - The Y coordinate of the point to test
	   * @return {boolean} Whether the x/y coords are within this ellipse
	   */
	
	
	  Ellipse.prototype.contains = function contains(x, y) {
	    if (this.width <= 0 || this.height <= 0) {
	      return false;
	    }
	
	    // normalize the coords to an ellipse with center 0,0
	    var normx = (x - this.x) / this.width;
	    var normy = (y - this.y) / this.height;
	
	    normx *= normx;
	    normy *= normy;
	
	    return normx + normy <= 1;
	  };
	
	  /**
	   * Returns the framing rectangle of the ellipse as a Rectangle object
	   *
	   * @return {PIXI.Rectangle} the framing rectangle
	   */
	
	
	  Ellipse.prototype.getBounds = function getBounds() {
	    return new _Rectangle2.default(this.x - this.width, this.y - this.height, this.width, this.height);
	  };
	
	  return Ellipse;
	}();
	
	exports.default = Ellipse;
	//# sourceMappingURL=Ellipse.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Point = __webpack_require__(61);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _const = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var Polygon = function () {
	    /**
	     * @param {PIXI.Point[]|number[]} points - This can be an array of Points
	     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
	     *  the arguments passed can be all the points of the polygon e.g.
	     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
	     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
	     */
	    function Polygon() {
	        for (var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++) {
	            points[_key] = arguments[_key];
	        }
	
	        _classCallCheck(this, Polygon);
	
	        if (Array.isArray(points[0])) {
	            points = points[0];
	        }
	
	        // if this is an array of points, convert it to a flat array of numbers
	        if (points[0] instanceof _Point2.default) {
	            var p = [];
	
	            for (var i = 0, il = points.length; i < il; i++) {
	                p.push(points[i].x, points[i].y);
	            }
	
	            points = p;
	        }
	
	        this.closed = true;
	
	        /**
	         * An array of the points of this polygon
	         *
	         * @member {number[]}
	         */
	        this.points = points;
	
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.POLY
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.POLY;
	    }
	
	    /**
	     * Creates a clone of this polygon
	     *
	     * @return {PIXI.Polygon} a copy of the polygon
	     */
	
	
	    Polygon.prototype.clone = function clone() {
	        return new Polygon(this.points.slice());
	    };
	
	    /**
	     * Closes the polygon, adding points if necessary.
	     *
	     */
	
	
	    Polygon.prototype.close = function close() {
	        var points = this.points;
	
	        // close the poly if the value is true!
	        if (points[0] !== points[points.length - 2] || points[1] !== points[points.length - 1]) {
	            points.push(points[0], points[1]);
	        }
	    };
	
	    /**
	     * Checks whether the x and y coordinates passed to this function are contained within this polygon
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this polygon
	     */
	
	
	    Polygon.prototype.contains = function contains(x, y) {
	        var inside = false;
	
	        // use some raycasting to test hits
	        // https://github.com/substack/point-in-polygon/blob/master/index.js
	        var length = this.points.length / 2;
	
	        for (var i = 0, j = length - 1; i < length; j = i++) {
	            var xi = this.points[i * 2];
	            var yi = this.points[i * 2 + 1];
	            var xj = this.points[j * 2];
	            var yj = this.points[j * 2 + 1];
	            var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
	
	            if (intersect) {
	                inside = !inside;
	            }
	        }
	
	        return inside;
	    };
	
	    return Polygon;
	}();
	
	exports.default = Polygon;
	//# sourceMappingURL=Polygon.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _const = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
	 * top-left corner point (x, y) and by its width and its height and its radius.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var RoundedRectangle = function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [width=0] - The overall width of this rounded rectangle
	     * @param {number} [height=0] - The overall height of this rounded rectangle
	     * @param {number} [radius=20] - Controls the radius of the rounded corners
	     */
	    function RoundedRectangle() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	        var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;
	
	        _classCallCheck(this, RoundedRectangle);
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = x;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = y;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = width;
	
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = height;
	
	        /**
	         * @member {number}
	         * @default 20
	         */
	        this.radius = radius;
	
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readonly
	         * @default PIXI.SHAPES.RREC
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.RREC;
	    }
	
	    /**
	     * Creates a clone of this Rounded Rectangle
	     *
	     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
	     */
	
	
	    RoundedRectangle.prototype.clone = function clone() {
	        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
	    };
	
	    /**
	     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
	     */
	
	
	    RoundedRectangle.prototype.contains = function contains(x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	        if (x >= this.x && x <= this.x + this.width) {
	            if (y >= this.y && y <= this.y + this.height) {
	                if (y >= this.y + this.radius && y <= this.y + this.height - this.radius || x >= this.x + this.radius && x <= this.x + this.width - this.radius) {
	                    return true;
	                }
	                var dx = x - (this.x + this.radius);
	                var dy = y - (this.y + this.radius);
	                var radius2 = this.radius * this.radius;
	
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.width - this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dy = y - (this.y + this.height - this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	            }
	        }
	
	        return false;
	    };
	
	    return RoundedRectangle;
	}();
	
	exports.default = RoundedRectangle;
	//# sourceMappingURL=RoundedRectangle.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _const = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A set of functions used to handle masking.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasMaskManager = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	     */
	    function CanvasMaskManager(renderer) {
	        _classCallCheck(this, CanvasMaskManager);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * This method adds it to the current stack of masks.
	     *
	     * @param {object} maskData - the maskData that will be pushed
	     */
	
	
	    CanvasMaskManager.prototype.pushMask = function pushMask(maskData) {
	        var renderer = this.renderer;
	
	        renderer.context.save();
	
	        var cacheAlpha = maskData.alpha;
	        var transform = maskData.transform.worldTransform;
	        var resolution = renderer.resolution;
	
	        renderer.context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
	
	        // TODO suport sprite alpha masks??
	        // lots of effort required. If demand is great enough..
	        if (!maskData._texture) {
	            this.renderGraphicsShape(maskData);
	            renderer.context.clip();
	        }
	
	        maskData.worldAlpha = cacheAlpha;
	    };
	
	    /**
	     * Renders a PIXI.Graphics shape.
	     *
	     * @param {PIXI.Graphics} graphics - The object to render.
	     */
	
	
	    CanvasMaskManager.prototype.renderGraphicsShape = function renderGraphicsShape(graphics) {
	        var context = this.renderer.context;
	        var len = graphics.graphicsData.length;
	
	        if (len === 0) {
	            return;
	        }
	
	        context.beginPath();
	
	        for (var i = 0; i < len; i++) {
	            var data = graphics.graphicsData[i];
	            var shape = data.shape;
	
	            if (data.type === _const.SHAPES.POLY) {
	                var points = shape.points;
	
	                context.moveTo(points[0], points[1]);
	
	                for (var j = 1; j < points.length / 2; j++) {
	                    context.lineTo(points[j * 2], points[j * 2 + 1]);
	                }
	
	                // if the first and last point are the same close the path - much neater :)
	                if (points[0] === points[points.length - 2] && points[1] === points[points.length - 1]) {
	                    context.closePath();
	                }
	            } else if (data.type === _const.SHAPES.RECT) {
	                context.rect(shape.x, shape.y, shape.width, shape.height);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.CIRC) {
	                // TODO - need to be Undefined!
	                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	
	                var w = shape.width * 2;
	                var h = shape.height * 2;
	
	                var x = shape.x - w / 2;
	                var y = shape.y - h / 2;
	
	                var kappa = 0.5522848;
	                var ox = w / 2 * kappa; // control point offset horizontal
	                var oy = h / 2 * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + w / 2; // x-middle
	                var ym = y + h / 2; // y-middle
	
	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.RREC) {
	                var rx = shape.x;
	                var ry = shape.y;
	                var width = shape.width;
	                var height = shape.height;
	                var radius = shape.radius;
	
	                var maxRadius = Math.min(width, height) / 2 | 0;
	
	                radius = radius > maxRadius ? maxRadius : radius;
	
	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();
	            }
	        }
	    };
	
	    /**
	     * Restores the current drawing context to the state it was before the mask was applied.
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer context to use.
	     */
	
	
	    CanvasMaskManager.prototype.popMask = function popMask(renderer) {
	        renderer.context.restore();
	        renderer.invalidateBlendMode();
	    };
	
	    /**
	     * Destroys this canvas mask manager.
	     *
	     */
	
	
	    CanvasMaskManager.prototype.destroy = function destroy() {
	        /* empty */
	    };
	
	    return CanvasMaskManager;
	}();
	
	exports.default = CanvasMaskManager;
	//# sourceMappingURL=CanvasMaskManager.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapCanvasBlendModesToPixi;
	
	var _const = __webpack_require__(3);
	
	var _canUseNewCanvasBlendModes = __webpack_require__(111);
	
	var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Maps blend combinations to Canvas.
	 *
	 * @memberof PIXI
	 * @function mapCanvasBlendModesToPixi
	 * @private
	 * @param {string[]} [array=[]] - The array to output into.
	 * @return {string[]} Mapped modes.
	 */
	function mapCanvasBlendModesToPixi() {
	    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    if ((0, _canUseNewCanvasBlendModes2.default)()) {
	        array[_const.BLEND_MODES.NORMAL] = 'source-over';
	        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[_const.BLEND_MODES.MULTIPLY] = 'multiply';
	        array[_const.BLEND_MODES.SCREEN] = 'screen';
	        array[_const.BLEND_MODES.OVERLAY] = 'overlay';
	        array[_const.BLEND_MODES.DARKEN] = 'darken';
	        array[_const.BLEND_MODES.LIGHTEN] = 'lighten';
	        array[_const.BLEND_MODES.COLOR_DODGE] = 'color-dodge';
	        array[_const.BLEND_MODES.COLOR_BURN] = 'color-burn';
	        array[_const.BLEND_MODES.HARD_LIGHT] = 'hard-light';
	        array[_const.BLEND_MODES.SOFT_LIGHT] = 'soft-light';
	        array[_const.BLEND_MODES.DIFFERENCE] = 'difference';
	        array[_const.BLEND_MODES.EXCLUSION] = 'exclusion';
	        array[_const.BLEND_MODES.HUE] = 'hue';
	        array[_const.BLEND_MODES.SATURATION] = 'saturate';
	        array[_const.BLEND_MODES.COLOR] = 'color';
	        array[_const.BLEND_MODES.LUMINOSITY] = 'luminosity';
	    } else {
	        // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
	        array[_const.BLEND_MODES.NORMAL] = 'source-over';
	        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[_const.BLEND_MODES.MULTIPLY] = 'source-over';
	        array[_const.BLEND_MODES.SCREEN] = 'source-over';
	        array[_const.BLEND_MODES.OVERLAY] = 'source-over';
	        array[_const.BLEND_MODES.DARKEN] = 'source-over';
	        array[_const.BLEND_MODES.LIGHTEN] = 'source-over';
	        array[_const.BLEND_MODES.COLOR_DODGE] = 'source-over';
	        array[_const.BLEND_MODES.COLOR_BURN] = 'source-over';
	        array[_const.BLEND_MODES.HARD_LIGHT] = 'source-over';
	        array[_const.BLEND_MODES.SOFT_LIGHT] = 'source-over';
	        array[_const.BLEND_MODES.DIFFERENCE] = 'source-over';
	        array[_const.BLEND_MODES.EXCLUSION] = 'source-over';
	        array[_const.BLEND_MODES.HUE] = 'source-over';
	        array[_const.BLEND_MODES.SATURATION] = 'source-over';
	        array[_const.BLEND_MODES.COLOR] = 'source-over';
	        array[_const.BLEND_MODES.LUMINOSITY] = 'source-over';
	    }
	    // not-premultiplied, only for webgl
	    array[_const.BLEND_MODES.NORMAL_NPM] = array[_const.BLEND_MODES.NORMAL];
	    array[_const.BLEND_MODES.ADD_NPM] = array[_const.BLEND_MODES.ADD];
	    array[_const.BLEND_MODES.SCREEN_NPM] = array[_const.BLEND_MODES.SCREEN];
	
	    return array;
	}
	//# sourceMappingURL=mapCanvasBlendModesToPixi.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * TextureGarbageCollector. This class manages the GPU and ensures that it does not get clogged
	 * up with textures that are no longer being used.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextureGarbageCollector = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function TextureGarbageCollector(renderer) {
	        _classCallCheck(this, TextureGarbageCollector);
	
	        this.renderer = renderer;
	
	        this.count = 0;
	        this.checkCount = 0;
	        this.maxIdle = _settings2.default.GC_MAX_IDLE;
	        this.checkCountMax = _settings2.default.GC_MAX_CHECK_COUNT;
	        this.mode = _settings2.default.GC_MODE;
	    }
	
	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */
	
	
	    TextureGarbageCollector.prototype.update = function update() {
	        this.count++;
	
	        if (this.mode === _const.GC_MODES.MANUAL) {
	            return;
	        }
	
	        this.checkCount++;
	
	        if (this.checkCount > this.checkCountMax) {
	            this.checkCount = 0;
	
	            this.run();
	        }
	    };
	
	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */
	
	
	    TextureGarbageCollector.prototype.run = function run() {
	        var tm = this.renderer.textureManager;
	        var managedTextures = tm._managedTextures;
	        var wasRemoved = false;
	
	        for (var i = 0; i < managedTextures.length; i++) {
	            var texture = managedTextures[i];
	
	            // only supports non generated textures at the moment!
	            if (!texture._glRenderTargets && this.count - texture.touched > this.maxIdle) {
	                tm.destroyTexture(texture, true);
	                managedTextures[i] = null;
	                wasRemoved = true;
	            }
	        }
	
	        if (wasRemoved) {
	            var j = 0;
	
	            for (var _i = 0; _i < managedTextures.length; _i++) {
	                if (managedTextures[_i] !== null) {
	                    managedTextures[j++] = managedTextures[_i];
	                }
	            }
	
	            managedTextures.length = j;
	        }
	    };
	
	    /**
	     * Removes all the textures within the specified displayObject and its children from the GPU
	     *
	     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
	     */
	
	
	    TextureGarbageCollector.prototype.unload = function unload(displayObject) {
	        var tm = this.renderer.textureManager;
	
	        // only destroy non generated textures
	        if (displayObject._texture && displayObject._texture._glRenderTargets) {
	            tm.destroyTexture(displayObject._texture, true);
	        }
	
	        for (var i = displayObject.children.length - 1; i >= 0; i--) {
	            this.unload(displayObject.children[i]);
	        }
	    };
	
	    return TextureGarbageCollector;
	}();
	
	exports.default = TextureGarbageCollector;
	//# sourceMappingURL=TextureGarbageCollector.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _const = __webpack_require__(3);
	
	var _RenderTarget = __webpack_require__(37);
	
	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
	
	var _utils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Helper class to create a webGL Texture
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextureManager = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function TextureManager(renderer) {
	        _classCallCheck(this, TextureManager);
	
	        /**
	         * A reference to the current renderer
	         *
	         * @member {PIXI.WebGLRenderer}
	         */
	        this.renderer = renderer;
	
	        /**
	         * The current WebGL rendering context
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = renderer.gl;
	
	        /**
	         * Track textures in the renderer so we can no longer listen to them on destruction.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this._managedTextures = [];
	    }
	
	    /**
	     * Binds a texture.
	     *
	     */
	
	
	    TextureManager.prototype.bindTexture = function bindTexture() {}
	    // empty
	
	
	    /**
	     * Gets a texture.
	     *
	     */
	    ;
	
	    TextureManager.prototype.getTexture = function getTexture() {}
	    // empty
	
	
	    /**
	     * Updates and/or Creates a WebGL texture for the renderer's context.
	     *
	     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to update
	     * @param {number} location - the location the texture will be bound to.
	     * @return {GLTexture} The gl texture.
	     */
	    ;
	
	    TextureManager.prototype.updateTexture = function updateTexture(texture, location) {
	        // assume it good!
	        // texture = texture.baseTexture || texture;
	
	        var gl = this.gl;
	
	        var isRenderTexture = !!texture._glRenderTargets;
	
	        if (!texture.hasLoaded) {
	            return null;
	        }
	
	        var boundTextures = this.renderer.boundTextures;
	
	        // if the location is undefined then this may have been called by n event.
	        // this being the case the texture may already be bound to a slot. As a texture can only be bound once
	        // we need to find its current location if it exists.
	        if (location === undefined) {
	            location = 0;
	
	            // TODO maybe we can use texture bound ids later on...
	            // check if texture is already bound..
	            for (var i = 0; i < boundTextures.length; ++i) {
	                if (boundTextures[i] === texture) {
	                    location = i;
	                    break;
	                }
	            }
	        }
	
	        boundTextures[location] = texture;
	
	        gl.activeTexture(gl.TEXTURE0 + location);
	
	        var glTexture = texture._glTextures[this.renderer.CONTEXT_UID];
	
	        if (!glTexture) {
	            if (isRenderTexture) {
	                var renderTarget = new _RenderTarget2.default(this.gl, texture.width, texture.height, texture.scaleMode, texture.resolution);
	
	                renderTarget.resize(texture.width, texture.height);
	                texture._glRenderTargets[this.renderer.CONTEXT_UID] = renderTarget;
	                glTexture = renderTarget.texture;
	            } else {
	                glTexture = new _pixiGlCore.GLTexture(this.gl, null, null, null, null);
	                glTexture.bind(location);
	                glTexture.premultiplyAlpha = true;
	                glTexture.upload(texture.source);
	            }
	
	            texture._glTextures[this.renderer.CONTEXT_UID] = glTexture;
	
	            texture.on('update', this.updateTexture, this);
	            texture.on('dispose', this.destroyTexture, this);
	
	            this._managedTextures.push(texture);
	
	            if (texture.isPowerOfTwo) {
	                if (texture.mipmap) {
	                    glTexture.enableMipmap();
	                }
	
	                if (texture.wrapMode === _const.WRAP_MODES.CLAMP) {
	                    glTexture.enableWrapClamp();
	                } else if (texture.wrapMode === _const.WRAP_MODES.REPEAT) {
	                    glTexture.enableWrapRepeat();
	                } else {
	                    glTexture.enableWrapMirrorRepeat();
	                }
	            } else {
	                glTexture.enableWrapClamp();
	            }
	
	            if (texture.scaleMode === _const.SCALE_MODES.NEAREST) {
	                glTexture.enableNearestScaling();
	            } else {
	                glTexture.enableLinearScaling();
	            }
	        }
	        // the texture already exists so we only need to update it..
	        else if (isRenderTexture) {
	                texture._glRenderTargets[this.renderer.CONTEXT_UID].resize(texture.width, texture.height);
	            } else {
	                glTexture.upload(texture.source);
	            }
	
	        return glTexture;
	    };
	
	    /**
	     * Deletes the texture from WebGL
	     *
	     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to destroy
	     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
	     */
	
	
	    TextureManager.prototype.destroyTexture = function destroyTexture(texture, skipRemove) {
	        texture = texture.baseTexture || texture;
	
	        if (!texture.hasLoaded) {
	            return;
	        }
	
	        var uid = this.renderer.CONTEXT_UID;
	        var glTextures = texture._glTextures;
	        var glRenderTargets = texture._glRenderTargets;
	
	        if (glTextures[uid]) {
	            this.renderer.unbindTexture(texture);
	
	            glTextures[uid].destroy();
	            texture.off('update', this.updateTexture, this);
	            texture.off('dispose', this.destroyTexture, this);
	
	            delete glTextures[uid];
	
	            if (!skipRemove) {
	                var i = this._managedTextures.indexOf(texture);
	
	                if (i !== -1) {
	                    (0, _utils.removeItems)(this._managedTextures, i, 1);
	                }
	            }
	        }
	
	        if (glRenderTargets && glRenderTargets[uid]) {
	            glRenderTargets[uid].destroy();
	            delete glRenderTargets[uid];
	        }
	    };
	
	    /**
	     * Deletes all the textures from WebGL
	     */
	
	
	    TextureManager.prototype.removeAll = function removeAll() {
	        // empty all the old gl textures as they are useless now
	        for (var i = 0; i < this._managedTextures.length; ++i) {
	            var texture = this._managedTextures[i];
	
	            if (texture._glTextures[this.renderer.CONTEXT_UID]) {
	                delete texture._glTextures[this.renderer.CONTEXT_UID];
	            }
	        }
	    };
	
	    /**
	     * Destroys this manager and removes all its textures
	     */
	
	
	    TextureManager.prototype.destroy = function destroy() {
	        // destroy managed textures
	        for (var i = 0; i < this._managedTextures.length; ++i) {
	            var texture = this._managedTextures[i];
	
	            this.destroyTexture(texture, true);
	
	            texture.off('update', this.updateTexture, this);
	            texture.off('dispose', this.destroyTexture, this);
	        }
	
	        this._managedTextures = null;
	    };
	
	    return TextureManager;
	}();
	
	exports.default = TextureManager;
	//# sourceMappingURL=TextureManager.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mapWebGLBlendModesToPixi = __webpack_require__(227);
	
	var _mapWebGLBlendModesToPixi2 = _interopRequireDefault(_mapWebGLBlendModesToPixi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BLEND = 0;
	var DEPTH_TEST = 1;
	var FRONT_FACE = 2;
	var CULL_FACE = 3;
	var BLEND_FUNC = 4;
	
	/**
	 * A WebGL state machines
	 *
	 * @memberof PIXI
	 * @class
	 */
	
	var WebGLState = function () {
	    /**
	     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
	     */
	    function WebGLState(gl) {
	        _classCallCheck(this, WebGLState);
	
	        /**
	         * The current active state
	         *
	         * @member {Uint8Array}
	         */
	        this.activeState = new Uint8Array(16);
	
	        /**
	         * The default state
	         *
	         * @member {Uint8Array}
	         */
	        this.defaultState = new Uint8Array(16);
	
	        // default blend mode..
	        this.defaultState[0] = 1;
	
	        /**
	         * The current state index in the stack
	         *
	         * @member {number}
	         * @private
	         */
	        this.stackIndex = 0;
	
	        /**
	         * The stack holding all the different states
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.stack = [];
	
	        /**
	         * The current WebGL rendering context
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = gl;
	
	        this.maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
	
	        this.attribState = {
	            tempAttribState: new Array(this.maxAttribs),
	            attribState: new Array(this.maxAttribs)
	        };
	
	        this.blendModes = (0, _mapWebGLBlendModesToPixi2.default)(gl);
	
	        // check we have vao..
	        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object');
	    }
	
	    /**
	     * Pushes a new active state
	     */
	
	
	    WebGLState.prototype.push = function push() {
	        // next state..
	        var state = this.stack[this.stackIndex];
	
	        if (!state) {
	            state = this.stack[this.stackIndex] = new Uint8Array(16);
	        }
	
	        ++this.stackIndex;
	
	        // copy state..
	        // set active state so we can force overrides of gl state
	        for (var i = 0; i < this.activeState.length; i++) {
	            state[i] = this.activeState[i];
	        }
	    };
	
	    /**
	     * Pops a state out
	     */
	
	
	    WebGLState.prototype.pop = function pop() {
	        var state = this.stack[--this.stackIndex];
	
	        this.setState(state);
	    };
	
	    /**
	     * Sets the current state
	     *
	     * @param {*} state - The state to set.
	     */
	
	
	    WebGLState.prototype.setState = function setState(state) {
	        this.setBlend(state[BLEND]);
	        this.setDepthTest(state[DEPTH_TEST]);
	        this.setFrontFace(state[FRONT_FACE]);
	        this.setCullFace(state[CULL_FACE]);
	        this.setBlendMode(state[BLEND_FUNC]);
	    };
	
	    /**
	     * Enables or disabled blending.
	     *
	     * @param {boolean} value - Turn on or off webgl blending.
	     */
	
	
	    WebGLState.prototype.setBlend = function setBlend(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[BLEND] === value) {
	            return;
	        }
	
	        this.activeState[BLEND] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
	    };
	
	    /**
	     * Sets the blend mode.
	     *
	     * @param {number} value - The blend mode to set to.
	     */
	
	
	    WebGLState.prototype.setBlendMode = function setBlendMode(value) {
	        if (value === this.activeState[BLEND_FUNC]) {
	            return;
	        }
	
	        this.activeState[BLEND_FUNC] = value;
	
	        var mode = this.blendModes[value];
	
	        if (mode.length === 2) {
	            this.gl.blendFunc(mode[0], mode[1]);
	        } else {
	            this.gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
	        }
	    };
	
	    /**
	     * Sets whether to enable or disable depth test.
	     *
	     * @param {boolean} value - Turn on or off webgl depth testing.
	     */
	
	
	    WebGLState.prototype.setDepthTest = function setDepthTest(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[DEPTH_TEST] === value) {
	            return;
	        }
	
	        this.activeState[DEPTH_TEST] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
	    };
	
	    /**
	     * Sets whether to enable or disable cull face.
	     *
	     * @param {boolean} value - Turn on or off webgl cull face.
	     */
	
	
	    WebGLState.prototype.setCullFace = function setCullFace(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[CULL_FACE] === value) {
	            return;
	        }
	
	        this.activeState[CULL_FACE] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
	    };
	
	    /**
	     * Sets the gl front face.
	     *
	     * @param {boolean} value - true is clockwise and false is counter-clockwise
	     */
	
	
	    WebGLState.prototype.setFrontFace = function setFrontFace(value) {
	        value = value ? 1 : 0;
	
	        if (this.activeState[FRONT_FACE] === value) {
	            return;
	        }
	
	        this.activeState[FRONT_FACE] = value;
	        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
	    };
	
	    /**
	     * Disables all the vaos in use
	     *
	     */
	
	
	    WebGLState.prototype.resetAttributes = function resetAttributes() {
	        for (var i = 0; i < this.attribState.tempAttribState.length; i++) {
	            this.attribState.tempAttribState[i] = 0;
	        }
	
	        for (var _i = 0; _i < this.attribState.attribState.length; _i++) {
	            this.attribState.attribState[_i] = 0;
	        }
	
	        // im going to assume one is always active for performance reasons.
	        for (var _i2 = 1; _i2 < this.maxAttribs; _i2++) {
	            this.gl.disableVertexAttribArray(_i2);
	        }
	    };
	
	    // used
	    /**
	     * Resets all the logic and disables the vaos
	     */
	
	
	    WebGLState.prototype.resetToDefault = function resetToDefault() {
	        // unbind any VAO if they exist..
	        if (this.nativeVaoExtension) {
	            this.nativeVaoExtension.bindVertexArrayOES(null);
	        }
	
	        // reset all attributes..
	        this.resetAttributes();
	
	        // set active state so we can force overrides of gl state
	        for (var i = 0; i < this.activeState.length; ++i) {
	            this.activeState[i] = 32;
	        }
	
	        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
	
	        this.setState(this.defaultState);
	    };
	
	    return WebGLState;
	}();
	
	exports.default = WebGLState;
	//# sourceMappingURL=WebGLState.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = extractUniformsFromSrc;
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultValue = _pixiGlCore2.default.shader.defaultValue;
	
	function extractUniformsFromSrc(vertexSrc, fragmentSrc, mask) {
	    var vertUniforms = extractUniformsFromString(vertexSrc, mask);
	    var fragUniforms = extractUniformsFromString(fragmentSrc, mask);
	
	    return Object.assign(vertUniforms, fragUniforms);
	}
	
	function extractUniformsFromString(string) {
	    var maskRegex = new RegExp('^(projectionMatrix|uSampler|filterArea|filterClamp)$');
	
	    var uniforms = {};
	    var nameSplit = void 0;
	
	    // clean the lines a little - remove extra spaces / tabs etc
	    // then split along ';'
	    var lines = string.replace(/\s+/g, ' ').split(/\s*;\s*/);
	
	    // loop through..
	    for (var i = 0; i < lines.length; i++) {
	        var line = lines[i].trim();
	
	        if (line.indexOf('uniform') > -1) {
	            var splitLine = line.split(' ');
	            var type = splitLine[1];
	
	            var name = splitLine[2];
	            var size = 1;
	
	            if (name.indexOf('[') > -1) {
	                // array!
	                nameSplit = name.split(/\[|]/);
	                name = nameSplit[0];
	                size *= Number(nameSplit[1]);
	            }
	
	            if (!name.match(maskRegex)) {
	                uniforms[name] = {
	                    value: defaultValue(type, size),
	                    name: name,
	                    type: type
	                };
	            }
	        }
	    }
	
	    return uniforms;
	}
	//# sourceMappingURL=extractUniformsFromSrc.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.calculateScreenSpaceMatrix = calculateScreenSpaceMatrix;
	exports.calculateNormalizedScreenSpaceMatrix = calculateNormalizedScreenSpaceMatrix;
	exports.calculateSpriteMatrix = calculateSpriteMatrix;
	
	var _math = __webpack_require__(7);
	
	/**
	 * Calculates the mapped matrix
	 * @param filterArea {Rectangle} The filter area
	 * @param sprite {Sprite} the target sprite
	 * @param outputMatrix {Matrix} @alvin
	 * @private
	 */
	// TODO playing around here.. this is temporary - (will end up in the shader)
	// this returns a matrix that will normalise map filter cords in the filter to screen space
	function calculateScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
	    // let worldTransform = sprite.worldTransform.copy(Matrix.TEMP_MATRIX),
	    // let texture = {width:1136, height:700};//sprite._texture.baseTexture;
	
	    // TODO unwrap?
	    var mappedMatrix = outputMatrix.identity();
	
	    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);
	
	    mappedMatrix.scale(textureSize.width, textureSize.height);
	
	    return mappedMatrix;
	}
	
	function calculateNormalizedScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
	    var mappedMatrix = outputMatrix.identity();
	
	    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);
	
	    var translateScaleX = textureSize.width / filterArea.width;
	    var translateScaleY = textureSize.height / filterArea.height;
	
	    mappedMatrix.scale(translateScaleX, translateScaleY);
	
	    return mappedMatrix;
	}
	
	// this will map the filter coord so that a texture can be used based on the transform of a sprite
	function calculateSpriteMatrix(outputMatrix, filterArea, textureSize, sprite) {
	    var orig = sprite._texture.orig;
	    var mappedMatrix = outputMatrix.set(textureSize.width, 0, 0, textureSize.height, filterArea.x, filterArea.y);
	    var worldTransform = sprite.worldTransform.copy(_math.Matrix.TEMP_MATRIX);
	
	    worldTransform.invert();
	    mappedMatrix.prepend(worldTransform);
	    mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
	    mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
	
	    return mappedMatrix;
	}
	//# sourceMappingURL=filterTransforms.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(29);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	var _RenderTarget = __webpack_require__(37);
	
	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
	
	var _Quad = __webpack_require__(114);
	
	var _Quad2 = _interopRequireDefault(_Quad);
	
	var _math = __webpack_require__(7);
	
	var _Shader = __webpack_require__(26);
	
	var _Shader2 = _interopRequireDefault(_Shader);
	
	var _filterTransforms = __webpack_require__(222);
	
	var filterTransforms = _interopRequireWildcard(_filterTransforms);
	
	var _bitTwiddle = __webpack_require__(50);
	
	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @ignore
	 * @class
	 */
	var FilterState = function () {
	    /**
	     *
	     */
	    function FilterState() {
	        _classCallCheck(this, FilterState);
	
	        this.renderTarget = null;
	        this.target = null;
	        this.resolution = 1;
	
	        // those three objects are used only for root
	        // re-assigned for everything else
	        this.sourceFrame = new _math.Rectangle();
	        this.destinationFrame = new _math.Rectangle();
	        this.filters = [];
	    }
	
	    /**
	     * clears the state
	     */
	
	
	    FilterState.prototype.clear = function clear() {
	        this.filters = null;
	        this.target = null;
	        this.renderTarget = null;
	    };
	
	    return FilterState;
	}();
	
	var screenKey = 'screen';
	
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.WebGLManager
	 */
	
	var FilterManager = function (_WebGLManager) {
	    _inherits(FilterManager, _WebGLManager);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function FilterManager(renderer) {
	        _classCallCheck(this, FilterManager);
	
	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
	
	        _this.gl = _this.renderer.gl;
	        // know about sprites!
	        _this.quad = new _Quad2.default(_this.gl, renderer.state.attribState);
	
	        _this.shaderCache = {};
	        // todo add default!
	        _this.pool = {};
	
	        _this.filterData = null;
	
	        _this.managedFilters = [];
	
	        _this.renderer.on('prerender', _this.onPrerender, _this);
	
	        _this._screenWidth = renderer.view.width;
	        _this._screenHeight = renderer.view.height;
	        return _this;
	    }
	
	    /**
	     * Adds a new filter to the manager.
	     *
	     * @param {PIXI.DisplayObject} target - The target of the filter to render.
	     * @param {PIXI.Filter[]} filters - The filters to apply.
	     */
	
	
	    FilterManager.prototype.pushFilter = function pushFilter(target, filters) {
	        var renderer = this.renderer;
	
	        var filterData = this.filterData;
	
	        if (!filterData) {
	            filterData = this.renderer._activeRenderTarget.filterStack;
	
	            // add new stack
	            var filterState = new FilterState();
	
	            filterState.sourceFrame = filterState.destinationFrame = this.renderer._activeRenderTarget.size;
	            filterState.renderTarget = renderer._activeRenderTarget;
	
	            this.renderer._activeRenderTarget.filterData = filterData = {
	                index: 0,
	                stack: [filterState]
	            };
	
	            this.filterData = filterData;
	        }
	
	        // get the current filter state..
	        var currentState = filterData.stack[++filterData.index];
	        var renderTargetFrame = filterData.stack[0].destinationFrame;
	
	        if (!currentState) {
	            currentState = filterData.stack[filterData.index] = new FilterState();
	        }
	
	        var fullScreen = target.filterArea && target.filterArea.x === 0 && target.filterArea.y === 0 && target.filterArea.width === renderer.screen.width && target.filterArea.height === renderer.screen.height;
	
	        // for now we go off the filter of the first resolution..
	        var resolution = filters[0].resolution;
	        var padding = filters[0].padding | 0;
	        var targetBounds = fullScreen ? renderer.screen : target.filterArea || target.getBounds(true);
	        var sourceFrame = currentState.sourceFrame;
	        var destinationFrame = currentState.destinationFrame;
	
	        sourceFrame.x = (targetBounds.x * resolution | 0) / resolution;
	        sourceFrame.y = (targetBounds.y * resolution | 0) / resolution;
	        sourceFrame.width = (targetBounds.width * resolution | 0) / resolution;
	        sourceFrame.height = (targetBounds.height * resolution | 0) / resolution;
	
	        if (!fullScreen) {
	            if (filterData.stack[0].renderTarget.transform) {//
	
	                // TODO we should fit the rect around the transform..
	            } else if (filters[0].autoFit) {
	                sourceFrame.fit(renderTargetFrame);
	            }
	
	            // lets apply the padding After we fit the element to the screen.
	            // this should stop the strange side effects that can occur when cropping to the edges
	            sourceFrame.pad(padding);
	        }
	
	        destinationFrame.width = sourceFrame.width;
	        destinationFrame.height = sourceFrame.height;
	
	        // lets play the padding after we fit the element to the screen.
	        // this should stop the strange side effects that can occur when cropping to the edges
	
	        var renderTarget = this.getPotRenderTarget(renderer.gl, sourceFrame.width, sourceFrame.height, resolution);
	
	        currentState.target = target;
	        currentState.filters = filters;
	        currentState.resolution = resolution;
	        currentState.renderTarget = renderTarget;
	
	        // bind the render target to draw the shape in the top corner..
	
	        renderTarget.setFrame(destinationFrame, sourceFrame);
	
	        // bind the render target
	        renderer.bindRenderTarget(renderTarget);
	        renderTarget.clear();
	    };
	
	    /**
	     * Pops off the filter and applies it.
	     *
	     */
	
	
	    FilterManager.prototype.popFilter = function popFilter() {
	        var filterData = this.filterData;
	
	        var lastState = filterData.stack[filterData.index - 1];
	        var currentState = filterData.stack[filterData.index];
	
	        this.quad.map(currentState.renderTarget.size, currentState.sourceFrame).upload();
	
	        var filters = currentState.filters;
	
	        if (filters.length === 1) {
	            filters[0].apply(this, currentState.renderTarget, lastState.renderTarget, false, currentState);
	            this.freePotRenderTarget(currentState.renderTarget);
	        } else {
	            var flip = currentState.renderTarget;
	            var flop = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, currentState.resolution);
	
	            flop.setFrame(currentState.destinationFrame, currentState.sourceFrame);
	
	            // finally lets clear the render target before drawing to it..
	            flop.clear();
	
	            var i = 0;
	
	            for (i = 0; i < filters.length - 1; ++i) {
	                filters[i].apply(this, flip, flop, true, currentState);
	
	                var t = flip;
	
	                flip = flop;
	                flop = t;
	            }
	
	            filters[i].apply(this, flip, lastState.renderTarget, false, currentState);
	
	            this.freePotRenderTarget(flip);
	            this.freePotRenderTarget(flop);
	        }
	
	        currentState.clear();
	        filterData.index--;
	
	        if (filterData.index === 0) {
	            this.filterData = null;
	        }
	    };
	
	    /**
	     * Draws a filter.
	     *
	     * @param {PIXI.Filter} filter - The filter to draw.
	     * @param {PIXI.RenderTarget} input - The input render target.
	     * @param {PIXI.RenderTarget} output - The target to output to.
	     * @param {boolean} clear - Should the output be cleared before rendering to it
	     */
	
	
	    FilterManager.prototype.applyFilter = function applyFilter(filter, input, output, clear) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;
	
	        var shader = filter.glShaders[renderer.CONTEXT_UID];
	
	        // cacheing..
	        if (!shader) {
	            if (filter.glShaderKey) {
	                shader = this.shaderCache[filter.glShaderKey];
	
	                if (!shader) {
	                    shader = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
	
	                    filter.glShaders[renderer.CONTEXT_UID] = this.shaderCache[filter.glShaderKey] = shader;
	                    this.managedFilters.push(filter);
	                }
	            } else {
	                shader = filter.glShaders[renderer.CONTEXT_UID] = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
	                this.managedFilters.push(filter);
	            }
	
	            // TODO - this only needs to be done once?
	            renderer.bindVao(null);
	
	            this.quad.initVao(shader);
	        }
	
	        renderer.bindVao(this.quad.vao);
	
	        renderer.bindRenderTarget(output);
	
	        if (clear) {
	            gl.disable(gl.SCISSOR_TEST);
	            renderer.clear(); // [1, 1, 1, 1]);
	            gl.enable(gl.SCISSOR_TEST);
	        }
	
	        // in case the render target is being masked using a scissor rect
	        if (output === renderer.maskManager.scissorRenderTarget) {
	            renderer.maskManager.pushScissorMask(null, renderer.maskManager.scissorData);
	        }
	
	        renderer.bindShader(shader);
	
	        // free unit 0 for us, doesn't matter what was there
	        // don't try to restore it, because syncUniforms can upload it to another slot
	        // and it'll be a problem
	        var tex = this.renderer.emptyTextures[0];
	
	        this.renderer.boundTextures[0] = tex;
	        // this syncs the PixiJS filters  uniforms with glsl uniforms
	        this.syncUniforms(shader, filter);
	
	        renderer.state.setBlendMode(filter.blendMode);
	
	        gl.activeTexture(gl.TEXTURE0);
	        gl.bindTexture(gl.TEXTURE_2D, input.texture.texture);
	
	        this.quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
	
	        gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
	    };
	
	    /**
	     * Uploads the uniforms of the filter.
	     *
	     * @param {GLShader} shader - The underlying gl shader.
	     * @param {PIXI.Filter} filter - The filter we are synchronizing.
	     */
	
	
	    FilterManager.prototype.syncUniforms = function syncUniforms(shader, filter) {
	        var uniformData = filter.uniformData;
	        var uniforms = filter.uniforms;
	
	        // 0 is reserved for the PixiJS texture so we start at 1!
	        var textureCount = 1;
	        var currentState = void 0;
	
	        // filterArea and filterClamp that are handled by FilterManager directly
	        // they must not appear in uniformData
	
	        if (shader.uniforms.filterArea) {
	            currentState = this.filterData.stack[this.filterData.index];
	
	            var filterArea = shader.uniforms.filterArea;
	
	            filterArea[0] = currentState.renderTarget.size.width;
	            filterArea[1] = currentState.renderTarget.size.height;
	            filterArea[2] = currentState.sourceFrame.x;
	            filterArea[3] = currentState.sourceFrame.y;
	
	            shader.uniforms.filterArea = filterArea;
	        }
	
	        // use this to clamp displaced texture coords so they belong to filterArea
	        // see displacementFilter fragment shader for an example
	        if (shader.uniforms.filterClamp) {
	            currentState = currentState || this.filterData.stack[this.filterData.index];
	
	            var filterClamp = shader.uniforms.filterClamp;
	
	            filterClamp[0] = 0;
	            filterClamp[1] = 0;
	            filterClamp[2] = (currentState.sourceFrame.width - 1) / currentState.renderTarget.size.width;
	            filterClamp[3] = (currentState.sourceFrame.height - 1) / currentState.renderTarget.size.height;
	
	            shader.uniforms.filterClamp = filterClamp;
	        }
	
	        // TODO Cacheing layer..
	        for (var i in uniformData) {
	            var type = uniformData[i].type;
	
	            if (type === 'sampler2d' && uniforms[i] !== 0) {
	                if (uniforms[i].baseTexture) {
	                    shader.uniforms[i] = this.renderer.bindTexture(uniforms[i].baseTexture, textureCount);
	                } else {
	                    shader.uniforms[i] = textureCount;
	
	                    // TODO
	                    // this is helpful as renderTargets can also be set.
	                    // Although thinking about it, we could probably
	                    // make the filter texture cache return a RenderTexture
	                    // rather than a renderTarget
	                    var gl = this.renderer.gl;
	
	                    this.renderer.boundTextures[textureCount] = this.renderer.emptyTextures[textureCount];
	                    gl.activeTexture(gl.TEXTURE0 + textureCount);
	
	                    uniforms[i].texture.bind();
	                }
	
	                textureCount++;
	            } else if (type === 'mat3') {
	                // check if its PixiJS matrix..
	                if (uniforms[i].a !== undefined) {
	                    shader.uniforms[i] = uniforms[i].toArray(true);
	                } else {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else if (type === 'vec2') {
	                // check if its a point..
	                if (uniforms[i].x !== undefined) {
	                    var val = shader.uniforms[i] || new Float32Array(2);
	
	                    val[0] = uniforms[i].x;
	                    val[1] = uniforms[i].y;
	                    shader.uniforms[i] = val;
	                } else {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else if (type === 'float') {
	                if (shader.uniforms.data[i].value !== uniformData[i]) {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else {
	                shader.uniforms[i] = uniforms[i];
	            }
	        }
	    };
	
	    /**
	     * Gets a render target from the pool, or creates a new one.
	     *
	     * @param {boolean} clear - Should we clear the render texture when we get it?
	     * @param {number} resolution - The resolution of the target.
	     * @return {PIXI.RenderTarget} The new render target
	     */
	
	
	    FilterManager.prototype.getRenderTarget = function getRenderTarget(clear, resolution) {
	        var currentState = this.filterData.stack[this.filterData.index];
	        var renderTarget = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, resolution || currentState.resolution);
	
	        renderTarget.setFrame(currentState.destinationFrame, currentState.sourceFrame);
	
	        return renderTarget;
	    };
	
	    /**
	     * Returns a render target to the pool.
	     *
	     * @param {PIXI.RenderTarget} renderTarget - The render target to return.
	     */
	
	
	    FilterManager.prototype.returnRenderTarget = function returnRenderTarget(renderTarget) {
	        this.freePotRenderTarget(renderTarget);
	    };
	
	    /**
	     * Calculates the mapped matrix.
	     *
	     * TODO playing around here.. this is temporary - (will end up in the shader)
	     * this returns a matrix that will normalise map filter cords in the filter to screen space
	     *
	     * @param {PIXI.Matrix} outputMatrix - the matrix to output to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */
	
	
	    FilterManager.prototype.calculateScreenSpaceMatrix = function calculateScreenSpaceMatrix(outputMatrix) {
	        var currentState = this.filterData.stack[this.filterData.index];
	
	        return filterTransforms.calculateScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size);
	    };
	
	    /**
	     * Multiply vTextureCoord to this matrix to achieve (0,0,1,1) for filterArea
	     *
	     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */
	
	
	    FilterManager.prototype.calculateNormalizedScreenSpaceMatrix = function calculateNormalizedScreenSpaceMatrix(outputMatrix) {
	        var currentState = this.filterData.stack[this.filterData.index];
	
	        return filterTransforms.calculateNormalizedScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, currentState.destinationFrame);
	    };
	
	    /**
	     * This will map the filter coord so that a texture can be used based on the transform of a sprite
	     *
	     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	     * @param {PIXI.Sprite} sprite - The sprite to map to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */
	
	
	    FilterManager.prototype.calculateSpriteMatrix = function calculateSpriteMatrix(outputMatrix, sprite) {
	        var currentState = this.filterData.stack[this.filterData.index];
	
	        return filterTransforms.calculateSpriteMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, sprite);
	    };
	
	    /**
	     * Destroys this Filter Manager.
	     *
	     * @param {boolean} [contextLost=false] context was lost, do not free shaders
	     *
	     */
	
	
	    FilterManager.prototype.destroy = function destroy() {
	        var contextLost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var renderer = this.renderer;
	        var filters = this.managedFilters;
	
	        renderer.off('prerender', this.onPrerender, this);
	
	        for (var i = 0; i < filters.length; i++) {
	            if (!contextLost) {
	                filters[i].glShaders[renderer.CONTEXT_UID].destroy();
	            }
	            delete filters[i].glShaders[renderer.CONTEXT_UID];
	        }
	
	        this.shaderCache = {};
	        if (!contextLost) {
	            this.emptyPool();
	        } else {
	            this.pool = {};
	        }
	    };
	
	    /**
	     * Gets a Power-of-Two render texture.
	     *
	     * TODO move to a seperate class could be on renderer?
	     * also - could cause issue with multiple contexts?
	     *
	     * @private
	     * @param {WebGLRenderingContext} gl - The webgl rendering context
	     * @param {number} minWidth - The minimum width of the render target.
	     * @param {number} minHeight - The minimum height of the render target.
	     * @param {number} resolution - The resolution of the render target.
	     * @return {PIXI.RenderTarget} The new render target.
	     */
	
	
	    FilterManager.prototype.getPotRenderTarget = function getPotRenderTarget(gl, minWidth, minHeight, resolution) {
	        var key = screenKey;
	
	        minWidth *= resolution;
	        minHeight *= resolution;
	
	        if (minWidth !== this._screenWidth || minHeight !== this._screenHeight) {
	            // TODO you could return a bigger texture if there is not one in the pool?
	            minWidth = _bitTwiddle2.default.nextPow2(minWidth);
	            minHeight = _bitTwiddle2.default.nextPow2(minHeight);
	            key = (minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF;
	        }
	
	        if (!this.pool[key]) {
	            this.pool[key] = [];
	        }
	
	        var renderTarget = this.pool[key].pop();
	
	        // creating render target will cause texture to be bound!
	        if (!renderTarget) {
	            // temporary bypass cache..
	            var tex = this.renderer.boundTextures[0];
	
	            gl.activeTexture(gl.TEXTURE0);
	
	            // internally - this will cause a texture to be bound..
	            renderTarget = new _RenderTarget2.default(gl, minWidth, minHeight, null, 1);
	
	            // set the current one back
	            gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
	        }
	
	        // manually tweak the resolution...
	        // this will not modify the size of the frame buffer, just its resolution.
	        renderTarget.resolution = resolution;
	        renderTarget.defaultFrame.width = renderTarget.size.width = minWidth / resolution;
	        renderTarget.defaultFrame.height = renderTarget.size.height = minHeight / resolution;
	        renderTarget.filterPoolKey = key;
	
	        return renderTarget;
	    };
	
	    /**
	     * Empties the texture pool.
	     *
	     */
	
	
	    FilterManager.prototype.emptyPool = function emptyPool() {
	        for (var i in this.pool) {
	            var textures = this.pool[i];
	
	            if (textures) {
	                for (var j = 0; j < textures.length; j++) {
	                    textures[j].destroy(true);
	                }
	            }
	        }
	
	        this.pool = {};
	    };
	
	    /**
	     * Frees a render target back into the pool.
	     *
	     * @param {PIXI.RenderTarget} renderTarget - The renderTarget to free
	     */
	
	
	    FilterManager.prototype.freePotRenderTarget = function freePotRenderTarget(renderTarget) {
	        this.pool[renderTarget.filterPoolKey].push(renderTarget);
	    };
	
	    /**
	     * Called before the renderer starts rendering.
	     *
	     */
	
	
	    FilterManager.prototype.onPrerender = function onPrerender() {
	        if (this._screenWidth !== this.renderer.view.width || this._screenHeight !== this.renderer.view.height) {
	            this._screenWidth = this.renderer.view.width;
	            this._screenHeight = this.renderer.view.height;
	
	            var textures = this.pool[screenKey];
	
	            if (textures) {
	                for (var j = 0; j < textures.length; j++) {
	                    textures[j].destroy(true);
	                }
	            }
	            this.pool[screenKey] = [];
	        }
	    };
	
	    return FilterManager;
	}(_WebGLManager3.default);
	
	exports.default = FilterManager;
	//# sourceMappingURL=FilterManager.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(29);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	var _SpriteMaskFilter = __webpack_require__(113);
	
	var _SpriteMaskFilter2 = _interopRequireDefault(_SpriteMaskFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var MaskManager = function (_WebGLManager) {
	    _inherits(MaskManager, _WebGLManager);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function MaskManager(renderer) {
	        _classCallCheck(this, MaskManager);
	
	        // TODO - we don't need both!
	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
	
	        _this.scissor = false;
	        _this.scissorData = null;
	        _this.scissorRenderTarget = null;
	
	        _this.enableScissor = true;
	
	        _this.alphaMaskPool = [];
	        _this.alphaMaskIndex = 0;
	        return _this;
	    }
	
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.pushMask = function pushMask(target, maskData) {
	        // TODO the root check means scissor rect will not
	        // be used on render textures more info here:
	        // https://github.com/pixijs/pixi.js/pull/3545
	
	        if (maskData.texture) {
	            this.pushSpriteMask(target, maskData);
	        } else if (this.enableScissor && !this.scissor && this.renderer._activeRenderTarget.root && !this.renderer.stencilManager.stencilMaskStack.length && maskData.isFastRect()) {
	            var matrix = maskData.worldTransform;
	
	            var rot = Math.atan2(matrix.b, matrix.a);
	
	            // use the nearest degree!
	            rot = Math.round(rot * (180 / Math.PI));
	
	            if (rot % 90) {
	                this.pushStencilMask(maskData);
	            } else {
	                this.pushScissorMask(target, maskData);
	            }
	        } else {
	            this.pushStencilMask(maskData);
	        }
	    };
	
	    /**
	     * Removes the last mask from the mask stack and doesn't return it.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.popMask = function popMask(target, maskData) {
	        if (maskData.texture) {
	            this.popSpriteMask(target, maskData);
	        } else if (this.enableScissor && !this.renderer.stencilManager.stencilMaskStack.length) {
	            this.popScissorMask(target, maskData);
	        } else {
	            this.popStencilMask(target, maskData);
	        }
	    };
	
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.RenderTarget} target - Display Object to push the sprite mask to
	     * @param {PIXI.Sprite} maskData - Sprite to be used as the mask
	     */
	
	
	    MaskManager.prototype.pushSpriteMask = function pushSpriteMask(target, maskData) {
	        var alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];
	
	        if (!alphaMaskFilter) {
	            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [new _SpriteMaskFilter2.default(maskData)];
	        }
	
	        alphaMaskFilter[0].resolution = this.renderer.resolution;
	        alphaMaskFilter[0].maskSprite = maskData;
	
	        // TODO - may cause issues!
	        target.filterArea = maskData.getBounds(true);
	
	        this.renderer.filterManager.pushFilter(target, alphaMaskFilter);
	
	        this.alphaMaskIndex++;
	    };
	
	    /**
	     * Removes the last filter from the filter stack and doesn't return it.
	     *
	     */
	
	
	    MaskManager.prototype.popSpriteMask = function popSpriteMask() {
	        this.renderer.filterManager.popFilter();
	        this.alphaMaskIndex--;
	    };
	
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.pushStencilMask = function pushStencilMask(maskData) {
	        this.renderer.currentRenderer.stop();
	        this.renderer.stencilManager.pushStencil(maskData);
	    };
	
	    /**
	     * Removes the last filter from the filter stack and doesn't return it.
	     *
	     */
	
	
	    MaskManager.prototype.popStencilMask = function popStencilMask() {
	        this.renderer.currentRenderer.stop();
	        this.renderer.stencilManager.popStencil();
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
	     * @param {PIXI.Graphics} maskData - The masking data.
	     */
	
	
	    MaskManager.prototype.pushScissorMask = function pushScissorMask(target, maskData) {
	        maskData.renderable = true;
	
	        var renderTarget = this.renderer._activeRenderTarget;
	
	        var bounds = maskData.getBounds();
	
	        bounds.fit(renderTarget.size);
	        maskData.renderable = false;
	
	        this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);
	
	        var resolution = this.renderer.resolution;
	
	        this.renderer.gl.scissor(bounds.x * resolution, (renderTarget.root ? renderTarget.size.height - bounds.y - bounds.height : bounds.y) * resolution, bounds.width * resolution, bounds.height * resolution);
	
	        this.scissorRenderTarget = renderTarget;
	        this.scissorData = maskData;
	        this.scissor = true;
	    };
	
	    /**
	     *
	     *
	     */
	
	
	    MaskManager.prototype.popScissorMask = function popScissorMask() {
	        this.scissorRenderTarget = null;
	        this.scissorData = null;
	        this.scissor = false;
	
	        // must be scissor!
	        var gl = this.renderer.gl;
	
	        gl.disable(gl.SCISSOR_TEST);
	    };
	
	    return MaskManager;
	}(_WebGLManager3.default);
	
	exports.default = MaskManager;
	//# sourceMappingURL=MaskManager.js.map

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLManager2 = __webpack_require__(29);
	
	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var StencilManager = function (_WebGLManager) {
	    _inherits(StencilManager, _WebGLManager);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function StencilManager(renderer) {
	        _classCallCheck(this, StencilManager);
	
	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
	
	        _this.stencilMaskStack = null;
	        return _this;
	    }
	
	    /**
	     * Changes the mask stack that is used by this manager.
	     *
	     * @param {PIXI.Graphics[]} stencilMaskStack - The mask stack
	     */
	
	
	    StencilManager.prototype.setMaskStack = function setMaskStack(stencilMaskStack) {
	        this.stencilMaskStack = stencilMaskStack;
	
	        var gl = this.renderer.gl;
	
	        if (stencilMaskStack.length === 0) {
	            gl.disable(gl.STENCIL_TEST);
	        } else {
	            gl.enable(gl.STENCIL_TEST);
	        }
	    };
	
	    /**
	     * Applies the Mask and adds it to the current stencil stack. @alvin
	     *
	     * @param {PIXI.Graphics} graphics - The mask
	     */
	
	
	    StencilManager.prototype.pushStencil = function pushStencil(graphics) {
	        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
	
	        this.renderer._activeRenderTarget.attachStencilBuffer();
	
	        var gl = this.renderer.gl;
	        var prevMaskCount = this.stencilMaskStack.length;
	
	        if (prevMaskCount === 0) {
	            gl.enable(gl.STENCIL_TEST);
	        }
	
	        this.stencilMaskStack.push(graphics);
	
	        // Increment the refference stencil value where the new mask overlaps with the old ones.
	        gl.colorMask(false, false, false, false);
	        gl.stencilFunc(gl.EQUAL, prevMaskCount, this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	        this.renderer.plugins.graphics.render(graphics);
	
	        this._useCurrent();
	    };
	
	    /**
	     * Removes the last mask from the stencil stack. @alvin
	     */
	
	
	    StencilManager.prototype.popStencil = function popStencil() {
	        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
	
	        var gl = this.renderer.gl;
	        var graphics = this.stencilMaskStack.pop();
	
	        if (this.stencilMaskStack.length === 0) {
	            // the stack is empty!
	            gl.disable(gl.STENCIL_TEST);
	            gl.clear(gl.STENCIL_BUFFER_BIT);
	            gl.clearStencil(0);
	        } else {
	            // Decrement the refference stencil value where the popped mask overlaps with the other ones
	            gl.colorMask(false, false, false, false);
	            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	            this.renderer.plugins.graphics.render(graphics);
	
	            this._useCurrent();
	        }
	    };
	
	    /**
	     * Setup renderer to use the current stencil data.
	     */
	
	
	    StencilManager.prototype._useCurrent = function _useCurrent() {
	        var gl = this.renderer.gl;
	
	        gl.colorMask(true, true, true, true);
	        gl.stencilFunc(gl.EQUAL, this.stencilMaskStack.length, this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
	    };
	
	    /**
	     * Fill 1s equal to the number of acitve stencil masks.
	     *
	     * @return {number} The bitwise mask.
	     */
	
	
	    StencilManager.prototype._getBitwiseMask = function _getBitwiseMask() {
	        return (1 << this.stencilMaskStack.length) - 1;
	    };
	
	    /**
	     * Destroys the mask stack.
	     *
	     */
	
	
	    StencilManager.prototype.destroy = function destroy() {
	        _WebGLManager3.default.prototype.destroy.call(this);
	
	        this.stencilMaskStack.stencilStack = null;
	    };
	
	    return StencilManager;
	}(_WebGLManager3.default);
	
	exports.default = StencilManager;
	//# sourceMappingURL=StencilManager.js.map

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = checkMaxIfStatmentsInShader;
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fragTemplate = ['precision mediump float;', 'void main(void){', 'float test = 0.1;', '%forloop%', 'gl_FragColor = vec4(0.0);', '}'].join('\n');
	
	function checkMaxIfStatmentsInShader(maxIfs, gl) {
	    var createTempContext = !gl;
	
	    // @if DEBUG
	    if (maxIfs === 0) {
	        throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
	    }
	    // @endif
	
	    if (createTempContext) {
	        var tinyCanvas = document.createElement('canvas');
	
	        tinyCanvas.width = 1;
	        tinyCanvas.height = 1;
	
	        gl = _pixiGlCore2.default.createContext(tinyCanvas);
	    }
	
	    var shader = gl.createShader(gl.FRAGMENT_SHADER);
	
	    while (true) // eslint-disable-line no-constant-condition
	    {
	        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));
	
	        gl.shaderSource(shader, fragmentSrc);
	        gl.compileShader(shader);
	
	        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
	            maxIfs = maxIfs / 2 | 0;
	        } else {
	            // valid!
	            break;
	        }
	    }
	
	    if (createTempContext) {
	        // get rid of context
	        if (gl.getExtension('WEBGL_lose_context')) {
	            gl.getExtension('WEBGL_lose_context').loseContext();
	        }
	    }
	
	    return maxIfs;
	}
	
	function generateIfTestSrc(maxIfs) {
	    var src = '';
	
	    for (var i = 0; i < maxIfs; ++i) {
	        if (i > 0) {
	            src += '\nelse ';
	        }
	
	        if (i < maxIfs - 1) {
	            src += 'if(test == ' + i + '.0){}';
	        }
	    }
	
	    return src;
	}
	//# sourceMappingURL=checkMaxIfStatmentsInShader.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapWebGLBlendModesToPixi;
	
	var _const = __webpack_require__(3);
	
	/**
	 * Maps gl blend combinations to WebGL.
	 *
	 * @memberof PIXI
	 * @function mapWebGLBlendModesToPixi
	 * @private
	 * @param {WebGLRenderingContext} gl - The rendering context.
	 * @param {string[]} [array=[]] - The array to output into.
	 * @return {string[]} Mapped modes.
	 */
	function mapWebGLBlendModesToPixi(gl) {
	    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    // TODO - premultiply alpha would be different.
	    // add a boolean for that!
	    array[_const.BLEND_MODES.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.ADD] = [gl.ONE, gl.DST_ALPHA];
	    array[_const.BLEND_MODES.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SCREEN] = [gl.ONE, gl.ONE_MINUS_SRC_COLOR];
	    array[_const.BLEND_MODES.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	
	    // not-premultiplied blend modes
	    array[_const.BLEND_MODES.NORMAL_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.ADD_NPM] = [gl.SRC_ALPHA, gl.DST_ALPHA, gl.ONE, gl.DST_ALPHA];
	    array[_const.BLEND_MODES.SCREEN_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_COLOR];
	
	    return array;
	}
	//# sourceMappingURL=mapWebGLBlendModesToPixi.js.map

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapWebGLDrawModesToPixi;
	
	var _const = __webpack_require__(3);
	
	/**
	 * Generic Mask Stack data structure.
	 *
	 * @memberof PIXI
	 * @function mapWebGLDrawModesToPixi
	 * @private
	 * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	 * @param {object} [object={}] - The object to map into
	 * @return {object} The mapped draw modes.
	 */
	function mapWebGLDrawModesToPixi(gl) {
	  var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  object[_const.DRAW_MODES.POINTS] = gl.POINTS;
	  object[_const.DRAW_MODES.LINES] = gl.LINES;
	  object[_const.DRAW_MODES.LINE_LOOP] = gl.LINE_LOOP;
	  object[_const.DRAW_MODES.LINE_STRIP] = gl.LINE_STRIP;
	  object[_const.DRAW_MODES.TRIANGLES] = gl.TRIANGLES;
	  object[_const.DRAW_MODES.TRIANGLE_STRIP] = gl.TRIANGLE_STRIP;
	  object[_const.DRAW_MODES.TRIANGLE_FAN] = gl.TRIANGLE_FAN;
	
	  return object;
	}
	//# sourceMappingURL=mapWebGLDrawModesToPixi.js.map

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = validateContext;
	function validateContext(gl) {
	    var attributes = gl.getContextAttributes();
	
	    // this is going to be fairly simple for now.. but at least we have room to grow!
	    if (!attributes.stencil) {
	        /* eslint-disable no-console */
	        console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
	        /* eslint-enable no-console */
	    }
	}
	//# sourceMappingURL=validateContext.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CanvasRenderer = __webpack_require__(28);
	
	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
	
	var _const = __webpack_require__(3);
	
	var _math = __webpack_require__(7);
	
	var _CanvasTinter = __webpack_require__(64);
	
	var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var canvasRenderWorldTransform = new _math.Matrix();
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasSpriteRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/CanvasSpriteRenderer.java
	 */
	
	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	
	var CanvasSpriteRenderer = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer -The renderer sprite this batch works for.
	     */
	    function CanvasSpriteRenderer(renderer) {
	        _classCallCheck(this, CanvasSpriteRenderer);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * Renders the sprite object.
	     *
	     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
	     */
	
	
	    CanvasSpriteRenderer.prototype.render = function render(sprite) {
	        var texture = sprite._texture;
	        var renderer = this.renderer;
	
	        var width = texture._frame.width;
	        var height = texture._frame.height;
	
	        var wt = sprite.transform.worldTransform;
	        var dx = 0;
	        var dy = 0;
	
	        if (texture.orig.width <= 0 || texture.orig.height <= 0 || !texture.baseTexture.source) {
	            return;
	        }
	
	        renderer.setBlendMode(sprite.blendMode);
	
	        //  Ignore null sources
	        if (texture.valid) {
	            renderer.context.globalAlpha = sprite.worldAlpha;
	
	            // If smoothingEnabled is supported and we need to change the smoothing property for sprite texture
	            var smoothingEnabled = texture.baseTexture.scaleMode === _const.SCALE_MODES.LINEAR;
	
	            if (renderer.smoothProperty && renderer.context[renderer.smoothProperty] !== smoothingEnabled) {
	                renderer.context[renderer.smoothProperty] = smoothingEnabled;
	            }
	
	            if (texture.trim) {
	                dx = texture.trim.width / 2 + texture.trim.x - sprite.anchor.x * texture.orig.width;
	                dy = texture.trim.height / 2 + texture.trim.y - sprite.anchor.y * texture.orig.height;
	            } else {
	                dx = (0.5 - sprite.anchor.x) * texture.orig.width;
	                dy = (0.5 - sprite.anchor.y) * texture.orig.height;
	            }
	
	            if (texture.rotate) {
	                wt.copy(canvasRenderWorldTransform);
	                wt = canvasRenderWorldTransform;
	                _math.GroupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
	                // the anchor has already been applied above, so lets set it to zero
	                dx = 0;
	                dy = 0;
	            }
	
	            dx -= width / 2;
	            dy -= height / 2;
	
	            // Allow for pixel rounding
	            if (renderer.roundPixels) {
	                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution | 0, wt.ty * renderer.resolution | 0);
	
	                dx = dx | 0;
	                dy = dy | 0;
	            } else {
	                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
	            }
	
	            var resolution = texture.baseTexture.resolution;
	
	            if (sprite.tint !== 0xFFFFFF) {
	                if (sprite.cachedTint !== sprite.tint || sprite.tintedTexture.tintId !== sprite._texture._updateID) {
	                    sprite.cachedTint = sprite.tint;
	
	                    // TODO clean up caching - how to clean up the caches?
	                    sprite.tintedTexture = _CanvasTinter2.default.getTintedTexture(sprite, sprite.tint);
	                }
	
	                renderer.context.drawImage(sprite.tintedTexture, 0, 0, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
	            } else {
	                renderer.context.drawImage(texture.baseTexture.source, texture._frame.x * resolution, texture._frame.y * resolution, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
	            }
	        }
	    };
	
	    /**
	     * destroy the sprite object.
	     *
	     */
	
	
	    CanvasSpriteRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };
	
	    return CanvasSpriteRenderer;
	}();
	
	exports.default = CanvasSpriteRenderer;
	
	
	_CanvasRenderer2.default.registerPlugin('sprite', CanvasSpriteRenderer);
	//# sourceMappingURL=CanvasSpriteRenderer.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class
	 * @memberof PIXI
	 */
	var Buffer = function () {
	  /**
	   * @param {number} size - The size of the buffer in bytes.
	   */
	  function Buffer(size) {
	    _classCallCheck(this, Buffer);
	
	    this.vertices = new ArrayBuffer(size);
	
	    /**
	     * View on the vertices as a Float32Array for positions
	     *
	     * @member {Float32Array}
	     */
	    this.float32View = new Float32Array(this.vertices);
	
	    /**
	     * View on the vertices as a Uint32Array for uvs
	     *
	     * @member {Float32Array}
	     */
	    this.uint32View = new Uint32Array(this.vertices);
	  }
	
	  /**
	   * Destroys the buffer.
	   *
	   */
	
	
	  Buffer.prototype.destroy = function destroy() {
	    this.vertices = null;
	    this.positions = null;
	    this.uvs = null;
	    this.colors = null;
	  };
	
	  return Buffer;
	}();
	
	exports.default = Buffer;
	//# sourceMappingURL=BatchBuffer.js.map

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ObjectRenderer2 = __webpack_require__(36);
	
	var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);
	
	var _WebGLRenderer = __webpack_require__(35);
	
	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
	
	var _createIndicesForQuads = __webpack_require__(67);
	
	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
	
	var _generateMultiTextureShader = __webpack_require__(233);
	
	var _generateMultiTextureShader2 = _interopRequireDefault(_generateMultiTextureShader);
	
	var _checkMaxIfStatmentsInShader = __webpack_require__(226);
	
	var _checkMaxIfStatmentsInShader2 = _interopRequireDefault(_checkMaxIfStatmentsInShader);
	
	var _BatchBuffer = __webpack_require__(231);
	
	var _BatchBuffer2 = _interopRequireDefault(_BatchBuffer);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _utils = __webpack_require__(5);
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _bitTwiddle = __webpack_require__(50);
	
	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TICK = 0;
	var TEXTURE_TICK = 0;
	
	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	
	var SpriteRenderer = function (_ObjectRenderer) {
	    _inherits(SpriteRenderer, _ObjectRenderer);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
	     */
	    function SpriteRenderer(renderer) {
	        _classCallCheck(this, SpriteRenderer);
	
	        /**
	         * Number of values sent in the vertex buffer.
	         * aVertexPosition(2), aTextureCoord(1), aColor(1), aTextureId(1) = 5
	         *
	         * @member {number}
	         */
	        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));
	
	        _this.vertSize = 5;
	
	        /**
	         * The size of the vertex information in bytes.
	         *
	         * @member {number}
	         */
	        _this.vertByteSize = _this.vertSize * 4;
	
	        /**
	         * The number of images in the SpriteRenderer before it flushes.
	         *
	         * @member {number}
	         */
	        _this.size = _settings2.default.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop
	
	        // the total number of bytes in our batch
	        // let numVerts = this.size * 4 * this.vertByteSize;
	
	        _this.buffers = [];
	        for (var i = 1; i <= _bitTwiddle2.default.nextPow2(_this.size); i *= 2) {
	            _this.buffers.push(new _BatchBuffer2.default(i * 4 * _this.vertByteSize));
	        }
	
	        /**
	         * Holds the indices of the geometry (quads) to draw
	         *
	         * @member {Uint16Array}
	         */
	        _this.indices = (0, _createIndicesForQuads2.default)(_this.size);
	
	        /**
	         * The default shaders that is used if a sprite doesn't have a more specific one.
	         * there is a shader for each number of textures that can be rendererd.
	         * These shaders will also be generated on the fly as required.
	         * @member {PIXI.Shader[]}
	         */
	        _this.shader = null;
	
	        _this.currentIndex = 0;
	        _this.groups = [];
	
	        for (var k = 0; k < _this.size; k++) {
	            _this.groups[k] = { textures: [], textureCount: 0, ids: [], size: 0, start: 0, blend: 0 };
	        }
	
	        _this.sprites = [];
	
	        _this.vertexBuffers = [];
	        _this.vaos = [];
	
	        _this.vaoMax = 2;
	        _this.vertexCount = 0;
	
	        _this.renderer.on('prerender', _this.onPrerender, _this);
	        return _this;
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    SpriteRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        if (this.renderer.legacy) {
	            this.MAX_TEXTURES = 1;
	        } else {
	            // step 1: first check max textures the GPU can handle.
	            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _settings2.default.SPRITE_MAX_TEXTURES);
	
	            // step 2: check the maximum number of if statements the shader can have too..
	            this.MAX_TEXTURES = (0, _checkMaxIfStatmentsInShader2.default)(this.MAX_TEXTURES, gl);
	        }
	
	        this.shader = (0, _generateMultiTextureShader2.default)(gl, this.MAX_TEXTURES);
	
	        // create a couple of buffers
	        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
	
	        // we use the second shader as the first one depending on your browser may omit aTextureId
	        // as it is not used by the shader so is optimized out.
	
	        this.renderer.bindVao(null);
	
	        var attrs = this.shader.attributes;
	
	        for (var i = 0; i < this.vaoMax; i++) {
	            /* eslint-disable max-len */
	            var vertexBuffer = this.vertexBuffers[i] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
	            /* eslint-enable max-len */
	
	            // build the vao object that will render..
	            var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);
	
	            if (attrs.aTextureId) {
	                vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
	            }
	
	            this.vaos[i] = vao;
	        }
	
	        this.vao = this.vaos[0];
	        this.currentBlendMode = 99999;
	
	        this.boundTextures = new Array(this.MAX_TEXTURES);
	    };
	
	    /**
	     * Called before the renderer starts rendering.
	     *
	     */
	
	
	    SpriteRenderer.prototype.onPrerender = function onPrerender() {
	        this.vertexCount = 0;
	    };
	
	    /**
	     * Renders the sprite object.
	     *
	     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
	     */
	
	
	    SpriteRenderer.prototype.render = function render(sprite) {
	        // TODO set blend modes..
	        // check texture..
	        if (this.currentIndex >= this.size) {
	            this.flush();
	        }
	
	        // get the uvs for the texture
	
	        // if the uvs have not updated then no point rendering just yet!
	        if (!sprite._texture._uvs) {
	            return;
	        }
	
	        // push a texture.
	        // increment the batchsize
	        this.sprites[this.currentIndex++] = sprite;
	    };
	
	    /**
	     * Renders the content and empties the current batch.
	     *
	     */
	
	
	    SpriteRenderer.prototype.flush = function flush() {
	        if (this.currentIndex === 0) {
	            return;
	        }
	
	        var gl = this.renderer.gl;
	        var MAX_TEXTURES = this.MAX_TEXTURES;
	
	        var np2 = _bitTwiddle2.default.nextPow2(this.currentIndex);
	        var log2 = _bitTwiddle2.default.log2(np2);
	        var buffer = this.buffers[log2];
	
	        var sprites = this.sprites;
	        var groups = this.groups;
	
	        var float32View = buffer.float32View;
	        var uint32View = buffer.uint32View;
	
	        var boundTextures = this.boundTextures;
	        var rendererBoundTextures = this.renderer.boundTextures;
	        var touch = this.renderer.textureGC.count;
	
	        var index = 0;
	        var nextTexture = void 0;
	        var currentTexture = void 0;
	        var groupCount = 1;
	        var textureCount = 0;
	        var currentGroup = groups[0];
	        var vertexData = void 0;
	        var uvs = void 0;
	        var blendMode = _utils.premultiplyBlendMode[sprites[0]._texture.baseTexture.premultipliedAlpha ? 1 : 0][sprites[0].blendMode];
	
	        currentGroup.textureCount = 0;
	        currentGroup.start = 0;
	        currentGroup.blend = blendMode;
	
	        TICK++;
	
	        var i = void 0;
	
	        // copy textures..
	        for (i = 0; i < MAX_TEXTURES; ++i) {
	            var bt = rendererBoundTextures[i];
	
	            if (bt._enabled === TICK) {
	                boundTextures[i] = this.renderer.emptyTextures[i];
	                continue;
	            }
	
	            boundTextures[i] = bt;
	            bt._virtalBoundId = i;
	            bt._enabled = TICK;
	        }
	        TICK++;
	
	        for (i = 0; i < this.currentIndex; ++i) {
	            // upload the sprite elemetns...
	            // they have all ready been calculated so we just need to push them into the buffer.
	            var sprite = sprites[i];
	
	            sprites[i] = null;
	
	            nextTexture = sprite._texture.baseTexture;
	
	            var spriteBlendMode = _utils.premultiplyBlendMode[Number(nextTexture.premultipliedAlpha)][sprite.blendMode];
	
	            if (blendMode !== spriteBlendMode) {
	                // finish a group..
	                blendMode = spriteBlendMode;
	
	                // force the batch to break!
	                currentTexture = null;
	                textureCount = MAX_TEXTURES;
	                TICK++;
	            }
	
	            if (currentTexture !== nextTexture) {
	                currentTexture = nextTexture;
	
	                if (nextTexture._enabled !== TICK) {
	                    if (textureCount === MAX_TEXTURES) {
	                        TICK++;
	
	                        currentGroup.size = i - currentGroup.start;
	
	                        textureCount = 0;
	
	                        currentGroup = groups[groupCount++];
	                        currentGroup.blend = blendMode;
	                        currentGroup.textureCount = 0;
	                        currentGroup.start = i;
	                    }
	
	                    nextTexture.touched = touch;
	
	                    if (nextTexture._virtalBoundId === -1) {
	                        for (var j = 0; j < MAX_TEXTURES; ++j) {
	                            var tIndex = (j + TEXTURE_TICK) % MAX_TEXTURES;
	
	                            var t = boundTextures[tIndex];
	
	                            if (t._enabled !== TICK) {
	                                TEXTURE_TICK++;
	
	                                t._virtalBoundId = -1;
	
	                                nextTexture._virtalBoundId = tIndex;
	
	                                boundTextures[tIndex] = nextTexture;
	                                break;
	                            }
	                        }
	                    }
	
	                    nextTexture._enabled = TICK;
	
	                    currentGroup.textureCount++;
	                    currentGroup.ids[textureCount] = nextTexture._virtalBoundId;
	                    currentGroup.textures[textureCount++] = nextTexture;
	                }
	            }
	
	            vertexData = sprite.vertexData;
	
	            // TODO this sum does not need to be set each frame..
	            uvs = sprite._texture._uvs.uvsUint32;
	
	            if (this.renderer.roundPixels) {
	                var resolution = this.renderer.resolution;
	
	                // xy
	                float32View[index] = (vertexData[0] * resolution | 0) / resolution;
	                float32View[index + 1] = (vertexData[1] * resolution | 0) / resolution;
	
	                // xy
	                float32View[index + 5] = (vertexData[2] * resolution | 0) / resolution;
	                float32View[index + 6] = (vertexData[3] * resolution | 0) / resolution;
	
	                // xy
	                float32View[index + 10] = (vertexData[4] * resolution | 0) / resolution;
	                float32View[index + 11] = (vertexData[5] * resolution | 0) / resolution;
	
	                // xy
	                float32View[index + 15] = (vertexData[6] * resolution | 0) / resolution;
	                float32View[index + 16] = (vertexData[7] * resolution | 0) / resolution;
	            } else {
	                // xy
	                float32View[index] = vertexData[0];
	                float32View[index + 1] = vertexData[1];
	
	                // xy
	                float32View[index + 5] = vertexData[2];
	                float32View[index + 6] = vertexData[3];
	
	                // xy
	                float32View[index + 10] = vertexData[4];
	                float32View[index + 11] = vertexData[5];
	
	                // xy
	                float32View[index + 15] = vertexData[6];
	                float32View[index + 16] = vertexData[7];
	            }
	
	            uint32View[index + 2] = uvs[0];
	            uint32View[index + 7] = uvs[1];
	            uint32View[index + 12] = uvs[2];
	            uint32View[index + 17] = uvs[3];
	            /* eslint-disable max-len */
	            var alpha = Math.min(sprite.worldAlpha, 1.0);
	            // we dont call extra function if alpha is 1.0, that's faster
	            var argb = alpha < 1.0 && nextTexture.premultipliedAlpha ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);
	
	            uint32View[index + 3] = uint32View[index + 8] = uint32View[index + 13] = uint32View[index + 18] = argb;
	            float32View[index + 4] = float32View[index + 9] = float32View[index + 14] = float32View[index + 19] = nextTexture._virtalBoundId;
	            /* eslint-enable max-len */
	
	            index += 20;
	        }
	
	        currentGroup.size = i - currentGroup.start;
	
	        if (!_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
	            // this is still needed for IOS performance..
	            // it really does not like uploading to the same buffer in a single frame!
	            if (this.vaoMax <= this.vertexCount) {
	                this.vaoMax++;
	
	                var attrs = this.shader.attributes;
	
	                /* eslint-disable max-len */
	                var vertexBuffer = this.vertexBuffers[this.vertexCount] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
	                /* eslint-enable max-len */
	
	                // build the vao object that will render..
	                var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);
	
	                if (attrs.aTextureId) {
	                    vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
	                }
	
	                this.vaos[this.vertexCount] = vao;
	            }
	
	            this.renderer.bindVao(this.vaos[this.vertexCount]);
	
	            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, false);
	
	            this.vertexCount++;
	        } else {
	            // lets use the faster option, always use buffer number 0
	            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, true);
	        }
	
	        for (i = 0; i < MAX_TEXTURES; ++i) {
	            rendererBoundTextures[i]._virtalBoundId = -1;
	        }
	
	        // render the groups..
	        for (i = 0; i < groupCount; ++i) {
	            var group = groups[i];
	            var groupTextureCount = group.textureCount;
	
	            for (var _j = 0; _j < groupTextureCount; _j++) {
	                currentTexture = group.textures[_j];
	
	                // reset virtual ids..
	                // lets do a quick check..
	                if (rendererBoundTextures[group.ids[_j]] !== currentTexture) {
	                    this.renderer.bindTexture(currentTexture, group.ids[_j], true);
	                }
	
	                // reset the virtualId..
	                currentTexture._virtalBoundId = -1;
	            }
	
	            // set the blend mode..
	            this.renderer.state.setBlendMode(group.blend);
	
	            gl.drawElements(gl.TRIANGLES, group.size * 6, gl.UNSIGNED_SHORT, group.start * 6 * 2);
	        }
	
	        // reset elements for the next flush
	        this.currentIndex = 0;
	    };
	
	    /**
	     * Starts a new sprite batch.
	     */
	
	
	    SpriteRenderer.prototype.start = function start() {
	        this.renderer.bindShader(this.shader);
	
	        if (_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
	            // bind buffer #0, we don't need others
	            this.renderer.bindVao(this.vaos[this.vertexCount]);
	
	            this.vertexBuffers[this.vertexCount].bind();
	        }
	    };
	
	    /**
	     * Stops and flushes the current batch.
	     *
	     */
	
	
	    SpriteRenderer.prototype.stop = function stop() {
	        this.flush();
	    };
	
	    /**
	     * Destroys the SpriteRenderer.
	     *
	     */
	
	
	    SpriteRenderer.prototype.destroy = function destroy() {
	        for (var i = 0; i < this.vaoMax; i++) {
	            if (this.vertexBuffers[i]) {
	                this.vertexBuffers[i].destroy();
	            }
	            if (this.vaos[i]) {
	                this.vaos[i].destroy();
	            }
	        }
	
	        if (this.indexBuffer) {
	            this.indexBuffer.destroy();
	        }
	
	        this.renderer.off('prerender', this.onPrerender, this);
	
	        _ObjectRenderer.prototype.destroy.call(this);
	
	        if (this.shader) {
	            this.shader.destroy();
	            this.shader = null;
	        }
	
	        this.vertexBuffers = null;
	        this.vaos = null;
	        this.indexBuffer = null;
	        this.indices = null;
	
	        this.sprites = null;
	
	        for (var _i = 0; _i < this.buffers.length; ++_i) {
	            this.buffers[_i].destroy();
	        }
	    };
	
	    return SpriteRenderer;
	}(_ObjectRenderer3.default);
	
	exports.default = SpriteRenderer;
	
	
	_WebGLRenderer2.default.registerPlugin('sprite', SpriteRenderer);
	//# sourceMappingURL=SpriteRenderer.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = generateMultiTextureShader;
	
	var _Shader = __webpack_require__(26);
	
	var _Shader2 = _interopRequireDefault(_Shader);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fragTemplate = ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'varying float vTextureId;', 'uniform sampler2D uSamplers[%count%];', 'void main(void){', 'vec4 color;', 'float textureId = floor(vTextureId+0.5);', '%forloop%', 'gl_FragColor = color * vColor;', '}'].join('\n');
	
	function generateMultiTextureShader(gl, maxTextures) {
	    var vertexSrc = 'precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor;\n}\n';
	    var fragmentSrc = fragTemplate;
	
	    fragmentSrc = fragmentSrc.replace(/%count%/gi, maxTextures);
	    fragmentSrc = fragmentSrc.replace(/%forloop%/gi, generateSampleSrc(maxTextures));
	
	    var shader = new _Shader2.default(gl, vertexSrc, fragmentSrc);
	
	    var sampleValues = [];
	
	    for (var i = 0; i < maxTextures; i++) {
	        sampleValues[i] = i;
	    }
	
	    shader.bind();
	    shader.uniforms.uSamplers = sampleValues;
	
	    return shader;
	}
	
	function generateSampleSrc(maxTextures) {
	    var src = '';
	
	    src += '\n';
	    src += '\n';
	
	    for (var i = 0; i < maxTextures; i++) {
	        if (i > 0) {
	            src += '\nelse ';
	        }
	
	        if (i < maxTextures - 1) {
	            src += 'if(textureId == ' + i + '.0)';
	        }
	
	        src += '\n{';
	        src += '\n\tcolor = texture2D(uSamplers[' + i + '], vTextureCoord);';
	        src += '\n}';
	    }
	
	    src += '\n';
	    src += '\n';
	
	    return src;
	}
	//# sourceMappingURL=generateMultiTextureShader.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Sprite2 = __webpack_require__(63);
	
	var _Sprite3 = _interopRequireDefault(_Sprite2);
	
	var _Texture = __webpack_require__(17);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _math = __webpack_require__(7);
	
	var _utils = __webpack_require__(5);
	
	var _const = __webpack_require__(3);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _TextStyle = __webpack_require__(116);
	
	var _TextStyle2 = _interopRequireDefault(_TextStyle);
	
	var _TextMetrics = __webpack_require__(115);
	
	var _TextMetrics2 = _interopRequireDefault(_TextMetrics);
	
	var _trimCanvas = __webpack_require__(243);
	
	var _trimCanvas2 = _interopRequireDefault(_trimCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-depth: [2, 8] */
	
	
	var defaultDestroyOptions = {
	    texture: true,
	    children: false,
	    baseTexture: true
	};
	
	/**
	 * A Text Object will create a line or multiple lines of text. To split a line you can use '\n' in your text string,
	 * or add a wordWrap property set to true and and wordWrapWidth property with a value in the style object.
	 *
	 * A Text can be created directly from a string and a style object
	 *
	 * ```js
	 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI
	 */
	
	var Text = function (_Sprite) {
	    _inherits(Text, _Sprite);
	
	    /**
	     * @param {string} text - The string that you would like the text to display
	     * @param {object|PIXI.TextStyle} [style] - The style parameters
	     * @param {HTMLCanvasElement} [canvas] - The canvas element for drawing text
	     */
	    function Text(text, style, canvas) {
	        _classCallCheck(this, Text);
	
	        canvas = canvas || document.createElement('canvas');
	
	        canvas.width = 3;
	        canvas.height = 3;
	
	        var texture = _Texture2.default.fromCanvas(canvas, _settings2.default.SCALE_MODE, 'text');
	
	        texture.orig = new _math.Rectangle();
	        texture.trim = new _math.Rectangle();
	
	        // base texture is already automatically added to the cache, now adding the actual texture
	        var _this = _possibleConstructorReturn(this, _Sprite.call(this, texture));
	
	        _Texture2.default.addToCache(_this._texture, _this._texture.baseTexture.textureCacheIds[0]);
	
	        /**
	         * The canvas element that everything is drawn to
	         *
	         * @member {HTMLCanvasElement}
	         */
	        _this.canvas = canvas;
	
	        /**
	         * The canvas 2d context that everything is drawn with
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.canvas.getContext('2d');
	
	        /**
	         * The resolution / device pixel ratio of the canvas. This is set automatically by the renderer.
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = _settings2.default.RESOLUTION;
	
	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = null;
	
	        /**
	         * Private tracker for the current style.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._style = null;
	        /**
	         * Private listener to track style changes.
	         *
	         * @member {Function}
	         * @private
	         */
	        _this._styleListener = null;
	
	        /**
	         * Private tracker for the current font.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._font = '';
	
	        _this.text = text;
	        _this.style = style;
	
	        _this.localStyleID = -1;
	        return _this;
	    }
	
	    /**
	     * Renders text and updates it when needed.
	     *
	     * @private
	     * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
	     */
	
	
	    Text.prototype.updateText = function updateText(respectDirty) {
	        var style = this._style;
	
	        // check if style has changed..
	        if (this.localStyleID !== style.styleID) {
	            this.dirty = true;
	            this.localStyleID = style.styleID;
	        }
	
	        if (!this.dirty && respectDirty) {
	            return;
	        }
	
	        this._font = this._style.toFontString();
	
	        var context = this.context;
	        var measured = _TextMetrics2.default.measureText(this._text, this._style, this._style.wordWrap, this.canvas);
	        var width = measured.width;
	        var height = measured.height;
	        var lines = measured.lines;
	        var lineHeight = measured.lineHeight;
	        var lineWidths = measured.lineWidths;
	        var maxLineWidth = measured.maxLineWidth;
	        var fontProperties = measured.fontProperties;
	
	        this.canvas.width = Math.ceil((Math.max(1, width) + style.padding * 2) * this.resolution);
	        this.canvas.height = Math.ceil((Math.max(1, height) + style.padding * 2) * this.resolution);
	
	        context.scale(this.resolution, this.resolution);
	
	        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	
	        context.font = this._font;
	        context.strokeStyle = style.stroke;
	        context.lineWidth = style.strokeThickness;
	        context.textBaseline = style.textBaseline;
	        context.lineJoin = style.lineJoin;
	        context.miterLimit = style.miterLimit;
	
	        var linePositionX = void 0;
	        var linePositionY = void 0;
	
	        if (style.dropShadow) {
	            context.fillStyle = style.dropShadowColor;
	            context.globalAlpha = style.dropShadowAlpha;
	            context.shadowBlur = style.dropShadowBlur;
	
	            if (style.dropShadowBlur > 0) {
	                context.shadowColor = style.dropShadowColor;
	            }
	
	            var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
	            var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;
	
	            for (var i = 0; i < lines.length; i++) {
	                linePositionX = style.strokeThickness / 2;
	                linePositionY = style.strokeThickness / 2 + i * lineHeight + fontProperties.ascent;
	
	                if (style.align === 'right') {
	                    linePositionX += maxLineWidth - lineWidths[i];
	                } else if (style.align === 'center') {
	                    linePositionX += (maxLineWidth - lineWidths[i]) / 2;
	                }
	
	                if (style.fill) {
	                    this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding);
	
	                    if (style.stroke && style.strokeThickness) {
	                        context.strokeStyle = style.dropShadowColor;
	                        this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding, true);
	                        context.strokeStyle = style.stroke;
	                    }
	                }
	            }
	        }
	
	        // reset the shadow blur and alpha that was set by the drop shadow, for the regular text
	        context.shadowBlur = 0;
	        context.globalAlpha = 1;
	
	        // set canvas text styles
	        context.fillStyle = this._generateFillStyle(style, lines);
	
	        // draw lines line by line
	        for (var _i = 0; _i < lines.length; _i++) {
	            linePositionX = style.strokeThickness / 2;
	            linePositionY = style.strokeThickness / 2 + _i * lineHeight + fontProperties.ascent;
	
	            if (style.align === 'right') {
	                linePositionX += maxLineWidth - lineWidths[_i];
	            } else if (style.align === 'center') {
	                linePositionX += (maxLineWidth - lineWidths[_i]) / 2;
	            }
	
	            if (style.stroke && style.strokeThickness) {
	                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding, true);
	            }
	
	            if (style.fill) {
	                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding);
	            }
	        }
	
	        this.updateTexture();
	    };
	
	    /**
	     * Render the text with letter-spacing.
	     * @param {string} text - The text to draw
	     * @param {number} x - Horizontal position to draw the text
	     * @param {number} y - Vertical position to draw the text
	     * @param {boolean} [isStroke=false] - Is this drawing for the outside stroke of the
	     *  text? If not, it's for the inside fill
	     * @private
	     */
	
	
	    Text.prototype.drawLetterSpacing = function drawLetterSpacing(text, x, y) {
	        var isStroke = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var style = this._style;
	
	        // letterSpacing of 0 means normal
	        var letterSpacing = style.letterSpacing;
	
	        if (letterSpacing === 0) {
	            if (isStroke) {
	                this.context.strokeText(text, x, y);
	            } else {
	                this.context.fillText(text, x, y);
	            }
	
	            return;
	        }
	
	        var characters = String.prototype.split.call(text, '');
	        var currentPosition = x;
	        var index = 0;
	        var current = '';
	
	        while (index < text.length) {
	            current = characters[index++];
	            if (isStroke) {
	                this.context.strokeText(current, currentPosition, y);
	            } else {
	                this.context.fillText(current, currentPosition, y);
	            }
	            currentPosition += this.context.measureText(current).width + letterSpacing;
	        }
	    };
	
	    /**
	     * Updates texture size based on canvas size
	     *
	     * @private
	     */
	
	
	    Text.prototype.updateTexture = function updateTexture() {
	        var canvas = this.canvas;
	
	        if (this._style.trim) {
	            var trimmed = (0, _trimCanvas2.default)(canvas);
	
	            canvas.width = trimmed.width;
	            canvas.height = trimmed.height;
	            this.context.putImageData(trimmed.data, 0, 0);
	        }
	
	        var texture = this._texture;
	        var style = this._style;
	        var padding = style.trim ? 0 : style.padding;
	        var baseTexture = texture.baseTexture;
	
	        baseTexture.hasLoaded = true;
	        baseTexture.resolution = this.resolution;
	
	        baseTexture.realWidth = canvas.width;
	        baseTexture.realHeight = canvas.height;
	        baseTexture.width = canvas.width / this.resolution;
	        baseTexture.height = canvas.height / this.resolution;
	
	        texture.trim.width = texture._frame.width = canvas.width / this.resolution;
	        texture.trim.height = texture._frame.height = canvas.height / this.resolution;
	        texture.trim.x = -padding;
	        texture.trim.y = -padding;
	
	        texture.orig.width = texture._frame.width - padding * 2;
	        texture.orig.height = texture._frame.height - padding * 2;
	
	        // call sprite onTextureUpdate to update scale if _width or _height were set
	        this._onTextureUpdate();
	
	        baseTexture.emit('update', baseTexture);
	
	        this.dirty = false;
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    Text.prototype.renderWebGL = function renderWebGL(renderer) {
	        if (this.resolution !== renderer.resolution) {
	            this.resolution = renderer.resolution;
	            this.dirty = true;
	        }
	
	        this.updateText(true);
	
	        _Sprite.prototype.renderWebGL.call(this, renderer);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	
	
	    Text.prototype._renderCanvas = function _renderCanvas(renderer) {
	        if (this.resolution !== renderer.resolution) {
	            this.resolution = renderer.resolution;
	            this.dirty = true;
	        }
	
	        this.updateText(true);
	
	        _Sprite.prototype._renderCanvas.call(this, renderer);
	    };
	
	    /**
	     * Gets the local bounds of the text object.
	     *
	     * @param {Rectangle} rect - The output rectangle.
	     * @return {Rectangle} The bounds.
	     */
	
	
	    Text.prototype.getLocalBounds = function getLocalBounds(rect) {
	        this.updateText(true);
	
	        return _Sprite.prototype.getLocalBounds.call(this, rect);
	    };
	
	    /**
	     * calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
	     */
	
	
	    Text.prototype._calculateBounds = function _calculateBounds() {
	        this.updateText(true);
	        this.calculateVertices();
	        // if we have already done this on THIS frame.
	        this._bounds.addQuad(this.vertexData);
	    };
	
	    /**
	     * Method to be called upon a TextStyle change.
	     * @private
	     */
	
	
	    Text.prototype._onStyleChange = function _onStyleChange() {
	        this.dirty = true;
	    };
	
	    /**
	     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
	     *
	     * @private
	     * @param {object} style - The style.
	     * @param {string[]} lines - The lines of text.
	     * @return {string|number|CanvasGradient} The fill style
	     */
	
	
	    Text.prototype._generateFillStyle = function _generateFillStyle(style, lines) {
	        if (!Array.isArray(style.fill)) {
	            return style.fill;
	        }
	
	        // cocoon on canvas+ cannot generate textures, so use the first colour instead
	        if (navigator.isCocoonJS) {
	            return style.fill[0];
	        }
	
	        // the gradient will be evenly spaced out according to how large the array is.
	        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
	        var gradient = void 0;
	        var totalIterations = void 0;
	        var currentIteration = void 0;
	        var stop = void 0;
	
	        var width = this.canvas.width / this.resolution;
	        var height = this.canvas.height / this.resolution;
	
	        // make a copy of the style settings, so we can manipulate them later
	        var fill = style.fill.slice();
	        var fillGradientStops = style.fillGradientStops.slice();
	
	        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
	        if (!fillGradientStops.length) {
	            var lengthPlus1 = fill.length + 1;
	
	            for (var i = 1; i < lengthPlus1; ++i) {
	                fillGradientStops.push(i / lengthPlus1);
	            }
	        }
	
	        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
	        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
	        fill.unshift(style.fill[0]);
	        fillGradientStops.unshift(0);
	
	        fill.push(style.fill[style.fill.length - 1]);
	        fillGradientStops.push(1);
	
	        if (style.fillGradientType === _const.TEXT_GRADIENT.LINEAR_VERTICAL) {
	            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
	            gradient = this.context.createLinearGradient(width / 2, 0, width / 2, height);
	
	            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
	            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
	            totalIterations = (fill.length + 1) * lines.length;
	            currentIteration = 0;
	            for (var _i2 = 0; _i2 < lines.length; _i2++) {
	                currentIteration += 1;
	                for (var j = 0; j < fill.length; j++) {
	                    if (typeof fillGradientStops[j] === 'number') {
	                        stop = fillGradientStops[j] / lines.length + _i2 / lines.length;
	                    } else {
	                        stop = currentIteration / totalIterations;
	                    }
	                    gradient.addColorStop(stop, fill[j]);
	                    currentIteration++;
	                }
	            }
	        } else {
	            // start the gradient at the center left of the canvas, and end at the center right of the canvas
	            gradient = this.context.createLinearGradient(0, height / 2, width, height / 2);
	
	            // can just evenly space out the gradients in this case, as multiple lines makes no difference
	            // to an even left to right gradient
	            totalIterations = fill.length + 1;
	            currentIteration = 1;
	
	            for (var _i3 = 0; _i3 < fill.length; _i3++) {
	                if (typeof fillGradientStops[_i3] === 'number') {
	                    stop = fillGradientStops[_i3];
	                } else {
	                    stop = currentIteration / totalIterations;
	                }
	                gradient.addColorStop(stop, fill[_i3]);
	                currentIteration++;
	            }
	        }
	
	        return gradient;
	    };
	
	    /**
	     * Destroys this text object.
	     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
	     * the majority of the time the texture will not be shared with any other Sprites.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    Text.prototype.destroy = function destroy(options) {
	        if (typeof options === 'boolean') {
	            options = { children: options };
	        }
	
	        options = Object.assign({}, defaultDestroyOptions, options);
	
	        _Sprite.prototype.destroy.call(this, options);
	
	        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
	        this.context = null;
	        this.canvas = null;
	
	        this._style = null;
	    };
	
	    /**
	     * The width of the Text, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(Text, [{
	        key: 'width',
	        get: function get() {
	            this.updateText(true);
	
	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.updateText(true);
	
	            var s = (0, _utils.sign)(this.scale.x) || 1;
	
	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        }
	
	        /**
	         * The height of the Text, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            this.updateText(true);
	
	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.updateText(true);
	
	            var s = (0, _utils.sign)(this.scale.y) || 1;
	
	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        }
	
	        /**
	         * Set the style of the text. Set up an event listener to listen for changes on the style
	         * object and mark the text as dirty.
	         *
	         * @member {object|PIXI.TextStyle}
	         */
	
	    }, {
	        key: 'style',
	        get: function get() {
	            return this._style;
	        },
	        set: function set(style) // eslint-disable-line require-jsdoc
	        {
	            style = style || {};
	
	            if (style instanceof _TextStyle2.default) {
	                this._style = style;
	            } else {
	                this._style = new _TextStyle2.default(style);
	            }
	
	            this.localStyleID = -1;
	            this.dirty = true;
	        }
	
	        /**
	         * Set the copy for the text object. To split a line you can use '\n'.
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'text',
	        get: function get() {
	            return this._text;
	        },
	        set: function set(text) // eslint-disable-line require-jsdoc
	        {
	            text = String(text === '' || text === null || text === undefined ? ' ' : text);
	
	            if (this._text === text) {
	                return;
	            }
	            this._text = text;
	            this.dirty = true;
	        }
	    }]);
	
	    return Text;
	}(_Sprite3.default);
	
	exports.default = Text;
	//# sourceMappingURL=Text.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ = __webpack_require__(4);
	
	var _utils = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Utility class for maintaining reference to a collection
	 * of Textures on a single Spritesheet.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Spritesheet = function () {
	    _createClass(Spritesheet, null, [{
	        key: 'BATCH_SIZE',
	
	        /**
	         * The maximum number of Textures to build per process.
	         *
	         * @type {number}
	         * @default 1000
	         */
	        get: function get() {
	            return 1000;
	        }
	
	        /**
	         * @param {PIXI.BaseTexture} baseTexture Reference to the source BaseTexture object.
	         * @param {Object} data - Spritesheet image data.
	         * @param {string} [resolutionFilename] - The filename to consider when determining
	         *        the resolution of the spritesheet. If not provided, the imageUrl will
	         *        be used on the BaseTexture.
	         */
	
	    }]);
	
	    function Spritesheet(baseTexture, data) {
	        var resolutionFilename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        _classCallCheck(this, Spritesheet);
	
	        /**
	         * Reference to ths source texture
	         * @type {PIXI.BaseTexture}
	         */
	        this.baseTexture = baseTexture;
	
	        /**
	         * Map of spritesheet textures.
	         * @type {Object}
	         */
	        this.textures = {};
	
	        /**
	         * Reference to the original JSON data.
	         * @type {Object}
	         */
	        this.data = data;
	
	        /**
	         * The resolution of the spritesheet.
	         * @type {number}
	         */
	        this.resolution = this._updateResolution(resolutionFilename || this.baseTexture.imageUrl);
	
	        /**
	         * Map of spritesheet frames.
	         * @type {Object}
	         * @private
	         */
	        this._frames = this.data.frames;
	
	        /**
	         * Collection of frame names.
	         * @type {string[]}
	         * @private
	         */
	        this._frameKeys = Object.keys(this._frames);
	
	        /**
	         * Current batch index being processed.
	         * @type {number}
	         * @private
	         */
	        this._batchIndex = 0;
	
	        /**
	         * Callback when parse is completed.
	         * @type {Function}
	         * @private
	         */
	        this._callback = null;
	    }
	
	    /**
	     * Generate the resolution from the filename or fallback
	     * to the meta.scale field of the JSON data.
	     *
	     * @private
	     * @param {string} resolutionFilename - The filename to use for resolving
	     *        the default resolution.
	     * @return {number} Resolution to use for spritesheet.
	     */
	
	
	    Spritesheet.prototype._updateResolution = function _updateResolution(resolutionFilename) {
	        var scale = this.data.meta.scale;
	
	        // Use a defaultValue of `null` to check if a url-based resolution is set
	        var resolution = (0, _utils.getResolutionOfUrl)(resolutionFilename, null);
	
	        // No resolution found via URL
	        if (resolution === null) {
	            // Use the scale value or default to 1
	            resolution = scale !== undefined ? parseFloat(scale) : 1;
	        }
	
	        // For non-1 resolutions, update baseTexture
	        if (resolution !== 1) {
	            this.baseTexture.resolution = resolution;
	            this.baseTexture.update();
	        }
	
	        return resolution;
	    };
	
	    /**
	     * Parser spritesheet from loaded data. This is done asynchronously
	     * to prevent creating too many Texture within a single process.
	     *
	     * @param {Function} callback - Callback when complete returns
	     *        a map of the Textures for this spritesheet.
	     */
	
	
	    Spritesheet.prototype.parse = function parse(callback) {
	        this._batchIndex = 0;
	        this._callback = callback;
	
	        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
	            this._processFrames(0);
	            this._parseComplete();
	        } else {
	            this._nextBatch();
	        }
	    };
	
	    /**
	     * Process a batch of frames
	     *
	     * @private
	     * @param {number} initialFrameIndex - The index of frame to start.
	     */
	
	
	    Spritesheet.prototype._processFrames = function _processFrames(initialFrameIndex) {
	        var frameIndex = initialFrameIndex;
	        var maxFrames = Spritesheet.BATCH_SIZE;
	        var sourceScale = this.baseTexture.sourceScale;
	
	        while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
	            var i = this._frameKeys[frameIndex];
	            var data = this._frames[i];
	            var rect = data.frame;
	
	            if (rect) {
	                var frame = null;
	                var trim = null;
	                var sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
	
	                var orig = new _.Rectangle(0, 0, Math.floor(sourceSize.w * sourceScale) / this.resolution, Math.floor(sourceSize.h * sourceScale) / this.resolution);
	
	                if (data.rotated) {
	                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution);
	                } else {
	                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
	                }
	
	                //  Check to see if the sprite is trimmed
	                if (data.trimmed !== false && data.spriteSourceSize) {
	                    trim = new _.Rectangle(Math.floor(data.spriteSourceSize.x * sourceScale) / this.resolution, Math.floor(data.spriteSourceSize.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
	                }
	
	                this.textures[i] = new _.Texture(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0);
	
	                // lets also add the frame to pixi's global cache for fromFrame and fromImage functions
	                _.Texture.addToCache(this.textures[i], i);
	            }
	
	            frameIndex++;
	        }
	    };
	
	    /**
	     * The parse has completed.
	     *
	     * @private
	     */
	
	
	    Spritesheet.prototype._parseComplete = function _parseComplete() {
	        var callback = this._callback;
	
	        this._callback = null;
	        this._batchIndex = 0;
	        callback.call(this, this.textures);
	    };
	
	    /**
	     * Begin the next batch of textures.
	     *
	     * @private
	     */
	
	
	    Spritesheet.prototype._nextBatch = function _nextBatch() {
	        var _this = this;
	
	        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
	        this._batchIndex++;
	        setTimeout(function () {
	            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) {
	                _this._nextBatch();
	            } else {
	                _this._parseComplete();
	            }
	        }, 0);
	    };
	
	    /**
	     * Destroy Spritesheet and don't use after this.
	     *
	     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
	     */
	
	
	    Spritesheet.prototype.destroy = function destroy() {
	        var destroyBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        for (var i in this.textures) {
	            this.textures[i].destroy();
	        }
	        this._frames = null;
	        this._frameKeys = null;
	        this.data = null;
	        this.textures = null;
	        if (destroyBase) {
	            this.baseTexture.destroy();
	        }
	        this.baseTexture = null;
	    };
	
	    return Spritesheet;
	}();
	
	exports.default = Spritesheet;
	//# sourceMappingURL=Spritesheet.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _const = __webpack_require__(3);
	
	var _TickerListener = __webpack_require__(237);
	
	var _TickerListener2 = _interopRequireDefault(_TickerListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A Ticker class that runs an update loop that other objects listen to.
	 * This class is composed around listeners
	 * meant for execution on the next requested animation frame.
	 * Animation frames are requested only when necessary,
	 * e.g. When the ticker is started and the emitter has listeners.
	 *
	 * @class
	 * @memberof PIXI.ticker
	 */
	var Ticker = function () {
	    /**
	     *
	     */
	    function Ticker() {
	        var _this = this;
	
	        _classCallCheck(this, Ticker);
	
	        /**
	         * The first listener. All new listeners added are chained on this.
	         * @private
	         * @type {TickerListener}
	         */
	        this._head = new _TickerListener2.default(null, null, Infinity);
	
	        /**
	         * Internal current frame request ID
	         * @private
	         */
	        this._requestId = null;
	
	        /**
	         * Internal value managed by minFPS property setter and getter.
	         * This is the maximum allowed milliseconds between updates.
	         * @private
	         */
	        this._maxElapsedMS = 100;
	
	        /**
	         * Whether or not this ticker should invoke the method
	         * {@link PIXI.ticker.Ticker#start} automatically
	         * when a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.autoStart = false;
	
	        /**
	         * Scalar time value from last frame to this frame.
	         * This value is capped by setting {@link PIXI.ticker.Ticker#minFPS}
	         * and is scaled with {@link PIXI.ticker.Ticker#speed}.
	         * **Note:** The cap may be exceeded by scaling.
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.deltaTime = 1;
	
	        /**
	         * Time elapsed in milliseconds from last frame to this frame.
	         * Opposed to what the scalar {@link PIXI.ticker.Ticker#deltaTime}
	         * is based, this value is neither capped nor scaled.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 µs.
	         * Defaults to target frame time
	         *
	         * @member {number}
	         * @default 16.66
	         */
	        this.elapsedMS = 1 / _settings2.default.TARGET_FPMS;
	
	        /**
	         * The last time {@link PIXI.ticker.Ticker#update} was invoked.
	         * This value is also reset internally outside of invoking
	         * update, but only when a new animation frame is requested.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 µs.
	         *
	         * @member {number}
	         * @default -1
	         */
	        this.lastTime = -1;
	
	        /**
	         * Factor of current {@link PIXI.ticker.Ticker#deltaTime}.
	         * @example
	         * // Scales ticker.deltaTime to what would be
	         * // the equivalent of approximately 120 FPS
	         * ticker.speed = 2;
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.speed = 1;
	
	        /**
	         * Whether or not this ticker has been started.
	         * `true` if {@link PIXI.ticker.Ticker#start} has been called.
	         * `false` if {@link PIXI.ticker.Ticker#stop} has been called.
	         * While `false`, this value may change to `true` in the
	         * event of {@link PIXI.ticker.Ticker#autoStart} being `true`
	         * and a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.started = false;
	
	        /**
	         * Internal tick method bound to ticker instance.
	         * This is because in early 2015, Function.bind
	         * is still 60% slower in high performance scenarios.
	         * Also separating frame requests from update method
	         * so listeners may be called at any time and with
	         * any animation API, just invoke ticker.update(time).
	         *
	         * @private
	         * @param {number} time - Time since last tick.
	         */
	        this._tick = function (time) {
	            _this._requestId = null;
	
	            if (_this.started) {
	                // Invoke listeners now
	                _this.update(time);
	                // Listener side effects may have modified ticker state.
	                if (_this.started && _this._requestId === null && _this._head.next) {
	                    _this._requestId = requestAnimationFrame(_this._tick);
	                }
	            }
	        };
	    }
	
	    /**
	     * Conditionally requests a new animation frame.
	     * If a frame has not already been requested, and if the internal
	     * emitter has listeners, a new frame is requested.
	     *
	     * @private
	     */
	
	
	    Ticker.prototype._requestIfNeeded = function _requestIfNeeded() {
	        if (this._requestId === null && this._head.next) {
	            // ensure callbacks get correct delta
	            this.lastTime = performance.now();
	            this._requestId = requestAnimationFrame(this._tick);
	        }
	    };
	
	    /**
	     * Conditionally cancels a pending animation frame.
	     *
	     * @private
	     */
	
	
	    Ticker.prototype._cancelIfNeeded = function _cancelIfNeeded() {
	        if (this._requestId !== null) {
	            cancelAnimationFrame(this._requestId);
	            this._requestId = null;
	        }
	    };
	
	    /**
	     * Conditionally requests a new animation frame.
	     * If the ticker has been started it checks if a frame has not already
	     * been requested, and if the internal emitter has listeners. If these
	     * conditions are met, a new frame is requested. If the ticker has not
	     * been started, but autoStart is `true`, then the ticker starts now,
	     * and continues with the previous conditions to request a new frame.
	     *
	     * @private
	     */
	
	
	    Ticker.prototype._startIfPossible = function _startIfPossible() {
	        if (this.started) {
	            this._requestIfNeeded();
	        } else if (this.autoStart) {
	            this.start();
	        }
	    };
	
	    /**
	     * Register a handler for tick events. Calls continuously unless
	     * it is removed or the ticker is stopped.
	     *
	     * @param {Function} fn - The listener function to be added for updates
	     * @param {Function} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype.add = function add(fn, context) {
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;
	
	        return this._addListener(new _TickerListener2.default(fn, context, priority));
	    };
	
	    /**
	     * Add a handler for the tick event which is only execute once.
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype.addOnce = function addOnce(fn, context) {
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;
	
	        return this._addListener(new _TickerListener2.default(fn, context, priority, true));
	    };
	
	    /**
	     * Internally adds the event handler so that it can be sorted by priority.
	     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
	     * before the rendering.
	     *
	     * @private
	     * @param {TickerListener} listener - Current listener being added.
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype._addListener = function _addListener(listener) {
	        // For attaching to head
	        var current = this._head.next;
	        var previous = this._head;
	
	        // Add the first item
	        if (!current) {
	            listener.connect(previous);
	        } else {
	            // Go from highest to lowest priority
	            while (current) {
	                if (listener.priority > current.priority) {
	                    listener.connect(previous);
	                    break;
	                }
	                previous = current;
	                current = current.next;
	            }
	
	            // Not yet connected
	            if (!listener.previous) {
	                listener.connect(previous);
	            }
	        }
	
	        this._startIfPossible();
	
	        return this;
	    };
	
	    /**
	     * Removes any handlers matching the function and context parameters.
	     * If no handlers are left after removing, then it cancels the animation frame.
	     *
	     * @param {Function} fn - The listener function to be removed
	     * @param {Function} [context] - The listener context to be removed
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */
	
	
	    Ticker.prototype.remove = function remove(fn, context) {
	        var listener = this._head.next;
	
	        while (listener) {
	            // We found a match, lets remove it
	            // no break to delete all possible matches
	            // incase a listener was added 2+ times
	            if (listener.match(fn, context)) {
	                listener = listener.destroy();
	            } else {
	                listener = listener.next;
	            }
	        }
	
	        if (!this._head.next) {
	            this._cancelIfNeeded();
	        }
	
	        return this;
	    };
	
	    /**
	     * Starts the ticker. If the ticker has listeners
	     * a new animation frame is requested at this point.
	     */
	
	
	    Ticker.prototype.start = function start() {
	        if (!this.started) {
	            this.started = true;
	            this._requestIfNeeded();
	        }
	    };
	
	    /**
	     * Stops the ticker. If the ticker has requested
	     * an animation frame it is canceled at this point.
	     */
	
	
	    Ticker.prototype.stop = function stop() {
	        if (this.started) {
	            this.started = false;
	            this._cancelIfNeeded();
	        }
	    };
	
	    /**
	     * Destroy the ticker and don't use after this. Calling
	     * this method removes all references to internal events.
	     */
	
	
	    Ticker.prototype.destroy = function destroy() {
	        this.stop();
	
	        var listener = this._head.next;
	
	        while (listener) {
	            listener = listener.destroy(true);
	        }
	
	        this._head.destroy();
	        this._head = null;
	    };
	
	    /**
	     * Triggers an update. An update entails setting the
	     * current {@link PIXI.ticker.Ticker#elapsedMS},
	     * the current {@link PIXI.ticker.Ticker#deltaTime},
	     * invoking all listeners with current deltaTime,
	     * and then finally setting {@link PIXI.ticker.Ticker#lastTime}
	     * with the value of currentTime that was provided.
	     * This method will be called automatically by animation
	     * frame callbacks if the ticker instance has been started
	     * and listeners are added.
	     *
	     * @param {number} [currentTime=performance.now()] - the current time of execution
	     */
	
	
	    Ticker.prototype.update = function update() {
	        var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
	
	        var elapsedMS = void 0;
	
	        // If the difference in time is zero or negative, we ignore most of the work done here.
	        // If there is no valid difference, then should be no reason to let anyone know about it.
	        // A zero delta, is exactly that, nothing should update.
	        //
	        // The difference in time can be negative, and no this does not mean time traveling.
	        // This can be the result of a race condition between when an animation frame is requested
	        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
	        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
	        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
	        // can receive a time argument that can be less than the lastTime value that was set within
	        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
	        //
	        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
	        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.
	
	        if (currentTime > this.lastTime) {
	            // Save uncapped elapsedMS for measurement
	            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
	
	            // cap the milliseconds elapsed used for deltaTime
	            if (elapsedMS > this._maxElapsedMS) {
	                elapsedMS = this._maxElapsedMS;
	            }
	
	            this.deltaTime = elapsedMS * _settings2.default.TARGET_FPMS * this.speed;
	
	            // Cache a local reference, in-case ticker is destroyed
	            // during the emit, we can still check for head.next
	            var head = this._head;
	
	            // Invoke listeners added to internal emitter
	            var listener = head.next;
	
	            while (listener) {
	                listener = listener.emit(this.deltaTime);
	            }
	
	            if (!head.next) {
	                this._cancelIfNeeded();
	            }
	        } else {
	            this.deltaTime = this.elapsedMS = 0;
	        }
	
	        this.lastTime = currentTime;
	    };
	
	    /**
	     * The frames per second at which this ticker is running.
	     * The default is approximately 60 in most modern browsers.
	     * **Note:** This does not factor in the value of
	     * {@link PIXI.ticker.Ticker#speed}, which is specific
	     * to scaling {@link PIXI.ticker.Ticker#deltaTime}.
	     *
	     * @member {number}
	     * @readonly
	     */
	
	
	    _createClass(Ticker, [{
	        key: 'FPS',
	        get: function get() {
	            return 1000 / this.elapsedMS;
	        }
	
	        /**
	         * Manages the maximum amount of milliseconds allowed to
	         * elapse between invoking {@link PIXI.ticker.Ticker#update}.
	         * This value is used to cap {@link PIXI.ticker.Ticker#deltaTime},
	         * but does not effect the measured value of {@link PIXI.ticker.Ticker#FPS}.
	         * When setting this property it is clamped to a value between
	         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
	         *
	         * @member {number}
	         * @default 10
	         */
	
	    }, {
	        key: 'minFPS',
	        get: function get() {
	            return 1000 / this._maxElapsedMS;
	        },
	        set: function set(fps) // eslint-disable-line require-jsdoc
	        {
	            // Clamp: 0 to TARGET_FPMS
	            var minFPMS = Math.min(Math.max(0, fps) / 1000, _settings2.default.TARGET_FPMS);
	
	            this._maxElapsedMS = 1 / minFPMS;
	        }
	    }]);
	
	    return Ticker;
	}();
	
	exports.default = Ticker;
	//# sourceMappingURL=Ticker.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Internal class for handling the priority sorting of ticker handlers.
	 *
	 * @private
	 * @class
	 * @memberof PIXI.ticker
	 */
	var TickerListener = function () {
	    /**
	     * Constructor
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} [context=null] - The listener context
	     * @param {number} [priority=0] - The priority for emitting
	     * @param {boolean} [once=false] - If the handler should fire once
	     */
	    function TickerListener(fn) {
	        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        _classCallCheck(this, TickerListener);
	
	        /**
	         * The handler function to execute.
	         * @member {Function}
	         */
	        this.fn = fn;
	
	        /**
	         * The calling to execute.
	         * @member {Function}
	         */
	        this.context = context;
	
	        /**
	         * The current priority.
	         * @member {number}
	         */
	        this.priority = priority;
	
	        /**
	         * If this should only execute once.
	         * @member {boolean}
	         */
	        this.once = once;
	
	        /**
	         * The next item in chain.
	         * @member {TickerListener}
	         */
	        this.next = null;
	
	        /**
	         * The previous item in chain.
	         * @member {TickerListener}
	         */
	        this.previous = null;
	
	        /**
	         * `true` if this listener has been destroyed already.
	         * @member {boolean}
	         * @private
	         */
	        this._destroyed = false;
	    }
	
	    /**
	     * Simple compare function to figure out if a function and context match.
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} context - The listener context
	     * @return {boolean} `true` if the listener match the arguments
	     */
	
	
	    TickerListener.prototype.match = function match(fn, context) {
	        context = context || null;
	
	        return this.fn === fn && this.context === context;
	    };
	
	    /**
	     * Emit by calling the current function.
	     * @param {number} deltaTime - time since the last emit.
	     * @return {TickerListener} Next ticker
	     */
	
	
	    TickerListener.prototype.emit = function emit(deltaTime) {
	        if (this.fn) {
	            if (this.context) {
	                this.fn.call(this.context, deltaTime);
	            } else {
	                this.fn(deltaTime);
	            }
	        }
	
	        var redirect = this.next;
	
	        if (this.once) {
	            this.destroy(true);
	        }
	
	        // Soft-destroying should remove
	        // the next reference
	        if (this._destroyed) {
	            this.next = null;
	        }
	
	        return redirect;
	    };
	
	    /**
	     * Connect to the list.
	     * @param {TickerListener} previous - Input node, previous listener
	     */
	
	
	    TickerListener.prototype.connect = function connect(previous) {
	        this.previous = previous;
	        if (previous.next) {
	            previous.next.previous = this;
	        }
	        this.next = previous.next;
	        previous.next = this;
	    };
	
	    /**
	     * Destroy and don't use after this.
	     * @param {boolean} [hard = false] `true` to remove the `next` reference, this
	     *        is considered a hard destroy. Soft destroy maintains the next reference.
	     * @return {TickerListener} The listener to redirect while emitting or removing.
	     */
	
	
	    TickerListener.prototype.destroy = function destroy() {
	        var hard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this._destroyed = true;
	        this.fn = null;
	        this.context = null;
	
	        // Disconnect, hook up next and previous
	        if (this.previous) {
	            this.previous.next = this.next;
	        }
	
	        if (this.next) {
	            this.next.previous = this.previous;
	        }
	
	        // Redirect to the next item
	        var redirect = this.next;
	
	        // Remove references
	        this.next = hard ? null : redirect;
	        this.previous = null;
	
	        return redirect;
	    };
	
	    return TickerListener;
	}();
	
	exports.default = TickerListener;
	//# sourceMappingURL=TickerListener.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = canUploadSameBuffer;
	function canUploadSameBuffer() {
		// Uploading the same buffer multiple times in a single frame can cause perf issues.
		// Apparent on IOS so only check for that at the moment
		// this check may become more complex if this issue pops up elsewhere.
		var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	
		return !ios;
	}
	//# sourceMappingURL=canUploadSameBuffer.js.map

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = mapPremultipliedBlendModes;
	
	var _const = __webpack_require__(3);
	
	/**
	 * Corrects PixiJS blend, takes premultiplied alpha into account
	 *
	 * @memberof PIXI
	 * @function mapPremultipliedBlendModes
	 * @private
	 * @param {Array<number[]>} [array] - The array to output into.
	 * @return {Array<number[]>} Mapped modes.
	 */
	
	function mapPremultipliedBlendModes() {
	    var pm = [];
	    var npm = [];
	
	    for (var i = 0; i < 32; i++) {
	        pm[i] = i;
	        npm[i] = i;
	    }
	
	    pm[_const.BLEND_MODES.NORMAL_NPM] = _const.BLEND_MODES.NORMAL;
	    pm[_const.BLEND_MODES.ADD_NPM] = _const.BLEND_MODES.ADD;
	    pm[_const.BLEND_MODES.SCREEN_NPM] = _const.BLEND_MODES.SCREEN;
	
	    npm[_const.BLEND_MODES.NORMAL] = _const.BLEND_MODES.NORMAL_NPM;
	    npm[_const.BLEND_MODES.ADD] = _const.BLEND_MODES.ADD_NPM;
	    npm[_const.BLEND_MODES.SCREEN] = _const.BLEND_MODES.SCREEN_NPM;
	
	    var array = [];
	
	    array.push(npm);
	    array.push(pm);
	
	    return array;
	}
	//# sourceMappingURL=mapPremultipliedBlendModes.js.map

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = maxRecommendedTextures;
	
	var _ismobilejs = __webpack_require__(56);
	
	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function maxRecommendedTextures(max) {
	    if (_ismobilejs2.default.tablet || _ismobilejs2.default.phone) {
	        // check if the res is iphone 6 or higher..
	        return 4;
	    }
	
	    // desktop should be ok
	    return max;
	}
	//# sourceMappingURL=maxRecommendedTextures.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.mixin = mixin;
	exports.delayMixin = delayMixin;
	exports.performMixins = performMixins;
	/**
	 * Mixes all enumerable properties and methods from a source object to a target object.
	 *
	 * @memberof PIXI.utils.mixins
	 * @function mixin
	 * @param {object} target The prototype or instance that properties and methods should be added to.
	 * @param {object} source The source of properties and methods to mix in.
	 */
	function mixin(target, source) {
	    if (!target || !source) return;
	    // in ES8/ES2017, this would be really easy:
	    // Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	
	    // get all the enumerable property keys
	    var keys = Object.keys(source);
	
	    // loop through properties
	    for (var i = 0; i < keys.length; ++i) {
	        var propertyName = keys[i];
	
	        // Set the property using the property descriptor - this works for accessors and normal value properties
	        Object.defineProperty(target, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
	    }
	}
	
	var mixins = [];
	
	/**
	 * Queues a mixin to be handled towards the end of the initialization of PIXI, so that deprecation
	 * can take effect.
	 *
	 * @memberof PIXI.utils.mixins
	 * @function delayMixin
	 * @private
	 * @param {object} target The prototype or instance that properties and methods should be added to.
	 * @param {object} source The source of properties and methods to mix in.
	 */
	function delayMixin(target, source) {
	    mixins.push(target, source);
	}
	
	/**
	 * Handles all mixins queued via delayMixin().
	 *
	 * @memberof PIXI.utils.mixins
	 * @function performMixins
	 * @private
	 */
	function performMixins() {
	    for (var i = 0; i < mixins.length; i += 2) {
	        mixin(mixins[i], mixins[i + 1]);
	    }
	    mixins.length = 0;
	}
	//# sourceMappingURL=mixin.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Mixins functionality to make an object have "plugins".
	 *
	 * @example
	 *      function MyObject() {}
	 *
	 *      pluginTarget.mixin(MyObject);
	 *
	 * @mixin
	 * @memberof PIXI.utils
	 * @param {object} obj - The object to mix into.
	 */
	function pluginTarget(obj) {
	    obj.__plugins = {};
	
	    /**
	     * Adds a plugin to an object
	     *
	     * @param {string} pluginName - The events that should be listed.
	     * @param {Function} ctor - The constructor function for the plugin.
	     */
	    obj.registerPlugin = function registerPlugin(pluginName, ctor) {
	        obj.__plugins[pluginName] = ctor;
	    };
	
	    /**
	     * Instantiates all the plugins of this object
	     *
	     */
	    obj.prototype.initPlugins = function initPlugins() {
	        this.plugins = this.plugins || {};
	
	        for (var o in obj.__plugins) {
	            this.plugins[o] = new obj.__plugins[o](this);
	        }
	    };
	
	    /**
	     * Removes all the plugins of this object
	     *
	     */
	    obj.prototype.destroyPlugins = function destroyPlugins() {
	        for (var o in this.plugins) {
	            this.plugins[o].destroy();
	            this.plugins[o] = null;
	        }
	
	        this.plugins = null;
	    };
	}
	
	exports.default = {
	    /**
	     * Mixes in the properties of the pluginTarget into another object
	     *
	     * @param {object} obj - The obj to mix into
	     */
	    mixin: function mixin(obj) {
	        pluginTarget(obj);
	    }
	};
	//# sourceMappingURL=pluginTarget.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = trimCanvas;
	/**
	 * Trim transparent borders from a canvas
	 *
	 * @memberof PIXI
	 * @function trimCanvas
	 * @private
	 * @param {HTMLCanvasElement} canvas - the canvas to trim
	 * @returns {object} Trim data
	 */
	function trimCanvas(canvas) {
	    // https://gist.github.com/remy/784508
	
	    var width = canvas.width;
	    var height = canvas.height;
	
	    var context = canvas.getContext('2d');
	    var imageData = context.getImageData(0, 0, width, height);
	    var pixels = imageData.data;
	    var len = pixels.length;
	
	    var bound = {
	        top: null,
	        left: null,
	        right: null,
	        bottom: null
	    };
	    var i = void 0;
	    var x = void 0;
	    var y = void 0;
	
	    for (i = 0; i < len; i += 4) {
	        if (pixels[i + 3] !== 0) {
	            x = i / 4 % width;
	            y = ~~(i / 4 / width);
	
	            if (bound.top === null) {
	                bound.top = y;
	            }
	
	            if (bound.left === null) {
	                bound.left = x;
	            } else if (x < bound.left) {
	                bound.left = x;
	            }
	
	            if (bound.right === null) {
	                bound.right = x + 1;
	            } else if (bound.right < x) {
	                bound.right = x + 1;
	            }
	
	            if (bound.bottom === null) {
	                bound.bottom = y;
	            } else if (bound.bottom < y) {
	                bound.bottom = y;
	            }
	        }
	    }
	
	    width = bound.right - bound.left;
	    height = bound.bottom - bound.top + 1;
	
	    var data = context.getImageData(bound.left, bound.top, width, height);
	
	    return {
	        height: height,
	        width: width,
	        data: data
	    };
	}
	//# sourceMappingURL=trimCanvas.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deprecation;
	// provide method to give a stack track for warnings
	// useful for tracking-down where deprecated methods/properties/classes
	// are being used within the code
	
	// A map of warning messages already fired
	var warnings = {};
	
	// provide method to give a stack track for warnings
	// useful for tracking-down where deprecated methods/properties/classes
	// are being used within the code
	function warn(msg) {
	    // Ignore duplicat
	    if (warnings[msg]) {
	        return;
	    }
	
	    /* eslint-disable no-console */
	    var stack = new Error().stack;
	
	    // Handle IE < 10 and Safari < 6
	    if (typeof stack === 'undefined') {
	        console.warn('Deprecation Warning: ', msg);
	    } else {
	        // chop off the stack trace which includes pixi.js internal calls
	        stack = stack.split('\n').splice(3).join('\n');
	
	        if (console.groupCollapsed) {
	            console.groupCollapsed('%cDeprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', msg);
	            console.warn(stack);
	            console.groupEnd();
	        } else {
	            console.warn('Deprecation Warning: ', msg);
	            console.warn(stack);
	        }
	    }
	    /* eslint-enable no-console */
	
	    warnings[msg] = true;
	}
	
	function deprecation(core) {
	    var mesh = core.mesh,
	        particles = core.particles,
	        extras = core.extras,
	        filters = core.filters,
	        prepare = core.prepare,
	        loaders = core.loaders,
	        interaction = core.interaction;
	
	
	    Object.defineProperties(core, {
	
	        /**
	         * @class
	         * @private
	         * @name SpriteBatch
	         * @memberof PIXI
	         * @see PIXI.ParticleContainer
	         * @throws {ReferenceError} SpriteBatch does not exist any more, please use the new ParticleContainer instead.
	         * @deprecated since version 3.0.0
	         */
	        SpriteBatch: {
	            get: function get() {
	                throw new ReferenceError('SpriteBatch does not exist any more, ' + 'please use the new ParticleContainer instead.');
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name AssetLoader
	         * @memberof PIXI
	         * @see PIXI.loaders.Loader
	         * @throws {ReferenceError} The loader system was overhauled in PixiJS v3,
	         * please see the new PIXI.loaders.Loader class.
	         * @deprecated since version 3.0.0
	         */
	        AssetLoader: {
	            get: function get() {
	                throw new ReferenceError('The loader system was overhauled in PixiJS v3, ' + 'please see the new PIXI.loaders.Loader class.');
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name Stage
	         * @memberof PIXI
	         * @see PIXI.Container
	         * @deprecated since version 3.0.0
	         */
	        Stage: {
	            get: function get() {
	                warn('You do not need to use a PIXI Stage any more, you can simply render any container.');
	
	                return core.Container;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name DisplayObjectContainer
	         * @memberof PIXI
	         * @see PIXI.Container
	         * @deprecated since version 3.0.0
	         */
	        DisplayObjectContainer: {
	            get: function get() {
	                warn('DisplayObjectContainer has been shortened to Container, please use Container from now on.');
	
	                return core.Container;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name Strip
	         * @memberof PIXI
	         * @see PIXI.mesh.Mesh
	         * @deprecated since version 3.0.0
	         */
	        Strip: {
	            get: function get() {
	                warn('The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on.');
	
	                return mesh.Mesh;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name Rope
	         * @memberof PIXI
	         * @see PIXI.mesh.Rope
	         * @deprecated since version 3.0.0
	         */
	        Rope: {
	            get: function get() {
	                warn('The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on.');
	
	                return mesh.Rope;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name ParticleContainer
	         * @memberof PIXI
	         * @see PIXI.particles.ParticleContainer
	         * @deprecated since version 4.0.0
	         */
	        ParticleContainer: {
	            get: function get() {
	                warn('The ParticleContainer class has been moved to particles.ParticleContainer, ' + 'please use particles.ParticleContainer from now on.');
	
	                return particles.ParticleContainer;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name MovieClip
	         * @memberof PIXI
	         * @see PIXI.extras.MovieClip
	         * @deprecated since version 3.0.0
	         */
	        MovieClip: {
	            get: function get() {
	                warn('The MovieClip class has been moved to extras.AnimatedSprite, please use extras.AnimatedSprite.');
	
	                return extras.AnimatedSprite;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name TilingSprite
	         * @memberof PIXI
	         * @see PIXI.extras.TilingSprite
	         * @deprecated since version 3.0.0
	         */
	        TilingSprite: {
	            get: function get() {
	                warn('The TilingSprite class has been moved to extras.TilingSprite, ' + 'please use extras.TilingSprite from now on.');
	
	                return extras.TilingSprite;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name BitmapText
	         * @memberof PIXI
	         * @see PIXI.extras.BitmapText
	         * @deprecated since version 3.0.0
	         */
	        BitmapText: {
	            get: function get() {
	                warn('The BitmapText class has been moved to extras.BitmapText, ' + 'please use extras.BitmapText from now on.');
	
	                return extras.BitmapText;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name blendModes
	         * @memberof PIXI
	         * @see PIXI.BLEND_MODES
	         * @deprecated since version 3.0.0
	         */
	        blendModes: {
	            get: function get() {
	                warn('The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on.');
	
	                return core.BLEND_MODES;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name scaleModes
	         * @memberof PIXI
	         * @see PIXI.SCALE_MODES
	         * @deprecated since version 3.0.0
	         */
	        scaleModes: {
	            get: function get() {
	                warn('The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on.');
	
	                return core.SCALE_MODES;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name BaseTextureCache
	         * @memberof PIXI
	         * @see PIXI.utils.BaseTextureCache
	         * @deprecated since version 3.0.0
	         */
	        BaseTextureCache: {
	            get: function get() {
	                warn('The BaseTextureCache class has been moved to utils.BaseTextureCache, ' + 'please use utils.BaseTextureCache from now on.');
	
	                return core.utils.BaseTextureCache;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name TextureCache
	         * @memberof PIXI
	         * @see PIXI.utils.TextureCache
	         * @deprecated since version 3.0.0
	         */
	        TextureCache: {
	            get: function get() {
	                warn('The TextureCache class has been moved to utils.TextureCache, ' + 'please use utils.TextureCache from now on.');
	
	                return core.utils.TextureCache;
	            }
	        },
	
	        /**
	         * @namespace
	         * @private
	         * @name math
	         * @memberof PIXI
	         * @see PIXI
	         * @deprecated since version 3.0.6
	         */
	        math: {
	            get: function get() {
	                warn('The math namespace is deprecated, please access members already accessible on PIXI.');
	
	                return core;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.AbstractFilter
	         * @see PIXI.Filter
	         * @deprecated since version 3.0.6
	         */
	        AbstractFilter: {
	            get: function get() {
	                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');
	
	                return core.Filter;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.TransformManual
	         * @see PIXI.TransformBase
	         * @deprecated since version 4.0.0
	         */
	        TransformManual: {
	            get: function get() {
	                warn('TransformManual has been renamed to TransformBase, please update your pixi-spine');
	
	                return core.TransformBase;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.TARGET_FPMS
	         * @see PIXI.settings.TARGET_FPMS
	         * @deprecated since version 4.2.0
	         */
	        TARGET_FPMS: {
	            get: function get() {
	                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');
	
	                return core.settings.TARGET_FPMS;
	            },
	            set: function set(value) {
	                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');
	
	                core.settings.TARGET_FPMS = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.FILTER_RESOLUTION
	         * @see PIXI.settings.FILTER_RESOLUTION
	         * @deprecated since version 4.2.0
	         */
	        FILTER_RESOLUTION: {
	            get: function get() {
	                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');
	
	                return core.settings.FILTER_RESOLUTION;
	            },
	            set: function set(value) {
	                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');
	
	                core.settings.FILTER_RESOLUTION = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.RESOLUTION
	         * @see PIXI.settings.RESOLUTION
	         * @deprecated since version 4.2.0
	         */
	        RESOLUTION: {
	            get: function get() {
	                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');
	
	                return core.settings.RESOLUTION;
	            },
	            set: function set(value) {
	                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');
	
	                core.settings.RESOLUTION = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.MIPMAP_TEXTURES
	         * @see PIXI.settings.MIPMAP_TEXTURES
	         * @deprecated since version 4.2.0
	         */
	        MIPMAP_TEXTURES: {
	            get: function get() {
	                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');
	
	                return core.settings.MIPMAP_TEXTURES;
	            },
	            set: function set(value) {
	                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');
	
	                core.settings.MIPMAP_TEXTURES = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.SPRITE_BATCH_SIZE
	         * @see PIXI.settings.SPRITE_BATCH_SIZE
	         * @deprecated since version 4.2.0
	         */
	        SPRITE_BATCH_SIZE: {
	            get: function get() {
	                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');
	
	                return core.settings.SPRITE_BATCH_SIZE;
	            },
	            set: function set(value) {
	                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');
	
	                core.settings.SPRITE_BATCH_SIZE = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.SPRITE_MAX_TEXTURES
	         * @see PIXI.settings.SPRITE_MAX_TEXTURES
	         * @deprecated since version 4.2.0
	         */
	        SPRITE_MAX_TEXTURES: {
	            get: function get() {
	                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');
	
	                return core.settings.SPRITE_MAX_TEXTURES;
	            },
	            set: function set(value) {
	                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');
	
	                core.settings.SPRITE_MAX_TEXTURES = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.RETINA_PREFIX
	         * @see PIXI.settings.RETINA_PREFIX
	         * @deprecated since version 4.2.0
	         */
	        RETINA_PREFIX: {
	            get: function get() {
	                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');
	
	                return core.settings.RETINA_PREFIX;
	            },
	            set: function set(value) {
	                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');
	
	                core.settings.RETINA_PREFIX = value;
	            }
	        },
	
	        /**
	         * @static
	         * @constant
	         * @name PIXI.DEFAULT_RENDER_OPTIONS
	         * @see PIXI.settings.RENDER_OPTIONS
	         * @deprecated since version 4.2.0
	         */
	        DEFAULT_RENDER_OPTIONS: {
	            get: function get() {
	                warn('PIXI.DEFAULT_RENDER_OPTIONS has been deprecated, please use PIXI.settings.DEFAULT_RENDER_OPTIONS');
	
	                return core.settings.RENDER_OPTIONS;
	            }
	        }
	    });
	
	    // Move the default properties to settings
	    var defaults = [{ parent: 'TRANSFORM_MODE', target: 'TRANSFORM_MODE' }, { parent: 'GC_MODES', target: 'GC_MODE' }, { parent: 'WRAP_MODES', target: 'WRAP_MODE' }, { parent: 'SCALE_MODES', target: 'SCALE_MODE' }, { parent: 'PRECISION', target: 'PRECISION_FRAGMENT' }];
	
	    var _loop = function _loop(i) {
	        var deprecation = defaults[i];
	
	        Object.defineProperty(core[deprecation.parent], 'DEFAULT', {
	            get: function get() {
	                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));
	
	                return core.settings[deprecation.target];
	            },
	            set: function set(value) {
	                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));
	
	                core.settings[deprecation.target] = value;
	            }
	        });
	    };
	
	    for (var i = 0; i < defaults.length; i++) {
	        _loop(i);
	    }
	
	    Object.defineProperties(core.settings, {
	
	        /**
	         * @static
	         * @name PRECISION
	         * @memberof PIXI.settings
	         * @see PIXI.PRECISION
	         * @deprecated since version 4.4.0
	         */
	        PRECISION: {
	            get: function get() {
	                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');
	
	                return core.settings.PRECISION_FRAGMENT;
	            },
	            set: function set(value) {
	                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');
	
	                core.settings.PRECISION_FRAGMENT = value;
	            }
	        }
	    });
	
	    if (extras.AnimatedSprite) {
	        Object.defineProperties(extras, {
	
	            /**
	             * @class
	             * @name MovieClip
	             * @memberof PIXI.extras
	             * @see PIXI.extras.AnimatedSprite
	             * @deprecated since version 4.2.0
	             */
	            MovieClip: {
	                get: function get() {
	                    warn('The MovieClip class has been renamed to AnimatedSprite, please use AnimatedSprite from now on.');
	
	                    return extras.AnimatedSprite;
	                }
	            }
	        });
	    }
	
	    if (extras) {
	        Object.defineProperties(extras, {
	            /**
	             * @class
	             * @name TextureTransform
	             * @memberof PIXI.extras
	             * @see PIXI.TextureMatrix
	             * @deprecated since version 4.6.0
	             */
	            TextureTransform: {
	                get: function get() {
	                    warn('The TextureTransform class has been renamed to TextureMatrix, ' + 'please use PIXI.TextureMatrix from now on.');
	
	                    return core.TextureMatrix;
	                }
	            }
	        });
	    }
	
	    core.DisplayObject.prototype.generateTexture = function generateTexture(renderer, scaleMode, resolution) {
	        warn('generateTexture has moved to the renderer, please use renderer.generateTexture(displayObject)');
	
	        return renderer.generateTexture(this, scaleMode, resolution);
	    };
	
	    core.Graphics.prototype.generateTexture = function generateTexture(scaleMode, resolution) {
	        warn('graphics generate texture has moved to the renderer. ' + 'Or to render a graphics to a texture using canvas please use generateCanvasTexture');
	
	        return this.generateCanvasTexture(scaleMode, resolution);
	    };
	
	    /**
	     * @method
	     * @name PIXI.GroupD8.isSwapWidthHeight
	     * @see PIXI.GroupD8.isVertical
	     * @param {number} rotation - The number to check.
	     * @returns {boolean} Whether or not the direction is vertical
	     * @deprecated since version 4.6.0
	     */
	    core.GroupD8.isSwapWidthHeight = function isSwapWidthHeight(rotation) {
	        warn('GroupD8.isSwapWidthHeight was renamed to GroupD8.isVertical');
	
	        return core.GroupD8.isVertical(rotation);
	    };
	
	    core.RenderTexture.prototype.render = function render(displayObject, matrix, clear, updateTransform) {
	        this.legacyRenderer.render(displayObject, this, clear, matrix, !updateTransform);
	        warn('RenderTexture.render is now deprecated, please use renderer.render(displayObject, renderTexture)');
	    };
	
	    core.RenderTexture.prototype.getImage = function getImage(target) {
	        warn('RenderTexture.getImage is now deprecated, please use renderer.extract.image(target)');
	
	        return this.legacyRenderer.extract.image(target);
	    };
	
	    core.RenderTexture.prototype.getBase64 = function getBase64(target) {
	        warn('RenderTexture.getBase64 is now deprecated, please use renderer.extract.base64(target)');
	
	        return this.legacyRenderer.extract.base64(target);
	    };
	
	    core.RenderTexture.prototype.getCanvas = function getCanvas(target) {
	        warn('RenderTexture.getCanvas is now deprecated, please use renderer.extract.canvas(target)');
	
	        return this.legacyRenderer.extract.canvas(target);
	    };
	
	    core.RenderTexture.prototype.getPixels = function getPixels(target) {
	        warn('RenderTexture.getPixels is now deprecated, please use renderer.extract.pixels(target)');
	
	        return this.legacyRenderer.pixels(target);
	    };
	
	    /**
	     * @method
	     * @private
	     * @name PIXI.Sprite#setTexture
	     * @see PIXI.Sprite#texture
	     * @deprecated since version 3.0.0
	     * @param {PIXI.Texture} texture - The texture to set to.
	     */
	    core.Sprite.prototype.setTexture = function setTexture(texture) {
	        this.texture = texture;
	        warn('setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;');
	    };
	
	    if (extras.BitmapText) {
	        /**
	         * @method
	         * @name PIXI.extras.BitmapText#setText
	         * @see PIXI.extras.BitmapText#text
	         * @deprecated since version 3.0.0
	         * @param {string} text - The text to set to.
	         */
	        extras.BitmapText.prototype.setText = function setText(text) {
	            this.text = text;
	            warn('setText is now deprecated, please use the text property, e.g : myBitmapText.text = \'my text\';');
	        };
	    }
	
	    /**
	     * @method
	     * @name PIXI.Text#setText
	     * @see PIXI.Text#text
	     * @deprecated since version 3.0.0
	     * @param {string} text - The text to set to.
	     */
	    core.Text.prototype.setText = function setText(text) {
	        this.text = text;
	        warn('setText is now deprecated, please use the text property, e.g : myText.text = \'my text\';');
	    };
	
	    /**
	     * Calculates the ascent, descent and fontSize of a given fontStyle
	     *
	     * @name PIXI.Text.calculateFontProperties
	     * @see PIXI.TextMetrics.measureFont
	     * @deprecated since version 4.5.0
	     * @param {string} font - String representing the style of the font
	     * @return {Object} Font properties object
	     */
	    core.Text.calculateFontProperties = function calculateFontProperties(font) {
	        warn('Text.calculateFontProperties is now deprecated, please use the TextMetrics.measureFont');
	
	        return core.TextMetrics.measureFont(font);
	    };
	
	    Object.defineProperties(core.Text, {
	        fontPropertiesCache: {
	            get: function get() {
	                warn('Text.fontPropertiesCache is deprecated');
	
	                return core.TextMetrics._fonts;
	            }
	        },
	        fontPropertiesCanvas: {
	            get: function get() {
	                warn('Text.fontPropertiesCanvas is deprecated');
	
	                return core.TextMetrics._canvas;
	            }
	        },
	        fontPropertiesContext: {
	            get: function get() {
	                warn('Text.fontPropertiesContext is deprecated');
	
	                return core.TextMetrics._context;
	            }
	        }
	    });
	
	    /**
	     * @method
	     * @name PIXI.Text#setStyle
	     * @see PIXI.Text#style
	     * @deprecated since version 3.0.0
	     * @param {*} style - The style to set to.
	     */
	    core.Text.prototype.setStyle = function setStyle(style) {
	        this.style = style;
	        warn('setStyle is now deprecated, please use the style property, e.g : myText.style = style;');
	    };
	
	    /**
	     * @method
	     * @name PIXI.Text#determineFontProperties
	     * @see PIXI.Text#measureFontProperties
	     * @deprecated since version 4.2.0
	     * @private
	     * @param {string} fontStyle - String representing the style of the font
	     * @return {Object} Font properties object
	     */
	    core.Text.prototype.determineFontProperties = function determineFontProperties(fontStyle) {
	        warn('determineFontProperties is now deprecated, please use TextMetrics.measureFont method');
	
	        return core.TextMetrics.measureFont(fontStyle);
	    };
	
	    /**
	     * @method
	     * @name PIXI.Text.getFontStyle
	     * @see PIXI.TextMetrics.getFontStyle
	     * @deprecated since version 4.5.0
	     * @param {PIXI.TextStyle} style - The style to use.
	     * @return {string} Font string
	     */
	    core.Text.getFontStyle = function getFontStyle(style) {
	        warn('getFontStyle is now deprecated, please use TextStyle.toFontString() instead');
	
	        style = style || {};
	
	        if (!(style instanceof core.TextStyle)) {
	            style = new core.TextStyle(style);
	        }
	
	        return style.toFontString();
	    };
	
	    Object.defineProperties(core.TextStyle.prototype, {
	        /**
	         * Set all properties of a font as a single string
	         *
	         * @name PIXI.TextStyle#font
	         * @deprecated since version 4.0.0
	         */
	        font: {
	            get: function get() {
	                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\', \'fontSize\', \'fontStyle\', \'fontVariant\' and \'fontWeight\' properties from now on');
	
	                var fontSizeString = typeof this._fontSize === 'number' ? this._fontSize + 'px' : this._fontSize;
	
	                return this._fontStyle + ' ' + this._fontVariant + ' ' + this._fontWeight + ' ' + fontSizeString + ' ' + this._fontFamily;
	            },
	            set: function set(font) {
	                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\',\'fontSize\',fontStyle\',\'fontVariant\' and \'fontWeight\' properties from now on');
	
	                // can work out fontStyle from search of whole string
	                if (font.indexOf('italic') > 1) {
	                    this._fontStyle = 'italic';
	                } else if (font.indexOf('oblique') > -1) {
	                    this._fontStyle = 'oblique';
	                } else {
	                    this._fontStyle = 'normal';
	                }
	
	                // can work out fontVariant from search of whole string
	                if (font.indexOf('small-caps') > -1) {
	                    this._fontVariant = 'small-caps';
	                } else {
	                    this._fontVariant = 'normal';
	                }
	
	                // fontWeight and fontFamily are tricker to find, but it's easier to find the fontSize due to it's units
	                var splits = font.split(' ');
	                var fontSizeIndex = -1;
	
	                this._fontSize = 26;
	                for (var i = 0; i < splits.length; ++i) {
	                    if (splits[i].match(/(px|pt|em|%)/)) {
	                        fontSizeIndex = i;
	                        this._fontSize = splits[i];
	                        break;
	                    }
	                }
	
	                // we can now search for fontWeight as we know it must occur before the fontSize
	                this._fontWeight = 'normal';
	                for (var _i = 0; _i < fontSizeIndex; ++_i) {
	                    if (splits[_i].match(/(bold|bolder|lighter|100|200|300|400|500|600|700|800|900)/)) {
	                        this._fontWeight = splits[_i];
	                        break;
	                    }
	                }
	
	                // and finally join everything together after the fontSize in case the font family has multiple words
	                if (fontSizeIndex > -1 && fontSizeIndex < splits.length - 1) {
	                    this._fontFamily = '';
	                    for (var _i2 = fontSizeIndex + 1; _i2 < splits.length; ++_i2) {
	                        this._fontFamily += splits[_i2] + ' ';
	                    }
	
	                    this._fontFamily = this._fontFamily.slice(0, -1);
	                } else {
	                    this._fontFamily = 'Arial';
	                }
	
	                this.styleID++;
	            }
	        }
	    });
	
	    /**
	     * @method
	     * @name PIXI.Texture#setFrame
	     * @see PIXI.Texture#setFrame
	     * @deprecated since version 3.0.0
	     * @param {PIXI.Rectangle} frame - The frame to set.
	     */
	    core.Texture.prototype.setFrame = function setFrame(frame) {
	        this.frame = frame;
	        warn('setFrame is now deprecated, please use the frame property, e.g: myTexture.frame = frame;');
	    };
	
	    /**
	     * @static
	     * @function
	     * @name PIXI.Texture.addTextureToCache
	     * @see PIXI.Texture.addToCache
	     * @deprecated since 4.5.0
	     * @param {PIXI.Texture} texture - The Texture to add to the cache.
	     * @param {string} id - The id that the texture will be stored against.
	     */
	    core.Texture.addTextureToCache = function addTextureToCache(texture, id) {
	        core.Texture.addToCache(texture, id);
	        warn('Texture.addTextureToCache is deprecated, please use Texture.addToCache from now on.');
	    };
	
	    /**
	     * @static
	     * @function
	     * @name PIXI.Texture.removeTextureFromCache
	     * @see PIXI.Texture.removeFromCache
	     * @deprecated since 4.5.0
	     * @param {string} id - The id of the texture to be removed
	     * @return {PIXI.Texture|null} The texture that was removed
	     */
	    core.Texture.removeTextureFromCache = function removeTextureFromCache(id) {
	        warn('Texture.removeTextureFromCache is deprecated, please use Texture.removeFromCache from now on. ' + 'Be aware that Texture.removeFromCache does not automatically its BaseTexture from the BaseTextureCache. ' + 'For that, use BaseTexture.removeFromCache');
	
	        core.BaseTexture.removeFromCache(id);
	
	        return core.Texture.removeFromCache(id);
	    };
	
	    Object.defineProperties(filters, {
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.AbstractFilter
	         * @see PIXI.AbstractFilter
	         * @deprecated since version 3.0.6
	         */
	        AbstractFilter: {
	            get: function get() {
	                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');
	
	                return core.AbstractFilter;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.SpriteMaskFilter
	         * @see PIXI.SpriteMaskFilter
	         * @deprecated since version 3.0.6
	         */
	        SpriteMaskFilter: {
	            get: function get() {
	                warn('filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on.');
	
	                return core.SpriteMaskFilter;
	            }
	        },
	
	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.VoidFilter
	         * @see PIXI.filters.AlphaFilter
	         * @deprecated since version 4.5.7
	         */
	        VoidFilter: {
	            get: function get() {
	                warn('VoidFilter has been renamed to AlphaFilter, please use PIXI.filters.AlphaFilter');
	
	                return filters.AlphaFilter;
	            }
	        }
	    });
	
	    /**
	     * @method
	     * @name PIXI.utils.uuid
	     * @see PIXI.utils.uid
	     * @deprecated since version 3.0.6
	     * @return {number} The uid
	     */
	    core.utils.uuid = function () {
	        warn('utils.uuid() is deprecated, please use utils.uid() from now on.');
	
	        return core.utils.uid();
	    };
	
	    /**
	     * @method
	     * @name PIXI.utils.canUseNewCanvasBlendModes
	     * @see PIXI.CanvasTinter
	     * @deprecated
	     * @return {boolean} Can use blend modes.
	     */
	    core.utils.canUseNewCanvasBlendModes = function () {
	        warn('utils.canUseNewCanvasBlendModes() is deprecated, please use CanvasTinter.canUseMultiply from now on');
	
	        return core.CanvasTinter.canUseMultiply;
	    };
	
	    var saidHello = true;
	
	    /**
	     * @name PIXI.utils._saidHello
	     * @type {boolean}
	     * @see PIXI.utils.skipHello
	     * @deprecated since 4.1.0
	     */
	    Object.defineProperty(core.utils, '_saidHello', {
	        set: function set(bool) {
	            if (bool) {
	                warn('PIXI.utils._saidHello is deprecated, please use PIXI.utils.skipHello()');
	                this.skipHello();
	            }
	            saidHello = bool;
	        },
	        get: function get() {
	            return saidHello;
	        }
	    });
	
	    if (prepare.BasePrepare) {
	        /**
	         * @method
	         * @name PIXI.prepare.BasePrepare#register
	         * @see PIXI.prepare.BasePrepare#registerFindHook
	         * @deprecated since version 4.4.2
	         * @param {Function} [addHook] - Function call that takes two parameters: `item:*, queue:Array`
	         *        function must return `true` if it was able to add item to the queue.
	         * @param {Function} [uploadHook] - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
	         *        function must return `true` if it was able to handle upload of item.
	         * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	         */
	        prepare.BasePrepare.prototype.register = function register(addHook, uploadHook) {
	            warn('renderer.plugins.prepare.register is now deprecated, ' + 'please use renderer.plugins.prepare.registerFindHook & renderer.plugins.prepare.registerUploadHook');
	
	            if (addHook) {
	                this.registerFindHook(addHook);
	            }
	
	            if (uploadHook) {
	                this.registerUploadHook(uploadHook);
	            }
	
	            return this;
	        };
	    }
	
	    if (prepare.canvas) {
	        /**
	         * The number of graphics or textures to upload to the GPU.
	         *
	         * @name PIXI.prepare.canvas.UPLOADS_PER_FRAME
	         * @static
	         * @type {number}
	         * @see PIXI.prepare.BasePrepare.limiter
	         * @deprecated since 4.2.0
	         */
	        Object.defineProperty(prepare.canvas, 'UPLOADS_PER_FRAME', {
	            set: function set() {
	                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
	                // because we don't have a reference to the renderer, we can't actually set
	                // the uploads per frame, so we'll have to stick with the warning.
	            },
	            get: function get() {
	                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');
	
	                return NaN;
	            }
	        });
	    }
	
	    if (prepare.webgl) {
	        /**
	         * The number of graphics or textures to upload to the GPU.
	         *
	         * @name PIXI.prepare.webgl.UPLOADS_PER_FRAME
	         * @static
	         * @type {number}
	         * @see PIXI.prepare.BasePrepare.limiter
	         * @deprecated since 4.2.0
	         */
	        Object.defineProperty(prepare.webgl, 'UPLOADS_PER_FRAME', {
	            set: function set() {
	                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
	                // because we don't have a reference to the renderer, we can't actually set
	                // the uploads per frame, so we'll have to stick with the warning.
	            },
	            get: function get() {
	                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');
	
	                return NaN;
	            }
	        });
	    }
	
	    if (loaders.Loader) {
	        var Resource = loaders.Resource;
	        var Loader = loaders.Loader;
	
	        Object.defineProperties(Resource.prototype, {
	            isJson: {
	                get: function get() {
	                    warn('The isJson property is deprecated, please use `resource.type === Resource.TYPE.JSON`.');
	
	                    return this.type === Resource.TYPE.JSON;
	                }
	            },
	            isXml: {
	                get: function get() {
	                    warn('The isXml property is deprecated, please use `resource.type === Resource.TYPE.XML`.');
	
	                    return this.type === Resource.TYPE.XML;
	                }
	            },
	            isImage: {
	                get: function get() {
	                    warn('The isImage property is deprecated, please use `resource.type === Resource.TYPE.IMAGE`.');
	
	                    return this.type === Resource.TYPE.IMAGE;
	                }
	            },
	            isAudio: {
	                get: function get() {
	                    warn('The isAudio property is deprecated, please use `resource.type === Resource.TYPE.AUDIO`.');
	
	                    return this.type === Resource.TYPE.AUDIO;
	                }
	            },
	            isVideo: {
	                get: function get() {
	                    warn('The isVideo property is deprecated, please use `resource.type === Resource.TYPE.VIDEO`.');
	
	                    return this.type === Resource.TYPE.VIDEO;
	                }
	            }
	        });
	
	        Object.defineProperties(Loader.prototype, {
	            before: {
	                get: function get() {
	                    warn('The before() method is deprecated, please use pre().');
	
	                    return this.pre;
	                }
	            },
	            after: {
	                get: function get() {
	                    warn('The after() method is deprecated, please use use().');
	
	                    return this.use;
	                }
	            }
	        });
	    }
	
	    if (interaction.interactiveTarget) {
	        /**
	         * @name PIXI.interaction.interactiveTarget#defaultCursor
	         * @static
	         * @type {number}
	         * @see PIXI.interaction.interactiveTarget#cursor
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.interactiveTarget, 'defaultCursor', {
	            set: function set(value) {
	                warn('Property defaultCursor has been replaced with \'cursor\'. ');
	                this.cursor = value;
	            },
	            get: function get() {
	                warn('Property defaultCursor has been replaced with \'cursor\'. ');
	
	                return this.cursor;
	            }
	        });
	    }
	
	    if (interaction.InteractionManager) {
	        /**
	         * @name PIXI.interaction.InteractionManager#defaultCursorStyle
	         * @static
	         * @type {string}
	         * @see PIXI.interaction.InteractionManager#cursorStyles
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.InteractionManager, 'defaultCursorStyle', {
	            set: function set(value) {
	                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
	                this.cursorStyles.default = value;
	            },
	            get: function get() {
	                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
	
	                return this.cursorStyles.default;
	            }
	        });
	
	        /**
	         * @name PIXI.interaction.InteractionManager#currentCursorStyle
	         * @static
	         * @type {string}
	         * @see PIXI.interaction.InteractionManager#cursorStyles
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.InteractionManager, 'currentCursorStyle', {
	            set: function set(value) {
	                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
	                this.currentCursorMode = value;
	            },
	            get: function get() {
	                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
	
	                return this.currentCursorMode;
	            }
	        });
	    }
	}
	//# sourceMappingURL=deprecation.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TEMP_RECT = new core.Rectangle();
	
	/**
	 * The extract manager provides functionality to export content from the renderers.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
	 *
	 * @class
	 * @memberof PIXI.extract
	 */
	
	var CanvasExtract = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasExtract(renderer) {
	        _classCallCheck(this, CanvasExtract);
	
	        this.renderer = renderer;
	        /**
	         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
	         *
	         * @member {PIXI.extract.CanvasExtract} extract
	         * @memberof PIXI.CanvasRenderer#
	         * @see PIXI.extract.CanvasExtract
	         */
	        renderer.extract = this;
	    }
	
	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLImageElement} HTML Image of the target
	     */
	
	
	    CanvasExtract.prototype.image = function image(target) {
	        var image = new Image();
	
	        image.src = this.base64(target);
	
	        return image;
	    };
	
	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `CanvasExtract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {string} A base64 encoded string of the texture.
	     */
	
	
	    CanvasExtract.prototype.base64 = function base64(target) {
	        return this.canvas(target).toDataURL();
	    };
	
	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */
	
	
	    CanvasExtract.prototype.canvas = function canvas(target) {
	        var renderer = this.renderer;
	        var context = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }
	
	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        } else {
	            context = renderer.rootContext;
	
	            frame = TEMP_RECT;
	            frame.width = this.renderer.width;
	            frame.height = this.renderer.height;
	        }
	
	        var width = frame.width * resolution;
	        var height = frame.height * resolution;
	
	        var canvasBuffer = new core.CanvasRenderTarget(width, height);
	        var canvasData = context.getImageData(frame.x * resolution, frame.y * resolution, width, height);
	
	        canvasBuffer.context.putImageData(canvasData, 0, 0);
	
	        // send the canvas back..
	        return canvasBuffer.canvas;
	    };
	
	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
	     */
	
	
	    CanvasExtract.prototype.pixels = function pixels(target) {
	        var renderer = this.renderer;
	        var context = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }
	
	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        } else {
	            context = renderer.rootContext;
	
	            frame = TEMP_RECT;
	            frame.width = renderer.width;
	            frame.height = renderer.height;
	        }
	
	        return context.getImageData(0, 0, frame.width * resolution, frame.height * resolution).data;
	    };
	
	    /**
	     * Destroys the extract
	     *
	     */
	
	
	    CanvasExtract.prototype.destroy = function destroy() {
	        this.renderer.extract = null;
	        this.renderer = null;
	    };
	
	    return CanvasExtract;
	}();
	
	exports.default = CanvasExtract;
	
	
	core.CanvasRenderer.registerPlugin('extract', CanvasExtract);
	//# sourceMappingURL=CanvasExtract.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLExtract = __webpack_require__(247);
	
	Object.defineProperty(exports, 'webgl', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLExtract).default;
	  }
	});
	
	var _CanvasExtract = __webpack_require__(245);
	
	Object.defineProperty(exports, 'canvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasExtract).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TEMP_RECT = new core.Rectangle();
	var BYTES_PER_PIXEL = 4;
	
	/**
	 * The extract manager provides functionality to export content from the renderers.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
	 *
	 * @class
	 * @memberof PIXI.extract
	 */
	
	var WebGLExtract = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function WebGLExtract(renderer) {
	        _classCallCheck(this, WebGLExtract);
	
	        this.renderer = renderer;
	        /**
	         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
	         *
	         * @member {PIXI.extract.WebGLExtract} extract
	         * @memberof PIXI.WebGLRenderer#
	         * @see PIXI.extract.WebGLExtract
	         */
	        renderer.extract = this;
	    }
	
	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLImageElement} HTML Image of the target
	     */
	
	
	    WebGLExtract.prototype.image = function image(target) {
	        var image = new Image();
	
	        image.src = this.base64(target);
	
	        return image;
	    };
	
	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `WebGLExtract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {string} A base64 encoded string of the texture.
	     */
	
	
	    WebGLExtract.prototype.base64 = function base64(target) {
	        return this.canvas(target).toDataURL();
	    };
	
	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */
	
	
	    WebGLExtract.prototype.canvas = function canvas(target) {
	        var renderer = this.renderer;
	        var textureBuffer = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var flipY = false;
	        var renderTexture = void 0;
	        var generated = false;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }
	
	        if (renderTexture) {
	            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
	            resolution = textureBuffer.resolution;
	            frame = renderTexture.frame;
	            flipY = false;
	        } else {
	            textureBuffer = this.renderer.rootRenderTarget;
	            resolution = textureBuffer.resolution;
	            flipY = true;
	
	            frame = TEMP_RECT;
	            frame.width = textureBuffer.size.width;
	            frame.height = textureBuffer.size.height;
	        }
	
	        var width = frame.width * resolution;
	        var height = frame.height * resolution;
	
	        var canvasBuffer = new core.CanvasRenderTarget(width, height);
	
	        if (textureBuffer) {
	            // bind the buffer
	            renderer.bindRenderTarget(textureBuffer);
	
	            // set up an array of pixels
	            var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
	
	            // read pixels to the array
	            var gl = renderer.gl;
	
	            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
	
	            // add the pixels to the canvas
	            var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);
	
	            canvasData.data.set(webglPixels);
	
	            canvasBuffer.context.putImageData(canvasData, 0, 0);
	
	            // pulling pixels
	            if (flipY) {
	                canvasBuffer.context.scale(1, -1);
	                canvasBuffer.context.drawImage(canvasBuffer.canvas, 0, -height);
	            }
	        }
	
	        if (generated) {
	            renderTexture.destroy(true);
	        }
	        // send the canvas back..
	
	        return canvasBuffer.canvas;
	    };
	
	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
	     */
	
	
	    WebGLExtract.prototype.pixels = function pixels(target) {
	        var renderer = this.renderer;
	        var textureBuffer = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;
	        var generated = false;
	
	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }
	
	        if (renderTexture) {
	            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
	            resolution = textureBuffer.resolution;
	            frame = renderTexture.frame;
	        } else {
	            textureBuffer = this.renderer.rootRenderTarget;
	            resolution = textureBuffer.resolution;
	
	            frame = TEMP_RECT;
	            frame.width = textureBuffer.size.width;
	            frame.height = textureBuffer.size.height;
	        }
	
	        var width = frame.width * resolution;
	        var height = frame.height * resolution;
	
	        var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
	
	        if (textureBuffer) {
	            // bind the buffer
	            renderer.bindRenderTarget(textureBuffer);
	            // read pixels to the array
	            var gl = renderer.gl;
	
	            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
	        }
	
	        if (generated) {
	            renderTexture.destroy(true);
	        }
	
	        return webglPixels;
	    };
	
	    /**
	     * Destroys the extract
	     *
	     */
	
	
	    WebGLExtract.prototype.destroy = function destroy() {
	        this.renderer.extract = null;
	        this.renderer = null;
	    };
	
	    return WebGLExtract;
	}();
	
	exports.default = WebGLExtract;
	
	
	core.WebGLRenderer.registerPlugin('extract', WebGLExtract);
	//# sourceMappingURL=WebGLExtract.js.map

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @typedef PIXI.extras.AnimatedSprite~FrameObject
	 * @type {object}
	 * @property {PIXI.Texture} texture - The {@link PIXI.Texture} of the frame
	 * @property {number} time - the duration of the frame in ms
	 */
	
	/**
	 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
	 *
	 * ```js
	 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
	 * let textureArray = [];
	 *
	 * for (let i=0; i < 4; i++)
	 * {
	 *      let texture = PIXI.Texture.fromImage(alienImages[i]);
	 *      textureArray.push(texture);
	 * };
	 *
	 * let mc = new PIXI.AnimatedSprite(textureArray);
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 */
	var AnimatedSprite = function (_core$Sprite) {
	    _inherits(AnimatedSprite, _core$Sprite);
	
	    /**
	     * @param {PIXI.Texture[]|PIXI.extras.AnimatedSprite~FrameObject[]} textures - an array of {@link PIXI.Texture} or frame
	     *  objects that make up the animation
	     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.ticker.shared to auto update animation time.
	     */
	    function AnimatedSprite(textures, autoUpdate) {
	        _classCallCheck(this, AnimatedSprite);
	
	        /**
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, textures[0] instanceof core.Texture ? textures[0] : textures[0].texture));
	
	        _this._textures = null;
	
	        /**
	         * @private
	         */
	        _this._durations = null;
	
	        _this.textures = textures;
	
	        /**
	         * `true` uses PIXI.ticker.shared to auto update animation time.
	         * @type {boolean}
	         * @default true
	         * @private
	         */
	        _this._autoUpdate = autoUpdate !== false;
	
	        /**
	         * The speed that the AnimatedSprite will play at. Higher is faster, lower is slower
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.animationSpeed = 1;
	
	        /**
	         * Whether or not the animate sprite repeats after playing.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.loop = true;
	
	        /**
	         * Function to call when a AnimatedSprite finishes playing
	         *
	         * @member {Function}
	         */
	        _this.onComplete = null;
	
	        /**
	         * Function to call when a AnimatedSprite changes which texture is being rendered
	         *
	         * @member {Function}
	         */
	        _this.onFrameChange = null;
	
	        /**
	        * Function to call when 'loop' is true, and an AnimatedSprite is played and loops around to start again
	        *
	        * @member {Function}
	        */
	        _this.onLoop = null;
	
	        /**
	         * Elapsed time since animation has been started, used internally to display current texture
	         *
	         * @member {number}
	         * @private
	         */
	        _this._currentTime = 0;
	
	        /**
	         * Indicates if the AnimatedSprite is currently playing
	         *
	         * @member {boolean}
	         * @readonly
	         */
	        _this.playing = false;
	        return _this;
	    }
	
	    /**
	     * Stops the AnimatedSprite
	     *
	     */
	
	
	    AnimatedSprite.prototype.stop = function stop() {
	        if (!this.playing) {
	            return;
	        }
	
	        this.playing = false;
	        if (this._autoUpdate) {
	            core.ticker.shared.remove(this.update, this);
	        }
	    };
	
	    /**
	     * Plays the AnimatedSprite
	     *
	     */
	
	
	    AnimatedSprite.prototype.play = function play() {
	        if (this.playing) {
	            return;
	        }
	
	        this.playing = true;
	        if (this._autoUpdate) {
	            core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.HIGH);
	        }
	    };
	
	    /**
	     * Stops the AnimatedSprite and goes to a specific frame
	     *
	     * @param {number} frameNumber - frame index to stop at
	     */
	
	
	    AnimatedSprite.prototype.gotoAndStop = function gotoAndStop(frameNumber) {
	        this.stop();
	
	        var previousFrame = this.currentFrame;
	
	        this._currentTime = frameNumber;
	
	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }
	    };
	
	    /**
	     * Goes to a specific frame and begins playing the AnimatedSprite
	     *
	     * @param {number} frameNumber - frame index to start at
	     */
	
	
	    AnimatedSprite.prototype.gotoAndPlay = function gotoAndPlay(frameNumber) {
	        var previousFrame = this.currentFrame;
	
	        this._currentTime = frameNumber;
	
	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }
	
	        this.play();
	    };
	
	    /**
	     * Updates the object transform for rendering.
	     *
	     * @private
	     * @param {number} deltaTime - Time since last tick.
	     */
	
	
	    AnimatedSprite.prototype.update = function update(deltaTime) {
	        var elapsed = this.animationSpeed * deltaTime;
	        var previousFrame = this.currentFrame;
	
	        if (this._durations !== null) {
	            var lag = this._currentTime % 1 * this._durations[this.currentFrame];
	
	            lag += elapsed / 60 * 1000;
	
	            while (lag < 0) {
	                this._currentTime--;
	                lag += this._durations[this.currentFrame];
	            }
	
	            var sign = Math.sign(this.animationSpeed * deltaTime);
	
	            this._currentTime = Math.floor(this._currentTime);
	
	            while (lag >= this._durations[this.currentFrame]) {
	                lag -= this._durations[this.currentFrame] * sign;
	                this._currentTime += sign;
	            }
	
	            this._currentTime += lag / this._durations[this.currentFrame];
	        } else {
	            this._currentTime += elapsed;
	        }
	
	        if (this._currentTime < 0 && !this.loop) {
	            this.gotoAndStop(0);
	
	            if (this.onComplete) {
	                this.onComplete();
	            }
	        } else if (this._currentTime >= this._textures.length && !this.loop) {
	            this.gotoAndStop(this._textures.length - 1);
	
	            if (this.onComplete) {
	                this.onComplete();
	            }
	        } else if (previousFrame !== this.currentFrame) {
	            if (this.loop && this.onLoop) {
	                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
	                    this.onLoop();
	                } else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
	                    this.onLoop();
	                }
	            }
	
	            this.updateTexture();
	        }
	    };
	
	    /**
	     * Updates the displayed texture to match the current frame index
	     *
	     * @private
	     */
	
	
	    AnimatedSprite.prototype.updateTexture = function updateTexture() {
	        this._texture = this._textures[this.currentFrame];
	        this._textureID = -1;
	        this.cachedTint = 0xFFFFFF;
	
	        if (this.onFrameChange) {
	            this.onFrameChange(this.currentFrame);
	        }
	    };
	
	    /**
	     * Stops the AnimatedSprite and destroys it
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    AnimatedSprite.prototype.destroy = function destroy(options) {
	        this.stop();
	        _core$Sprite.prototype.destroy.call(this, options);
	    };
	
	    /**
	     * A short hand way of creating a movieclip from an array of frame ids
	     *
	     * @static
	     * @param {string[]} frames - The array of frames ids the movieclip will use as its texture frames
	     * @return {AnimatedSprite} The new animated sprite with the specified frames.
	     */
	
	
	    AnimatedSprite.fromFrames = function fromFrames(frames) {
	        var textures = [];
	
	        for (var i = 0; i < frames.length; ++i) {
	            textures.push(core.Texture.fromFrame(frames[i]));
	        }
	
	        return new AnimatedSprite(textures);
	    };
	
	    /**
	     * A short hand way of creating a movieclip from an array of image ids
	     *
	     * @static
	     * @param {string[]} images - the array of image urls the movieclip will use as its texture frames
	     * @return {AnimatedSprite} The new animate sprite with the specified images as frames.
	     */
	
	
	    AnimatedSprite.fromImages = function fromImages(images) {
	        var textures = [];
	
	        for (var i = 0; i < images.length; ++i) {
	            textures.push(core.Texture.fromImage(images[i]));
	        }
	
	        return new AnimatedSprite(textures);
	    };
	
	    /**
	     * totalFrames is the total number of frames in the AnimatedSprite. This is the same as number of textures
	     * assigned to the AnimatedSprite.
	     *
	     * @readonly
	     * @member {number}
	     * @default 0
	     */
	
	
	    _createClass(AnimatedSprite, [{
	        key: 'totalFrames',
	        get: function get() {
	            return this._textures.length;
	        }
	
	        /**
	         * The array of textures used for this AnimatedSprite
	         *
	         * @member {PIXI.Texture[]}
	         */
	
	    }, {
	        key: 'textures',
	        get: function get() {
	            return this._textures;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (value[0] instanceof core.Texture) {
	                this._textures = value;
	                this._durations = null;
	            } else {
	                this._textures = [];
	                this._durations = [];
	
	                for (var i = 0; i < value.length; i++) {
	                    this._textures.push(value[i].texture);
	                    this._durations.push(value[i].time);
	                }
	            }
	            this.gotoAndStop(0);
	            this.updateTexture();
	        }
	
	        /**
	        * The AnimatedSprites current frame index
	        *
	        * @member {number}
	        * @readonly
	        */
	
	    }, {
	        key: 'currentFrame',
	        get: function get() {
	            var currentFrame = Math.floor(this._currentTime) % this._textures.length;
	
	            if (currentFrame < 0) {
	                currentFrame += this._textures.length;
	            }
	
	            return currentFrame;
	        }
	    }]);
	
	    return AnimatedSprite;
	}(core.Sprite);
	
	exports.default = AnimatedSprite;
	//# sourceMappingURL=AnimatedSprite.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _ObservablePoint = __webpack_require__(108);
	
	var _ObservablePoint2 = _interopRequireDefault(_ObservablePoint);
	
	var _utils = __webpack_require__(5);
	
	var _settings = __webpack_require__(6);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A BitmapText object will create a line or multiple lines of text using bitmap font. To
	 * split a line you can use '\n', '\r' or '\r\n' in your string. You can generate the fnt files using:
	 *
	 * A BitmapText can only be created when the font is loaded
	 *
	 * ```js
	 * // in this case the font is in a file called 'desyrel.fnt'
	 * let bitmapText = new PIXI.extras.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
	 * ```
	 *
	 * http://www.angelcode.com/products/bmfont/ for windows or
	 * http://www.bmglyph.com/ for mac.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.extras
	 */
	var BitmapText = function (_core$Container) {
	    _inherits(BitmapText, _core$Container);
	
	    /**
	     * @param {string} text - The copy that you would like the text to display
	     * @param {object} style - The style parameters
	     * @param {string|object} style.font - The font descriptor for the object, can be passed as a string of form
	     *      "24px FontName" or "FontName" or as an object with explicit name/size properties.
	     * @param {string} [style.font.name] - The bitmap font id
	     * @param {number} [style.font.size] - The size of the font in pixels, e.g. 24
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'), does not affect
	     *      single line text
	     * @param {number} [style.tint=0xFFFFFF] - The tint color
	     */
	    function BitmapText(text) {
	        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, BitmapText);
	
	        /**
	         * Private tracker for the width of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));
	
	        _this._textWidth = 0;
	
	        /**
	         * Private tracker for the height of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        _this._textHeight = 0;
	
	        /**
	         * Private tracker for the letter sprite pool.
	         *
	         * @member {PIXI.Sprite[]}
	         * @private
	         */
	        _this._glyphs = [];
	
	        /**
	         * Private tracker for the current style.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._font = {
	            tint: style.tint !== undefined ? style.tint : 0xFFFFFF,
	            align: style.align || 'left',
	            name: null,
	            size: 0
	        };
	
	        /**
	         * Private tracker for the current font.
	         *
	         * @member {object}
	         * @private
	         */
	        _this.font = style.font; // run font setter
	
	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = text;
	
	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting value to 0
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxWidth = 0;
	
	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * ie: when trying to vertically align.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxLineHeight = 0;
	
	        /**
	         * Letter spacing. This is useful for setting the space between characters.
	         * @member {number}
	         * @private
	         */
	        _this._letterSpacing = 0;
	
	        /**
	         * Text anchor. read-only
	         *
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        _this._anchor = new _ObservablePoint2.default(function () {
	            _this.dirty = true;
	        }, _this, 0, 0);
	
	        /**
	         * The dirty state of this object.
	         *
	         * @member {boolean}
	         */
	        _this.dirty = false;
	
	        _this.updateText();
	        return _this;
	    }
	
	    /**
	     * Renders text and updates it when needed
	     *
	     * @private
	     */
	
	
	    BitmapText.prototype.updateText = function updateText() {
	        var data = BitmapText.fonts[this._font.name];
	        var scale = this._font.size / data.size;
	        var pos = new core.Point();
	        var chars = [];
	        var lineWidths = [];
	        var text = this.text.replace(/(?:\r\n|\r)/g, '\n');
	        var textLength = text.length;
	        var maxWidth = this._maxWidth * data.size / this._font.size;
	
	        var prevCharCode = null;
	        var lastLineWidth = 0;
	        var maxLineWidth = 0;
	        var line = 0;
	        var lastBreakPos = -1;
	        var lastBreakWidth = 0;
	        var spacesRemoved = 0;
	        var maxLineHeight = 0;
	
	        for (var i = 0; i < textLength; i++) {
	            var charCode = text.charCodeAt(i);
	            var char = text.charAt(i);
	
	            if (/(?:\s)/.test(char)) {
	                lastBreakPos = i;
	                lastBreakWidth = lastLineWidth;
	            }
	
	            if (char === '\r' || char === '\n') {
	                lineWidths.push(lastLineWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	                ++line;
	                ++spacesRemoved;
	
	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	                continue;
	            }
	
	            var charData = data.chars[charCode];
	
	            if (!charData) {
	                continue;
	            }
	
	            if (prevCharCode && charData.kerning[prevCharCode]) {
	                pos.x += charData.kerning[prevCharCode];
	            }
	
	            chars.push({
	                texture: charData.texture,
	                line: line,
	                charCode: charCode,
	                position: new core.Point(pos.x + charData.xOffset + this._letterSpacing / 2, pos.y + charData.yOffset)
	            });
	            pos.x += charData.xAdvance + this._letterSpacing;
	            lastLineWidth = pos.x;
	            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
	            prevCharCode = charCode;
	
	            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
	                ++spacesRemoved;
	                core.utils.removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
	                i = lastBreakPos;
	                lastBreakPos = -1;
	
	                lineWidths.push(lastBreakWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
	                line++;
	
	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	            }
	        }
	
	        var lastChar = text.charAt(text.length - 1);
	
	        if (lastChar !== '\r' && lastChar !== '\n') {
	            if (/(?:\s)/.test(lastChar)) {
	                lastLineWidth = lastBreakWidth;
	            }
	
	            lineWidths.push(lastLineWidth);
	            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	        }
	
	        var lineAlignOffsets = [];
	
	        for (var _i = 0; _i <= line; _i++) {
	            var alignOffset = 0;
	
	            if (this._font.align === 'right') {
	                alignOffset = maxLineWidth - lineWidths[_i];
	            } else if (this._font.align === 'center') {
	                alignOffset = (maxLineWidth - lineWidths[_i]) / 2;
	            }
	
	            lineAlignOffsets.push(alignOffset);
	        }
	
	        var lenChars = chars.length;
	        var tint = this.tint;
	
	        for (var _i2 = 0; _i2 < lenChars; _i2++) {
	            var c = this._glyphs[_i2]; // get the next glyph sprite
	
	            if (c) {
	                c.texture = chars[_i2].texture;
	            } else {
	                c = new core.Sprite(chars[_i2].texture);
	                this._glyphs.push(c);
	            }
	
	            c.position.x = (chars[_i2].position.x + lineAlignOffsets[chars[_i2].line]) * scale;
	            c.position.y = chars[_i2].position.y * scale;
	            c.scale.x = c.scale.y = scale;
	            c.tint = tint;
	
	            if (!c.parent) {
	                this.addChild(c);
	            }
	        }
	
	        // remove unnecessary children.
	        for (var _i3 = lenChars; _i3 < this._glyphs.length; ++_i3) {
	            this.removeChild(this._glyphs[_i3]);
	        }
	
	        this._textWidth = maxLineWidth * scale;
	        this._textHeight = (pos.y + data.lineHeight) * scale;
	
	        // apply anchor
	        if (this.anchor.x !== 0 || this.anchor.y !== 0) {
	            for (var _i4 = 0; _i4 < lenChars; _i4++) {
	                this._glyphs[_i4].x -= this._textWidth * this.anchor.x;
	                this._glyphs[_i4].y -= this._textHeight * this.anchor.y;
	            }
	        }
	        this._maxLineHeight = maxLineHeight * scale;
	    };
	
	    /**
	     * Updates the transform of this object
	     *
	     * @private
	     */
	
	
	    BitmapText.prototype.updateTransform = function updateTransform() {
	        this.validate();
	        this.containerUpdateTransform();
	    };
	
	    /**
	     * Validates text before calling parent's getLocalBounds
	     *
	     * @return {PIXI.Rectangle} The rectangular bounding area
	     */
	
	
	    BitmapText.prototype.getLocalBounds = function getLocalBounds() {
	        this.validate();
	
	        return _core$Container.prototype.getLocalBounds.call(this);
	    };
	
	    /**
	     * Updates text when needed
	     *
	     * @private
	     */
	
	
	    BitmapText.prototype.validate = function validate() {
	        if (this.dirty) {
	            this.updateText();
	            this.dirty = false;
	        }
	    };
	
	    /**
	     * The tint of the BitmapText object
	     *
	     * @member {number}
	     */
	
	
	    /**
	     * Register a bitmap font with data and a texture.
	     *
	     * @static
	     * @param {XMLDocument} xml - The XML document data.
	     * @param {PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
	     * @return {Object} Result font object with font, size, lineHeight and char fields.
	     */
	    BitmapText.registerFont = function registerFont(xml, textures) {
	        var data = {};
	        var info = xml.getElementsByTagName('info')[0];
	        var common = xml.getElementsByTagName('common')[0];
	        var fileName = xml.getElementsByTagName('page')[0].getAttribute('file');
	        var res = (0, _utils.getResolutionOfUrl)(fileName, _settings2.default.RESOLUTION);
	
	        data.font = info.getAttribute('face');
	        data.size = parseInt(info.getAttribute('size'), 10);
	        data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10) / res;
	        data.chars = {};
	        if (!(textures instanceof Array)) {
	            textures = [textures];
	        }
	
	        // parse letters
	        var letters = xml.getElementsByTagName('char');
	        var page = void 0;
	
	        for (var i = 0; i < letters.length; i++) {
	            var letter = letters[i];
	            var charCode = parseInt(letter.getAttribute('id'), 10);
	            var textureRect = void 0;
	
	            page = parseInt(letter.getAttribute('page'), 10);
	            if (isNaN(page)) {
	                textureRect = new core.Rectangle(0, 0, 0, 0);
	                page = 0;
	            } else {
	                textureRect = new core.Rectangle(parseInt(letter.getAttribute('x'), 10) / res + textures[page].frame.x / res, parseInt(letter.getAttribute('y'), 10) / res + textures[page].frame.y / res, parseInt(letter.getAttribute('width'), 10) / res, parseInt(letter.getAttribute('height'), 10) / res);
	            }
	
	            data.chars[charCode] = {
	                xOffset: parseInt(letter.getAttribute('xoffset'), 10) / res,
	                yOffset: parseInt(letter.getAttribute('yoffset'), 10) / res,
	                xAdvance: parseInt(letter.getAttribute('xadvance'), 10) / res,
	                kerning: {},
	                texture: new core.Texture(textures[page].baseTexture, textureRect),
	                page: page
	            };
	        }
	
	        // parse kernings
	        var kernings = xml.getElementsByTagName('kerning');
	
	        for (var _i5 = 0; _i5 < kernings.length; _i5++) {
	            var kerning = kernings[_i5];
	            var first = parseInt(kerning.getAttribute('first'), 10) / res;
	            var second = parseInt(kerning.getAttribute('second'), 10) / res;
	            var amount = parseInt(kerning.getAttribute('amount'), 10) / res;
	
	            if (data.chars[second]) {
	                data.chars[second].kerning[first] = amount;
	            }
	        }
	
	        // I'm leaving this as a temporary fix so we can test the bitmap fonts in v3
	        // but it's very likely to change
	        BitmapText.fonts[data.font] = data;
	
	        return data;
	    };
	
	    _createClass(BitmapText, [{
	        key: 'tint',
	        get: function get() {
	            return this._font.tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._font.tint = typeof value === 'number' && value >= 0 ? value : 0xFFFFFF;
	
	            this.dirty = true;
	        }
	
	        /**
	         * The alignment of the BitmapText object
	         *
	         * @member {string}
	         * @default 'left'
	         */
	
	    }, {
	        key: 'align',
	        get: function get() {
	            return this._font.align;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._font.align = value || 'left';
	
	            this.dirty = true;
	        }
	
	        /**
	         * The anchor sets the origin point of the text.
	         * The default is 0,0 this means the text's origin is the top left
	         * Setting the anchor to 0.5,0.5 means the text's origin is centered
	         * Setting the anchor to 1,1 would mean the text's origin point will be the bottom right corner
	         *
	         * @member {PIXI.Point | number}
	         */
	
	    }, {
	        key: 'anchor',
	        get: function get() {
	            return this._anchor;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (typeof value === 'number') {
	                this._anchor.set(value);
	            } else {
	                this._anchor.copy(value);
	            }
	        }
	
	        /**
	         * The font descriptor of the BitmapText object
	         *
	         * @member {string|object}
	         */
	
	    }, {
	        key: 'font',
	        get: function get() {
	            return this._font;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (!value) {
	                return;
	            }
	
	            if (typeof value === 'string') {
	                value = value.split(' ');
	
	                this._font.name = value.length === 1 ? value[0] : value.slice(1).join(' ');
	                this._font.size = value.length >= 2 ? parseInt(value[0], 10) : BitmapText.fonts[this._font.name].size;
	            } else {
	                this._font.name = value.name;
	                this._font.size = typeof value.size === 'number' ? value.size : parseInt(value.size, 10);
	            }
	
	            this.dirty = true;
	        }
	
	        /**
	         * The text of the BitmapText object
	         *
	         * @member {string}
	         */
	
	    }, {
	        key: 'text',
	        get: function get() {
	            return this._text;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            value = value.toString() || ' ';
	            if (this._text === value) {
	                return;
	            }
	            this._text = value;
	            this.dirty = true;
	        }
	
	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting value to 0
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'maxWidth',
	        get: function get() {
	            return this._maxWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._maxWidth === value) {
	                return;
	            }
	            this._maxWidth = value;
	            this.dirty = true;
	        }
	
	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * ie: when trying to vertically align.
	         *
	         * @member {number}
	         * @readonly
	         */
	
	    }, {
	        key: 'maxLineHeight',
	        get: function get() {
	            this.validate();
	
	            return this._maxLineHeight;
	        }
	
	        /**
	         * The width of the overall text, different from fontSize,
	         * which is defined in the style object
	         *
	         * @member {number}
	         * @readonly
	         */
	
	    }, {
	        key: 'textWidth',
	        get: function get() {
	            this.validate();
	
	            return this._textWidth;
	        }
	
	        /**
	         * Additional space between characters.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'letterSpacing',
	        get: function get() {
	            return this._letterSpacing;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._letterSpacing !== value) {
	                this._letterSpacing = value;
	                this.dirty = true;
	            }
	        }
	
	        /**
	         * The height of the overall text, different from fontSize,
	         * which is defined in the style object
	         *
	         * @member {number}
	         * @readonly
	         */
	
	    }, {
	        key: 'textHeight',
	        get: function get() {
	            this.validate();
	
	            return this._textHeight;
	        }
	    }]);
	
	    return BitmapText;
	}(core.Container);
	
	exports.default = BitmapText;
	
	
	BitmapText.fonts = {};
	//# sourceMappingURL=BitmapText.js.map

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _CanvasTinter = __webpack_require__(64);
	
	var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempPoint = new core.Point();
	
	/**
	 * A tiling sprite is a fast way of rendering a tiling image
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 */
	
	var TilingSprite = function (_core$Sprite) {
	    _inherits(TilingSprite, _core$Sprite);
	
	    /**
	     * @param {PIXI.Texture} texture - the texture of the tiling sprite
	     * @param {number} [width=100] - the width of the tiling sprite
	     * @param {number} [height=100] - the height of the tiling sprite
	     */
	    function TilingSprite(texture) {
	        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
	
	        _classCallCheck(this, TilingSprite);
	
	        /**
	         * Tile transform
	         *
	         * @member {PIXI.TransformStatic}
	         */
	        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, texture));
	
	        _this.tileTransform = new core.TransformStatic();
	
	        // /// private
	
	        /**
	         * The with of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._width = width;
	
	        /**
	         * The height of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._height = height;
	
	        /**
	         * Canvas pattern
	         *
	         * @type {CanvasPattern}
	         * @private
	         */
	        _this._canvasPattern = null;
	
	        /**
	         * transform that is applied to UV to get the texture coords
	         *
	         * @member {PIXI.TextureMatrix}
	         */
	        _this.uvTransform = texture.transform || new core.TextureMatrix(texture);
	
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' method.
	         *
	         * @member {string}
	         * @default 'tilingSprite'
	         */
	        _this.pluginName = 'tilingSprite';
	
	        /**
	         * Whether or not anchor affects uvs
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.uvRespectAnchor = false;
	        return _this;
	    }
	    /**
	     * Changes frame clamping in corresponding textureTransform, shortcut
	     * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	     *
	     * @default 0.5
	     * @member {number}
	     */
	
	
	    /**
	     * @private
	     */
	    TilingSprite.prototype._onTextureUpdate = function _onTextureUpdate() {
	        if (this.uvTransform) {
	            this.uvTransform.texture = this._texture;
	        }
	        this.cachedTint = 0xFFFFFF;
	    };
	
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	
	
	    TilingSprite.prototype._renderWebGL = function _renderWebGL(renderer) {
	        // tweak our texture temporarily..
	        var texture = this._texture;
	
	        if (!texture || !texture.valid) {
	            return;
	        }
	
	        this.tileTransform.updateLocalTransform();
	        this.uvTransform.update();
	
	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
	     */
	
	
	    TilingSprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	        var texture = this._texture;
	
	        if (!texture.baseTexture.hasLoaded) {
	            return;
	        }
	
	        var context = renderer.context;
	        var transform = this.worldTransform;
	        var resolution = renderer.resolution;
	        var baseTexture = texture.baseTexture;
	        var baseTextureResolution = baseTexture.resolution;
	        var modX = this.tilePosition.x / this.tileScale.x % texture._frame.width * baseTextureResolution;
	        var modY = this.tilePosition.y / this.tileScale.y % texture._frame.height * baseTextureResolution;
	
	        // create a nice shiny pattern!
	        if (this._textureID !== this._texture._updateID || this.cachedTint !== this.tint) {
	            this._textureID = this._texture._updateID;
	            // cut an object from a spritesheet..
	            var tempCanvas = new core.CanvasRenderTarget(texture._frame.width, texture._frame.height, baseTextureResolution);
	
	            // Tint the tiling sprite
	            if (this.tint !== 0xFFFFFF) {
	                this.tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
	                tempCanvas.context.drawImage(this.tintedTexture, 0, 0);
	            } else {
	                tempCanvas.context.drawImage(baseTexture.source, -texture._frame.x * baseTextureResolution, -texture._frame.y * baseTextureResolution);
	            }
	            this.cachedTint = this.tint;
	            this._canvasPattern = tempCanvas.context.createPattern(tempCanvas.canvas, 'repeat');
	        }
	
	        // set context state..
	        context.globalAlpha = this.worldAlpha;
	        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
	
	        renderer.setBlendMode(this.blendMode);
	
	        // fill the pattern!
	        context.fillStyle = this._canvasPattern;
	
	        // TODO - this should be rolled into the setTransform above..
	        context.scale(this.tileScale.x / baseTextureResolution, this.tileScale.y / baseTextureResolution);
	
	        var anchorX = this.anchor.x * -this._width;
	        var anchorY = this.anchor.y * -this._height;
	
	        if (this.uvRespectAnchor) {
	            context.translate(modX, modY);
	
	            context.fillRect(-modX + anchorX, -modY + anchorY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	        } else {
	            context.translate(modX + anchorX, modY + anchorY);
	
	            context.fillRect(-modX, -modY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	        }
	    };
	
	    /**
	     * Updates the bounds of the tiling sprite.
	     *
	     * @private
	     */
	
	
	    TilingSprite.prototype._calculateBounds = function _calculateBounds() {
	        var minX = this._width * -this._anchor._x;
	        var minY = this._height * -this._anchor._y;
	        var maxX = this._width * (1 - this._anchor._x);
	        var maxY = this._height * (1 - this._anchor._y);
	
	        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
	    };
	
	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */
	
	
	    TilingSprite.prototype.getLocalBounds = function getLocalBounds(rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._width * -this._anchor._x;
	            this._bounds.minY = this._height * -this._anchor._y;
	            this._bounds.maxX = this._width * (1 - this._anchor._x);
	            this._bounds.maxY = this._height * (1 - this._anchor._y);
	
	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new core.Rectangle();
	                }
	
	                rect = this._localBoundsRect;
	            }
	
	            return this._bounds.getRectangle(rect);
	        }
	
	        return _core$Sprite.prototype.getLocalBounds.call(this, rect);
	    };
	
	    /**
	     * Checks if a point is inside this tiling sprite.
	     *
	     * @param {PIXI.Point} point - the point to check
	     * @return {boolean} Whether or not the sprite contains the point.
	     */
	
	
	    TilingSprite.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);
	
	        var width = this._width;
	        var height = this._height;
	        var x1 = -width * this.anchor._x;
	
	        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
	            var y1 = -height * this.anchor._y;
	
	            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	
	
	    TilingSprite.prototype.destroy = function destroy(options) {
	        _core$Sprite.prototype.destroy.call(this, options);
	
	        this.tileTransform = null;
	        this.uvTransform = null;
	    };
	
	    /**
	     * Helper function that creates a new tiling sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @return {PIXI.Texture} The newly created texture
	     */
	
	
	    TilingSprite.from = function from(source, width, height) {
	        return new TilingSprite(core.Texture.from(source), width, height);
	    };
	
	    /**
	     * Helper function that creates a tiling sprite that will use a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the frameId
	     */
	
	
	    TilingSprite.fromFrame = function fromFrame(frameId, width, height) {
	        var texture = core.utils.TextureCache[frameId];
	
	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache ' + this);
	        }
	
	        return new TilingSprite(texture, width, height);
	    };
	
	    /**
	     * Helper function that creates a sprite that will contain a texture based on an image url
	     * If the image is not in the texture cache it will be loaded
	     *
	     * @static
	     * @param {string} imageId - The image url of the texture
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @param {boolean} [crossorigin] - if you want to specify the cross-origin parameter
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
	     *  see {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the image id
	     */
	
	
	    TilingSprite.fromImage = function fromImage(imageId, width, height, crossorigin, scaleMode) {
	        return new TilingSprite(core.Texture.fromImage(imageId, crossorigin, scaleMode), width, height);
	    };
	
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */
	
	
	    _createClass(TilingSprite, [{
	        key: 'clampMargin',
	        get: function get() {
	            return this.uvTransform.clampMargin;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uvTransform.clampMargin = value;
	            this.uvTransform.update(true);
	        }
	
	        /**
	         * The scaling of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'tileScale',
	        get: function get() {
	            return this.tileTransform.scale;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tileTransform.scale.copy(value);
	        }
	
	        /**
	         * The offset of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	
	    }, {
	        key: 'tilePosition',
	        get: function get() {
	            return this.tileTransform.position;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tileTransform.position.copy(value);
	        }
	    }, {
	        key: 'width',
	        get: function get() {
	            return this._width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._width = value;
	        }
	
	        /**
	         * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this._height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._height = value;
	        }
	    }]);
	
	    return TilingSprite;
	}(core.Sprite);
	
	exports.default = TilingSprite;
	//# sourceMappingURL=TilingSprite.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _Texture = __webpack_require__(17);
	
	var _Texture2 = _interopRequireDefault(_Texture);
	
	var _BaseTexture = __webpack_require__(24);
	
	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
	
	var _utils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DisplayObject = core.DisplayObject;
	var _tempMatrix = new core.Matrix();
	
	DisplayObject.prototype._cacheAsBitmap = false;
	DisplayObject.prototype._cacheData = false;
	
	// figured theres no point adding ALL the extra variables to prototype.
	// this model can hold the information needed. This can also be generated on demand as
	// most objects are not cached as bitmaps.
	/**
	 * @class
	 * @ignore
	 */
	
	var CacheData =
	/**
	 *
	 */
	function CacheData() {
	    _classCallCheck(this, CacheData);
	
	    this.textureCacheId = null;
	
	    this.originalRenderWebGL = null;
	    this.originalRenderCanvas = null;
	    this.originalCalculateBounds = null;
	    this.originalGetLocalBounds = null;
	
	    this.originalUpdateTransform = null;
	    this.originalHitTest = null;
	    this.originalDestroy = null;
	    this.originalMask = null;
	    this.originalFilterArea = null;
	    this.sprite = null;
	};
	
	Object.defineProperties(DisplayObject.prototype, {
	    /**
	     * Set this to true if you want this display object to be cached as a bitmap.
	     * This basically takes a snap shot of the display object as it is at that moment. It can
	     * provide a performance benefit for complex static displayObjects.
	     * To remove simply set this property to 'false'
	     *
	     * IMPORTANT GOTCHA - make sure that all your textures are preloaded BEFORE setting this property to true
	     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    cacheAsBitmap: {
	        get: function get() {
	            return this._cacheAsBitmap;
	        },
	        set: function set(value) {
	            if (this._cacheAsBitmap === value) {
	                return;
	            }
	
	            this._cacheAsBitmap = value;
	
	            var data = void 0;
	
	            if (value) {
	                if (!this._cacheData) {
	                    this._cacheData = new CacheData();
	                }
	
	                data = this._cacheData;
	
	                data.originalRenderWebGL = this.renderWebGL;
	                data.originalRenderCanvas = this.renderCanvas;
	
	                data.originalUpdateTransform = this.updateTransform;
	                data.originalCalculateBounds = this._calculateBounds;
	                data.originalGetLocalBounds = this.getLocalBounds;
	
	                data.originalDestroy = this.destroy;
	
	                data.originalContainsPoint = this.containsPoint;
	
	                data.originalMask = this._mask;
	                data.originalFilterArea = this.filterArea;
	
	                this.renderWebGL = this._renderCachedWebGL;
	                this.renderCanvas = this._renderCachedCanvas;
	
	                this.destroy = this._cacheAsBitmapDestroy;
	            } else {
	                data = this._cacheData;
	
	                if (data.sprite) {
	                    this._destroyCachedDisplayObject();
	                }
	
	                this.renderWebGL = data.originalRenderWebGL;
	                this.renderCanvas = data.originalRenderCanvas;
	                this._calculateBounds = data.originalCalculateBounds;
	                this.getLocalBounds = data.originalGetLocalBounds;
	
	                this.destroy = data.originalDestroy;
	
	                this.updateTransform = data.originalUpdateTransform;
	                this.containsPoint = data.originalContainsPoint;
	
	                this._mask = data.originalMask;
	                this.filterArea = data.originalFilterArea;
	            }
	        }
	    }
	});
	
	/**
	 * Renders a cached version of the sprite with WebGL
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._renderCachedWebGL = function _renderCachedWebGL(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }
	
	    this._initCachedDisplayObject(renderer);
	
	    this._cacheData.sprite._transformID = -1;
	    this._cacheData.sprite.worldAlpha = this.worldAlpha;
	    this._cacheData.sprite._renderWebGL(renderer);
	};
	
	/**
	 * Prepares the WebGL renderer to cache the sprite
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }
	
	    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
	    var cacheAlpha = this.alpha;
	
	    this.alpha = 1;
	
	    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
	    renderer.currentRenderer.flush();
	    // this.filters= [];
	
	    // next we find the dimensions of the untransformed object
	    // this function also calls updatetransform on all its children as part of the measuring.
	    // This means we don't need to update the transform again in this function
	    // TODO pass an object to clone too? saves having to create a new one each time!
	    var bounds = this.getLocalBounds().clone();
	
	    // add some padding!
	    if (this._filters) {
	        var padding = this._filters[0].padding;
	
	        bounds.pad(padding);
	    }
	
	    // for now we cache the current renderTarget that the webGL renderer is currently using.
	    // this could be more elegent..
	    var cachedRenderTarget = renderer._activeRenderTarget;
	    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
	    var stack = renderer.filterManager.filterStack;
	
	    // this renderTexture will be used to store the cached DisplayObject
	
	    var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);
	
	    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();
	
	    this._cacheData.textureCacheId = textureCacheId;
	
	    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
	    _Texture2.default.addToCache(renderTexture, textureCacheId);
	
	    // need to set //
	    var m = _tempMatrix;
	
	    m.tx = -bounds.x;
	    m.ty = -bounds.y;
	
	    // reset
	    this.transform.worldTransform.identity();
	
	    // set all properties to there original so we can render to a texture
	    this.renderWebGL = this._cacheData.originalRenderWebGL;
	
	    renderer.render(this, renderTexture, true, m, true);
	    // now restore the state be setting the new properties
	
	    renderer.bindRenderTarget(cachedRenderTarget);
	
	    renderer.filterManager.filterStack = stack;
	
	    this.renderWebGL = this._renderCachedWebGL;
	    this.updateTransform = this.displayObjectUpdateTransform;
	
	    this._mask = null;
	    this.filterArea = null;
	
	    // create our cached sprite
	    var cachedSprite = new core.Sprite(renderTexture);
	
	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite.alpha = cacheAlpha;
	    cachedSprite._bounds = this._bounds;
	
	    // easy bounds..
	    this._calculateBounds = this._calculateCachedBounds;
	    this.getLocalBounds = this._getCachedLocalBounds;
	
	    this._cacheData.sprite = cachedSprite;
	
	    this.transform._parentID = -1;
	    // restore the transform of the cached sprite to avoid the nasty flicker..
	    if (!this.parent) {
	        this.parent = renderer._tempDisplayObjectParent;
	        this.updateTransform();
	        this.parent = null;
	    } else {
	        this.updateTransform();
	    }
	
	    // map the hit test..
	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};
	
	/**
	 * Renders a cached version of the sprite with canvas
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }
	
	    this._initCachedDisplayObjectCanvas(renderer);
	
	    this._cacheData.sprite.worldAlpha = this.worldAlpha;
	
	    this._cacheData.sprite.renderCanvas(renderer);
	};
	
	// TODO this can be the same as the webGL verison.. will need to do a little tweaking first though..
	/**
	 * Prepares the Canvas renderer to cache the sprite
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }
	
	    // get bounds actually transforms the object for us already!
	    var bounds = this.getLocalBounds();
	
	    var cacheAlpha = this.alpha;
	
	    this.alpha = 1;
	
	    var cachedRenderTarget = renderer.context;
	
	    var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);
	
	    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();
	
	    this._cacheData.textureCacheId = textureCacheId;
	
	    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
	    _Texture2.default.addToCache(renderTexture, textureCacheId);
	
	    // need to set //
	    var m = _tempMatrix;
	
	    this.transform.localTransform.copy(m);
	    m.invert();
	
	    m.tx -= bounds.x;
	    m.ty -= bounds.y;
	
	    // m.append(this.transform.worldTransform.)
	    // set all properties to there original so we can render to a texture
	    this.renderCanvas = this._cacheData.originalRenderCanvas;
	
	    // renderTexture.render(this, m, true);
	    renderer.render(this, renderTexture, true, m, false);
	
	    // now restore the state be setting the new properties
	    renderer.context = cachedRenderTarget;
	
	    this.renderCanvas = this._renderCachedCanvas;
	    this._calculateBounds = this._calculateCachedBounds;
	
	    this._mask = null;
	    this.filterArea = null;
	
	    // create our cached sprite
	    var cachedSprite = new core.Sprite(renderTexture);
	
	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite._bounds = this._bounds;
	    cachedSprite.alpha = cacheAlpha;
	
	    if (!this.parent) {
	        this.parent = renderer._tempDisplayObjectParent;
	        this.updateTransform();
	        this.parent = null;
	    } else {
	        this.updateTransform();
	    }
	
	    this.updateTransform = this.displayObjectUpdateTransform;
	
	    this._cacheData.sprite = cachedSprite;
	
	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};
	
	/**
	 * Calculates the bounds of the cached sprite
	 *
	 * @private
	 */
	DisplayObject.prototype._calculateCachedBounds = function _calculateCachedBounds() {
	    this._cacheData.sprite._calculateBounds();
	};
	
	/**
	 * Gets the bounds of the cached sprite.
	 *
	 * @private
	 * @return {Rectangle} The local bounds.
	 */
	DisplayObject.prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
	    return this._cacheData.sprite.getLocalBounds();
	};
	
	/**
	 * Destroys the cached sprite.
	 *
	 * @private
	 */
	DisplayObject.prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
	    this._cacheData.sprite._texture.destroy(true);
	    this._cacheData.sprite = null;
	
	    _BaseTexture2.default.removeFromCache(this._cacheData.textureCacheId);
	    _Texture2.default.removeFromCache(this._cacheData.textureCacheId);
	
	    this._cacheData.textureCacheId = null;
	};
	
	/**
	 * Destroys the cached object.
	 *
	 * @private
	 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	 *  have been set to that value.
	 *  Used when destroying containers, see the Container.destroy method.
	 */
	DisplayObject.prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
	    this.cacheAsBitmap = false;
	    this.destroy(options);
	};
	//# sourceMappingURL=cacheAsBitmap.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * The instance name of the object.
	 *
	 * @memberof PIXI.DisplayObject#
	 * @member {string} name
	 */
	core.DisplayObject.prototype.name = null;
	
	/**
	 * Returns the display object in the container
	 *
	 * @method getChildByName
	 * @memberof PIXI.Container#
	 * @param {string} name - instance name
	 * @return {PIXI.DisplayObject} The child with the specified name.
	 */
	core.Container.prototype.getChildByName = function getChildByName(name) {
	    for (var i = 0; i < this.children.length; i++) {
	        if (this.children[i].name === name) {
	            return this.children[i];
	        }
	    }
	
	    return null;
	};
	//# sourceMappingURL=getChildByName.js.map

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
	 *
	 * @method getGlobalPosition
	 * @memberof PIXI.DisplayObject#
	 * @param {Point} point - the point to write the global value to. If null a new point will be returned
	 * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
	 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	 *  nice performance boost
	 * @return {Point} The updated point
	 */
	core.DisplayObject.prototype.getGlobalPosition = function getGlobalPosition() {
	    var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new core.Point();
	    var skipUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (this.parent) {
	        this.parent.toGlobal(this.position, point, skipUpdate);
	    } else {
	        point.x = this.position.x;
	        point.y = this.position.y;
	    }
	
	    return point;
	};
	//# sourceMappingURL=getGlobalPosition.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _const = __webpack_require__(3);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tempMat = new core.Matrix();
	
	/**
	 * WebGL renderer plugin for tiling sprites
	 *
	 * @class
	 * @memberof PIXI.extras
	 * @extends PIXI.ObjectRenderer
	 */
	
	var TilingSpriteRenderer = function (_core$ObjectRenderer) {
	    _inherits(TilingSpriteRenderer, _core$ObjectRenderer);
	
	    /**
	     * constructor for renderer
	     *
	     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
	     */
	    function TilingSpriteRenderer(renderer) {
	        _classCallCheck(this, TilingSpriteRenderer);
	
	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
	
	        _this.shader = null;
	        _this.simpleShader = null;
	        _this.quad = null;
	        return _this;
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    TilingSpriteRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = mod(vTextureCoord - uClampOffset, vec2(1.0, 1.0)) + uClampOffset;\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 sample = texture2D(uSampler, coord);\n    gl_FragColor = sample * uColor;\n}\n');
	        this.simpleShader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 sample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = sample * uColor;\n}\n');
	
	        this.renderer.bindVao(null);
	        this.quad = new core.Quad(gl, this.renderer.state.attribState);
	        this.quad.initVao(this.shader);
	    };
	
	    /**
	     *
	     * @param {PIXI.extras.TilingSprite} ts tilingSprite to be rendered
	     */
	
	
	    TilingSpriteRenderer.prototype.render = function render(ts) {
	        var renderer = this.renderer;
	        var quad = this.quad;
	
	        renderer.bindVao(quad.vao);
	
	        var vertices = quad.vertices;
	
	        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
	        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;
	
	        vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
	        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);
	
	        if (ts.uvRespectAnchor) {
	            vertices = quad.uvs;
	
	            vertices[0] = vertices[6] = -ts.anchor.x;
	            vertices[1] = vertices[3] = -ts.anchor.y;
	
	            vertices[2] = vertices[4] = 1.0 - ts.anchor.x;
	            vertices[5] = vertices[7] = 1.0 - ts.anchor.y;
	        }
	
	        quad.upload();
	
	        var tex = ts._texture;
	        var baseTex = tex.baseTexture;
	        var lt = ts.tileTransform.localTransform;
	        var uv = ts.uvTransform;
	        var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
	
	        // auto, force repeat wrapMode for big tiling textures
	        if (isSimple) {
	            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
	                if (baseTex.wrapMode === _const.WRAP_MODES.CLAMP) {
	                    baseTex.wrapMode = _const.WRAP_MODES.REPEAT;
	                }
	            } else {
	                isSimple = baseTex.wrapMode !== _const.WRAP_MODES.CLAMP;
	            }
	        }
	
	        var shader = isSimple ? this.simpleShader : this.shader;
	
	        renderer.bindShader(shader);
	
	        var w = tex.width;
	        var h = tex.height;
	        var W = ts._width;
	        var H = ts._height;
	
	        tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);
	
	        // that part is the same as above:
	        // tempMat.identity();
	        // tempMat.scale(tex.width, tex.height);
	        // tempMat.prepend(lt);
	        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);
	
	        tempMat.invert();
	        if (isSimple) {
	            tempMat.prepend(uv.mapCoord);
	        } else {
	            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
	            shader.uniforms.uClampFrame = uv.uClampFrame;
	            shader.uniforms.uClampOffset = uv.uClampOffset;
	        }
	
	        shader.uniforms.uTransform = tempMat.toArray(true);
	        shader.uniforms.uColor = core.utils.premultiplyTintToRgba(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.premultipliedAlpha);
	        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);
	
	        shader.uniforms.uSampler = renderer.bindTexture(tex);
	
	        renderer.setBlendMode(core.utils.correctBlendMode(ts.blendMode, baseTex.premultipliedAlpha));
	
	        quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
	    };
	
	    return TilingSpriteRenderer;
	}(core.ObjectRenderer);
	
	exports.default = TilingSpriteRenderer;
	
	
	core.WebGLRenderer.registerPlugin('tilingSprite', TilingSpriteRenderer);
	//# sourceMappingURL=TilingSpriteRenderer.js.map

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Simplest filter - applies alpha
	 *
	 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
	 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
	 * If elements are not opaque, they will blend with each other anyway.
	 *
	 * Very handy if you want to use common features of all filters:
	 *
	 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
	 *
	 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var AlphaFilter = function (_core$Filter) {
	    _inherits(AlphaFilter, _core$Filter);
	
	    /**
	     * @param {number} [alpha=1] Amount of alpha from 0 to 1, where 0 is transparent
	     */
	    function AlphaFilter() {
	        var alpha = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;
	
	        _classCallCheck(this, AlphaFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n'));
	
	        _this.alpha = alpha;
	        _this.glShaderKey = 'alpha';
	        return _this;
	    }
	
	    /**
	     * Coefficient for alpha multiplication
	     *
	     * @member {number}
	     * @default 1
	     */
	
	
	    _createClass(AlphaFilter, [{
	        key: 'alpha',
	        get: function get() {
	            return this.uniforms.uAlpha;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uAlpha = value;
	        }
	    }]);
	
	    return AlphaFilter;
	}(core.Filter);
	
	exports.default = AlphaFilter;
	//# sourceMappingURL=AlphaFilter.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _BlurXFilter = __webpack_require__(123);
	
	var _BlurXFilter2 = _interopRequireDefault(_BlurXFilter);
	
	var _BlurYFilter = __webpack_require__(124);
	
	var _BlurYFilter2 = _interopRequireDefault(_BlurYFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The BlurFilter applies a Gaussian blur to an object.
	 * The strength of the blur can be set for x- and y-axis separately.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurFilter = function (_core$Filter) {
	    _inherits(BlurFilter, _core$Filter);
	
	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this));
	
	        _this.blurXFilter = new _BlurXFilter2.default(strength, quality, resolution, kernelSize);
	        _this.blurYFilter = new _BlurYFilter2.default(strength, quality, resolution, kernelSize);
	
	        _this.padding = 0;
	        _this.resolution = resolution || core.settings.RESOLUTION;
	        _this.quality = quality || 4;
	        _this.blur = strength || 8;
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     */
	
	
	    BlurFilter.prototype.apply = function apply(filterManager, input, output) {
	        var renderTarget = filterManager.getRenderTarget(true);
	
	        this.blurXFilter.apply(filterManager, input, renderTarget, true);
	        this.blurYFilter.apply(filterManager, renderTarget, output, false);
	
	        filterManager.returnRenderTarget(renderTarget);
	    };
	
	    /**
	     * Sets the strength of both the blurX and blurY properties simultaneously
	     *
	     * @member {number}
	     * @default 2
	     */
	
	
	    _createClass(BlurFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.blurXFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.blur = this.blurYFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }
	
	        /**
	         * Sets the number of passes for blur. More passes means higher quaility bluring.
	         *
	         * @member {number}
	         * @default 1
	         */
	
	    }, {
	        key: 'quality',
	        get: function get() {
	            return this.blurXFilter.quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.quality = this.blurYFilter.quality = value;
	        }
	
	        /**
	         * Sets the strength of the blurX property
	         *
	         * @member {number}
	         * @default 2
	         */
	
	    }, {
	        key: 'blurX',
	        get: function get() {
	            return this.blurXFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }
	
	        /**
	         * Sets the strength of the blurY property
	         *
	         * @member {number}
	         * @default 2
	         */
	
	    }, {
	        key: 'blurY',
	        get: function get() {
	            return this.blurYFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurYFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }
	
	        /**
	         * Sets the blendmode of the filter
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         */
	
	    }, {
	        key: 'blendMode',
	        get: function get() {
	            return this.blurYFilter._blendMode;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurYFilter._blendMode = value;
	        }
	    }]);
	
	    return BlurFilter;
	}(core.Filter);
	
	exports.default = BlurFilter;
	//# sourceMappingURL=BlurFilter.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
	 * color and alpha values of every pixel on your displayObject to produce a result
	 * with a new set of RGBA color and alpha values. It's pretty powerful!
	 *
	 * ```js
	 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
	 *  container.filters = [colorMatrix];
	 *  colorMatrix.contrast(2);
	 * ```
	 * @author Clément Chenebault <clement@goodboydigital.com>
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var ColorMatrixFilter = function (_core$Filter) {
	    _inherits(ColorMatrixFilter, _core$Filter);
	
	    /**
	     *
	     */
	    function ColorMatrixFilter() {
	        _classCallCheck(this, ColorMatrixFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n'));
	
	        _this.uniforms.m = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
	
	        _this.alpha = 1;
	        return _this;
	    }
	
	    /**
	     * Transforms current matrix and set the new one
	     *
	     * @param {number[]} matrix - 5x4 matrix
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype._loadMatrix = function _loadMatrix(matrix) {
	        var multiply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var newMatrix = matrix;
	
	        if (multiply) {
	            this._multiply(newMatrix, this.uniforms.m, matrix);
	            newMatrix = this._colorMatrix(newMatrix);
	        }
	
	        // set the new matrix
	        this.uniforms.m = newMatrix;
	    };
	
	    /**
	     * Multiplies two mat5's
	     *
	     * @private
	     * @param {number[]} out - 5x4 matrix the receiving matrix
	     * @param {number[]} a - 5x4 matrix the first operand
	     * @param {number[]} b - 5x4 matrix the second operand
	     * @returns {number[]} 5x4 matrix
	     */
	
	
	    ColorMatrixFilter.prototype._multiply = function _multiply(out, a, b) {
	        // Red Channel
	        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
	        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
	        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
	        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
	        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
	
	        // Green Channel
	        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
	        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
	        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
	        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
	        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
	
	        // Blue Channel
	        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
	        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
	        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
	        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
	        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
	
	        // Alpha Channel
	        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
	        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
	        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
	        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
	        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
	
	        return out;
	    };
	
	    /**
	     * Create a Float32 Array and normalize the offset component to 0-1
	     *
	     * @private
	     * @param {number[]} matrix - 5x4 matrix
	     * @return {number[]} 5x4 matrix with all values between 0-1
	     */
	
	
	    ColorMatrixFilter.prototype._colorMatrix = function _colorMatrix(matrix) {
	        // Create a Float32 Array and normalize the offset component to 0-1
	        var m = new Float32Array(matrix);
	
	        m[4] /= 255;
	        m[9] /= 255;
	        m[14] /= 255;
	        m[19] /= 255;
	
	        return m;
	    };
	
	    /**
	     * Adjusts brightness
	     *
	     * @param {number} b - value of the brigthness (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.brightness = function brightness(b, multiply) {
	        var matrix = [b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the matrices in grey scales
	     *
	     * @param {number} scale - value of the grey (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.greyscale = function greyscale(scale, multiply) {
	        var matrix = [scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the black and white matrice.
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.blackAndWhite = function blackAndWhite(multiply) {
	        var matrix = [0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the hue property of the color
	     *
	     * @param {number} rotation - in degrees
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.hue = function hue(rotation, multiply) {
	        rotation = (rotation || 0) / 180 * Math.PI;
	
	        var cosR = Math.cos(rotation);
	        var sinR = Math.sin(rotation);
	        var sqrt = Math.sqrt;
	
	        /* a good approximation for hue rotation
	         This matrix is far better than the versions with magic luminance constants
	         formerly used here, but also used in the starling framework (flash) and known from this
	         old part of the internet: quasimondo.com/archives/000565.php
	          This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
	         implementation as a shader not a general matrix:
	         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js
	          This is the source for the code:
	         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
	         */
	
	        var w = 1 / 3;
	        var sqrW = sqrt(w); // weight is
	
	        var a00 = cosR + (1.0 - cosR) * w;
	        var a01 = w * (1.0 - cosR) - sqrW * sinR;
	        var a02 = w * (1.0 - cosR) + sqrW * sinR;
	
	        var a10 = w * (1.0 - cosR) + sqrW * sinR;
	        var a11 = cosR + w * (1.0 - cosR);
	        var a12 = w * (1.0 - cosR) - sqrW * sinR;
	
	        var a20 = w * (1.0 - cosR) - sqrW * sinR;
	        var a21 = w * (1.0 - cosR) + sqrW * sinR;
	        var a22 = cosR + w * (1.0 - cosR);
	
	        var matrix = [a00, a01, a02, 0, 0, a10, a11, a12, 0, 0, a20, a21, a22, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the contrast matrix, increase the separation between dark and bright
	     * Increase contrast : shadows darker and highlights brighter
	     * Decrease contrast : bring the shadows up and the highlights down
	     *
	     * @param {number} amount - value of the contrast (0-1)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.contrast = function contrast(amount, multiply) {
	        var v = (amount || 0) + 1;
	        var o = -0.5 * (v - 1);
	
	        var matrix = [v, 0, 0, 0, o, 0, v, 0, 0, o, 0, 0, v, 0, o, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Set the saturation matrix, increase the separation between colors
	     * Increase saturation : increase contrast, brightness, and sharpness
	     *
	     * @param {number} amount - The saturation amount (0-1)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.saturate = function saturate() {
	        var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var multiply = arguments[1];
	
	        var x = amount * 2 / 3 + 1;
	        var y = (x - 1) * -0.5;
	
	        var matrix = [x, y, y, 0, 0, y, x, y, 0, 0, y, y, x, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Desaturate image (remove color)
	     *
	     * Call the saturate function
	     *
	     */
	
	
	    ColorMatrixFilter.prototype.desaturate = function desaturate() // eslint-disable-line no-unused-vars
	    {
	        this.saturate(-1);
	    };
	
	    /**
	     * Negative image (inverse of classic rgb matrix)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.negative = function negative(multiply) {
	        var matrix = [-1, 0, 0, 1, 0, 0, -1, 0, 1, 0, 0, 0, -1, 1, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Sepia image
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.sepia = function sepia(multiply) {
	        var matrix = [0.393, 0.7689999, 0.18899999, 0, 0, 0.349, 0.6859999, 0.16799999, 0, 0, 0.272, 0.5339999, 0.13099999, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.technicolor = function technicolor(multiply) {
	        var matrix = [1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337, -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398, -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Polaroid filter
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.polaroid = function polaroid(multiply) {
	        var matrix = [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Filter who transforms : Red -> Blue and Blue -> Red
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.toBGR = function toBGR(multiply) {
	        var matrix = [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.kodachrome = function kodachrome(multiply) {
	        var matrix = [1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502, -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203, -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Brown delicious browni filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.browni = function browni(multiply) {
	        var matrix = [0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873, -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127, 0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Vintage filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.vintage = function vintage(multiply) {
	        var matrix = [0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123, 0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591, 0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * We don't know exactly what it does, kind of gradient map, but funny to play with!
	     *
	     * @param {number} desaturation - Tone values.
	     * @param {number} toned - Tone values.
	     * @param {string} lightColor - Tone values, example: `0xFFE580`
	     * @param {string} darkColor - Tone values, example: `0xFFE580`
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.colorTone = function colorTone(desaturation, toned, lightColor, darkColor, multiply) {
	        desaturation = desaturation || 0.2;
	        toned = toned || 0.15;
	        lightColor = lightColor || 0xFFE580;
	        darkColor = darkColor || 0x338000;
	
	        var lR = (lightColor >> 16 & 0xFF) / 255;
	        var lG = (lightColor >> 8 & 0xFF) / 255;
	        var lB = (lightColor & 0xFF) / 255;
	
	        var dR = (darkColor >> 16 & 0xFF) / 255;
	        var dG = (darkColor >> 8 & 0xFF) / 255;
	        var dB = (darkColor & 0xFF) / 255;
	
	        var matrix = [0.3, 0.59, 0.11, 0, 0, lR, lG, lB, desaturation, 0, dR, dG, dB, toned, 0, lR - dR, lG - dG, lB - dB, 0, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Night effect
	     *
	     * @param {number} intensity - The intensity of the night effect.
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.night = function night(intensity, multiply) {
	        intensity = intensity || 0.1;
	        var matrix = [intensity * -2.0, -intensity, 0, 0, 0, -intensity, 0, intensity, 0, 0, 0, intensity, intensity * 2.0, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Predator effect
	     *
	     * Erase the current matrix by setting a new indepent one
	     *
	     * @param {number} amount - how much the predator feels his future victim
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.predator = function predator(amount, multiply) {
	        var matrix = [
	        // row 1
	        11.224130630493164 * amount, -4.794486999511719 * amount, -2.8746118545532227 * amount, 0 * amount, 0.40342438220977783 * amount,
	        // row 2
	        -3.6330697536468506 * amount, 9.193157196044922 * amount, -2.951810836791992 * amount, 0 * amount, -1.316135048866272 * amount,
	        // row 3
	        -3.2184197902679443 * amount, -4.2375030517578125 * amount, 7.476448059082031 * amount, 0 * amount, 0.8044459223747253 * amount,
	        // row 4
	        0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * LSD effect
	     *
	     * Multiply the current matrix
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	
	
	    ColorMatrixFilter.prototype.lsd = function lsd(multiply) {
	        var matrix = [2, -0.4, 0.5, 0, 0, -0.5, 2, -0.4, 0, 0, -0.4, -0.5, 3, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, multiply);
	    };
	
	    /**
	     * Erase the current matrix by setting the default one
	     *
	     */
	
	
	    ColorMatrixFilter.prototype.reset = function reset() {
	        var matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
	
	        this._loadMatrix(matrix, false);
	    };
	
	    /**
	     * The matrix of the color matrix filter
	     *
	     * @member {number[]}
	     * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
	     */
	
	
	    _createClass(ColorMatrixFilter, [{
	        key: 'matrix',
	        get: function get() {
	            return this.uniforms.m;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.m = value;
	        }
	
	        /**
	         * The opacity value to use when mixing the original and resultant colors.
	         *
	         * When the value is 0, the original color is used without modification.
	         * When the value is 1, the result color is used.
	         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
	         *
	         * @member {number}
	         * @default 1
	         */
	
	    }, {
	        key: 'alpha',
	        get: function get() {
	            return this.uniforms.uAlpha;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uAlpha = value;
	        }
	    }]);
	
	    return ColorMatrixFilter;
	}(core.Filter);
	
	// Americanized alias
	
	
	exports.default = ColorMatrixFilter;
	ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;
	//# sourceMappingURL=ColorMatrixFilter.js.map

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The DisplacementFilter class uses the pixel values from the specified texture
	 * (called the displacement map) to perform a displacement of an object. You can
	 * use this filter to apply all manor of crazy warping effects. Currently the r
	 * property of the texture is used to offset the x and the g property of the texture
	 * is used to offset the y.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var DisplacementFilter = function (_core$Filter) {
	    _inherits(DisplacementFilter, _core$Filter);
	
	    /**
	     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
	     * @param {number} scale - The scale of the displacement
	     */
	    function DisplacementFilter(sprite, scale) {
	        _classCallCheck(this, DisplacementFilter);
	
	        var maskMatrix = new core.Matrix();
	
	        sprite.renderable = false;
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n   vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\n\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform vec4 filterArea;\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy *= scale / filterArea.xy;\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), filterClamp.xy, filterClamp.zw));\n}\n'));
	
	        _this.maskSprite = sprite;
	        _this.maskMatrix = maskMatrix;
	
	        _this.uniforms.mapSampler = sprite._texture;
	        _this.uniforms.filterMatrix = maskMatrix;
	        _this.uniforms.scale = { x: 1, y: 1 };
	
	        if (scale === null || scale === undefined) {
	            scale = 20;
	        }
	
	        _this.scale = new core.Point(scale, scale);
	        return _this;
	    }
	
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     */
	
	
	    DisplacementFilter.prototype.apply = function apply(filterManager, input, output) {
	        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
	        this.uniforms.scale.x = this.scale.x;
	        this.uniforms.scale.y = this.scale.y;
	
	        // draw the filter...
	        filterManager.applyFilter(this, input, output);
	    };
	
	    /**
	     * The texture used for the displacement map. Must be power of 2 sized texture.
	     *
	     * @member {PIXI.Texture}
	     */
	
	
	    _createClass(DisplacementFilter, [{
	        key: 'map',
	        get: function get() {
	            return this.uniforms.mapSampler;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.mapSampler = value;
	        }
	    }]);
	
	    return DisplacementFilter;
	}(core.Filter);
	
	exports.default = DisplacementFilter;
	//# sourceMappingURL=DisplacementFilter.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 *
	 * Basic FXAA implementation based on the code on geeks3d.com with the
	 * modification that the texture2DLod stuff was removed since it's
	 * unsupported by WebGL.
	 *
	 * @see https://github.com/mitsuhiko/webgl-meincraft
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 *
	 */
	var FXAAFilter = function (_core$Filter) {
	    _inherits(FXAAFilter, _core$Filter);
	
	    /**
	     *
	     */
	    function FXAAFilter() {
	        _classCallCheck(this, FXAAFilter);
	
	        // TODO - needs work
	        return _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        '\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec4 filterArea;\n\nvarying vec2 vTextureCoord;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvoid texcoords(vec2 fragCoord, vec2 resolution,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    vec2 inverseVP = 1.0 / resolution.xy;\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n   vTextureCoord = aTextureCoord;\n\n   vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n   texcoords(fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}',
	        // fragment shader
	        'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform vec4 filterArea;\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n \n --\n \n From:\n https://github.com/mitsuhiko/webgl-meincraft\n \n Copyright (c) 2011 by Armin Ronacher.\n \n Some rights reserved.\n \n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n \n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n \n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n \n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n \n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n    \n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n    \n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n    \n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n    \n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n    \n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n      vec4 color;\n\n    color = fxaa(uSampler, fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n'));
	    }
	
	    return FXAAFilter;
	}(core.Filter);
	
	exports.default = FXAAFilter;
	//# sourceMappingURL=FXAAFilter.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FXAAFilter = __webpack_require__(259);
	
	Object.defineProperty(exports, 'FXAAFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FXAAFilter).default;
	  }
	});
	
	var _NoiseFilter = __webpack_require__(261);
	
	Object.defineProperty(exports, 'NoiseFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NoiseFilter).default;
	  }
	});
	
	var _DisplacementFilter = __webpack_require__(258);
	
	Object.defineProperty(exports, 'DisplacementFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplacementFilter).default;
	  }
	});
	
	var _BlurFilter = __webpack_require__(256);
	
	Object.defineProperty(exports, 'BlurFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurFilter).default;
	  }
	});
	
	var _BlurXFilter = __webpack_require__(123);
	
	Object.defineProperty(exports, 'BlurXFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurXFilter).default;
	  }
	});
	
	var _BlurYFilter = __webpack_require__(124);
	
	Object.defineProperty(exports, 'BlurYFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurYFilter).default;
	  }
	});
	
	var _ColorMatrixFilter = __webpack_require__(257);
	
	Object.defineProperty(exports, 'ColorMatrixFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorMatrixFilter).default;
	  }
	});
	
	var _AlphaFilter = __webpack_require__(255);
	
	Object.defineProperty(exports, 'AlphaFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlphaFilter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author Vico @vicocotea
	 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
	 */
	
	/**
	 * A Noise effect filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var NoiseFilter = function (_core$Filter) {
	    _inherits(NoiseFilter, _core$Filter);
	
	    /**
	     * @param {number} noise - The noise intensity, should be a normalized value in the range [0, 1].
	     * @param {number} seed - A random seed for the noise generation. Default is `Math.random()`.
	     */
	    function NoiseFilter() {
	        var noise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
	        var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.random();
	
	        _classCallCheck(this, NoiseFilter);
	
	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n'));
	
	        _this.noise = noise;
	        _this.seed = seed;
	        return _this;
	    }
	
	    /**
	     * The amount of noise to apply, this value should be in the range (0, 1].
	     *
	     * @member {number}
	     * @default 0.5
	     */
	
	
	    _createClass(NoiseFilter, [{
	        key: 'noise',
	        get: function get() {
	            return this.uniforms.uNoise;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uNoise = value;
	        }
	
	        /**
	         * A seed value to apply to the random noise generation. `Math.random()` is a good value to use.
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'seed',
	        get: function get() {
	            return this.uniforms.uSeed;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uSeed = value;
	        }
	    }]);
	
	    return NoiseFilter;
	}(core.Filter);
	
	exports.default = NoiseFilter;
	//# sourceMappingURL=NoiseFilter.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _InteractionData = __webpack_require__(128);
	
	var _InteractionData2 = _interopRequireDefault(_InteractionData);
	
	var _InteractionEvent = __webpack_require__(129);
	
	var _InteractionEvent2 = _interopRequireDefault(_InteractionEvent);
	
	var _InteractionTrackingData = __webpack_require__(130);
	
	var _InteractionTrackingData2 = _interopRequireDefault(_InteractionTrackingData);
	
	var _eventemitter = __webpack_require__(19);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _interactiveTarget = __webpack_require__(131);
	
	var _interactiveTarget2 = _interopRequireDefault(_interactiveTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Mix interactiveTarget into core.DisplayObject.prototype, after deprecation has been handled
	core.utils.mixins.delayMixin(core.DisplayObject.prototype, _interactiveTarget2.default);
	
	var MOUSE_POINTER_ID = 1;
	
	// helpers for hitTest() - only used inside hitTest()
	var hitTestEvent = {
	    target: null,
	    data: {
	        global: null
	    }
	};
	
	/**
	 * The interaction manager deals with mouse, touch and pointer events. Any DisplayObject can be interactive
	 * if its interactive parameter is set to true
	 * This manager also supports multitouch.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.interaction
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI.interaction
	 */
	
	var InteractionManager = function (_EventEmitter) {
	    _inherits(InteractionManager, _EventEmitter);
	
	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     * @param {object} [options] - The options for the manager.
	     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
	     * @param {number} [options.interactionFrequency=10] - Frequency increases the interaction events will be checked.
	     */
	    function InteractionManager(renderer, options) {
	        _classCallCheck(this, InteractionManager);
	
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	        options = options || {};
	
	        /**
	         * The renderer this interaction manager works for.
	         *
	         * @member {PIXI.SystemRenderer}
	         */
	        _this.renderer = renderer;
	
	        /**
	         * Should default browser actions automatically be prevented.
	         * Does not apply to pointer events for backwards compatibility
	         * preventDefault on pointer events stops mouse events from firing
	         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;
	
	        /**
	         * Frequency in milliseconds that the mousemove, moveover & mouseout interaction events will be checked.
	         *
	         * @member {number}
	         * @default 10
	         */
	        _this.interactionFrequency = options.interactionFrequency || 10;
	
	        /**
	         * The mouse data
	         *
	         * @member {PIXI.interaction.InteractionData}
	         */
	        _this.mouse = new _InteractionData2.default();
	        _this.mouse.identifier = MOUSE_POINTER_ID;
	
	        // setting the mouse to start off far off screen will mean that mouse over does
	        //  not get called before we even move the mouse.
	        _this.mouse.global.set(-999999);
	
	        /**
	         * Actively tracked InteractionData
	         *
	         * @private
	         * @member {Object.<number,PIXI.interation.InteractionData>}
	         */
	        _this.activeInteractionData = {};
	        _this.activeInteractionData[MOUSE_POINTER_ID] = _this.mouse;
	
	        /**
	         * Pool of unused InteractionData
	         *
	         * @private
	         * @member {PIXI.interation.InteractionData[]}
	         */
	        _this.interactionDataPool = [];
	
	        /**
	         * An event data object to handle all the event tracking/dispatching
	         *
	         * @member {object}
	         */
	        _this.eventData = new _InteractionEvent2.default();
	
	        /**
	         * The DOM element to bind to.
	         *
	         * @private
	         * @member {HTMLElement}
	         */
	        _this.interactionDOMElement = null;
	
	        /**
	         * This property determines if mousemove and touchmove events are fired only when the cursor
	         * is over the object.
	         * Setting to true will make things work more in line with how the DOM verison works.
	         * Setting to false can make things easier for things like dragging
	         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
	         * future versions of pixi.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.moveWhenInside = false;
	
	        /**
	         * Have events been attached to the dom element?
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.eventsAdded = false;
	
	        /**
	         * Is the mouse hovering over the renderer?
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.mouseOverRenderer = false;
	
	        /**
	         * Does the device support touch events
	         * https://www.w3.org/TR/touch-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsTouchEvents = 'ontouchstart' in window;
	
	        /**
	         * Does the device support pointer events
	         * https://www.w3.org/Submission/pointer-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsPointerEvents = !!window.PointerEvent;
	
	        // this will make it so that you don't have to call bind all the time
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerUp = _this.onPointerUp.bind(_this);
	        _this.processPointerUp = _this.processPointerUp.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerCancel = _this.onPointerCancel.bind(_this);
	        _this.processPointerCancel = _this.processPointerCancel.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerDown = _this.onPointerDown.bind(_this);
	        _this.processPointerDown = _this.processPointerDown.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerMove = _this.onPointerMove.bind(_this);
	        _this.processPointerMove = _this.processPointerMove.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOut = _this.onPointerOut.bind(_this);
	        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);
	
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOver = _this.onPointerOver.bind(_this);
	
	        /**
	         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
	         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
	         * and functions are called instead of changing the CSS.
	         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
	         * @member {Object.<string, (string|Function|Object.<string, string>)>}
	         */
	        _this.cursorStyles = {
	            default: 'inherit',
	            pointer: 'pointer'
	        };
	
	        /**
	         * The mode of the cursor that is being used.
	         * The value of this is a key from the cursorStyles dictionary.
	         *
	         * @member {string}
	         */
	        _this.currentCursorMode = null;
	
	        /**
	         * Internal cached let.
	         *
	         * @private
	         * @member {string}
	         */
	        _this.cursor = null;
	
	        /**
	         * Internal cached let.
	         *
	         * @private
	         * @member {PIXI.Point}
	         */
	        _this._tempPoint = new core.Point();
	
	        /**
	         * The current resolution / device pixel ratio.
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = 1;
	
	        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
	         * object.
	         *
	         * @event PIXI.interaction.InteractionManager#mousedown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object.
	         *
	         * @event PIXI.interaction.InteractionManager#mouseup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#click
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightclick
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown}.
	         *
	         * @event PIXI.interaction.InteractionManager#mouseupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.interaction.InteractionManager#event:rightdown}.
	         *
	         * @event PIXI.interaction.InteractionManager#rightupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mousemove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mouseover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mouseout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released over the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a pointer event
	         *
	         * @event PIXI.interaction.InteractionManager#pointercancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointertap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.interaction.InteractionManager#event:pointerdown}.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved while over the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointermove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved onto the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointerover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved off the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointerout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchstart
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed from the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchend
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a touch
	         *
	         * @event PIXI.interaction.InteractionManager#touchcancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#tap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.interaction.InteractionManager#event:touchstart}.
	         *
	         * @event PIXI.interaction.InteractionManager#touchendoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is moved along the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchmove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousedown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#click
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightclick
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousemove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a pointer event.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointercancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointertap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointermove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a pointer device is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchstart
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchend
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when the operating system cancels a touch.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchcancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#tap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchendoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	
	        /**
	         * Fired when a touch point is moved along the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchmove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	        return _this;
	    }
	
	    /**
	     * Hit tests a point against the display tree, returning the first interactive object that is hit.
	     *
	     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
	     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
	     * to the last rendered root of the associated renderer.
	     * @return {PIXI.DisplayObject} The hit display object, if any.
	     */
	
	
	    InteractionManager.prototype.hitTest = function hitTest(globalPoint, root) {
	        // clear the target for our hit test
	        hitTestEvent.target = null;
	        // assign the global point
	        hitTestEvent.data.global = globalPoint;
	        // ensure safety of the root
	        if (!root) {
	            root = this.renderer._lastObjectRendered;
	        }
	        // run the hit test
	        this.processInteractive(hitTestEvent, root, null, true);
	        // return our found object - it'll be null if we didn't hit anything
	
	        return hitTestEvent.target;
	    };
	
	    /**
	     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
	     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to deletegate
	     * another DOM element to receive those events.
	     *
	     * @param {HTMLCanvasElement} element - the DOM element which will receive mouse and touch events.
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
	     */
	
	
	    InteractionManager.prototype.setTargetElement = function setTargetElement(element) {
	        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        this.removeEvents();
	
	        this.interactionDOMElement = element;
	
	        this.resolution = resolution;
	
	        this.addEvents();
	    };
	
	    /**
	     * Registers all the DOM events
	     *
	     * @private
	     */
	
	
	    InteractionManager.prototype.addEvents = function addEvents() {
	        if (!this.interactionDOMElement) {
	            return;
	        }
	
	        core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.INTERACTION);
	
	        if (window.navigator.msPointerEnabled) {
	            this.interactionDOMElement.style['-ms-content-zooming'] = 'none';
	            this.interactionDOMElement.style['-ms-touch-action'] = 'none';
	        } else if (this.supportsPointerEvents) {
	            this.interactionDOMElement.style['touch-action'] = 'none';
	        }
	
	        /**
	         * These events are added first, so that if pointer events are normalised, they are fired
	         * in the same order as non-normalised events. ie. pointer event 1st, mouse / touch 2nd
	         */
	        if (this.supportsPointerEvents) {
	            window.document.addEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, true);
	            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
	            // we already handle those, so for the purposes of what we do in onPointerOut, we only
	            // care about the pointerleave event
	            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, true);
	            window.addEventListener('pointercancel', this.onPointerCancel, true);
	            window.addEventListener('pointerup', this.onPointerUp, true);
	        } else {
	            window.document.addEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, true);
	            window.addEventListener('mouseup', this.onPointerUp, true);
	        }
	
	        // always look directly for touch events so that we can provide original data
	        // In a future version we should change this to being just a fallback and rely solely on
	        // PointerEvents whenever available
	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, true);
	        }
	
	        this.eventsAdded = true;
	    };
	
	    /**
	     * Removes all the DOM events that were previously registered
	     *
	     * @private
	     */
	
	
	    InteractionManager.prototype.removeEvents = function removeEvents() {
	        if (!this.interactionDOMElement) {
	            return;
	        }
	
	        core.ticker.shared.remove(this.update, this);
	
	        if (window.navigator.msPointerEnabled) {
	            this.interactionDOMElement.style['-ms-content-zooming'] = '';
	            this.interactionDOMElement.style['-ms-touch-action'] = '';
	        } else if (this.supportsPointerEvents) {
	            this.interactionDOMElement.style['touch-action'] = '';
	        }
	
	        if (this.supportsPointerEvents) {
	            window.document.removeEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, true);
	            window.removeEventListener('pointercancel', this.onPointerCancel, true);
	            window.removeEventListener('pointerup', this.onPointerUp, true);
	        } else {
	            window.document.removeEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, true);
	            window.removeEventListener('mouseup', this.onPointerUp, true);
	        }
	
	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, true);
	        }
	
	        this.interactionDOMElement = null;
	
	        this.eventsAdded = false;
	    };
	
	    /**
	     * Updates the state of interactive objects.
	     * Invoked by a throttled ticker update from {@link PIXI.ticker.shared}.
	     *
	     * @param {number} deltaTime - time delta since last tick
	     */
	
	
	    InteractionManager.prototype.update = function update(deltaTime) {
	        this._deltaTime += deltaTime;
	
	        if (this._deltaTime < this.interactionFrequency) {
	            return;
	        }
	
	        this._deltaTime = 0;
	
	        if (!this.interactionDOMElement) {
	            return;
	        }
	
	        // if the user move the mouse this check has already been done using the mouse move!
	        if (this.didMove) {
	            this.didMove = false;
	
	            return;
	        }
	
	        this.cursor = null;
	
	        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
	        // but there was a scenario of a display object moving under a static mouse cursor.
	        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
	        for (var k in this.activeInteractionData) {
	            // eslint-disable-next-line no-prototype-builtins
	            if (this.activeInteractionData.hasOwnProperty(k)) {
	                var interactionData = this.activeInteractionData[k];
	
	                if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
	                    var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);
	
	                    this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, true);
	                }
	            }
	        }
	
	        this.setCursorMode(this.cursor);
	
	        // TODO
	    };
	
	    /**
	     * Sets the current cursor mode, handling any callbacks or CSS style changes.
	     *
	     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
	     */
	
	
	    InteractionManager.prototype.setCursorMode = function setCursorMode(mode) {
	        mode = mode || 'default';
	        // if the mode didn't actually change, bail early
	        if (this.currentCursorMode === mode) {
	            return;
	        }
	        this.currentCursorMode = mode;
	        var style = this.cursorStyles[mode];
	
	        // only do things if there is a cursor style for it
	        if (style) {
	            switch (typeof style === 'undefined' ? 'undefined' : _typeof(style)) {
	                case 'string':
	                    // string styles are handled as cursor CSS
	                    this.interactionDOMElement.style.cursor = style;
	                    break;
	                case 'function':
	                    // functions are just called, and passed the cursor mode
	                    style(mode);
	                    break;
	                case 'object':
	                    // if it is an object, assume that it is a dictionary of CSS styles,
	                    // apply it to the interactionDOMElement
	                    Object.assign(this.interactionDOMElement.style, style);
	                    break;
	            }
	        } else if (typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) {
	            // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
	            // for the mode, then assume that the dev wants it to be CSS for the cursor.
	            this.interactionDOMElement.style.cursor = mode;
	        }
	    };
	
	    /**
	     * Dispatches an event on the display object that was interacted with
	     *
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the display object in question
	     * @param {string} eventString - the name of the event (e.g, mousedown)
	     * @param {object} eventData - the event data object
	     * @private
	     */
	
	
	    InteractionManager.prototype.dispatchEvent = function dispatchEvent(displayObject, eventString, eventData) {
	        if (!eventData.stopped) {
	            eventData.currentTarget = displayObject;
	            eventData.type = eventString;
	
	            displayObject.emit(eventString, eventData);
	
	            if (displayObject[eventString]) {
	                displayObject[eventString](eventData);
	            }
	        }
	    };
	
	    /**
	     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
	     * resulting value is stored in the point. This takes into account the fact that the DOM
	     * element could be scaled and positioned anywhere on the screen.
	     *
	     * @param  {PIXI.Point} point - the point that the result will be stored in
	     * @param  {number} x - the x coord of the position to map
	     * @param  {number} y - the y coord of the position to map
	     */
	
	
	    InteractionManager.prototype.mapPositionToPoint = function mapPositionToPoint(point, x, y) {
	        var rect = void 0;
	
	        // IE 11 fix
	        if (!this.interactionDOMElement.parentElement) {
	            rect = { x: 0, y: 0, width: 0, height: 0 };
	        } else {
	            rect = this.interactionDOMElement.getBoundingClientRect();
	        }
	
	        var resolutionMultiplier = navigator.isCocoonJS ? this.resolution : 1.0 / this.resolution;
	
	        point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
	        point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
	    };
	
	    /**
	     * This function is provides a neat way of crawling through the scene graph and running a
	     * specified function on all interactive objects it finds. It will also take care of hit
	     * testing the interactive objects and passes the hit across in the function.
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - event containing the point that
	     *  is tested for collision
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the displayObject
	     *  that will be hit test (recursively crawls its children)
	     * @param {Function} [func] - the function that will be called on each interactive object. The
	     *  interactionEvent, displayObject and hit will be passed to the function
	     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
	     * @param {boolean} [interactive] - Whether the displayObject is interactive
	     * @return {boolean} returns true if the displayObject hit the point
	     */
	
	
	    InteractionManager.prototype.processInteractive = function processInteractive(interactionEvent, displayObject, func, hitTest, interactive) {
	        if (!displayObject || !displayObject.visible) {
	            return false;
	        }
	
	        var point = interactionEvent.data.global;
	
	        // Took a little while to rework this function correctly! But now it is done and nice and optimised. ^_^
	        //
	        // This function will now loop through all objects and then only hit test the objects it HAS
	        // to, not all of them. MUCH faster..
	        // An object will be hit test if the following is true:
	        //
	        // 1: It is interactive.
	        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
	        //
	        // As another little optimisation once an interactive object has been hit we can carry on
	        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
	        // A final optimisation is that an object is not hit test directly if a child has already been hit.
	
	        interactive = displayObject.interactive || interactive;
	
	        var hit = false;
	        var interactiveParent = interactive;
	
	        // Flag here can set to false if the event is outside the parents hitArea or mask
	        var hitTestChildren = true;
	
	        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
	        // There is also no longer a need to hitTest children.
	        if (displayObject.hitArea) {
	            if (hitTest) {
	                displayObject.worldTransform.applyInverse(point, this._tempPoint);
	                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
	                    hitTest = false;
	                    hitTestChildren = false;
	                } else {
	                    hit = true;
	                }
	            }
	            interactiveParent = false;
	        }
	        // If there is a mask, no need to test against anything else if the pointer is not within the mask
	        else if (displayObject._mask) {
	                if (hitTest) {
	                    if (!displayObject._mask.containsPoint(point)) {
	                        hitTest = false;
	                        hitTestChildren = false;
	                    }
	                }
	            }
	
	        // ** FREE TIP **! If an object is not interactive or has no buttons in it
	        // (such as a game scene!) set interactiveChildren to false for that displayObject.
	        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
	        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
	            var children = displayObject.children;
	
	            for (var i = children.length - 1; i >= 0; i--) {
	                var child = children[i];
	
	                // time to get recursive.. if this function will return if something is hit..
	                var childHit = this.processInteractive(interactionEvent, child, func, hitTest, interactiveParent);
	
	                if (childHit) {
	                    // its a good idea to check if a child has lost its parent.
	                    // this means it has been removed whilst looping so its best
	                    if (!child.parent) {
	                        continue;
	                    }
	
	                    // we no longer need to hit test any more objects in this container as we we
	                    // now know the parent has been hit
	                    interactiveParent = false;
	
	                    // If the child is interactive , that means that the object hit was actually
	                    // interactive and not just the child of an interactive object.
	                    // This means we no longer need to hit test anything else. We still need to run
	                    // through all objects, but we don't need to perform any hit tests.
	
	                    if (childHit) {
	                        if (interactionEvent.target) {
	                            hitTest = false;
	                        }
	                        hit = true;
	                    }
	                }
	            }
	        }
	
	        // no point running this if the item is not interactive or does not have an interactive parent.
	        if (interactive) {
	            // if we are hit testing (as in we have no hit any objects yet)
	            // We also don't need to worry about hit testing if once of the displayObjects children
	            // has already been hit - but only if it was interactive, otherwise we need to keep
	            // looking for an interactive child, just in case we hit one
	            if (hitTest && !interactionEvent.target) {
	                // already tested against hitArea if it is defined
	                if (!displayObject.hitArea && displayObject.containsPoint) {
	                    if (displayObject.containsPoint(point)) {
	                        hit = true;
	                    }
	                }
	            }
	
	            if (displayObject.interactive) {
	                if (hit && !interactionEvent.target) {
	                    interactionEvent.target = displayObject;
	                }
	
	                if (func) {
	                    func(interactionEvent, displayObject, !!hit);
	                }
	            }
	        }
	
	        return hit;
	    };
	
	    /**
	     * Is called when the pointer button is pressed down on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
	     */
	
	
	    InteractionManager.prototype.onPointerDown = function onPointerDown(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
	
	        var events = this.normalizeToPointerData(originalEvent);
	
	        /**
	         * No need to prevent default on natural pointer events, as there are no side effects
	         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
	         * so still need to be prevented.
	         */
	
	        // Guaranteed that there will be at least one event in events, and all events must have the same pointer type
	
	        if (this.autoPreventDefault && events[0].isNormalized) {
	            originalEvent.preventDefault();
	        }
	
	        var eventLen = events.length;
	
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	
	            var interactionData = this.getInteractionDataForPointerId(event);
	
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	            interactionEvent.data.originalEvent = originalEvent;
	
	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerDown, true);
	
	            this.emit('pointerdown', interactionEvent);
	            if (event.pointerType === 'touch') {
	                this.emit('touchstart', interactionEvent);
	            }
	            // emit a mouse event for "pen" pointers, the way a browser would emit a fallback event
	            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                    var isRightButton = event.button === 2;
	
	                    this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
	                }
	        }
	    };
	
	    /**
	     * Processes the result of the pointer down check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerDown = function processPointerDown(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	        var id = interactionEvent.data.identifier;
	
	        if (hit) {
	            if (!displayObject.trackedPointers[id]) {
	                displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
	            }
	            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);
	
	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
	            } else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
	                var isRightButton = data.button === 2;
	
	                if (isRightButton) {
	                    displayObject.trackedPointers[id].rightDown = true;
	                } else {
	                    displayObject.trackedPointers[id].leftDown = true;
	                }
	
	                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
	     * @param {boolean} cancelled - true if the pointer is cancelled
	     * @param {Function} func - Function passed to {@link processInteractive}
	     */
	
	
	    InteractionManager.prototype.onPointerComplete = function onPointerComplete(originalEvent, cancelled, func) {
	        var events = this.normalizeToPointerData(originalEvent);
	
	        var eventLen = events.length;
	
	        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
	        // in all cases (unless it was a pointercancel)
	        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';
	
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	
	            var interactionData = this.getInteractionDataForPointerId(event);
	
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	            interactionEvent.data.originalEvent = originalEvent;
	
	            // perform hit testing for events targeting our canvas or cancel events
	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, func, cancelled || !eventAppend);
	
	            this.emit(cancelled ? 'pointercancel' : 'pointerup' + eventAppend, interactionEvent);
	
	            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                var isRightButton = event.button === 2;
	
	                this.emit(isRightButton ? 'rightup' + eventAppend : 'mouseup' + eventAppend, interactionEvent);
	            } else if (event.pointerType === 'touch') {
	                this.emit(cancelled ? 'touchcancel' : 'touchend' + eventAppend, interactionEvent);
	                this.releaseInteractionDataForPointerId(event.pointerId, interactionData);
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer button is cancelled
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */
	
	
	    InteractionManager.prototype.onPointerCancel = function onPointerCancel(event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
	
	        this.onPointerComplete(event, true, this.processPointerCancel);
	    };
	
	    /**
	     * Processes the result of the pointer cancel check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     */
	
	
	    InteractionManager.prototype.processPointerCancel = function processPointerCancel(interactionEvent, displayObject) {
	        var data = interactionEvent.data;
	
	        var id = interactionEvent.data.identifier;
	
	        if (displayObject.trackedPointers[id] !== undefined) {
	            delete displayObject.trackedPointers[id];
	            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);
	
	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */
	
	
	    InteractionManager.prototype.onPointerUp = function onPointerUp(event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
	
	        this.onPointerComplete(event, false, this.processPointerUp);
	    };
	
	    /**
	     * Processes the result of the pointer up check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerUp = function processPointerUp(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	
	        var id = interactionEvent.data.identifier;
	
	        var trackingData = displayObject.trackedPointers[id];
	
	        var isTouch = data.pointerType === 'touch';
	
	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
	        // need to track mouse down status in the mouse block so that we can emit
	        // event in a later block
	        var isMouseTap = false;
	
	        // Mouse only
	        if (isMouse) {
	            var isRightButton = data.button === 2;
	
	            var flags = _InteractionTrackingData2.default.FLAGS;
	
	            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;
	
	            var isDown = trackingData !== undefined && trackingData.flags & test;
	
	            if (hit) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);
	
	                if (isDown) {
	                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
	                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
	                    isMouseTap = true;
	                }
	            } else if (isDown) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
	            }
	            // update the down state of the tracking data
	            if (trackingData) {
	                if (isRightButton) {
	                    trackingData.rightDown = false;
	                } else {
	                    trackingData.leftDown = false;
	                }
	            }
	        }
	
	        // Pointers and Touches, and Mouse
	        if (hit) {
	            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);
	
	            if (trackingData) {
	                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
	                if (!isMouse || isMouseTap) {
	                    this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
	                }
	                if (isTouch) {
	                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
	                    // touches are no longer over (if they ever were) when we get the touchend
	                    // so we should ensure that we don't keep pretending that they are
	                    trackingData.over = false;
	                }
	            }
	        } else if (trackingData) {
	            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
	        }
	        // Only remove the tracking data if there is no over/down state still associated with it
	        if (trackingData && trackingData.none) {
	            delete displayObject.trackedPointers[id];
	        }
	    };
	
	    /**
	     * Is called when the pointer moves across the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
	     */
	
	
	    InteractionManager.prototype.onPointerMove = function onPointerMove(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
	
	        var events = this.normalizeToPointerData(originalEvent);
	
	        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
	            this.didMove = true;
	
	            this.cursor = null;
	        }
	
	        var eventLen = events.length;
	
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	
	            var interactionData = this.getInteractionDataForPointerId(event);
	
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	            interactionEvent.data.originalEvent = originalEvent;
	
	            var interactive = event.pointerType === 'touch' ? this.moveWhenInside : true;
	
	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerMove, interactive);
	            this.emit('pointermove', interactionEvent);
	            if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
	            if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mousemove', interactionEvent);
	        }
	
	        if (events[0].pointerType === 'mouse') {
	            this.setCursorMode(this.cursor);
	
	            // TODO BUG for parents interactive object (border order issue)
	        }
	    };
	
	    /**
	     * Processes the result of the pointer move check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerMove = function processPointerMove(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	
	        var isTouch = data.pointerType === 'touch';
	
	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
	
	        if (isMouse) {
	            this.processPointerOverOut(interactionEvent, displayObject, hit);
	        }
	
	        if (!this.moveWhenInside || hit) {
	            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
	            if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
	        }
	    };
	
	    /**
	     * Is called when the pointer is moved out of the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
	     */
	
	
	    InteractionManager.prototype.onPointerOut = function onPointerOut(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
	
	        var events = this.normalizeToPointerData(originalEvent);
	
	        // Only mouse and pointer can call onPointerOut, so events will always be length 1
	        var event = events[0];
	
	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = false;
	            this.setCursorMode(null);
	        }
	
	        var interactionData = this.getInteractionDataForPointerId(event);
	
	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	        interactionEvent.data.originalEvent = event;
	
	        this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, false);
	
	        this.emit('pointerout', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseout', interactionEvent);
	        } else {
	            // we can get touchleave events after touchend, so we want to make sure we don't
	            // introduce memory leaks
	            this.releaseInteractionDataForPointerId(interactionData.identifier);
	        }
	    };
	
	    /**
	     * Processes the result of the pointer over/out check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	
	
	    InteractionManager.prototype.processPointerOverOut = function processPointerOverOut(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	
	        var id = interactionEvent.data.identifier;
	
	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
	
	        var trackingData = displayObject.trackedPointers[id];
	
	        // if we just moused over the display object, then we need to track that state
	        if (hit && !trackingData) {
	            trackingData = displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
	        }
	
	        if (trackingData === undefined) return;
	
	        if (hit && this.mouseOverRenderer) {
	            if (!trackingData.over) {
	                trackingData.over = true;
	                this.dispatchEvent(displayObject, 'pointerover', interactionEvent);
	                if (isMouse) {
	                    this.dispatchEvent(displayObject, 'mouseover', interactionEvent);
	                }
	            }
	
	            // only change the cursor if it has not already been changed (by something deeper in the
	            // display tree)
	            if (isMouse && this.cursor === null) {
	                this.cursor = displayObject.cursor;
	            }
	        } else if (trackingData.over) {
	            trackingData.over = false;
	            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
	            if (isMouse) {
	                this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
	            }
	            // if there is no mouse down information for the pointer, then it is safe to delete
	            if (trackingData.none) {
	                delete displayObject.trackedPointers[id];
	            }
	        }
	    };
	
	    /**
	     * Is called when the pointer is moved into the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
	     */
	
	
	    InteractionManager.prototype.onPointerOver = function onPointerOver(originalEvent) {
	        var events = this.normalizeToPointerData(originalEvent);
	
	        // Only mouse and pointer can call onPointerOver, so events will always be length 1
	        var event = events[0];
	
	        var interactionData = this.getInteractionDataForPointerId(event);
	
	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	
	        interactionEvent.data.originalEvent = event;
	
	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = true;
	        }
	
	        this.emit('pointerover', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseover', interactionEvent);
	        }
	    };
	
	    /**
	     * Get InteractionData for a given pointerId. Store that data as well
	     *
	     * @private
	     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
	     * @return {PIXI.interaction.InteractionData} - Interaction data for the given pointer identifier
	     */
	
	
	    InteractionManager.prototype.getInteractionDataForPointerId = function getInteractionDataForPointerId(event) {
	        var pointerId = event.pointerId;
	
	        var interactionData = void 0;
	
	        if (pointerId === MOUSE_POINTER_ID || event.pointerType === 'mouse') {
	            interactionData = this.mouse;
	        } else if (this.activeInteractionData[pointerId]) {
	            interactionData = this.activeInteractionData[pointerId];
	        } else {
	            interactionData = this.interactionDataPool.pop() || new _InteractionData2.default();
	            interactionData.identifier = pointerId;
	            this.activeInteractionData[pointerId] = interactionData;
	        }
	        // copy properties from the event, so that we can make sure that touch/pointer specific
	        // data is available
	        interactionData.copyEvent(event);
	
	        return interactionData;
	    };
	
	    /**
	     * Return unused InteractionData to the pool, for a given pointerId
	     *
	     * @private
	     * @param {number} pointerId - Identifier from a pointer event
	     */
	
	
	    InteractionManager.prototype.releaseInteractionDataForPointerId = function releaseInteractionDataForPointerId(pointerId) {
	        var interactionData = this.activeInteractionData[pointerId];
	
	        if (interactionData) {
	            delete this.activeInteractionData[pointerId];
	            interactionData.reset();
	            this.interactionDataPool.push(interactionData);
	        }
	    };
	
	    /**
	     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The event to be configured
	     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
	     * @param {PIXI.interaction.InteractionData} interactionData - The InteractionData that will be paired
	     *        with the InteractionEvent
	     * @return {PIXI.interaction.InteractionEvent} the interaction event that was passed in
	     */
	
	
	    InteractionManager.prototype.configureInteractionEventForDOMEvent = function configureInteractionEventForDOMEvent(interactionEvent, pointerEvent, interactionData) {
	        interactionEvent.data = interactionData;
	
	        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);
	
	        // This is the way InteractionManager processed touch events before the refactoring, so I've kept
	        // it here. But it doesn't make that much sense to me, since mapPositionToPoint already factors
	        // in this.resolution, so this just divides by this.resolution twice for touch events...
	        if (navigator.isCocoonJS && pointerEvent.pointerType === 'touch') {
	            interactionData.global.x = interactionData.global.x / this.resolution;
	            interactionData.global.y = interactionData.global.y / this.resolution;
	        }
	
	        // Not really sure why this is happening, but it's how a previous version handled things
	        if (pointerEvent.pointerType === 'touch') {
	            pointerEvent.globalX = interactionData.global.x;
	            pointerEvent.globalY = interactionData.global.y;
	        }
	
	        interactionData.originalEvent = pointerEvent;
	        interactionEvent.reset();
	
	        return interactionEvent;
	    };
	
	    /**
	     * Ensures that the original event object contains all data that a regular pointer event would have
	     *
	     * @private
	     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
	     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
	     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
	     */
	
	
	    InteractionManager.prototype.normalizeToPointerData = function normalizeToPointerData(event) {
	        var normalizedEvents = [];
	
	        if (this.supportsTouchEvents && event instanceof TouchEvent) {
	            for (var i = 0, li = event.changedTouches.length; i < li; i++) {
	                var touch = event.changedTouches[i];
	
	                if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
	                if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
	                if (typeof touch.isPrimary === 'undefined') {
	                    touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
	                }
	                if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
	                if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
	                if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
	                if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
	                if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
	                if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
	                if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
	                touch.twist = 0;
	                touch.tangentialPressure = 0;
	                // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
	                // support, and the fill ins are not quite the same
	                // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
	                // left is not 0,0 on the page
	                if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
	                if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;
	
	                // mark the touch as normalized, just so that we know we did it
	                touch.isNormalized = true;
	
	                normalizedEvents.push(touch);
	            }
	        }
	        // apparently PointerEvent subclasses MouseEvent, so yay
	        else if (event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof window.PointerEvent))) {
	                if (typeof event.isPrimary === 'undefined') event.isPrimary = true;
	                if (typeof event.width === 'undefined') event.width = 1;
	                if (typeof event.height === 'undefined') event.height = 1;
	                if (typeof event.tiltX === 'undefined') event.tiltX = 0;
	                if (typeof event.tiltY === 'undefined') event.tiltY = 0;
	                if (typeof event.pointerType === 'undefined') event.pointerType = 'mouse';
	                if (typeof event.pointerId === 'undefined') event.pointerId = MOUSE_POINTER_ID;
	                if (typeof event.pressure === 'undefined') event.pressure = 0.5;
	                event.twist = 0;
	                event.tangentialPressure = 0;
	
	                // mark the mouse event as normalized, just so that we know we did it
	                event.isNormalized = true;
	
	                normalizedEvents.push(event);
	            } else {
	                normalizedEvents.push(event);
	            }
	
	        return normalizedEvents;
	    };
	
	    /**
	     * Destroys the interaction manager
	     *
	     */
	
	
	    InteractionManager.prototype.destroy = function destroy() {
	        this.removeEvents();
	
	        this.removeAllListeners();
	
	        this.renderer = null;
	
	        this.mouse = null;
	
	        this.eventData = null;
	
	        this.interactionDOMElement = null;
	
	        this.onPointerDown = null;
	        this.processPointerDown = null;
	
	        this.onPointerUp = null;
	        this.processPointerUp = null;
	
	        this.onPointerCancel = null;
	        this.processPointerCancel = null;
	
	        this.onPointerMove = null;
	        this.processPointerMove = null;
	
	        this.onPointerOut = null;
	        this.processPointerOverOut = null;
	
	        this.onPointerOver = null;
	
	        this._tempPoint = null;
	    };
	
	    return InteractionManager;
	}(_eventemitter2.default);
	
	exports.default = InteractionManager;
	
	
	core.WebGLRenderer.registerPlugin('interaction', InteractionManager);
	core.CanvasRenderer.registerPlugin('interaction', InteractionManager);
	//# sourceMappingURL=InteractionManager.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InteractionData = __webpack_require__(128);
	
	Object.defineProperty(exports, 'InteractionData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionData).default;
	  }
	});
	
	var _InteractionManager = __webpack_require__(262);
	
	Object.defineProperty(exports, 'InteractionManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionManager).default;
	  }
	});
	
	var _interactiveTarget = __webpack_require__(131);
	
	Object.defineProperty(exports, 'interactiveTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_interactiveTarget).default;
	  }
	});
	
	var _InteractionTrackingData = __webpack_require__(130);
	
	Object.defineProperty(exports, 'InteractionTrackingData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionTrackingData).default;
	  }
	});
	
	var _InteractionEvent = __webpack_require__(129);
	
	Object.defineProperty(exports, 'InteractionEvent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionEvent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.shared = exports.Resource = exports.textureParser = exports.getResourcePath = exports.spritesheetParser = exports.parseBitmapFontData = exports.bitmapFontParser = exports.Loader = undefined;
	
	var _bitmapFontParser = __webpack_require__(132);
	
	Object.defineProperty(exports, 'bitmapFontParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_bitmapFontParser).default;
	    }
	});
	Object.defineProperty(exports, 'parseBitmapFontData', {
	    enumerable: true,
	    get: function get() {
	        return _bitmapFontParser.parse;
	    }
	});
	
	var _spritesheetParser = __webpack_require__(133);
	
	Object.defineProperty(exports, 'spritesheetParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_spritesheetParser).default;
	    }
	});
	Object.defineProperty(exports, 'getResourcePath', {
	    enumerable: true,
	    get: function get() {
	        return _spritesheetParser.getResourcePath;
	    }
	});
	
	var _textureParser = __webpack_require__(134);
	
	Object.defineProperty(exports, 'textureParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_textureParser).default;
	    }
	});
	
	var _resourceLoader = __webpack_require__(31);
	
	Object.defineProperty(exports, 'Resource', {
	    enumerable: true,
	    get: function get() {
	        return _resourceLoader.Resource;
	    }
	});
	
	var _Application = __webpack_require__(101);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _loader = __webpack_require__(265);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This namespace contains APIs which extends the {@link https://github.com/englercj/resource-loader resource-loader} module
	 * for loading assets, data, and other resources dynamically.
	 * @example
	 * const loader = new PIXI.loaders.Loader();
	 * loader.add('bunny', 'data/bunny.png')
	 *       .add('spaceship', 'assets/spritesheet.json');
	 * loader.load((loader, resources) => {
	 *    // resources.bunny
	 *    // resources.spaceship
	 * });
	 * @namespace PIXI.loaders
	 */
	exports.Loader = _loader2.default;
	
	
	/**
	 * A premade instance of the loader that can be used to load resources.
	 * @name shared
	 * @memberof PIXI.loaders
	 * @type {PIXI.loaders.Loader}
	 */
	var shared = new _loader2.default();
	
	shared.destroy = function () {
	    // protect destroying shared loader
	};
	
	exports.shared = shared;
	
	// Mixin the loader construction
	
	var AppPrototype = _Application2.default.prototype;
	
	AppPrototype._loader = null;
	
	/**
	 * Loader instance to help with asset loading.
	 * @name PIXI.Application#loader
	 * @type {PIXI.loaders.Loader}
	 */
	Object.defineProperty(AppPrototype, 'loader', {
	    get: function get() {
	        if (!this._loader) {
	            var sharedLoader = this._options.sharedLoader;
	
	            this._loader = sharedLoader ? shared : new _loader2.default();
	        }
	
	        return this._loader;
	    }
	});
	
	// Override the destroy function
	// making sure to destroy the current Loader
	AppPrototype._parentDestroy = AppPrototype.destroy;
	AppPrototype.destroy = function destroy(removeView, stageOptions) {
	    if (this._loader) {
	        this._loader.destroy();
	        this._loader = null;
	    }
	    this._parentDestroy(removeView, stageOptions);
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _resourceLoader = __webpack_require__(31);
	
	var _resourceLoader2 = _interopRequireDefault(_resourceLoader);
	
	var _blob = __webpack_require__(300);
	
	var _eventemitter = __webpack_require__(19);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _textureParser = __webpack_require__(134);
	
	var _textureParser2 = _interopRequireDefault(_textureParser);
	
	var _spritesheetParser = __webpack_require__(133);
	
	var _spritesheetParser2 = _interopRequireDefault(_spritesheetParser);
	
	var _bitmapFontParser = __webpack_require__(132);
	
	var _bitmapFontParser2 = _interopRequireDefault(_bitmapFontParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 *
	 * The new loader, extends Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
	 *
	 * ```js
	 * const loader = PIXI.loader; // PixiJS exposes a premade instance for you to use.
	 * //or
	 * const loader = new PIXI.loaders.Loader(); // you can also create your own if you want
	 *
	 * const sprites = {};
	 *
	 * // Chainable `add` to enqueue a resource
	 * loader.add('bunny', 'data/bunny.png')
	 *       .add('spaceship', 'assets/spritesheet.json');
	 * loader.add('scoreFont', 'assets/score.fnt');
	 *
	 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
	 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
	 * loader.pre(cachingMiddleware);
	 *
	 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
	 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
	 * loader.use(parsingMiddleware);
	 *
	 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
	 * // resources have loaded.
	 * loader.load((loader, resources) => {
	 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
	 *     // They have a couple default properties:
	 *     // - `url`: The URL that the resource was loaded from
	 *     // - `error`: The error that happened when trying to load (if any)
	 *     // - `data`: The raw data that was loaded
	 *     // also may contain other properties based on the middleware that runs.
	 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
	 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
	 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
	 * });
	 *
	 * // throughout the process multiple signals can be dispatched.
	 * loader.onProgress.add(() => {}); // called once per loaded/errored file
	 * loader.onError.add(() => {}); // called once per errored file
	 * loader.onLoad.add(() => {}); // called once per loaded file
	 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
	 * ```
	 *
	 * @see https://github.com/englercj/resource-loader
	 *
	 * @class
	 * @extends module:resource-loader.ResourceLoader
	 * @memberof PIXI.loaders
	 */
	var Loader = function (_ResourceLoader) {
	    _inherits(Loader, _ResourceLoader);
	
	    /**
	     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	     * @param {number} [concurrency=10] - The number of resources to load concurrently.
	     */
	    function Loader(baseUrl, concurrency) {
	        _classCallCheck(this, Loader);
	
	        var _this = _possibleConstructorReturn(this, _ResourceLoader.call(this, baseUrl, concurrency));
	
	        _eventemitter2.default.call(_this);
	
	        for (var i = 0; i < Loader._pixiMiddleware.length; ++i) {
	            _this.use(Loader._pixiMiddleware[i]());
	        }
	
	        // Compat layer, translate the new v2 signals into old v1 events.
	        _this.onStart.add(function (l) {
	            return _this.emit('start', l);
	        });
	        _this.onProgress.add(function (l, r) {
	            return _this.emit('progress', l, r);
	        });
	        _this.onError.add(function (e, l, r) {
	            return _this.emit('error', e, l, r);
	        });
	        _this.onLoad.add(function (l, r) {
	            return _this.emit('load', l, r);
	        });
	        _this.onComplete.add(function (l, r) {
	            return _this.emit('complete', l, r);
	        });
	        return _this;
	    }
	
	    /**
	     * Adds a default middleware to the PixiJS loader.
	     *
	     * @static
	     * @param {Function} fn - The middleware to add.
	     */
	
	
	    Loader.addPixiMiddleware = function addPixiMiddleware(fn) {
	        Loader._pixiMiddleware.push(fn);
	    };
	
	    /**
	     * Destroy the loader, removes references.
	     */
	
	
	    Loader.prototype.destroy = function destroy() {
	        this.removeAllListeners();
	        this.reset();
	    };
	
	    return Loader;
	}(_resourceLoader2.default);
	
	// Copy EE3 prototype (mixin)
	
	
	exports.default = Loader;
	for (var k in _eventemitter2.default.prototype) {
	    Loader.prototype[k] = _eventemitter2.default.prototype[k];
	}
	
	Loader._pixiMiddleware = [
	// parse any blob into more usable objects (e.g. Image)
	_blob.blobMiddlewareFactory,
	// parse any Image objects into textures
	_textureParser2.default,
	// parse any spritesheet data into multiple textures
	_spritesheetParser2.default,
	// parse bitmap font data into multiple textures
	_bitmapFontParser2.default];
	
	// Add custom extentions
	var Resource = _resourceLoader2.default.Resource;
	
	Resource.setExtensionXhrType('fnt', Resource.XHR_RESPONSE_TYPE.DOCUMENT);
	//# sourceMappingURL=loader.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Plane2 = __webpack_require__(135);
	
	var _Plane3 = _interopRequireDefault(_Plane2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_BORDER_SIZE = 10;
	
	/**
	 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
	 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
	 *
	 *```js
	 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.fromImage('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
	 *  ```
	 * <pre>
	 *      A                          B
	 *    +---+----------------------+---+
	 *  C | 1 |          2           | 3 |
	 *    +---+----------------------+---+
	 *    |   |                      |   |
	 *    | 4 |          5           | 6 |
	 *    |   |                      |   |
	 *    +---+----------------------+---+
	 *  D | 7 |          8           | 9 |
	 *    +---+----------------------+---+
	
	 *  When changing this objects width and/or height:
	 *     areas 1 3 7 and 9 will remain unscaled.
	 *     areas 2 and 8 will be stretched horizontally
	 *     areas 4 and 6 will be stretched vertically
	 *     area 5 will be stretched both horizontally and vertically
	 * </pre>
	 *
	 * @class
	 * @extends PIXI.mesh.Plane
	 * @memberof PIXI.mesh
	 *
	 */
	
	var NineSlicePlane = function (_Plane) {
	    _inherits(NineSlicePlane, _Plane);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the NineSlicePlane.
	     * @param {int} [leftWidth=10] size of the left vertical bar (A)
	     * @param {int} [topHeight=10] size of the top horizontal bar (C)
	     * @param {int} [rightWidth=10] size of the right vertical bar (B)
	     * @param {int} [bottomHeight=10] size of the bottom horizontal bar (D)
	     */
	    function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
	        _classCallCheck(this, NineSlicePlane);
	
	        var _this = _possibleConstructorReturn(this, _Plane.call(this, texture, 4, 4));
	
	        _this._origWidth = texture.orig.width;
	        _this._origHeight = texture.orig.height;
	
	        /**
	         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._width = _this._origWidth;
	
	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._height = _this._origHeight;
	
	        /**
	         * The width of the left column (a)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._leftWidth = typeof leftWidth !== 'undefined' ? leftWidth : DEFAULT_BORDER_SIZE;
	
	        /**
	         * The width of the right column (b)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._rightWidth = typeof rightWidth !== 'undefined' ? rightWidth : DEFAULT_BORDER_SIZE;
	
	        /**
	         * The height of the top row (c)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._topHeight = typeof topHeight !== 'undefined' ? topHeight : DEFAULT_BORDER_SIZE;
	
	        /**
	         * The height of the bottom row (d)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._bottomHeight = typeof bottomHeight !== 'undefined' ? bottomHeight : DEFAULT_BORDER_SIZE;
	
	        _this.refresh(true);
	        return _this;
	    }
	
	    /**
	     * Updates the horizontal vertices.
	     *
	     */
	
	
	    NineSlicePlane.prototype.updateHorizontalVertices = function updateHorizontalVertices() {
	        var vertices = this.vertices;
	
	        var h = this._topHeight + this._bottomHeight;
	        var scale = this._height > h ? 1.0 : this._height / h;
	
	        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
	        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
	        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
	    };
	
	    /**
	     * Updates the vertical vertices.
	     *
	     */
	
	
	    NineSlicePlane.prototype.updateVerticalVertices = function updateVerticalVertices() {
	        var vertices = this.vertices;
	
	        var w = this._leftWidth + this._rightWidth;
	        var scale = this._width > w ? 1.0 : this._width / w;
	
	        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
	        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
	        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer to render with.
	     */
	
	
	    NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
	        var context = renderer.context;
	
	        context.globalAlpha = this.worldAlpha;
	        renderer.setBlendMode(this.blendMode);
	
	        var transform = this.worldTransform;
	        var res = renderer.resolution;
	
	        if (renderer.roundPixels) {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
	        } else {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
	        }
	
	        var base = this._texture.baseTexture;
	        var textureSource = base.source;
	        var w = base.width * base.resolution;
	        var h = base.height * base.resolution;
	
	        this.drawSegment(context, textureSource, w, h, 0, 1, 10, 11);
	        this.drawSegment(context, textureSource, w, h, 2, 3, 12, 13);
	        this.drawSegment(context, textureSource, w, h, 4, 5, 14, 15);
	        this.drawSegment(context, textureSource, w, h, 8, 9, 18, 19);
	        this.drawSegment(context, textureSource, w, h, 10, 11, 20, 21);
	        this.drawSegment(context, textureSource, w, h, 12, 13, 22, 23);
	        this.drawSegment(context, textureSource, w, h, 16, 17, 26, 27);
	        this.drawSegment(context, textureSource, w, h, 18, 19, 28, 29);
	        this.drawSegment(context, textureSource, w, h, 20, 21, 30, 31);
	    };
	
	    /**
	     * Renders one segment of the plane.
	     * to mimic the exact drawing behavior of stretching the image like WebGL does, we need to make sure
	     * that the source area is at least 1 pixel in size, otherwise nothing gets drawn when a slice size of 0 is used.
	     *
	     * @private
	     * @param {CanvasRenderingContext2D} context - The context to draw with.
	     * @param {CanvasImageSource} textureSource - The source to draw.
	     * @param {number} w - width of the texture
	     * @param {number} h - height of the texture
	     * @param {number} x1 - x index 1
	     * @param {number} y1 - y index 1
	     * @param {number} x2 - x index 2
	     * @param {number} y2 - y index 2
	     */
	
	
	    NineSlicePlane.prototype.drawSegment = function drawSegment(context, textureSource, w, h, x1, y1, x2, y2) {
	        // otherwise you get weird results when using slices of that are 0 wide or high.
	        var uvs = this.uvs;
	        var vertices = this.vertices;
	
	        var sw = (uvs[x2] - uvs[x1]) * w;
	        var sh = (uvs[y2] - uvs[y1]) * h;
	        var dw = vertices[x2] - vertices[x1];
	        var dh = vertices[y2] - vertices[y1];
	
	        // make sure the source is at least 1 pixel wide and high, otherwise nothing will be drawn.
	        if (sw < 1) {
	            sw = 1;
	        }
	
	        if (sh < 1) {
	            sh = 1;
	        }
	
	        // make sure destination is at least 1 pixel wide and high, otherwise you get
	        // lines when rendering close to original size.
	        if (dw < 1) {
	            dw = 1;
	        }
	
	        if (dh < 1) {
	            dh = 1;
	        }
	
	        context.drawImage(textureSource, uvs[x1] * w, uvs[y1] * h, sw, sh, vertices[x1], vertices[y1], dw, dh);
	    };
	
	    /**
	     * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	     *
	     * @member {number}
	     */
	
	
	    /**
	     * Refreshes NineSlicePlane coords. All of them.
	     */
	    NineSlicePlane.prototype._refresh = function _refresh() {
	        _Plane.prototype._refresh.call(this);
	
	        var uvs = this.uvs;
	        var texture = this._texture;
	
	        this._origWidth = texture.orig.width;
	        this._origHeight = texture.orig.height;
	
	        var _uvw = 1.0 / this._origWidth;
	        var _uvh = 1.0 / this._origHeight;
	
	        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
	        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
	        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
	        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
	
	        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
	        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
	        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
	        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;
	
	        this.updateHorizontalVertices();
	        this.updateVerticalVertices();
	
	        this.dirty++;
	
	        this.multiplyUvs();
	    };
	
	    _createClass(NineSlicePlane, [{
	        key: 'width',
	        get: function get() {
	            return this._width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._width = value;
	            this._refresh();
	        }
	
	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'height',
	        get: function get() {
	            return this._height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._height = value;
	            this._refresh();
	        }
	
	        /**
	         * The width of the left column
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'leftWidth',
	        get: function get() {
	            return this._leftWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._leftWidth = value;
	            this._refresh();
	        }
	
	        /**
	         * The width of the right column
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'rightWidth',
	        get: function get() {
	            return this._rightWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._rightWidth = value;
	            this._refresh();
	        }
	
	        /**
	         * The height of the top row
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'topHeight',
	        get: function get() {
	            return this._topHeight;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._topHeight = value;
	            this._refresh();
	        }
	
	        /**
	         * The height of the bottom row
	         *
	         * @member {number}
	         */
	
	    }, {
	        key: 'bottomHeight',
	        get: function get() {
	            return this._bottomHeight;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._bottomHeight = value;
	            this._refresh();
	        }
	    }]);
	
	    return NineSlicePlane;
	}(_Plane3.default);
	
	exports.default = NineSlicePlane;
	//# sourceMappingURL=NineSlicePlane.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mesh2 = __webpack_require__(30);
	
	var _Mesh3 = _interopRequireDefault(_Mesh2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The rope allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let rope = new PIXI.Rope(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 *
	 */
	var Rope = function (_Mesh) {
	    _inherits(Rope, _Mesh);
	
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the rope.
	     * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
	     */
	    function Rope(texture, points) {
	        _classCallCheck(this, Rope);
	
	        /**
	         * An array of points that determine the rope
	         *
	         * @member {PIXI.Point[]}
	         */
	        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));
	
	        _this.points = points;
	
	        /**
	         * An array of vertices used to construct this rope.
	         *
	         * @member {Float32Array}
	         */
	        _this.vertices = new Float32Array(points.length * 4);
	
	        /**
	         * The WebGL Uvs of the rope.
	         *
	         * @member {Float32Array}
	         */
	        _this.uvs = new Float32Array(points.length * 4);
	
	        /**
	         * An array containing the color components
	         *
	         * @member {Float32Array}
	         */
	        _this.colors = new Float32Array(points.length * 2);
	
	        /**
	         * An array containing the indices of the vertices
	         *
	         * @member {Uint16Array}
	         */
	        _this.indices = new Uint16Array(points.length * 2);
	
	        /**
	         * refreshes vertices on every updateTransform
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoUpdate = true;
	
	        _this.refresh();
	        return _this;
	    }
	
	    /**
	     * Refreshes
	     *
	     */
	
	
	    Rope.prototype._refresh = function _refresh() {
	        var points = this.points;
	
	        // if too little points, or texture hasn't got UVs set yet just move on.
	        if (points.length < 1 || !this._texture._uvs) {
	            return;
	        }
	
	        // if the number of points has changed we will need to recreate the arraybuffers
	        if (this.vertices.length / 4 !== points.length) {
	            this.vertices = new Float32Array(points.length * 4);
	            this.uvs = new Float32Array(points.length * 4);
	            this.colors = new Float32Array(points.length * 2);
	            this.indices = new Uint16Array(points.length * 2);
	        }
	
	        var uvs = this.uvs;
	
	        var indices = this.indices;
	        var colors = this.colors;
	
	        uvs[0] = 0;
	        uvs[1] = 0;
	        uvs[2] = 0;
	        uvs[3] = 1;
	
	        colors[0] = 1;
	        colors[1] = 1;
	
	        indices[0] = 0;
	        indices[1] = 1;
	
	        var total = points.length;
	
	        for (var i = 1; i < total; i++) {
	            // time to do some smart drawing!
	            var index = i * 4;
	            var amount = i / (total - 1);
	
	            uvs[index] = amount;
	            uvs[index + 1] = 0;
	
	            uvs[index + 2] = amount;
	            uvs[index + 3] = 1;
	
	            index = i * 2;
	            colors[index] = 1;
	            colors[index + 1] = 1;
	
	            index = i * 2;
	            indices[index] = index;
	            indices[index + 1] = index + 1;
	        }
	
	        // ensure that the changes are uploaded
	        this.dirty++;
	        this.indexDirty++;
	
	        this.multiplyUvs();
	        this.refreshVertices();
	    };
	
	    /**
	     * refreshes vertices of Rope mesh
	     */
	
	
	    Rope.prototype.refreshVertices = function refreshVertices() {
	        var points = this.points;
	
	        if (points.length < 1) {
	            return;
	        }
	
	        var lastPoint = points[0];
	        var nextPoint = void 0;
	        var perpX = 0;
	        var perpY = 0;
	
	        // this.count -= 0.2;
	
	        var vertices = this.vertices;
	        var total = points.length;
	
	        for (var i = 0; i < total; i++) {
	            var point = points[i];
	            var index = i * 4;
	
	            if (i < points.length - 1) {
	                nextPoint = points[i + 1];
	            } else {
	                nextPoint = point;
	            }
	
	            perpY = -(nextPoint.x - lastPoint.x);
	            perpX = nextPoint.y - lastPoint.y;
	
	            var ratio = (1 - i / (total - 1)) * 10;
	
	            if (ratio > 1) {
	                ratio = 1;
	            }
	
	            var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
	            var num = this._texture.height / 2; // (20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;
	
	            perpX /= perpLength;
	            perpY /= perpLength;
	
	            perpX *= num;
	            perpY *= num;
	
	            vertices[index] = point.x + perpX;
	            vertices[index + 1] = point.y + perpY;
	            vertices[index + 2] = point.x - perpX;
	            vertices[index + 3] = point.y - perpY;
	
	            lastPoint = point;
	        }
	    };
	
	    /**
	     * Updates the object transform for rendering
	     *
	     * @private
	     */
	
	
	    Rope.prototype.updateTransform = function updateTransform() {
	        if (this.autoUpdate) {
	            this.refreshVertices();
	        }
	        this.containerUpdateTransform();
	    };
	
	    return Rope;
	}(_Mesh3.default);
	
	exports.default = Rope;
	//# sourceMappingURL=Rope.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _Mesh = __webpack_require__(30);
	
	var _Mesh2 = _interopRequireDefault(_Mesh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Renderer dedicated to meshes.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var MeshSpriteRenderer = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The renderer this downport works for
	     */
	    function MeshSpriteRenderer(renderer) {
	        _classCallCheck(this, MeshSpriteRenderer);
	
	        this.renderer = renderer;
	    }
	
	    /**
	     * Renders the Mesh
	     *
	     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
	     */
	
	
	    MeshSpriteRenderer.prototype.render = function render(mesh) {
	        var renderer = this.renderer;
	        var context = renderer.context;
	
	        var transform = mesh.worldTransform;
	        var res = renderer.resolution;
	
	        if (renderer.roundPixels) {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
	        } else {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
	        }
	
	        renderer.context.globalAlpha = mesh.worldAlpha;
	        renderer.setBlendMode(mesh.blendMode);
	
	        if (mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH) {
	            this._renderTriangleMesh(mesh);
	        } else {
	            this._renderTriangles(mesh);
	        }
	    };
	
	    /**
	     * Draws the object in Triangle Mesh mode
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
	     */
	
	
	    MeshSpriteRenderer.prototype._renderTriangleMesh = function _renderTriangleMesh(mesh) {
	        // draw triangles!!
	        var length = mesh.vertices.length / 2;
	
	        for (var i = 0; i < length - 2; i++) {
	            // draw some triangles!
	            var index = i * 2;
	
	            this._renderDrawTriangle(mesh, index, index + 2, index + 4);
	        }
	    };
	
	    /**
	     * Draws the object in triangle mode using canvas
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the current mesh
	     */
	
	
	    MeshSpriteRenderer.prototype._renderTriangles = function _renderTriangles(mesh) {
	        // draw triangles!!
	        var indices = mesh.indices;
	        var length = indices.length;
	
	        for (var i = 0; i < length; i += 3) {
	            // draw some triangles!
	            var index0 = indices[i] * 2;
	            var index1 = indices[i + 1] * 2;
	            var index2 = indices[i + 2] * 2;
	
	            this._renderDrawTriangle(mesh, index0, index1, index2);
	        }
	    };
	
	    /**
	     * Draws one of the triangles that from the Mesh
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the current mesh
	     * @param {number} index0 - the index of the first vertex
	     * @param {number} index1 - the index of the second vertex
	     * @param {number} index2 - the index of the third vertex
	     */
	
	
	    MeshSpriteRenderer.prototype._renderDrawTriangle = function _renderDrawTriangle(mesh, index0, index1, index2) {
	        var context = this.renderer.context;
	        var uvs = mesh.uvs;
	        var vertices = mesh.vertices;
	        var texture = mesh._texture;
	
	        if (!texture.valid) {
	            return;
	        }
	
	        var base = texture.baseTexture;
	        var textureSource = base.source;
	        var textureWidth = base.width;
	        var textureHeight = base.height;
	
	        var u0 = void 0;
	        var u1 = void 0;
	        var u2 = void 0;
	        var v0 = void 0;
	        var v1 = void 0;
	        var v2 = void 0;
	
	        if (mesh.uploadUvTransform) {
	            var ut = mesh._uvTransform.mapCoord;
	
	            u0 = (uvs[index0] * ut.a + uvs[index0 + 1] * ut.c + ut.tx) * base.width;
	            u1 = (uvs[index1] * ut.a + uvs[index1 + 1] * ut.c + ut.tx) * base.width;
	            u2 = (uvs[index2] * ut.a + uvs[index2 + 1] * ut.c + ut.tx) * base.width;
	            v0 = (uvs[index0] * ut.b + uvs[index0 + 1] * ut.d + ut.ty) * base.height;
	            v1 = (uvs[index1] * ut.b + uvs[index1 + 1] * ut.d + ut.ty) * base.height;
	            v2 = (uvs[index2] * ut.b + uvs[index2 + 1] * ut.d + ut.ty) * base.height;
	        } else {
	            u0 = uvs[index0] * base.width;
	            u1 = uvs[index1] * base.width;
	            u2 = uvs[index2] * base.width;
	            v0 = uvs[index0 + 1] * base.height;
	            v1 = uvs[index1 + 1] * base.height;
	            v2 = uvs[index2 + 1] * base.height;
	        }
	
	        var x0 = vertices[index0];
	        var x1 = vertices[index1];
	        var x2 = vertices[index2];
	        var y0 = vertices[index0 + 1];
	        var y1 = vertices[index1 + 1];
	        var y2 = vertices[index2 + 1];
	
	        var canvasPadding = mesh.canvasPadding / this.renderer.resolution;
	
	        if (canvasPadding > 0) {
	            var paddingX = canvasPadding / Math.abs(mesh.worldTransform.a);
	            var paddingY = canvasPadding / Math.abs(mesh.worldTransform.d);
	            var centerX = (x0 + x1 + x2) / 3;
	            var centerY = (y0 + y1 + y2) / 3;
	
	            var normX = x0 - centerX;
	            var normY = y0 - centerY;
	
	            var dist = Math.sqrt(normX * normX + normY * normY);
	
	            x0 = centerX + normX / dist * (dist + paddingX);
	            y0 = centerY + normY / dist * (dist + paddingY);
	
	            //
	
	            normX = x1 - centerX;
	            normY = y1 - centerY;
	
	            dist = Math.sqrt(normX * normX + normY * normY);
	            x1 = centerX + normX / dist * (dist + paddingX);
	            y1 = centerY + normY / dist * (dist + paddingY);
	
	            normX = x2 - centerX;
	            normY = y2 - centerY;
	
	            dist = Math.sqrt(normX * normX + normY * normY);
	            x2 = centerX + normX / dist * (dist + paddingX);
	            y2 = centerY + normY / dist * (dist + paddingY);
	        }
	
	        context.save();
	        context.beginPath();
	
	        context.moveTo(x0, y0);
	        context.lineTo(x1, y1);
	        context.lineTo(x2, y2);
	
	        context.closePath();
	
	        context.clip();
	
	        // Compute matrix transform
	        var delta = u0 * v1 + v0 * u2 + u1 * v2 - v1 * u2 - v0 * u1 - u0 * v2;
	        var deltaA = x0 * v1 + v0 * x2 + x1 * v2 - v1 * x2 - v0 * x1 - x0 * v2;
	        var deltaB = u0 * x1 + x0 * u2 + u1 * x2 - x1 * u2 - x0 * u1 - u0 * x2;
	        var deltaC = u0 * v1 * x2 + v0 * x1 * u2 + x0 * u1 * v2 - x0 * v1 * u2 - v0 * u1 * x2 - u0 * x1 * v2;
	        var deltaD = y0 * v1 + v0 * y2 + y1 * v2 - v1 * y2 - v0 * y1 - y0 * v2;
	        var deltaE = u0 * y1 + y0 * u2 + u1 * y2 - y1 * u2 - y0 * u1 - u0 * y2;
	        var deltaF = u0 * v1 * y2 + v0 * y1 * u2 + y0 * u1 * v2 - y0 * v1 * u2 - v0 * u1 * y2 - u0 * y1 * v2;
	
	        context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);
	
	        context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);
	
	        context.restore();
	        this.renderer.invalidateBlendMode();
	    };
	
	    /**
	     * Renders a flat Mesh
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - The Mesh to render
	     */
	
	
	    MeshSpriteRenderer.prototype.renderMeshFlat = function renderMeshFlat(mesh) {
	        var context = this.renderer.context;
	        var vertices = mesh.vertices;
	        var length = vertices.length / 2;
	
	        // this.count++;
	
	        context.beginPath();
	
	        for (var i = 1; i < length - 2; ++i) {
	            // draw some triangles!
	            var index = i * 2;
	
	            var x0 = vertices[index];
	            var y0 = vertices[index + 1];
	
	            var x1 = vertices[index + 2];
	            var y1 = vertices[index + 3];
	
	            var x2 = vertices[index + 4];
	            var y2 = vertices[index + 5];
	
	            context.moveTo(x0, y0);
	            context.lineTo(x1, y1);
	            context.lineTo(x2, y2);
	        }
	
	        context.fillStyle = '#FF0000';
	        context.fill();
	        context.closePath();
	    };
	
	    /**
	     * destroy the the renderer.
	     *
	     */
	
	
	    MeshSpriteRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };
	
	    return MeshSpriteRenderer;
	}();
	
	exports.default = MeshSpriteRenderer;
	
	
	core.CanvasRenderer.registerPlugin('mesh', MeshSpriteRenderer);
	//# sourceMappingURL=CanvasMeshRenderer.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Mesh = __webpack_require__(30);
	
	Object.defineProperty(exports, 'Mesh', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Mesh).default;
	  }
	});
	
	var _MeshRenderer = __webpack_require__(270);
	
	Object.defineProperty(exports, 'MeshRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MeshRenderer).default;
	  }
	});
	
	var _CanvasMeshRenderer = __webpack_require__(268);
	
	Object.defineProperty(exports, 'CanvasMeshRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasMeshRenderer).default;
	  }
	});
	
	var _Plane = __webpack_require__(135);
	
	Object.defineProperty(exports, 'Plane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plane).default;
	  }
	});
	
	var _NineSlicePlane = __webpack_require__(266);
	
	Object.defineProperty(exports, 'NineSlicePlane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NineSlicePlane).default;
	  }
	});
	
	var _Rope = __webpack_require__(267);
	
	Object.defineProperty(exports, 'Rope', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rope).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _Mesh = __webpack_require__(30);
	
	var _Mesh2 = _interopRequireDefault(_Mesh);
	
	var _path = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var matrixIdentity = core.Matrix.IDENTITY;
	
	/**
	 * WebGL renderer plugin for tiling sprites
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	
	var MeshRenderer = function (_core$ObjectRenderer) {
	    _inherits(MeshRenderer, _core$ObjectRenderer);
	
	    /**
	     * constructor for renderer
	     *
	     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
	     */
	    function MeshRenderer(renderer) {
	        _classCallCheck(this, MeshRenderer);
	
	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
	
	        _this.shader = null;
	        return _this;
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    MeshRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n');
	    };
	
	    /**
	     * renders mesh
	     *
	     * @param {PIXI.mesh.Mesh} mesh mesh instance
	     */
	
	
	    MeshRenderer.prototype.render = function render(mesh) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;
	        var texture = mesh._texture;
	
	        if (!texture.valid) {
	            return;
	        }
	
	        var glData = mesh._glDatas[renderer.CONTEXT_UID];
	
	        if (!glData) {
	            renderer.bindVao(null);
	
	            glData = {
	                shader: this.shader,
	                vertexBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.vertices, gl.STREAM_DRAW),
	                uvBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.uvs, gl.STREAM_DRAW),
	                indexBuffer: _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, mesh.indices, gl.STATIC_DRAW),
	                // build the vao object that will render..
	                vao: null,
	                dirty: mesh.dirty,
	                indexDirty: mesh.indexDirty,
	                vertexDirty: mesh.vertexDirty
	            };
	
	            // build the vao object that will render..
	            glData.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(glData.indexBuffer).addAttribute(glData.vertexBuffer, glData.shader.attributes.aVertexPosition, gl.FLOAT, false, 2 * 4, 0).addAttribute(glData.uvBuffer, glData.shader.attributes.aTextureCoord, gl.FLOAT, false, 2 * 4, 0);
	
	            mesh._glDatas[renderer.CONTEXT_UID] = glData;
	        }
	
	        renderer.bindVao(glData.vao);
	
	        if (mesh.dirty !== glData.dirty) {
	            glData.dirty = mesh.dirty;
	            glData.uvBuffer.upload(mesh.uvs);
	        }
	
	        if (mesh.indexDirty !== glData.indexDirty) {
	            glData.indexDirty = mesh.indexDirty;
	            glData.indexBuffer.upload(mesh.indices);
	        }
	
	        if (mesh.vertexDirty !== glData.vertexDirty) {
	            glData.vertexDirty = mesh.vertexDirty;
	            glData.vertexBuffer.upload(mesh.vertices);
	        }
	
	        renderer.bindShader(glData.shader);
	
	        glData.shader.uniforms.uSampler = renderer.bindTexture(texture);
	
	        renderer.state.setBlendMode(core.utils.correctBlendMode(mesh.blendMode, texture.baseTexture.premultipliedAlpha));
	
	        if (glData.shader.uniforms.uTransform) {
	            if (mesh.uploadUvTransform) {
	                glData.shader.uniforms.uTransform = mesh._uvTransform.mapCoord.toArray(true);
	            } else {
	                glData.shader.uniforms.uTransform = matrixIdentity.toArray(true);
	            }
	        }
	        glData.shader.uniforms.translationMatrix = mesh.worldTransform.toArray(true);
	
	        glData.shader.uniforms.uColor = core.utils.premultiplyRgba(mesh.tintRgb, mesh.worldAlpha, glData.shader.uniforms.uColor, texture.baseTexture.premultipliedAlpha);
	
	        var drawMode = mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH ? gl.TRIANGLE_STRIP : gl.TRIANGLES;
	
	        glData.vao.draw(drawMode, mesh.indices.length, 0);
	    };
	
	    return MeshRenderer;
	}(core.ObjectRenderer);
	
	exports.default = MeshRenderer;
	
	
	core.WebGLRenderer.registerPlugin('mesh', MeshRenderer);
	//# sourceMappingURL=MeshRenderer.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _utils = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The ParticleContainer class is a really fast version of the Container built solely for speed,
	 * so use when you need a lot of sprites or particles. The tradeoff of the ParticleContainer is that most advanced
	 * functionality will not work. ParticleContainer implements the basic object transform (position, scale, rotation)
	 * and some advanced functionality like tint (as of v4.5.6).
	 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
	 *
	 * It's extremely easy to use :
	 *
	 * ```js
	 * let container = new ParticleContainer();
	 *
	 * for (let i = 0; i < 100; ++i)
	 * {
	 *     let sprite = new PIXI.Sprite.fromImage("myImage.png");
	 *     container.addChild(sprite);
	 * }
	 * ```
	 *
	 * And here you have a hundred sprites that will be rendered at the speed of light.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.particles
	 */
	var ParticleContainer = function (_core$Container) {
	    _inherits(ParticleContainer, _core$Container);
	
	    /**
	     * @param {number} [maxSize=1500] - The maximum number of particles that can be rendered by the container.
	     *  Affects size of allocated buffers.
	     * @param {object} [properties] - The properties of children that should be uploaded to the gpu and applied.
	     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
	     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
	     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
	     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
	     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
	     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
	     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
	     * @param {boolean} [autoResize=false] If true, container allocates more batches in case
	     *  there are more than `maxSize` particles.
	     */
	    function ParticleContainer() {
	        var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1500;
	        var properties = arguments[1];
	        var batchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16384;
	        var autoResize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        _classCallCheck(this, ParticleContainer);
	
	        // Making sure the batch size is valid
	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));
	
	        var maxBatchSize = 16384;
	
	        if (batchSize > maxBatchSize) {
	            batchSize = maxBatchSize;
	        }
	
	        if (batchSize > maxSize) {
	            batchSize = maxSize;
	        }
	
	        /**
	         * Set properties to be dynamic (true) / static (false)
	         *
	         * @member {boolean[]}
	         * @private
	         */
	        _this._properties = [false, true, false, false, false];
	
	        /**
	         * @member {number}
	         * @private
	         */
	        _this._maxSize = maxSize;
	
	        /**
	         * @member {number}
	         * @private
	         */
	        _this._batchSize = batchSize;
	
	        /**
	         * @member {object<number, WebGLBuffer>}
	         * @private
	         */
	        _this._glBuffers = {};
	
	        /**
	         * for every batch stores _updateID corresponding to the last change in that batch
	         * @member {number[]}
	         * @private
	         */
	        _this._bufferUpdateIDs = [];
	
	        /**
	         * when child inserted, removed or changes position this number goes up
	         * @member {number[]}
	         * @private
	         */
	        _this._updateID = 0;
	
	        /**
	         * @member {boolean}
	         *
	         */
	        _this.interactiveChildren = false;
	
	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL`
	         * to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = core.BLEND_MODES.NORMAL;
	
	        /**
	         * If true, container allocates more batches in case there are more than `maxSize` particles.
	         * @member {boolean}
	         * @default false
	         */
	        _this.autoResize = autoResize;
	
	        /**
	         * Used for canvas renderering. If true then the elements will be positioned at the
	         * nearest pixel. This provides a nice speed boost.
	         *
	         * @member {boolean}
	         * @default true;
	         */
	        _this.roundPixels = true;
	
	        /**
	         * The texture used to render the children.
	         *
	         * @readonly
	         * @member {BaseTexture}
	         */
	        _this.baseTexture = null;
	
	        _this.setProperties(properties);
	
	        /**
	         * The tint applied to the container.
	         * This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = 0;
	        _this.tintRgb = new Float32Array(4);
	        _this.tint = 0xFFFFFF;
	        return _this;
	    }
	
	    /**
	     * Sets the private properties array to dynamic / static based on the passed properties object
	     *
	     * @param {object} properties - The properties to be uploaded
	     */
	
	
	    ParticleContainer.prototype.setProperties = function setProperties(properties) {
	        if (properties) {
	            this._properties[0] = 'vertices' in properties || 'scale' in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
	            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
	            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
	            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
	            this._properties[4] = 'tint' in properties || 'alpha' in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
	        }
	    };
	
	    /**
	     * Updates the object transform for rendering
	     *
	     * @private
	     */
	
	
	    ParticleContainer.prototype.updateTransform = function updateTransform() {
	        // TODO don't need to!
	        this.displayObjectUpdateTransform();
	        //  PIXI.Container.prototype.updateTransform.call( this );
	    };
	
	    /**
	     * The tint applied to the container. This is a hex value.
	     * A value of 0xFFFFFF will remove any tint effect.
	     ** IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
	     * @member {number}
	     * @default 0xFFFFFF
	     */
	
	
	    /**
	     * Renders the container using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The webgl renderer
	     */
	    ParticleContainer.prototype.renderWebGL = function renderWebGL(renderer) {
	        var _this2 = this;
	
	        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	            return;
	        }
	
	        if (!this.baseTexture) {
	            this.baseTexture = this.children[0]._texture.baseTexture;
	            if (!this.baseTexture.hasLoaded) {
	                this.baseTexture.once('update', function () {
	                    return _this2.onChildrenChange(0);
	                });
	            }
	        }
	
	        renderer.setObjectRenderer(renderer.plugins.particle);
	        renderer.plugins.particle.render(this);
	    };
	
	    /**
	     * Set the flag that static data should be updated to true
	     *
	     * @private
	     * @param {number} smallestChildIndex - The smallest child index
	     */
	
	
	    ParticleContainer.prototype.onChildrenChange = function onChildrenChange(smallestChildIndex) {
	        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
	
	        while (this._bufferUpdateIDs.length < bufferIndex) {
	            this._bufferUpdateIDs.push(0);
	        }
	        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
	    };
	
	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
	     */
	
	
	    ParticleContainer.prototype.renderCanvas = function renderCanvas(renderer) {
	        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	            return;
	        }
	
	        var context = renderer.context;
	        var transform = this.worldTransform;
	        var isRotated = true;
	
	        var positionX = 0;
	        var positionY = 0;
	
	        var finalWidth = 0;
	        var finalHeight = 0;
	
	        renderer.setBlendMode(this.blendMode);
	
	        context.globalAlpha = this.worldAlpha;
	
	        this.displayObjectUpdateTransform();
	
	        for (var i = 0; i < this.children.length; ++i) {
	            var child = this.children[i];
	
	            if (!child.visible) {
	                continue;
	            }
	
	            var frame = child._texture.frame;
	
	            context.globalAlpha = this.worldAlpha * child.alpha;
	
	            if (child.rotation % (Math.PI * 2) === 0) {
	                // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
	                if (isRotated) {
	                    context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.tx * renderer.resolution, transform.ty * renderer.resolution);
	
	                    isRotated = false;
	                }
	
	                positionX = child.anchor.x * (-frame.width * child.scale.x) + child.position.x + 0.5;
	                positionY = child.anchor.y * (-frame.height * child.scale.y) + child.position.y + 0.5;
	
	                finalWidth = frame.width * child.scale.x;
	                finalHeight = frame.height * child.scale.y;
	            } else {
	                if (!isRotated) {
	                    isRotated = true;
	                }
	
	                child.displayObjectUpdateTransform();
	
	                var childTransform = child.worldTransform;
	
	                if (renderer.roundPixels) {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution | 0, childTransform.ty * renderer.resolution | 0);
	                } else {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution, childTransform.ty * renderer.resolution);
	                }
	
	                positionX = child.anchor.x * -frame.width + 0.5;
	                positionY = child.anchor.y * -frame.height + 0.5;
	
	                finalWidth = frame.width;
	                finalHeight = frame.height;
	            }
	
	            var resolution = child._texture.baseTexture.resolution;
	
	            context.drawImage(child._texture.baseTexture.source, frame.x * resolution, frame.y * resolution, frame.width * resolution, frame.height * resolution, positionX * renderer.resolution, positionY * renderer.resolution, finalWidth * renderer.resolution, finalHeight * renderer.resolution);
	        }
	    };
	
	    /**
	     * Destroys the container
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	
	
	    ParticleContainer.prototype.destroy = function destroy(options) {
	        _core$Container.prototype.destroy.call(this, options);
	
	        if (this._buffers) {
	            for (var i = 0; i < this._buffers.length; ++i) {
	                this._buffers[i].destroy();
	            }
	        }
	
	        this._properties = null;
	        this._buffers = null;
	        this._bufferUpdateIDs = null;
	    };
	
	    _createClass(ParticleContainer, [{
	        key: 'tint',
	        get: function get() {
	            return this._tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._tint = value;
	            (0, _utils.hex2rgb)(value, this.tintRgb);
	        }
	    }]);
	
	    return ParticleContainer;
	}(core.Container);
	
	exports.default = ParticleContainer;
	//# sourceMappingURL=ParticleContainer.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ParticleContainer = __webpack_require__(271);
	
	Object.defineProperty(exports, 'ParticleContainer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ParticleContainer).default;
	  }
	});
	
	var _ParticleRenderer = __webpack_require__(274);
	
	Object.defineProperty(exports, 'ParticleRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ParticleRenderer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pixiGlCore = __webpack_require__(8);
	
	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
	
	var _createIndicesForQuads = __webpack_require__(67);
	
	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
	 * they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleBuffer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
	 */
	
	/**
	 * The particle buffer manages the static and dynamic buffers for a particle container.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var ParticleBuffer = function () {
	    /**
	     * @param {WebGLRenderingContext} gl - The rendering context.
	     * @param {object} properties - The properties to upload.
	     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
	     * @param {number} size - The size of the batch.
	     */
	    function ParticleBuffer(gl, properties, dynamicPropertyFlags, size) {
	        _classCallCheck(this, ParticleBuffer);
	
	        /**
	         * The current WebGL drawing context.
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = gl;
	
	        /**
	         * The number of particles the buffer can hold
	         *
	         * @member {number}
	         */
	        this.size = size;
	
	        /**
	         * A list of the properties that are dynamic.
	         *
	         * @member {object[]}
	         */
	        this.dynamicProperties = [];
	
	        /**
	         * A list of the properties that are static.
	         *
	         * @member {object[]}
	         */
	        this.staticProperties = [];
	
	        for (var i = 0; i < properties.length; ++i) {
	            var property = properties[i];
	
	            // Make copy of properties object so that when we edit the offset it doesn't
	            // change all other instances of the object literal
	            property = {
	                attribute: property.attribute,
	                size: property.size,
	                uploadFunction: property.uploadFunction,
	                unsignedByte: property.unsignedByte,
	                offset: property.offset
	            };
	
	            if (dynamicPropertyFlags[i]) {
	                this.dynamicProperties.push(property);
	            } else {
	                this.staticProperties.push(property);
	            }
	        }
	
	        this.staticStride = 0;
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;
	
	        this.dynamicStride = 0;
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;
	
	        this._updateID = 0;
	
	        this.initBuffers();
	    }
	
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	
	
	    ParticleBuffer.prototype.initBuffers = function initBuffers() {
	        var gl = this.gl;
	        var dynamicOffset = 0;
	
	        /**
	         * Holds the indices of the geometry (quads) to draw
	         *
	         * @member {Uint16Array}
	         */
	        this.indices = (0, _createIndicesForQuads2.default)(this.size);
	        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
	
	        this.dynamicStride = 0;
	
	        for (var i = 0; i < this.dynamicProperties.length; ++i) {
	            var property = this.dynamicProperties[i];
	
	            property.offset = dynamicOffset;
	            dynamicOffset += property.size;
	            this.dynamicStride += property.size;
	        }
	
	        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);
	
	        this.dynamicData = new Float32Array(dynBuffer);
	        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
	        this.dynamicBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, dynBuffer, gl.STREAM_DRAW);
	
	        // static //
	        var staticOffset = 0;
	
	        this.staticStride = 0;
	
	        for (var _i = 0; _i < this.staticProperties.length; ++_i) {
	            var _property = this.staticProperties[_i];
	
	            _property.offset = staticOffset;
	            staticOffset += _property.size;
	            this.staticStride += _property.size;
	        }
	
	        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 4 * 4);
	
	        this.staticData = new Float32Array(statBuffer);
	        this.staticDataUint32 = new Uint32Array(statBuffer);
	        this.staticBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, statBuffer, gl.STATIC_DRAW);
	
	        this.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(this.indexBuffer);
	
	        for (var _i2 = 0; _i2 < this.dynamicProperties.length; ++_i2) {
	            var _property2 = this.dynamicProperties[_i2];
	
	            if (_property2.unsignedByte) {
	                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.UNSIGNED_BYTE, true, this.dynamicStride * 4, _property2.offset * 4);
	            } else {
	                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.FLOAT, false, this.dynamicStride * 4, _property2.offset * 4);
	            }
	        }
	
	        for (var _i3 = 0; _i3 < this.staticProperties.length; ++_i3) {
	            var _property3 = this.staticProperties[_i3];
	
	            if (_property3.unsignedByte) {
	                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.UNSIGNED_BYTE, true, this.staticStride * 4, _property3.offset * 4);
	            } else {
	                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.FLOAT, false, this.staticStride * 4, _property3.offset * 4);
	            }
	        }
	    };
	
	    /**
	     * Uploads the dynamic properties.
	     *
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */
	
	
	    ParticleBuffer.prototype.uploadDynamic = function uploadDynamic(children, startIndex, amount) {
	        for (var i = 0; i < this.dynamicProperties.length; i++) {
	            var property = this.dynamicProperties[i];
	
	            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
	        }
	
	        this.dynamicBuffer.upload();
	    };
	
	    /**
	     * Uploads the static properties.
	     *
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */
	
	
	    ParticleBuffer.prototype.uploadStatic = function uploadStatic(children, startIndex, amount) {
	        for (var i = 0; i < this.staticProperties.length; i++) {
	            var property = this.staticProperties[i];
	
	            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
	        }
	
	        this.staticBuffer.upload();
	    };
	
	    /**
	     * Destroys the ParticleBuffer.
	     *
	     */
	
	
	    ParticleBuffer.prototype.destroy = function destroy() {
	        this.dynamicProperties = null;
	        this.dynamicBuffer.destroy();
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;
	
	        this.staticProperties = null;
	        this.staticBuffer.destroy();
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;
	    };
	
	    return ParticleBuffer;
	}();
	
	exports.default = ParticleBuffer;
	//# sourceMappingURL=ParticleBuffer.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _ParticleShader = __webpack_require__(275);
	
	var _ParticleShader2 = _interopRequireDefault(_ParticleShader);
	
	var _ParticleBuffer = __webpack_require__(273);
	
	var _ParticleBuffer2 = _interopRequireDefault(_ParticleBuffer);
	
	var _utils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
	 */
	
	/**
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var ParticleRenderer = function (_core$ObjectRenderer) {
	    _inherits(ParticleRenderer, _core$ObjectRenderer);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
	     */
	    function ParticleRenderer(renderer) {
	        _classCallCheck(this, ParticleRenderer);
	
	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        // and max number of element in the index buffer is 16384 * 6 = 98304
	        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
	        // let numIndices = 98304;
	
	        /**
	         * The default shader that is used if a sprite doesn't have a more specific one.
	         *
	         * @member {PIXI.Shader}
	         */
	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
	
	        _this.shader = null;
	
	        _this.indexBuffer = null;
	
	        _this.properties = null;
	
	        _this.tempMatrix = new core.Matrix();
	
	        _this.CONTEXT_UID = 0;
	        return _this;
	    }
	
	    /**
	     * When there is a WebGL context change
	     *
	     * @private
	     */
	
	
	    ParticleRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;
	
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	
	        // setup default shader
	        this.shader = new _ParticleShader2.default(gl);
	
	        this.properties = [
	        // verticesData
	        {
	            attribute: this.shader.attributes.aVertexPosition,
	            size: 2,
	            uploadFunction: this.uploadVertices,
	            offset: 0
	        },
	        // positionData
	        {
	            attribute: this.shader.attributes.aPositionCoord,
	            size: 2,
	            uploadFunction: this.uploadPosition,
	            offset: 0
	        },
	        // rotationData
	        {
	            attribute: this.shader.attributes.aRotation,
	            size: 1,
	            uploadFunction: this.uploadRotation,
	            offset: 0
	        },
	        // uvsData
	        {
	            attribute: this.shader.attributes.aTextureCoord,
	            size: 2,
	            uploadFunction: this.uploadUvs,
	            offset: 0
	        },
	        // tintData
	        {
	            attribute: this.shader.attributes.aColor,
	            size: 1,
	            unsignedByte: true,
	            uploadFunction: this.uploadTint,
	            offset: 0
	        }];
	    };
	
	    /**
	     * Starts a new particle batch.
	     *
	     */
	
	
	    ParticleRenderer.prototype.start = function start() {
	        this.renderer.bindShader(this.shader);
	    };
	
	    /**
	     * Renders the particle container object.
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     */
	
	
	    ParticleRenderer.prototype.render = function render(container) {
	        var children = container.children;
	        var maxSize = container._maxSize;
	        var batchSize = container._batchSize;
	        var renderer = this.renderer;
	        var totalChildren = children.length;
	
	        if (totalChildren === 0) {
	            return;
	        } else if (totalChildren > maxSize) {
	            totalChildren = maxSize;
	        }
	
	        var buffers = container._glBuffers[renderer.CONTEXT_UID];
	
	        if (!buffers) {
	            buffers = container._glBuffers[renderer.CONTEXT_UID] = this.generateBuffers(container);
	        }
	
	        var baseTexture = children[0]._texture.baseTexture;
	
	        // if the uvs have not updated then no point rendering just yet!
	        this.renderer.setBlendMode(core.utils.correctBlendMode(container.blendMode, baseTexture.premultipliedAlpha));
	
	        var gl = renderer.gl;
	
	        var m = container.worldTransform.copy(this.tempMatrix);
	
	        m.prepend(renderer._activeRenderTarget.projectionMatrix);
	
	        this.shader.uniforms.projectionMatrix = m.toArray(true);
	
	        this.shader.uniforms.uColor = core.utils.premultiplyRgba(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.premultipliedAlpha);
	
	        // make sure the texture is bound..
	        this.shader.uniforms.uSampler = renderer.bindTexture(baseTexture);
	
	        var updateStatic = false;
	
	        // now lets upload and render the buffers..
	        for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1) {
	            var amount = totalChildren - i;
	
	            if (amount > batchSize) {
	                amount = batchSize;
	            }
	
	            if (j >= buffers.length) {
	                if (!container.autoResize) {
	                    break;
	                }
	                buffers.push(this._generateOneMoreBuffer(container));
	            }
	
	            var buffer = buffers[j];
	
	            // we always upload the dynamic
	            buffer.uploadDynamic(children, i, amount);
	
	            var bid = container._bufferUpdateIDs[j] || 0;
	
	            updateStatic = updateStatic || buffer._updateID < bid;
	            // we only upload the static content when we have to!
	            if (updateStatic) {
	                buffer._updateID = container._updateID;
	                buffer.uploadStatic(children, i, amount);
	            }
	
	            // bind the buffer
	            renderer.bindVao(buffer.vao);
	            buffer.vao.draw(gl.TRIANGLES, amount * 6);
	        }
	    };
	
	    /**
	     * Creates one particle buffer for each child in the container we want to render and updates internal properties
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer[]} The buffers
	     */
	
	
	    ParticleRenderer.prototype.generateBuffers = function generateBuffers(container) {
	        var gl = this.renderer.gl;
	        var buffers = [];
	        var size = container._maxSize;
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;
	
	        for (var i = 0; i < size; i += batchSize) {
	            buffers.push(new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize));
	        }
	
	        return buffers;
	    };
	
	    /**
	     * Creates one more particle buffer, because container has autoResize feature
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer} generated buffer
	     * @private
	     */
	
	
	    ParticleRenderer.prototype._generateOneMoreBuffer = function _generateOneMoreBuffer(container) {
	        var gl = this.renderer.gl;
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;
	
	        return new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize);
	    };
	
	    /**
	     * Uploads the verticies.
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their vertices uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadVertices = function uploadVertices(children, startIndex, amount, array, stride, offset) {
	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;
	
	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var texture = sprite._texture;
	            var sx = sprite.scale.x;
	            var sy = sprite.scale.y;
	            var trim = texture.trim;
	            var orig = texture.orig;
	
	            if (trim) {
	                // if the sprite is trimmed and is not a tilingsprite then we need to add the
	                // extra space before transforming the sprite coords..
	                w1 = trim.x - sprite.anchor.x * orig.width;
	                w0 = w1 + trim.width;
	
	                h1 = trim.y - sprite.anchor.y * orig.height;
	                h0 = h1 + trim.height;
	            } else {
	                w0 = orig.width * (1 - sprite.anchor.x);
	                w1 = orig.width * -sprite.anchor.x;
	
	                h0 = orig.height * (1 - sprite.anchor.y);
	                h1 = orig.height * -sprite.anchor.y;
	            }
	
	            array[offset] = w1 * sx;
	            array[offset + 1] = h1 * sy;
	
	            array[offset + stride] = w0 * sx;
	            array[offset + stride + 1] = h1 * sy;
	
	            array[offset + stride * 2] = w0 * sx;
	            array[offset + stride * 2 + 1] = h0 * sy;
	
	            array[offset + stride * 3] = w1 * sx;
	            array[offset + stride * 3 + 1] = h0 * sy;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their positions uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadPosition = function uploadPosition(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spritePosition = children[startIndex + i].position;
	
	            array[offset] = spritePosition.x;
	            array[offset + 1] = spritePosition.y;
	
	            array[offset + stride] = spritePosition.x;
	            array[offset + stride + 1] = spritePosition.y;
	
	            array[offset + stride * 2] = spritePosition.x;
	            array[offset + stride * 2 + 1] = spritePosition.y;
	
	            array[offset + stride * 3] = spritePosition.x;
	            array[offset + stride * 3 + 1] = spritePosition.y;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadRotation = function uploadRotation(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spriteRotation = children[startIndex + i].rotation;
	
	            array[offset] = spriteRotation;
	            array[offset + stride] = spriteRotation;
	            array[offset + stride * 2] = spriteRotation;
	            array[offset + stride * 3] = spriteRotation;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadUvs = function uploadUvs(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var textureUvs = children[startIndex + i]._texture._uvs;
	
	            if (textureUvs) {
	                array[offset] = textureUvs.x0;
	                array[offset + 1] = textureUvs.y0;
	
	                array[offset + stride] = textureUvs.x1;
	                array[offset + stride + 1] = textureUvs.y1;
	
	                array[offset + stride * 2] = textureUvs.x2;
	                array[offset + stride * 2 + 1] = textureUvs.y2;
	
	                array[offset + stride * 3] = textureUvs.x3;
	                array[offset + stride * 3 + 1] = textureUvs.y3;
	
	                offset += stride * 4;
	            } else {
	                // TODO you know this can be easier!
	                array[offset] = 0;
	                array[offset + 1] = 0;
	
	                array[offset + stride] = 0;
	                array[offset + stride + 1] = 0;
	
	                array[offset + stride * 2] = 0;
	                array[offset + stride * 2 + 1] = 0;
	
	                array[offset + stride * 3] = 0;
	                array[offset + stride * 3 + 1] = 0;
	
	                offset += stride * 4;
	            }
	        }
	    };
	
	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	
	
	    ParticleRenderer.prototype.uploadTint = function uploadTint(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var premultiplied = sprite._texture.baseTexture.premultipliedAlpha;
	            var alpha = sprite.alpha;
	            // we dont call extra function if alpha is 1.0, that's faster
	            var argb = alpha < 1.0 && premultiplied ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);
	
	            array[offset] = argb;
	            array[offset + stride] = argb;
	            array[offset + stride * 2] = argb;
	            array[offset + stride * 3] = argb;
	
	            offset += stride * 4;
	        }
	    };
	
	    /**
	     * Destroys the ParticleRenderer.
	     *
	     */
	
	
	    ParticleRenderer.prototype.destroy = function destroy() {
	        if (this.renderer.gl) {
	            this.renderer.gl.deleteBuffer(this.indexBuffer);
	        }
	
	        _core$ObjectRenderer.prototype.destroy.call(this);
	
	        this.shader.destroy();
	
	        this.indices = null;
	        this.tempMatrix = null;
	    };
	
	    return ParticleRenderer;
	}(core.ObjectRenderer);
	
	exports.default = ParticleRenderer;
	
	
	core.WebGLRenderer.registerPlugin('particle', ParticleRenderer);
	//# sourceMappingURL=ParticleRenderer.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Shader2 = __webpack_require__(26);
	
	var _Shader3 = _interopRequireDefault(_Shader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @class
	 * @extends PIXI.Shader
	 * @memberof PIXI
	 */
	var ParticleShader = function (_Shader) {
	    _inherits(ParticleShader, _Shader);
	
	    /**
	     * @param {PIXI.Shader} gl - The webgl shader manager this shader works for.
	     */
	    function ParticleShader(gl) {
	        _classCallCheck(this, ParticleShader);
	
	        return _possibleConstructorReturn(this, _Shader.call(this, gl,
	        // vertex shader
	        ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'attribute vec4 aColor;', 'attribute vec2 aPositionCoord;', 'attribute float aRotation;', 'uniform mat3 projectionMatrix;', 'uniform vec4 uColor;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'void main(void){', '   float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);', '   float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);', '   vec2 v = vec2(x, y);', '   v = v + aPositionCoord;', '   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);', '   vTextureCoord = aTextureCoord;', '   vColor = aColor * uColor;', '}'].join('\n'),
	        // hello
	        ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'uniform sampler2D uSampler;', 'void main(void){', '  vec4 color = texture2D(uSampler, vTextureCoord) * vColor;', '  gl_FragColor = color;', '}'].join('\n')));
	    }
	
	    return ParticleShader;
	}(_Shader3.default);
	
	exports.default = ParticleShader;
	//# sourceMappingURL=ParticleShader.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	"use strict";
	
	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
	
	if (!Math.sign) {
	    Math.sign = function mathSign(x) {
	        x = Number(x);
	
	        if (x === 0 || isNaN(x)) {
	            return x;
	        }
	
	        return x > 0 ? 1 : -1;
	    };
	}
	//# sourceMappingURL=Math.sign.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
	
	if (!Number.isInteger) {
	    Number.isInteger = function numberIsInteger(value) {
	        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	    };
	}
	//# sourceMappingURL=Number.isInteger.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectAssign = __webpack_require__(161);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!Object.assign) {
	    Object.assign = _objectAssign2.default;
	} // References:
	// https://github.com/sindresorhus/object-assign
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	//# sourceMappingURL=Object.assign.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(278);
	
	__webpack_require__(280);
	
	__webpack_require__(276);
	
	__webpack_require__(277);
	
	if (!window.ArrayBuffer) {
	    window.ArrayBuffer = Array;
	}
	
	if (!window.Float32Array) {
	    window.Float32Array = Array;
	}
	
	if (!window.Uint32Array) {
	    window.Uint32Array = Array;
	}
	
	if (!window.Uint16Array) {
	    window.Uint16Array = Array;
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// References:
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// https://gist.github.com/1579671
	// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
	// https://gist.github.com/timhall/4078614
	// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
	
	// Expected to be used with Browserfiy
	// Browserify automatically detects the use of `global` and passes the
	// correct reference of `global`, `self`, and finally `window`
	
	var ONE_FRAME_TIME = 16;
	
	// Date.now
	if (!(Date.now && Date.prototype.getTime)) {
	    Date.now = function now() {
	        return new Date().getTime();
	    };
	}
	
	// performance.now
	if (!(global.performance && global.performance.now)) {
	    var startTime = Date.now();
	
	    if (!global.performance) {
	        global.performance = {};
	    }
	
	    global.performance.now = function () {
	        return Date.now() - startTime;
	    };
	}
	
	// requestAnimationFrame
	var lastTime = Date.now();
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	for (var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
	    var p = vendors[x];
	
	    global.requestAnimationFrame = global[p + 'RequestAnimationFrame'];
	    global.cancelAnimationFrame = global[p + 'CancelAnimationFrame'] || global[p + 'CancelRequestAnimationFrame'];
	}
	
	if (!global.requestAnimationFrame) {
	    global.requestAnimationFrame = function (callback) {
	        if (typeof callback !== 'function') {
	            throw new TypeError(callback + 'is not a function');
	        }
	
	        var currentTime = Date.now();
	        var delay = ONE_FRAME_TIME + lastTime - currentTime;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        lastTime = currentTime;
	
	        return setTimeout(function () {
	            lastTime = Date.now();
	            callback(performance.now());
	        }, delay);
	    };
	}
	
	if (!global.cancelAnimationFrame) {
	    global.cancelAnimationFrame = function (id) {
	        return clearTimeout(id);
	    };
	}
	//# sourceMappingURL=requestAnimationFrame.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _BasePrepare2 = __webpack_require__(68);
	
	var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CANVAS_START_SIZE = 16;
	
	/**
	 * The prepare manager provides functionality to upload content to the GPU
	 * This cannot be done directly for Canvas like in WebGL, but the effect can be achieved by drawing
	 * textures to an offline canvas.
	 * This draw call will force the texture to be moved onto the GPU.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
	 *
	 * @class
	 * @extends PIXI.prepare.BasePrepare
	 * @memberof PIXI.prepare
	 */
	
	var CanvasPrepare = function (_BasePrepare) {
	    _inherits(CanvasPrepare, _BasePrepare);
	
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasPrepare(renderer) {
	        _classCallCheck(this, CanvasPrepare);
	
	        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));
	
	        _this.uploadHookHelper = _this;
	
	        /**
	        * An offline canvas to render textures to
	        * @type {HTMLCanvasElement}
	        * @private
	        */
	        _this.canvas = document.createElement('canvas');
	        _this.canvas.width = CANVAS_START_SIZE;
	        _this.canvas.height = CANVAS_START_SIZE;
	
	        /**
	         * The context to the canvas
	        * @type {CanvasRenderingContext2D}
	        * @private
	        */
	        _this.ctx = _this.canvas.getContext('2d');
	
	        // Add textures to upload
	        _this.registerUploadHook(uploadBaseTextures);
	        return _this;
	    }
	
	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */
	
	
	    CanvasPrepare.prototype.destroy = function destroy() {
	        _BasePrepare.prototype.destroy.call(this);
	        this.ctx = null;
	        this.canvas = null;
	    };
	
	    return CanvasPrepare;
	}(_BasePrepare3.default);
	
	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {*} prepare - Instance of CanvasPrepare
	 * @param {*} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	
	
	exports.default = CanvasPrepare;
	function uploadBaseTextures(prepare, item) {
	    if (item instanceof core.BaseTexture) {
	        var image = item.source;
	
	        // Sometimes images (like atlas images) report a size of zero, causing errors on windows phone.
	        // So if the width or height is equal to zero then use the canvas size
	        // Otherwise use whatever is smaller, the image dimensions or the canvas dimensions.
	        var imageWidth = image.width === 0 ? prepare.canvas.width : Math.min(prepare.canvas.width, image.width);
	        var imageHeight = image.height === 0 ? prepare.canvas.height : Math.min(prepare.canvas.height, image.height);
	
	        // Only a small subsections is required to be drawn to have the whole texture uploaded to the GPU
	        // A smaller draw can be faster.
	        prepare.ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, prepare.canvas.width, prepare.canvas.height);
	
	        return true;
	    }
	
	    return false;
	}
	
	core.CanvasRenderer.registerPlugin('prepare', CanvasPrepare);
	//# sourceMappingURL=CanvasPrepare.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _WebGLPrepare = __webpack_require__(284);
	
	Object.defineProperty(exports, 'webgl', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLPrepare).default;
	  }
	});
	
	var _CanvasPrepare = __webpack_require__(281);
	
	Object.defineProperty(exports, 'canvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasPrepare).default;
	  }
	});
	
	var _BasePrepare = __webpack_require__(68);
	
	Object.defineProperty(exports, 'BasePrepare', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BasePrepare).default;
	  }
	});
	
	var _CountLimiter = __webpack_require__(136);
	
	Object.defineProperty(exports, 'CountLimiter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CountLimiter).default;
	  }
	});
	
	var _TimeLimiter = __webpack_require__(283);
	
	Object.defineProperty(exports, 'TimeLimiter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TimeLimiter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
	 * number of milliseconds per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TimeLimiter = function () {
	  /**
	   * @param {number} maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame.
	   */
	  function TimeLimiter(maxMilliseconds) {
	    _classCallCheck(this, TimeLimiter);
	
	    /**
	     * The maximum milliseconds that can be spent preparing items each frame.
	     * @private
	     */
	    this.maxMilliseconds = maxMilliseconds;
	    /**
	     * The start time of the current frame.
	     * @type {number}
	     * @private
	     */
	    this.frameStart = 0;
	  }
	
	  /**
	   * Resets any counting properties to start fresh on a new frame.
	   */
	
	
	  TimeLimiter.prototype.beginFrame = function beginFrame() {
	    this.frameStart = Date.now();
	  };
	
	  /**
	   * Checks to see if another item can be uploaded. This should only be called once per item.
	   * @return {boolean} If the item is allowed to be uploaded.
	   */
	
	
	  TimeLimiter.prototype.allowedToUpload = function allowedToUpload() {
	    return Date.now() - this.frameStart < this.maxMilliseconds;
	  };
	
	  return TimeLimiter;
	}();
	
	exports.default = TimeLimiter;
	//# sourceMappingURL=TimeLimiter.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _core = __webpack_require__(4);
	
	var core = _interopRequireWildcard(_core);
	
	var _BasePrepare2 = __webpack_require__(68);
	
	var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The prepare manager provides functionality to upload content to the GPU.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
	 *
	 * @class
	 * @extends PIXI.prepare.BasePrepare
	 * @memberof PIXI.prepare
	 */
	var WebGLPrepare = function (_BasePrepare) {
	    _inherits(WebGLPrepare, _BasePrepare);
	
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function WebGLPrepare(renderer) {
	        _classCallCheck(this, WebGLPrepare);
	
	        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));
	
	        _this.uploadHookHelper = _this.renderer;
	
	        // Add textures and graphics to upload
	        _this.registerFindHook(findGraphics);
	        _this.registerUploadHook(uploadBaseTextures);
	        _this.registerUploadHook(uploadGraphics);
	        return _this;
	    }
	
	    return WebGLPrepare;
	}(_BasePrepare3.default);
	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	
	
	exports.default = WebGLPrepare;
	function uploadBaseTextures(renderer, item) {
	    if (item instanceof core.BaseTexture) {
	        // if the texture already has a GL texture, then the texture has been prepared or rendered
	        // before now. If the texture changed, then the changer should be calling texture.update() which
	        // reuploads the texture without need for preparing it again
	        if (!item._glTextures[renderer.CONTEXT_UID]) {
	            renderer.textureManager.updateTexture(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to upload PIXI.Graphics to the GPU.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function uploadGraphics(renderer, item) {
	    if (item instanceof core.Graphics) {
	        // if the item is not dirty and already has webgl data, then it got prepared or rendered
	        // before now and we shouldn't waste time updating it again
	        if (item.dirty || item.clearDirty || !item._webGL[renderer.plugins.graphics.CONTEXT_UID]) {
	            renderer.plugins.graphics.updateGraphics(item);
	        }
	
	        return true;
	    }
	
	    return false;
	}
	
	/**
	 * Built-in hook to find graphics.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Graphics object was found.
	 */
	function findGraphics(item, queue) {
	    if (item instanceof core.Graphics) {
	        queue.push(item);
	
	        return true;
	    }
	
	    return false;
	}
	
	core.WebGLRenderer.registerPlugin('prepare', WebGLPrepare);
	//# sourceMappingURL=WebGLPrepare.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"object"==typeof navigator&&function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("Plyr",t):e.Plyr=t()}(this,function(){"use strict";"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var e,t,i=(function(e,t){var i;i=function(){var e=function(){},t={},i={},n={};function s(e,t){if(e){var s=n[e];if(i[e]=t,s)for(;s.length;)s[0](e,t),s.splice(0,1)}}function a(t,i){t.call&&(t={success:t}),i.length?(t.error||e)(i):(t.success||e)(t)}function r(t,i,n,s){var a,l,o=document,c=n.async,u=(n.numRetries||0)+1,d=n.before||e,p=t.replace(/^(css|img)!/,"");s=s||0,/(^css!|\.css$)/.test(t)?(a=!0,(l=o.createElement("link")).rel="stylesheet",l.href=p):/(^img!|\.(png|gif|jpg|svg)$)/.test(t)?(l=o.createElement("img")).src=p:((l=o.createElement("script")).src=t,l.async=void 0===c||c),l.onload=l.onerror=l.onbeforeload=function(e){var o=e.type[0];if(a&&"hideFocus"in l)try{l.sheet.cssText.length||(o="e")}catch(e){o="e"}if("e"==o&&(s+=1)<u)return r(t,i,n,s);i(t,o,e.defaultPrevented)},!1!==d(t,l)&&o.head.appendChild(l)}function l(e,i,n){var l,o;if(i&&i.trim&&(l=i),o=(l?n:i)||{},l){if(l in t)throw"LoadJS";t[l]=!0}!function(e,t,i){var n,s,a=(e=e.push?e:[e]).length,l=a,o=[];for(n=function(e,i,n){if("e"==i&&o.push(e),"b"==i){if(!n)return;o.push(e)}--a||t(o)},s=0;s<l;s++)r(e[s],n,i)}(e,function(e){a(o,e),s(l,e)},o)}return l.ready=function(e,t){return function(e,t){e=e.push?e:[e];var s,a,r,l=[],o=e.length,c=o;for(s=function(e,i){i.length&&l.push(e),--c||t(l)};o--;)a=e[o],(r=i[a])?s(a,r):(n[a]=n[a]||[]).push(s)}(e,function(e){a(t,e)}),l},l.done=function(e){s(e,[])},l.reset=function(){t={},i={},n={}},l.isDefined=function(e){return e in t},l},e.exports=i()}(e={exports:{}},e.exports),e.exports),n=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},s=function(){function e(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,i,n){return i&&e(t.prototype,i),n&&e(t,n),t}}(),a=function(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e},r=function(){return function(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return function(e,t){var i=[],n=!0,s=!1,a=void 0;try{for(var r,l=e[Symbol.iterator]();!(n=(r=l.next()).done)&&(i.push(r.value),!t||i.length!==t);n=!0);}catch(e){s=!0,a=e}finally{try{!n&&l.return&&l.return()}finally{if(s)throw a}}return i}(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),l=function(){function e(t){n(this,e),this.enabled=t.config.storage.enabled,this.key=t.config.storage.key}return s(e,[{key:"get",value:function(t){if(!e.supported||!this.enabled)return null;var i=window.localStorage.getItem(this.key);if(u.is.empty(i))return null;var n=JSON.parse(i);return u.is.string(t)&&t.length?n[t]:n}},{key:"set",value:function(t){if(e.supported&&this.enabled&&u.is.object(t)){var i=this.get();u.is.empty(i)&&(i={}),u.extend(i,t),window.localStorage.setItem(this.key,JSON.stringify(i))}}}],[{key:"supported",get:function(){try{if(!("localStorage"in window))return!1;return window.localStorage.setItem("___test","___test"),window.localStorage.removeItem("___test"),!0}catch(e){return!1}}}]),e}(),o={html5:"html5",youtube:"youtube",vimeo:"vimeo"},c={audio:"audio",video:"video"},u={is:{object:function(e){return this.getConstructor(e)===Object},number:function(e){return this.getConstructor(e)===Number&&!Number.isNaN(e)},string:function(e){return this.getConstructor(e)===String},boolean:function(e){return this.getConstructor(e)===Boolean},function:function(e){return this.getConstructor(e)===Function},array:function(e){return!this.nullOrUndefined(e)&&Array.isArray(e)},weakMap:function(e){return this.instanceof(e,WeakMap)},nodeList:function(e){return this.instanceof(e,NodeList)},element:function(e){return this.instanceof(e,Element)},textNode:function(e){return this.getConstructor(e)===Text},event:function(e){return this.instanceof(e,Event)},cue:function(e){return this.instanceof(e,window.TextTrackCue)||this.instanceof(e,window.VTTCue)},track:function(e){return this.instanceof(e,TextTrack)||!this.nullOrUndefined(e)&&this.string(e.kind)},url:function(e){return!this.nullOrUndefined(e)&&/(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/.test(e)},nullOrUndefined:function(e){return null==e},empty:function(e){return this.nullOrUndefined(e)||(this.string(e)||this.array(e)||this.nodeList(e))&&!e.length||this.object(e)&&!Object.keys(e).length},instanceof:function(e,t){return Boolean(e&&t&&e instanceof t)},getConstructor:function(e){return this.nullOrUndefined(e)?null:e.constructor}},getBrowser:function(){return{isIE:!!document.documentMode,isWebkit:"WebkitAppearance"in document.documentElement.style&&!/Edge/.test(navigator.userAgent),isIPhone:/(iPhone|iPod)/gi.test(navigator.platform),isIos:/(iPad|iPhone|iPod)/gi.test(navigator.platform)}},fetch:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"text";return new Promise(function(i,n){try{var s=new XMLHttpRequest;if(!("withCredentials"in s))return;s.addEventListener("load",function(){if("text"===t)try{i(JSON.parse(s.responseText))}catch(e){i(s.responseText)}else i(s.response)}),s.addEventListener("error",function(){throw new Error(s.statusText)}),s.open("GET",e,!0),s.responseType=t,s.send()}catch(e){n(e)}})},loadImage:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return new Promise(function(i,n){var s=new Image,a=function(){delete s.onload,delete s.onerror,(s.naturalWidth>=t?i:n)(s)};Object.assign(s,{onload:a,onerror:a,src:e})})},loadScript:function(e){return new Promise(function(t,n){i(e,{success:t,error:n})})},loadSprite:function(e,t){if(u.is.string(e)){var i=u.is.string(t),n=function(){return document.querySelectorAll("#"+t).length};if(!i||!n()){var s=l.supported,a=document.createElement("div");if(u.toggleHidden(a,!0),i&&a.setAttribute("id",t),s){var r=window.localStorage.getItem("cache-"+t);if(null!==r){var o=JSON.parse(r);return void c.call(a,o.content)}}u.fetch(e).then(function(e){u.is.empty(e)||(s&&window.localStorage.setItem("cache-"+t,JSON.stringify({content:e})),c.call(a,e))}).catch(function(){})}}function c(e){i&&n()||(this.innerHTML=e,document.body.insertBefore(this,document.body.childNodes[0]))}},generateId:function(e){return e+"-"+Math.floor(1e4*Math.random())},wrap:function(e,t){var i=e.length?e:[e];Array.from(i).reverse().forEach(function(e,i){var n=i>0?t.cloneNode(!0):t,s=e.parentNode,a=e.nextSibling;n.appendChild(e),a?s.insertBefore(n,a):s.appendChild(n)})},createElement:function(e,t,i){var n=document.createElement(e);return u.is.object(t)&&u.setAttributes(n,t),u.is.string(i)&&(n.innerText=i),n},insertAfter:function(e,t){t.parentNode.insertBefore(e,t.nextSibling)},insertElement:function(e,t,i,n){t.appendChild(u.createElement(e,i,n))},removeElement:function(e){u.is.nodeList(e)||u.is.array(e)?Array.from(e).forEach(u.removeElement):u.is.element(e)&&u.is.element(e.parentNode)&&e.parentNode.removeChild(e)},emptyElement:function(e){for(var t=e.childNodes.length;t>0;)e.removeChild(e.lastChild),t-=1},replaceElement:function(e,t){return u.is.element(t)&&u.is.element(t.parentNode)&&u.is.element(e)?(t.parentNode.replaceChild(e,t),e):null},setAttributes:function(e,t){u.is.element(e)&&!u.is.empty(t)&&Object.entries(t).forEach(function(t){var i=r(t,2),n=i[0],s=i[1];e.setAttribute(n,s)})},getAttributesFromSelector:function(e,t){if(!u.is.string(e)||u.is.empty(e))return{};var i={},n=t;return e.split(",").forEach(function(e){var t=e.trim(),s=t.replace(".",""),a=t.replace(/[[\]]/g,"").split("="),r=a[0],l=a.length>1?a[1].replace(/["']/g,""):"";switch(t.charAt(0)){case".":u.is.object(n)&&u.is.string(n.class)&&(n.class+=" "+s),i.class=s;break;case"#":i.id=t.replace("#","");break;case"[":i[r]=l}}),i},toggleHidden:function(e,t){if(u.is.element(e)){var i=t;u.is.boolean(i)||(i=!e.hasAttribute("hidden")),i?e.setAttribute("hidden",""):e.removeAttribute("hidden")}},toggleClass:function(e,t,i){if(u.is.element(e)){var n="toggle";return void 0!==i&&(n=i?"add":"remove"),e.classList[n](t),e.classList.contains(t)}return null},hasClass:function(e,t){return u.is.element(e)&&e.classList.contains(t)},matches:function(e,t){var i={Element:Element};var n=i.matches||i.webkitMatchesSelector||i.mozMatchesSelector||i.msMatchesSelector||function(){return Array.from(document.querySelectorAll(t)).includes(this)};return n.call(e,t)},getElements:function(e){return this.elements.container.querySelectorAll(e)},getElement:function(e){return this.elements.container.querySelector(e)},getFocusElement:function(){var e=document.activeElement;return e=e&&e!==document.body?document.querySelector(":focus"):null},trapFocus:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(u.is.element(e)){var i=u.getElements.call(this,"button:not(:disabled), input:not(:disabled), [tabindex]"),n=i[0],s=i[i.length-1],a=function(e){if("Tab"===e.key&&9===e.keyCode){var t=u.getFocusElement();t!==s||e.shiftKey?t===n&&e.shiftKey&&(s.focus(),e.preventDefault()):(n.focus(),e.preventDefault())}};t?u.on(this.elements.container,"keydown",a,!1):u.off(this.elements.container,"keydown",a,!1)}},toggleListener:function(e,t,i){var n=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],a=arguments.length>5&&void 0!==arguments[5]&&arguments[5];if(!u.is.empty(e)&&!u.is.empty(t)&&u.is.function(i))if(u.is.nodeList(e)||u.is.array(e))Array.from(e).forEach(function(e){e instanceof Node&&u.toggleListener.call(null,e,t,i,n,s,a)});else{var r=t.split(" "),l=a;d.passiveListeners&&(l={passive:s,capture:a}),r.forEach(function(t){e[n?"addEventListener":"removeEventListener"](t,i,l)})}},on:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments[2],n=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];u.toggleListener(e,t,i,!0,n,s)},off:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments[2],n=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];u.toggleListener(e,t,i,!1,n,s)},dispatchEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};if(u.is.element(e)&&!u.is.empty(t)){var s=new CustomEvent(t,{bubbles:i,detail:Object.assign({},n,{plyr:this})});e.dispatchEvent(s)}},toggleState:function(e,t){if(u.is.array(e)||u.is.nodeList(e))Array.from(e).forEach(function(e){return u.toggleState(e,t)});else if(u.is.element(e)){var i="true"===e.getAttribute("aria-pressed"),n=u.is.boolean(t)?t:!i;e.setAttribute("aria-pressed",n)}},format:function(e){for(var t=arguments.length,i=Array(t>1?t-1:0),n=1;n<t;n++)i[n-1]=arguments[n];return u.is.empty(e)?e:e.toString().replace(/{(\d+)}/g,function(e,t){return u.is.string(i[t])?i[t]:""})},getPercentage:function(e,t){return 0===e||0===t||Number.isNaN(e)||Number.isNaN(t)?0:(e/t*100).toFixed(2)},getHours:function(e){return parseInt(e/60/60%60,10)},getMinutes:function(e){return parseInt(e/60%60,10)},getSeconds:function(e){return parseInt(e%60,10)},formatTime:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!u.is.number(e))return this.formatTime(null,t,i);var n=function(e){return("0"+e).slice(-2)},s=this.getHours(e),a=this.getMinutes(e),r=this.getSeconds(e);return t||s>0?s+=":":s="",(i?"-":"")+s+n(a)+":"+n(r)},replaceAll:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";return e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g,"\\$1"),"g"),i.toString())},toTitleCase:function(){return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString().replace(/\w\S*/g,function(e){return e.charAt(0).toUpperCase()+e.substr(1).toLowerCase()})},toPascalCase:function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return e=u.replaceAll(e,"-"," "),e=u.replaceAll(e,"_"," "),e=u.toTitleCase(e),u.replaceAll(e," ","")},toCamelCase:function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return(e=u.toPascalCase(e)).charAt(0).toLowerCase()+e.slice(1)},extend:function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length,i=Array(t>1?t-1:0),n=1;n<t;n++)i[n-1]=arguments[n];if(!i.length)return e;var s=i.shift();return u.is.object(s)?(Object.keys(s).forEach(function(t){u.is.object(s[t])?(Object.keys(e).includes(t)||Object.assign(e,a({},t,{})),u.extend(e[t],s[t])):Object.assign(e,a({},t,s[t]))}),u.extend.apply(u,[e].concat(function(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++)i[t]=e[t];return i}return Array.from(e)}(i)))):e},dedupe:function(e){return u.is.array(e)?e.filter(function(t,i){return e.indexOf(t)===i}):e},cloneDeep:function(e){return JSON.parse(JSON.stringify(e))},closest:function(e,t){return u.is.array(e)&&e.length?e.reduce(function(e,i){return Math.abs(i-t)<Math.abs(e-t)?i:e}):null},getProviderByUrl:function(e){return/^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/.test(e)?o.youtube:/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e)?o.vimeo:null},parseYouTubeId:function(e){if(u.is.empty(e))return null;return e.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/)?RegExp.$2:e},parseVimeoId:function(e){if(u.is.empty(e))return null;if(u.is.number(Number(e)))return e;return e.match(/^.*(vimeo.com\/|video\/)(\d+).*/)?RegExp.$2:e},parseUrl:function(e){var t=document.createElement("a");return t.href=e,t},getUrlParams:function(e){var t=e;(e.startsWith("http://")||e.startsWith("https://"))&&(t=this.parseUrl(e).search);return this.is.empty(t)?null:t.slice(t.indexOf("?")+1).split("&").reduce(function(e,t){var i=t.split("="),n=r(i,2),s=n[0],l=n[1];return Object.assign(e,a({},s,decodeURIComponent(l)))},{})},buildUrlParams:function(e){return u.is.object(e)?Object.keys(e).map(function(t){return encodeURIComponent(t)+"="+encodeURIComponent(e[t])}).join("&"):""},stripHTML:function(e){var t=document.createDocumentFragment(),i=document.createElement("div");return t.appendChild(i),i.innerHTML=e,t.firstChild.innerText},getAspectRatio:function(e,t){var i=function e(t,i){return 0===i?t:e(i,t%i)}(e,t);return e/i+":"+t/i},get transitionEndEvent(){var e=document.createElement("span"),t={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"},i=Object.keys(t).find(function(t){return void 0!==e.style[t]});return!!u.is.string(i)&&t[i]},repaint:function(e){setTimeout(function(){u.toggleHidden(e,!0),e.offsetHeight,u.toggleHidden(e,!1)},0)}},d={audio:"canPlayType"in document.createElement("audio"),video:"canPlayType"in document.createElement("video"),check:function(e,t,i){var n=!1,s=!1,a=u.getBrowser(),r=a.isIPhone&&i&&d.playsinline;switch(t+":"+e){case"html5:video":s=(n=d.video)&&d.rangeInput&&(!a.isIPhone||r);break;case"html5:audio":s=(n=d.audio)&&d.rangeInput;break;case"youtube:video":case"vimeo:video":n=!0,s=d.rangeInput&&(!a.isIPhone||r);break;default:s=(n=d.audio&&d.video)&&d.rangeInput}return{api:n,ui:s}},pip:!u.getBrowser().isIPhone&&u.is.function(u.createElement("video").webkitSetPresentationMode),airplay:u.is.function(window.WebKitPlaybackTargetAvailabilityEvent),playsinline:"playsInline"in document.createElement("video"),mime:function(e){var t=this.media;try{if(!this.isHTML5||!u.is.function(t.canPlayType))return!1;if(e.includes("codecs="))return t.canPlayType(e).replace(/no/,"");if(this.isVideo)switch(e){case"video/webm":return t.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/no/,"");case"video/mp4":return t.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"').replace(/no/,"");case"video/ogg":return t.canPlayType('video/ogg; codecs="theora"').replace(/no/,"");default:return!1}else if(this.isAudio)switch(e){case"audio/mpeg":return t.canPlayType("audio/mpeg;").replace(/no/,"");case"audio/ogg":return t.canPlayType('audio/ogg; codecs="vorbis"').replace(/no/,"");case"audio/wav":return t.canPlayType('audio/wav; codecs="1"').replace(/no/,"");default:return!1}}catch(e){return!1}return!1},textTracks:"textTracks"in document.createElement("video"),passiveListeners:function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){return e=!0,null}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}(),rangeInput:(t=document.createElement("input"),t.type="range","range"===t.type),touch:"ontouchstart"in document.documentElement,transitions:!1!==u.transitionEndEvent,reducedMotion:"matchMedia"in window&&window.matchMedia("(prefers-reduced-motion)").matches},p={getSources:function(){return this.isHTML5?this.media.querySelectorAll("source"):null},getQualityOptions:function(){if(!this.isHTML5)return null;var e=p.getSources.call(this);if(u.is.empty(e))return null;var t=Array.from(e).filter(function(e){return!u.is.empty(e.getAttribute("size"))});return u.is.empty(t)?null:u.dedupe(t.map(function(e){return Number(e.getAttribute("size"))}))},extend:function(){if(this.isHTML5){var e=this;Object.defineProperty(e.media,"quality",{get:function(){var t=p.getSources.call(e);if(u.is.empty(t))return null;var i=Array.from(t).filter(function(t){return t.getAttribute("src")===e.source});return u.is.empty(i)?null:Number(i[0].getAttribute("size"))},set:function(t){var i=p.getSources.call(e);if(!u.is.empty(i)){var n=Array.from(i).filter(function(e){return Number(e.getAttribute("size"))===t});if(!u.is.empty(n)){var s=n.filter(function(t){return d.mime.call(e,t.getAttribute("type"))});if(!u.is.empty(s)){u.dispatchEvent.call(e,e.media,"qualityrequested",!1,{quality:t});var a=e.currentTime,r=e.playing;e.media.src=s[0].getAttribute("src"),e.media.load(),r&&e.play(),e.currentTime=a,u.dispatchEvent.call(e,e.media,"qualitychange",!1,{quality:t})}}}}})}},cancelRequests:function(){this.isHTML5&&(u.removeElement(p.getSources()),this.media.setAttribute("src",this.config.blankVideo),this.media.load(),this.debug.log("Cancelled network requests"))}},h=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(u.is.empty(e)||u.is.empty(t)||!Object.keys(t.i18n).includes(e))return"";var i=t.i18n[e],n={"{seektime}":t.seekTime,"{title}":t.title};return Object.entries(n).forEach(function(e){var t=r(e,2),n=t[0],s=t[1];i=u.replaceAll(i,n,s)}),i},m=u.getBrowser(),g={getIconUrl:function(){var e=new URL(this.config.iconUrl,window.location).host!==window.location.host||m.isIE&&!window.svg4everybody;return{url:this.config.iconUrl,cors:e}},findElements:function(){try{return this.elements.controls=u.getElement.call(this,this.config.selectors.controls.wrapper),this.elements.buttons={play:u.getElements.call(this,this.config.selectors.buttons.play),pause:u.getElement.call(this,this.config.selectors.buttons.pause),restart:u.getElement.call(this,this.config.selectors.buttons.restart),rewind:u.getElement.call(this,this.config.selectors.buttons.rewind),fastForward:u.getElement.call(this,this.config.selectors.buttons.fastForward),mute:u.getElement.call(this,this.config.selectors.buttons.mute),pip:u.getElement.call(this,this.config.selectors.buttons.pip),airplay:u.getElement.call(this,this.config.selectors.buttons.airplay),settings:u.getElement.call(this,this.config.selectors.buttons.settings),captions:u.getElement.call(this,this.config.selectors.buttons.captions),fullscreen:u.getElement.call(this,this.config.selectors.buttons.fullscreen)},this.elements.progress=u.getElement.call(this,this.config.selectors.progress),this.elements.inputs={seek:u.getElement.call(this,this.config.selectors.inputs.seek),volume:u.getElement.call(this,this.config.selectors.inputs.volume)},this.elements.display={buffer:u.getElement.call(this,this.config.selectors.display.buffer),currentTime:u.getElement.call(this,this.config.selectors.display.currentTime),duration:u.getElement.call(this,this.config.selectors.display.duration)},u.is.element(this.elements.progress)&&(this.elements.display.seekTooltip=this.elements.progress.querySelector("."+this.config.classNames.tooltip)),!0}catch(e){return this.debug.warn("It looks like there is a problem with your custom controls HTML",e),this.toggleNativeControls(!0),!1}},createIcon:function(e,t){var i=g.getIconUrl.call(this),n=(i.cors?"":i.url)+"#"+this.config.iconPrefix,s=document.createElementNS("http://www.w3.org/2000/svg","svg");u.setAttributes(s,u.extend(t,{role:"presentation",focusable:"false"}));var a=document.createElementNS("http://www.w3.org/2000/svg","use"),r=n+"-"+e;return"href"in a?a.setAttributeNS("http://www.w3.org/1999/xlink","href",r):a.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href",r),s.appendChild(a),s},createLabel:function(e,t){var i=h(e,this.config),n=Object.assign({},t);switch(e){case"pip":i="PIP";break;case"airplay":i="AirPlay"}return"class"in n?n.class+=" "+this.config.classNames.hidden:n.class=this.config.classNames.hidden,u.createElement("span",n,i)},createBadge:function(e){if(u.is.empty(e))return null;var t=u.createElement("span",{class:this.config.classNames.menu.value});return t.appendChild(u.createElement("span",{class:this.config.classNames.menu.badge},e)),t},createButton:function(e,t){var i=u.createElement("button"),n=Object.assign({},t),s=u.toCamelCase(e),a=!1,r=void 0,l=void 0,o=void 0,c=void 0;switch("type"in n||(n.type="button"),"class"in n?n.class.includes(this.config.classNames.control)&&(n.class+=" "+this.config.classNames.control):n.class=this.config.classNames.control,e){case"play":a=!0,r="play",o="pause",l="play",c="pause";break;case"mute":a=!0,r="mute",o="unmute",l="volume",c="muted";break;case"captions":a=!0,r="enableCaptions",o="disableCaptions",l="captions-off",c="captions-on";break;case"fullscreen":a=!0,r="enterFullscreen",o="exitFullscreen",l="enter-fullscreen",c="exit-fullscreen";break;case"play-large":n.class+=" "+this.config.classNames.control+"--overlaid",s="play",r="play",l="play";break;default:r=s,l=e}return a?(i.appendChild(g.createIcon.call(this,c,{class:"icon--pressed"})),i.appendChild(g.createIcon.call(this,l,{class:"icon--not-pressed"})),i.appendChild(g.createLabel.call(this,o,{class:"label--pressed"})),i.appendChild(g.createLabel.call(this,r,{class:"label--not-pressed"})),n["aria-pressed"]=!1):(i.appendChild(g.createIcon.call(this,l)),i.appendChild(g.createLabel.call(this,r))),u.extend(n,u.getAttributesFromSelector(this.config.selectors.buttons[s],n)),u.setAttributes(i,n),"play"===s?(u.is.array(this.elements.buttons[s])||(this.elements.buttons[s]=[]),this.elements.buttons[s].push(i)):this.elements.buttons[s]=i,i},createRange:function(e,t){var i=u.createElement("label",{for:t.id,id:t.id+"-label",class:this.config.classNames.hidden},h(e,this.config)),n=u.createElement("input",u.extend(u.getAttributesFromSelector(this.config.selectors.inputs[e]),{type:"range",min:0,max:100,step:.01,value:0,autocomplete:"off",role:"slider","aria-labelledby":t.id+"-label","aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":0},t));return this.elements.inputs[e]=n,g.updateRangeFill.call(this,n),{label:i,input:n}},createProgress:function(e,t){var i=u.createElement("progress",u.extend(u.getAttributesFromSelector(this.config.selectors.display[e]),{min:0,max:100,value:0,role:"presentation","aria-hidden":!0},t));if("volume"!==e){i.appendChild(u.createElement("span",null,"0"));var n="";switch(e){case"played":n=h("played",this.config);break;case"buffer":n=h("buffered",this.config)}i.innerText="% "+n.toLowerCase()}return this.elements.display[e]=i,i},createTime:function(e){var t=u.getAttributesFromSelector(this.config.selectors.display[e]),i=u.createElement("div",u.extend(t,{class:"plyr__time "+t.class,"aria-label":h(e,this.config)}),"00:00");return this.elements.display[e]=i,i},createMenuItem:function(e,t,i,n){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:null,a=arguments.length>5&&void 0!==arguments[5]&&arguments[5],r=u.createElement("li"),l=u.createElement("label",{class:this.config.classNames.control}),o=u.createElement("input",u.extend(u.getAttributesFromSelector(this.config.selectors.inputs[i]),{type:"radio",name:"plyr-"+i,value:e,checked:a,class:"plyr__sr-only"})),c=u.createElement("span",{hidden:""});l.appendChild(o),l.appendChild(c),l.insertAdjacentHTML("beforeend",n),u.is.element(s)&&l.appendChild(s),r.appendChild(l),t.appendChild(r)},updateTimeDisplay:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(u.is.element(e)&&u.is.number(t)){var n=u.getHours(this.duration)>0;e.innerText=u.formatTime(t,n,i)}},updateVolume:function(){this.supported.ui&&(u.is.element(this.elements.inputs.volume)&&g.setRange.call(this,this.elements.inputs.volume,this.muted?0:this.volume),u.is.element(this.elements.buttons.mute)&&u.toggleState(this.elements.buttons.mute,this.muted||0===this.volume))},setRange:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;u.is.element(e)&&(e.value=t,g.updateRangeFill.call(this,e))},updateProgress:function(e){var t=this;if(this.supported.ui&&u.is.event(e)){var i=0;if(e)switch(e.type){case"timeupdate":case"seeking":case"seeked":i=u.getPercentage(this.currentTime,this.duration),"timeupdate"===e.type&&g.setRange.call(this,this.elements.inputs.seek,i);break;case"playing":case"progress":!function(e,i){var n=u.is.number(i)?i:0,s=u.is.element(e)?e:t.elements.display.buffer;if(u.is.element(s)){s.value=n;var a=s.getElementsByTagName("span")[0];u.is.element(a)&&(a.childNodes[0].nodeValue=n)}}(this.elements.display.buffer,100*this.buffered)}}},updateRangeFill:function(e){var t=u.is.event(e)?e.target:e;u.is.element(t)&&"range"===t.getAttribute("type")&&(t.setAttribute("aria-valuenow",t.value),m.isWebkit&&t.style.setProperty("--value",t.value/t.max*100+"%"))},updateSeekTooltip:function(e){var t=this;if(this.config.tooltips.seek&&u.is.element(this.elements.inputs.seek)&&u.is.element(this.elements.display.seekTooltip)&&0!==this.duration){var i=0,n=this.elements.progress.getBoundingClientRect(),s=this.config.classNames.tooltip+"--visible",a=function(e){u.toggleClass(t.elements.display.seekTooltip,s,e)};if(this.touch)a(!1);else{if(u.is.event(e))i=100/n.width*(e.pageX-n.left);else{if(!u.hasClass(this.elements.display.seekTooltip,s))return;i=parseFloat(this.elements.display.seekTooltip.style.left,10)}i<0?i=0:i>100&&(i=100),g.updateTimeDisplay.call(this,this.elements.display.seekTooltip,this.duration/100*i),this.elements.display.seekTooltip.style.left=i+"%",u.is.event(e)&&["mouseenter","mouseleave"].includes(e.type)&&a("mouseenter"===e.type)}}},timeUpdate:function(e){var t=!u.is.element(this.elements.display.duration)&&this.config.invertTime;g.updateTimeDisplay.call(this,this.elements.display.currentTime,t?this.duration-this.currentTime:this.currentTime,t),e&&"timeupdate"===e.type&&this.media.seeking||g.updateProgress.call(this,e)},durationUpdate:function(){if(this.supported.ui&&(this.config.invertTime||!this.currentTime)){var e=u.is.element(this.elements.display.duration);!e&&this.config.displayDuration&&this.paused&&g.updateTimeDisplay.call(this,this.elements.display.currentTime,this.duration),e&&g.updateTimeDisplay.call(this,this.elements.display.duration,this.duration),g.updateSeekTooltip.call(this)}},toggleTab:function(e,t){u.toggleHidden(this.elements.settings.tabs[e],!t)},setQualityMenu:function(e){var t=this;if(u.is.element(this.elements.settings.panes.quality)){var i=this.elements.settings.panes.quality.querySelector("ul");u.is.array(e)&&(this.options.quality=e.filter(function(e){return t.config.quality.options.includes(e)}));var n=!u.is.empty(this.options.quality)&&this.options.quality.length>1;if(g.toggleTab.call(this,"quality",n),g.checkMenu.call(this),n){u.emptyElement(i);this.options.quality.sort(function(e,i){var n=t.config.quality.options;return n.indexOf(e)>n.indexOf(i)?1:-1}).forEach(function(e){var n=g.getLabel.call(t,"quality",e);g.createMenuItem.call(t,e,i,"quality",n,function(e){var i="";switch(e){case 2160:i="4K";break;case 1440:case 1080:case 720:i="HD";break;case 576:case 480:i="SD"}return i.length?g.createBadge.call(t,i):null}(e))}),g.updateSetting.call(this,"quality",i)}}},getLabel:function(e,t){switch(e){case"speed":return 1===t?h("normal",this.config):t+"&times;";case"quality":return u.is.number(t)?t+"p":u.toTitleCase(t);case"captions":return f.getLabel.call(this);default:return null}},updateSetting:function(e,t,i){var n=this.elements.settings.panes[e],s=null,a=t;switch(e){case"captions":s=this.captions.active?this.options.captions.length>2||!this.options.captions.some(function(e){return"enabled"===e})?this.captions.language:"enabled":"";break;default:if(s=u.is.empty(i)?this[e]:i,u.is.empty(s)&&(s=this.config[e].default),!u.is.empty(this.options[e])&&!this.options[e].includes(s))return void this.debug.warn("Unsupported value of '"+s+"' for "+e);if(!this.config[e].options.includes(s))return void this.debug.warn("Disabled value of '"+s+"' for "+e)}if(u.is.element(a)||(a=n&&n.querySelector("ul")),u.is.element(a)){this.elements.settings.tabs[e].querySelector("."+this.config.classNames.menu.value).innerHTML=g.getLabel.call(this,e,s);var r=a&&a.querySelector('input[value="'+s+'"]');u.is.element(r)&&(r.checked=!0)}},setCaptionsMenu:function(){var e=this,t=this.elements.settings.panes.captions.querySelector("ul"),i=f.getTracks.call(this).length;if(g.toggleTab.call(this,"captions",i),u.emptyElement(t),g.checkMenu.call(this),i){var n=f.getTracks.call(this).map(function(t){return{language:u.is.empty(t.language)?"enabled":t.language,label:f.getLabel.call(e,t)}});n.unshift({language:"",label:h("disabled",this.config)}),n.forEach(function(i){g.createMenuItem.call(e,i.language,t,"language",i.label,"enabled"!==i.language?g.createBadge.call(e,i.language.toUpperCase()):null,i.language.toLowerCase()===e.captions.language.toLowerCase())}),this.options.captions=n.map(function(e){return e.language}),g.updateSetting.call(this,"captions",t)}},setSpeedMenu:function(e){var t=this;if(this.config.controls.includes("settings")&&this.config.settings.includes("speed")&&u.is.element(this.elements.settings.panes.speed)){u.is.array(e)?this.options.speed=e:(this.isHTML5||this.isVimeo)&&(this.options.speed=[.5,.75,1,1.25,1.5,1.75,2]),this.options.speed=this.options.speed.filter(function(e){return t.config.speed.options.includes(e)});var i=!u.is.empty(this.options.speed)&&this.options.speed.length>1;if(g.toggleTab.call(this,"speed",i),g.checkMenu.call(this),i){var n=this.elements.settings.panes.speed.querySelector("ul");u.emptyElement(n),this.options.speed.forEach(function(e){var i=g.getLabel.call(t,"speed",e);g.createMenuItem.call(t,e,n,"speed",i)}),g.updateSetting.call(this,"speed",n)}}},checkMenu:function(){var e=this.elements.settings.tabs,t=!u.is.empty(e)&&Object.values(e).some(function(e){return!e.hidden});u.toggleHidden(this.elements.settings.menu,!t)},toggleMenu:function(e){var t=this.elements.settings.form,i=this.elements.buttons.settings;if(u.is.element(t)&&u.is.element(i)){var n=u.is.boolean(e)?e:u.is.element(t)&&t.hasAttribute("hidden");if(u.is.event(e)){var s=u.is.element(t)&&t.contains(e.target),a=e.target===this.elements.buttons.settings;if(s||!s&&!a&&n)return;a&&e.stopPropagation()}u.is.element(i)&&i.setAttribute("aria-expanded",n),u.is.element(t)&&(u.toggleHidden(t,!n),u.toggleClass(this.elements.container,this.config.classNames.menu.open,n),n?t.removeAttribute("tabindex"):t.setAttribute("tabindex",-1))}},getTabSize:function(e){var t=e.cloneNode(!0);t.style.position="absolute",t.style.opacity=0,t.removeAttribute("hidden"),Array.from(t.querySelectorAll("input[name]")).forEach(function(e){var t=e.getAttribute("name");e.setAttribute("name",t+"-clone")}),e.parentNode.appendChild(t);var i=t.scrollWidth,n=t.scrollHeight;return u.removeElement(t),{width:i,height:n}},showTab:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=this.elements.settings.menu,i=document.getElementById(e);if(u.is.element(i)&&"tabpanel"===i.getAttribute("role")){var n=t.querySelector('[role="tabpanel"]:not([hidden])'),s=n.parentNode;if(Array.from(t.querySelectorAll('[aria-controls="'+n.getAttribute("id")+'"]')).forEach(function(e){e.setAttribute("aria-expanded",!1)}),d.transitions&&!d.reducedMotion){s.style.width=n.scrollWidth+"px",s.style.height=n.scrollHeight+"px";var a=g.getTabSize.call(this,i);u.on(s,u.transitionEndEvent,function e(t){t.target===s&&["width","height"].includes(t.propertyName)&&(s.style.width="",s.style.height="",u.off(s,u.transitionEndEvent,e))}),s.style.width=a.width+"px",s.style.height=a.height+"px"}u.toggleHidden(n,!0),n.setAttribute("tabindex",-1),u.toggleHidden(i,!1);var r=u.getElements.call(this,'[aria-controls="'+e+'"]');Array.from(r).forEach(function(e){e.setAttribute("aria-expanded",!0)}),i.removeAttribute("tabindex"),i.querySelectorAll("button:not(:disabled), input:not(:disabled), [tabindex]")[0].focus()}},create:function(e){var t=this;if(u.is.empty(this.config.controls))return null;var i=u.createElement("div",u.getAttributesFromSelector(this.config.selectors.controls.wrapper));if(this.config.controls.includes("restart")&&i.appendChild(g.createButton.call(this,"restart")),this.config.controls.includes("rewind")&&i.appendChild(g.createButton.call(this,"rewind")),this.config.controls.includes("play")&&i.appendChild(g.createButton.call(this,"play")),this.config.controls.includes("fast-forward")&&i.appendChild(g.createButton.call(this,"fast-forward")),this.config.controls.includes("progress")){var n=u.createElement("div",u.getAttributesFromSelector(this.config.selectors.progress)),s=g.createRange.call(this,"seek",{id:"plyr-seek-"+e.id});if(n.appendChild(s.label),n.appendChild(s.input),n.appendChild(g.createProgress.call(this,"buffer")),this.config.tooltips.seek){var a=u.createElement("span",{class:this.config.classNames.tooltip},"00:00");n.appendChild(a),this.elements.display.seekTooltip=a}this.elements.progress=n,i.appendChild(this.elements.progress)}if(this.config.controls.includes("current-time")&&i.appendChild(g.createTime.call(this,"currentTime")),this.config.controls.includes("duration")&&i.appendChild(g.createTime.call(this,"duration")),this.config.controls.includes("mute")&&i.appendChild(g.createButton.call(this,"mute")),this.config.controls.includes("volume")){var r=u.createElement("div",{class:"plyr__volume"}),l={max:1,step:.05,value:this.config.volume},o=g.createRange.call(this,"volume",u.extend(l,{id:"plyr-volume-"+e.id}));r.appendChild(o.label),r.appendChild(o.input),this.elements.volume=r,i.appendChild(r)}if(this.config.controls.includes("captions")&&i.appendChild(g.createButton.call(this,"captions")),this.config.controls.includes("settings")&&!u.is.empty(this.config.settings)){var c=u.createElement("div",{class:"plyr__menu",hidden:""});c.appendChild(g.createButton.call(this,"settings",{id:"plyr-settings-toggle-"+e.id,"aria-haspopup":!0,"aria-controls":"plyr-settings-"+e.id,"aria-expanded":!1}));var m=u.createElement("form",{class:"plyr__menu__container",id:"plyr-settings-"+e.id,hidden:"","aria-labelled-by":"plyr-settings-toggle-"+e.id,role:"tablist",tabindex:-1}),f=u.createElement("div"),y=u.createElement("div",{id:"plyr-settings-"+e.id+"-home","aria-labelled-by":"plyr-settings-toggle-"+e.id,role:"tabpanel"}),v=u.createElement("ul",{role:"tablist"});this.config.settings.forEach(function(i){var n=u.createElement("li",{role:"tab",hidden:""}),s=u.createElement("button",u.extend(u.getAttributesFromSelector(t.config.selectors.buttons.settings),{type:"button",class:t.config.classNames.control+" "+t.config.classNames.control+"--forward",id:"plyr-settings-"+e.id+"-"+i+"-tab","aria-haspopup":!0,"aria-controls":"plyr-settings-"+e.id+"-"+i,"aria-expanded":!1}),h(i,t.config)),a=u.createElement("span",{class:t.config.classNames.menu.value});a.innerHTML=e[i],s.appendChild(a),n.appendChild(s),v.appendChild(n),t.elements.settings.tabs[i]=n}),y.appendChild(v),f.appendChild(y),this.config.settings.forEach(function(i){var n=u.createElement("div",{id:"plyr-settings-"+e.id+"-"+i,hidden:"","aria-labelled-by":"plyr-settings-"+e.id+"-"+i+"-tab",role:"tabpanel",tabindex:-1}),s=u.createElement("button",{type:"button",class:t.config.classNames.control+" "+t.config.classNames.control+"--back","aria-haspopup":!0,"aria-controls":"plyr-settings-"+e.id+"-home","aria-expanded":!1},h(i,t.config));n.appendChild(s);var a=u.createElement("ul");n.appendChild(a),f.appendChild(n),t.elements.settings.panes[i]=n}),m.appendChild(f),c.appendChild(m),i.appendChild(c),this.elements.settings.form=m,this.elements.settings.menu=c}return this.config.controls.includes("pip")&&d.pip&&i.appendChild(g.createButton.call(this,"pip")),this.config.controls.includes("airplay")&&d.airplay&&i.appendChild(g.createButton.call(this,"airplay")),this.config.controls.includes("fullscreen")&&i.appendChild(g.createButton.call(this,"fullscreen")),this.config.controls.includes("play-large")&&this.elements.container.appendChild(g.createButton.call(this,"play-large")),this.elements.controls=i,this.isHTML5&&g.setQualityMenu.call(this,p.getQualityOptions.call(this)),g.setSpeedMenu.call(this),i},inject:function(){var e=this;if(this.config.loadSprite){var t=g.getIconUrl.call(this);t.cors&&u.loadSprite(t.url,"sprite-plyr")}this.id=Math.floor(1e4*Math.random());var i=null;this.elements.controls=null;var n={id:this.id,seektime:this.config.seekTime,title:this.config.title},s=!0;u.is.string(this.config.controls)||u.is.element(this.config.controls)?i=this.config.controls:u.is.function(this.config.controls)?i=this.config.controls.call(this,n):(i=g.create.call(this,{id:this.id,seektime:this.config.seekTime,speed:this.speed,quality:this.quality,captions:f.getLabel.call(this)}),s=!1);var a=function(e){var t=e;return Object.entries(n).forEach(function(e){var i=r(e,2),n=i[0],s=i[1];t=u.replaceAll(t,"{"+n+"}",s)}),t};s&&(u.is.string(this.config.controls)?i=a(i):u.is.element(i)&&(i.innerHTML=a(i.innerHTML)));var l=void 0;if(u.is.string(this.config.selectors.controls.container)&&(l=document.querySelector(this.config.selectors.controls.container)),u.is.element(l)||(l=this.elements.container),u.is.element(i)?l.appendChild(i):i&&l.insertAdjacentHTML("beforeend",i),u.is.element(this.elements.controls)||g.findElements.call(this),window.navigator.userAgent.includes("Edge")&&u.repaint(l),this.config.tooltips.controls){var o=u.getElements.call(this,[this.config.selectors.controls.wrapper," ",this.config.selectors.labels," .",this.config.classNames.hidden].join(""));Array.from(o).forEach(function(t){u.toggleClass(t,e.config.classNames.hidden,!1),u.toggleClass(t,e.config.classNames.tooltip,!0),t.setAttribute("role","tooltip")})}}},f={setup:function(){if(this.supported.ui){var e=this.storage.get("language");if(u.is.empty(e)||(this.captions.language=e),u.is.empty(this.captions.language)&&(this.captions.language=this.config.captions.language.toLowerCase()),!u.is.boolean(this.captions.active)){var t=this.storage.get("captions");u.is.boolean(t)?this.captions.active=t:this.captions.active=this.config.captions.active}if(!this.isVideo||this.isYouTube||this.isHTML5&&!d.textTracks)u.is.array(this.config.controls)&&this.config.controls.includes("settings")&&this.config.settings.includes("captions")&&g.setCaptionsMenu.call(this);else{u.is.element(this.elements.captions)||(this.elements.captions=u.createElement("div",u.getAttributesFromSelector(this.config.selectors.captions)),u.insertAfter(this.elements.captions,this.elements.wrapper)),u.toggleClass(this.elements.container,this.config.classNames.captions.enabled,!u.is.empty(f.getTracks.call(this)));var i=f.getTracks.call(this);if(!u.is.empty(i)){if(u.getBrowser().isIE&&window.URL){var n=this.media.querySelectorAll("track");Array.from(n).forEach(function(e){var t=e.getAttribute("src"),i=u.parseUrl(t);i.hostname!==window.location.href.hostname&&["http:","https:"].includes(i.protocol)&&u.fetch(t,"blob").then(function(t){e.setAttribute("src",window.URL.createObjectURL(t))}).catch(function(){u.removeElement(e)})})}f.setLanguage.call(this),f.show.call(this),u.is.array(this.config.controls)&&this.config.controls.includes("settings")&&this.config.settings.includes("captions")&&g.setCaptionsMenu.call(this)}}}},setLanguage:function(){var e=this;if(this.isHTML5&&this.isVideo){f.getTracks.call(this).forEach(function(t){u.on(t,"cuechange",function(t){return f.setCue.call(e,t)}),t.mode="hidden"});var t=f.getCurrentTrack.call(this);u.is.track(t)&&Array.from(t.activeCues||[]).length&&f.setCue.call(this,t)}else this.isVimeo&&this.captions.active&&this.embed.enableTextTrack(this.language)},getTracks:function(){return u.is.nullOrUndefined(this.media)?[]:Array.from(this.media.textTracks||[]).filter(function(e){return["captions","subtitles"].includes(e.kind)})},getCurrentTrack:function(){var e=this,t=f.getTracks.call(this);if(!t.length)return null;var i=t.find(function(t){return t.language.toLowerCase()===e.language});(i||(i=u.getElement.call(this,"track[default]")),i)||(i=r(t,1)[0]);return i},getLabel:function(e){var t=e;return!u.is.track(t)&&d.textTracks&&this.captions.active&&(t=f.getCurrentTrack.call(this)),u.is.track(t)?u.is.empty(t.label)?u.is.empty(t.language)?h("enabled",this.config):e.language.toUpperCase():t.label:h("disabled",this.config)},setCue:function(e){var t=u.is.event(e)?e.target:e,i=t.activeCues,n=i.length&&i[0];t===f.getCurrentTrack.call(this)&&(u.is.cue(n)?f.setText.call(this,n.getCueAsHTML()):f.setText.call(this,null),u.dispatchEvent.call(this,this.media,"cuechange"))},setText:function(e){if(this.supported.ui)if(u.is.element(this.elements.captions)){var t=u.createElement("span");u.emptyElement(this.elements.captions);var i=u.is.nullOrUndefined(e)?"":e;u.is.string(i)?t.innerText=i.trim():t.appendChild(i),this.elements.captions.appendChild(t)}else this.debug.warn("No captions element to render to")},show:function(){var e=this.storage.get("captions");u.is.boolean(e)?this.captions.active=e:e=this.config.captions.active,e&&(u.toggleClass(this.elements.container,this.config.classNames.captions.active,!0),u.toggleState(this.elements.buttons.captions,!0))}},y=function(){},v=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];n(this,e),this.enabled=window.console&&t,this.enabled&&this.log("Debugging enabled")}return s(e,[{key:"log",get:function(){return this.enabled?Function.prototype.bind.call(console.log,console):y}},{key:"warn",get:function(){return this.enabled?Function.prototype.bind.call(console.warn,console):y}},{key:"error",get:function(){return this.enabled?Function.prototype.bind.call(console.error,console):y}}]),e}(),b={enabled:!0,title:"",debug:!1,autoplay:!1,autopause:!0,seekTime:10,volume:1,muted:!1,duration:null,displayDuration:!0,invertTime:!0,toggleInvert:!0,ratio:"16:9",clickToPlay:!0,hideControls:!0,resetOnEnd:!1,disableContextMenu:!0,loadSprite:!0,iconPrefix:"plyr",iconUrl:"https://cdn.plyr.io/3.3.9/plyr.svg",blankVideo:"https://cdn.plyr.io/static/blank.mp4",quality:{default:576,options:[4320,2880,2160,1440,1080,720,576,480,360,240,"default"]},loop:{active:!1},speed:{selected:1,options:[.5,.75,1,1.25,1.5,1.75,2]},keyboard:{focused:!0,global:!1},tooltips:{controls:!1,seek:!0},captions:{active:!1,language:(navigator.language||navigator.userLanguage).split("-")[0]},fullscreen:{enabled:!0,fallback:!0,iosNative:!1},storage:{enabled:!0,key:"plyr"},controls:["play-large","play","progress","current-time","mute","volume","captions","settings","pip","airplay","fullscreen"],settings:["captions","quality","speed"],i18n:{restart:"Restart",rewind:"Rewind {seektime}s",play:"Play",pause:"Pause",fastForward:"Forward {seektime}s",seek:"Seek",played:"Played",buffered:"Buffered",currentTime:"Current time",duration:"Duration",volume:"Volume",mute:"Mute",unmute:"Unmute",enableCaptions:"Enable captions",disableCaptions:"Disable captions",enterFullscreen:"Enter fullscreen",exitFullscreen:"Exit fullscreen",frameTitle:"Player for {title}",captions:"Captions",settings:"Settings",speed:"Speed",normal:"Normal",quality:"Quality",loop:"Loop",start:"Start",end:"End",all:"All",reset:"Reset",disabled:"Disabled",enabled:"Enabled",advertisement:"Ad"},urls:{vimeo:{sdk:"https://player.vimeo.com/api/player.js",iframe:"https://player.vimeo.com/video/{0}?{1}",api:"https://vimeo.com/api/v2/video/{0}.json"},youtube:{sdk:"https://www.youtube.com/iframe_api",api:"https://www.googleapis.com/youtube/v3/videos?id={0}&key={1}&fields=items(snippet(title))&part=snippet"},googleIMA:{sdk:"https://imasdk.googleapis.com/js/sdkloader/ima3.js"}},listeners:{seek:null,play:null,pause:null,restart:null,rewind:null,fastForward:null,mute:null,volume:null,captions:null,fullscreen:null,pip:null,airplay:null,speed:null,quality:null,loop:null,language:null},events:["ended","progress","stalled","playing","waiting","canplay","canplaythrough","loadstart","loadeddata","loadedmetadata","timeupdate","volumechange","play","pause","error","seeking","seeked","emptied","ratechange","cuechange","enterfullscreen","exitfullscreen","captionsenabled","captionsdisabled","languagechange","controlshidden","controlsshown","ready","statechange","qualitychange","qualityrequested","adsloaded","adscontentpause","adscontentresume","adstarted","adsmidpoint","adscomplete","adsallcomplete","adsimpression","adsclick"],selectors:{editable:"input, textarea, select, [contenteditable]",container:".plyr",controls:{container:null,wrapper:".plyr__controls"},labels:"[data-plyr]",buttons:{play:'[data-plyr="play"]',pause:'[data-plyr="pause"]',restart:'[data-plyr="restart"]',rewind:'[data-plyr="rewind"]',fastForward:'[data-plyr="fast-forward"]',mute:'[data-plyr="mute"]',captions:'[data-plyr="captions"]',fullscreen:'[data-plyr="fullscreen"]',pip:'[data-plyr="pip"]',airplay:'[data-plyr="airplay"]',settings:'[data-plyr="settings"]',loop:'[data-plyr="loop"]'},inputs:{seek:'[data-plyr="seek"]',volume:'[data-plyr="volume"]',speed:'[data-plyr="speed"]',language:'[data-plyr="language"]',quality:'[data-plyr="quality"]'},display:{currentTime:".plyr__time--current",duration:".plyr__time--duration",buffer:".plyr__progress--buffer",played:".plyr__progress--played",loop:".plyr__progress--loop",volume:".plyr__volume--display"},progress:".plyr__progress",captions:".plyr__captions",menu:{quality:".js-plyr__menu__list--quality"}},classNames:{type:"plyr--{0}",provider:"plyr--{0}",video:"plyr__video-wrapper",embed:"plyr__video-embed",embedContainer:"plyr__video-embed__container",poster:"plyr__poster",posterEnabled:"plyr__poster-enabled",ads:"plyr__ads",control:"plyr__control",playing:"plyr--playing",paused:"plyr--paused",stopped:"plyr--stopped",loading:"plyr--loading",hover:"plyr--hover",tooltip:"plyr__tooltip",cues:"plyr__cues",hidden:"plyr__sr-only",hideControls:"plyr--hide-controls",isIos:"plyr--is-ios",isTouch:"plyr--is-touch",uiSupported:"plyr--full-ui",noTransition:"plyr--no-transition",menu:{value:"plyr__menu__value",badge:"plyr__badge",open:"plyr--menu-open"},captions:{enabled:"plyr--captions-enabled",active:"plyr--captions-active"},fullscreen:{enabled:"plyr--fullscreen-enabled",fallback:"plyr--fullscreen-fallback"},pip:{supported:"plyr--pip-supported",active:"plyr--pip-active"},airplay:{supported:"plyr--airplay-supported",active:"plyr--airplay-active"},tabFocus:"plyr__tab-focus"},attributes:{embed:{provider:"data-plyr-provider",id:"data-plyr-embed-id"}},keys:{google:null},ads:{enabled:!1,publisherId:""}},k=u.getBrowser();function w(){if(this.enabled){var e=this.player.elements.buttons.fullscreen;u.is.element(e)&&u.toggleState(e,this.active),u.dispatchEvent.call(this.player,this.target,this.active?"enterfullscreen":"exitfullscreen",!0),k.isIos||u.trapFocus.call(this.player,this.target,this.active)}}function E(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];e?this.scrollPosition={x:window.scrollX||0,y:window.scrollY||0}:window.scrollTo(this.scrollPosition.x,this.scrollPosition.y),document.body.style.overflow=e?"hidden":"",u.toggleClass(this.target,this.player.config.classNames.fullscreen.fallback,e),w.call(this)}var T=function(){function e(t){var i=this;n(this,e),this.player=t,this.prefix=e.prefix,this.property=e.property,this.scrollPosition={x:0,y:0},u.on(document,"ms"===this.prefix?"MSFullscreenChange":this.prefix+"fullscreenchange",function(){w.call(i)}),u.on(this.player.elements.container,"dblclick",function(e){u.is.element(i.player.elements.controls)&&i.player.elements.controls.contains(e.target)||i.toggle()}),this.update()}return s(e,[{key:"update",value:function(){this.enabled?this.player.debug.log((e.native?"Native":"Fallback")+" fullscreen enabled"):this.player.debug.log("Fullscreen not supported and fallback disabled"),u.toggleClass(this.player.elements.container,this.player.config.classNames.fullscreen.enabled,this.enabled)}},{key:"enter",value:function(){this.enabled&&(k.isIos&&this.player.config.fullscreen.iosNative?this.player.playing&&this.target.webkitEnterFullscreen():e.native?this.prefix?u.is.empty(this.prefix)||this.target[this.prefix+"Request"+this.property]():this.target.requestFullscreen():E.call(this,!0))}},{key:"exit",value:function(){if(this.enabled)if(k.isIos&&this.player.config.fullscreen.iosNative)this.target.webkitExitFullscreen(),this.player.play();else if(e.native)if(this.prefix){if(!u.is.empty(this.prefix)){var t="moz"===this.prefix?"Cancel":"Exit";document[""+this.prefix+t+this.property]()}}else(document.cancelFullScreen||document.exitFullscreen).call(document);else E.call(this,!1)}},{key:"toggle",value:function(){this.active?this.exit():this.enter()}},{key:"enabled",get:function(){return(e.native||this.player.config.fullscreen.fallback)&&this.player.config.fullscreen.enabled&&this.player.supported.ui&&this.player.isVideo}},{key:"active",get:function(){return!!this.enabled&&(e.native?(this.prefix?document[""+this.prefix+this.property+"Element"]:document.fullscreenElement)===this.target:u.hasClass(this.target,this.player.config.classNames.fullscreen.fallback))}},{key:"target",get:function(){return k.isIos&&this.player.config.fullscreen.iosNative?this.player.media:this.player.elements.container}}],[{key:"native",get:function(){return!!(document.fullscreenEnabled||document.webkitFullscreenEnabled||document.mozFullScreenEnabled||document.msFullscreenEnabled)}},{key:"prefix",get:function(){if(u.is.function(document.exitFullscreen))return"";var e="";return["webkit","moz","ms"].some(function(t){return!(!u.is.function(document[t+"ExitFullscreen"])&&!u.is.function(document[t+"CancelFullScreen"]))&&(e=t,!0)}),e}},{key:"property",get:function(){return"moz"===this.prefix?"FullScreen":"Fullscreen"}}]),e}(),A=u.getBrowser(),C={addStyleHook:function(){u.toggleClass(this.elements.container,this.config.selectors.container.replace(".",""),!0),u.toggleClass(this.elements.container,this.config.classNames.uiSupported,this.supported.ui)},toggleNativeControls:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.isHTML5?this.media.setAttribute("controls",""):this.media.removeAttribute("controls")},build:function(){var e=this;if(this.listeners.media(),!this.supported.ui)return this.debug.warn("Basic support only for "+this.provider+" "+this.type),void C.toggleNativeControls.call(this,!0);u.is.element(this.elements.controls)||(g.inject.call(this),this.listeners.controls()),C.toggleNativeControls.call(this),f.setup.call(this),this.volume=null,this.muted=null,this.speed=null,this.loop=null,this.quality=null,g.updateVolume.call(this),g.timeUpdate.call(this),C.checkPlaying.call(this),u.toggleClass(this.elements.container,this.config.classNames.pip.supported,d.pip&&this.isHTML5&&this.isVideo),u.toggleClass(this.elements.container,this.config.classNames.airplay.supported,d.airplay&&this.isHTML5),u.toggleClass(this.elements.container,this.config.classNames.isIos,A.isIos),u.toggleClass(this.elements.container,this.config.classNames.isTouch,this.touch),this.ready=!0,setTimeout(function(){u.dispatchEvent.call(e,e.media,"ready")},0),C.setTitle.call(this),this.poster&&this.elements.poster&&!this.elements.poster.style.backgroundImage&&C.setPoster.call(this,this.poster)},setTitle:function(){var e=h("play",this.config);if(u.is.string(this.config.title)&&!u.is.empty(this.config.title)&&(e+=", "+this.config.title,this.elements.container.setAttribute("aria-label",this.config.title)),u.is.nodeList(this.elements.buttons.play)&&Array.from(this.elements.buttons.play).forEach(function(t){t.setAttribute("aria-label",e)}),this.isEmbed){var t=u.getElement.call(this,"iframe");if(!u.is.element(t))return;var i=u.is.empty(this.config.title)?"video":this.config.title,n=h("frameTitle",this.config);t.setAttribute("title",n.replace("{title}",i))}},togglePoster:function(e){u.toggleClass(this.elements.container,this.config.classNames.posterEnabled,e)},setPoster:function(e){var t=this;if(this.media.setAttribute("poster",e),!u.is.element(this.elements.poster))return Promise.reject();var i=u.loadImage(e).then(function(){return t.elements.poster.style.backgroundImage="url('"+e+"')",Object.assign(t.elements.poster.style,{backgroundImage:"url('"+e+"')",backgroundSize:""}),C.togglePoster.call(t,!0),e});return i.catch(function(){return C.togglePoster.call(t,!1)}),i},checkPlaying:function(e){u.toggleClass(this.elements.container,this.config.classNames.playing,this.playing),u.toggleClass(this.elements.container,this.config.classNames.paused,this.paused),u.toggleClass(this.elements.container,this.config.classNames.stopped,this.stopped),u.toggleState(this.elements.buttons.play,this.playing),u.is.event(e)&&"timeupdate"===e.type||C.toggleControls.call(this)},checkLoading:function(e){var t=this;this.loading=["stalled","waiting"].includes(e.type),clearTimeout(this.timers.loading),this.timers.loading=setTimeout(function(){u.toggleClass(t.elements.container,t.config.classNames.loading,t.loading),C.toggleControls.call(t)},this.loading?250:0)},toggleControls:function(e){var t=this.elements.controls;t&&this.config.hideControls&&this.toggleControls(Boolean(e||this.loading||this.paused||t.pressed||t.hover))}},S=u.getBrowser(),P=function(){function e(t){n(this,e),this.player=t,this.lastKey=null,this.handleKey=this.handleKey.bind(this),this.toggleMenu=this.toggleMenu.bind(this),this.firstTouch=this.firstTouch.bind(this)}return s(e,[{key:"handleKey",value:function(e){var t=this,i=e.keyCode?e.keyCode:e.which,n="keydown"===e.type,s=n&&i===this.lastKey;if(!(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey)&&u.is.number(i)){if(n){var a=u.getFocusElement();if(u.is.element(a)&&u.matches(a,this.player.config.selectors.editable))return;switch([48,49,50,51,52,53,54,56,57,32,75,38,40,77,39,37,70,67,73,76,79].includes(i)&&(e.preventDefault(),e.stopPropagation()),i){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:s||(t.player.currentTime=t.player.duration/10*(i-48));break;case 32:case 75:s||this.player.togglePlay();break;case 38:this.player.increaseVolume(.1);break;case 40:this.player.decreaseVolume(.1);break;case 77:s||(this.player.muted=!this.player.muted);break;case 39:this.player.forward();break;case 37:this.player.rewind();break;case 70:this.player.fullscreen.toggle();break;case 67:s||this.player.toggleCaptions();break;case 76:this.player.loop=!this.player.loop}!this.player.fullscreen.enabled&&this.player.fullscreen.active&&27===i&&this.player.fullscreen.toggle(),this.lastKey=i}else this.lastKey=null}}},{key:"toggleMenu",value:function(e){g.toggleMenu.call(this.player,e)}},{key:"firstTouch",value:function(){this.player.touch=!0,u.toggleClass(this.player.elements.container,this.player.config.classNames.isTouch,!0),u.off(document.body,"touchstart",this.firstTouch)}},{key:"global",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.player.config.keyboard.global&&u.toggleListener(window,"keydown keyup",this.handleKey,e,!1),u.toggleListener(document.body,"click",this.toggleMenu,e),u.on(document.body,"touchstart",this.firstTouch)}},{key:"container",value:function(){var e=this;!this.player.config.keyboard.global&&this.player.config.keyboard.focused&&u.on(this.player.elements.container,"keydown keyup",this.handleKey,!1),u.on(this.player.elements.container,"focusout",function(t){u.toggleClass(t.target,e.player.config.classNames.tabFocus,!1)}),u.on(this.player.elements.container,"keydown",function(t){9===t.keyCode&&setTimeout(function(){u.toggleClass(u.getFocusElement(),e.player.config.classNames.tabFocus,!0)},0)}),u.on(this.player.elements.container,"mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",function(t){var i=e.player.elements.controls;"enterfullscreen"===t.type&&(i.pressed=!1,i.hover=!1);var n=0;["touchstart","touchmove","mousemove"].includes(t.type)&&(C.toggleControls.call(e.player,!0),n=e.player.touch?3e3:2e3),clearTimeout(e.player.timers.controls),e.player.timers.controls=setTimeout(function(){return C.toggleControls.call(e.player,!1)},n)})}},{key:"media",value:function(){var e=this;if(u.on(this.player.media,"timeupdate seeking seeked",function(t){return g.timeUpdate.call(e.player,t)}),u.on(this.player.media,"durationchange loadeddata loadedmetadata",function(t){return g.durationUpdate.call(e.player,t)}),u.on(this.player.media,"loadeddata",function(){u.toggleHidden(e.player.elements.volume,!e.player.hasAudio),u.toggleHidden(e.player.elements.buttons.mute,!e.player.hasAudio)}),u.on(this.player.media,"ended",function(){e.player.isHTML5&&e.player.isVideo&&e.player.config.resetOnEnd&&e.player.restart()}),u.on(this.player.media,"progress playing seeking seeked",function(t){return g.updateProgress.call(e.player,t)}),u.on(this.player.media,"volumechange",function(t){return g.updateVolume.call(e.player,t)}),u.on(this.player.media,"playing play pause ended emptied timeupdate",function(t){return C.checkPlaying.call(e.player,t)}),u.on(this.player.media,"waiting canplay seeked playing",function(t){return C.checkLoading.call(e.player,t)}),u.on(this.player.media,"playing",function(){e.player.ads&&e.player.ads.enabled&&!e.player.ads.initialized&&e.player.ads.managerPromise.then(function(){return e.player.ads.play()}).catch(function(){return e.player.play()})}),this.player.supported.ui&&this.player.config.clickToPlay&&!this.player.isAudio){var t=u.getElement.call(this.player,"."+this.player.config.classNames.video);if(!u.is.element(t))return;u.on(t,"click",function(){e.player.config.hideControls&&e.player.touch&&!e.player.paused||(e.player.paused?e.player.play():e.player.ended?(e.player.restart(),e.player.play()):e.player.pause())})}this.player.supported.ui&&this.player.config.disableContextMenu&&u.on(this.player.elements.wrapper,"contextmenu",function(e){e.preventDefault()},!1),u.on(this.player.media,"volumechange",function(){e.player.storage.set({volume:e.player.volume,muted:e.player.muted})}),u.on(this.player.media,"ratechange",function(){g.updateSetting.call(e.player,"speed"),e.player.storage.set({speed:e.player.speed})}),u.on(this.player.media,"qualityrequested",function(t){e.player.storage.set({quality:t.detail.quality})}),u.on(this.player.media,"qualitychange",function(t){g.updateSetting.call(e.player,"quality",null,t.detail.quality)}),u.on(this.player.media,"languagechange",function(){g.updateSetting.call(e.player,"captions"),e.player.storage.set({language:e.player.language})}),u.on(this.player.media,"captionsenabled captionsdisabled",function(){g.updateSetting.call(e.player,"captions"),e.player.storage.set({captions:e.player.captions.active})}),u.on(this.player.media,this.player.config.events.concat(["keyup","keydown"]).join(" "),function(t){var i={};"error"===t.type&&(i=e.player.media.error),u.dispatchEvent.call(e.player,e.player.elements.container,t.type,!0,i)})}},{key:"controls",value:function(){var e=this,t=S.isIE?"change":"input",i=function(t,i,n){var s=e.player.config.listeners[n],a=!0;u.is.function(s)&&(a=s.call(e.player,t)),a&&u.is.function(i)&&i.call(e.player,t)},n=function(t,n,s,a){var r=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],l=e.player.config.listeners[a],o=u.is.function(l);u.on(t,n,function(e){return i(e,s,a)},r&&!o)};n(this.player.elements.buttons.play,"click",this.player.togglePlay,"play"),n(this.player.elements.buttons.restart,"click",this.player.restart,"restart"),n(this.player.elements.buttons.rewind,"click",this.player.rewind,"rewind"),n(this.player.elements.buttons.fastForward,"click",this.player.forward,"fastForward"),n(this.player.elements.buttons.mute,"click",function(){e.player.muted=!e.player.muted},"mute"),n(this.player.elements.buttons.captions,"click",this.player.toggleCaptions),n(this.player.elements.buttons.fullscreen,"click",function(){e.player.fullscreen.toggle()},"fullscreen"),n(this.player.elements.buttons.pip,"click",function(){e.player.pip="toggle"},"pip"),n(this.player.elements.buttons.airplay,"click",this.player.airplay,"airplay"),n(this.player.elements.buttons.settings,"click",function(t){g.toggleMenu.call(e.player,t)}),n(this.player.elements.settings.form,"click",function(t){t.stopPropagation();var n=function(){var t="plyr-settings-"+e.player.id+"-home";g.showTab.call(e.player,t)};if(u.matches(t.target,e.player.config.selectors.inputs.language))i(t,function(){e.player.language=t.target.value,n()},"language");else if(u.matches(t.target,e.player.config.selectors.inputs.quality))i(t,function(){e.player.quality=t.target.value,n()},"quality");else if(u.matches(t.target,e.player.config.selectors.inputs.speed))i(t,function(){e.player.speed=parseFloat(t.target.value),n()},"speed");else{var s=t.target;g.showTab.call(e.player,s.getAttribute("aria-controls"))}}),n(this.player.elements.inputs.seek,"mousedown mousemove",function(t){var i=e.player.elements.progress.getBoundingClientRect(),n=100/i.width*(t.pageX-i.left);t.currentTarget.setAttribute("seek-value",n)}),n(this.player.elements.inputs.seek,"mousedown mouseup keydown keyup touchstart touchend",function(t){var i=t.currentTarget,n=i.hasAttribute("play-on-seeked"),s=["mouseup","touchend","keyup"].includes(t.type);n&&s?(i.removeAttribute("play-on-seeked"),e.player.play()):!s&&e.player.playing&&(i.setAttribute("play-on-seeked",""),e.player.pause())}),n(this.player.elements.inputs.seek,t,function(t){var i=t.currentTarget,n=i.getAttribute("seek-value");u.is.empty(n)&&(n=i.value),i.removeAttribute("seek-value"),e.player.currentTime=n/i.max*e.player.duration},"seek"),this.player.config.toggleInvert&&!u.is.element(this.player.elements.display.duration)&&n(this.player.elements.display.currentTime,"click",function(){0!==e.player.currentTime&&(e.player.config.invertTime=!e.player.config.invertTime,g.timeUpdate.call(e.player))}),n(this.player.elements.inputs.volume,t,function(t){e.player.volume=t.target.value},"volume"),S.isWebkit&&n(u.getElements.call(this.player,'input[type="range"]'),"input",function(t){g.updateRangeFill.call(e.player,t.target)}),n(this.player.elements.progress,"mouseenter mouseleave mousemove",function(t){return g.updateSeekTooltip.call(e.player,t)}),n(this.player.elements.controls,"mouseenter mouseleave",function(t){e.player.elements.controls.hover=!e.player.touch&&"mouseenter"===t.type}),n(this.player.elements.controls,"mousedown mouseup touchstart touchend touchcancel",function(t){e.player.elements.controls.pressed=["mousedown","touchstart"].includes(t.type)}),n(this.player.elements.controls,"focusin focusout",function(t){var i=e.player,n=i.config,s=i.elements,a=i.timers;if(u.toggleClass(s.controls,n.classNames.noTransition,"focusin"===t.type),C.toggleControls.call(e.player,"focusin"===t.type),"focusin"===t.type){setTimeout(function(){u.toggleClass(s.controls,n.classNames.noTransition,!1)},0);var r=e.touch?3e3:4e3;clearTimeout(a.controls),a.controls=setTimeout(function(){return C.toggleControls.call(e.player,!1)},r)}}),n(this.player.elements.inputs.volume,"wheel",function(t){var i=t.webkitDirectionInvertedFromDevice,n=0;(t.deltaY<0||t.deltaX>0)&&(i?(e.player.decreaseVolume(.02),n=-1):(e.player.increaseVolume(.02),n=1)),(t.deltaY>0||t.deltaX<0)&&(i?(e.player.increaseVolume(.02),n=1):(e.player.decreaseVolume(.02),n=-1)),(1===n&&e.player.media.volume<1||-1===n&&e.player.media.volume>0)&&t.preventDefault()},"volume",!1)}},{key:"clear",value:function(){this.global(!1)}}]),e}();function x(e){this.media.paused===e&&(this.media.paused=!e,u.dispatchEvent.call(this,this.media,e?"play":"pause"))}var N={setup:function(){var e=this;u.toggleClass(this.elements.wrapper,this.config.classNames.embed,!0),N.setAspectRatio.call(this),u.is.object(window.Vimeo)?N.ready.call(this):u.loadScript(this.config.urls.vimeo.sdk).then(function(){N.ready.call(e)}).catch(function(t){e.debug.warn("Vimeo API failed to load",t)})},setAspectRatio:function(e){var t=u.is.string(e)?e.split(":"):this.config.ratio.split(":"),i=100/t[0]*t[1];if(this.elements.wrapper.style.paddingBottom=i+"%",this.supported.ui){var n=(240-i)/4.8;this.media.style.transform="translateY(-"+n+"%)"}},ready:function(){var e=this,t=this,i={loop:t.config.loop.active,autoplay:t.autoplay,byline:!1,portrait:!1,title:!1,speed:!0,transparent:0,gesture:"media",playsinline:!this.config.fullscreen.iosNative},n=u.buildUrlParams(i),s=t.media.getAttribute("src");u.is.empty(s)&&(s=t.media.getAttribute(t.config.attributes.embed.id));var a=u.parseVimeoId(s),r=u.createElement("iframe"),l=u.format(t.config.urls.vimeo.iframe,a,n);r.setAttribute("src",l),r.setAttribute("allowfullscreen",""),r.setAttribute("allowtransparency",""),r.setAttribute("allow","autoplay");var o=u.createElement("div",{class:t.config.classNames.embedContainer});o.appendChild(r),t.media=u.replaceElement(o,t.media),u.fetch(u.format(t.config.urls.vimeo.api,a),"json").then(function(e){if(!u.is.empty(e)){var i=new URL(e[0].thumbnail_large);i.pathname=i.pathname.split("_")[0]+".jpg",C.setPoster.call(t,i.href)}}),t.embed=new window.Vimeo.Player(r,{autopause:t.config.autopause,muted:t.muted}),t.media.paused=!0,t.media.currentTime=0,t.supported.ui&&t.embed.disableTextTrack(),t.media.play=function(){return x.call(t,!0),t.embed.play()},t.media.pause=function(){return x.call(t,!1),t.embed.pause()},t.media.stop=function(){t.pause(),t.currentTime=0};var c=t.media.currentTime;Object.defineProperty(t.media,"currentTime",{get:function(){return c},set:function(e){var i=t.embed,n=t.media,s=t.paused,a=t.volume;n.seeking=!0,u.dispatchEvent.call(t,n,"seeking"),Promise.resolve(s&&i.setVolume(0)).then(function(){return i.setCurrentTime(e)}).then(function(){return s&&i.pause()}).then(function(){return s&&i.setVolume(a)}).catch(function(){})}});var d=t.config.speed.selected;Object.defineProperty(t.media,"playbackRate",{get:function(){return d},set:function(e){t.embed.setPlaybackRate(e).then(function(){d=e,u.dispatchEvent.call(t,t.media,"ratechange")}).catch(function(e){"Error"===e.name&&g.setSpeedMenu.call(t,[])})}});var p=t.config.volume;Object.defineProperty(t.media,"volume",{get:function(){return p},set:function(e){t.embed.setVolume(e).then(function(){p=e,u.dispatchEvent.call(t,t.media,"volumechange")})}});var h=t.config.muted;Object.defineProperty(t.media,"muted",{get:function(){return h},set:function(e){var i=!!u.is.boolean(e)&&e;t.embed.setVolume(i?0:t.config.volume).then(function(){h=i,u.dispatchEvent.call(t,t.media,"volumechange")})}});var m=t.config.loop;Object.defineProperty(t.media,"loop",{get:function(){return m},set:function(e){var i=u.is.boolean(e)?e:t.config.loop.active;t.embed.setLoop(i).then(function(){m=i})}});var y=void 0;t.embed.getVideoUrl().then(function(e){y=e}).catch(function(t){e.debug.warn(t)}),Object.defineProperty(t.media,"currentSrc",{get:function(){return y}}),Object.defineProperty(t.media,"ended",{get:function(){return t.currentTime===t.duration}}),Promise.all([t.embed.getVideoWidth(),t.embed.getVideoHeight()]).then(function(t){var i=u.getAspectRatio(t[0],t[1]);N.setAspectRatio.call(e,i)}),t.embed.setAutopause(t.config.autopause).then(function(e){t.config.autopause=e}),t.embed.getVideoTitle().then(function(i){t.config.title=i,C.setTitle.call(e)}),t.embed.getCurrentTime().then(function(e){c=e,u.dispatchEvent.call(t,t.media,"timeupdate")}),t.embed.getDuration().then(function(e){t.media.duration=e,u.dispatchEvent.call(t,t.media,"durationchange")}),t.embed.getTextTracks().then(function(e){t.media.textTracks=e,f.setup.call(t)}),t.embed.on("cuechange",function(e){var i=null;e.cues.length&&(i=u.stripHTML(e.cues[0].text)),f.setText.call(t,i)}),t.embed.on("loaded",function(){u.is.element(t.embed.element)&&t.supported.ui&&t.embed.element.setAttribute("tabindex",-1)}),t.embed.on("play",function(){x.call(t,!0),u.dispatchEvent.call(t,t.media,"playing")}),t.embed.on("pause",function(){x.call(t,!1)}),t.embed.on("timeupdate",function(e){t.media.seeking=!1,c=e.seconds,u.dispatchEvent.call(t,t.media,"timeupdate")}),t.embed.on("progress",function(e){t.media.buffered=e.percent,u.dispatchEvent.call(t,t.media,"progress"),1===parseInt(e.percent,10)&&u.dispatchEvent.call(t,t.media,"canplaythrough"),t.embed.getDuration().then(function(e){e!==t.media.duration&&(t.media.duration=e,u.dispatchEvent.call(t,t.media,"durationchange"))})}),t.embed.on("seeked",function(){t.media.seeking=!1,u.dispatchEvent.call(t,t.media,"seeked")}),t.embed.on("ended",function(){t.media.paused=!0,u.dispatchEvent.call(t,t.media,"ended")}),t.embed.on("error",function(e){t.media.error=e,u.dispatchEvent.call(t,t.media,"error")}),setTimeout(function(){return C.build.call(t)},0)}};function L(e){switch(e){case"hd2160":return 2160;case 2160:return"hd2160";case"hd1440":return 1440;case 1440:return"hd1440";case"hd1080":return 1080;case 1080:return"hd1080";case"hd720":return 720;case 720:return"hd720";case"large":return 480;case 480:return"large";case"medium":return 360;case 360:return"medium";case"small":return 240;case 240:return"small";default:return"default"}}function M(e){this.media.paused===e&&(this.media.paused=!e,u.dispatchEvent.call(this,this.media,e?"play":"pause"))}var I={setup:function(){var e=this;u.toggleClass(this.elements.wrapper,this.config.classNames.embed,!0),I.setAspectRatio.call(this),u.is.object(window.YT)&&u.is.function(window.YT.Player)?I.ready.call(this):(u.loadScript(this.config.urls.youtube.sdk).catch(function(t){e.debug.warn("YouTube API failed to load",t)}),window.onYouTubeReadyCallbacks=window.onYouTubeReadyCallbacks||[],window.onYouTubeReadyCallbacks.push(function(){I.ready.call(e)}),window.onYouTubeIframeAPIReady=function(){window.onYouTubeReadyCallbacks.forEach(function(e){e()})})},getTitle:function(e){var t=this;if(u.is.function(this.embed.getVideoData)){var i=this.embed.getVideoData().title;if(u.is.empty(i))return this.config.title=i,void C.setTitle.call(this)}var n=this.config.keys.google;if(u.is.string(n)&&!u.is.empty(n)){var s=u.format(this.config.urls.youtube.api,e,n);u.fetch(s).then(function(e){u.is.object(e)&&(t.config.title=e.items[0].snippet.title,C.setTitle.call(t))}).catch(function(){})}},setAspectRatio:function(){var e=this.config.ratio.split(":");this.elements.wrapper.style.paddingBottom=100/e[0]*e[1]+"%"},ready:function(){var e=this,t=e.media.getAttribute("id");if(u.is.empty(t)||!t.startsWith("youtube-")){var i=e.media.getAttribute("src");u.is.empty(i)&&(i=e.media.getAttribute(this.config.attributes.embed.id));var n=u.parseYouTubeId(i),s=u.generateId(e.provider),a=u.createElement("div",{id:s});e.media=u.replaceElement(a,e.media);var r=function(e){return"https://img.youtube.com/vi/"+n+"/"+e+"default.jpg"};u.loadImage(r("maxres"),121).catch(function(){return u.loadImage(r("sd"),121)}).catch(function(){return u.loadImage(r("hq"))}).then(function(t){return C.setPoster.call(e,t.src)}).then(function(t){t.includes("maxres")||(e.elements.poster.style.backgroundSize="cover")}),e.embed=new window.YT.Player(s,{videoId:n,playerVars:{autoplay:e.config.autoplay?1:0,controls:e.supported.ui?0:1,rel:0,showinfo:0,iv_load_policy:3,modestbranding:1,disablekb:1,playsinline:1,widget_referrer:window?window.location.href:null,cc_load_policy:e.captions.active?1:0,cc_lang_pref:e.config.captions.language},events:{onError:function(t){if(!u.is.object(e.media.error)){var i={code:t.data};switch(t.data){case 2:i.message="The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.";break;case 5:i.message="The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.";break;case 100:i.message="The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.";break;case 101:case 150:i.message="The owner of the requested video does not allow it to be played in embedded players.";break;default:i.message="An unknown error occured"}e.media.error=i,u.dispatchEvent.call(e,e.media,"error")}},onPlaybackQualityChange:function(){u.dispatchEvent.call(e,e.media,"qualitychange",!1,{quality:e.media.quality})},onPlaybackRateChange:function(t){var i=t.target;e.media.playbackRate=i.getPlaybackRate(),u.dispatchEvent.call(e,e.media,"ratechange")},onReady:function(t){var i=t.target;I.getTitle.call(e,n),e.media.play=function(){M.call(e,!0),i.playVideo()},e.media.pause=function(){M.call(e,!1),i.pauseVideo()},e.media.stop=function(){i.stopVideo()},e.media.duration=i.getDuration(),e.media.paused=!0,e.media.currentTime=0,Object.defineProperty(e.media,"currentTime",{get:function(){return Number(i.getCurrentTime())},set:function(t){e.paused&&e.embed.mute(),e.media.seeking=!0,u.dispatchEvent.call(e,e.media,"seeking"),i.seekTo(t)}}),Object.defineProperty(e.media,"playbackRate",{get:function(){return i.getPlaybackRate()},set:function(e){i.setPlaybackRate(e)}}),Object.defineProperty(e.media,"quality",{get:function(){return L(i.getPlaybackQuality())},set:function(t){var n=t;i.setPlaybackQuality(L(n)),u.dispatchEvent.call(e,e.media,"qualityrequested",!1,{quality:n})}});var s=e.config.volume;Object.defineProperty(e.media,"volume",{get:function(){return s},set:function(t){s=t,i.setVolume(100*s),u.dispatchEvent.call(e,e.media,"volumechange")}});var a=e.config.muted;Object.defineProperty(e.media,"muted",{get:function(){return a},set:function(t){var n=u.is.boolean(t)?t:a;a=n,i[n?"mute":"unMute"](),u.dispatchEvent.call(e,e.media,"volumechange")}}),Object.defineProperty(e.media,"currentSrc",{get:function(){return i.getVideoUrl()}}),Object.defineProperty(e.media,"ended",{get:function(){return e.currentTime===e.duration}}),e.options.speed=i.getAvailablePlaybackRates(),e.supported.ui&&e.media.setAttribute("tabindex",-1),u.dispatchEvent.call(e,e.media,"timeupdate"),u.dispatchEvent.call(e,e.media,"durationchange"),clearInterval(e.timers.buffering),e.timers.buffering=setInterval(function(){e.media.buffered=i.getVideoLoadedFraction(),(null===e.media.lastBuffered||e.media.lastBuffered<e.media.buffered)&&u.dispatchEvent.call(e,e.media,"progress"),e.media.lastBuffered=e.media.buffered,1===e.media.buffered&&(clearInterval(e.timers.buffering),u.dispatchEvent.call(e,e.media,"canplaythrough"))},200),setTimeout(function(){return C.build.call(e)},50)},onStateChange:function(t){var i,n=t.target;switch(clearInterval(e.timers.playing),e.media.seeking&&[1,2].includes(t.data)&&(e.media.seeking=!1,u.dispatchEvent.call(e,e.media,"seeked")),t.data){case-1:u.dispatchEvent.call(e,e.media,"timeupdate"),e.media.buffered=n.getVideoLoadedFraction(),u.dispatchEvent.call(e,e.media,"progress");break;case 0:M.call(e,!1),e.media.loop?(n.stopVideo(),n.playVideo()):u.dispatchEvent.call(e,e.media,"ended");break;case 1:e.media.paused?e.media.pause():(M.call(e,!0),u.dispatchEvent.call(e,e.media,"playing"),e.timers.playing=setInterval(function(){u.dispatchEvent.call(e,e.media,"timeupdate")},50),e.media.duration!==n.getDuration()&&(e.media.duration=n.getDuration(),u.dispatchEvent.call(e,e.media,"durationchange")),g.setQualityMenu.call(e,(i=n.getAvailableQualityLevels(),u.is.empty(i)?i:u.dedupe(i.map(function(e){return L(e)})))));break;case 2:e.muted||e.embed.unMute(),M.call(e,!1)}u.dispatchEvent.call(e,e.elements.container,"statechange",!1,{code:t.data})}}})}}},q={setup:function(){if(this.media)if(u.toggleClass(this.elements.container,this.config.classNames.type.replace("{0}",this.type),!0),u.toggleClass(this.elements.container,this.config.classNames.provider.replace("{0}",this.provider),!0),this.isEmbed&&u.toggleClass(this.elements.container,this.config.classNames.type.replace("{0}","video"),!0),this.isVideo&&(this.elements.wrapper=u.createElement("div",{class:this.config.classNames.video}),u.wrap(this.media,this.elements.wrapper),this.elements.poster=u.createElement("div",{class:this.config.classNames.poster}),this.elements.wrapper.appendChild(this.elements.poster)),this.isEmbed)switch(this.provider){case"youtube":I.setup.call(this);break;case"vimeo":N.setup.call(this)}else this.isHTML5&&p.extend.call(this);else this.debug.warn("No media element found!")}},_=function(){function e(t){var i=this;n(this,e),this.player=t,this.publisherId=t.config.ads.publisherId,this.playing=!1,this.initialized=!1,this.elements={container:null,displayContainer:null},this.manager=null,this.loader=null,this.cuePoints=null,this.events={},this.safetyTimer=null,this.countdownTimer=null,this.managerPromise=new Promise(function(e,t){i.on("loaded",e),i.on("error",t)}),this.load()}return s(e,[{key:"load",value:function(){var e=this;this.enabled&&(u.is.object(window.google)&&u.is.object(window.google.ima)?this.ready():u.loadScript(this.player.config.urls.googleIMA.sdk).then(function(){e.ready()}).catch(function(){e.trigger("error",new Error("Google IMA SDK failed to load"))}))}},{key:"ready",value:function(){var e=this;this.startSafetyTimer(12e3,"ready()"),this.managerPromise.then(function(){e.clearSafetyTimer("onAdsManagerLoaded()")}),this.listeners(),this.setupIMA()}},{key:"setupIMA",value:function(){this.elements.container=u.createElement("div",{class:this.player.config.classNames.ads}),this.player.elements.container.appendChild(this.elements.container),google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED),google.ima.settings.setLocale(this.player.config.ads.language),this.elements.displayContainer=new google.ima.AdDisplayContainer(this.elements.container),this.requestAds()}},{key:"requestAds",value:function(){var e=this,t=this.player.elements.container;try{this.loader=new google.ima.AdsLoader(this.elements.displayContainer),this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,function(t){return e.onAdsManagerLoaded(t)},!1),this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(t){return e.onAdError(t)},!1);var i=new google.ima.AdsRequest;i.adTagUrl=this.tagUrl,i.linearAdSlotWidth=t.offsetWidth,i.linearAdSlotHeight=t.offsetHeight,i.nonLinearAdSlotWidth=t.offsetWidth,i.nonLinearAdSlotHeight=t.offsetHeight,i.forceNonLinearFullSlot=!1,i.setAdWillPlayMuted(!this.player.muted),this.loader.requestAds(i)}catch(e){this.onAdError(e)}}},{key:"pollCountdown",value:function(){var e=this;if(!(arguments.length>0&&void 0!==arguments[0]&&arguments[0]))return clearInterval(this.countdownTimer),void this.elements.container.removeAttribute("data-badge-text");this.countdownTimer=setInterval(function(){var t=u.formatTime(Math.max(e.manager.getRemainingTime(),0)),i=h("advertisement",e.player.config)+" - "+t;e.elements.container.setAttribute("data-badge-text",i)},100)}},{key:"onAdsManagerLoaded",value:function(e){var t=this,i=new google.ima.AdsRenderingSettings;i.restoreCustomPlaybackStateOnAdBreakComplete=!0,i.enablePreloading=!0,this.manager=e.getAdsManager(this.player,i),this.cuePoints=this.manager.getCuePoints(),u.is.empty(this.cuePoints)||this.cuePoints.forEach(function(e){if(0!==e&&-1!==e&&e<t.player.duration){var i=t.player.elements.progress;if(u.is.element(i)){var n=100/t.player.duration*e,s=u.createElement("span",{class:t.player.config.classNames.cues});s.style.left=n.toString()+"%",i.appendChild(s)}}}),this.manager.setVolume(this.player.volume),this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(e){return t.onAdError(e)}),Object.keys(google.ima.AdEvent.Type).forEach(function(e){t.manager.addEventListener(google.ima.AdEvent.Type[e],function(e){return t.onAdEvent(e)})}),this.trigger("loaded")}},{key:"onAdEvent",value:function(e){var t=this,i=this.player.elements.container,n=e.getAd(),s=function(e){var i="ads"+e.replace(/_/g,"").toLowerCase();u.dispatchEvent.call(t.player,t.player.media,i)};switch(e.type){case google.ima.AdEvent.Type.LOADED:this.trigger("loaded"),s(e.type),this.pollCountdown(!0),n.isLinear()||(n.width=i.offsetWidth,n.height=i.offsetHeight);break;case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:s(e.type),this.loadAds();break;case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:s(e.type),this.pauseContent();break;case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:s(e.type),this.pollCountdown(),this.resumeContent();break;case google.ima.AdEvent.Type.STARTED:case google.ima.AdEvent.Type.MIDPOINT:case google.ima.AdEvent.Type.COMPLETE:case google.ima.AdEvent.Type.IMPRESSION:case google.ima.AdEvent.Type.CLICK:s(e.type)}}},{key:"onAdError",value:function(e){this.cancel(),this.player.debug.warn("Ads error",e)}},{key:"listeners",value:function(){var e=this,t=this.player.elements.container,i=void 0;this.player.on("ended",function(){e.loader.contentComplete()}),this.player.on("seeking",function(){return i=e.player.currentTime}),this.player.on("seeked",function(){var t=e.player.currentTime;u.is.empty(e.cuePoints)||e.cuePoints.forEach(function(n,s){i<n&&n<t&&(e.manager.discardAdBreak(),e.cuePoints.splice(s,1))})}),window.addEventListener("resize",function(){e.manager&&e.manager.resize(t.offsetWidth,t.offsetHeight,google.ima.ViewMode.NORMAL)})}},{key:"play",value:function(){var e=this,t=this.player.elements.container;this.managerPromise||this.resumeContent(),this.managerPromise.then(function(){e.elements.displayContainer.initialize();try{e.initialized||(e.manager.init(t.offsetWidth,t.offsetHeight,google.ima.ViewMode.NORMAL),e.manager.start()),e.initialized=!0}catch(t){e.onAdError(t)}}).catch(function(){})}},{key:"resumeContent",value:function(){this.elements.container.style.zIndex="",this.playing=!1,this.player.currentTime<this.player.duration&&this.player.play()}},{key:"pauseContent",value:function(){this.elements.container.style.zIndex=3,this.playing=!0,this.player.pause()}},{key:"cancel",value:function(){this.initialized&&this.resumeContent(),this.trigger("error"),this.loadAds()}},{key:"loadAds",value:function(){var e=this;this.managerPromise.then(function(){e.manager&&e.manager.destroy(),e.managerPromise=new Promise(function(t){e.on("loaded",t),e.player.debug.log(e.manager)}),e.requestAds()}).catch(function(){})}},{key:"trigger",value:function(e){for(var t=this,i=arguments.length,n=Array(i>1?i-1:0),s=1;s<i;s++)n[s-1]=arguments[s];var a=this.events[e];u.is.array(a)&&a.forEach(function(e){u.is.function(e)&&e.apply(t,n)})}},{key:"on",value:function(e,t){return u.is.array(this.events[e])||(this.events[e]=[]),this.events[e].push(t),this}},{key:"startSafetyTimer",value:function(e,t){var i=this;this.player.debug.log("Safety timer invoked from: "+t),this.safetyTimer=setTimeout(function(){i.cancel(),i.clearSafetyTimer("startSafetyTimer()")},e)}},{key:"clearSafetyTimer",value:function(e){u.is.nullOrUndefined(this.safetyTimer)||(this.player.debug.log("Safety timer cleared from: "+e),clearTimeout(this.safetyTimer),this.safetyTimer=null)}},{key:"enabled",get:function(){return this.player.isVideo&&this.player.config.ads.enabled&&!u.is.empty(this.publisherId)}},{key:"tagUrl",get:function(){var e={AV_PUBLISHERID:"58c25bb0073ef448b1087ad6",AV_CHANNELID:"5a0458dc28a06145e4519d21",AV_URL:location.hostname,cb:Date.now(),AV_WIDTH:640,AV_HEIGHT:480,AV_CDIM2:this.publisherId};return"https://go.aniview.com/api/adserver6/vast/?"+u.buildUrlParams(e)}}]),e}(),O={insertElements:function(e,t){var i=this;u.is.string(t)?u.insertElement(e,this.media,{src:t}):u.is.array(t)&&t.forEach(function(t){u.insertElement(e,i.media,t)})},change:function(e){var t=this;u.is.object(e)&&"sources"in e&&e.sources.length?(p.cancelRequests.call(this),this.destroy.call(this,function(){switch(t.options.quality=[],u.removeElement(t.media),t.media=null,u.is.element(t.elements.container)&&t.elements.container.removeAttribute("class"),t.type=e.type,t.provider=u.is.empty(e.sources[0].provider)?o.html5:e.sources[0].provider,t.supported=d.check(t.type,t.provider,t.config.playsinline),t.provider+":"+t.type){case"html5:video":t.media=u.createElement("video");break;case"html5:audio":t.media=u.createElement("audio");break;case"youtube:video":case"vimeo:video":t.media=u.createElement("div",{src:e.sources[0].src})}t.elements.container.appendChild(t.media),u.is.boolean(e.autoplay)&&(t.config.autoplay=e.autoplay),t.isHTML5&&(t.config.crossorigin&&t.media.setAttribute("crossorigin",""),t.config.autoplay&&t.media.setAttribute("autoplay",""),u.is.empty(e.poster)||(t.poster=e.poster),t.config.loop.active&&t.media.setAttribute("loop",""),t.config.muted&&t.media.setAttribute("muted",""),t.config.playsinline&&t.media.setAttribute("playsinline","")),C.addStyleHook.call(t),t.isHTML5&&O.insertElements.call(t,"source",e.sources),t.config.title=e.title,q.setup.call(t),t.isHTML5&&("tracks"in e&&O.insertElements.call(t,"track",e.tracks),t.media.load()),(t.isHTML5||t.isEmbed&&!t.supported.ui)&&C.build.call(t),t.fullscreen.update()},!0)):this.debug.warn("Invalid source format")}},j=function(){function e(t,i){var s=this;if(n(this,e),this.timers={},this.ready=!1,this.loading=!1,this.failed=!1,this.touch=d.touch,this.media=t,u.is.string(this.media)&&(this.media=document.querySelectorAll(this.media)),(window.jQuery&&this.media instanceof jQuery||u.is.nodeList(this.media)||u.is.array(this.media))&&(this.media=this.media[0]),this.config=u.extend({},b,e.defaults,i||{},function(){try{return JSON.parse(s.media.getAttribute("data-plyr-config"))}catch(e){return{}}}()),this.elements={container:null,buttons:{},display:{},progress:{},inputs:{},settings:{menu:null,panes:{},tabs:{}},captions:null},this.captions={active:null,currentTrack:null},this.fullscreen={active:!1},this.options={speed:[],quality:[],captions:[]},this.debug=new v(this.config.debug),this.debug.log("Config",this.config),this.debug.log("Support",d),!u.is.nullOrUndefined(this.media)&&u.is.element(this.media))if(this.media.plyr)this.debug.warn("Target already setup");else if(this.config.enabled)if(d.check().api){var a=this.media.cloneNode(!0);a.autoplay=!1,this.elements.original=a;var r=this.media.tagName.toLowerCase(),p=null,h=null,m=null;switch(r){case"div":if(p=this.media.querySelector("iframe"),u.is.element(p)){if(h=p.getAttribute("src"),this.provider=u.getProviderByUrl(h),this.elements.container=this.media,this.media=p,this.elements.container.className="",m=u.getUrlParams(h),!u.is.empty(m)){var g=["1","true"];g.includes(m.autoplay)&&(this.config.autoplay=!0),g.includes(m.loop)&&(this.config.loop.active=!0),this.isYouTube?this.config.playsinline=g.includes(m.playsinline):this.config.playsinline=!0}}else this.provider=this.media.getAttribute(this.config.attributes.embed.provider),this.media.removeAttribute(this.config.attributes.embed.provider);if(u.is.empty(this.provider)||!Object.keys(o).includes(this.provider))return void this.debug.error("Setup failed: Invalid provider");this.type=c.video;break;case"video":case"audio":this.type=r,this.provider=o.html5,this.media.hasAttribute("crossorigin")&&(this.config.crossorigin=!0),this.media.hasAttribute("autoplay")&&(this.config.autoplay=!0),this.media.hasAttribute("playsinline")&&(this.config.playsinline=!0),this.media.hasAttribute("muted")&&(this.config.muted=!0),this.media.hasAttribute("loop")&&(this.config.loop.active=!0);break;default:return void this.debug.error("Setup failed: unsupported type")}this.supported=d.check(this.type,this.provider,this.config.playsinline),this.supported.api?(this.listeners=new P(this),this.storage=new l(this),this.media.plyr=this,u.is.element(this.elements.container)||(this.elements.container=u.createElement("div"),u.wrap(this.media,this.elements.container)),this.elements.container.setAttribute("tabindex",0),C.addStyleHook.call(this),q.setup.call(this),this.config.debug&&u.on(this.elements.container,this.config.events.join(" "),function(e){s.debug.log("event: "+e.type)}),(this.isHTML5||this.isEmbed&&!this.supported.ui)&&C.build.call(this),this.listeners.container(),this.listeners.global(),this.fullscreen=new T(this),this.ads=new _(this),this.config.autoplay&&this.play()):this.debug.error("Setup failed: no support")}else this.debug.error("Setup failed: no support");else this.debug.error("Setup failed: disabled by config");else this.debug.error("Setup failed: no suitable element passed")}return s(e,[{key:"play",value:function(){return u.is.function(this.media.play)?this.media.play():null}},{key:"pause",value:function(){this.playing&&u.is.function(this.media.pause)&&this.media.pause()}},{key:"togglePlay",value:function(e){(u.is.boolean(e)?e:!this.playing)?this.play():this.pause()}},{key:"stop",value:function(){this.isHTML5?(this.pause(),this.restart()):u.is.function(this.media.stop)&&this.media.stop()}},{key:"restart",value:function(){this.currentTime=0}},{key:"rewind",value:function(e){this.currentTime=this.currentTime-(u.is.number(e)?e:this.config.seekTime)}},{key:"forward",value:function(e){this.currentTime=this.currentTime+(u.is.number(e)?e:this.config.seekTime)}},{key:"increaseVolume",value:function(e){var t=this.media.muted?0:this.volume;this.volume=t+(u.is.number(e)?e:1)}},{key:"decreaseVolume",value:function(e){var t=this.media.muted?0:this.volume;this.volume=t-(u.is.number(e)?e:1)}},{key:"toggleCaptions",value:function(e){if(this.supported.ui){var t=u.is.boolean(e)?e:!this.elements.container.classList.contains(this.config.classNames.captions.active);this.captions.active!==t&&(this.captions.active=t,u.toggleState(this.elements.buttons.captions,this.captions.active),u.toggleClass(this.elements.container,this.config.classNames.captions.active,this.captions.active),u.dispatchEvent.call(this,this.media,this.captions.active?"captionsenabled":"captionsdisabled"))}}},{key:"airplay",value:function(){d.airplay&&this.media.webkitShowPlaybackTargetPicker()}},{key:"toggleControls",value:function(e){if(this.supported.ui&&!this.isAudio){var t=u.hasClass(this.elements.container,this.config.classNames.hideControls),i=void 0===e?void 0:!e,n=u.toggleClass(this.elements.container,this.config.classNames.hideControls,i);if(n&&this.config.controls.includes("settings")&&!u.is.empty(this.config.settings)&&g.toggleMenu.call(this,!1),n!==t){var s=n?"controlshidden":"controlsshown";u.dispatchEvent.call(this,this.media,s)}return!n}return!1}},{key:"on",value:function(e,t){u.on(this.elements.container,e,t)}},{key:"off",value:function(e,t){u.off(this.elements.container,e,t)}},{key:"destroy",value:function(e){var t=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.ready){var n=function(){document.body.style.overflow="",t.embed=null,i?(Object.keys(t.elements).length&&(u.removeElement(t.elements.buttons.play),u.removeElement(t.elements.captions),u.removeElement(t.elements.controls),u.removeElement(t.elements.wrapper),t.elements.buttons.play=null,t.elements.captions=null,t.elements.controls=null,t.elements.wrapper=null),u.is.function(e)&&e()):(t.listeners.clear(),u.replaceElement(t.elements.original,t.elements.container),u.dispatchEvent.call(t,t.elements.original,"destroyed",!0),u.is.function(e)&&e.call(t.elements.original),t.ready=!1,setTimeout(function(){t.elements=null,t.media=null},200))};switch(this.stop(),this.provider+":"+this.type){case"html5:video":case"html5:audio":clearTimeout(this.timers.loading),C.toggleNativeControls.call(this,!0),n();break;case"youtube:video":clearInterval(this.timers.buffering),clearInterval(this.timers.playing),null!==this.embed&&u.is.function(this.embed.destroy)&&this.embed.destroy(),n();break;case"vimeo:video":null!==this.embed&&this.embed.unload().then(n),setTimeout(n,200)}}}},{key:"supports",value:function(e){return d.mime.call(this,e)}},{key:"isHTML5",get:function(){return Boolean(this.provider===o.html5)}},{key:"isEmbed",get:function(){return Boolean(this.isYouTube||this.isVimeo)}},{key:"isYouTube",get:function(){return Boolean(this.provider===o.youtube)}},{key:"isVimeo",get:function(){return Boolean(this.provider===o.vimeo)}},{key:"isVideo",get:function(){return Boolean(this.type===c.video)}},{key:"isAudio",get:function(){return Boolean(this.type===c.audio)}},{key:"playing",get:function(){return Boolean(this.ready&&!this.paused&&!this.ended)}},{key:"paused",get:function(){return Boolean(this.media.paused)}},{key:"stopped",get:function(){return Boolean(this.paused&&0===this.currentTime)}},{key:"ended",get:function(){return Boolean(this.media.ended)}},{key:"currentTime",set:function(e){if(this.duration){var t=u.is.number(e)&&e>0;this.media.currentTime=t?Math.min(e,this.duration):0,this.debug.log("Seeking to "+this.currentTime+" seconds")}},get:function(){return Number(this.media.currentTime)}},{key:"buffered",get:function(){var e=this.media.buffered;return u.is.number(e)?e:e&&e.length&&this.duration>0?e.end(0)/this.duration:0}},{key:"seeking",get:function(){return Boolean(this.media.seeking)}},{key:"duration",get:function(){var e=parseFloat(this.config.duration),t=(this.media||{}).duration||0;return e||t}},{key:"volume",set:function(e){var t=e;u.is.string(t)&&(t=Number(t)),u.is.number(t)||(t=this.storage.get("volume")),u.is.number(t)||(t=this.config.volume),t>1&&(t=1),t<0&&(t=0),this.config.volume=t,this.media.volume=t,!u.is.empty(e)&&this.muted&&t>0&&(this.muted=!1)},get:function(){return Number(this.media.volume)}},{key:"muted",set:function(e){var t=e;u.is.boolean(t)||(t=this.storage.get("muted")),u.is.boolean(t)||(t=this.config.muted),this.config.muted=t,this.media.muted=t},get:function(){return Boolean(this.media.muted)}},{key:"hasAudio",get:function(){return!this.isHTML5||(!!this.isAudio||(Boolean(this.media.mozHasAudio)||Boolean(this.media.webkitAudioDecodedByteCount)||Boolean(this.media.audioTracks&&this.media.audioTracks.length)))}},{key:"speed",set:function(e){var t=null;u.is.number(e)&&(t=e),u.is.number(t)||(t=this.storage.get("speed")),u.is.number(t)||(t=this.config.speed.selected),t<.1&&(t=.1),t>2&&(t=2),this.config.speed.options.includes(t)?(this.config.speed.selected=t,this.media.playbackRate=t):this.debug.warn("Unsupported speed ("+t+")")},get:function(){return Number(this.media.playbackRate)}},{key:"quality",set:function(e){var t=null;if(u.is.empty(e)||(t=Number(e)),u.is.number(t)&&0!==t||(t=this.storage.get("quality")),u.is.number(t)||(t=this.config.quality.selected),u.is.number(t)||(t=this.config.quality.default),this.options.quality.length){if(!this.options.quality.includes(t)){var i=u.closest(this.options.quality,t);this.debug.warn("Unsupported quality option: "+t+", using "+i+" instead"),t=i}this.config.quality.selected=t,this.media.quality=t}},get:function(){return this.media.quality}},{key:"loop",set:function(e){var t=u.is.boolean(e)?e:this.config.loop.active;this.config.loop.active=t,this.media.loop=t},get:function(){return Boolean(this.media.loop)}},{key:"source",set:function(e){O.change.call(this,e)},get:function(){return this.media.currentSrc}},{key:"poster",set:function(e){this.isVideo?C.setPoster.call(this,e):this.debug.warn("Poster can only be set for video")},get:function(){return this.isVideo?this.media.getAttribute("poster"):null}},{key:"autoplay",set:function(e){var t=u.is.boolean(e)?e:this.config.autoplay;this.config.autoplay=t},get:function(){return Boolean(this.config.autoplay)}},{key:"language",set:function(e){if(u.is.string(e))if(u.is.empty(e))this.toggleCaptions(!1);else{var t=e.toLowerCase();this.options.captions.includes(t)?(this.toggleCaptions(!0),"enabled"!==t&&this.language!==t&&(this.captions.language=t,f.setText.call(this,null),f.setLanguage.call(this),u.dispatchEvent.call(this,this.media,"languagechange"))):this.debug.warn("Unsupported language option: "+t)}},get:function(){return this.captions.language}},{key:"pip",set:function(e){var t="picture-in-picture",i="inline";if(d.pip){var n=u.is.boolean(e)?e:this.pip===i;this.media.webkitSetPresentationMode(n?t:i)}},get:function(){return d.pip?this.media.webkitPresentationMode:null}}],[{key:"supported",value:function(e,t,i){return d.check(e,t,i)}},{key:"loadSprite",value:function(e,t){return u.loadSprite(e,t)}},{key:"setup",value:function(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=null;return u.is.string(t)?n=Array.from(document.querySelectorAll(t)):u.is.nodeList(t)?n=Array.from(t):u.is.array(t)&&(n=t.filter(function(e){return u.is.element(e)})),u.is.empty(n)?null:n.map(function(t){return new e(t,i)})}}]),e}();return j.defaults=u.cloneDeep(b),j});
	//# sourceMappingURL=plyr.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 287 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(286);
	exports.encode = exports.stringify = __webpack_require__(287);


/***/ }),
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(9);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(69);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 *
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disables exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onExited: _this.handleExited.bind(_this, child),
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: _this2.handleExited.bind(_this2, child),
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: _this2.handleExited.bind(_this2, child),
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    this.setState(function (state) {
	      var children = _extends({}, state.children);
	
	      delete children[child.key];
	      return { children: children };
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = values(this.state.children).map(childFactory);
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransition = __webpack_require__(417);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _ReplaceTransition = __webpack_require__(418);
	
	var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);
	
	var _TransitionGroup = __webpack_require__(295);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Transition = __webpack_require__(294);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition2.default,
	  TransitionGroup: _TransitionGroup2.default,
	  ReplaceTransition: _ReplaceTransition2.default,
	  CSSTransition: _CSSTransition2.default
	};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterDone: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitDone: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	'use strict'
	
	/**
	 * Remove a range of items from an array
	 *
	 * @function removeItems
	 * @param {Array<*>} arr The target array
	 * @param {number} startIdx The index to begin removing from (inclusive)
	 * @param {number} removeCount How many items to remove
	 */
	module.exports = function removeItems(arr, startIdx, removeCount)
	{
	  var i, length = arr.length
	
	  if (startIdx >= length || removeCount === 0) {
	    return
	  }
	
	  removeCount = (startIdx + removeCount > length ? length - startIdx : removeCount)
	
	  var len = length - removeCount
	
	  for (i = startIdx; i < len; ++i) {
	    arr[i] = arr[i + removeCount]
	  }
	
	  arr.length = len
	}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _miniSignals = __webpack_require__(89);
	
	var _miniSignals2 = _interopRequireDefault(_miniSignals);
	
	var _parseUri = __webpack_require__(90);
	
	var _parseUri2 = _interopRequireDefault(_parseUri);
	
	var _async = __webpack_require__(137);
	
	var async = _interopRequireWildcard(_async);
	
	var _Resource = __webpack_require__(70);
	
	var _Resource2 = _interopRequireDefault(_Resource);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// some constants
	var MAX_PROGRESS = 100;
	var rgxExtractUrlHash = /(#[\w-]+)?$/;
	
	/**
	 * Manages the state and loading of multiple resources to load.
	 *
	 * @class
	 */
	
	var Loader = function () {
	    /**
	     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	     * @param {number} [concurrency=10] - The number of resources to load concurrently.
	     */
	    function Loader() {
	        var _this = this;
	
	        var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var concurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	        _classCallCheck(this, Loader);
	
	        /**
	         * The base url for all resources loaded by this loader.
	         *
	         * @member {string}
	         */
	        this.baseUrl = baseUrl;
	
	        /**
	         * The progress percent of the loader going through the queue.
	         *
	         * @member {number}
	         */
	        this.progress = 0;
	
	        /**
	         * Loading state of the loader, true if it is currently loading resources.
	         *
	         * @member {boolean}
	         */
	        this.loading = false;
	
	        /**
	         * A querystring to append to every URL added to the loader.
	         *
	         * This should be a valid query string *without* the question-mark (`?`). The loader will
	         * also *not* escape values for you. Make sure to escape your parameters with
	         * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
	         *
	         * @example
	         * const loader = new Loader();
	         *
	         * loader.defaultQueryString = 'user=me&password=secret';
	         *
	         * // This will request 'image.png?user=me&password=secret'
	         * loader.add('image.png').load();
	         *
	         * loader.reset();
	         *
	         * // This will request 'image.png?v=1&user=me&password=secret'
	         * loader.add('iamge.png?v=1').load();
	         */
	        this.defaultQueryString = '';
	
	        /**
	         * The middleware to run before loading each resource.
	         *
	         * @member {function[]}
	         */
	        this._beforeMiddleware = [];
	
	        /**
	         * The middleware to run after loading each resource.
	         *
	         * @member {function[]}
	         */
	        this._afterMiddleware = [];
	
	        /**
	         * The tracks the resources we are currently completing parsing for.
	         *
	         * @member {Resource[]}
	         */
	        this._resourcesParsing = [];
	
	        /**
	         * The `_loadResource` function bound with this object context.
	         *
	         * @private
	         * @member {function}
	         * @param {Resource} r - The resource to load
	         * @param {Function} d - The dequeue function
	         * @return {undefined}
	         */
	        this._boundLoadResource = function (r, d) {
	            return _this._loadResource(r, d);
	        };
	
	        /**
	         * The resources waiting to be loaded.
	         *
	         * @private
	         * @member {Resource[]}
	         */
	        this._queue = async.queue(this._boundLoadResource, concurrency);
	
	        this._queue.pause();
	
	        /**
	         * All the resources for this loader keyed by name.
	         *
	         * @member {object<string, Resource>}
	         */
	        this.resources = {};
	
	        /**
	         * Dispatched once per loaded or errored resource.
	         *
	         * The callback looks like {@link Loader.OnProgressSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onProgress = new _miniSignals2.default();
	
	        /**
	         * Dispatched once per errored resource.
	         *
	         * The callback looks like {@link Loader.OnErrorSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onError = new _miniSignals2.default();
	
	        /**
	         * Dispatched once per loaded resource.
	         *
	         * The callback looks like {@link Loader.OnLoadSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onLoad = new _miniSignals2.default();
	
	        /**
	         * Dispatched when the loader begins to process the queue.
	         *
	         * The callback looks like {@link Loader.OnStartSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onStart = new _miniSignals2.default();
	
	        /**
	         * Dispatched when the queued resources all load.
	         *
	         * The callback looks like {@link Loader.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onComplete = new _miniSignals2.default();
	
	        /**
	         * When the progress changes the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnProgressSignal
	         * @param {Loader} loader - The loader the progress is advancing on.
	         * @param {Resource} resource - The resource that has completed or failed to cause the progress to advance.
	         */
	
	        /**
	         * When an error occurrs the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnErrorSignal
	         * @param {Loader} loader - The loader the error happened in.
	         * @param {Resource} resource - The resource that caused the error.
	         */
	
	        /**
	         * When a load completes the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnLoadSignal
	         * @param {Loader} loader - The loader that laoded the resource.
	         * @param {Resource} resource - The resource that has completed loading.
	         */
	
	        /**
	         * When the loader starts loading resources it dispatches this callback.
	         *
	         * @memberof Loader
	         * @callback OnStartSignal
	         * @param {Loader} loader - The loader that has started loading resources.
	         */
	
	        /**
	         * When the loader completes loading resources it dispatches this callback.
	         *
	         * @memberof Loader
	         * @callback OnCompleteSignal
	         * @param {Loader} loader - The loader that has finished loading resources.
	         */
	    }
	
	    /**
	     * Adds a resource (or multiple resources) to the loader queue.
	     *
	     * This function can take a wide variety of different parameters. The only thing that is always
	     * required the url to load. All the following will work:
	     *
	     * ```js
	     * loader
	     *     // normal param syntax
	     *     .add('key', 'http://...', function () {})
	     *     .add('http://...', function () {})
	     *     .add('http://...')
	     *
	     *     // object syntax
	     *     .add({
	     *         name: 'key2',
	     *         url: 'http://...'
	     *     }, function () {})
	     *     .add({
	     *         url: 'http://...'
	     *     }, function () {})
	     *     .add({
	     *         name: 'key3',
	     *         url: 'http://...'
	     *         onComplete: function () {}
	     *     })
	     *     .add({
	     *         url: 'https://...',
	     *         onComplete: function () {},
	     *         crossOrigin: true
	     *     })
	     *
	     *     // you can also pass an array of objects or urls or both
	     *     .add([
	     *         { name: 'key4', url: 'http://...', onComplete: function () {} },
	     *         { url: 'http://...', onComplete: function () {} },
	     *         'http://...'
	     *     ])
	     *
	     *     // and you can use both params and options
	     *     .add('key', 'http://...', { crossOrigin: true }, function () {})
	     *     .add('http://...', { crossOrigin: true }, function () {});
	     * ```
	     *
	     * @param {string} [name] - The name of the resource to load, if not passed the url is used.
	     * @param {string} [url] - The url for this resource, relative to the baseUrl of this loader.
	     * @param {object} [options] - The options for the load.
	     * @param {boolean} [options.crossOrigin] - Is this request cross-origin? Default is to determine automatically.
	     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource be loaded?
	     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How should
	     *      the data being loaded be interpreted when using XHR?
	     * @param {object} [options.metadata] - Extra configuration for middleware and the Resource object.
	     * @param {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [options.metadata.loadElement=null] - The
	     *      element to use for loading, instead of creating one.
	     * @param {boolean} [options.metadata.skipSource=false] - Skips adding source(s) to the load element. This
	     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
	     * @param {function} [cb] - Function to call when this specific resource completes loading.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.add = function add(name, url, options, cb) {
	        // special case of an array of objects or urls
	        if (Array.isArray(name)) {
	            for (var i = 0; i < name.length; ++i) {
	                this.add(name[i]);
	            }
	
	            return this;
	        }
	
	        // if an object is passed instead of params
	        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	            cb = url || name.callback || name.onComplete;
	            options = name;
	            url = name.url;
	            name = name.name || name.key || name.url;
	        }
	
	        // case where no name is passed shift all args over by one.
	        if (typeof url !== 'string') {
	            cb = options;
	            options = url;
	            url = name;
	        }
	
	        // now that we shifted make sure we have a proper url.
	        if (typeof url !== 'string') {
	            throw new Error('No url passed to add resource to loader.');
	        }
	
	        // options are optional so people might pass a function and no options
	        if (typeof options === 'function') {
	            cb = options;
	            options = null;
	        }
	
	        // if loading already you can only add resources that have a parent.
	        if (this.loading && (!options || !options.parentResource)) {
	            throw new Error('Cannot add resources while the loader is running.');
	        }
	
	        // check if resource already exists.
	        if (this.resources[name]) {
	            throw new Error('Resource named "' + name + '" already exists.');
	        }
	
	        // add base url if this isn't an absolute url
	        url = this._prepareUrl(url);
	
	        // create the store the resource
	        this.resources[name] = new _Resource2.default(name, url, options);
	
	        if (typeof cb === 'function') {
	            this.resources[name].onAfterMiddleware.once(cb);
	        }
	
	        // if actively loading, make sure to adjust progress chunks for that parent and its children
	        if (this.loading) {
	            var parent = options.parentResource;
	            var incompleteChildren = [];
	
	            for (var _i = 0; _i < parent.children.length; ++_i) {
	                if (!parent.children[_i].isComplete) {
	                    incompleteChildren.push(parent.children[_i]);
	                }
	            }
	
	            var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
	            var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child
	
	            parent.children.push(this.resources[name]);
	            parent.progressChunk = eachChunk;
	
	            for (var _i2 = 0; _i2 < incompleteChildren.length; ++_i2) {
	                incompleteChildren[_i2].progressChunk = eachChunk;
	            }
	
	            this.resources[name].progressChunk = eachChunk;
	        }
	
	        // add the resource to the queue
	        this._queue.push(this.resources[name]);
	
	        return this;
	    };
	
	    /**
	     * Sets up a middleware function that will run *before* the
	     * resource is loaded.
	     *
	     * @method before
	     * @param {function} fn - The middleware function to register.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.pre = function pre(fn) {
	        this._beforeMiddleware.push(fn);
	
	        return this;
	    };
	
	    /**
	     * Sets up a middleware function that will run *after* the
	     * resource is loaded.
	     *
	     * @alias use
	     * @method after
	     * @param {function} fn - The middleware function to register.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.use = function use(fn) {
	        this._afterMiddleware.push(fn);
	
	        return this;
	    };
	
	    /**
	     * Resets the queue of the loader to prepare for a new load.
	     *
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.reset = function reset() {
	        this.progress = 0;
	        this.loading = false;
	
	        this._queue.kill();
	        this._queue.pause();
	
	        // abort all resource loads
	        for (var k in this.resources) {
	            var res = this.resources[k];
	
	            if (res._onLoadBinding) {
	                res._onLoadBinding.detach();
	            }
	
	            if (res.isLoading) {
	                res.abort();
	            }
	        }
	
	        this.resources = {};
	
	        return this;
	    };
	
	    /**
	     * Starts loading the queued resources.
	     *
	     * @param {function} [cb] - Optional callback that will be bound to the `complete` event.
	     * @return {Loader} Returns itself.
	     */
	
	
	    Loader.prototype.load = function load(cb) {
	        // register complete callback if they pass one
	        if (typeof cb === 'function') {
	            this.onComplete.once(cb);
	        }
	
	        // if the queue has already started we are done here
	        if (this.loading) {
	            return this;
	        }
	
	        if (this._queue.idle()) {
	            this._onStart();
	            this._onComplete();
	        } else {
	            // distribute progress chunks
	            var numTasks = this._queue._tasks.length;
	            var chunk = 100 / numTasks;
	
	            for (var i = 0; i < this._queue._tasks.length; ++i) {
	                this._queue._tasks[i].data.progressChunk = chunk;
	            }
	
	            // notify we are starting
	            this._onStart();
	
	            // start loading
	            this._queue.resume();
	        }
	
	        return this;
	    };
	
	    /**
	     * The number of resources to load concurrently.
	     *
	     * @member {number}
	     * @default 10
	     */
	
	
	    /**
	     * Prepares a url for usage based on the configuration of this object
	     *
	     * @private
	     * @param {string} url - The url to prepare.
	     * @return {string} The prepared url.
	     */
	    Loader.prototype._prepareUrl = function _prepareUrl(url) {
	        var parsedUrl = (0, _parseUri2.default)(url, { strictMode: true });
	        var result = void 0;
	
	        // absolute url, just use it as is.
	        if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) {
	            result = url;
	        }
	        // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
	        else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') {
	                result = this.baseUrl + '/' + url;
	            } else {
	                result = this.baseUrl + url;
	            }
	
	        // if we need to add a default querystring, there is a bit more work
	        if (this.defaultQueryString) {
	            var hash = rgxExtractUrlHash.exec(result)[0];
	
	            result = result.substr(0, result.length - hash.length);
	
	            if (result.indexOf('?') !== -1) {
	                result += '&' + this.defaultQueryString;
	            } else {
	                result += '?' + this.defaultQueryString;
	            }
	
	            result += hash;
	        }
	
	        return result;
	    };
	
	    /**
	     * Loads a single resource.
	     *
	     * @private
	     * @param {Resource} resource - The resource to load.
	     * @param {function} dequeue - The function to call when we need to dequeue this item.
	     */
	
	
	    Loader.prototype._loadResource = function _loadResource(resource, dequeue) {
	        var _this2 = this;
	
	        resource._dequeue = dequeue;
	
	        // run before middleware
	        async.eachSeries(this._beforeMiddleware, function (fn, next) {
	            fn.call(_this2, resource, function () {
	                // if the before middleware marks the resource as complete,
	                // break and don't process any more before middleware
	                next(resource.isComplete ? {} : null);
	            });
	        }, function () {
	            if (resource.isComplete) {
	                _this2._onLoad(resource);
	            } else {
	                resource._onLoadBinding = resource.onComplete.once(_this2._onLoad, _this2);
	                resource.load();
	            }
	        }, true);
	    };
	
	    /**
	     * Called once loading has started.
	     *
	     * @private
	     */
	
	
	    Loader.prototype._onStart = function _onStart() {
	        this.progress = 0;
	        this.loading = true;
	        this.onStart.dispatch(this);
	    };
	
	    /**
	     * Called once each resource has loaded.
	     *
	     * @private
	     */
	
	
	    Loader.prototype._onComplete = function _onComplete() {
	        this.progress = MAX_PROGRESS;
	        this.loading = false;
	        this.onComplete.dispatch(this, this.resources);
	    };
	
	    /**
	     * Called each time a resources is loaded.
	     *
	     * @private
	     * @param {Resource} resource - The resource that was loaded
	     */
	
	
	    Loader.prototype._onLoad = function _onLoad(resource) {
	        var _this3 = this;
	
	        resource._onLoadBinding = null;
	
	        // remove this resource from the async queue, and add it to our list of resources that are being parsed
	        this._resourcesParsing.push(resource);
	        resource._dequeue();
	
	        // run all the after middleware for this resource
	        async.eachSeries(this._afterMiddleware, function (fn, next) {
	            fn.call(_this3, resource, next);
	        }, function () {
	            resource.onAfterMiddleware.dispatch(resource);
	
	            _this3.progress += resource.progressChunk;
	            _this3.onProgress.dispatch(_this3, resource);
	
	            if (resource.error) {
	                _this3.onError.dispatch(resource.error, _this3, resource);
	            } else {
	                _this3.onLoad.dispatch(_this3, resource);
	            }
	
	            _this3._resourcesParsing.splice(_this3._resourcesParsing.indexOf(resource), 1);
	
	            // do completion check
	            if (_this3._queue.idle() && _this3._resourcesParsing.length === 0) {
	                _this3._onComplete();
	            }
	        }, true);
	    };
	
	    _createClass(Loader, [{
	        key: 'concurrency',
	        get: function get() {
	            return this._queue.concurrency;
	        }
	        // eslint-disable-next-line require-jsdoc
	        ,
	        set: function set(concurrency) {
	            this._queue.concurrency = concurrency;
	        }
	    }]);
	
	    return Loader;
	}();
	
	exports.default = Loader;
	//# sourceMappingURL=Loader.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.blobMiddlewareFactory = blobMiddlewareFactory;
	
	var _Resource = __webpack_require__(70);
	
	var _Resource2 = _interopRequireDefault(_Resource);
	
	var _b = __webpack_require__(138);
	
	var _b2 = _interopRequireDefault(_b);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Url = window.URL || window.webkitURL;
	
	// a middleware for transforming XHR loaded Blobs into more useful objects
	function blobMiddlewareFactory() {
	    return function blobMiddleware(resource, next) {
	        if (!resource.data) {
	            next();
	
	            return;
	        }
	
	        // if this was an XHR load of a blob
	        if (resource.xhr && resource.xhrType === _Resource2.default.XHR_RESPONSE_TYPE.BLOB) {
	            // if there is no blob support we probably got a binary string back
	            if (!window.Blob || typeof resource.data === 'string') {
	                var type = resource.xhr.getResponseHeader('content-type');
	
	                // this is an image, convert the binary string into a data url
	                if (type && type.indexOf('image') === 0) {
	                    resource.data = new Image();
	                    resource.data.src = 'data:' + type + ';base64,' + _b2.default.encodeBinary(resource.xhr.responseText);
	
	                    resource.type = _Resource2.default.TYPE.IMAGE;
	
	                    // wait until the image loads and then callback
	                    resource.data.onload = function () {
	                        resource.data.onload = null;
	
	                        next();
	                    };
	
	                    // next will be called on load
	                    return;
	                }
	            }
	            // if content type says this is an image, then we should transform the blob into an Image object
	            else if (resource.data.type.indexOf('image') === 0) {
	                    var _ret = function () {
	                        var src = Url.createObjectURL(resource.data);
	
	                        resource.blob = resource.data;
	                        resource.data = new Image();
	                        resource.data.src = src;
	
	                        resource.type = _Resource2.default.TYPE.IMAGE;
	
	                        // cleanup the no longer used blob after the image loads
	                        // TODO: Is this correct? Will the image be invalid after revoking?
	                        resource.data.onload = function () {
	                            Url.revokeObjectURL(src);
	                            resource.data.onload = null;
	
	                            next();
	                        };
	
	                        // next will be called on load.
	                        return {
	                            v: void 0
	                        };
	                    }();
	
	                    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	                }
	        }
	
	        next();
	    };
	}
	//# sourceMappingURL=blob.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(303)(module), (function() { return this; }())))

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OpenCloseButtonModule = __webpack_require__(865);
	
	var _OpenCloseButtonModule2 = _interopRequireDefault(_OpenCloseButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OpenCloseButton = function OpenCloseButton(_ref) {
	  var clicked = _ref.clicked,
	      onClick = _ref.onClick,
	      buttonStyle = _ref.buttonStyle;
	  return _react2.default.createElement(
	    'button',
	    {
	      name: 'button',
	      className: buttonStyle !== 'close' ? _OpenCloseButtonModule2.default.button : _OpenCloseButtonModule2.default.closeButton,
	      onClick: onClick
	    },
	    buttonStyle !== 'close' ? _react2.default.createElement('div', { className: !clicked ? _OpenCloseButtonModule2.default.cross : _OpenCloseButtonModule2.default.crossClicked }) : _react2.default.createElement('div', { className: _OpenCloseButtonModule2.default.crossClicked })
	  );
	};
	
	exports.default = OpenCloseButton;
	module.exports = exports['default'];

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageSliderPixi = __webpack_require__(338);
	
	var _ImageSliderPixi2 = _interopRequireDefault(_ImageSliderPixi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageSlider = function (_Component) {
	  _inherits(ImageSlider, _Component);
	
	  function ImageSlider() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageSlider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.isSetup = false, _this.resizePixi = function () {
	      _this.imageSlider.updatePixiSize(_this.pixiContainer.offsetWidth, _this.pixiContainer.offsetHeight);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ImageSlider.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.display && !this.isSetup) {
	      this.setup();
	    }
	  };
	
	  ImageSlider.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.display && !prevProps.display && !this.isSetup) {
	      this.setup();
	    }
	  };
	
	  ImageSlider.prototype.setup = function setup() {
	    this.isSetup = true;
	    // create pixi slider
	    var imgSrcs = this.props.images.map(function (imgData) {
	      return imgData.sizes.large;
	    });
	    console.log('pixi size', this.pixiContainer.offsetWidth, this.pixiContainer.offsetHeight);
	    this.imageSlider = new _ImageSliderPixi2.default(this.pixiContainer, imgSrcs, this.pixiContainer.offsetWidth, this.pixiContainer.offsetHeight);
	    this.props.registerNextListener(this.imageSlider.nextSlide);
	    this.props.registerPrevListener(this.imageSlider.prevSlide);
	    this.props.registerOpenListener(this.imageSlider.open);
	    this.props.registerCloseListener(this.imageSlider.close);
	    this.props.registerCloseSectionListener(this.imageSlider.closeSection);
	
	    window.addEventListener('resize', this.resizePixi);
	  };
	
	  ImageSlider.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.resizePixi);
	    if (this.imageSlider && this.imageSlider.app) {
	      this.imageSlider.app.destroy(true, { children: true });
	    }
	  };
	
	  ImageSlider.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement('div', {
	      ref: function ref(el) {
	        _this2.pixiContainer = el;
	      },
	      style: {
	        width: '100%',
	        height: '100%',
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        pointerEvents: 'none'
	      }
	    });
	  };
	
	  return ImageSlider;
	}(_react.Component);
	
	exports.default = ImageSlider;
	module.exports = exports['default'];

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Slide = __webpack_require__(339);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PIXI = void 0;
	if (typeof window !== 'undefined') {
	  PIXI = __webpack_require__(33);
	}
	
	var closeAlpha = 0.95;
	var breakpoint = 800;
	
	var ImageSliderPixi = function () {
	  function ImageSliderPixi(containerEl, imgs) {
	    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.innerWidth;
	    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.innerHeight;
	
	    _classCallCheck(this, ImageSliderPixi);
	
	    _initialiseProps.call(this);
	
	    this.app = new PIXI.Application({
	      width: width,
	      height: height,
	      antialias: false,
	      transparent: true,
	      resolution: 1
	    });
	    this.imgs = imgs;
	    this.size = imgs.length;
	    if (this.size === 1) {
	      this.draw = this.drawOne;
	      this.open = this.openOne;
	      this.close = this.closeOne;
	    } else if (this.size === 2) {
	      this.draw = this.drawTwo;
	      this.open = this.openTwo;
	      this.close = this.closeTwo;
	    } else {
	      this.draw = this.drawThree;
	      this.open = this.openThree;
	      this.close = this.closeThree;
	    }
	    // make pixi full screen
	    this.app.renderer.view.style.position = 'absolute';
	    this.app.renderer.view.style.display = 'block';
	    this.app.renderer.autoResize = true;
	    containerEl.appendChild(this.app.view);
	    this.createSlides();
	    // this.loadImages(imgs, this.createSlides);
	  }
	
	  ImageSliderPixi.prototype.getPrevIndex = function getPrevIndex() {
	    if (this.currentIndex === 0) {
	      return this.size - 1;
	    }
	    return this.currentIndex - 1;
	  };
	
	  ImageSliderPixi.prototype.getNextIndex = function getNextIndex() {
	    if (this.currentIndex === this.size - 1) {
	      return 0;
	    }
	    return this.currentIndex + 1;
	  };
	
	  ImageSliderPixi.prototype.getView = function getView() {
	    return this.app.view;
	  };
	
	  return ImageSliderPixi;
	}();
	
	var _initialiseProps = function _initialiseProps() {
	  var _this = this;
	
	  this.currentIndex = 0;
	  this.slidesCreated = 0;
	
	  this.closeSection = function (activeIndex) {
	    var current = _this.currentIndex;
	    var nextIndex = _this.getNextIndex();
	    var prevIndex = _this.getPrevIndex();
	    if (_this.slides.length >= 3) {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === current) {
	          // move(size, alpha, screenAlign = true, darken = false, duration = 1) {
	
	          slide.move('full', 0.6, undefined, undefined, 0.7);
	        } else if (slide.index === prevIndex) {
	          slide.move('offLeft', closeAlpha, undefined, undefined, 0.7);
	        } else if (slide.index === nextIndex) {
	          slide.move('offRight', closeAlpha, undefined, undefined, 0.7);
	        } else {
	          slide.off();
	        }
	      });
	    } else if (_this.slides.length === 2) {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === 0) {
	          slide.move('full', 0.6, undefined, undefined, 0.7);
	        } else {
	          slide.move('offRight', closeAlpha, undefined, undefined, 0.7);
	        }
	      });
	    } else {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === current) {
	          // move(size, alpha, screenAlign = true, darken = false, duration = 1) {
	          slide.move('full', 0.6, undefined, undefined, 0.7);
	        } else {
	          slide.off();
	        }
	      });
	    }
	  };
	
	  this.openOne = function () {
	    _this.slides[0].move('full', 0, false);
	  };
	
	  this.openTwo = function (openIndex) {
	    if (window.innerWidth > breakpoint) {
	      if (openIndex === 0) {
	        _this.slides[0].move('full', 0, false);
	        _this.slides[1].move('offRight', closeAlpha, false, true);
	      } else {
	        _this.slides[1].move('full', 0);
	        _this.slides[0].move('offLeft', closeAlpha, false);
	      }
	    } else {
	      if (_this.currentIndex === 0) {
	        _this.slides[0].move('full', 0);
	        _this.slides[1].draw('offRight');
	      } else {
	        _this.slides[0].draw('offLeft');
	        _this.slides[1].move('full', 0);
	      }
	    }
	  };
	
	  this.openThree = function () {
	    var current = _this.currentIndex;
	    var nextIndex = _this.getNextIndex();
	    var prevIndex = _this.getPrevIndex();
	    _this.slides.forEach(function (slide) {
	      if (slide.index === current) {
	        slide.move('full', 0);
	      } else if (slide.index === prevIndex) {
	        slide.move('offLeft', closeAlpha);
	      } else if (slide.index === nextIndex) {
	        slide.move('offRight', closeAlpha);
	      } else {
	        slide.off();
	      }
	    });
	  };
	
	  this.closeOne = function () {
	    _this.slides[0].move('full', 0.6, false);
	  };
	
	  this.closeTwo = function () {
	    if (window.innerWidth > breakpoint) {
	      _this.slides[0].move('halfLeft', 'default', false);
	      _this.slides[1].move('halfRight', 'default', false, true);
	    } else {
	      if (_this.currentIndex === 0) {
	        _this.slides[0].move('full');
	        _this.slides[1].move('offRight');
	      } else {
	        _this.slides[0].move('offLeft');
	        _this.slides[1].move('full');
	      }
	    }
	  };
	
	  this.closeThree = function () {
	    var current = _this.currentIndex;
	    var nextIndex = _this.getNextIndex();
	    var prevIndex = _this.getPrevIndex();
	    if (window.innerWidth > breakpoint) {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === current) {
	          slide.move('center');
	        } else if (slide.index === prevIndex) {
	          slide.move('left');
	        } else if (slide.index === nextIndex) {
	          slide.move('right');
	        } else {
	          slide.off();
	        }
	      });
	    } else {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === current) {
	          slide.move('full');
	        } else if (slide.index === prevIndex) {
	          slide.move('offLeft');
	        } else if (slide.index === nextIndex) {
	          slide.move('offRight');
	        } else {
	          slide.off();
	        }
	      });
	    }
	  };
	
	  this.nextSlide = function () {
	    var current = _this.currentIndex;
	    var exitingIndex = _this.getPrevIndex();
	    var nextIndex = _this.getNextIndex();
	    _this.currentIndex = nextIndex;
	    var enteringIndex = _this.getNextIndex();
	    if (window.innerWidth > breakpoint) {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === current) {
	          slide.move('left');
	        } else if (slide.index === exitingIndex) {
	          slide.move('offLeft');
	        } else if (slide.index === nextIndex) {
	          slide.move('center');
	        } else if (slide.index === enteringIndex) {
	          slide.enterFromRight();
	        } else {
	          slide.off();
	        }
	      });
	    } else {
	      if (_this.size === 2) {
	        _this.slides[1 - current].draw('offRight');
	        _this.slides[1 - current].move('full');
	        _this.slides[current].move('offLeft');
	      } else {
	        _this.slides.forEach(function (slide) {
	          if (slide.index === current) {
	            slide.move('offLeft');
	          } else if (slide.index === exitingIndex) {
	            slide.move('offLeft');
	          } else if (slide.index === nextIndex) {
	            slide.move('full');
	          } else if (slide.index === enteringIndex) {
	            slide.draw('offRight');
	          } else {
	            slide.off();
	          }
	        });
	      }
	    }
	  };
	
	  this.prevSlide = function () {
	    var current = _this.currentIndex;
	    var exitingIndex = _this.getNextIndex();
	    var prevIndex = _this.getPrevIndex();
	    _this.currentIndex = prevIndex;
	    var enteringIndex = _this.getPrevIndex();
	
	    if (window.innerWidth > breakpoint) {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === current) {
	          slide.move('right');
	        } else if (slide.index === exitingIndex) {
	          slide.move('offRight');
	        } else if (slide.index === prevIndex) {
	          slide.move('center');
	        } else if (slide.index === enteringIndex) {
	          slide.enterFromLeft();
	        } else {
	          slide.off();
	        }
	      });
	    } else {
	      if (_this.size === 2) {
	        _this.slides[1 - current].draw('offLeft');
	        _this.slides[1 - current].move('full');
	        _this.slides[current].move('offRight');
	      } else {
	        _this.slides.forEach(function (slide) {
	          if (slide.index === current) {
	            slide.move('offRight');
	          } else if (slide.index === exitingIndex) {
	            slide.move('offRight');
	          } else if (slide.index === prevIndex) {
	            slide.move('full');
	          } else if (slide.index === enteringIndex) {
	            slide.draw('offLeft');
	          } else {
	            slide.off();
	          }
	        });
	      }
	    }
	  };
	
	  this.drawOne = function () {
	    _this.slides.forEach(function (slide) {
	      slide.draw('full', false);
	    });
	  };
	
	  this.drawTwo = function () {
	    if (window.innerWidth > breakpoint) {
	      _this.slides[0].draw('halfLeft', false);
	      _this.slides[1].draw('halfRight', false, true);
	    } else {
	      if (_this.currentIndex === 0) {
	        _this.slides[0].draw('full');
	        _this.slides[1].draw('offRight');
	      } else {
	        _this.slides[1].draw('full');
	        _this.slides[0].draw('offLeft');
	      }
	    }
	  };
	
	  this.drawThree = function () {
	    var currentIndex = _this.currentIndex;
	    var prevIndex = _this.getPrevIndex();
	    var nextIndex = _this.getNextIndex();
	
	    if (window.innerWidth > breakpoint) {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === _this.currentIndex) {
	          slide.draw('center');
	        } else if (slide.index === prevIndex) {
	          slide.draw('left');
	        } else if (slide.index === nextIndex) {
	          slide.draw('right');
	        } else {
	          slide.off();
	        }
	      });
	    } else {
	      _this.slides.forEach(function (slide) {
	        if (slide.index === _this.currentIndex) {
	          slide.draw('full');
	        } else if (slide.index === prevIndex) {
	          slide.draw('offLeft');
	        } else if (slide.index === nextIndex) {
	          slide.draw('offRight');
	        } else {
	          slide.off();
	        }
	      });
	    }
	  };
	
	  this.onSlideCreated = function () {
	    _this.slidesCreated += 1;
	    if (_this.slidesCreated === _this.size) {
	      _this.draw();
	    }
	  };
	
	  this.createSlides = function () {
	    if (_this.slides) {
	      _this.draw();
	      return;
	    }
	
	    if (_this.size >= 3 && _this.size <= 4) {
	      _this.imgs = [].concat(_this.imgs, _this.imgs);
	      _this.size = _this.size * 2;
	    }
	    _this.slides = _this.imgs.map(function (img, i) {
	      var slide = new _Slide2.default(img, i, _this.app, _this.onSlideCreated, 0.5, 0.5);
	      _this.app.stage.addChild(slide.getContainer());
	      return slide;
	    });
	  };
	
	  this.updatePixiSize = function (width, height) {
	    _this.app.renderer.resize(width, height);
	    _this.draw();
	  };
	};
	
	exports.default = ImageSliderPixi;
	module.exports = exports['default'];

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FramedImage = __webpack_require__(83);
	
	var _FramedImage2 = _interopRequireDefault(_FramedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PIXI = void 0;
	if (typeof window !== 'undefined') {
	  PIXI = __webpack_require__(33);
	}
	
	var Slide = function () {
	  function Slide(imgSrc, index, app, callback) {
	    var _this = this;
	
	    var focalX = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.5;
	    var focalY = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0.5;
	
	    _classCallCheck(this, Slide);
	
	    console.log(imgSrc);
	    this.index = index;
	    this.container = new PIXI.Container();
	    this.app = app;
	    this.framedImage = new _FramedImage2.default(app, imgSrc, false, focalX, focalY, 0.5);
	    this.framedImage.load().then(function () {
	      _this.container.addChild(_this.framedImage.mask, _this.framedImage.imgContainer);
	      _this.framedImage.setVisible(true);
	      if (callback) {
	        callback();
	      }
	    });
	    this.container.visible = false;
	  }
	
	  Slide.prototype.getContainer = function getContainer() {
	    return this.container;
	  };
	
	  Slide.prototype.setVisible = function setVisible() {
	    var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    this.container.visible = bool;
	  };
	
	  Slide.prototype.getDimensions = function getDimensions(size) {
	    var containerWidth = this.app.renderer.width;
	    var containerHeight = this.app.renderer.height;
	    switch (size) {
	      case 'left':
	        return {
	          width: containerWidth * 0.27,
	          height: containerHeight,
	          x: 0,
	          y: 0
	        };
	      case 'right':
	        return {
	          width: containerWidth * 0.27,
	          height: containerHeight,
	          x: containerWidth * 0.73,
	          y: 0
	        };
	      case 'closeLeft':
	        return {
	          width: 0,
	          height: containerHeight,
	          x: containerWidth * 0.27,
	          y: 0
	        };
	      case 'closeRight':
	        return {
	          width: 0,
	          height: containerHeight,
	          x: containerWidth * 0.73,
	          y: 0
	        };
	      case 'center':
	        return {
	          width: containerWidth * 0.46,
	          height: containerHeight,
	          x: containerWidth * 0.27,
	          y: 0
	        };
	      case 'halfLeft':
	        return {
	          width: containerWidth / 2,
	          height: containerHeight,
	          x: 0,
	          y: 0
	        };
	      case 'halfRight':
	        return {
	          width: containerWidth / 2,
	          height: containerHeight,
	          x: containerWidth / 2,
	          y: 0
	        };
	      case 'offLeft':
	        return {
	          width: 0,
	          height: containerHeight,
	          x: 0,
	          y: 0
	        };
	      case 'offRight':
	        return {
	          width: 0,
	          height: containerHeight,
	          x: containerWidth,
	          y: 0
	        };
	      case 'full':
	      default:
	        return {
	          width: containerWidth,
	          height: containerHeight,
	          x: 0,
	          y: 0
	        };
	    }
	  };
	
	  Slide.prototype.getScreenAlpha = function getScreenAlpha(size) {
	    var darken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var screenAlpha = 0.82;
	    if (size === 'center' || size === 'halfLeft' || size === 'halfRight' || size === 'full') {
	      screenAlpha = 0.52;
	    }
	    if (darken) {
	      screenAlpha += 0.11;
	    }
	    return screenAlpha;
	  };
	
	  Slide.prototype.draw = function draw(size) {
	    var screenAlign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    var darken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    this.framedImage.setImageSize(this.getDimensions(size), screenAlign, this.getScreenAlpha(size, darken));
	    this.setVisible();
	  };
	
	  Slide.prototype.move = function move(size, alpha) {
	    var screenAlign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var darken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	    var duration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
	
	    this.framedImage.panToCoverSize(this.getDimensions(size), duration, null, screenAlign, typeof alpha === 'undefined' || alpha === 'default' ? this.getScreenAlpha(size, darken) : alpha);
	  };
	
	  Slide.prototype.enterFromRight = function enterFromRight() {
	    var screenAlign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    if (this.isOff) {
	      this.framedImage.setImageSize(this.getDimensions('offRight'), screenAlign, this.getScreenAlpha('right'));
	    }
	    this.setVisible();
	    this.isOff = false;
	    this.framedImage.panToCoverSize(this.getDimensions('right'), 1, null, screenAlign, this.getScreenAlpha('right'));
	  };
	
	  Slide.prototype.enterFromLeft = function enterFromLeft() {
	    var screenAlign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    if (this.isOff) {
	      this.framedImage.setImageSize(this.getDimensions('offLeft'), screenAlign, this.getScreenAlpha('left'));
	    }
	    this.setVisible();
	    this.isOff = false;
	
	    this.setVisible();
	    this.framedImage.panToCoverSize(this.getDimensions('left'), 1, null, screenAlign, this.getScreenAlpha('left'));
	  };
	
	  Slide.prototype.off = function off() {
	    this.setVisible(false);
	    this.isOff = true;
	  };
	
	  return Slide;
	}();
	
	exports.default = Slide;
	module.exports = exports['default'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(11);
	
	var _reactSlick = __webpack_require__(181);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _PlaylistButton = __webpack_require__(184);
	
	var _PlaylistButton2 = _interopRequireDefault(_PlaylistButton);
	
	var _PlaylistGesturalNavigation = __webpack_require__(345);
	
	var _PlaylistGesturalNavigation2 = _interopRequireDefault(_PlaylistGesturalNavigation);
	
	var _PlaylistVideo = __webpack_require__(346);
	
	var _PlaylistVideo2 = _interopRequireDefault(_PlaylistVideo);
	
	var _StoryProgressBar = __webpack_require__(347);
	
	var _StoryProgressBar2 = _interopRequireDefault(_StoryProgressBar);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _PlaylistCoverText = __webpack_require__(343);
	
	var _PlaylistCoverText2 = _interopRequireDefault(_PlaylistCoverText);
	
	var _BackToChapterButton = __webpack_require__(182);
	
	var _BackToChapterButton2 = _interopRequireDefault(_BackToChapterButton);
	
	var _ImageSlider = __webpack_require__(337);
	
	var _ImageSlider2 = _interopRequireDefault(_ImageSlider);
	
	var _ChapterSectionPressPlayModule = __webpack_require__(193);
	
	var _ChapterSectionPressPlayModule2 = _interopRequireDefault(_ChapterSectionPressPlayModule);
	
	var _SwipeNextPrev = __webpack_require__(141);
	
	var _SwipeNextPrev2 = _interopRequireDefault(_SwipeNextPrev);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var holdTimer = 1500;
	var SplitText = void 0;
	var DrawSVG = void 0;
	
	var findButton = function findButton(node) {
	  if (node.classList.contains('playlist-button')) {
	    return node;
	  } else {
	    return findButton(node.parentNode);
	  }
	};
	
	var ChapterSectionPressPlay = function (_Component) {
	  _inherits(ChapterSectionPressPlay, _Component);
	
	  function ChapterSectionPressPlay() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChapterSectionPressPlay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      activeVideo: 0,
	      isVideoPaused: true,
	      isHoldComplete: false,
	      isHoldStarted: false,
	      allInactive: false
	    }, _this.isReversing = false, _this.activePlaylistIndex = 0, _this.activeProgBar = 0, _this.progressRefs = {}, _this.playlistData = _this.props.sectionData.playlists, _this.bringBackUI = function () {
	      var duration = 1.5;
	
	      _this.fadeInElements = new _gsap.TimelineLite();
	
	      _this.fadeInElements.to('.maskDownLabel', duration, {
	        y: 0,
	        ease: Quart.easeInOut
	      }).to('.fadeTitle .maskDownTitle', 0.4, {
	        opacity: 1,
	        ease: Quart.easeInOut
	      }, '-=' + duration / 2).to('.fadeOut', duration / 2, {
	        opacity: 1,
	        ease: Quart.easeInOut
	      }, '-=' + duration).to('.slick-current .fadeOutWatermark', duration / 2, {
	        opacity: 0.6,
	        ease: Quart.easeInOut
	      }, '-=' + duration / 2).to([_this.prevSlide, _this.nextSlide], duration, {
	        opacity: 1,
	        ease: Linear.easeNone
	      }, '-=' + duration);
	
	      if (_this.getNumberOfSlides() === 2) {
	        var buttonOff = _this.container.querySelectorAll('.js-storyInstructions')[1 - _this.activePlaylistIndex];
	
	        _this.fadeInElements.to(buttonOff, 0.4, {
	          opacity: 1,
	          ease: Quart.easeInOut
	        }, '-=' + duration);
	      }
	      _this.fadeInElements.to('div:not(.fadeTitle) > div > .maskDownTitle', 1.5, {
	        y: 0,
	        ease: Quart.easeInOut
	      }, '-=' + duration / 2).to('.scaleDown', 0.8, {
	        scale: 1,
	        opacity: 1,
	        ease: Back.easeIn
	      }, '-=' + duration / 3);
	
	      _gsap.TweenLite.to('.story-nav', 1, {
	        opacity: 0,
	        y: 0,
	        ease: Back.easeOut
	      });
	    }, _this.createProgressAnimation = function () {
	      _this.activeProgBar = _this.activePlaylistIndex;
	      if (_this.lineDrawing) {
	        _this.lineDrawing.kill();
	      }
	      _this.lineDrawing = new _gsap.TimelineLite({
	        paused: true
	      });
	      _this.lineDrawing.fromTo('.progressBar' + _this.activeProgBar, 1.5, {
	        drawSVG: '0%',
	        ease: Sine.easeInOut,
	        delay: 2.0
	      }, {
	        drawSVG: '100%',
	        ease: Sine.easeInOut
	      }).eventCallback('onComplete'
	      // TODO: Figure out how to trigger on animation complete
	      // Currently this fires on reverse complete
	      // this.holdIsComplete();
	      );
	    }, _this.createFadeElementsTimeline = function () {
	      var duration = 1.5;
	      if (_this.fadeOutElements) {
	        _this.fadeOutElements.kill();
	      }
	      _this.fadeOutElements = new _gsap.TimelineLite({
	        paused: true
	      });
	      _this.fadeOutElements.to('.maskDownLabel', duration, {
	        y: 50,
	        ease: Quart.easeInOut
	      }).to('.fadeTitle .maskDownTitle', 0.4, {
	        opacity: 0,
	        ease: Quart.easeInOut
	      }, '-=' + duration).to('.fadeOut', duration / 2, {
	        opacity: 0,
	        ease: Quart.easeInOut
	      }, '-=' + duration).to('.fadeOutWatermark', duration / 2, {
	        opacity: 0,
	        ease: Quart.easeInOut
	      }, '-=' + duration).to([_this.prevSlide, _this.nextSlide], duration, {
	        opacity: 0,
	        ease: Linear.easeNone
	      }, '-=' + duration);
	      if (_this.getNumberOfSlides() === 2) {
	        var buttonOff = _this.container.querySelectorAll('.js-storyInstructions')[1 - _this.activePlaylistIndex];
	
	        _this.fadeOutElements.to(buttonOff, 0.4, {
	          opacity: 0,
	          ease: Quart.easeInOut
	        }, '-=' + duration);
	      }
	      _this.fadeOutElements.to('div:not(.fadeTitle) > div > .maskDownTitle', 1.5, {
	        y: 100,
	        ease: Quart.easeInOut
	      }, '-=1.35').to('.scaleDown', 0.8, {
	        scale: 0,
	        opacity: 0,
	        ease: Back.easeIn
	      }, '-=0.1').to('.story-nav', 1, {
	        opacity: 1,
	        y: 0,
	        ease: Back.easeOut
	      }, '-=0.1');
	    }, _this.holdIsComplete = function () {
	      _this.setState({
	        isHoldComplete: true
	      });
	
	      // hide header on mobile
	      if (window.innerWidth < 768) {
	        _gsap.TweenLite.to('.site-header', 0.8, {
	          opacity: 0,
	          ease: Circ.easeInOut
	        });
	        var header = document.querySelector('.site-header');
	        header.style.pointerEvents = 'none';
	        var dropdown = Array.from(document.querySelectorAll('.js-dropdownNav'));
	        if (dropdown) {
	          dropdown.forEach(function (dd) {
	            dd.style.pointerEvents = 'none';
	          });
	        }
	      }
	
	      _this.props.setPlaylistOpen(true);
	
	      _gsap.TweenLite.to('.back-to-chapter', 0.8, {
	        opacity: 1,
	        ease: Circ.easeInOut,
	        delay: 0.3
	      });
	    }, _this.getNextSlide = function () {
	      _this.nextSlide = _this.currentSlide.nextElementSibling;
	      if (_this.nextSlide) {
	        var title = _this.nextSlide.querySelector('.splitText');
	        title.classList.add('fadeTitle');
	
	        _this.nextImage = _this.nextSlide !== null ? _this.nextSlide.querySelector('img') : null;
	      }
	    }, _this.getPrevSlide = function () {
	      _this.prevSlide = _this.currentSlide.previousElementSibling;
	      if (_this.prevSlide) {
	        var title = _this.prevSlide.querySelector('.splitText');
	        title.classList.add('fadeTitle');
	
	        _this.prevImage = _this.prevSlide !== null ? _this.prevSlide.querySelector('img') : null;
	      }
	    }, _this.handleMouseDown = function (event) {
	      _this.isReversing = false;
	      event.preventDefault();
	      event.stopPropagation();
	      _this.cancelHoldTimer = setTimeout(_this.holdIsComplete, holdTimer);
	      var current = _this.getCurrentSlideDOM(event);
	      _this.currentSlide = current.el;
	      _this.resetFadeTitles();
	
	      // Update next and previous slides based on current slide
	      // Also sets fade title
	      _this.currentImage = _this.currentSlide.querySelector('img');
	      _this.getNextSlide();
	      _this.getPrevSlide();
	      _this.createProgressAnimation();
	      _this.createFadeElementsTimeline();
	
	      _this.lineDrawing.play();
	      _this.onOpenSlide(current.index);
	      _this.fadeOutElements.play();
	
	      // not sure we need these checks anymore
	
	      // if (
	      //   !this.lineDrawing ||
	      //   this.lineDrawing.progress() === 1 ||
	      //   this.activeProgBar !== this.state.activePlaylistIndex
	      // ) {
	      //   this.createProgressAnimation();
	      // }
	
	      // if (
	      //   !this.fadeOutElements ||
	      //   this.fadeOutElements.progress() === 1 ||
	      //   this.activeProgBar !== this.state.activePlaylistIndex
	      // ) {
	      //   this.createFadeElementsTimeline();
	      // }
	    }, _this.handleMouseUp = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (_this.isReversing) {
	        return;
	      }
	      _this.isReversing = true;
	      _this.setState({
	        isHoldComplete: false
	      });
	
	      clearTimeout(_this.cancelHoldTimer);
	
	      if (_this.state.isHoldComplete === false && !_this.lineDrawing.reversed()) {
	        _this.onCloseSlide();
	        _this.lineDrawing.reverse();
	        _this.fadeOutElements.reverse();
	      }
	    }, _this.onChapterClose = function () {
	      _gsap.TweenLite.to('.js-dropdownNav, .js-navItemActive', 0.8, {
	        opacity: 1,
	        ease: Circ.easeInOut
	      });
	      // hide header on mobile
	      if (window.innerWidth < 768) {
	        _gsap.TweenLite.to('.site-header', 0.8, {
	          opacity: 1,
	          ease: Circ.easeInOut
	        });
	        var header = document.querySelector('.site-header');
	        header.style.pointerEvents = 'auto';
	        var dropdown = document.querySelectorAll('.js-dropdownNav');
	        if (dropdown) {
	          dropdown.forEach(function (dd) {
	            dd.style.pointerEvents = 'auto';
	          });
	        }
	      }
	
	      _this.resetProgress();
	      _this.props.setPlaylistOpen(false);
	      _this.setState({
	        isHoldComplete: false,
	        isVideoPaused: true
	      });
	
	      // this.fadeOutElements.timeScale(1.25).reverse();
	      _this.bringBackUI();
	
	      _this.onCloseSlide();
	      _gsap.TweenLite.to('.back-to-chapter', 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut,
	        delay: 0.3
	      });
	      setTimeout(function () {
	        _this.setState({
	          activeVideo: 0
	        });
	      }, 1500);
	    }, _this.registerProgressBar = function (elem, index) {
	      _this.progressRefs[index] = elem;
	    }, _this.onVideoComplete = function () {
	      if (_this.state.activeVideo < _this.props.sectionData.playlists[_this.activePlaylistIndex].slides.length - 1) {
	        _this.setState(function (state) {
	          return {
	            activeVideo: state.activeVideo + 1
	          };
	        });
	      } else if (_this.state.activeVideo === _this.props.sectionData.playlists[_this.activePlaylistIndex].slides.length - 1) {
	        _this.onChapterClose();
	      }
	    }, _this.handlePlayPause = function () {
	      _this.setState(function (state) {
	        return {
	          isVideoPaused: !state.isVideoPaused
	        };
	      });
	    }, _this.goToVideo = function (activeVideo) {
	      _this.setState({
	        activeVideo: activeVideo
	      });
	    }, _this.setActivePlaylist = function (index) {
	      _this.activePlaylistIndex = index;
	      _this.props.setActiveImage(_this.props.index, _this.playlistData[_this.activePlaylistIndex].image.sizes.large);
	    }, _this.skipVideo = function (direction) {
	      if (direction === 'prev' && _this.state.activeVideo > 0) {
	        _this.setState(function (state) {
	          return {
	            activeVideo: state.activeVideo - 1
	          };
	        });
	      } else if (direction === 'next' && _this.state.activeVideo < _this.props.sectionData.playlists[0].slides.length - 1) {
	        _this.setState(function (state) {
	          return {
	            activeVideo: state.activeVideo + 1
	          };
	        });
	      }
	    }, _this.isActivePlaylist = function (index) {
	      if (_this.playlistData.length <= 2 && !_this.state.allInactive) {
	        return _ChapterSectionPressPlayModule2.default.activePlaylist;
	      } else {
	        return _this.activePlaylistIndex === index && !_this.state.allInactive ? _ChapterSectionPressPlayModule2.default.activePlaylist : _ChapterSectionPressPlayModule2.default.inactivePlaylist;
	      }
	    }, _this.getNumberOfSlides = function () {
	      if (_this.playlistData.length < 2) {
	        return 1;
	      } else if (_this.playlistData.length > 2) {
	        return 3;
	      } else {
	        return 2;
	      }
	    }, _this.registerNextListener = function (func) {
	      _this.onNextSlide = func;
	    }, _this.registerPrevListener = function (func) {
	      _this.onPrevSlide = func;
	    }, _this.registerOpenListener = function (func) {
	      _this.onOpenSlide = func;
	    }, _this.registerCloseListener = function (func) {
	      _this.onCloseSlide = func;
	    }, _this.registerCloseSectionListener = function (func) {
	      _this.onCloseSection = func;
	    }, _this.resetProgress = function () {
	      _gsap.TweenLite.set('.view-button-progress', {
	        drawSVG: '0%'
	      });
	    }, _this.addCurrentUI = function () {
	      var currentSlideString = '.fp-section.active .slick-center';
	      if (_this.getNumberOfSlides() === 2 & window.innerWidth > 800) {
	        currentSlideString = '.fp-section.active .slick-slide';
	      }
	
	      _gsap.TweenLite.to(currentSlideString + ' .js-storyTitle', 0.75, {
	        scale: window.innerWidth <= 800 ? 1.1 : 1.35,
	        opacity: 1
	      });
	      _gsap.TweenLite.to(currentSlideString + ' .chapter-watermark', 0.75, {
	        opacity: 0.6
	      });
	      _gsap.TweenLite.to(currentSlideString + ' .js-storyInstructions', 0.75, {
	        opacity: 1
	      });
	    }, _this.handleNextSlide = function () {
	      if (_this.isSliding || !_this.onNextSlide) {
	        return;
	      }
	      _this.removeCurrentUI();
	      _this.slider.slickNext();
	      setTimeout(function () {
	        _this.addCurrentUI();
	      }, 250);
	      _this.onNextSlide();
	    }, _this.handlePrevSlide = function () {
	      if (_this.isSliding || !_this.onPrevSlide) {
	        return;
	      }
	      _this.removeCurrentUI();
	      _this.slider.slickPrev();
	      setTimeout(function () {
	        _this.addCurrentUI();
	      }, 250);
	      _this.onPrevSlide();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ChapterSectionPressPlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.preExit !== nextProps.preExit && nextProps.preExit) {
	      // exit animation
	      this.preDrawExit();
	    }
	    if (this.props.exitingDrawn !== nextProps.exitingDrawn && nextProps.exitingDrawn) {
	      // exit animation
	      this.postDrawExit();
	    }
	  };
	
	  ChapterSectionPressPlay.prototype.preDrawExit = function preDrawExit() {
	    // fade out non-pixi content
	    if (this.arrows) {
	      _gsap.TweenLite.to(this.arrows, 0.5, { opacity: 0 });
	    }
	    _gsap.TweenLite.to('.playlist-slick', 0.5, { opacity: 0 });
	    if (this.playlistData.length <= 2 && window.innerWidth > 800) {
	      this.onCloseSection(0);
	    } else {
	      this.onCloseSection(this.activePlaylistIndex);
	    }
	  };
	
	  ChapterSectionPressPlay.prototype.postDrawExit = function postDrawExit() {
	    _gsap.TweenLite.set(this.container, { opacity: 0 });
	  };
	
	  ChapterSectionPressPlay.prototype.getCurrentSlideDOM = function getCurrentSlideDOM(event) {
	    var eventTarget = event.target;
	    if (this.getNumberOfSlides() === 1) {
	      return {
	        el: document.querySelector('.playlist-slick .slick-slide'),
	        index: 0
	      };
	    } else if (this.getNumberOfSlides() === 2 & window.innerWidth > 800) {
	      // Find event target within Press-n-Play
	      var target = findButton(eventTarget);
	      var currentSection = document.querySelector('.fp-section.active');
	
	      // Get current index and check if the target matches the intended target
	      var playlistButtons = Array.from(currentSection.querySelectorAll('.playlist-button'));
	      var currIndex = playlistButtons.findIndex(function (element) {
	        return element === target;
	      });
	
	      this.setActivePlaylist(currIndex);
	
	      // Set current slide to mousedown target
	      return {
	        el: document.querySelectorAll('.fp-section.active .slick-slide')[currIndex],
	        index: currIndex
	      };
	    } else {
	      return {
	        el: document.querySelector('.fp-section.active .slick-current'),
	        index: this.activePlaylistIndex
	      };
	    }
	  };
	
	  ChapterSectionPressPlay.prototype.resetFadeTitles = function resetFadeTitles() {
	    var titles = Array.from(document.querySelectorAll('.fadeTitle'));
	    titles.forEach(function (title) {
	      if (title.classList) {
	        title.classList.remove('fadeTitle');
	      }
	    });
	  };
	
	  ChapterSectionPressPlay.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.setActiveImage) {
	      this.props.setActiveImage(this.props.index, this.playlistData[this.activePlaylistIndex].image.sizes.large);
	    }
	
	    if (typeof window !== 'undefined') {
	      SplitText = __webpack_require__(144);
	      DrawSVG = __webpack_require__(352);
	    }
	    this.resetProgress();
	    this.startCurrentUI();
	    window.addEventListener('resize', this.addCurrentUI);
	    var splitWords = void 0;
	    var splitText = new SplitText('.splitText', {
	      type: 'words',
	      wordsClass: 'maskDownTitle'
	    });
	
	    if (typeof document !== 'undefined') {
	      splitWords = document.querySelectorAll('.maskDownTitle');
	    }
	
	    var wrap = function wrap(el, wrapper) {
	      el.parentNode.insertBefore(wrapper, el);
	      wrapper.appendChild(el);
	    };
	
	    splitWords.forEach(function (word) {
	      var element = void 0;
	      if (typeof document !== 'undefined') {
	        element = document.createElement('div');
	      }
	      element.className = _ChapterSectionPressPlayModule2.default.maskDownWrapper;
	      wrap(word, element);
	    });
	  };
	
	  ChapterSectionPressPlay.prototype.startCurrentUI = function startCurrentUI() {
	    var numSlides = this.getNumberOfSlides();
	    var slideSelector = void 0;
	    if (numSlides === 2) {
	      slideSelector = '.slick-slide';
	    } else {
	      slideSelector = ".slick-slide[data-index='0']";
	    }
	
	    var title = this.container.querySelectorAll(slideSelector + ' .js-storyTitle');
	    _gsap.TweenLite.set(title, {
	      scale: window.innerWidth <= 800 ? 1.1 : 1.35,
	      opacity: 1
	    });
	    var water = this.container.querySelectorAll(slideSelector + ' .chapter-watermark');
	    _gsap.TweenLite.set(water, {
	      opacity: 0.6
	    });
	    var instructions = this.container.querySelectorAll(slideSelector + ' .js-storyInstructions');
	    _gsap.TweenLite.set(instructions, {
	      opacity: 1
	    });
	  };
	
	  ChapterSectionPressPlay.prototype.removeCurrentUI = function removeCurrentUI() {
	    var currentSlideString = '.fp-section.active .slick-center';
	    _gsap.TweenLite.to(currentSlideString + ' .js-storyTitle', 0.75, {
	      scale: 1,
	      opacity: 0.4
	    });
	    _gsap.TweenLite.to(currentSlideString + ' .chapter-watermark', 0.75, {
	      opacity: 0
	    });
	    _gsap.TweenLite.to(currentSlideString + ' .js-storyInstructions', 0.75, {
	      opacity: 0
	    });
	  };
	
	  ChapterSectionPressPlay.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.addCurrentUI);
	    if (!this.props.isChapter) {
	      this.props.setPlaylistOpen(false);
	      this.setState({
	        isHoldComplete: false,
	        isVideoPaused: true,
	        activeVideo: 0
	      });
	    }
	  };
	
	  ChapterSectionPressPlay.prototype.renderArrows = function renderArrows() {
	    var _this2 = this;
	
	    if (typeof window === 'undefined') {
	      return _react2.default.createElement('div', null);
	    }
	    var numSlides = this.getNumberOfSlides();
	
	    if (numSlides === 3 || numSlides === 2 && window.innerWidth <= 800) {
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: function ref(el) {
	            _this2.arrows = el;
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'fadeOut ' + _ChapterSectionPressPlayModule2.default.arrowWrapRight },
	          _react2.default.createElement(_ArrowButton2.default, {
	            onClick: this.handleNextSlide,
	            direction: 'right',
	            white: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fadeOut ' + _ChapterSectionPressPlayModule2.default.arrowWrap },
	          _react2.default.createElement(_ArrowButton2.default, {
	            onClick: this.handlePrevSlide,
	            direction: 'left',
	            white: true
	          })
	        )
	      );
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  ChapterSectionPressPlay.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        activeVideo = _state.activeVideo,
	        isHoldComplete = _state.isHoldComplete,
	        isVideoPaused = _state.isVideoPaused;
	    var _props = this.props,
	        screenOrientation = _props.screenOrientation,
	        isPlaylistOpen = _props.isPlaylistOpen;
	
	    var currentPlaylist = this.playlistData[this.activePlaylistIndex];
	    var numSlides = this.getNumberOfSlides();
	    var slickOptions = {
	      dots: false,
	      infinite: true,
	      arrows: false,
	      centerMode: numSlides === 3,
	      slidesToShow: numSlides === 2 ? 2 : 1,
	      centerPadding: numSlides === 3 ? '32%' : 0,
	      draggable: false,
	      swipe: false,
	      speed: 1000,
	      respondTo: 'window',
	      cssEase: 'cubic-bezier(0.5, 0, 0.5, 1)',
	      responsive: [{
	        breakpoint: 800,
	        settings: {
	          draggable: false,
	          slidesToShow: 1,
	          centerMode: true,
	          centerPadding: 0
	        }
	      }],
	      beforeChange: function beforeChange() {
	        _this3.isSliding = true;
	      },
	      afterChange: function afterChange(index) {
	        _this3.isSliding = false;
	        _this3.setActivePlaylist(index);
	        _this3.setState({ allInactive: false });
	      }
	    };
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'section ' + _ChapterSectionPressPlayModule2.default.sectionWrapper,
	        ref: function ref(el) {
	          _this3.container = el;
	        }
	      },
	      this.props.isCurrentSlide && !isPlaylistOpen && _react2.default.createElement(_SwipeNextPrev2.default, {
	        next: this.handleNextSlide,
	        prev: this.handlePrevSlide
	      }),
	      this.props.isChapter && _react2.default.createElement(_BackToChapterButton2.default, {
	        isPlaylistOpen: isPlaylistOpen,
	        onChapterClose: this.onChapterClose
	      }),
	      this.renderArrows(),
	      _react2.default.createElement(
	        _reactSlick2.default,
	        _extends({
	          ref: function ref(el) {
	            _this3.slider = el;
	          },
	          className: 'playlist-slick ' + _ChapterSectionPressPlayModule2.default.playlistWrapper
	        }, slickOptions),
	        this.playlistData.map(function (playlist, index) {
	          return _react2.default.createElement(_PlaylistCoverText2.default, {
	            key: playlist.title,
	            isActive: _this3.isActivePlaylist(index),
	            isPlaylistOpen: isPlaylistOpen,
	            playlist: playlist,
	            index: index,
	            handleMouseDown: _this3.handleMouseDown,
	            handleMouseUp: _this3.handleMouseUp,
	            registerProgressBar: _this3.registerProgressBar,
	            disallowScroll: _this3.props.disallowScroll,
	            allowScroll: _this3.props.allowScroll
	          });
	        })
	      ),
	      _react2.default.createElement(_ImageSlider2.default, {
	        display: typeof this.props.display !== 'undefined' ? this.props.display : true,
	        images: this.playlistData.map(function (data) {
	          return data.image;
	        }),
	        registerNextListener: this.registerNextListener,
	        registerPrevListener: this.registerPrevListener,
	        registerOpenListener: this.registerOpenListener,
	        registerCloseListener: this.registerCloseListener,
	        registerCloseSectionListener: this.registerCloseSectionListener
	      }),
	      _react2.default.createElement(_PlaylistGesturalNavigation2.default, {
	        activeVideo: activeVideo,
	        isPlaylistOpen: isPlaylistOpen,
	        navigateVideos: this.skipVideo
	      }),
	      _react2.default.createElement(_StoryProgressBar2.default, {
	        activeVideo: activeVideo,
	        isVideoPaused: isVideoPaused,
	        isPlaylistOpen: isPlaylistOpen,
	        playlistVideoData: currentPlaylist.slides,
	        onPlayPauseClick: this.handlePlayPause,
	        navigateVideos: this.goToVideo
	      }),
	      _react2.default.createElement(_PlaylistVideo2.default, {
	        activeVideo: activeVideo,
	        isVideoPaused: isVideoPaused,
	        isPlaylistOpen: isPlaylistOpen,
	        screenOrientation: screenOrientation,
	        playlistVideoData: currentPlaylist.slides,
	        togglePlayPause: this.handlePlayPause,
	        videoEnded: this.onVideoComplete
	      })
	    );
	  };
	
	  return ChapterSectionPressPlay;
	}(_react.Component);
	
	exports.default = ChapterSectionPressPlay;
	module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(11);
	
	var _PlyrComponent = __webpack_require__(183);
	
	var _PlyrComponent2 = _interopRequireDefault(_PlyrComponent);
	
	var _ScreenedImageCover = __webpack_require__(164);
	
	var _ScreenedImageCover2 = _interopRequireDefault(_ScreenedImageCover);
	
	var _BackToChapterButton = __webpack_require__(182);
	
	var _BackToChapterButton2 = _interopRequireDefault(_BackToChapterButton);
	
	var _PlayPauseButton = __webpack_require__(71);
	
	var _PlayPauseButton2 = _interopRequireDefault(_PlayPauseButton);
	
	var _ChapterSectionVideoModule = __webpack_require__(396);
	
	var _ChapterSectionVideoModule2 = _interopRequireDefault(_ChapterSectionVideoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChapterSectionVideo = function (_Component) {
	  _inherits(ChapterSectionVideo, _Component);
	
	  function ChapterSectionVideo() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChapterSectionVideo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onVideoOpen = function () {
	      _this.props.setVideoOpen(true);
	
	      _gsap.TweenMax.to('.back-to-chapter', 0.8, {
	        opacity: 1,
	        ease: Circ.easeInOut,
	        delay: 0.3
	      });
	
	      // hide header on mobile
	      if (window.innerWidth < 768) {
	        TweenLite.to('.site-header', 0.8, {
	          opacity: 0,
	          ease: Circ.easeInOut
	        });
	        var header = document.querySelector('.site-header');
	        header.style.pointerEvents = 'none';
	        var dropdown = document.querySelectorAll('.js-dropdownNav');
	        if (dropdown) {
	          dropdown.forEach(function (dd) {
	            dd.style.pointerEvents = 'none';
	          });
	        }
	      }
	
	      _gsap.TweenMax.to('.js-nextSectionArrow', 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut
	      });
	    }, _this.onVideoClose = function () {
	      _this.props.setVideoOpen(false);
	
	      _gsap.TweenMax.to('.back-to-chapter', 0.8, {
	        opacity: 0,
	        ease: Circ.easeInOut,
	        delay: 0.3
	      });
	
	      // hide header on mobile
	      if (window.innerWidth < 768) {
	        TweenLite.to('.site-header', 0.8, {
	          opacity: 1,
	          ease: Circ.easeInOut
	        });
	        var header = document.querySelector('.site-header');
	        header.style.pointerEvents = 'auto';
	        var dropdown = document.querySelectorAll('.js-dropdownNav');
	        if (dropdown) {
	          dropdown.forEach(function (dd) {
	            dd.style.pointerEvents = 'auto';
	          });
	        }
	      }
	
	      _gsap.TweenMax.to('.js-nextSectionArrow', 0.8, {
	        opacity: 1,
	        ease: Circ.easeInOut
	      });
	    }, _this.plyrOptions = {
	      controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'fullscreen']
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ChapterSectionVideo.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.setActiveImage) {
	      this.props.setActiveImage(this.props.index, this.props.sectionData.image.sizes.large);
	    }
	  };
	
	  ChapterSectionVideo.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.preExit !== nextProps.preExit && nextProps.preExit) {
	      this.preDrawExit();
	    }
	    if (this.props.exitingDrawn !== nextProps.exitingDrawn && nextProps.exitingDrawn) {
	      this.postDrawExit();
	    }
	  };
	
	  ChapterSectionVideo.prototype.preDrawExit = function preDrawExit() {
	    if (this.props.isVideoOpen) {
	      this.onVideoClose();
	    }
	    TweenLite.to(this.contentEl, 0.5, {
	      opacity: 0
	    });
	  };
	
	  ChapterSectionVideo.prototype.postDrawExit = function postDrawExit() {
	    this.bk.style.visibility = 'hidden';
	    // TweenLite.set(this.bk, { opacity: 0 });
	  };
	
	  ChapterSectionVideo.prototype.hasVideo = function hasVideo() {
	    return this.props.sectionData.video_file.url || this.props.sectionData.youtube_id || this.props.sectionData.vimeo_id;
	  };
	
	  ChapterSectionVideo.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'section ' + _ChapterSectionVideoModule2.default.sectionWrapper,
	        ref: function ref(el) {
	          _this2.bk = el;
	        }
	      },
	      this.props.isChapter && _react2.default.createElement(_BackToChapterButton2.default, {
	        isVideoOpen: this.props.isVideoOpen,
	        onVideoClose: this.onVideoClose
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: _ChapterSectionVideoModule2.default.videoIntroWrapper + ' ' + (this.props.isVideoOpen ? _ChapterSectionVideoModule2.default.videoIntroHidden : '')
	        },
	        this.props.sectionData.image && _react2.default.createElement(
	          'div',
	          { className: _ChapterSectionVideoModule2.default.videoPoster },
	          _react2.default.createElement(_ScreenedImageCover2.default, {
	            url: this.props.sectionData.image.sizes.large,
	            load: this.props.display
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(el) {
	              _this2.contentEl = el;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: _ChapterSectionVideoModule2.default.videoIntro,
	              style: {
	                pointerEvents: this.props.isVideoOpen ? 'none' : 'auto'
	              }
	            },
	            this.props.sectionData.title && _react2.default.createElement(
	              'div',
	              { className: _ChapterSectionVideoModule2.default.videoTitleWrapper },
	              _react2.default.createElement(
	                'div',
	                { className: 'splitText ' + _ChapterSectionVideoModule2.default.videoTitle },
	                this.props.sectionData.title
	              )
	            ),
	            this.props.sectionData.subtitle && _react2.default.createElement(
	              'div',
	              { className: _ChapterSectionVideoModule2.default.videoDescription },
	              this.props.sectionData.subtitle
	            ),
	            this.hasVideo() && _react2.default.createElement(
	              'div',
	              {
	                className: _ChapterSectionVideoModule2.default.playButton,
	                onClick: this.onVideoOpen,
	                onTouchStart: this.props.disallowScroll,
	                onTouchEnd: this.props.allowScroll
	              },
	              _react2.default.createElement(_PlayPauseButton2.default, { noBorder: true, isVideoPaused: true, largeButton: true })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'chapter-video ' + _ChapterSectionVideoModule2.default.videoWrapper + ' ' + (this.props.isVideoOpen ? _ChapterSectionVideoModule2.default.videoOpen : '')
	        },
	        this.hasVideo() && _react2.default.createElement(_PlyrComponent2.default, {
	          isChapter: true,
	          options: this.plyrOptions,
	          videoData: this.props.sectionData,
	          isVideoOpen: this.props.isVideoOpen
	        })
	      )
	    );
	  };
	
	  return ChapterSectionVideo;
	}(_react.Component);
	
	exports.default = ChapterSectionVideo;
	module.exports = exports['default'];

/***/ }),
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChapterSectionPressPlayModule = __webpack_require__(193);
	
	var _ChapterSectionPressPlayModule2 = _interopRequireDefault(_ChapterSectionPressPlayModule);
	
	var _PlaylistButton = __webpack_require__(184);
	
	var _PlaylistButton2 = _interopRequireDefault(_PlaylistButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlaylistCoverText = function PlaylistCoverText(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.isActive },
	    _react2.default.createElement(
	      'div',
	      {
	        className: _ChapterSectionPressPlayModule2.default.storyIntro,
	        style: { pointerEvents: props.isPlaylistOpen ? 'none' : 'auto' }
	      },
	      props.playlist.label && _react2.default.createElement(
	        'div',
	        { className: _ChapterSectionPressPlayModule2.default.storyLabel },
	        _react2.default.createElement(
	          'div',
	          { className: 'maskDownLabel' },
	          props.playlist.label
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _ChapterSectionPressPlayModule2.default.storyTitleWrapper },
	        _react2.default.createElement('div', {
	          className: 'splitText js-storyTitle ' + _ChapterSectionPressPlayModule2.default.storyTitle,
	          dangerouslySetInnerHTML: { __html: props.playlist.title }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'fadeOutWatermark chapter-watermark ' + _ChapterSectionPressPlayModule2.default.storyWatermark
	      },
	      props.playlist.watermark
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'js-storyInstructions ' + _ChapterSectionPressPlayModule2.default.storyInstructions },
	      _react2.default.createElement(
	        'p',
	        { className: 'fadeOut' },
	        'Press and hold ',
	        _react2.default.createElement('br', null),
	        ' to view the story'
	      ),
	      _react2.default.createElement(_PlaylistButton2.default, {
	        index: props.index,
	        handleMouseDown: props.handleMouseDown,
	        handleMouseUp: props.handleMouseUp,
	        registerProgressBar: props.registerProgressBar,
	        disallowScroll: props.disallowScroll,
	        allowScroll: props.allowScroll
	      })
	    )
	  );
	};
	
	exports.default = PlaylistCoverText;
	module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _introWithWatermarkModule = __webpack_require__(399);
	
	var _introWithWatermarkModule2 = _interopRequireDefault(_introWithWatermarkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IntroWithWaterMark = function (_Component) {
	  _inherits(IntroWithWaterMark, _Component);
	
	  function IntroWithWaterMark() {
	    _classCallCheck(this, IntroWithWaterMark);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IntroWithWaterMark.prototype.render = function render() {
	    var _props = this.props,
	        watermark = _props.watermark,
	        title = _props.title,
	        label = _props.label,
	        registerTitle = _props.registerTitle,
	        registerWatermark = _props.registerWatermark;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _introWithWatermarkModule2.default.intro },
	      _react2.default.createElement(
	        'div',
	        { className: _introWithWatermarkModule2.default.introInner },
	        label && _react2.default.createElement(
	          'div',
	          { className: _introWithWatermarkModule2.default.label },
	          _react2.default.createElement(
	            'div',
	            { className: 'maskDownLabel' },
	            label
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _introWithWatermarkModule2.default.title },
	          _react2.default.createElement('h1', {
	            ref: registerTitle ? registerTitle : '',
	            className: 'maskDownTitle',
	            dangerouslySetInnerHTML: { __html: title }
	          })
	        )
	      ),
	      watermark && _react2.default.createElement(
	        'div',
	        {
	          ref: registerWatermark ? registerWatermark : '',
	          className: 'fadeOut chapter-watermark ' + _introWithWatermarkModule2.default.watermark
	        },
	        watermark
	      )
	    );
	  };
	
	  return IntroWithWaterMark;
	}(_react.Component);
	
	exports.default = IntroWithWaterMark;
	module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlaylistGesturalNavigationModule = __webpack_require__(401);
	
	var _PlaylistGesturalNavigationModule2 = _interopRequireDefault(_PlaylistGesturalNavigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlaylistGesturalNavigation = function PlaylistGesturalNavigation(_ref) {
	  var isPlaylistOpen = _ref.isPlaylistOpen,
	      activeVideo = _ref.activeVideo,
	      navigateVideos = _ref.navigateVideos;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _PlaylistGesturalNavigationModule2.default.navigationWrapper,
	      style: { pointerEvents: isPlaylistOpen ? 'auto' : 'none' }
	    },
	    _react2.default.createElement('div', {
	      className: _PlaylistGesturalNavigationModule2.default.navigationLeft,
	      onClick: function onClick() {
	        return navigateVideos('prev');
	      }
	    }),
	    _react2.default.createElement('div', {
	      className: _PlaylistGesturalNavigationModule2.default.navigationRight,
	      onClick: function onClick() {
	        return navigateVideos('next');
	      }
	    })
	  );
	};
	
	exports.default = PlaylistGesturalNavigation;
	module.exports = exports['default'];

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(11);
	
	var _progressListener = __webpack_require__(185);
	
	var _progressListener2 = _interopRequireDefault(_progressListener);
	
	var _PlaylistVideoModule = __webpack_require__(402);
	
	var _PlaylistVideoModule2 = _interopRequireDefault(_PlaylistVideoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getBodyTextQuadrant = function getBodyTextQuadrant(body_quadrant) {
	  switch (body_quadrant) {
	    case 'bottomright':
	      return '' + _PlaylistVideoModule2.default.videoTextBottomRight;
	    case 'topright':
	      return '' + _PlaylistVideoModule2.default.videoTextTopRight;
	    case 'topleft':
	      return '' + _PlaylistVideoModule2.default.videoTextTopLeft;
	    default:
	      return '' + _PlaylistVideoModule2.default.videoTextBottomLeft;
	  }
	};
	
	var PlaylistVideo = function (_Component) {
	  _inherits(PlaylistVideo, _Component);
	
	  function PlaylistVideo() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PlaylistVideo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.videos = [], _this.videoText = [], _this.state = {
	      showBk: false,
	      prevActive: null,
	      screenOrientation: ''
	    }, _this.setScreenOrientation = function () {
	      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	      if (typeof window !== 'undefined') {
	        if (window.innerHeight < window.innerWidth) {
	          _this.setState({
	            screenOrientation: 'landscape'
	          }, callback);
	        } else {
	          _this.setState({
	            screenOrientation: 'portrait'
	          }, callback);
	        }
	      }
	    }, _this.videoTimeUpdate = function () {
	      if (_this.props.isPlaylistOpen && _this.videos[0] !== null) {
	        _progressListener2.default.progress(_this.videos[_this.props.activeVideo].currentTime, _this.videos[_this.props.activeVideo].duration);
	
	        requestAnimationFrame(_this.videoTimeUpdate);
	      }
	    }, _this.playWhenReady = function (video) {
	      var checkReadyState = function checkReadyState() {
	        // playlist remembers the previous active video and holds it on screen
	        // until the next one can play, then they cross fade.
	        if (video.readyState === 4) {
	          _this.setState({ prevActive: null });
	
	          video.play();
	        } else {
	          requestAnimationFrame(checkReadyState);
	        }
	      };
	      requestAnimationFrame(checkReadyState);
	    }, _this.onVideoComplete = function () {
	      _this.props.videoEnded();
	    }, _this.onVideoPlay = function () {
	      if (!_this.state.showBk) {
	        setTimeout(function () {
	          _this.setState({ showBk: true });
	        }, 1500);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PlaylistVideo.prototype.componentDidMount = function componentDidMount() {
	    this.setScreenOrientation();
	    // this probably never fires b/c can't mount without press
	    // Start animations and play video
	    if (this.props.isPlaylistOpen) {
	      this.videos[this.props.activeVideo].play();
	      this.animationFrame = requestAnimationFrame(this.videoTimeUpdate);
	    }
	  };
	
	  PlaylistVideo.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // When video is opened:
	    if (this.props.isPlaylistOpen !== nextProps.isPlaylistOpen && nextProps.isPlaylistOpen) {
	      // Reset videos back to 0
	      for (var video in this.videos) {
	        this.videos[video].currentTime = 0;
	      }
	
	      // Play active video and start progress bar
	      if (this.videos[this.props.activeVideo]) {
	        this.props.togglePlayPause();
	        // this.playWhenReady(this.videos[this.props.activeVideo]);
	        this.animationFrame = requestAnimationFrame(this.videoTimeUpdate);
	      }
	    }
	
	    // When video changes
	    // Check if video switches, then play videos and start progress bar
	    if (this.props.isPlaylistOpen && this.props.activeVideo !== nextProps.activeVideo && this.videos[nextProps.activeVideo] !== undefined) {
	      this.videos[this.props.activeVideo].pause();
	      this.videos[nextProps.activeVideo].currentTime = 0;
	      this.setState({ prevActive: this.props.activeVideo });
	      this.playWhenReady(this.videos[nextProps.activeVideo]);
	      this.animationFrame = requestAnimationFrame(this.videoTimeUpdate);
	    }
	
	    // When video is closed
	    // Check if Playlist is closed
	    if (this.props.isPlaylistOpen !== nextProps.isPlaylistOpen && !nextProps.isPlaylistOpen) {
	      this.setState({
	        showBk: false,
	        prevActive: null
	      });
	      this.videos[this.props.activeVideo].pause();
	    }
	
	    // Check whether video is playing or paused
	    if (this.props.isVideoPause !== nextProps.isVideoPaused && this.videos[nextProps.activeVideo] !== undefined) {
	      if (nextProps.isVideoPaused) {
	        this.videos[nextProps.activeVideo].pause();
	      } else {
	        this.videos[nextProps.activeVideo].play();
	      }
	    }
	  };
	
	  PlaylistVideo.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    // if src changes, need to call load method ¯\_(ツ)_/¯
	    if (prevProps.playlistVideoData !== this.props.playlistVideoData) {
	      this.videos.length = this.props.playlistVideoData.length;
	      this.videoText.length = this.props.playlistVideoData.length;
	    }
	    if (prevProps.screenOrientation !== this.props.screenOrientation) {
	      this.setScreenOrientation(function () {
	        _this2.videos[_this2.props.activeVideo].load();
	      });
	    }
	  };
	
	  PlaylistVideo.prototype.componentWillUnmount = function componentWillUnmount() {
	    cancelAnimationFrame(this.animationFrame);
	  };
	
	  PlaylistVideo.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        screenOrientation = _props.screenOrientation,
	        isPlaylistOpen = _props.isPlaylistOpen,
	        playlistVideoData = _props.playlistVideoData,
	        videoEnded = _props.videoEnded;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'playlist-video ' + _PlaylistVideoModule2.default.videoWrapper + ' ' + (isPlaylistOpen ? _PlaylistVideoModule2.default.playlistOpen : '') + ' ' + (this.state.showBk ? _PlaylistVideoModule2.default.hasBackground : ''),
	        style: { pointerEvents: isPlaylistOpen ? 'auto' : 'none' }
	      },
	      playlistVideoData.map(function (video, i) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: video.body + '-' + i,
	            className: _PlaylistVideoModule2.default.videoWrap + ' ' + ((i === _this3.props.activeVideo || i === _this3.state.prevActive) && _this3.props.isPlaylistOpen ? _PlaylistVideoModule2.default.isActive : '') + ' playlist-video--' + i
	          },
	          _react2.default.createElement('div', {
	            className: (i === _this3.props.activeVideo && _this3.props.isPlaylistOpen ? _PlaylistVideoModule2.default.activeVideoText : '') + ' ' + _PlaylistVideoModule2.default.videoText + ' ' + getBodyTextQuadrant(video.body_quadrant),
	            dangerouslySetInnerHTML: { __html: video.body }
	          }),
	          _react2.default.createElement('video', {
	            ref: function ref(el) {
	              return _this3.videos[i] = el;
	            },
	            src: _this3.state.screenOrientation === 'landscape' ? video.source.landscape.url : video.source.portrait.url,
	            className: ((i === _this3.props.activeVideo || i === _this3.state.prevActive) && _this3.props.isPlaylistOpen ? _PlaylistVideoModule2.default.activeVideo : '') + ' ' + _PlaylistVideoModule2.default.video,
	            playsInline: true,
	            onEnded: _this3.onVideoComplete,
	            onPlay: _this3.onVideoPlay
	          })
	        );
	      })
	    );
	  };
	
	  return PlaylistVideo;
	}(_react.Component);
	
	exports.default = PlaylistVideo;
	module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gsap = __webpack_require__(11);
	
	var _progressListener = __webpack_require__(185);
	
	var _progressListener2 = _interopRequireDefault(_progressListener);
	
	var _PlayPauseButton = __webpack_require__(71);
	
	var _PlayPauseButton2 = _interopRequireDefault(_PlayPauseButton);
	
	var _StoryProgressBarModule = __webpack_require__(403);
	
	var _StoryProgressBarModule2 = _interopRequireDefault(_StoryProgressBarModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StoryProgressBar = function (_Component) {
	  _inherits(StoryProgressBar, _Component);
	
	  function StoryProgressBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StoryProgressBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      currentTime: 0,
	      duration: 1
	    }, _this.handleProgress = function (currentTime, duration) {
	      _this.setState({
	        currentTime: currentTime,
	        duration: duration
	      });
	    }, _this.getProgressWidth = function (currentTime, duration) {
	      return currentTime / duration * 100 + '%';
	    }, _this.getVideoProgress = function (i) {
	      if (i === _this.props.activeVideo) {
	        return {
	          width: _this.getProgressWidth(_this.state.currentTime, _this.state.duration)
	        };
	      } else if (i < _this.props.activeVideo) {
	        return {
	          width: '100%'
	        };
	      } else {
	        return {
	          width: 0
	        };
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StoryProgressBar.prototype.componentDidMount = function componentDidMount() {
	    // Set unsubscribe method
	    this.unsubscribe = _progressListener2.default.subscribe(this.handleProgress);
	  };
	
	  StoryProgressBar.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  StoryProgressBar.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        isPlaylistOpen = _props.isPlaylistOpen,
	        playlistVideoData = _props.playlistVideoData,
	        onPlayPauseClick = _props.onPlayPauseClick,
	        navigateVideos = _props.navigateVideos;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: { pointerEvents: isPlaylistOpen ? '' : 'none' },
	        className: 'story-nav ' + _StoryProgressBarModule2.default.storyNavigation
	      },
	      _react2.default.createElement(_PlayPauseButton2.default, {
	        onPlayPauseClick: onPlayPauseClick,
	        isVideoPaused: this.props.isVideoPaused
	      }),
	      playlistVideoData.map(function (video, i) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: 'progressBar-' + i,
	            className: _StoryProgressBarModule2.default.progressWrapper
	            // Remove anonymous function and make this its own component
	            , onClick: function onClick() {
	              return navigateVideos(i);
	            }
	          },
	          _react2.default.createElement('div', { className: _StoryProgressBarModule2.default.progressBar }),
	          _react2.default.createElement('div', {
	            className: _StoryProgressBarModule2.default.progress,
	            style: _this2.getVideoProgress(i)
	          })
	        );
	      })
	    );
	  };
	
	  return StoryProgressBar;
	}(_react.Component);
	
	exports.default = StoryProgressBar;
	module.exports = exports['default'];

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Transitioner = function Transitioner(props) {
	  return _react2.default.createElement(
	    _reactTransitionGroup.TransitionGroup,
	    null,
	    props.isActive && _react2.default.createElement(
	      _reactTransitionGroup.CSSTransition,
	      { timeout: props.timeout, classNames: props.classNames },
	      props.children
	    )
	  );
	};
	
	exports.default = Transitioner;
	module.exports = exports['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	/*!
	 * VERSION: 0.1.5
	 * DATE: 2018-02-15
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * DrawSVGPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
	 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
	 * This work is subject to the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = typeof module !== "undefined" && module.exports && typeof global !== "undefined" ? global : undefined || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
	
		"use strict";
	
		var _doc = _gsScope.document,
		    _getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function () {},
		    _numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
		    _isEdge = ((_gsScope.navigator || {}).userAgent || "").indexOf("Edge") !== -1,
		    //Microsoft Edge has a bug that causes it not to redraw the path correctly if the stroke-linecap is anything other than "butt" (like "round") and it doesn't match the stroke-linejoin. A way to trigger it is to change the stroke-miterlimit, so we'll only do that if/when we have to (to maximize performance)
		DrawSVGPlugin;
	
		function getDistance(x1, y1, x2, y2, scaleX, scaleY) {
			x2 = (parseFloat(x2 || 0) - parseFloat(x1 || 0)) * scaleX;
			y2 = (parseFloat(y2 || 0) - parseFloat(y1 || 0)) * scaleY;
			return Math.sqrt(x2 * x2 + y2 * y2);
		}
	
		function unwrap(element) {
			if (typeof element === "string" || !element.nodeType) {
				element = _gsScope.TweenLite.selector(element);
				if (element.length) {
					element = element[0];
				}
			}
			return element;
		}
	
		//accepts values like "100%" or "20% 80%" or "20 50" and parses it into an absolute start and end position on the line/stroke based on its length. Returns an an array with the start and end values, like [0, 243]
		function parse(value, length, defaultStart) {
			var i = value.indexOf(" "),
			    s,
			    e;
			if (i === -1) {
				s = defaultStart !== undefined ? defaultStart + "" : value;
				e = value;
			} else {
				s = value.substr(0, i);
				e = value.substr(i + 1);
			}
			s = s.indexOf("%") !== -1 ? parseFloat(s) / 100 * length : parseFloat(s);
			e = e.indexOf("%") !== -1 ? parseFloat(e) / 100 * length : parseFloat(e);
			return s > e ? [e, s] : [s, e];
		}
	
		function getLength(element) {
			if (!element) {
				return 0;
			}
			element = unwrap(element);
			var type = element.tagName.toLowerCase(),
			    scaleX = 1,
			    scaleY = 1,
			    length,
			    bbox,
			    points,
			    prevPoint,
			    i,
			    rx,
			    ry;
			if (element.getAttribute("vector-effect") === "non-scaling-stroke") {
				//non-scaling-stroke basically scales the shape and then strokes it at the screen-level (after transforms), thus we need to adjust the length accordingly.
				scaleY = element.getScreenCTM();
				scaleX = scaleY.a;
				scaleY = scaleY.d;
			}
			try {
				//IE bug: calling <path>.getTotalLength() locks the repaint area of the stroke to whatever its current dimensions are on that frame/tick. To work around that, we must call getBBox() to force IE to recalculate things.
				bbox = element.getBBox(); //solely for fixing bug in IE - we don't actually use the bbox.
			} catch (e) {
				//firefox has a bug that throws an error if the element isn't visible.
				console.log("Error: Some browsers like Firefox won't report measurements of invisible elements (like display:none).");
			}
			if ((!bbox || !bbox.width && !bbox.height) && (type === "rect" || type === "circle" || type === "ellipse")) {
				//if the element isn't visible, try to discern width/height using its attributes.
				bbox = {
					width: parseFloat(element.getAttribute(type === "rect" ? "width" : type === "circle" ? "r" : "rx")),
					height: parseFloat(element.getAttribute(type === "rect" ? "height" : type === "circle" ? "r" : "ry"))
				};
				if (type !== "rect") {
					bbox.width *= 2;
					bbox.height *= 2;
				}
			}
			if (type === "path") {
				prevPoint = element.style.strokeDasharray;
				element.style.strokeDasharray = "none";
				length = element.getTotalLength() || 0;
				if (scaleX !== scaleY) {
					console.log("Warning: <path> length cannot be measured accurately when vector-effect is non-scaling-stroke and the element isn't proportionally scaled.");
				}
				length *= (scaleX + scaleY) / 2;
				element.style.strokeDasharray = prevPoint;
			} else if (type === "rect") {
				length = bbox.width * 2 * scaleX + bbox.height * 2 * scaleY;
			} else if (type === "line") {
				length = getDistance(bbox.x, bbox.y, bbox.x + bbox.width, bbox.y + bbox.height, scaleX, scaleY);
			} else if (type === "polyline" || type === "polygon") {
				points = element.getAttribute("points").match(_numbersExp) || [];
				if (type === "polygon") {
					points.push(points[0], points[1]);
				}
				length = 0;
				for (i = 2; i < points.length; i += 2) {
					length += getDistance(points[i - 2], points[i - 1], points[i], points[i + 1], scaleX, scaleY) || 0;
				}
			} else if (type === "circle" || type === "ellipse") {
				rx = bbox.width / 2 * scaleX;
				ry = bbox.height / 2 * scaleY;
				length = Math.PI * (3 * (rx + ry) - Math.sqrt((3 * rx + ry) * (rx + 3 * ry)));
			}
			return length || 0;
		}
	
		function getPosition(element, length) {
			if (!element) {
				return [0, 0];
			}
			element = unwrap(element);
			length = length || getLength(element) + 1;
			var cs = _getComputedStyle(element),
			    dash = cs.strokeDasharray || "",
			    offset = parseFloat(cs.strokeDashoffset),
			    i = dash.indexOf(",");
			if (i < 0) {
				i = dash.indexOf(" ");
			}
			dash = i < 0 ? length : parseFloat(dash.substr(0, i)) || 0.00001;
			if (dash > length) {
				dash = length;
			}
			return [Math.max(0, -offset), Math.max(0, dash - offset)];
		}
	
		DrawSVGPlugin = _gsScope._gsDefine.plugin({
			propName: "drawSVG",
			API: 2,
			version: "0.1.5",
			global: true,
			overwriteProps: ["drawSVG"],
	
			init: function init(target, value, tween, index) {
				if (!target.getBBox) {
					return false;
				}
				var length = getLength(target) + 1,
				    start,
				    end,
				    overage,
				    cs;
				this._style = target.style;
				if (typeof value === "function") {
					value = value(index, target);
				}
				if (value === true || value === "true") {
					value = "0 100%";
				} else if (!value) {
					value = "0 0";
				} else if ((value + "").indexOf(" ") === -1) {
					value = "0 " + value;
				}
				start = getPosition(target, length);
				end = parse(value, length, start[0]);
				this._length = length + 10;
				if (start[0] === 0 && end[0] === 0) {
					overage = Math.max(0.00001, end[1] - length); //allow people to go past the end, like values of 105% because for some paths, Firefox doesn't return an accurate getTotalLength(), so it could end up coming up short.
					this._dash = length + overage;
					this._offset = length - start[1] + overage;
					this._addTween(this, "_offset", this._offset, length - end[1] + overage, "drawSVG");
				} else {
					this._dash = start[1] - start[0] || 0.000001; //some browsers render artifacts if dash is 0, so we use a very small number in that case.
					this._offset = -start[0];
					this._addTween(this, "_dash", this._dash, end[1] - end[0] || 0.00001, "drawSVG");
					this._addTween(this, "_offset", this._offset, -end[0], "drawSVG");
				}
				if (_isEdge) {
					//to work around a bug in Microsoft Edge, animate the stroke-miterlimit by 0.0001 just to trigger the repaint (only necessary if stroke-linecap isn't "butt"; also unnecessary if it's "round" and stroke-linejoin is also "round"). Imperceptible, relatively high-performance, and effective. Another option was to set the "d" <path> attribute to its current value on every tick, but that seems like it'd be much less performant.
					cs = _getComputedStyle(target);
					end = cs.strokeLinecap;
					if (end !== "butt" && end !== cs.strokeLinejoin) {
						end = parseFloat(cs.strokeMiterlimit);
						this._addTween(target.style, "strokeMiterlimit", end, end + 0.0001, "strokeMiterlimit");
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function set(ratio) {
				if (this._firstPT) {
					this._super.setRatio.call(this, ratio);
					this._style.strokeDashoffset = this._offset;
					if (ratio === 1 || ratio === 0) {
						this._style.strokeDasharray = this._offset < 0.001 && this._length - this._dash <= 10 ? "none" : this._offset === this._dash ? "0px, 999999px" : this._dash + "px," + this._length + "px";
					} else {
						this._style.strokeDasharray = this._dash + "px," + this._length + "px";
					}
				}
			}
	
		});
	
		DrawSVGPlugin.getLength = getLength;
		DrawSVGPlugin.getPosition = getPosition;
	});if (_gsScope._gsDefine) {
		_gsScope._gsQueue.pop()();
	}
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function (name) {
		"use strict";
	
		var getGlobal = function getGlobal() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof module !== "undefined" && module.exports) {
			//node
			__webpack_require__(16);
			module.exports = getGlobal();
		} else if (true) {
			//AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	})("DrawSVGPlugin");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"backToChapter":"src-components-chapter----BackToChapterButton-module---backToChapter---CZPxi","navArrow":"src-components-chapter----BackToChapterButton-module---navArrow---oxocP","fadeIn":"src-components-chapter----BackToChapterButton-module---fadeIn---3TAvD","fadeInUp":"src-components-chapter----BackToChapterButton-module---fadeInUp---133aC","fadeInUpCenter":"src-components-chapter----BackToChapterButton-module---fadeInUpCenter---3tJxe","fadeInUpSmall":"src-components-chapter----BackToChapterButton-module---fadeInUpSmall---2mSoN","textCoverIn":"src-components-chapter----BackToChapterButton-module---textCoverIn---3lE4_","textCoverOut":"src-components-chapter----BackToChapterButton-module---textCoverOut---3IdQt"};

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoTitle":"src-components-chapter----ChapterSectionVideo-module---videoTitle---n-GS6","sectionWrapper":"src-components-chapter----ChapterSectionVideo-module---sectionWrapper---2FWE4","videoIntroWrapper":"src-components-chapter----ChapterSectionVideo-module---videoIntroWrapper---2Wa7f","videoIntroHidden":"src-components-chapter----ChapterSectionVideo-module---videoIntroHidden---2Xz6-","videoPoster":"src-components-chapter----ChapterSectionVideo-module---videoPoster---180K9","videoIntro":"src-components-chapter----ChapterSectionVideo-module---videoIntro---3pkQj","maskDownWrapper":"src-components-chapter----ChapterSectionVideo-module---maskDownWrapper---3-6L0","videoDescription":"src-components-chapter----ChapterSectionVideo-module---videoDescription---Jiln3","videoWrapper":"src-components-chapter----ChapterSectionVideo-module---videoWrapper---3kgm6","videoOpen":"src-components-chapter----ChapterSectionVideo-module---videoOpen---2_6-6","fadeIn":"src-components-chapter----ChapterSectionVideo-module---fadeIn---2CME3","fadeInUp":"src-components-chapter----ChapterSectionVideo-module---fadeInUp---1wgJM","fadeInUpCenter":"src-components-chapter----ChapterSectionVideo-module---fadeInUpCenter---3Dn3h","fadeInUpSmall":"src-components-chapter----ChapterSectionVideo-module---fadeInUpSmall---1R4N3","textCoverIn":"src-components-chapter----ChapterSectionVideo-module---textCoverIn---1qgY5","textCoverOut":"src-components-chapter----ChapterSectionVideo-module---textCoverOut---1MBmv"};

/***/ }),
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"intro":"src-components-global----introWithWatermark-module---intro---3VAGQ","introInner":"src-components-global----introWithWatermark-module---introInner---3B6Xo","label":"src-components-global----introWithWatermark-module---label---3TsuZ","title":"src-components-global----introWithWatermark-module---title---7gnH0","watermark":"src-components-global----introWithWatermark-module---watermark---JVaOR","fadeIn":"src-components-global----introWithWatermark-module---fadeIn---mB1FB","fadeInUp":"src-components-global----introWithWatermark-module---fadeInUp---JLIWT","fadeInUpCenter":"src-components-global----introWithWatermark-module---fadeInUpCenter---3B2qF","fadeInUpSmall":"src-components-global----introWithWatermark-module---fadeInUpSmall---346YL","textCoverIn":"src-components-global----introWithWatermark-module---textCoverIn---1a68m","textCoverOut":"src-components-global----introWithWatermark-module---textCoverOut---b426M"};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"viewButtonWrapper":"src-components-global-playlist----PlaylistButton-module---viewButtonWrapper---1by2v","pulse":"src-components-global-playlist----PlaylistButton-module---pulse---1LHLp","progressWrapper":"src-components-global-playlist----PlaylistButton-module---progressWrapper---DSntL","viewButton":"src-components-global-playlist----PlaylistButton-module---viewButton---1-UmS","pulseInner":"src-components-global-playlist----PlaylistButton-module---pulseInner---wxkWP","pulseInner2":"src-components-global-playlist----PlaylistButton-module---pulseInner2---3zVwA","pulseScaleOut":"src-components-global-playlist----PlaylistButton-module---pulseScaleOut---d2z4D","progress":"src-components-global-playlist----PlaylistButton-module---progress---2NDq9","progressBar":"src-components-global-playlist----PlaylistButton-module---progressBar---2VsbX","fadeIn":"src-components-global-playlist----PlaylistButton-module---fadeIn---1127E","fadeInUp":"src-components-global-playlist----PlaylistButton-module---fadeInUp---1OLPq","fadeInUpCenter":"src-components-global-playlist----PlaylistButton-module---fadeInUpCenter---3grXj","fadeInUpSmall":"src-components-global-playlist----PlaylistButton-module---fadeInUpSmall---3X4Ob","textCoverIn":"src-components-global-playlist----PlaylistButton-module---textCoverIn---25xxB","textCoverOut":"src-components-global-playlist----PlaylistButton-module---textCoverOut---3SUPe"};

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"navigationWrapper":"src-components-global-playlist----PlaylistGesturalNavigation-module---navigationWrapper---1rsH0","navigationLeft":"src-components-global-playlist----PlaylistGesturalNavigation-module---navigationLeft---3IleH","navigationRight":"src-components-global-playlist----PlaylistGesturalNavigation-module---navigationRight---Nb8hL","fadeIn":"src-components-global-playlist----PlaylistGesturalNavigation-module---fadeIn---1G0Tn","fadeInUp":"src-components-global-playlist----PlaylistGesturalNavigation-module---fadeInUp---3Rkfo","fadeInUpCenter":"src-components-global-playlist----PlaylistGesturalNavigation-module---fadeInUpCenter---21kUx","fadeInUpSmall":"src-components-global-playlist----PlaylistGesturalNavigation-module---fadeInUpSmall---1K5oL","textCoverIn":"src-components-global-playlist----PlaylistGesturalNavigation-module---textCoverIn---3nVit","textCoverOut":"src-components-global-playlist----PlaylistGesturalNavigation-module---textCoverOut---JKUdn"};

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoWrapper":"src-components-global-playlist----PlaylistVideo-module---videoWrapper---CbxmX","playlistOpen":"src-components-global-playlist----PlaylistVideo-module---playlistOpen---1pFM2","hasBackground":"src-components-global-playlist----PlaylistVideo-module---hasBackground---2MeRs","video":"src-components-global-playlist----PlaylistVideo-module---video---36rFq","activeVideo":"src-components-global-playlist----PlaylistVideo-module---activeVideo---3JEtk","videoText":"src-components-global-playlist----PlaylistVideo-module---videoText---3EvZC","videoTextBottomLeft":"src-components-global-playlist----PlaylistVideo-module---videoTextBottomLeft---3YjbD","videoTextBottomRight":"src-components-global-playlist----PlaylistVideo-module---videoTextBottomRight---2rHFA","videoTextTopLeft":"src-components-global-playlist----PlaylistVideo-module---videoTextTopLeft---3M1XR","videoTextTopRight":"src-components-global-playlist----PlaylistVideo-module---videoTextTopRight---1njwd","activeVideoText":"src-components-global-playlist----PlaylistVideo-module---activeVideoText---2cPmB","fadeIn":"src-components-global-playlist----PlaylistVideo-module---fadeIn---3lsXT","fadeInUp":"src-components-global-playlist----PlaylistVideo-module---fadeInUp---2xVLj","fadeInUpCenter":"src-components-global-playlist----PlaylistVideo-module---fadeInUpCenter---yGwy4","fadeInUpSmall":"src-components-global-playlist----PlaylistVideo-module---fadeInUpSmall---2OaPT","textCoverIn":"src-components-global-playlist----PlaylistVideo-module---textCoverIn---2tfxf","textCoverOut":"src-components-global-playlist----PlaylistVideo-module---textCoverOut---2TR0H"};

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"storyNavigation":"src-components-global-playlist----StoryProgressBar-module---storyNavigation---jB-UT","progressWrapper":"src-components-global-playlist----StoryProgressBar-module---progressWrapper---1m3m2","progressBar":"src-components-global-playlist----StoryProgressBar-module---progressBar---1joyy","progress":"src-components-global-playlist----StoryProgressBar-module---progress---1dEsC","fadeIn":"src-components-global-playlist----StoryProgressBar-module---fadeIn---3EDJO","fadeInUp":"src-components-global-playlist----StoryProgressBar-module---fadeInUp---bhJWf","fadeInUpCenter":"src-components-global-playlist----StoryProgressBar-module---fadeInUpCenter---2-nyp","fadeInUpSmall":"src-components-global-playlist----StoryProgressBar-module---fadeInUpSmall---1N-3U","textCoverIn":"src-components-global-playlist----StoryProgressBar-module---textCoverIn---188qA","textCoverOut":"src-components-global-playlist----StoryProgressBar-module---textCoverOut---1hE8z"};

/***/ }),
/* 404 */,
/* 405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"src-components-ui----ScreenedImageCover-module---image---2xRFb"};

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports) {

	module.exports = {"O_RDONLY":0,"O_WRONLY":1,"O_RDWR":2,"S_IFMT":61440,"S_IFREG":32768,"S_IFDIR":16384,"S_IFCHR":8192,"S_IFBLK":24576,"S_IFIFO":4096,"S_IFLNK":40960,"S_IFSOCK":49152,"O_CREAT":512,"O_EXCL":2048,"O_NOCTTY":131072,"O_TRUNC":1024,"O_APPEND":8,"O_DIRECTORY":1048576,"O_NOFOLLOW":256,"O_SYNC":128,"O_SYMLINK":2097152,"O_NONBLOCK":4,"S_IRWXU":448,"S_IRUSR":256,"S_IWUSR":128,"S_IXUSR":64,"S_IRWXG":56,"S_IRGRP":32,"S_IWGRP":16,"S_IXGRP":8,"S_IRWXO":7,"S_IROTH":4,"S_IWOTH":2,"S_IXOTH":1,"E2BIG":7,"EACCES":13,"EADDRINUSE":48,"EADDRNOTAVAIL":49,"EAFNOSUPPORT":47,"EAGAIN":35,"EALREADY":37,"EBADF":9,"EBADMSG":94,"EBUSY":16,"ECANCELED":89,"ECHILD":10,"ECONNABORTED":53,"ECONNREFUSED":61,"ECONNRESET":54,"EDEADLK":11,"EDESTADDRREQ":39,"EDOM":33,"EDQUOT":69,"EEXIST":17,"EFAULT":14,"EFBIG":27,"EHOSTUNREACH":65,"EIDRM":90,"EILSEQ":92,"EINPROGRESS":36,"EINTR":4,"EINVAL":22,"EIO":5,"EISCONN":56,"EISDIR":21,"ELOOP":62,"EMFILE":24,"EMLINK":31,"EMSGSIZE":40,"EMULTIHOP":95,"ENAMETOOLONG":63,"ENETDOWN":50,"ENETRESET":52,"ENETUNREACH":51,"ENFILE":23,"ENOBUFS":55,"ENODATA":96,"ENODEV":19,"ENOENT":2,"ENOEXEC":8,"ENOLCK":77,"ENOLINK":97,"ENOMEM":12,"ENOMSG":91,"ENOPROTOOPT":42,"ENOSPC":28,"ENOSR":98,"ENOSTR":99,"ENOSYS":78,"ENOTCONN":57,"ENOTDIR":20,"ENOTEMPTY":66,"ENOTSOCK":38,"ENOTSUP":45,"ENOTTY":25,"ENXIO":6,"EOPNOTSUPP":102,"EOVERFLOW":84,"EPERM":1,"EPIPE":32,"EPROTO":100,"EPROTONOSUPPORT":43,"EPROTOTYPE":41,"ERANGE":34,"EROFS":30,"ESPIPE":29,"ESRCH":3,"ESTALE":70,"ETIME":101,"ETIMEDOUT":60,"ETXTBSY":26,"EWOULDBLOCK":35,"EXDEV":18,"SIGHUP":1,"SIGINT":2,"SIGQUIT":3,"SIGILL":4,"SIGTRAP":5,"SIGABRT":6,"SIGIOT":6,"SIGBUS":10,"SIGFPE":8,"SIGKILL":9,"SIGUSR1":30,"SIGSEGV":11,"SIGUSR2":31,"SIGPIPE":13,"SIGALRM":14,"SIGTERM":15,"SIGCHLD":20,"SIGCONT":19,"SIGSTOP":17,"SIGTSTP":18,"SIGTTIN":21,"SIGTTOU":22,"SIGURG":16,"SIGXCPU":24,"SIGXFSZ":25,"SIGVTALRM":26,"SIGPROF":27,"SIGWINCH":28,"SIGIO":23,"SIGSYS":12,"SSL_OP_ALL":2147486719,"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION":262144,"SSL_OP_CIPHER_SERVER_PREFERENCE":4194304,"SSL_OP_CISCO_ANYCONNECT":32768,"SSL_OP_COOKIE_EXCHANGE":8192,"SSL_OP_CRYPTOPRO_TLSEXT_BUG":2147483648,"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS":2048,"SSL_OP_EPHEMERAL_RSA":0,"SSL_OP_LEGACY_SERVER_CONNECT":4,"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER":32,"SSL_OP_MICROSOFT_SESS_ID_BUG":1,"SSL_OP_MSIE_SSLV2_RSA_PADDING":0,"SSL_OP_NETSCAPE_CA_DN_BUG":536870912,"SSL_OP_NETSCAPE_CHALLENGE_BUG":2,"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG":1073741824,"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG":8,"SSL_OP_NO_COMPRESSION":131072,"SSL_OP_NO_QUERY_MTU":4096,"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION":65536,"SSL_OP_NO_SSLv2":16777216,"SSL_OP_NO_SSLv3":33554432,"SSL_OP_NO_TICKET":16384,"SSL_OP_NO_TLSv1":67108864,"SSL_OP_NO_TLSv1_1":268435456,"SSL_OP_NO_TLSv1_2":134217728,"SSL_OP_PKCS1_CHECK_1":0,"SSL_OP_PKCS1_CHECK_2":0,"SSL_OP_SINGLE_DH_USE":1048576,"SSL_OP_SINGLE_ECDH_USE":524288,"SSL_OP_SSLEAY_080_CLIENT_DH_BUG":128,"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG":0,"SSL_OP_TLS_BLOCK_PADDING_BUG":512,"SSL_OP_TLS_D5_BUG":256,"SSL_OP_TLS_ROLLBACK_BUG":8388608,"ENGINE_METHOD_DSA":2,"ENGINE_METHOD_DH":4,"ENGINE_METHOD_RAND":8,"ENGINE_METHOD_ECDH":16,"ENGINE_METHOD_ECDSA":32,"ENGINE_METHOD_CIPHERS":64,"ENGINE_METHOD_DIGESTS":128,"ENGINE_METHOD_STORE":256,"ENGINE_METHOD_PKEY_METHS":512,"ENGINE_METHOD_PKEY_ASN1_METHS":1024,"ENGINE_METHOD_ALL":65535,"ENGINE_METHOD_NONE":0,"DH_CHECK_P_NOT_SAFE_PRIME":2,"DH_CHECK_P_NOT_PRIME":1,"DH_UNABLE_TO_CHECK_GENERATOR":4,"DH_NOT_SUITABLE_GENERATOR":8,"NPN_ENABLED":1,"RSA_PKCS1_PADDING":1,"RSA_SSLV23_PADDING":2,"RSA_NO_PADDING":3,"RSA_PKCS1_OAEP_PADDING":4,"RSA_X931_PADDING":5,"RSA_PKCS1_PSS_PADDING":6,"POINT_CONVERSION_COMPRESSED":2,"POINT_CONVERSION_UNCOMPRESSED":4,"POINT_CONVERSION_HYBRID":6,"F_OK":0,"R_OK":4,"W_OK":2,"X_OK":1,"UV_UDP_REUSEADDR":4}

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(9);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(476);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(477);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(294);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters, exits or has finished the transition.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation. After the animation,
	 * matching `done` class names are applied to persist the animation state.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      var _this$getClassNames3 = _this.getClassNames('enter'),
	          doneClassName = _this$getClassNames3.doneClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          className = _this$getClassNames4.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames5.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      var _this$getClassNames6 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames6.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
	
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName,
	        doneClassName = _getClassNames.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node && node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(69);
	
	var _TransitionGroup = __webpack_require__(295);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  in: _propTypes2.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');
	
	    return null;
	  }
	};
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	
	var ReplaceTransition = function (_React$Component) {
	  _inherits(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReplaceTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react2.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  ReplaceTransition.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        inProp = _props.in,
	        props = _objectWithoutProperties(_props, ['children', 'in']);
	
	    var _React$Children$toArr = _react2.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	
	    return _react2.default.createElement(
	      _TransitionGroup2.default,
	      props,
	      inProp ? _react2.default.cloneElement(first, {
	        key: 'first',
	        onEnter: this.handleEnter,
	        onEntering: this.handleEntering,
	        onEntered: this.handleEntered
	
	      }) : _react2.default.cloneElement(second, {
	        key: 'second',
	        onEnter: this.handleExit,
	        onEntering: this.handleExiting,
	        onEntered: this.handleExited
	      })
	    );
	  };
	
	  return ReplaceTransition;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleEnter = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _this2.handleLifecycle('onEnter', 0, args);
	  };
	
	  this.handleEntering = function () {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _this2.handleLifecycle('onEntering', 0, args);
	  };
	
	  this.handleEntered = function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return _this2.handleLifecycle('onEntered', 0, args);
	  };
	
	  this.handleExit = function () {
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    return _this2.handleLifecycle('onExit', 1, args);
	  };
	
	  this.handleExiting = function () {
	    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	      args[_key6] = arguments[_key6];
	    }
	
	    return _this2.handleLifecycle('onExiting', 1, args);
	  };
	
	  this.handleExited = function () {
	    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	      args[_key7] = arguments[_key7];
	    }
	
	    return _this2.handleLifecycle('onExited', 1, args);
	  };
	};
	
	ReplaceTransition.propTypes =  false ? propTypes : {};
	
	exports.default = ReplaceTransition;
	module.exports = exports['default'];

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// ==ClosureCompiler==
	// @compilation_level ADVANCED_OPTIMIZATIONS
	// @externs_url http://closure-compiler.googlecode.com/svn/trunk/contrib/externs/maps/google_maps_api_v3.js
	// @output_wrapper (function() {%output%})();
	// ==/ClosureCompiler==
	
	/**
	 * @license
	 * Copyright 2013 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	function initializeRichMarker() {
	    /**
	     * A RichMarker that allows any HTML/DOM to be added to a map and be draggable.
	     *
	     * @param {Object.<string, *>=} opt_options Optional properties to set.
	     * @extends {google.maps.OverlayView}
	     * @constructor
	     */
	    function RichMarker(opt_options) {
	        var options = opt_options || {};
	
	        /**
	         * @type {boolean}
	         * @private
	         */
	        this.ready_ = false;
	
	        /**
	         * @type {boolean}
	         * @private
	         */
	        this.dragging_ = false;
	
	        if (opt_options['visible'] == undefined) {
	            opt_options['visible'] = true;
	        }
	
	        if (opt_options['shadow'] == undefined) {
	            opt_options['shadow'] = '7px -3px 5px rgba(88,88,88,0.7)';
	        }
	
	        if (opt_options['anchor'] == undefined) {
	            opt_options['anchor'] = RichMarkerPosition['BOTTOM'];
	        }
	
	        this.setValues(options);
	    }
	
	    RichMarker.prototype = new google.maps.OverlayView();
	    window['RichMarker'] = RichMarker;
	
	    /**
	     * Returns the current visibility state of the marker.
	     *
	     * @return {boolean} The visiblity of the marker.
	     */
	    RichMarker.prototype.getVisible = function () {
	        return (/** @type {boolean} */this.get('visible')
	        );
	    };
	    RichMarker.prototype['getVisible'] = RichMarker.prototype.getVisible;
	
	    /**
	     * Sets the visiblility state of the marker.
	     *
	     * @param {boolean} visible The visiblilty of the marker.
	     */
	    RichMarker.prototype.setVisible = function (visible) {
	        this.set('visible', visible);
	    };
	    RichMarker.prototype['setVisible'] = RichMarker.prototype.setVisible;
	
	    /**
	     *  The visible changed event.
	     */
	    RichMarker.prototype.visible_changed = function () {
	        if (this.ready_) {
	            this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';
	            this.draw();
	        }
	    };
	    RichMarker.prototype['visible_changed'] = RichMarker.prototype.visible_changed;
	
	    /**
	     * Sets the marker to be flat.
	     *
	     * @param {boolean} flat If the marker is to be flat or not.
	     */
	    RichMarker.prototype.setFlat = function (flat) {
	        this.set('flat', !!flat);
	    };
	    RichMarker.prototype['setFlat'] = RichMarker.prototype.setFlat;
	
	    /**
	     * If the makrer is flat or not.
	     *
	     * @return {boolean} True the marker is flat.
	     */
	    RichMarker.prototype.getFlat = function () {
	        return (/** @type {boolean} */this.get('flat')
	        );
	    };
	    RichMarker.prototype['getFlat'] = RichMarker.prototype.getFlat;
	
	    /**
	     * Get the width of the marker.
	     *
	     * @return {Number} The width of the marker.
	     */
	    RichMarker.prototype.getWidth = function () {
	        return (/** @type {Number} */this.get('width')
	        );
	    };
	    RichMarker.prototype['getWidth'] = RichMarker.prototype.getWidth;
	
	    /**
	     * Get the height of the marker.
	     *
	     * @return {Number} The height of the marker.
	     */
	    RichMarker.prototype.getHeight = function () {
	        return (/** @type {Number} */this.get('height')
	        );
	    };
	    RichMarker.prototype['getHeight'] = RichMarker.prototype.getHeight;
	
	    /**
	     * Sets the marker's box shadow.
	     *
	     * @param {string} shadow The box shadow to set.
	     */
	    RichMarker.prototype.setShadow = function (shadow) {
	        this.set('shadow', shadow);
	        this.flat_changed();
	    };
	    RichMarker.prototype['setShadow'] = RichMarker.prototype.setShadow;
	
	    /**
	     * Gets the marker's box shadow.
	     *
	     * @return {string} The box shadow.
	     */
	    RichMarker.prototype.getShadow = function () {
	        return (/** @type {string} */this.get('shadow')
	        );
	    };
	    RichMarker.prototype['getShadow'] = RichMarker.prototype.getShadow;
	
	    /**
	     * Flat changed event.
	     */
	    RichMarker.prototype.flat_changed = function () {
	        if (!this.ready_) {
	            return;
	        }
	
	        this.markerWrapper_.style['boxShadow'] = this.markerWrapper_.style['webkitBoxShadow'] = this.markerWrapper_.style['MozBoxShadow'] = this.getFlat() ? '' : this.getShadow();
	    };
	    RichMarker.prototype['flat_changed'] = RichMarker.prototype.flat_changed;
	
	    /**
	     * Sets the zIndex of the marker.
	     *
	     * @param {Number} index The index to set.
	     */
	    RichMarker.prototype.setZIndex = function (index) {
	        this.set('zIndex', index);
	    };
	    RichMarker.prototype['setZIndex'] = RichMarker.prototype.setZIndex;
	
	    /**
	     * Gets the zIndex of the marker.
	     *
	     * @return {Number} The zIndex of the marker.
	     */
	    RichMarker.prototype.getZIndex = function () {
	        return (/** @type {Number} */this.get('zIndex')
	        );
	    };
	    RichMarker.prototype['getZIndex'] = RichMarker.prototype.getZIndex;
	
	    /**
	     * zIndex changed event.
	     */
	    RichMarker.prototype.zIndex_changed = function () {
	        if (this.getZIndex() && this.ready_) {
	            this.markerWrapper_.style.zIndex = this.getZIndex();
	        }
	    };
	    RichMarker.prototype['zIndex_changed'] = RichMarker.prototype.zIndex_changed;
	
	    /**
	     * Whether the marker is draggable or not.
	     *
	     * @return {boolean} True if the marker is draggable.
	     */
	    RichMarker.prototype.getDraggable = function () {
	        return (/** @type {boolean} */this.get('draggable')
	        );
	    };
	    RichMarker.prototype['getDraggable'] = RichMarker.prototype.getDraggable;
	
	    /**
	     * Sets the marker to be draggable or not.
	     *
	     * @param {boolean} draggable If the marker is draggable or not.
	     */
	    RichMarker.prototype.setDraggable = function (draggable) {
	        this.set('draggable', !!draggable);
	    };
	    RichMarker.prototype['setDraggable'] = RichMarker.prototype.setDraggable;
	
	    /**
	     * Draggable property changed callback.
	     */
	    RichMarker.prototype.draggable_changed = function () {
	        if (this.ready_) {
	            if (this.getDraggable()) {
	                this.addDragging_(this.markerWrapper_);
	            } else {
	                this.removeDragListeners_();
	            }
	        }
	    };
	    RichMarker.prototype['draggable_changed'] = RichMarker.prototype.draggable_changed;
	
	    /**
	     * Gets the postiton of the marker.
	     *
	     * @return {google.maps.LatLng} The position of the marker.
	     */
	    RichMarker.prototype.getPosition = function () {
	        return (/** @type {google.maps.LatLng} */this.get('position')
	        );
	    };
	    RichMarker.prototype['getPosition'] = RichMarker.prototype.getPosition;
	
	    /**
	     * Sets the position of the marker.
	     *
	     * @param {google.maps.LatLng} position The position to set.
	     */
	    RichMarker.prototype.setPosition = function (position) {
	        this.set('position', position);
	    };
	    RichMarker.prototype['setPosition'] = RichMarker.prototype.setPosition;
	
	    /**
	     * Position changed event.
	     */
	    RichMarker.prototype.position_changed = function () {
	        this.draw();
	    };
	    RichMarker.prototype['position_changed'] = RichMarker.prototype.position_changed;
	
	    /**
	     * Gets the anchor.
	     *
	     * @return {google.maps.Size} The position of the anchor.
	     */
	    RichMarker.prototype.getAnchor = function () {
	        return (/** @type {google.maps.Size} */this.get('anchor')
	        );
	    };
	    RichMarker.prototype['getAnchor'] = RichMarker.prototype.getAnchor;
	
	    /**
	     * Sets the anchor.
	     *
	     * @param {RichMarkerPosition|google.maps.Size} anchor The anchor to set.
	     */
	    RichMarker.prototype.setAnchor = function (anchor) {
	        this.set('anchor', anchor);
	    };
	    RichMarker.prototype['setAnchor'] = RichMarker.prototype.setAnchor;
	
	    /**
	     * Anchor changed event.
	     */
	    RichMarker.prototype.anchor_changed = function () {
	        this.draw();
	    };
	    RichMarker.prototype['anchor_changed'] = RichMarker.prototype.anchor_changed;
	
	    /**
	     * Converts a HTML string to a document fragment.
	     *
	     * @param {string} htmlString The HTML string to convert.
	     * @return {Node} A HTML document fragment.
	     * @private
	     */
	    RichMarker.prototype.htmlToDocumentFragment_ = function (htmlString) {
	        var tempDiv = document.createElement('DIV');
	        tempDiv.innerHTML = htmlString;
	        if (tempDiv.childNodes.length == 1) {
	            return (/** @type {!Node} */tempDiv.removeChild(tempDiv.firstChild)
	            );
	        } else {
	            var fragment = document.createDocumentFragment();
	            while (tempDiv.firstChild) {
	                fragment.appendChild(tempDiv.firstChild);
	            }
	            return fragment;
	        }
	    };
	
	    /**
	     * Removes all children from the node.
	     *
	     * @param {Node} node The node to remove all children from.
	     * @private
	     */
	    RichMarker.prototype.removeChildren_ = function (node) {
	        if (!node) {
	            return;
	        }
	
	        var child;
	        while (child = node.firstChild) {
	            node.removeChild(child);
	        }
	    };
	
	    /**
	     * Sets the content of the marker.
	     *
	     * @param {string|Node} content The content to set.
	     */
	    RichMarker.prototype.setContent = function (content) {
	        this.set('content', content);
	    };
	    RichMarker.prototype['setContent'] = RichMarker.prototype.setContent;
	
	    /**
	     * Get the content of the marker.
	     *
	     * @return {string|Node} The marker content.
	     */
	    RichMarker.prototype.getContent = function () {
	        return (/** @type {Node|string} */this.get('content')
	        );
	    };
	    RichMarker.prototype['getContent'] = RichMarker.prototype.getContent;
	
	    /**
	     * Sets the marker content and adds loading events to images
	     */
	    RichMarker.prototype.content_changed = function () {
	        if (!this.markerContent_) {
	            // Marker content area doesnt exist.
	            return;
	        }
	
	        this.removeChildren_(this.markerContent_);
	        var content = this.getContent();
	        if (content) {
	            if (typeof content == 'string') {
	                content = content.replace(/^\s*([\S\s]*)\b\s*$/, '$1');
	                content = this.htmlToDocumentFragment_(content);
	            }
	            this.markerContent_.appendChild(content);
	
	            var that = this;
	            var images = this.markerContent_.getElementsByTagName('IMG');
	            for (var i = 0, image; image = images[i]; i++) {
	                // By default, a browser lets a image be dragged outside of the browser,
	                // so by calling preventDefault we stop this behaviour and allow the image
	                // to be dragged around the map and now out of the browser and onto the
	                // desktop.
	                google.maps.event.addDomListener(image, 'mousedown', function (e) {
	                    if (that.getDraggable()) {
	                        if (e.preventDefault) {
	                            e.preventDefault();
	                        }
	                        e.returnValue = false;
	                    }
	                });
	
	                // Because we don't know the size of an image till it loads, add a
	                // listener to the image load so the marker can resize and reposition
	                // itself to be the correct height.
	                google.maps.event.addDomListener(image, 'load', function () {
	                    that.draw();
	                });
	            }
	
	            google.maps.event.trigger(this, 'domready');
	        }
	
	        if (this.ready_) {
	            this.draw();
	        }
	    };
	    RichMarker.prototype['content_changed'] = RichMarker.prototype.content_changed;
	
	    /**
	     * Sets the cursor.
	     *
	     * @param {string} whichCursor What cursor to show.
	     * @private
	     */
	    RichMarker.prototype.setCursor_ = function (whichCursor) {
	        if (!this.ready_) {
	            return;
	        }
	
	        var cursor = '';
	        if (navigator.userAgent.indexOf('Gecko/') !== -1) {
	            // Moz has some nice cursors :)
	            if (whichCursor == 'dragging') {
	                cursor = '-moz-grabbing';
	            }
	
	            if (whichCursor == 'dragready') {
	                cursor = '-moz-grab';
	            }
	
	            if (whichCursor == 'draggable') {
	                cursor = 'pointer';
	            }
	        } else {
	            if (whichCursor == 'dragging' || whichCursor == 'dragready') {
	                cursor = 'move';
	            }
	
	            if (whichCursor == 'draggable') {
	                cursor = 'pointer';
	            }
	        }
	
	        if (this.markerWrapper_.style.cursor != cursor) {
	            this.markerWrapper_.style.cursor = cursor;
	        }
	    };
	
	    /**
	     * Start dragging.
	     *
	     * @param {Event} e The event.
	     */
	    RichMarker.prototype.startDrag = function (e) {
	        if (!this.getDraggable()) {
	            return;
	        }
	
	        if (!this.dragging_) {
	            this.dragging_ = true;
	            var map = this.getMap();
	            this.mapDraggable_ = map.get('draggable');
	            map.set('draggable', false);
	
	            // Store the current mouse position
	            this.mouseX_ = e.clientX;
	            this.mouseY_ = e.clientY;
	
	            this.setCursor_('dragready');
	
	            // Stop the text from being selectable while being dragged
	            this.markerWrapper_.style['MozUserSelect'] = 'none';
	            this.markerWrapper_.style['KhtmlUserSelect'] = 'none';
	            this.markerWrapper_.style['WebkitUserSelect'] = 'none';
	
	            this.markerWrapper_['unselectable'] = 'on';
	            this.markerWrapper_['onselectstart'] = function () {
	                return false;
	            };
	
	            this.addDraggingListeners_();
	
	            google.maps.event.trigger(this, 'dragstart');
	        }
	    };
	
	    /**
	     * Stop dragging.
	     */
	    RichMarker.prototype.stopDrag = function () {
	        if (!this.getDraggable()) {
	            return;
	        }
	
	        if (this.dragging_) {
	            this.dragging_ = false;
	            this.getMap().set('draggable', this.mapDraggable_);
	            this.mouseX_ = this.mouseY_ = this.mapDraggable_ = null;
	
	            // Allow the text to be selectable again
	            this.markerWrapper_.style['MozUserSelect'] = '';
	            this.markerWrapper_.style['KhtmlUserSelect'] = '';
	            this.markerWrapper_.style['WebkitUserSelect'] = '';
	            this.markerWrapper_['unselectable'] = 'off';
	            this.markerWrapper_['onselectstart'] = function () {};
	
	            this.removeDraggingListeners_();
	
	            this.setCursor_('draggable');
	            google.maps.event.trigger(this, 'dragend');
	
	            this.draw();
	        }
	    };
	
	    /**
	     * Handles the drag event.
	     *
	     * @param {Event} e The event.
	     */
	    RichMarker.prototype.drag = function (e) {
	        if (!this.getDraggable() || !this.dragging_) {
	            // This object isn't draggable or we have stopped dragging
	            this.stopDrag();
	            return;
	        }
	
	        var dx = this.mouseX_ - e.clientX;
	        var dy = this.mouseY_ - e.clientY;
	
	        this.mouseX_ = e.clientX;
	        this.mouseY_ = e.clientY;
	
	        var left = parseInt(this.markerWrapper_.style['left'], 10) - dx;
	        var top = parseInt(this.markerWrapper_.style['top'], 10) - dy;
	
	        this.markerWrapper_.style['left'] = left + 'px';
	        this.markerWrapper_.style['top'] = top + 'px';
	
	        var offset = this.getOffset_();
	
	        // Set the position property and adjust for the anchor offset
	        var point = new google.maps.Point(left - offset.width, top - offset.height);
	        var projection = this.getProjection();
	        this.setPosition(projection.fromDivPixelToLatLng(point));
	
	        this.setCursor_('dragging');
	        google.maps.event.trigger(this, 'drag');
	    };
	
	    /**
	     * Removes the drag listeners associated with the marker.
	     *
	     * @private
	     */
	    RichMarker.prototype.removeDragListeners_ = function () {
	        if (this.draggableListener_) {
	            google.maps.event.removeListener(this.draggableListener_);
	            delete this.draggableListener_;
	        }
	        this.setCursor_('');
	    };
	
	    /**
	     * Add dragability events to the marker.
	     *
	     * @param {Node} node The node to apply dragging to.
	     * @private
	     */
	    RichMarker.prototype.addDragging_ = function (node) {
	        if (!node) {
	            return;
	        }
	
	        var that = this;
	        this.draggableListener_ = google.maps.event.addDomListener(node, 'mousedown', function (e) {
	            that.startDrag(e);
	        });
	
	        this.setCursor_('draggable');
	    };
	
	    /**
	     * Add dragging listeners.
	     *
	     * @private
	     */
	    RichMarker.prototype.addDraggingListeners_ = function () {
	        var that = this;
	        if (this.markerWrapper_.setCapture) {
	            this.markerWrapper_.setCapture(true);
	            this.draggingListeners_ = [google.maps.event.addDomListener(this.markerWrapper_, 'mousemove', function (e) {
	                that.drag(e);
	            }, true), google.maps.event.addDomListener(this.markerWrapper_, 'mouseup', function () {
	                that.stopDrag();
	                that.markerWrapper_.releaseCapture();
	            }, true)];
	        } else {
	            this.draggingListeners_ = [google.maps.event.addDomListener(window, 'mousemove', function (e) {
	                that.drag(e);
	            }, true), google.maps.event.addDomListener(window, 'mouseup', function () {
	                that.stopDrag();
	            }, true)];
	        }
	    };
	
	    /**
	     * Remove dragging listeners.
	     *
	     * @private
	     */
	    RichMarker.prototype.removeDraggingListeners_ = function () {
	        if (this.draggingListeners_) {
	            for (var i = 0, listener; listener = this.draggingListeners_[i]; i++) {
	                google.maps.event.removeListener(listener);
	            }
	            this.draggingListeners_.length = 0;
	        }
	    };
	
	    /**
	     * Get the anchor offset.
	     *
	     * @return {google.maps.Size} The size offset.
	     * @private
	     */
	    RichMarker.prototype.getOffset_ = function () {
	        var anchor = this.getAnchor();
	        if ((typeof anchor === 'undefined' ? 'undefined' : _typeof(anchor)) == 'object') {
	            return (/** @type {google.maps.Size} */anchor
	            );
	        }
	
	        var offset = new google.maps.Size(0, 0);
	        if (!this.markerContent_) {
	            return offset;
	        }
	
	        var width = this.markerContent_.offsetWidth;
	        var height = this.markerContent_.offsetHeight;
	
	        switch (anchor) {
	            case RichMarkerPosition['TOP_LEFT']:
	                break;
	            case RichMarkerPosition['TOP']:
	                offset.width = -width / 2;
	                break;
	            case RichMarkerPosition['TOP_RIGHT']:
	                offset.width = -width;
	                break;
	            case RichMarkerPosition['LEFT']:
	                offset.height = -height / 2;
	                break;
	            case RichMarkerPosition['MIDDLE']:
	                offset.width = -width / 2;
	                offset.height = -height / 2;
	                break;
	            case RichMarkerPosition['RIGHT']:
	                offset.width = -width;
	                offset.height = -height / 2;
	                break;
	            case RichMarkerPosition['BOTTOM_LEFT']:
	                offset.height = -height;
	                break;
	            case RichMarkerPosition['BOTTOM']:
	                offset.width = -width / 2;
	                offset.height = -height;
	                break;
	            case RichMarkerPosition['BOTTOM_RIGHT']:
	                offset.width = -width;
	                offset.height = -height;
	                break;
	        }
	
	        return offset;
	    };
	
	    /**
	     * Adding the marker to a map.
	     * Implementing the interface.
	     */
	    RichMarker.prototype.onAdd = function () {
	        if (!this.markerWrapper_) {
	            this.markerWrapper_ = document.createElement('DIV');
	            this.markerWrapper_.style['position'] = 'absolute';
	        }
	
	        if (this.getZIndex()) {
	            this.markerWrapper_.style['zIndex'] = this.getZIndex();
	        }
	
	        this.markerWrapper_.style['display'] = this.getVisible() ? '' : 'none';
	
	        if (!this.markerContent_) {
	            this.markerContent_ = document.createElement('DIV');
	            this.markerWrapper_.appendChild(this.markerContent_);
	
	            var that = this;
	            google.maps.event.addDomListener(this.markerContent_, 'click', function (e) {
	                google.maps.event.trigger(that, 'click', e);
	            });
	            google.maps.event.addDomListener(this.markerContent_, 'mouseover', function (e) {
	                google.maps.event.trigger(that, 'mouseover', e);
	            });
	            google.maps.event.addDomListener(this.markerContent_, 'mouseout', function (e) {
	                google.maps.event.trigger(that, 'mouseout', e);
	            });
	        }
	
	        this.ready_ = true;
	        this.content_changed();
	        this.flat_changed();
	        this.draggable_changed();
	
	        var panes = this.getPanes();
	        if (panes) {
	            panes.overlayMouseTarget.appendChild(this.markerWrapper_);
	        }
	
	        google.maps.event.trigger(this, 'ready');
	    };
	    RichMarker.prototype['onAdd'] = RichMarker.prototype.onAdd;
	
	    /**
	     * Impelementing the interface.
	     */
	    RichMarker.prototype.draw = function () {
	        if (!this.ready_ || this.dragging_) {
	            return;
	        }
	
	        var projection = this.getProjection();
	
	        if (!projection) {
	            // The map projection is not ready yet so do nothing
	            return;
	        }
	
	        var latLng = /** @type {google.maps.LatLng} */this.get('position');
	        var pos = projection.fromLatLngToDivPixel(latLng);
	
	        var offset = this.getOffset_();
	        this.markerWrapper_.style['top'] = pos.y + offset.height + 'px';
	        this.markerWrapper_.style['left'] = pos.x + offset.width + 'px';
	
	        var height = this.markerContent_.offsetHeight;
	        var width = this.markerContent_.offsetWidth;
	
	        if (width != this.get('width')) {
	            this.set('width', width);
	        }
	
	        if (height != this.get('height')) {
	            this.set('height', height);
	        }
	    };
	    RichMarker.prototype['draw'] = RichMarker.prototype.draw;
	
	    /**
	     * Removing a marker from the map.
	     * Implementing the interface.
	     */
	    RichMarker.prototype.onRemove = function () {
	        if (this.markerWrapper_ && this.markerWrapper_.parentNode) {
	            this.markerWrapper_.parentNode.removeChild(this.markerWrapper_);
	        }
	        this.removeDragListeners_();
	    };
	    RichMarker.prototype['onRemove'] = RichMarker.prototype.onRemove;
	
	    /**
	     * RichMarker Anchor positions
	     * @enum {number}
	     */
	    var RichMarkerPosition = {
	        'TOP_LEFT': 1,
	        'TOP': 2,
	        'TOP_RIGHT': 3,
	        'LEFT': 4,
	        'MIDDLE': 5,
	        'RIGHT': 6,
	        'BOTTOM_LEFT': 7,
	        'BOTTOM': 8,
	        'BOTTOM_RIGHT': 9
	    };
	
	    return {
	        RichMarker: RichMarker,
	        RichMarkerPosition: RichMarkerPosition
	    };
	}
	
	var cache = {};
	/**
	 * Memoizes a function
	 *
	 * @param {Function} f
	 * @returns {Function}
	 */
	function memoize(f) {
	    return function _memoized() {
	        if (!cache[f]) cache[f] = f.apply(null, arguments);
	        return cache[f];
	    };
	}
	
	/**
	 * Adds lazy getter properties to an object
	 *
	 * @param {Object} target
	 * @param {Iterable} properties
	 * @param {Function} provider
	 */
	function lazy(target, properties, provider) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var property = _step.value;
	            Object.defineProperty(target, property, {
	                configurable: true,
	                enumerable: true,
	                get: function get() {
	                    var source = provider();
	                    delete target[property];
	                    target[property] = source[property];
	                    return source[property];
	                }
	            });
	        };
	
	        for (var _iterator = properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return target;
	}
	
	exports.default = lazy({}, ["RichMarker", "RichMarkerPosition"], memoize(initializeRichMarker));


/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlayPauseButton = __webpack_require__(71);
	
	var _PlayPauseButton2 = _interopRequireDefault(_PlayPauseButton);
	
	var _VolumeControls = __webpack_require__(559);
	
	var _VolumeControls2 = _interopRequireDefault(_VolumeControls);
	
	var _AudioPlayerModule = __webpack_require__(834);
	
	var _AudioPlayerModule2 = _interopRequireDefault(_AudioPlayerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AudioPlayer = function (_Component) {
	  _inherits(AudioPlayer, _Component);
	
	  function AudioPlayer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AudioPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isAudioPaused: true,
	      isVolumeOpen: false,
	      currVolume: '',
	      durationInt: '',
	      currTimeInt: '',
	      duration: '',
	      currTime: ''
	    }, _this.strPadLeft = function (string, pad, length) {
	      return (new Array(length + 1).join(pad) + string).slice(-length);
	    }, _this.convertTime = function (time) {
	      var roundedTime = Math.ceil(time);
	      var minutes = Math.floor(roundedTime / 60);
	      var seconds = roundedTime - minutes * 60;
	
	      return minutes + ':' + _this.strPadLeft(seconds, '0', 2);
	    }, _this.setAudioState = function () {
	      var audio = _this.audio;
	
	      if (audio !== null) {
	        _this.setState({
	          durationInt: audio.duration,
	          currTimeInt: audio.currentTime,
	          duration: _this.convertTime(audio.duration),
	          currTime: _this.convertTime(audio.currentTime)
	        });
	      }
	    }, _this.handleProgress = function () {
	      _this.setAudioState();
	
	      _this.animateProgress = requestAnimationFrame(_this.handleProgress);
	    }, _this.getProgressWidth = function (currentTime, duration) {
	      return currentTime / duration * 100 + '%';
	    }, _this.setAudioProgress = function () {
	      return {
	        width: _this.getProgressWidth(_this.state.currTimeInt, _this.state.durationInt)
	      };
	    }, _this.getTouchAmount = function (e) {
	      var rect = _this.progressWrapper.getBoundingClientRect();
	
	      if (e.type === 'mousemove' || e.type === 'mousedown') {
	        return (e.clientX - rect.left) / rect.width;
	      } else if (e.type === 'touchmove' || e.type === 'touchstart') {
	        return (e.touches[0].clientX - rect.left) / rect.width;
	      }
	    }, _this.handleScrubMove = function (e) {
	      var percentage = _this.getTouchAmount(e);
	
	      _this.audio.currentTime = percentage * _this.state.durationInt;
	
	      if (_this.state.isAudioPaused) {
	        _this.setAudioState();
	      }
	    }, _this.handleScrubUp = function (e) {
	      if (e.type === 'mouseup') {
	        window.removeEventListener('mousemove', _this.handleScrubMove);
	        window.removeEventListener('mouseup', _this.handleScrubUp);
	      } else if (e.type === 'touchend') {
	        window.removeEventListener('touchmove', _this.handleScrubMove);
	        window.removeEventListener('touchend', _this.handleScrubUp);
	      }
	    }, _this.handleMouseDown = function (e) {
	      e.preventDefault();
	      window.addEventListener('mousemove', _this.handleScrubMove);
	      window.addEventListener('mouseup', _this.handleScrubUp);
	      _this.handleScrubMove(e);
	    }, _this.handleTouchStart = function (e) {
	      e.preventDefault();
	      window.addEventListener('touchmove', _this.handleScrubMove);
	      window.addEventListener('touchend', _this.handleScrubUp);
	      _this.handleScrubMove(e);
	    }, _this.handlePlayPause = function () {
	      _this.setState(function (state) {
	        return {
	          isAudioPaused: !state.isAudioPaused
	        };
	      });
	    }, _this.handleVolumeVisibility = function () {
	      _this.setState(function (state) {
	        return {
	          isVolumeOpen: !state.isVolumeOpen
	        };
	      });
	    }, _this.handleVolumeLevel = function (e) {
	      _this.setState({
	        currVolume: e.target.value
	      });
	
	      _this.audio.volume = _this.state.currVolume;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // Check for trailing zero and add to time if needed
	
	
	  // Convert seconds into minutes:seconds
	
	
	  AudioPlayer.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var audio = this.audio;
	
	    if (audio !== null) {
	      audio.addEventListener('loadedmetadata', function () {
	        _this2.setAudioState();
	      });
	
	      audio.addEventListener('pause', function () {
	        _this2.setState({
	          isAudioPaused: true
	        });
	      });
	    }
	  };
	
	  AudioPlayer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // Check if audio is paused
	    if (prevState.isAudioPaused !== this.state.isAudioPaused) {
	      console.log(this.audio);
	      if (this.state.isAudioPaused) {
	        this.audio.pause();
	        cancelAnimationFrame(this.animateProgress);
	      } else {
	        this.audio.play();
	        this.animateProgress = requestAnimationFrame(this.handleProgress);
	      }
	    }
	  };
	
	  AudioPlayer.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _AudioPlayerModule2.default.audioWrapper },
	      _react2.default.createElement(
	        'audio',
	        {
	          src: this.props.source,
	          preload: 'auto',
	          className: _AudioPlayerModule2.default.audioElement,
	          ref: function ref(el) {
	            return _this3.audio = el;
	          }
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your browser does not support native audio, but you can',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: this.props.source, target: '_blank' },
	            'download this MP3'
	          ),
	          ' ',
	          'to listen on your device.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _AudioPlayerModule2.default.audioPlayer },
	        _react2.default.createElement(_PlayPauseButton2.default, {
	          onPlayPauseClick: this.handlePlayPause,
	          isAudioPaused: this.state.isAudioPaused,
	          noBorder: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _AudioPlayerModule2.default.audioInfo },
	          _react2.default.createElement(
	            'div',
	            { className: _AudioPlayerModule2.default.audioTitle },
	            this.props.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _AudioPlayerModule2.default.audioControls },
	            _react2.default.createElement(
	              'div',
	              {
	                className: _AudioPlayerModule2.default.progressWrapper,
	                onMouseDown: this.handleMouseDown,
	                onTouchStart: this.handleTouchStart,
	                ref: function ref(el) {
	                  return _this3.progressWrapper = el;
	                }
	              },
	              _react2.default.createElement('div', {
	                className: 'audio-progress ' + _AudioPlayerModule2.default.progress,
	                style: this.setAudioProgress()
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _AudioPlayerModule2.default.audioTime },
	              _react2.default.createElement(
	                'span',
	                { className: _AudioPlayerModule2.default.currTime },
	                this.state.currTime
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: _AudioPlayerModule2.default.duration },
	                this.state.duration
	              )
	            ),
	            _react2.default.createElement(_VolumeControls2.default, {
	              currVolume: this.state.currVolume,
	              handleVolumeVisibility: this.handleVolumeVisibility,
	              handleVolumeLevel: this.handleVolumeLevel,
	              isVolumeOpen: this.state.isVolumeOpen
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return AudioPlayer;
	}(_react.Component);
	
	exports.default = AudioPlayer;
	module.exports = exports['default'];

/***/ }),
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(181);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _IntroWithWatermark = __webpack_require__(344);
	
	var _IntroWithWatermark2 = _interopRequireDefault(_IntroWithWatermark);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _PinSvg = __webpack_require__(537);
	
	var _PinSvg2 = _interopRequireDefault(_PinSvg);
	
	var _SwipeSvg = __webpack_require__(538);
	
	var _SwipeSvg2 = _interopRequireDefault(_SwipeSvg);
	
	var _onboardingModule = __webpack_require__(859);
	
	var _onboardingModule2 = _interopRequireDefault(_onboardingModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OnboardingIntro = function OnboardingIntro() {
	  return _react2.default.createElement(_IntroWithWatermark2.default, {
	    watermark: 'LES',
	    label: 'Henry Street Settlement',
	    title: '<strong>Walking Tour</strong>'
	  });
	};
	
	var Slide1 = function Slide1() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: _onboardingModule2.default.text },
	      'Explore the neighborhood the',
	      _react2.default.createElement(
	        'strong',
	        null,
	        ' Henry Street Settlement '
	      ),
	      'calls home.'
	    )
	  );
	};
	
	var Slide2 = function Slide2() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: _onboardingModule2.default.text },
	      _react2.default.createElement(
	        'span',
	        { className: _onboardingModule2.default.pinIcon },
	        _react2.default.createElement(_PinSvg2.default, null)
	      ),
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Tap the pins'
	      ),
	      ' to explore different locations'
	    )
	  );
	};
	
	var Slide3 = function Slide3() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: _onboardingModule2.default.text },
	      _react2.default.createElement(
	        'span',
	        { className: _onboardingModule2.default.swipeIcon },
	        _react2.default.createElement(_SwipeSvg2.default, null)
	      ),
	      _react2.default.createElement(
	        'strong',
	        null,
	        'swipe up'
	      ),
	      ' to uncover more information'
	    )
	  );
	};
	
	var Onboarding = function (_Component) {
	  _inherits(Onboarding, _Component);
	
	  function Onboarding() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Onboarding);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.slickOptions = {
	      dots: true,
	      infinite: false,
	      draggable: true,
	      speed: 500,
	      // cssEase: 'cubic-bezier(.9, 0, .3, 1)',
	      nextArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'right' }),
	      prevArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'left' })
	    }, _this.ExploreButton = _react2.default.createElement(
	      'button',
	      {
	        className: _onboardingModule2.default.button,
	        onClick: _this.props.handleEnterFromOnboarding
	      },
	      'Enter'
	    ), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Onboarding.prototype.componentDidMount = function componentDidMount() {
	    this.forceUpdate();
	  };
	
	  Onboarding.prototype.render = function render() {
	    var _this2 = this;
	
	    var slides = [_react2.default.createElement(OnboardingIntro, null), _react2.default.createElement(Slide1, null), _react2.default.createElement(Slide2, null), _react2.default.createElement(Slide3, null)];
	    if (typeof window !== 'undefined' && this.props.isMobileDevice === true) {
	      return _react2.default.createElement(
	        'div',
	        { className: _onboardingModule2.default.wrapper + ' ' + _onboardingModule2.default[this.props.status] },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          _extends({
	            className: 'onboarding-slick ' + _onboardingModule2.default.slickWrap
	          }, this.slickOptions),
	          slides.map(function (slide, index) {
	            return _react2.default.createElement(
	              'div',
	              { key: index + '-onboarding-slide' },
	              slide,
	              index === slides.length - 1 ? _this2.ExploreButton : null
	            );
	          })
	        )
	      );
	    } else {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: 'onboarding',
	          className: _onboardingModule2.default.wrapper + ' ' + _onboardingModule2.default[this.props.status]
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _onboardingModule2.default.verticalCenter },
	          _react2.default.createElement(OnboardingIntro, null),
	          _react2.default.createElement(Slide1, null),
	          _react2.default.createElement(Slide2, null),
	          _react2.default.createElement(
	            'button',
	            {
	              className: _onboardingModule2.default.button,
	              onClick: this.props.handleEnterFromOnboarding
	            },
	            'Enter'
	          )
	        )
	      );
	    }
	  };
	
	  return Onboarding;
	}(_react.Component);
	
	exports.default = Onboarding;
	module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    {
	      xmlns: "http://www.w3.org/2000/svg",
	      width: "41",
	      height: "41",
	      viewBox: "0 0 41 41"
	    },
	    _react2.default.createElement("path", {
	      fill: "none",
	      stroke: "#D6434F",
	      strokeLinejoin: "bevel",
	      strokeWidth: "3.75",
	      d: "M1100,2936.41889 L1108.98169,2933.42499 C1109.57914,2933.22584 1110.23138,2933.27353 1110.79351,2933.55746 C1113.24412,2934.79527 1115.95245,2935.43672 1118.70317,2935.42955 C1125.41165,2935.42696 1131.54314,2931.63511 1134.54673,2925.62538 C1135.78454,2923.17477 1136.42599,2920.46644 1136.41883,2917.72097 L1136.42241,2916.66394 C1135.92634,2907.67224 1128.74665,2900.49255 1119.88506,2900.00007 L1118.69792,2900.00006 C1115.95245,2899.9929 1113.24412,2900.63435 1110.78455,2901.87666 C1104.78378,2904.87575 1100.99193,2911.00724 1100.98933,2917.72097 C1100.98217,2920.46644 1101.62362,2923.17477 1102.86143,2925.62538 C1103.14536,2926.18751 1103.19305,2926.83975 1102.9939,2927.4372 L1100,2936.41889 Z",
	      transform: "translate(-1098 -2898)"
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var style = _ref.style;
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 34 49", xmlns: "http://www.w3.org/2000/svg", className: style },
	    _react2.default.createElement("path", { d: "M17 0C7.601 0 0 7.668 0 17.15 0 30.013 17 49 17 49s17-18.988 17-31.85C34 7.669 26.399 0 17 0z" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 22" },
	    _react2.default.createElement("path", { transform: "translate(-1,-1)", d: "M12,8 C9.79,8 8,9.79 8,12 C8,14.21 9.79,16 12,16 C14.21,16 16,14.21 16,12 C16,9.79 14.21,8 12,8 L12,8 Z M20.94,11 C20.48,6.83 17.17,3.52 13,3.06 L13,1 L11,1 L11,3.06 C6.83,3.52 3.52,6.83 3.06,11 L1,11 L1,13 L3.06,13 C3.52,17.17 6.83,20.48 11,20.94 L11,23 L13,23 L13,20.94 C17.17,20.48 20.48,17.17 20.94,13 L23,13 L23,11 L20.94,11 L20.94,11 Z M12,19 C8.13,19 5,15.87 5,12 C5,8.13 8.13,5 12,5 C15.87,5 19,8.13 19,12 C19,15.87 15.87,19 12,19 L12,19 Z" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 46\">\n    <title>Arts</title>\n    <path d=\"M18.78,11.52c-3,0-5.57-.83-6.85-2V23.38c0,3.15,2.85,5.12,6.89,5.12s6.81-1.79,6.81-5v-14C24.35,10.69,21.76,11.52,18.78,11.52Zm-3.31,5a2.15,2.15,0,0,1,2,1.46l-4,0A2.3,2.3,0,0,1,15.47,16.55Zm3.31,8.14c-2.05,0-3.74-1-3.93-2.27l7.86,0C22.51,23.71,20.83,24.69,18.78,24.69ZM20.12,18a2.31,2.31,0,0,1,2.07-1.43,2.17,2.17,0,0,1,2,1.47Z\" />\n    <path d=\"M34.22,19.55c-3,0-5.57-.83-6.85-2.05V31.41c0,3.15,2.85,5.12,6.9,5.12s6.8-1.8,6.8-5v-14C39.79,18.72,37.2,19.55,34.22,19.55ZM28.84,25.5l4,0A2.31,2.31,0,0,1,30.81,27,2.16,2.16,0,0,1,28.84,25.5Zm1.45,6.63c.2-1.27,1.88-2.26,3.93-2.25s3.74,1,3.93,2.27ZM37.53,27a2.15,2.15,0,0,1-2-1.46l4,0A2.3,2.3,0,0,1,37.53,27Z\" />\n  </svg>";
	module.exports = exports["default"];

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 46\">\n    <title>Bridge</title>\n    <path d=\"M42.92,22.78a7.3,7.3,0,0,0,.94-.05V20.14a5.77,5.77,0,0,1-.94.08A6.15,6.15,0,0,1,39.3,19,7.61,7.61,0,0,1,38.15,18a11.08,11.08,0,0,1-2-6.54H33.52c0,4.4-3.1,8.81-6.89,8.81s-6.87-4.41-6.88-8.81h-2.6v.87a8.27,8.27,0,0,1-3.55,7,6.13,6.13,0,0,1-3.34,1,5.91,5.91,0,0,1-1.12-.11v2.6a8.32,8.32,0,0,0,1.12.08,8.55,8.55,0,0,0,1.34-.11v4.77H9.15v2.57h7.94v2H14.21v2.57h8.32V32H19.65v-2h13.8v2H30.58v2.57H38.9V32H36v-2h7.83V27.48H41.4V22.65A8.59,8.59,0,0,0,42.92,22.78Zm-28.75,4.7v-5.6A9.42,9.42,0,0,0,17,19.67l.09-.1v7.91Zm5.48-4.42V19.35l.25.29a9.59,9.59,0,0,0,2.64,2.11v5.73H19.65Zm5.46,0v-.41a8.59,8.59,0,0,0,1.52.13,8.93,8.93,0,0,0,1.37-.1v4.8H25.11Zm5.46,4.42V21.83a9.39,9.39,0,0,0,2.8-2.19l.08-.1v7.94Zm5.45,0V19.4l.2.24a9.37,9.37,0,0,0,2.62,2.11v5.73Z\" />\n  </svg>";
	module.exports = exports["default"];

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 46\">\n    <title>Building</title>\n    <path d=\"M12.3,36.34H25.65V9.66H12.3Zm8-23.72H23v3H20.31Zm0,5.93H23v3H20.31Zm0,5.93H23v3H20.31Zm0,5.93H23v3H20.31ZM15,12.62h2.67v3H15Zm0,5.93h2.67v3H15Zm0,5.93h2.67v3H15Zm0,5.93h2.67v3H15Z\" />\n    <path d=\"M27.35,21V36.34H40.7V21Zm5.27,12.38H30v-3h2.6Zm0-5.93H30v-3h2.6ZM38,33.38H35.36v-3H38Zm0-5.93H35.36v-3H38Z\" />\n  </svg>";
	module.exports = exports["default"];

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 46\">\n    <title>Market Fair</title>\n    <path d=\"M35.94,28.45a4.6,4.6,0,0,1,1.22.17h0V24.43H15.84v4.12a4.5,4.5,0,0,1,1.22-.18,4.41,4.41,0,0,1,2.06.53,4.7,4.7,0,0,1,2.42,4.15.53.53,0,0,1,0,.13h9.93v0A4.59,4.59,0,0,1,35.94,28.45Z\" />\n    <path d=\"M37.3,30.26a2.86,2.86,0,0,0-1.36-.34,3.11,3.11,0,0,0-3,3.21c0,.12,0,.24,0,.36a3.1,3.1,0,0,0,3,2.85,2.66,2.66,0,0,0,.9-.15,2.85,2.85,0,0,0,.68-.33,3.32,3.32,0,0,0-.22-5.6Z\" />\n    <path d=\"M18.42,30.19a2.86,2.86,0,0,0-1.36-.35,3.12,3.12,0,0,0-3,3.21,2.23,2.23,0,0,0,0,.37,3.08,3.08,0,0,0,3,2.84,3,3,0,0,0,.9-.14,2.85,2.85,0,0,0,.68-.33,3.29,3.29,0,0,0,1.43-2.74A3.23,3.23,0,0,0,18.42,30.19Z\" />\n    <path d=\"M15.66,19.32c.06.1.13.2.2.3v3.12H18V21.12a3.77,3.77,0,0,0,1.06.15,4.13,4.13,0,0,0,3.73-2.57,4,4,0,0,0,7.46,0A4.14,4.14,0,0,0,34,21.27,3.79,3.79,0,0,0,35,21.11v1.63h2.13V19.61c.09-.12.17-.23.25-.36a4.31,4.31,0,0,0,.69-2,3.32,3.32,0,0,0,0-.63,12.66,12.66,0,0,0-.26-1.34l-.13-.63-1.06-5H16.37l-1.05,5a8.38,8.38,0,0,0-.39,2.59A4.86,4.86,0,0,0,15.66,19.32Z\" />\n  </svg>";
	module.exports = exports["default"];

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 46\">\n    <title>Park</title>\n    <path d=\"M30.52,27.1a4,4,0,1,0,3.95-7,4.16,4.16,0,0,0,1.69-5.63,4.16,4.16,0,0,0-5.64-1.38,4.16,4.16,0,0,0-4-4.19,4.15,4.15,0,0,0-4,4.12,4.15,4.15,0,0,0-5.59,1.36A4.18,4.18,0,0,0,18.53,20a4,4,0,1,0,3.95,7,4,4,0,1,0,8,.08Zm-4-3.88a2.61,2.61,0,1,1,2.44-2.6A2.53,2.53,0,0,1,26.5,23.22Z\" />\n    <path d=\"M20.73,32.28a5,5,0,0,0-4.84,4.84h9.68A5,5,0,0,0,20.73,32.28Z\" />\n    <path d=\"M32.26,31.88a5,5,0,0,0-4.85,5.17v.07H37.1s0,0,0-.07A5,5,0,0,0,32.26,31.88Z\" />\n  </svg>";
	module.exports = exports["default"];

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 46\">\n    <title>Religious Structure</title>\n    <path d=\"M39.38,31.68c0,3.68-4.64,4.57-4.64,4.57V18.51h4.64Z\" />\n    <path d=\"M13.62,31.67c0,3.68,4.64,4.58,4.64,4.58V18.5H13.62Z\" />\n    <path d=\"M26.58,9.75,20,18.37V36.24h4.09c0-2.55,0-5,0-6.57,0-3.07,1.23-4.1,2.66-4.1q2.44,0,2.45,4v6.67h4.07V18.37Zm0,13a2.43,2.43,0,1,1,2.28-2.43A2.36,2.36,0,0,1,26.57,22.7Z\" />\n  </svg>";
	module.exports = exports["default"];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    {
	      version: "1.1",
	      id: "Layer_1",
	      xmlns: "http://www.w3.org/2000/svg",
	      x: "0px",
	      y: "0px",
	      viewBox: "0 0 20 32"
	    },
	    _react2.default.createElement(
	      "g",
	      { transform: "translate(1 1)" },
	      _react2.default.createElement("rect", { x: "2.7", y: "29.8", width: "12.6", height: "1" }),
	      _react2.default.createElement("path", { d: "M9,12.8c-1.7,0-3-1.6-3-3.5s1.3-3.5,3-3.5s3,1.6,3,3.5S10.7,12.8,9,12.8L9,12.8z" }),
	      _react2.default.createElement("path", {
	        d: "M9,26.5l-0.4-0.4C8.3,25.7-0.5,15.8-0.5,8.9c0-5.3,4.3-9.6,9.5-9.6s9.5,4.3,9.5,9.6c0,6.9-8.8,16.8-9.1,17.2 L9,26.5z M9,0.2c-4.7,0-8.5,3.9-8.5,8.6C0.5,14.6,7.3,23,9,25c1.7-2,8.5-10.4,8.5-16.1C17.5,4.1,13.7,0.2,9,0.2z"
	      })
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    {
	      id: "Layer_1",
	      "data-name": "Layer 1",
	      xmlns: "http://www.w3.org/2000/svg",
	      viewBox: "0 0 20 32"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "onboarding_swipe"
	    ),
	    _react2.default.createElement("path", {
	      id: "swipe-up",
	      d: "M5.25,3.55v9.08H4.58V3.56L.69,7.62.25,7.16,4.92,2.28,9.59,7.16l-.45.46Z"
	    }),
	    _react2.default.createElement("path", { d: "M6.28,20.54a3,3,0,0,1-.1-.32,4.45,4.45,0,0,0-.94-2c-1-1.13.54-1.43,1-1.23a5.74,5.74,0,0,1,1.91,2.16c.54,1,1.53,1.58,2.07,1.38s.93-.5.29-3.6-1.42-6.72-1.37-7c.2-1,1.52-.79,1.81,0s.43,1.52.64,2.27a20.08,20.08,0,0,0,1.16,4c1-.41,2,.51,2.58,1.28.12.16,1,.28,1.23.36a2.23,2.23,0,0,1,1.57,1.32,2.43,2.43,0,0,0,.35.49c.19.2.64.34.89.55a1.35,1.35,0,0,1,.39,1.07,23.08,23.08,0,0,1-.34,5c-.3.59.34,2.16.34,2.16l-7.28,1.24c.16,0-.23-1.64-.32-1.8-.3-.59-.74-.72-1.31-.94a4.58,4.58,0,0,1-2.6-2.73,12.64,12.64,0,0,0-1-2.2A10,10,0,0,1,6.28,20.54Z" })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(296);
	
	var _ChapterSectionPressPlayPixi = __webpack_require__(340);
	
	var _ChapterSectionPressPlayPixi2 = _interopRequireDefault(_ChapterSectionPressPlayPixi);
	
	var _ChapterSectionVideo = __webpack_require__(341);
	
	var _ChapterSectionVideo2 = _interopRequireDefault(_ChapterSectionVideo);
	
	var _OpenCloseButton = __webpack_require__(308);
	
	var _OpenCloseButton2 = _interopRequireDefault(_OpenCloseButton);
	
	var _detailViewerModule = __webpack_require__(848);
	
	var _detailViewerModule2 = _interopRequireDefault(_detailViewerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DetailViewer = function (_Component) {
	  _inherits(DetailViewer, _Component);
	
	  function DetailViewer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DetailViewer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isPlaylistOpen: false,
	      isVideoOpen: false
	    }, _this.setPlaylistOpen = function (value) {
	      _this.setState({
	        isPlaylistOpen: value
	      });
	    }, _this.setVideoOpen = function (value) {
	      _this.setState({
	        isVideoOpen: value
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  DetailViewer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.detail.title !== this.props.detail.title) {
	      this.reset();
	    }
	  };
	
	  DetailViewer.prototype.reset = function reset() {
	    this.setState({
	      isPlaylistOpen: false,
	      isVideoOpen: false
	    });
	  };
	
	  DetailViewer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _detailViewerModule2.default.container + ' blur-in-up transition-' + status },
	      _react2.default.createElement(
	        'div',
	        { className: _detailViewerModule2.default.buttonWrap },
	        _react2.default.createElement(_OpenCloseButton2.default, {
	          buttonStyle: 'close',
	          isActive: this.state.isPlaylistOpen,
	          onClick: this.props.closeActiveDetail
	        })
	      ),
	      this.props.detail.detail_type === 'press_and_hold' ? _react2.default.createElement(_ChapterSectionPressPlayPixi2.default, _extends({}, this.props.parentProps, this.state, {
	        isChapter: false,
	        sectionData: { playlists: [_extends({}, this.props.detail)] },
	        setPlaylistOpen: this.setPlaylistOpen
	      })) : _react2.default.createElement(_ChapterSectionVideo2.default, {
	        sectionData: _extends({}, this.props.detail, {
	          image: {
	            sizes: {
	              large: this.props.detail.poster.sizes.medium_large
	            }
	          }
	        }),
	        setVideoOpen: this.setVideoOpen,
	        isVideoOpen: this.state.isVideoOpen
	      })
	    );
	  };
	
	  return DetailViewer;
	}(_react.Component);
	
	exports.default = DetailViewer;
	module.exports = exports['default'];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DiscussionPoint = __webpack_require__(542);
	
	var _DiscussionPoint2 = _interopRequireDefault(_DiscussionPoint);
	
	var _Quote = __webpack_require__(544);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _AudioClip = __webpack_require__(541);
	
	var _AudioClip2 = _interopRequireDefault(_AudioClip);
	
	var _SlideshowTeaser = __webpack_require__(545);
	
	var _SlideshowTeaser2 = _interopRequireDefault(_SlideshowTeaser);
	
	var _VideoTeaser = __webpack_require__(546);
	
	var _VideoTeaser2 = _interopRequireDefault(_VideoTeaser);
	
	var _PressPlayTeaser = __webpack_require__(543);
	
	var _PressPlayTeaser2 = _interopRequireDefault(_PressPlayTeaser);
	
	var _teaserModule = __webpack_require__(849);
	
	var _teaserModule2 = _interopRequireDefault(_teaserModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setTeaserByType = function setTeaserByType(props) {
	  switch (props.detail_type) {
	    case 'discussion_point':
	      return _react2.default.createElement(_DiscussionPoint2.default, props);
	    case 'quote':
	      return _react2.default.createElement(_Quote2.default, props);
	    case 'slideshow':
	      return _react2.default.createElement(_SlideshowTeaser2.default, props);
	    case 'audio':
	      return _react2.default.createElement(_AudioClip2.default, props);
	    case 'video':
	      return _react2.default.createElement(_PressPlayTeaser2.default, _extends({}, props, {
	        label: props.body,
	        imageSrc: props.poster.sizes.medium_large,
	        alt: props.poster.alt
	      }));
	    case 'press_and_hold':
	      return _react2.default.createElement(_PressPlayTeaser2.default, _extends({}, props, {
	        imageSrc: props.image.sizes.large,
	        alt: props.image.alt
	      }));
	    default:
	      return null;
	  }
	};
	
	var Teaser = function Teaser(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _teaserModule2.default.container },
	    setTeaserByType(props)
	  );
	};
	
	exports.default = Teaser;
	module.exports = exports['default'];

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AudioPlayer = __webpack_require__(511);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _audioClipModule = __webpack_require__(850);
	
	var _audioClipModule2 = _interopRequireDefault(_audioClipModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioClip = function AudioClip(_ref) {
	  var title = _ref.title,
	      audio_file = _ref.audio_file,
	      body = _ref.body;
	  return _react2.default.createElement(
	    'div',
	    { className: _audioClipModule2.default.container },
	    title && _react2.default.createElement('h4', {
	      className: _audioClipModule2.default.title,
	      dangerouslySetInnerHTML: { __html: title }
	    }),
	    body && _react2.default.createElement('div', { className: _audioClipModule2.default.body, dangerouslySetInnerHTML: { __html: body } }),
	    audio_file && audio_file.url && _react2.default.createElement(_AudioPlayer2.default, { source: audio_file.url, title: null })
	  );
	};
	
	exports.default = AudioClip;
	module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Discussion_Red = __webpack_require__(528);
	
	var _Discussion_Red2 = _interopRequireDefault(_Discussion_Red);
	
	var _discussionPointModule = __webpack_require__(851);
	
	var _discussionPointModule2 = _interopRequireDefault(_discussionPointModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DiscussionPoint = function DiscussionPoint(_ref) {
	  var body = _ref.body,
	      detail_type = _ref.detail_type,
	      index = _ref.index;
	  return _react2.default.createElement(
	    'div',
	    { className: _discussionPointModule2.default.discussionPoint },
	    _react2.default.createElement(
	      'h4',
	      { className: _discussionPointModule2.default.discussionPointTitle },
	      'Discussion Point',
	      _react2.default.createElement(
	        'span',
	        { className: _discussionPointModule2.default.dicussionPointIcon },
	        _react2.default.createElement(_Discussion_Red2.default, null)
	      )
	    ),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: body } })
	  );
	};
	
	exports.default = DiscussionPoint;
	module.exports = exports['default'];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OpenCloseButton = __webpack_require__(308);
	
	var _OpenCloseButton2 = _interopRequireDefault(_OpenCloseButton);
	
	var _pressPlayTeaserModule = __webpack_require__(852);
	
	var _pressPlayTeaserModule2 = _interopRequireDefault(_pressPlayTeaserModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PressPlayTeaser = function PressPlayTeaser(props) {
	  var title = props.title,
	      label = props.label,
	      setActiveDetail = props.setActiveDetail,
	      isActive = props.isActive,
	      imageSrc = props.imageSrc,
	      alt = props.alt;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _pressPlayTeaserModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _pressPlayTeaserModule2.default.imageContainer },
	      _react2.default.createElement(
	        'div',
	        { className: _pressPlayTeaserModule2.default.imageContainerInner },
	        _react2.default.createElement('img', { className: _pressPlayTeaserModule2.default.image, src: imageSrc, alt: alt }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: !isActive ? _pressPlayTeaserModule2.default.buttonWrap : _pressPlayTeaserModule2.default.buttonWrapClosed
	          },
	          _react2.default.createElement(_OpenCloseButton2.default, {
	            clicked: isActive,
	            onClick: setActiveDetail.bind(null, props)
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _pressPlayTeaserModule2.default.contentContainer },
	      title.length && _react2.default.createElement('h4', {
	        className: _pressPlayTeaserModule2.default.title,
	        dangerouslySetInnerHTML: { __html: title }
	      }),
	      label && _react2.default.createElement('p', {
	        className: _pressPlayTeaserModule2.default.body,
	        dangerouslySetInnerHTML: { __html: label }
	      })
	    )
	  );
	};
	
	exports.default = PressPlayTeaser;
	module.exports = exports['default'];

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QuotationMark_Red = __webpack_require__(163);
	
	var _QuotationMark_Red2 = _interopRequireDefault(_QuotationMark_Red);
	
	var _quoteModule = __webpack_require__(853);
	
	var _quoteModule2 = _interopRequireDefault(_quoteModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quote = function Quote(_ref) {
	  var quote_text = _ref.quote_text,
	      caption = _ref.caption;
	  return _react2.default.createElement(
	    'div',
	    { className: _quoteModule2.default.quote },
	    _react2.default.createElement(
	      'div',
	      { className: _quoteModule2.default.quoteIcon },
	      _react2.default.createElement(_QuotationMark_Red2.default, null)
	    ),
	    _react2.default.createElement('div', {
	      className: _quoteModule2.default.quoteText,
	      dangerouslySetInnerHTML: {
	        __html: quote_text
	      }
	    }),
	    _react2.default.createElement('div', {
	      className: _quoteModule2.default.quoteCaption,
	      dangerouslySetInnerHTML: { __html: caption }
	    })
	  );
	};
	
	exports.default = Quote;
	module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OpenCloseButton = __webpack_require__(308);
	
	var _OpenCloseButton2 = _interopRequireDefault(_OpenCloseButton);
	
	var _slideshowTeaserModule = __webpack_require__(854);
	
	var _slideshowTeaserModule2 = _interopRequireDefault(_slideshowTeaserModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideshowTeaser = function SlideshowTeaser(props) {
	  var title = props.title,
	      images = props.images,
	      body = props.body,
	      setActiveDetail = props.setActiveDetail,
	      isActive = props.isActive;
	  var _images$ = images[0],
	      url = _images$.url,
	      alt = _images$.alt;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _slideshowTeaserModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _slideshowTeaserModule2.default.imageContainer },
	      _react2.default.createElement(
	        'div',
	        { className: _slideshowTeaserModule2.default.imageContainerInner },
	        _react2.default.createElement('img', { className: _slideshowTeaserModule2.default.image, src: images[0].sizes.large, alt: alt }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: !isActive ? _slideshowTeaserModule2.default.buttonWrap : _slideshowTeaserModule2.default.buttonWrapClosed
	          },
	          _react2.default.createElement(_OpenCloseButton2.default, {
	            clicked: isActive,
	            onClick: setActiveDetail.bind(null, props)
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _slideshowTeaserModule2.default.contentContainer },
	      title.length && _react2.default.createElement('h4', {
	        className: _slideshowTeaserModule2.default.title,
	        dangerouslySetInnerHTML: { __html: title }
	      }),
	      body.legnth && _react2.default.createElement('p', {
	        className: _slideshowTeaserModule2.default.body,
	        dangerouslySetInnerHTML: { __html: body }
	      })
	    )
	  );
	};
	
	exports.default = SlideshowTeaser;
	module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OpenCloseButton = __webpack_require__(308);
	
	var _OpenCloseButton2 = _interopRequireDefault(_OpenCloseButton);
	
	var _videoTeaserModule = __webpack_require__(855);
	
	var _videoTeaserModule2 = _interopRequireDefault(_videoTeaserModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoTeaser = function VideoTeaser(props) {
	  // const { url, alt } = images[0];
	  // console.log(props);
	  return _react2.default.createElement('div', { className: _videoTeaserModule2.default.container });
	};
	
	exports.default = VideoTeaser;
	module.exports = exports['default'];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(181);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _ArrowButton = __webpack_require__(49);
	
	var _ArrowButton2 = _interopRequireDefault(_ArrowButton);
	
	var _SlideshowModule = __webpack_require__(856);
	
	var _SlideshowModule2 = _interopRequireDefault(_SlideshowModule);
	
	var _gsap = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slideshow = function (_Component) {
	  _inherits(Slideshow, _Component);
	
	  function Slideshow() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Slideshow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      currentImage: null
	    }, _this.slickOptions = {
	      dots: true,
	      infinite: false,
	      draggable: true,
	      speed: 1500,
	      cssEase: 'cubic-bezier(.9, 0, .3, 1)',
	      nextArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'right' }),
	      prevArrow: _react2.default.createElement(_ArrowButton2.default, { direction: 'left' }),
	      beforeChange: function beforeChange(oldIndex, newIndex) {
	        _this.setState({ currentImage: _this.props.images[newIndex] });
	      }
	    }, _this.createRef = function (el) {
	      return _this.slideshowref = el;
	    }, _this.animateOut = function () {
	      _gsap.TweenLite.to(_this.slideshowref, 0.65, {
	        x: '100%',
	        ease: Expo.easeInOut,
	        onComplete: _this.props.handleTourStopDetailClosed
	      });
	    }, _this.animateIn = function () {
	      _gsap.TweenLite.set(_this.slideshowref, { x: '100%', force3D: true });
	      _gsap.TweenLite.to(_this.slideshowref, 1, { x: '0%', ease: Expo.easeInOut });
	    }, _this.getSliderOrImage = function (images) {
	      if (images.length <= 1) {
	        return _react2.default.createElement('img', {
	          className: _SlideshowModule2.default.image,
	          src: images[0].sizes.large,
	          alt: images[0].alt
	        });
	      } else {
	        return _react2.default.createElement(
	          _reactSlick2.default,
	          _extends({ className: 'tour-slick' }, _this.slickOptions),
	          images.map(function (image) {
	            return _react2.default.createElement('img', {
	              key: image.sizes.large,
	              src: image.sizes.large,
	              alt: image.caption
	            });
	          })
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Slideshow.prototype.componentDidMount = function componentDidMount() {
	    // console.log(this.props.images);
	    this.setState({ currentImage: this.props.images[0] });
	    this.animateIn();
	  };
	
	  Slideshow.prototype.render = function render() {
	    var _props = this.props,
	        images = _props.images,
	        body = _props.body,
	        title = _props.title,
	        isOpen = _props.isOpen,
	        handleTourStopDetailClosed = _props.handleTourStopDetailClosed;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: this.createRef,
	        className: _SlideshowModule2.default.container + ' slide-in-' + status
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          className: isOpen ? _SlideshowModule2.default.backBarOpen : _SlideshowModule2.default.backBarClosed,
	          onClick: this.animateOut
	        },
	        _react2.default.createElement(
	          'span',
	          { className: _SlideshowModule2.default.backTitle },
	          _react2.default.createElement(
	            'svg',
	            {
	              width: '27',
	              height: '24',
	              viewBox: '0 0 27 24',
	              className: _SlideshowModule2.default.arrow
	            },
	            _react2.default.createElement(
	              'title',
	              null,
	              'Left Arrow'
	            ),
	            _react2.default.createElement('polygon', { points: '3.891 10.946 26.267 10.946 26.267 12.592 3.917 12.592 13.92 22.171 12.776 23.267 .755 11.756 12.776 .245 13.92 1.341' })
	          ),
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _SlideshowModule2.default.header },
	        _react2.default.createElement(
	          'div',
	          { className: _SlideshowModule2.default.headerBg },
	          this.getSliderOrImage(images)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _SlideshowModule2.default.teaserContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _SlideshowModule2.default.tourStopBodyContainer },
	          title && _react2.default.createElement('h3', { dangerouslySetInnerHTML: { __html: title } }),
	          images.length <= 1 && body ? _react2.default.createElement('div', {
	            className: _SlideshowModule2.default.tourStopBody,
	            dangerouslySetInnerHTML: { __html: body }
	          }) : _react2.default.createElement(
	            'div',
	            { className: _SlideshowModule2.default.tourStopBody },
	            this.state.currentImage && _react2.default.createElement('p', {
	              dangerouslySetInnerHTML: {
	                __html: this.state.currentImage.caption
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Slideshow;
	}(_react.Component);
	
	exports.default = Slideshow;
	module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _googlemapsRichMarkerWeb = __webpack_require__(482);
	
	var _googlemapsRichMarkerWeb2 = _interopRequireDefault(_googlemapsRichMarkerWeb);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(69);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _mapModule = __webpack_require__(857);
	
	var _mapModule2 = _interopRequireDefault(_mapModule);
	
	var _LocationOnly = __webpack_require__(530);
	
	var _LocationOnly2 = _interopRequireDefault(_LocationOnly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStyles = __webpack_require__(935);
	
	var MAX_ZOOM = 16;
	var MIN_ZOOM = 16;
	
	var LATITUDE = 40.716947;
	var LONGITUDE = -73.983198;
	
	var NE_BOUNDS_LAT = 40.724476648050285; //north, y
	var NE_BOUNDS_LNG = -73.96517355541994; //east, x
	var SW_BOUNDS_LAT = 40.709416500218396; //south, y
	var SW_BOUNDS_LNG = -74.0012224445801; //west, x
	
	var LOCATION = 'location';
	var TAP = 'tap';
	
	//create promise for getCurrentPosition
	var getPositionPromise = function getPositionPromise() {
	  if (navigator.geolocation) {
	    return new Promise(function (resolve, reject) {
	      return navigator.geolocation.getCurrentPosition(resolve, reject, {
	        enableHighAccuracy: true
	      });
	    });
	  } else {
	    console.log("Browser doesn't support Geolocation");
	    return new Promise(function (resolve) {
	      return resolve();
	    }, reject);
	  }
	};
	
	var FocusButton = function FocusButton(_ref) {
	  var stopSelectionMethod = _ref.stopSelectionMethod,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: _mapModule2.default.focusButton + ' ' + (stopSelectionMethod === LOCATION ? _mapModule2.default.focusActive : ''),
	      onClick: onClick
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _mapModule2.default.focusIconContainer },
	      _react2.default.createElement(_LocationOnly2.default, null)
	    )
	  );
	};
	
	var GoogleMap = function (_Component) {
	  _inherits(GoogleMap, _Component);
	
	  function GoogleMap() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GoogleMap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      hasRequestedLocation: false,
	      doesMapExist: false
	    }, _this.mapBounds = {
	      north: NE_BOUNDS_LAT,
	      east: NE_BOUNDS_LNG,
	      south: SW_BOUNDS_LAT,
	      west: SW_BOUNDS_LNG
	    }, _this.map = null, _this.mapRef = null, _this.gmBounds = null, _this.LESBounds = null, _this.lastValidCenter = null, _this.blueDot = null, _this.currLocation = null, _this.initalLocation = null, _this.isLocationInLowerEastSide = function (lat, lng) {
	      return lat > _this.mapBounds.south && lat < _this.mapBounds.north && lng > _this.mapBounds.west && lng < _this.mapBounds.east;
	    }, _this.getInitialLocation = function () {
	      //check for current position
	      getPositionPromise().then(function (position) {
	        var Maps = _this.props.Maps;
	
	
	        var initPosition = new Maps.LatLng(position.coords.latitude, position.coords.longitude);
	
	        if (_this.isLocationInLowerEastSide(initPosition.lat(), initPosition.lng())) {
	          // if (this.map.getBounds().contains(initPosition)) {
	          _this.createBlueDot(initPosition, true);
	        } else {
	          console.log('out of bounds');
	          _this.props.setDefaultActivePin();
	        }
	      }).catch(function (err) {
	        throw err;
	      });
	    }, _this.setCurrentLocation = function (lat, lng) {
	      _this.currLocation = {
	        lat: lat,
	        lng: lng
	      };
	    }, _this.createBlueDot = function (position) {
	      var startUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (_this.blueDot) return;
	      var _this$props = _this.props,
	          Maps = _this$props.Maps,
	          getDotLocationForMap = _this$props.getDotLocationForMap;
	
	
	      _this.setCurrentLocation(position.lat(), position.lng());
	
	      _this.blueDot = new _googlemapsRichMarkerWeb2.default.RichMarker({
	        position: new Maps.LatLng(_this.currLocation.lat, _this.currLocation.lng),
	        content: '',
	        shadow: 'none',
	        map: _this.map
	      });
	
	      if (!_this.blueDot.content.length) {
	        _this.blueDot.setContent(_this.getDotContent());
	      }
	
	      getDotLocationForMap(_this.currLocation);
	
	      if (startUpdate) {
	        _this.updateBlueDot();
	      }
	    }, _this.updateBlueDot = function () {
	      // Try HTML5 geolocation.
	      if (navigator.geolocation) {
	        navigator.geolocation.watchPosition(function (position) {
	          _this.setLocation(position);
	        }, function (err) {
	          console.log(err);
	          throw err;
	        }, { enableHighAccuracy: true });
	      } else {
	        console.log("Browser doesn't support Geolocation");
	      }
	    }, _this.getDotContent = function (currLocation) {
	      var content = "<div class='dot'><div class='shadow'></div><div class='innerCircle'></div><div class='outerCircle'></div></div>";
	      return content;
	    }, _this.setLocation = function (position) {
	      var _this$props2 = _this.props,
	          Maps = _this$props2.Maps,
	          getDotLocationForMap = _this$props2.getDotLocationForMap;
	
	
	      _this.setCurrentLocation(position.coords.latitude, position.coords.longitude);
	
	      if (!_this.blueDot) {
	        _this.createBlueDot(_this.currLocation);
	      } else {
	        _this.blueDot.setPosition(new Maps.LatLng(_this.currLocation.lat, _this.currLocation.lng));
	      }
	
	      if (_this.props.stopSelectionMethod === LOCATION) {
	        getDotLocationForMap(_this.currLocation);
	        _this.map.panTo(_this.blueDot.getPosition());
	      }
	    }, _this.panToOffsetCenter = function (latlng, _ref2) {
	      var x = _ref2.x,
	          y = _ref2.y;
	      var shouldPan = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	      var Maps = _this.props.Maps;
	
	      var scale = Math.pow(2, _this.map.getZoom());
	
	      var worldCoordinate = _this.map.getProjection().fromLatLngToPoint(latlng);
	
	      var pixelOffset = new Maps.Point(parseFloat(x) / scale || 0, parseFloat(y) / scale || 0);
	
	      var worldCoordinateNewCenter = new Maps.Point(worldCoordinate.x - pixelOffset.x, worldCoordinate.y + pixelOffset.y);
	
	      var newCenter = _this.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
	
	      if (shouldPan) {
	        _this.map.panTo(newCenter);
	      } else {
	        _this.map.setCenter(newCenter);
	      }
	    }, _this.setLastValidCenter = function () {
	      if (_this.gmBounds.contains(_this.map.getCenter())) {
	        // console.log(this.gmBounds.contains(this.map.getCenter()));
	        _this.lastValidCenter = _this.map.getCenter();
	        return;
	      }
	    }, _this.remainInBounds = function () {
	      // let zoom = this.map.getZoom();
	      // let projection = this.map.getProjection();
	      // let NEPx = projection.fromLatLngToPixel(this.gmBounds.getNorthEast(), zoom);
	      // let SWPx = projection.fromLatLngToPixel(this.gmBounds.getSouthWest(), zoom);
	      // console.log(NEPx, SWPx);
	      // if (!this.gmBounds.contains(this.map.getCenter())) {
	      //   this.panToOffsetCenter(
	      //     this.lastValidCenter,
	      //     this.getPixelOffsetToOffsetCenter(this.mapRef)
	      //   );
	      // }
	    }, _this.getPixelOffsetToOffsetCenter = function (mapRef) {
	      var isMobileDevice = _this.props.isMobileDevice;
	
	      var riverWidth = !isMobileDevice ? mapRef.getBoundingClientRect().width * 0.3 : 0;
	      var paddingRight = !isMobileDevice ? 25 : 0;
	      var paddingTop = 115;
	      var paddingBottom = !isMobileDevice ? 40 : 165;
	
	      var pixelCenter = {
	        x: mapRef.getBoundingClientRect().width * 0.5,
	        y: mapRef.getBoundingClientRect().height * 0.5
	      };
	
	      var offsetCenter = {
	        x: (mapRef.getBoundingClientRect().width - (riverWidth + paddingRight)) * 0.5,
	        y: mapRef.getBoundingClientRect().height * 0.5
	      };
	
	      return {
	        x: offsetCenter.x - pixelCenter.x,
	        y: offsetCenter.y - pixelCenter.y
	      };
	    }, _this.drawDebugRect = function () {
	      //Add debug rectangle around markers
	      var debugRectangle = new google.maps.Rectangle({
	        strokeColor: '#FF0000',
	        strokeOpacity: 0.8,
	        strokeWeight: 2,
	        fillColor: '#FF0000',
	        fillOpacity: 0.35,
	        map: _this.map,
	        bounds: _this.gmBounds
	      });
	    }, _this.loadMap = function (mapRef) {
	      if (_this.props && _this.props.Maps) {
	        var Maps = _this.props.Maps;
	
	        //const maps = google.maps;
	
	        var node = _reactDom2.default.findDOMNode(mapRef);
	        var center = new Maps.LatLng(LATITUDE, LONGITUDE);
	
	        //set bounds
	        _this.gmBounds = new Maps.LatLngBounds();
	
	        //extend bounds to fit markers
	        _this.props.markers.map(function (marker) {
	          var markerPosition = new Maps.LatLng(marker.map_data.lat, marker.map_data.lng);
	
	          if (
	          /*set this check to true to test on site*/
	          _this.isLocationInLowerEastSide(markerPosition.lat(), markerPosition.lng())) {
	            _this.gmBounds.extend(markerPosition);
	          }
	        });
	
	        var mapConfig = {
	          center: _this.gmBounds.getCenter(),
	          zoom: MIN_ZOOM,
	          maxZoom: MAX_ZOOM,
	          minZoom: MIN_ZOOM,
	          styles: [].concat(mapStyles, [{
	            featureType: 'poi',
	            stylers: [{ visibility: 'off' }]
	          }]),
	          mapTypeControl: false,
	          scaleControl: false,
	          streetViewControl: false,
	          rotateControl: false,
	          fullscreenControl: false,
	          zoomControl: false,
	          disableDefaultUI: true,
	          gestureHandling: 'greedy',
	          zoomControlOptions: {
	            position: Maps.ControlPosition.LEFT_BOTTOM
	          }
	        };
	
	        _this.map = new Maps.Map(node, mapConfig);
	
	        //set the last valid center
	        _this.lastValidCenter = _this.map.getCenter();
	
	        // this.drawDebugRect();
	
	        // const marker = new google.maps.Marker({
	        //   position: this.map.getCenter(),
	        //   map: this.map,
	        // });
	
	        // const neMarker = new google.maps.Marker({
	        //   position: this.gmBounds.getNorthEast(),
	        //   map: this.map,
	        // });
	
	        // const swMarker = new google.maps.Marker({
	        //   position: this.gmBounds.getSouthWest(),
	        //   map: this.map,
	        // });
	
	        Maps.event.addListenerOnce(_this.map, 'idle', function () {
	          _this.panToOffsetCenter(_this.map.getCenter(), _this.getPixelOffsetToOffsetCenter(_this.mapRef));
	        });
	
	        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined) {
	          Maps.event.addDomListener(window, 'resize', function () {
	            _this.panToOffsetCenter(_this.lastValidCenter, _this.getPixelOffsetToOffsetCenter(_this.mapRef), false);
	          });
	        }
	
	        //event logic
	        Maps.event.addListener(_this.map, 'dragstart', function () {
	          _this.props.handleSetSelectionMethod(TAP);
	        });
	
	        Maps.event.addListener(_this.map, 'drag', function () {
	          _this.setLastValidCenter();
	        });
	
	        // Maps.event.addListener(this.map, 'dragend', () => {
	        //   this.remainInBounds();
	        // });
	
	        // Maps.event.addListener(this.map, 'click', event => {
	        //   console.log('map', event);
	        //   this.blueDot.setPosition(event.latLng);
	        //   this.setCurrentLocation(event.latLng.lat(), event.latLng.lng());
	        //   this.props.getDotLocationForMap(this.currLocation);
	        // });
	
	        _this.setState({ doesMapExist: true });
	      }
	    }, _this.handleFollowTheDot = function () {
	      var getDotLocationForMap = _this.props.getDotLocationForMap;
	
	      if (_this.blueDot && _this.map) {
	        _this.props.handleSetSelectionMethod(LOCATION);
	        _this.map.panTo(_this.blueDot.getPosition());
	        getDotLocationForMap(_this.currLocation);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GoogleMap.prototype.componentWillMount = function componentWillMount() {
	    if (!this.props.shouldRequestLocation && this.props.hasRequestedLocation) {
	      this.props.setDefaultActivePin();
	    }
	  };
	
	  GoogleMap.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.isMobileDevice) {
	      this.props.setDefaultActivePin();
	    }
	    this.loadMap(this.mapRef);
	  };
	
	  GoogleMap.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (this.props.Maps && this.props.shouldRequestLocation !== prevProps.shouldRequestLocation) {
	      if (this.props.shouldRequestLocation && !this.state.hasRequestedLocation) {
	        console.log('should request location');
	        this.getInitialLocation();
	        this.setState({ hasRequestedLocation: true });
	      } else {
	        console.log('should not request location');
	        this.setState({ hasRequestedLocation: true });
	      }
	    }
	  };
	
	  GoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined) {
	      this.props.Maps.event.clearListeners(this.map, 'click');
	      this.props.Maps.event.clearListeners(this.map, 'dragend');
	      this.props.Maps.event.clearListeners(this.map, 'dragstart');
	      this.props.Maps.event.clearListeners(this.map, 'drag');
	      this.props.Maps.event.clearListeners(window, 'resize');
	    }
	  };
	
	  GoogleMap.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        Maps = _props.Maps,
	        shouldRequestLocation = _props.shouldRequestLocation;
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { ref: function ref(el) {
	            return _this2.mapRef = el;
	          }, className: _mapModule2.default.mapContainer },
	        children.length && this.state.doesMapExist && Maps && _react2.default.Children.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            Maps: Maps,
	            map: _this2.map
	          });
	        })
	      ),
	      shouldRequestLocation && this.blueDot && _react2.default.createElement(FocusButton, {
	        onClick: this.handleFollowTheDot,
	        stopSelectionMethod: this.props.stopSelectionMethod
	      })
	    );
	  };
	
	  return GoogleMap;
	}(_react.Component);
	
	exports.default = GoogleMap;
	module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GoogleApiComponent = __webpack_require__(552);
	
	var _GoogleApiComponent2 = _interopRequireDefault(_GoogleApiComponent);
	
	var _GoogleMap = __webpack_require__(548);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _Pin = __webpack_require__(550);
	
	var _Pin2 = _interopRequireDefault(_Pin);
	
	var _constants = __webpack_require__(410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//distance formula from
	//https://www.movable-type.co.uk/scripts/latlong.html
	var EARTHS_RADIUS = 6371e3; // meters
	var MAX_DIST = 70.0; //meters
	
	var rad = function rad(x) {
	  return x * Math.PI / 180.0;
	};
	
	var toFeet = function toFeet(dm) {
	  return dm / 0.3048;
	};
	
	var Map = function (_Component) {
	  _inherits(Map, _Component);
	
	  function Map() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Map);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      dotLocation: {}
	    }, _this.isPinActive = function (id) {
	      return _this.props.activeStopId === id;
	    }, _this.isPinVisited = function (id) {
	      return _this.props.visitedStopIds.includes(id);
	    }, _this.setDefaultActivePin = function () {
	      var hss = _this.props.markers.filter(function (marker) {
	        return marker.title.match(/Henry Street Settlement/g);
	      })[0];
	      _this.props.handleMarkerClicked(null, hss.id);
	    }, _this.setDotLocation = function (dotLocation) {
	      _this.setState({ dotLocation: dotLocation }, _this.findClosestPin(dotLocation));
	    }, _this.findClosestPin = function (dotLocation) {
	      var maxDist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_DIST;
	      var markers = _this.props.markers;
	
	      var lng1 = rad(dotLocation.lng);
	      var lat1 = rad(dotLocation.lat);
	
	      var minDist = maxDist;
	      var closestStopId = -1;
	
	      markers.map(function (marker, index) {
	        var _marker$map_data = marker.map_data,
	            lat = _marker$map_data.lat,
	            lng = _marker$map_data.lng;
	
	
	        var lng2 = rad(lng);
	        var lat2 = rad(lat);
	
	        var x = (lng2 - lng1) * Math.cos((lat1 + lat2) / 2);
	        var y = lat2 - lat1;
	        var dist = Math.sqrt(x * x + y * y) * EARTHS_RADIUS;
	
	        minDist = Math.min(minDist, dist);
	        if (minDist === dist) {
	          closestStopId = parseInt(marker.id);
	        }
	      });
	
	      if (parseInt(_this.props.activeStopId) !== closestStopId && closestStopId !== -1) {
	        console.log('found it', parseInt(_this.props.activeStopId), closestStopId);
	        _this.props.handleOpenTourStopByDistance(closestStopId);
	      } else if (!_this.props.firstStopLoaded) {
	        console.log('keep looking');
	        _this.findClosestPin(dotLocation, minDist += 10.0);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Map.prototype.render = function render() {
	    var _this2 = this;
	
	    var style = {
	      width: '100vw',
	      height: '100vh'
	    };
	    var _props = this.props,
	        loaded = _props.loaded,
	        markers = _props.markers,
	        Maps = _props.Maps,
	        handleMarkerClicked = _props.handleMarkerClicked,
	        activeStopId = _props.activeStopId,
	        visitedStopIds = _props.visitedStopIds,
	        hasBeenOnboarded = _props.hasBeenOnboarded,
	        isMobileDevice = _props.isMobileDevice,
	        isTransitioningBetweenStops = _props.isTransitioningBetweenStops,
	        stopSelectionMethod = _props.stopSelectionMethod;
	
	
	    if (!loaded) {
	      return _react2.default.createElement(
	        'div',
	        { style: style },
	        'Loading...'
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { id: 'map-div', style: style },
	      _react2.default.createElement(
	        _GoogleMap2.default,
	        {
	          Maps: Maps,
	          markers: markers,
	          isMobileDevice: isMobileDevice,
	          hasBeenOnboarded: hasBeenOnboarded,
	          shouldRequestLocation: hasBeenOnboarded && isMobileDevice,
	          setDefaultActivePin: this.setDefaultActivePin,
	          getDotLocationForMap: this.setDotLocation,
	          stopSelectionMethod: stopSelectionMethod,
	          handleSetSelectionMethod: this.props.handleSetSelectionMethod
	        },
	        hasBeenOnboarded && markers.map(function (marker, index) {
	          return _react2.default.createElement(_Pin2.default, _extends({
	            id: marker.id,
	            title: marker.title,
	            isActive: _this2.isPinActive(marker.id),
	            isVisited: _this2.isPinVisited(marker.id),
	            handleMarkerClicked: handleMarkerClicked,
	            isTransitioningBetweenStops: isTransitioningBetweenStops,
	            key: marker.map_data.address,
	            type: marker.tour_stop_type
	          }, marker.map_data, {
	            hasBeenOnboarded: true,
	            index: index
	          }));
	        })
	      )
	    );
	  };
	
	  return Map;
	}(_react.Component);
	
	exports.default = (0, _GoogleApiComponent2.default)({
	  apiKey: ("AIzaSyB89K-mTGYcEcpseeDosNmR--C1hMsr4f4")
	})(Map);
	module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _googlemapsRichMarkerWeb = __webpack_require__(482);
	
	var _googlemapsRichMarkerWeb2 = _interopRequireDefault(_googlemapsRichMarkerWeb);
	
	var _HSS_Pin = __webpack_require__(529);
	
	var _HSS_Pin2 = _interopRequireDefault(_HSS_Pin);
	
	var _gsap = __webpack_require__(11);
	
	var _Arts = __webpack_require__(531);
	
	var _Arts2 = _interopRequireDefault(_Arts);
	
	var _Bridge = __webpack_require__(532);
	
	var _Bridge2 = _interopRequireDefault(_Bridge);
	
	var _Building = __webpack_require__(533);
	
	var _Building2 = _interopRequireDefault(_Building);
	
	var _MarketFair = __webpack_require__(534);
	
	var _MarketFair2 = _interopRequireDefault(_MarketFair);
	
	var _Park = __webpack_require__(535);
	
	var _Park2 = _interopRequireDefault(_Park);
	
	var _ReligiousStructure = __webpack_require__(536);
	
	var _ReligiousStructure2 = _interopRequireDefault(_ReligiousStructure);
	
	var _pinModule = __webpack_require__(858);
	
	var _pinModule2 = _interopRequireDefault(_pinModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pin = function (_Component) {
	  _inherits(Pin, _Component);
	
	  function Pin() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pin);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.setIsActive = function (isActive) {
	      if (!_this.pinContentDOMNode) return;
	      var z = isActive ? 2 : 1;
	
	      //wait to set z-index until all transitions are mostly over
	      setTimeout(function () {
	        _this.pin.setZIndex(z);
	      }, 480);
	
	      if (isActive) {
	        _this.pinContentDOMNode.classList.remove(_pinModule2.default.UNVISITED);
	        _this.pinContentDOMNode.classList.add(_pinModule2.default.OPEN);
	      } else {
	        if (_this.pinContentDOMNode.classList.contains(_pinModule2.default.OPEN)) {
	          _this.pinContentDOMNode.classList.add(_pinModule2.default.VISITED);
	        }
	        _this.pinContentDOMNode.classList.remove(_pinModule2.default.OPEN);
	      }
	    }, _this.initMarker = function () {
	      var _this$props = _this.props,
	          Maps = _this$props.Maps,
	          map = _this$props.map;
	
	      if (Maps && map) {
	        _this.pinContentId = 'pin-' + _this.props.index;
	        _this.pinContent = '<div id="' + _this.pinContentId + '" class="' + _pinModule2.default.UNVISITED + ' ' + (_this.props.type === 'Default' ? _pinModule2.default.SMALL : '') + '" style="height: 49px; width: 34px">\n        <svg viewBox="0 0 34 49" xmlns="http://www.w3.org/2000/svg" class="' + _pinModule2.default.pin + '">\n          <path d="M17 0C7.601 0 0 7.668 0 17.15 0 30.013 17 49 17 49s17-18.988 17-31.85C34 7.669 26.399 0 17 0z" />\n        </svg>\n        <div class="' + _pinModule2.default.contentContainer + '">\n          <div class="' + _pinModule2.default.iconContainer + '">\n            ' + (_this.props.type !== 'Default' ? _this.getIconByType(_this.props.type) : '') + '\n          </div>\n          <div class="' + _pinModule2.default.titleContainer + '">\n            <h2 class="' + _pinModule2.default.title + '">' + _this.props.title + '</h2>\n          </div>\n        </div>\n      </div>';
	
	        _this.pin = new _googlemapsRichMarkerWeb2.default.RichMarker({
	          anchor: _googlemapsRichMarkerWeb2.default.RichMarkerPosition.BOTTOM,
	          position: new Maps.LatLng(_this.props.lat, _this.props.lng),
	          content: _this.pinContent,
	          shadow: false,
	          map: map
	        });
	
	        // this.pin.setMap(map);
	
	        _this.pin.addListener('ready', function () {
	          if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
	            _this.pinContentDOMNode = document.getElementById(_this.pinContentId);
	
	            _gsap.TweenLite.set(_this.pinContentDOMNode, { autoAlpha: 0, y: -100 });
	            _this.tween = _gsap.TweenLite.to(_this.pinContentDOMNode, 1.23, {
	              autoAlpha: 1,
	              y: 0,
	              ease: Expo.easeInOut,
	              delay: 0.05 * _this.props.index,
	              force3D: true,
	              onComplete: function onComplete() {
	                _this.setIsActive(_this.props.isActive);
	              }
	            });
	          }
	        });
	
	        _this.pin.addListener('click', function (event) {
	          _this.props.handleMarkerClicked(event, _this.props.id);
	        });
	      }
	    }, _this.getIconByType = function (type) {
	      switch (type) {
	        case 'Arts':
	          return _Arts2.default;
	        case 'Bridge':
	          return _Bridge2.default;
	        case 'Building':
	          return _Building2.default;
	        case 'MarketFair':
	          return _MarketFair2.default;
	        case 'Park':
	          return _Park2.default;
	        case 'ReligiousStructure':
	          return _ReligiousStructure2.default;
	        default:
	          return null;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Pin.prototype.componentDidMount = function componentDidMount() {
	    this.initMarker();
	  };
	
	  Pin.prototype.componentWillMount = function componentWillMount() {
	    this.pin = null;
	  };
	
	  Pin.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.pin.setMap(null);
	    this.props.Maps.event.clearListeners(this.pin, 'click');
	    if (this.tween) this.tween.kill();
	  };
	
	  Pin.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.isActive !== this.props.isActive) {
	      this.setIsActive(this.props.isActive);
	    }
	  };
	
	  Pin.prototype.render = function render() {
	    return null;
	  };
	
	  return Pin;
	}(_react.Component);
	
	exports.default = Pin;
	module.exports = exports['default'];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (global, factory) {
	  typeof window !== 'undefined' && ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.GoogleMapsPromise = {});
	})(undefined, function (exports) {
	  'use strict';
	
	  var defaultUrlSettings = {
	    url: 'https://maps.googleapis.com/maps/api/js',
	    key: null,
	    client: null,
	    version: '3.32',
	    channel: null,
	    libraries: [],
	    language: null,
	    region: null,
	    windowCallbackName: '__google_maps_api_provider_initializator__'
	  };
	
	  var windowWithAnything = window;
	  exports.urlSettings = _extends({}, defaultUrlSettings);
	  var resolvePromise;
	  var rejectPromise;
	  var promise;
	  var loaded;
	  var scriptElement;
	  init();
	  function load() {
	    if (!loaded) {
	      loaded = true;
	      createLoader();
	    }
	    return promise;
	  }
	  function release() {
	    if (!loaded) {
	      cleanupEnvironment();
	      return Promise.resolve();
	    }
	    return promise.then(cleanupEnvironment);
	  }
	  function init() {
	    exports.urlSettings = _extends({}, defaultUrlSettings);
	    loaded = false;
	    promise = new Promise(function (resolve, reject) {
	      resolvePromise = resolve;
	      rejectPromise = reject;
	    });
	  }
	  function createLoader() {
	    if (windowWithAnything.google && windowWithAnything.google.maps) {
	      resolvePromise(windowWithAnything.google.maps);
	      return;
	    }
	    var onError = function onError() {
	      return rejectPromise(new URIError('The script ' + (scriptElement && scriptElement.src) + ' is not accessible.'));
	    };
	    scriptElement = document.createElement('script');
	    scriptElement.type = 'text/javascript';
	    scriptElement.src = createUrl();
	    scriptElement.onerror = onError;
	    windowWithAnything[exports.urlSettings.windowCallbackName] = function () {
	      return resolvePromise(windowWithAnything.google.maps);
	    };
	    document.body.appendChild(scriptElement);
	  }
	  function createUrl() {
	    var parts = ['callback=' + (exports.urlSettings.windowCallbackName || defaultUrlSettings.windowCallbackName)];
	    if (exports.urlSettings.key) {
	      parts.push('key=' + exports.urlSettings.key);
	    }
	    if (exports.urlSettings.client) {
	      parts.push('client=' + exports.urlSettings.client, 'v=' + (exports.urlSettings.version || defaultUrlSettings.version));
	    } else if (exports.urlSettings.version) {
	      parts.push('v=' + exports.urlSettings.version);
	    }
	    if (exports.urlSettings.channel) {
	      parts.push('channel=' + exports.urlSettings.channel);
	    }
	    if (exports.urlSettings.libraries.length > 0) {
	      parts.push('libraries=' + exports.urlSettings.libraries.join(','));
	    }
	    if (exports.urlSettings.language) {
	      parts.push('language=' + exports.urlSettings.language);
	    }
	    if (exports.urlSettings.region) {
	      parts.push('region=' + exports.urlSettings.region);
	    }
	    return (exports.urlSettings.url || defaultUrlSettings.url) + '?' + parts.join('&');
	  }
	  function cleanupEnvironment() {
	    init();
	    if (typeof windowWithAnything.google !== 'undefined') {
	      delete windowWithAnything.google;
	    }
	    if (typeof windowWithAnything[exports.urlSettings.windowCallbackName] !== 'undefined') {
	      delete windowWithAnything[exports.urlSettings.windowCallbackName];
	    }
	    if (scriptElement) {
	      if (scriptElement.parentElement) {
	        scriptElement.parentElement.removeChild(scriptElement);
	      }
	      scriptElement = null;
	    }
	  }
	
	  exports.load = load;
	  exports.release = release;
	  exports.defaultUrlSettings = defaultUrlSettings;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	});

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapper = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var wrapper = exports.wrapper = function wrapper(options) {
	  return function (WrappedComponent) {
	    var apiKey = options.apiKey;
	    var libraries = options.libraries || ['places'];
	
	    var Wrapper = function (_Component) {
	      _inherits(Wrapper, _Component);
	
	      function Wrapper() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Wrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          loaded: false,
	          Maps: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      // componentDidMount() {}
	
	      Wrapper.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        if (typeof window !== 'undefined') {
	          var _require = __webpack_require__(551),
	              load = _require.load,
	              urlSettings = _require.urlSettings,
	              release = _require.release;
	
	          urlSettings.key = apiKey;
	          load().then(function (Maps) {
	            console.log('Google Maps Loaded');
	            return _this2.setState({
	              loaded: true,
	              Maps: Maps
	            });
	          }).catch(function (err) {
	            console.log(err);
	            throw err;
	          });
	        }
	      };
	
	      Wrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	        // release()
	        //   .then(() => console.log('No google maps api around'))
	        //   .catch(err => {
	        //     console.log(err);
	        //     throw err;
	        //   });
	      };
	
	      Wrapper.prototype.render = function render() {
	        var props = _extends({}, this.props, {
	          loaded: this.state.loaded,
	          Maps: this.state.Maps
	        });
	        return this.state.loaded && this.state.Maps && _react2.default.createElement(WrappedComponent, props);
	      };
	
	      return Wrapper;
	    }(_react.Component);
	
	    return Wrapper;
	  };
	};
	
	exports.default = wrapper;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Teaser = __webpack_require__(540);
	
	var _Teaser2 = _interopRequireDefault(_Teaser);
	
	var _Slideshow = __webpack_require__(547);
	
	var _Slideshow2 = _interopRequireDefault(_Slideshow);
	
	var _riverModule = __webpack_require__(860);
	
	var _riverModule2 = _interopRequireDefault(_riverModule);
	
	var _CSSPlugin = __webpack_require__(47);
	
	var _gsap = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { ThrowPropsPlugin } from '../../../lib/ThrowPropsPlugin';
	
	var Draggable = void 0;
	var ThrowPropsPlugin = void 0;
	var plugins = [_CSSPlugin.CSSPlugin];
	var inDelay = 0.75;
	var outDelay = 0.75;
	var headerHeight = parseInt(_riverModule2.default.locationHeaderHeight.replace('px', ''), 10);
	
	var setBodyColor = function setBodyColor(color) {
	  if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
	    var body = document.querySelector('body');
	    body.style.backgroundColor = color;
	  }
	};
	
	var River = function (_Component) {
	  _inherits(River, _Component);
	
	  function River() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, River);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      currentStop: undefined,
	      nextStop: undefined
	    }, _this.initSwipe = function () {
	      if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefined && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
	        Draggable = __webpack_require__(914);
	        ThrowPropsPlugin = __webpack_require__(561);
	        var riverHeight = _this.riverRef.getBoundingClientRect().height;
	
	        var direction = void 0;
	        var _river = _this.riverRef;
	        _this.swipe = Draggable.create(_this.riverRef, {
	          type: 'y',
	          trigger: _this.headerRef,
	          lockAxis: 'y',
	          throwProps: true,
	          bounds: {
	            top: 0,
	            left: 0,
	            width: 0,
	            height: riverHeight * 2 - headerHeight
	          },
	          overshootTolerance: 0.15,
	          onDragEnd: function onDragEnd() {
	            //move the original marker to end position
	            if (this.getDirection('velocity') === 'up') {
	              _gsap.TweenLite.to(_river, 0.68, {
	                x: this.x,
	                y: this.minY,
	                onComplete: setBodyColor,
	                onCompleteParams: ['#fff'],
	                force3D: true
	              });
	            } else if (this.getDirection('velocity') === 'down') {
	              _gsap.TweenLite.to(_river, 0.68, {
	                x: this.x,
	                y: this.maxY,
	                onComplete: setBodyColor,
	                onCompleteParams: [''],
	                force3D: true
	              });
	            }
	          }
	        });
	
	        window.addEventListener('resize', function () {
	          if (!_this.swipe[0].enabled()) return;
	          riverHeight = _this.riverRef.getBoundingClientRect().height;
	          _this.swipe[0].applyBounds({
	            top: 0,
	            left: 10,
	            width: 0,
	            height: riverHeight * 2 - headerHeight
	          });
	        });
	      }
	    }, _this.toggleSwipe = function () {
	      if (_this.props.isMobileDevice && _this.riverRef) {
	        _this.swipe[0].enable();
	      } else {
	        _this.swipe[0].disable();
	      }
	    }, _this.animateMaskIn = function (title) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return _gsap.TweenLite.to(title, 0.85, {
	        autoAlpha: 1,
	        y: '0%',
	        ease: Quint.easeInOut,
	        delay: delay,
	        force3D: true
	      });
	    }, _this.animateFadeIn = function (content) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return _gsap.TweenLite.to(content, 0.85, {
	        autoAlpha: 1,
	        ease: Quint.easeInOut,
	        delay: delay,
	        force3D: true
	      });
	    }, _this.animateOff = function () {}, _this.animateOnMount = function () {
	      var isMobileDevice = _this.props.isMobileDevice;
	
	      var riverHeight = _this.riverRef.getBoundingClientRect().height;
	      var fromY = isMobileDevice ? riverHeight : 50;
	      var toY = isMobileDevice ? riverHeight - headerHeight : 0;
	
	      _gsap.TweenLite.set(_this.riverRef, {
	        autoAlpha: 0,
	        y: fromY
	      });
	
	      var onMountTimeline = new _gsap.TimelineLite({
	        clearProps: 'all',
	        force3D: true,
	        onComplete: function onComplete() {
	          _this.initSwipe();
	          _this.props.setIsTransitioningBetweenStops(false);
	          _this.toggleSwipe();
	        }
	      });
	
	      onMountTimeline.to(_this.riverRef, 0.85, {
	        autoAlpha: 1,
	        y: toY,
	        ease: Quad.easeOut
	      }, 0).add(_this.animateMaskIn(_this.titleRef, inDelay), 0);
	    }, _this.animateNextIn = function () {
	      var nextInTimeline = new _gsap.TimelineLite({
	        clearProps: 'all',
	        force3D: true,
	        onComplete: function onComplete() {
	          _this.props.setIsTransitioningBetweenStops(false);
	        }
	      });
	
	      nextInTimeline.add(_this.animateMaskIn(_this.titleRef), 0).add(_this.animateFadeIn(_this.contentRef), 0).add(_this.animateFadeIn(_this.scrimRef), 0);
	    }, _this.animateToNextOut = function () {
	      var totalDuration = 1.25;
	      _gsap.TweenLite.set(_this.bgRef, { x: '-50%' });
	      _gsap.TweenLite.set(_this.nextBgRef, { x: '50%' });
	
	      var nextOutTimeline = new _gsap.TimelineLite({
	        clearProps: 'all',
	        force3D: true,
	        onStart: function onStart() {
	          _this.props.setIsTransitioningBetweenStops(true);
	        },
	        onComplete: function onComplete() {
	          _gsap.TweenLite.set(_this.contentRef, { scrollTop: 0 });
	          _this.setState({ currentStop: _this.state.nextStop }, function () {
	            _this.animateNextIn();
	          });
	        }
	      });
	
	      nextOutTimeline.to(_this.bgRef, totalDuration, {
	        x: '-150%',
	        ease: Quint.easeInOut,
	        onComplete: _this.onComplete
	      }, 0).to(_this.nextBgRef, totalDuration, {
	        x: '-50%',
	        ease: Quint.easeInOut
	      }, 0).to(_this.titleRef, totalDuration * 0.85, {
	        y: '110%',
	        ease: Quint.easeInOut
	      }, 0).to(_this.contentRef, totalDuration, {
	        autoAlpha: 0,
	        ease: Quint.easeInOut
	      }, 0).to(_this.scrimRef, totalDuration, {
	        autoAlpha: 0,
	        ease: Quint.easeInOut
	      }, 0);
	    }, _this.handAnimateNextComplete = function () {
	      _this.setState();
	    }, _this.resetAllTweenedProps = function () {
	      var targets = [_this.bgRef, _this.nextBgRef, _this.riverRef, _this.contentRef];
	      _gsap.TweenLite.killTweensOf(targets);
	      _gsap.TweenLite.set(targets, { clearProps: 'all' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  River.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.activeStop !== nextProps.activeStop) {
	      this.setState({ nextStop: nextProps.activeStop }, this.animateToNextOut());
	    }
	  };
	
	  River.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {};
	
	  River.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.isMobileDevice !== prevProps.isMobileDevice) {
	      this.resetAllTweenedProps();
	      this.toggleSwipe();
	    }
	  };
	
	  River.prototype.componentWillMount = function componentWillMount() {
	    this.setState({
	      currentStop: this.props.activeStop,
	      nextStop: this.props.activeStop
	    });
	  };
	
	  River.prototype.componentDidMount = function componentDidMount() {
	    _gsap.TweenLite.set(this.titleRef, { y: '100%' });
	    this.animateOnMount();
	    // this.animateMaskIn(this.titleRef, inDelay);
	  };
	
	  River.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        setActiveDetail = _props.setActiveDetail,
	        activeDetail = _props.activeDetail,
	        isSlideshowDetailOpen = _props.isSlideshowDetailOpen,
	        handleTourStopDetailClosed = _props.handleTourStopDetailClosed;
	    var _state = this.state,
	        nextStop = _state.nextStop,
	        currentStop = _state.currentStop;
	    var title = currentStop.title,
	        body = currentStop.body,
	        details = currentStop.details;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _riverModule2.default.riverContainer, ref: function ref(el) {
	          return _this2.riverRef = el;
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: _riverModule2.default.riverContainerInner },
	        _react2.default.createElement(
	          'div',
	          { ref: function ref(el) {
	              return _this2.headerRef = el;
	            }, className: _riverModule2.default.header },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(el) {
	                return _this2.bgRef = el;
	              }, className: _riverModule2.default.headerBg },
	            currentStop.image && currentStop.image.sizes && _react2.default.createElement('img', {
	              className: _riverModule2.default.headerBgImage,
	              src: currentStop.image.sizes.large,
	              alt: currentStop.image.alt
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: function ref(el) {
	                return _this2.nextBgRef = el;
	              },
	              className: _riverModule2.default.nextHeaderBg
	            },
	            nextStop.image && nextStop.image.sizes && _react2.default.createElement('img', {
	              className: _riverModule2.default.headerBgImage,
	              src: nextStop.image.sizes.large,
	              alt: nextStop.image.alt
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _riverModule2.default.locationNameWrapper },
	            _react2.default.createElement('span', {
	              ref: function ref(el) {
	                return _this2.scrimRef = el;
	              },
	              className: _riverModule2.default.titleScrim
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: _riverModule2.default.swipeCta },
	              'Swipe up to explore'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { overflow: 'hidden' } },
	              _react2.default.createElement('h2', {
	                ref: function ref(el) {
	                  return _this2.titleRef = el;
	                },
	                className: _riverModule2.default.locationName,
	                dangerouslySetInnerHTML: { __html: currentStop.title }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(el) {
	              return _this2.contentRef = el;
	            },
	            className: _riverModule2.default.teaserContainer
	          },
	          _react2.default.createElement(
	            'div',
	            { className: _riverModule2.default.tourStopBodyContainer },
	            _react2.default.createElement('div', {
	              className: _riverModule2.default.tourStopBody,
	              dangerouslySetInnerHTML: { __html: body }
	            })
	          ),
	          details !== undefined && details.length > 0 && details.map(function (detail, index) {
	            return _react2.default.createElement(_Teaser2.default, _extends({
	              setActiveDetail: setActiveDetail,
	              isActive: activeDetail && detail.title === activeDetail.title,
	              key: detail.detail_type + '-' + index
	            }, detail));
	          })
	        ),
	        isSlideshowDetailOpen && _react2.default.createElement(_Slideshow2.default, _extends({
	          handleTourStopDetailClosed: handleTourStopDetailClosed,
	          isOpen: isSlideshowDetailOpen,
	          title: isSlideshowDetailOpen && title
	        }, activeDetail))
	      )
	    );
	  };
	
	  return River;
	}(_react.Component);
	
	exports.default = River;
	module.exports = exports['default'];

/***/ }),
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VolumeControlsModule = __webpack_require__(867);
	
	var _VolumeControlsModule2 = _interopRequireDefault(_VolumeControlsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VolumeControls = function VolumeControls(_ref) {
	  var currVolume = _ref.currVolume,
	      handleVolumeVisibility = _ref.handleVolumeVisibility,
	      isVolumeOpen = _ref.isVolumeOpen,
	      handleVolumeLevel = _ref.handleVolumeLevel;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _VolumeControlsModule2.default.volumeWrapper },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (currVolume <= '0.50' && currVolume >= '0.05' ? _VolumeControlsModule2.default.volumeButtonHalf : currVolume === '0' ? _VolumeControlsModule2.default.volumeButtonMuted : '') + ' ' + _VolumeControlsModule2.default.volumeButton,
	        onClick: handleVolumeVisibility
	      },
	      _react2.default.createElement(
	        'svg',
	        { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 17.5' },
	        _react2.default.createElement('path', { d: 'M0,5.8v6h4l5,5v-16l-5,5H0z' }),
	        _react2.default.createElement(
	          'g',
	          { className: _VolumeControlsModule2.default.volumeBars },
	          _react2.default.createElement('path', { d: 'M11,0v2.1c2.9,0.9,5,3.5,5,6.7s-2.1,5.9-5,6.7v2.1c4-0.9,7-4.5,7-8.8S15,0.9,11,0L11,0z' }),
	          _react2.default.createElement('path', { d: 'M13.5,8.8c0-1.8-1-3.3-2.5-4v8C12.5,12.1,13.5,10.5,13.5,8.8z' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'volume-slider ' + (isVolumeOpen ? _VolumeControlsModule2.default.volumeSliderOpen : '') + ' ' + _VolumeControlsModule2.default.volumeSlider
	      },
	      _react2.default.createElement('input', {
	        type: 'range',
	        min: '0',
	        max: '1',
	        step: '0.05',
	        onChange: handleVolumeLevel
	      })
	    )
	  );
	};
	
	exports.default = VolumeControls;
	module.exports = exports['default'];

/***/ }),
/* 560 */,
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * VERSION: 0.11.1
	 * DATE: 2017-06-19
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
	 * ThrowPropsPlugin is a Club GreenSock membership benefit; You must have a valid membership to use
	 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
	 * This work is subject to the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = typeof module !== 'undefined' && module.exports && typeof global !== 'undefined' ? global : undefined || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
	  'use strict';
	
	  _gsScope._gsDefine('plugins.ThrowPropsPlugin', ['plugins.TweenPlugin', 'TweenLite', 'easing.Ease', 'utils.VelocityTracker'], function (TweenPlugin, TweenLite, Ease, VelocityTracker) {
	    var ThrowPropsPlugin = function ThrowPropsPlugin(props, priority) {
	      TweenPlugin.call(this, 'throwProps');
	      this._overwriteProps.length = 0;
	    },
	        _max = 999999999999999,
	        _min = 0.0000000001,
	        _globals = _gsScope._gsDefine.globals,
	        _recordEndMode = false,
	        //in a typical throwProps css tween that has an "end" defined as a function, it grabs that value initially when the tween is rendered, then again when we calculate the necessary duration, and then a 3rd time after we invalidate() the tween, so we toggle _recordEndMode to true when we're about to begin such a tween which tells the engine to grab the end value(s) once and record them as "max" and "min" on the throwProps object, thus we can skip those extra calls. Then we set it back to false when we're done with our fancy initialization routine.
	    _transforms = {
	      x: 1,
	      y: 1,
	      z: 2,
	      scale: 1,
	      scaleX: 1,
	      scaleY: 1,
	      rotation: 1,
	      rotationZ: 1,
	      rotationX: 2,
	      rotationY: 2,
	      skewX: 1,
	      skewY: 1,
	      xPercent: 1,
	      yPercent: 1
	    },
	        _getClosest = function _getClosest(n, values, max, min, radius) {
	      var i = values.length,
	          closest = 0,
	          absDif = _max,
	          val,
	          dif,
	          p,
	          dist;
	      if ((typeof n === 'undefined' ? 'undefined' : _typeof(n)) === 'object') {
	        while (--i > -1) {
	          val = values[i];
	          dif = 0;
	          for (p in n) {
	            dist = val[p] - n[p];
	            dif += dist * dist;
	          }
	          if (dif < absDif) {
	            closest = i;
	            absDif = dif;
	          }
	        }
	        if ((radius || _max) < _max && radius < Math.sqrt(absDif)) {
	          return n;
	        }
	      } else {
	        while (--i > -1) {
	          val = values[i];
	          dif = val - n;
	          if (dif < 0) {
	            dif = -dif;
	          }
	          if (dif < absDif && val >= min && val <= max) {
	            closest = i;
	            absDif = dif;
	          }
	        }
	      }
	      return values[closest];
	    },
	        _parseEnd = function _parseEnd(curProp, end, max, min, name, radius) {
	      if (curProp.end === 'auto') {
	        return curProp;
	      }
	      var endVar = curProp.end,
	          adjustedEnd,
	          p;
	      max = isNaN(max) ? _max : max;
	      min = isNaN(min) ? -_max : min;
	      if ((typeof end === 'undefined' ? 'undefined' : _typeof(end)) === 'object') {
	        //for objects, like {x, y} where they're linked and we must pass an object to the function or find the closest value in an array.
	        adjustedEnd = end.calculated ? end : (typeof endVar === 'function' ? endVar(end) : _getClosest(end, endVar, max, min, radius)) || end;
	        if (!end.calculated) {
	          for (p in adjustedEnd) {
	            end[p] = adjustedEnd[p];
	          }
	          end.calculated = true;
	        }
	        adjustedEnd = adjustedEnd[name];
	      } else {
	        adjustedEnd = typeof endVar === 'function' ? endVar(end) : endVar instanceof Array ? _getClosest(end, endVar, max, min, radius) : Number(endVar);
	      }
	      if (adjustedEnd > max) {
	        adjustedEnd = max;
	      } else if (adjustedEnd < min) {
	        adjustedEnd = min;
	      }
	      return {
	        max: adjustedEnd,
	        min: adjustedEnd,
	        unitFactor: curProp.unitFactor
	      };
	    },
	        _extend = function _extend(decoratee, extras, exclude) {
	      for (var p in extras) {
	        if (decoratee[p] === undefined && p !== exclude) {
	          decoratee[p] = extras[p];
	        }
	      }
	      return decoratee;
	    },
	        _calculateChange = ThrowPropsPlugin.calculateChange = function (velocity, ease, duration, checkpoint) {
	      if (checkpoint == null) {
	        checkpoint = 0.05;
	      }
	      var e = ease instanceof Ease ? ease : !ease ? TweenLite.defaultEase : new Ease(ease);
	      return duration * checkpoint * velocity / e.getRatio(checkpoint);
	    },
	        _calculateDuration = ThrowPropsPlugin.calculateDuration = function (start, end, velocity, ease, checkpoint) {
	      checkpoint = checkpoint || 0.05;
	      var e = ease instanceof Ease ? ease : !ease ? TweenLite.defaultEase : new Ease(ease);
	      return Math.abs((end - start) * e.getRatio(checkpoint) / velocity / checkpoint);
	    },
	        _calculateTweenDuration = ThrowPropsPlugin.calculateTweenDuration = function (target, vars, maxDuration, minDuration, overshootTolerance, recordEnd) {
	      if (typeof target === 'string') {
	        target = TweenLite.selector(target);
	      }
	      if (!target) {
	        return 0;
	      }
	      if (maxDuration == null) {
	        maxDuration = 10;
	      }
	      if (minDuration == null) {
	        minDuration = 0.2;
	      }
	      if (overshootTolerance == null) {
	        overshootTolerance = 1;
	      }
	      if (target.length) {
	        target = target[0] || target;
	      }
	      var duration = 0,
	          clippedDuration = 9999999999,
	          throwPropsVars = vars.throwProps || vars,
	          ease = vars.ease instanceof Ease ? vars.ease : !vars.ease ? TweenLite.defaultEase : new Ease(vars.ease),
	          checkpoint = isNaN(throwPropsVars.checkpoint) ? 0.05 : Number(throwPropsVars.checkpoint),
	          resistance = isNaN(throwPropsVars.resistance) ? ThrowPropsPlugin.defaultResistance : Number(throwPropsVars.resistance),
	          p,
	          curProp,
	          curDuration,
	          curVelocity,
	          curResistance,
	          curVal,
	          end,
	          curClippedDuration,
	          tracker,
	          unitFactor,
	          linkedProps,
	          linkedPropNames,
	          i;
	
	      if (throwPropsVars.linkedProps) {
	        //when there are linkedProps (typically "x,y" where snapping has to factor in multiple properties, we must first populate an object with all of those end values, then feed it to the function that make any necessary alterations. So the point of this first loop is to simply build an object (like {x:100, y:204.5}) for feeding into that function which we'll do later in the "real" loop.
	        linkedPropNames = throwPropsVars.linkedProps.split(',');
	        linkedProps = {};
	        for (i = 0; i < linkedPropNames.length; i++) {
	          p = linkedPropNames[i];
	          curProp = throwPropsVars[p];
	          if (curProp) {
	            if (curProp.velocity !== undefined && typeof curProp.velocity === 'number') {
	              curVelocity = Number(curProp.velocity) || 0;
	            } else {
	              tracker = tracker || VelocityTracker.getByTarget(target);
	              curVelocity = tracker && tracker.isTrackingProp(p) ? tracker.getVelocity(p) : 0;
	            }
	            curResistance = isNaN(curProp.resistance) ? resistance : Number(curProp.resistance);
	            curDuration = curVelocity * curResistance > 0 ? curVelocity / curResistance : curVelocity / -curResistance;
	            curVal = typeof target[p] === 'function' ? target[p.indexOf('set') || typeof target['get' + p.substr(3)] !== 'function' ? p : 'get' + p.substr(3)]() : target[p] || 0;
	            linkedProps[p] = curVal + _calculateChange(curVelocity, ease, curDuration, checkpoint);
	          }
	        }
	      }
	
	      for (p in throwPropsVars) {
	        if (p !== 'resistance' && p !== 'checkpoint' && p !== 'preventOvershoot' && p !== 'linkedProps' && p !== 'radius') {
	          curProp = throwPropsVars[p];
	          if ((typeof curProp === 'undefined' ? 'undefined' : _typeof(curProp)) !== 'object') {
	            tracker = tracker || VelocityTracker.getByTarget(target);
	            if (tracker && tracker.isTrackingProp(p)) {
	              curProp = typeof curProp === 'number' ? { velocity: curProp } : { velocity: tracker.getVelocity(p) }; //if we're tracking this property, we should use the tracking velocity and then use the numeric value that was passed in as the min and max so that it tweens exactly there.
	            } else {
	              curVelocity = Number(curProp) || 0;
	              curDuration = curVelocity * resistance > 0 ? curVelocity / resistance : curVelocity / -resistance;
	            }
	          }
	          if ((typeof curProp === 'undefined' ? 'undefined' : _typeof(curProp)) === 'object') {
	            if (curProp.velocity !== undefined && typeof curProp.velocity === 'number') {
	              curVelocity = Number(curProp.velocity) || 0;
	            } else {
	              tracker = tracker || VelocityTracker.getByTarget(target);
	              curVelocity = tracker && tracker.isTrackingProp(p) ? tracker.getVelocity(p) : 0;
	            }
	            curResistance = isNaN(curProp.resistance) ? resistance : Number(curProp.resistance);
	            curDuration = curVelocity * curResistance > 0 ? curVelocity / curResistance : curVelocity / -curResistance;
	            curVal = typeof target[p] === 'function' ? target[p.indexOf('set') || typeof target['get' + p.substr(3)] !== 'function' ? p : 'get' + p.substr(3)]() : target[p] || 0;
	            end = curVal + _calculateChange(curVelocity, ease, curDuration, checkpoint);
	            if (curProp.end !== undefined) {
	              curProp = _parseEnd(curProp, linkedProps && p in linkedProps ? linkedProps : end, curProp.max, curProp.min, p, throwPropsVars.radius);
	              if (recordEnd || _recordEndMode) {
	                throwPropsVars[p] = _extend(curProp, throwPropsVars[p], 'end');
	              }
	            }
	            if (curProp.max !== undefined && end > Number(curProp.max) + _min) {
	              unitFactor = curProp.unitFactor || ThrowPropsPlugin.defaultUnitFactors[p] || 1; //some values are measured in special units like radians in which case our thresholds need to be adjusted accordingly.
	              //if the value is already exceeding the max or the velocity is too low, the duration can end up being uncomfortably long but in most situations, users want the snapping to occur relatively quickly (0.75 seconds), so we implement a cap here to make things more intuitive. If the max and min match, it means we're animating to a particular value and we don't want to shorten the time unless the velocity is really slow. Example: a rotation where the start and natural end value are less than the snapping spot, but the natural end is pretty close to the snap.
	              curClippedDuration = curVal > curProp.max && curProp.min !== curProp.max || curVelocity * unitFactor > -15 && curVelocity * unitFactor < 45 ? minDuration + (maxDuration - minDuration) * 0.1 : _calculateDuration(curVal, curProp.max, curVelocity, ease, checkpoint);
	              if (curClippedDuration + overshootTolerance < clippedDuration) {
	                clippedDuration = curClippedDuration + overshootTolerance;
	              }
	            } else if (curProp.min !== undefined && end < Number(curProp.min) - _min) {
	              unitFactor = curProp.unitFactor || ThrowPropsPlugin.defaultUnitFactors[p] || 1; //some values are measured in special units like radians in which case our thresholds need to be adjusted accordingly.
	              //if the value is already exceeding the min or if the velocity is too low, the duration can end up being uncomfortably long but in most situations, users want the snapping to occur relatively quickly (0.75 seconds), so we implement a cap here to make things more intuitive.
	              curClippedDuration = curVal < curProp.min && curProp.min !== curProp.max || curVelocity * unitFactor > -45 && curVelocity * unitFactor < 15 ? minDuration + (maxDuration - minDuration) * 0.1 : _calculateDuration(curVal, curProp.min, curVelocity, ease, checkpoint);
	              if (curClippedDuration + overshootTolerance < clippedDuration) {
	                clippedDuration = curClippedDuration + overshootTolerance;
	              }
	            }
	
	            if (curClippedDuration > duration) {
	              duration = curClippedDuration;
	            }
	          }
	
	          if (curDuration > duration) {
	            duration = curDuration;
	          }
	        }
	      }
	      if (duration > clippedDuration) {
	        duration = clippedDuration;
	      }
	      if (duration > maxDuration) {
	        return maxDuration;
	      } else if (duration < minDuration) {
	        return minDuration;
	      }
	      return duration;
	    },
	        p = ThrowPropsPlugin.prototype = new TweenPlugin('throwProps'),
	        _cssProxy,
	        _cssVars,
	        _last,
	        _lastValue; //these serve as a cache of sorts, recording the last css-related proxy and the throwProps vars that get calculated in the _cssRegister() method. This allows us to grab them in the ThrowPropsPlugin.to() function and calculate the duration. Of course we could have structured things in a more "clean" fashion, but performance is of paramount importance.
	
	    p.constructor = ThrowPropsPlugin;
	    ThrowPropsPlugin.version = '0.11.1';
	    ThrowPropsPlugin.API = 2;
	    ThrowPropsPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
	    ThrowPropsPlugin.defaultResistance = 100;
	    ThrowPropsPlugin.defaultUnitFactors = { time: 1000, totalTime: 1000 }; //setting the unitFactor to a higher value (default is 1) reduces the chance of the auto-accelerating behavior kicking in when determining durations when the initial velocity is adequately low - imagine dragging something past a boundary and then letting go - snapping back relatively quickly should be prioritized over matching the initial velocity (at least that's the behavior most people consider intuitive). But in some situations when the units are very low (like "time" of a timeline or rotation when using radians), it can kick in too frequently so this allows tweaking.
	
	    ThrowPropsPlugin.track = function (target, props, types) {
	      return VelocityTracker.track(target, props, types);
	    };
	
	    ThrowPropsPlugin.untrack = function (target, props) {
	      VelocityTracker.untrack(target, props);
	    };
	
	    ThrowPropsPlugin.isTracking = function (target, prop) {
	      return VelocityTracker.isTracking(target, prop);
	    };
	
	    ThrowPropsPlugin.getVelocity = function (target, prop) {
	      var vt = VelocityTracker.getByTarget(target);
	      return vt ? vt.getVelocity(prop) : NaN;
	    };
	
	    ThrowPropsPlugin._cssRegister = function () {
	      var CSSPlugin = _globals.com.greensock.plugins.CSSPlugin;
	      if (!CSSPlugin) {
	        return;
	      }
	      var _internals = CSSPlugin._internals,
	          _parseToProxy = _internals._parseToProxy,
	          _setPluginRatio = _internals._setPluginRatio,
	          CSSPropTween = _internals.CSSPropTween;
	      _internals._registerComplexSpecialProp('throwProps', {
	        parser: function parser(t, e, prop, cssp, pt, plugin) {
	          plugin = new ThrowPropsPlugin();
	          var velocities = {},
	              min = {},
	              max = {},
	              end = {},
	              res = {},
	              preventOvershoot = {},
	              hasResistance,
	              val,
	              p,
	              data,
	              tracker;
	          _cssVars = {};
	          for (p in e) {
	            if (p !== 'resistance' && p !== 'preventOvershoot' && p !== 'linkedProps' && p !== 'radius') {
	              val = e[p];
	              if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	                if (val.velocity !== undefined && typeof val.velocity === 'number') {
	                  velocities[p] = Number(val.velocity) || 0;
	                } else {
	                  tracker = tracker || VelocityTracker.getByTarget(t);
	                  velocities[p] = tracker && tracker.isTrackingProp(p) ? tracker.getVelocity(p) : 0; //rotational values are actually converted to radians in CSSPlugin, but our tracking velocity is in radians already, so make it into degrees to avoid a funky conversion
	                }
	                if (val.end !== undefined) {
	                  end[p] = val.end;
	                }
	                if (val.min !== undefined) {
	                  min[p] = val.min;
	                }
	                if (val.max !== undefined) {
	                  max[p] = val.max;
	                }
	                if (val.preventOvershoot) {
	                  preventOvershoot[p] = true;
	                }
	                if (val.resistance !== undefined) {
	                  hasResistance = true;
	                  res[p] = val.resistance;
	                }
	              } else if (typeof val === 'number') {
	                velocities[p] = val;
	              } else {
	                tracker = tracker || VelocityTracker.getByTarget(t);
	                if (tracker && tracker.isTrackingProp(p)) {
	                  velocities[p] = tracker.getVelocity(p);
	                } else {
	                  velocities[p] = val || 0;
	                }
	              }
	              if (_transforms[p]) {
	                cssp._enableTransforms(_transforms[p] === 2);
	              }
	            }
	          }
	          data = _parseToProxy(t, velocities, cssp, pt, plugin);
	          _cssProxy = data.proxy;
	          velocities = data.end;
	          for (p in _cssProxy) {
	            _cssVars[p] = {
	              velocity: velocities[p],
	              min: min[p],
	              max: max[p],
	              end: end[p],
	              resistance: res[p],
	              preventOvershoot: preventOvershoot[p]
	            };
	          }
	          if (e.resistance != null) {
	            _cssVars.resistance = e.resistance;
	          }
	          if (e.linkedProps != null) {
	            _cssVars.linkedProps = e.linkedProps;
	          }
	          if (e.radius != null) {
	            _cssVars.radius = e.radius;
	          }
	          if (e.preventOvershoot) {
	            _cssVars.preventOvershoot = true;
	          }
	          pt = new CSSPropTween(t, 'throwProps', 0, 0, data.pt, 2);
	          cssp._overwriteProps.pop(); //don't overwrite all other throwProps tweens. In the CSSPropTween constructor, we add the property to the _overwriteProps, so remove it here.
	          pt.plugin = plugin;
	          pt.setRatio = _setPluginRatio;
	          pt.data = data;
	          plugin._onInitTween(_cssProxy, _cssVars, cssp._tween);
	          return pt;
	        }
	      });
	    };
	
	    ThrowPropsPlugin.to = function (target, vars, maxDuration, minDuration, overshootTolerance) {
	      if (!vars.throwProps) {
	        vars = { throwProps: vars };
	      }
	      if (overshootTolerance === 0) {
	        vars.throwProps.preventOvershoot = true;
	      }
	      _recordEndMode = true; //if we encounter a function-based "end" value, ThrowPropsPlugin will record it as "max" and "min" properties, replacing "end" (this is an optimization so that the function only gets called once)
	      var tween = new TweenLite(target, minDuration || 1, vars);
	      tween.render(0, true, true); //we force a render so that the CSSPlugin instantiates and populates the _cssProxy and _cssVars which we need in order to calculate the tween duration. Remember, we can't use the regular target for calculating the duration because the current values wouldn't be able to be grabbed like target["propertyName"], as css properties can be complex like boxShadow:"10px 10px 20px 30px red" or backgroundPosition:"25px 50px". The proxy is the result of breaking all that complex data down and finding just the numeric values and assigning them to a generic proxy object with unique names. THAT is what the _calculateTweenDuration() can look at. We also needed to do the same break down of any min or max or velocity data
	      if (tween.vars.css) {
	        tween.duration(_calculateTweenDuration(_cssProxy, { throwProps: _cssVars, ease: vars.ease }, maxDuration, minDuration, overshootTolerance));
	        if (tween._delay && !tween.vars.immediateRender) {
	          tween.invalidate(); //if there's a delay, the starting values could be off, so invalidate() to force reinstantiation when the tween actually starts.
	        } else {
	          _last._onInitTween(_cssProxy, _lastValue, tween);
	        }
	        _recordEndMode = false;
	        return tween;
	      } else {
	        tween.kill();
	        tween = new TweenLite(target, _calculateTweenDuration(target, vars, maxDuration, minDuration, overshootTolerance), vars);
	        _recordEndMode = false;
	        return tween;
	      }
	    };
	
	    p._onInitTween = function (target, value, tween, index) {
	      this.target = target;
	      this._props = [];
	      _last = this;
	      _lastValue = value;
	      var ease = tween._ease,
	          checkpoint = isNaN(value.checkpoint) ? 0.05 : Number(value.checkpoint),
	          duration = tween._duration,
	          preventOvershoot = value.preventOvershoot,
	          cnt = 0,
	          p,
	          curProp,
	          curVal,
	          isFunc,
	          velocity,
	          change1,
	          end,
	          change2,
	          tracker,
	          linkedProps,
	          linkedPropNames,
	          i;
	
	      if (value.linkedProps) {
	        //when there are linkedProps (typically "x,y" where snapping has to factor in multiple properties, we must first populate an object with all of those end values, then feed it to the function that make any necessary alterations. So the point of this first loop is to simply build an object (like {x:100, y:204.5}) for feeding into that function which we'll do later in the "real" loop.
	        linkedPropNames = value.linkedProps.split(',');
	        linkedProps = {};
	        for (i = 0; i < linkedPropNames.length; i++) {
	          p = linkedPropNames[i];
	          curProp = value[p];
	          if (curProp) {
	            if (curProp.velocity !== undefined && typeof curProp.velocity === 'number') {
	              velocity = Number(curProp.velocity) || 0;
	            } else {
	              tracker = tracker || VelocityTracker.getByTarget(target);
	              velocity = tracker && tracker.isTrackingProp(p) ? tracker.getVelocity(p) : 0;
	            }
	            curVal = typeof target[p] === 'function' ? target[p.indexOf('set') || typeof target['get' + p.substr(3)] !== 'function' ? p : 'get' + p.substr(3)]() : target[p] || 0;
	            linkedProps[p] = curVal + _calculateChange(velocity, ease, duration, checkpoint);
	          }
	        }
	      }
	
	      for (p in value) {
	        if (p !== 'resistance' && p !== 'checkpoint' && p !== 'preventOvershoot' && p !== 'linkedProps' && p !== 'radius') {
	          curProp = value[p];
	          if (typeof curProp === 'function') {
	            curProp = curProp(index, target);
	          }
	          if (typeof curProp === 'number') {
	            velocity = Number(curProp) || 0;
	          } else if ((typeof curProp === 'undefined' ? 'undefined' : _typeof(curProp)) === 'object' && !isNaN(curProp.velocity)) {
	            velocity = Number(curProp.velocity);
	          } else {
	            tracker = tracker || VelocityTracker.getByTarget(target);
	            if (tracker && tracker.isTrackingProp(p)) {
	              velocity = tracker.getVelocity(p);
	            } else {
	              throw 'ERROR: No velocity was defined in the throwProps tween of ' + target + ' property: ' + p;
	            }
	          }
	          change1 = _calculateChange(velocity, ease, duration, checkpoint);
	          change2 = 0;
	          isFunc = typeof target[p] === 'function';
	          curVal = isFunc ? target[p.indexOf('set') || typeof target['get' + p.substr(3)] !== 'function' ? p : 'get' + p.substr(3)]() : target[p];
	          if ((typeof curProp === 'undefined' ? 'undefined' : _typeof(curProp)) === 'object') {
	            end = curVal + change1;
	            if (curProp.end !== undefined) {
	              curProp = _parseEnd(curProp, linkedProps && p in linkedProps ? linkedProps : end, curProp.max, curProp.min, p, value.radius);
	              if (_recordEndMode) {
	                value[p] = _extend(curProp, value[p], 'end');
	              }
	            }
	            if (curProp.max !== undefined && Number(curProp.max) < end) {
	              if (preventOvershoot || curProp.preventOvershoot) {
	                change1 = curProp.max - curVal;
	              } else {
	                change2 = curProp.max - curVal - change1;
	              }
	            } else if (curProp.min !== undefined && Number(curProp.min) > end) {
	              if (preventOvershoot || curProp.preventOvershoot) {
	                change1 = curProp.min - curVal;
	              } else {
	                change2 = curProp.min - curVal - change1;
	              }
	            }
	          }
	          this._overwriteProps[cnt] = p;
	          this._props[cnt++] = {
	            p: p,
	            s: curVal,
	            c1: change1,
	            c2: change2,
	            f: isFunc,
	            r: false
	          };
	        }
	      }
	      return true;
	    };
	
	    p._kill = function (lookup) {
	      var i = this._props.length;
	      while (--i > -1) {
	        if (lookup[this._props[i].p] != null) {
	          this._props.splice(i, 1);
	        }
	      }
	      return TweenPlugin.prototype._kill.call(this, lookup);
	    };
	
	    p._mod = function (lookup) {
	      var p = this._props,
	          i = p.length,
	          val;
	      while (--i > -1) {
	        val = lookup[p[i].p] || lookup.throwProps;
	        if (typeof val === 'function') {
	          p[i].m = val;
	        }
	      }
	    };
	
	    p.setRatio = function (v) {
	      var i = this._props.length,
	          cp,
	          val;
	      while (--i > -1) {
	        cp = this._props[i];
	        val = cp.s + cp.c1 * v + cp.c2 * v * v;
	        if (cp.m) {
	          val = cp.m(val, this.target);
	        } else if (v === 1) {
	          val = (val * 10000 + (val < 0 ? -0.5 : 0.5) | 0) / 10000; //if we don't round things at the very end, binary math issues can creep in and cause snapping not to be exact (like landing on 20.000000000001 instead of 20).
	        }
	        if (cp.f) {
	          this.target[cp.p](val);
	        } else {
	          this.target[cp.p] = val;
	        }
	      }
	    };
	
	    TweenPlugin.activate([ThrowPropsPlugin]);
	
	    return ThrowPropsPlugin;
	  }, true);
	
	  /*
	  * ----------------------------------------------------------------
	  * VelocityTracker
	  * ----------------------------------------------------------------
	  */
	  _gsScope._gsDefine('utils.VelocityTracker', ['TweenLite'], function (TweenLite) {
	    var _first,
	        _initted,
	        _time1,
	        _time2,
	        _capsExp = /([A-Z])/g,
	        _empty = {},
	        _doc = _gsScope.document,
	        _transforms = {
	      x: 1,
	      y: 1,
	      z: 2,
	      scale: 1,
	      scaleX: 1,
	      scaleY: 1,
	      rotation: 1,
	      rotationZ: 1,
	      rotationX: 2,
	      rotationY: 2,
	      skewX: 1,
	      skewY: 1,
	      xPercent: 1,
	      yPercent: 1
	    },
	        _getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function () {},
	        _getStyle = function _getStyle(t, p, cs) {
	      var rv = (t._gsTransform || _empty)[p];
	      if (rv || rv === 0) {
	        return rv;
	      } else if (t.style[p]) {
	        rv = t.style[p];
	      } else if (cs = cs || _getComputedStyle(t, null)) {
	        rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, '-$1').toLowerCase());
	      } else if (t.currentStyle) {
	        rv = t.currentStyle[p];
	      }
	      return parseFloat(rv) || 0;
	    },
	        _ticker = TweenLite.ticker,
	        VelocityProp = function VelocityProp(p, isFunc, next) {
	      this.p = p;
	      this.f = isFunc;
	      this.v1 = this.v2 = 0;
	      this.t1 = this.t2 = _ticker.time;
	      this.css = false;
	      this.type = '';
	      this._prev = null;
	      if (next) {
	        this._next = next;
	        next._prev = this;
	      }
	    },
	        _update = function _update() {
	      var vt = _first,
	          t = _ticker.time,
	          val,
	          vp;
	      //if the frame rate is too high, we won't be able to track the velocity as well, so only update the values about 33 times per second
	      if (t - _time1 >= 0.03) {
	        _time2 = _time1;
	        _time1 = t;
	        while (vt) {
	          vp = vt._firstVP;
	          while (vp) {
	            val = vp.css ? _getStyle(vt.target, vp.p) : vp.f ? vt.target[vp.p]() : vt.target[vp.p];
	            if (val !== vp.v1 || t - vp.t1 > 0.15) {
	              //use a threshold of 0.15 seconds for zeroing-out velocity. If we only use 0.03 and things update slightly slower, like some Android devices dispatch "touchmove" events sluggishly so 2 or 3 ticks of the TweenLite.ticker may elapse inbetween, thus it may appear like the object is not moving but it actually is but it's not updating as frequently. A threshold of 0.15 seconds seems to be a good balance. We want to update things frequently (0.03 seconds) when they're moving so that we can respond to fast motions accurately, but we want to be more resistant to go back to a zero velocity.
	              vp.v2 = vp.v1;
	              vp.v1 = val;
	              vp.t2 = vp.t1;
	              vp.t1 = t;
	            }
	            vp = vp._next;
	          }
	          vt = vt._next;
	        }
	      }
	    },
	        VelocityTracker = function VelocityTracker(target) {
	      this._lookup = {};
	      this.target = target;
	      this.elem = target.style && target.nodeType ? true : false;
	      if (!_initted) {
	        _ticker.addEventListener('tick', _update, null, false, -100);
	        _time1 = _time2 = _ticker.time;
	        _initted = true;
	      }
	      if (_first) {
	        this._next = _first;
	        _first._prev = this;
	      }
	      _first = this;
	    },
	        getByTarget = VelocityTracker.getByTarget = function (target) {
	      var vt = _first;
	      while (vt) {
	        if (vt.target === target) {
	          return vt;
	        }
	        vt = vt._next;
	      }
	    },
	        p = VelocityTracker.prototype;
	
	    p.addProp = function (prop, type) {
	      if (!this._lookup[prop]) {
	        var t = this.target,
	            isFunc = typeof t[prop] === 'function',
	            alt = isFunc ? this._altProp(prop) : prop,
	            vp = this._firstVP;
	        this._firstVP = this._lookup[prop] = this._lookup[alt] = vp = new VelocityProp(alt !== prop && prop.indexOf('set') === 0 ? alt : prop, isFunc, vp);
	        vp.css = this.elem && (this.target.style[vp.p] !== undefined || _transforms[vp.p]);
	        if (vp.css && _transforms[vp.p] && !t._gsTransform) {
	          TweenLite.set(t, { x: '+=0', overwrite: false }); //just forces CSSPlugin to create a _gsTransform for the element if it doesn't exist
	        }
	        vp.type = type || vp.css && prop.indexOf('rotation') === 0 ? 'deg' : '';
	        vp.v1 = vp.v2 = vp.css ? _getStyle(t, vp.p) : isFunc ? t[vp.p]() : t[vp.p];
	      }
	    };
	
	    p.removeProp = function (prop) {
	      var vp = this._lookup[prop];
	      if (vp) {
	        if (vp._prev) {
	          vp._prev._next = vp._next;
	        } else if (vp === this._firstVP) {
	          this._firstVP = vp._next;
	        }
	        if (vp._next) {
	          vp._next._prev = vp._prev;
	        }
	        this._lookup[prop] = 0;
	        if (vp.f) {
	          this._lookup[this._altProp(prop)] = 0; //if it's a getter/setter, we should remove the matching counterpart (if one exists)
	        }
	      }
	    };
	
	    p.isTrackingProp = function (prop) {
	      return this._lookup[prop] instanceof VelocityProp;
	    };
	
	    p.getVelocity = function (prop) {
	      var vp = this._lookup[prop],
	          target = this.target,
	          val,
	          dif,
	          rotationCap;
	      if (!vp) {
	        throw 'The velocity of ' + prop + ' is not being tracked.';
	      }
	      val = vp.css ? _getStyle(target, vp.p) : vp.f ? target[vp.p]() : target[vp.p];
	      dif = val - vp.v2;
	      if (vp.type === 'rad' || vp.type === 'deg') {
	        //rotational values need special interpretation so that if, for example, they go from 179 to -178 degrees it is interpreted as a change of 3 instead of -357.
	        rotationCap = vp.type === 'rad' ? Math.PI * 2 : 360;
	        dif = dif % rotationCap;
	        if (dif !== dif % (rotationCap / 2)) {
	          dif = dif < 0 ? dif + rotationCap : dif - rotationCap;
	        }
	      }
	      return dif / (_ticker.time - vp.t2);
	    };
	
	    p._altProp = function (p) {
	      //for getters/setters like getCustomProp() and setCustomProp() - we should accommodate both
	      var pre = p.substr(0, 3),
	          alt = (pre === 'get' ? 'set' : pre === 'set' ? 'get' : pre) + p.substr(3);
	      return typeof this.target[alt] === 'function' ? alt : p;
	    };
	
	    VelocityTracker.getByTarget = function (target) {
	      var vt = _first;
	      if (typeof target === 'string') {
	        target = TweenLite.selector(target);
	      }
	      if (target.length && target !== window && target[0] && target[0].style && !target.nodeType) {
	        target = target[0];
	      }
	      while (vt) {
	        if (vt.target === target) {
	          return vt;
	        }
	        vt = vt._next;
	      }
	    };
	
	    VelocityTracker.track = function (target, props, types) {
	      var vt = getByTarget(target),
	          a = props.split(','),
	          i = a.length;
	      types = (types || '').split(',');
	      if (!vt) {
	        vt = new VelocityTracker(target);
	      }
	      while (--i > -1) {
	        vt.addProp(a[i], types[i] || types[0]);
	      }
	      return vt;
	    };
	
	    VelocityTracker.untrack = function (target, props) {
	      var vt = getByTarget(target),
	          a = (props || '').split(','),
	          i = a.length;
	      if (!vt) {
	        return;
	      }
	      while (--i > -1) {
	        vt.removeProp(a[i]);
	      }
	      if (!vt._firstVP || !props) {
	        if (vt._prev) {
	          vt._prev._next = vt._next;
	        } else if (vt === _first) {
	          _first = vt._next;
	        }
	        if (vt._next) {
	          vt._next._prev = vt._prev;
	        }
	      }
	    };
	
	    VelocityTracker.isTracking = function (target, prop) {
	      var vt = getByTarget(target);
	      return !vt ? false : !prop && vt._firstVP ? true : vt.isTrackingProp(prop);
	    };
	
	    return VelocityTracker;
	  }, true);
	});
	if (_gsScope._gsDefine) {
	  _gsScope._gsQueue.pop()();
	}
	
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function (name) {
	  'use strict';
	
	  var getGlobal = function getGlobal() {
	    return (_gsScope.GreenSockGlobals || _gsScope)[name];
	  };
	  if (typeof module !== 'undefined' && module.exports) {
	    //node
	    __webpack_require__(16);
	    module.exports = getGlobal();
	  } else if (true) {
	    //AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	})('ThrowPropsPlugin');
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tourQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Onboarding = __webpack_require__(527);
	
	var _Onboarding2 = _interopRequireDefault(_Onboarding);
	
	var _River = __webpack_require__(553);
	
	var _River2 = _interopRequireDefault(_River);
	
	var _DetailViewer = __webpack_require__(539);
	
	var _DetailViewer2 = _interopRequireDefault(_DetailViewer);
	
	var _Map = __webpack_require__(549);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _TourModule = __webpack_require__(870);
	
	var _TourModule2 = _interopRequireDefault(_TourModule);
	
	var _Transitioner = __webpack_require__(351);
	
	var _Transitioner2 = _interopRequireDefault(_Transitioner);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//selection enums
	var LOCATION = 'location';
	var TAP = 'tap';
	
	//it begins
	
	var Tour = function (_Component) {
	  _inherits(Tour, _Component);
	
	  function Tour() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tour);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      activeStop: undefined, //this.props.data.details.tour_stops[0]
	      firstStopLoaded: false,
	      visitedStopIds: [], //[this.props.data.markers.tour_stops[0].id]
	      activeDetailType: '',
	      stopSelectionMethod: '',
	      activeDetail: undefined,
	      tourStopSelectionMethod: '',
	      hasBeenOnboarded: false,
	      onboardingStatus: 'beforeEnter',
	      isMobileDevice: false,
	      isDetailViewerOpen: false,
	      isSlideshowDetailOpen: false,
	      isTransitioningBetweenStops: false
	    }, _this.handleCheckForMobileDevice = function () {
	      if (typeof window !== 'undefined') {
	        var mq = parseInt(_TourModule2.default.mobileBreakPoint.replace('px', ''), 10);
	        if (window.innerWidth < mq) {
	          _this.setState({
	            isMobileDevice: true
	          });
	        } else {
	          _this.setState({
	            isMobileDevice: false
	          });
	        }
	      }
	    }, _this.handleTourStopDetailClosed = function () {
	      _this.setState({
	        activeDetailType: '',
	        activeDetail: undefined,
	        isDetailViewerOpen: false,
	        isSlideshowDetailOpen: false
	      });
	    }, _this.handleTourStopDetailOpened = function (detail) {
	      var detail_type = detail.detail_type;
	
	      if (_this.state.activeDetail && detail.title === _this.state.activeDetail.title) {
	        _this.handleTourStopDetailClosed();
	      } else {
	        _this.setState({
	          activeDetailType: detail_type,
	          activeDetail: detail,
	          isSlideshowDetailOpen: detail_type === 'slideshow' ? true : false,
	          isDetailViewerOpen: detail_type === 'press_and_hold' || detail_type === 'video' ? true : false
	        });
	      }
	    }, _this.handleIsTransitioningBetweenStops = function (transitioning) {
	      _this.setState({
	        isTransitioningBetweenStops: transitioning
	      });
	    }, _this.handleSetSelectionMethod = function (method) {
	      _this.setState({
	        stopSelectionMethod: method
	      });
	    }, _this.handleOpenTourStopByDistance = function (id) {
	      _this.handleMarkerClicked(null, id, false);
	    }, _this.handleMarkerClicked = function (e, id) {
	      var tap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (_this.state.isTransitioningBetweenStops) return;
	      _this.handleMarkerSelected(id, tap);
	    }, _this.handleMarkerSelected = function (id, tap) {
	      var tour_stops = _this.props.data.details.tour_stops;
	
	      _this.handleTourStopDetailClosed();
	
	      _this.setState({
	        stopSelectionMethod: tap ? TAP : LOCATION,
	        isTransitioningBetweenStops: true,
	        firstStopLoaded: _this.state.firstStopLoaded === false ? true : _this.state.firstStopLoaded,
	        activeStop: id ? tour_stops.find(function (stop) {
	          return parseInt(stop.id) === parseInt(id);
	        }) : _this.state.activeStop,
	        visitedStopIds: [].concat(_this.state.visitedStopIds, [id])
	      });
	    }, _this.handleEnterFromOnboarding = function (e) {
	      _this.setState({
	        onboardingStatus: 'exit'
	      }, function () {
	        setTimeout(function () {
	          _this.setState({ hasBeenOnboarded: true }, _this.props.setMainMenuColor('black'), _this.props.setLogoColor('black'));
	        }, 600);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  //Handle clicking the marker
	
	
	  Tour.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.setState({ onboardingStatus: 'active' });
	    }, 200);
	
	    this.handleCheckForMobileDevice();
	    this.props.setMainMenuColor('white');
	    this.props.setLogoColor('white');
	    this.props.setHeaderGradient(false);
	    if (typeof window !== 'undefined') {
	      window.addEventListener('resize', this.handleCheckForMobileDevice);
	    }
	  };
	
	  Tour.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('resize', this.handleCheckForMobileDevice);
	    }
	  };
	
	  Tour.prototype.render = function render() {
	    var _props$data = this.props.data,
	        markers = _props$data.markers,
	        details = _props$data.details;
	    var _state = this.state,
	        activeDetail = _state.activeDetail,
	        activeStop = _state.activeStop,
	        firstStopLoaded = _state.firstStopLoaded,
	        visitedStopIds = _state.visitedStopIds,
	        hasBeenOnboarded = _state.hasBeenOnboarded,
	        isDetailViewerOpen = _state.isDetailViewerOpen,
	        isSlideshowDetailOpen = _state.isSlideshowDetailOpen;
	
	
	    return _react2.default.createElement(
	      'div',
	      { style: { overflow: 'hidden', height: '100%', position: 'relative' } },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Walking Tour | The House on Henry Street' }),
	      this.state.hasBeenOnboarded && firstStopLoaded && _react2.default.createElement(_River2.default, {
	        isSlideshowDetailOpen: isSlideshowDetailOpen,
	        isMobileDevice: this.state.isMobileDevice,
	        setActiveDetail: this.handleTourStopDetailOpened,
	        handleTourStopDetailClosed: this.handleTourStopDetailClosed,
	        activeDetail: activeDetail,
	        activeStop: activeStop,
	        setIsTransitioningBetweenStops: this.handleIsTransitioningBetweenStops
	      }),
	      _react2.default.createElement(
	        _Transitioner2.default,
	        {
	          isActive: isDetailViewerOpen,
	          timeout: 1500,
	          classNames: 'slideUp'
	        },
	        _react2.default.createElement(_DetailViewer2.default, {
	          isOpen: isDetailViewerOpen,
	          closeActiveDetail: this.handleTourStopDetailOpened,
	          parentProps: _extends({}, this.props),
	          detail: _extends({}, activeDetail)
	        })
	      ),
	      _react2.default.createElement(_Map2.default, {
	        hasBeenOnboarded: hasBeenOnboarded,
	        isMobileDevice: this.state.isMobileDevice,
	        handleMarkerClicked: this.handleMarkerClicked,
	        stopSelectionMethod: this.state.stopSelectionMethod,
	        handleSetSelectionMethod: this.handleSetSelectionMethod,
	        handleOpenTourStopByDistance: this.handleOpenTourStopByDistance,
	        markers: markers.tour_stops,
	        activeStopId: activeStop !== undefined ? activeStop.id : -1,
	        visitedStopIds: visitedStopIds,
	        firstStopLoaded: firstStopLoaded,
	        isTransitioningBetweenStops: this.state.isTransitioningBetweenStops
	      }),
	      !hasBeenOnboarded && _react2.default.createElement(_Onboarding2.default, {
	        isMobileDevice: this.state.isMobileDevice,
	        handleEnterFromOnboarding: this.handleEnterFromOnboarding,
	        status: this.state.onboardingStatus
	      })
	    );
	  };
	
	  return Tour;
	}(_react.Component);
	
	exports.default = Tour;
	var tourQuery = exports.tourQuery = '** extracted graphql fragment **';

/***/ }),
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"audioWrapper":"src-components-global----AudioPlayer-module---audioWrapper---j_tnI","audioPlayer":"src-components-global----AudioPlayer-module---audioPlayer---3G1wz","audioInfo":"src-components-global----AudioPlayer-module---audioInfo---279f4","audioTitle":"src-components-global----AudioPlayer-module---audioTitle---2jYNW","audioControls":"src-components-global----AudioPlayer-module---audioControls---22UTt","progressWrapper":"src-components-global----AudioPlayer-module---progressWrapper---2pnSo","progress":"src-components-global----AudioPlayer-module---progress---buhXb","audioTime":"src-components-global----AudioPlayer-module---audioTime---4t-VA","currTime":"src-components-global----AudioPlayer-module---currTime---Unv_M","fadeIn":"src-components-global----AudioPlayer-module---fadeIn---1v3pl","fadeInUp":"src-components-global----AudioPlayer-module---fadeInUp---3H3qP","fadeInUpCenter":"src-components-global----AudioPlayer-module---fadeInUpCenter---3h_w4","fadeInUpSmall":"src-components-global----AudioPlayer-module---fadeInUpSmall---2trgX","textCoverIn":"src-components-global----AudioPlayer-module---textCoverIn---1Tnvg","textCoverOut":"src-components-global----AudioPlayer-module---textCoverOut---3Mh7r"};

/***/ }),
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-tour-details----detailViewer-module---container---1NhR7","buttonWrap":"src-components-tour-details----detailViewer-module---buttonWrap---3RUzm","fadeIn":"src-components-tour-details----detailViewer-module---fadeIn---zPPbj","fadeInUp":"src-components-tour-details----detailViewer-module---fadeInUp---2jody","fadeInUpCenter":"src-components-tour-details----detailViewer-module---fadeInUpCenter---Z6-RL","fadeInUpSmall":"src-components-tour-details----detailViewer-module---fadeInUpSmall---1RBXb","textCoverIn":"src-components-tour-details----detailViewer-module---textCoverIn---QSHwc","textCoverOut":"src-components-tour-details----detailViewer-module---textCoverOut---2Elzm"};

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-tour-details----teaser-module---container---3n7c_ src-style----_utility---spaceSandwichl---1NtHV","fadeIn":"src-components-tour-details----teaser-module---fadeIn---2OjJA","fadeInUp":"src-components-tour-details----teaser-module---fadeInUp---DSZMG","fadeInUpCenter":"src-components-tour-details----teaser-module---fadeInUpCenter---synWF","fadeInUpSmall":"src-components-tour-details----teaser-module---fadeInUpSmall---2prYz","textCoverIn":"src-components-tour-details----teaser-module---textCoverIn---FAFch","textCoverOut":"src-components-tour-details----teaser-module---textCoverOut---tkL-O"};

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"src-components-tour-details-teasers----audioClip-module---title---5TSSN","body":"src-components-tour-details-teasers----audioClip-module---body---3YUD-","fadeIn":"src-components-tour-details-teasers----audioClip-module---fadeIn---1XqPh","fadeInUp":"src-components-tour-details-teasers----audioClip-module---fadeInUp---2gxgQ","fadeInUpCenter":"src-components-tour-details-teasers----audioClip-module---fadeInUpCenter---2dg1N","fadeInUpSmall":"src-components-tour-details-teasers----audioClip-module---fadeInUpSmall---3ZyA7","textCoverIn":"src-components-tour-details-teasers----audioClip-module---textCoverIn---zI0Db","textCoverOut":"src-components-tour-details-teasers----audioClip-module---textCoverOut---2UW8l"};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"discussionPointTitle":"src-components-tour-details-teasers----discussionPoint-module---discussionPointTitle---1BPcS src-style----_utility---spaceStackm---SVJFp","dicussionPointIcon":"src-components-tour-details-teasers----discussionPoint-module---dicussionPointIcon---ftyxI","fadeIn":"src-components-tour-details-teasers----discussionPoint-module---fadeIn---1Oi2A","fadeInUp":"src-components-tour-details-teasers----discussionPoint-module---fadeInUp---18TMr","fadeInUpCenter":"src-components-tour-details-teasers----discussionPoint-module---fadeInUpCenter----5ic-","fadeInUpSmall":"src-components-tour-details-teasers----discussionPoint-module---fadeInUpSmall---3JgQq","textCoverIn":"src-components-tour-details-teasers----discussionPoint-module---textCoverIn---3fBBs","textCoverOut":"src-components-tour-details-teasers----discussionPoint-module---textCoverOut---n6C9f"};

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageContainerInner":"src-components-tour-details-teasers----pressPlayTeaser-module---imageContainerInner---3cGLk","buttonWrap":"src-components-tour-details-teasers----pressPlayTeaser-module---buttonWrap---sd71J","buttonWrapClosed":"src-components-tour-details-teasers----pressPlayTeaser-module---buttonWrapClosed---3KUiI src-components-tour-details-teasers----pressPlayTeaser-module---buttonWrap---sd71J","imageContainer":"src-components-tour-details-teasers----pressPlayTeaser-module---imageContainer---3d1iq","image":"src-components-tour-details-teasers----pressPlayTeaser-module---image---2J00G","title":"src-components-tour-details-teasers----pressPlayTeaser-module---title---2iCLI","body":"src-components-tour-details-teasers----pressPlayTeaser-module---body---2TuAa","fadeIn":"src-components-tour-details-teasers----pressPlayTeaser-module---fadeIn---NJRe1","fadeInUp":"src-components-tour-details-teasers----pressPlayTeaser-module---fadeInUp---19w3g","fadeInUpCenter":"src-components-tour-details-teasers----pressPlayTeaser-module---fadeInUpCenter---1USL4","fadeInUpSmall":"src-components-tour-details-teasers----pressPlayTeaser-module---fadeInUpSmall---2jOXV","textCoverIn":"src-components-tour-details-teasers----pressPlayTeaser-module---textCoverIn---1h4-b","textCoverOut":"src-components-tour-details-teasers----pressPlayTeaser-module---textCoverOut---2Abx_"};

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"quoteIcon":"src-components-tour-details-teasers----quote-module---quoteIcon---PwU79","quoteText":"src-components-tour-details-teasers----quote-module---quoteText---2xIWi src-style----_utility---spaceStacks---1zeSR","quoteCaption":"src-components-tour-details-teasers----quote-module---quoteCaption---1zKRe","fadeIn":"src-components-tour-details-teasers----quote-module---fadeIn---1NC1x","fadeInUp":"src-components-tour-details-teasers----quote-module---fadeInUp---3d-OY","fadeInUpCenter":"src-components-tour-details-teasers----quote-module---fadeInUpCenter---3lo9Z","fadeInUpSmall":"src-components-tour-details-teasers----quote-module---fadeInUpSmall---2z86J","textCoverIn":"src-components-tour-details-teasers----quote-module---textCoverIn---ZKOm-","textCoverOut":"src-components-tour-details-teasers----quote-module---textCoverOut---1yoQa"};

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-tour-details-teasers----slideshowTeaser-module---container---3CoJn","imageContainerInner":"src-components-tour-details-teasers----slideshowTeaser-module---imageContainerInner---1D9sG","imageContainer":"src-components-tour-details-teasers----slideshowTeaser-module---imageContainer---Lxm_E","contentContainer":"src-components-tour-details-teasers----slideshowTeaser-module---contentContainer---2BkqX","image":"src-components-tour-details-teasers----slideshowTeaser-module---image---jrEfQ","title":"src-components-tour-details-teasers----slideshowTeaser-module---title---3rrhd","body":"src-components-tour-details-teasers----slideshowTeaser-module---body---22RfX","buttonWrap":"src-components-tour-details-teasers----slideshowTeaser-module---buttonWrap---Vkry8","buttonWrapClosed":"src-components-tour-details-teasers----slideshowTeaser-module---buttonWrapClosed---2GWGB src-components-tour-details-teasers----slideshowTeaser-module---buttonWrap---Vkry8","fadeIn":"src-components-tour-details-teasers----slideshowTeaser-module---fadeIn---2uMAF","fadeInUp":"src-components-tour-details-teasers----slideshowTeaser-module---fadeInUp---DYsep","fadeInUpCenter":"src-components-tour-details-teasers----slideshowTeaser-module---fadeInUpCenter---1nb8j","fadeInUpSmall":"src-components-tour-details-teasers----slideshowTeaser-module---fadeInUpSmall---1V0YT","textCoverIn":"src-components-tour-details-teasers----slideshowTeaser-module---textCoverIn---3wA8-","textCoverOut":"src-components-tour-details-teasers----slideshowTeaser-module---textCoverOut---2EzxC"};

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fadeIn":"src-components-tour-details-teasers----videoTeaser-module---fadeIn---1qN-v","fadeInUp":"src-components-tour-details-teasers----videoTeaser-module---fadeInUp---UoB5U","fadeInUpCenter":"src-components-tour-details-teasers----videoTeaser-module---fadeInUpCenter---23caI","fadeInUpSmall":"src-components-tour-details-teasers----videoTeaser-module---fadeInUpSmall----Y7bL","textCoverIn":"src-components-tour-details-teasers----videoTeaser-module---textCoverIn---2fLvi","textCoverOut":"src-components-tour-details-teasers----videoTeaser-module---textCoverOut---2Y7mJ"};

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-tour-details-views----Slideshow-module---container---33Vpf","header":"src-components-tour-details-views----Slideshow-module---header---2OcLk","headerBg":"src-components-tour-details-views----Slideshow-module---headerBg---2iORF","image":"src-components-tour-details-views----Slideshow-module---image---3lVzq","imagePortrait":"src-components-tour-details-views----Slideshow-module---imagePortrait---7lvKd src-components-tour-details-views----Slideshow-module---image---3lVzq","imageLandscape":"src-components-tour-details-views----Slideshow-module---imageLandscape---2uXrt src-components-tour-details-views----Slideshow-module---image---3lVzq","teaserContainer":"src-components-tour-details-views----Slideshow-module---teaserContainer---2WgZH","tourStopBodyContainer":"src-components-tour-details-views----Slideshow-module---tourStopBodyContainer---Y-fkL src-style----_utility---spaceSandwichl---1NtHV","backBar":"src-components-tour-details-views----Slideshow-module---backBar---G3K16","backBarClosed":"src-components-tour-details-views----Slideshow-module---backBarClosed---2_lHk src-components-tour-details-views----Slideshow-module---backBar---G3K16","backBarOpen":"src-components-tour-details-views----Slideshow-module---backBarOpen---1dAuT src-components-tour-details-views----Slideshow-module---backBar---G3K16","backTitle":"src-components-tour-details-views----Slideshow-module---backTitle---263Du","arrow":"src-components-tour-details-views----Slideshow-module---arrow---3Qj4T","fadeIn":"src-components-tour-details-views----Slideshow-module---fadeIn---XYr0m","fadeInUp":"src-components-tour-details-views----Slideshow-module---fadeInUp---3de81","fadeInUpCenter":"src-components-tour-details-views----Slideshow-module---fadeInUpCenter---31rSi","fadeInUpSmall":"src-components-tour-details-views----Slideshow-module---fadeInUpSmall---2-iLa","textCoverIn":"src-components-tour-details-views----Slideshow-module---textCoverIn---3V1AF","textCoverOut":"src-components-tour-details-views----Slideshow-module---textCoverOut---y-yc9"};

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dot":"src-components-tour-map----map-module---dot---2KQW_","shadow":"src-components-tour-map----map-module---shadow---3jrQW","innerCircle":"src-components-tour-map----map-module---innerCircle---2jRoF","outerCircle":"src-components-tour-map----map-module---outerCircle---1MCmi","removeLogo":"src-components-tour-map----map-module---removeLogo---1j8lW","gmnoprint":"src-components-tour-map----map-module---gmnoprint---C66TV","gm-style-cc":"src-components-tour-map----map-module---gm-style-cc---3Ucdu","mapContainer":"src-components-tour-map----map-module---mapContainer---5sCa_ src-components-tour-map----map-module---removeLogo---1j8lW","mapContainerHidden":"src-components-tour-map----map-module---mapContainerHidden---2gYmH src-components-tour-map----map-module---mapContainer---5sCa_ src-components-tour-map----map-module---removeLogo---1j8lW","focusButton":"src-components-tour-map----map-module---focusButton---18m_R","fadeIn":"src-components-tour-map----map-module---fadeIn---1pVHY","focusIconContainer":"src-components-tour-map----map-module---focusIconContainer---KyiJV","focusActive":"src-components-tour-map----map-module---focusActive---1qcJ-","fadeInUp":"src-components-tour-map----map-module---fadeInUp---3wbca","fadeInUpCenter":"src-components-tour-map----map-module---fadeInUpCenter---3_5Zg","fadeInUpSmall":"src-components-tour-map----map-module---fadeInUpSmall---3s3AG","textCoverIn":"src-components-tour-map----map-module---textCoverIn---3eP1Q","textCoverOut":"src-components-tour-map----map-module---textCoverOut---2O9wx"};

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pin":"src-components-tour-map----pin-module---pin---1ipRn","contentContainer":"src-components-tour-map----pin-module---contentContainer---1x_1H","iconContainer":"src-components-tour-map----pin-module---iconContainer---8oHEv","titleContainer":"src-components-tour-map----pin-module---titleContainer---1x1x_","title":"src-components-tour-map----pin-module---title---27mva","SMALL":"src-components-tour-map----pin-module---SMALL---gXKt1","UNVISITED":"src-components-tour-map----pin-module---UNVISITED---3Wwjz","VISITED":"src-components-tour-map----pin-module---VISITED---q8IsU","OPEN":"src-components-tour-map----pin-module---OPEN---2c9-A","fadeIn":"src-components-tour-map----pin-module---fadeIn---141ls","fadeInUp":"src-components-tour-map----pin-module---fadeInUp---2WnIo","fadeInUpCenter":"src-components-tour-map----pin-module---fadeInUpCenter---2ANOJ","fadeInUpSmall":"src-components-tour-map----pin-module---fadeInUpSmall---3AUA1","textCoverIn":"src-components-tour-map----pin-module---textCoverIn---1P-PA","textCoverOut":"src-components-tour-map----pin-module---textCoverOut---2hGjS"};

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"src-components-tour----onboarding-module---wrapper---19xOF","exit":"src-components-tour----onboarding-module---exit---36V-i","verticalCenter":"src-components-tour----onboarding-module---verticalCenter---1VmhR","beforeEnter":"src-components-tour----onboarding-module---beforeEnter---MyCu7","slickWrap":"src-components-tour----onboarding-module---slickWrap---u5xrO","text":"src-components-tour----onboarding-module---text---1lR8j","button":"src-components-tour----onboarding-module---button---21Wff","pinIcon":"src-components-tour----onboarding-module---pinIcon---2awpl","swipeIcon":"src-components-tour----onboarding-module---swipeIcon---3SmSp","fadeIn":"src-components-tour----onboarding-module---fadeIn---tXaNR","fadeInUp":"src-components-tour----onboarding-module---fadeInUp---10cq-","fadeInUpCenter":"src-components-tour----onboarding-module---fadeInUpCenter---2yUab","fadeInUpSmall":"src-components-tour----onboarding-module---fadeInUpSmall---2xiRe","textCoverIn":"src-components-tour----onboarding-module---textCoverIn---1HEmS","textCoverOut":"src-components-tour----onboarding-module---textCoverOut---yf2HI"};

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"locationHeaderHeight":"165px","riverContainer":"src-components-tour-river----river-module---riverContainer---W52kE","riverContainerInner":"src-components-tour-river----river-module---riverContainerInner---1opHn","teaserContainer":"src-components-tour-river----river-module---teaserContainer---3POWW","header":"src-components-tour-river----river-module---header---lWQDk","headerBg":"src-components-tour-river----river-module---headerBg---3nCjh","nextHeaderBg":"src-components-tour-river----river-module---nextHeaderBg---1oySX","headerBgImage":"src-components-tour-river----river-module---headerBgImage---suB1y","locationNameWrapper":"src-components-tour-river----river-module---locationNameWrapper---3FCz5 src-style----_utility---spaceInsetl---ZajFk","swipeCta":"src-components-tour-river----river-module---swipeCta---1eDeM","locationName":"src-components-tour-river----river-module---locationName---3McH7","titleScrim":"src-components-tour-river----river-module---titleScrim---TTR_8","tourStopBodyContainer":"src-components-tour-river----river-module---tourStopBodyContainer---1xXVL src-style----_utility---spaceSandwichl---1NtHV","fadeIn":"src-components-tour-river----river-module---fadeIn---M96zG","fadeInUp":"src-components-tour-river----river-module---fadeInUp---15bDa","fadeInUpCenter":"src-components-tour-river----river-module---fadeInUpCenter---ZGuih","fadeInUpSmall":"src-components-tour-river----river-module---fadeInUpSmall---3YZf1","textCoverIn":"src-components-tour-river----river-module---textCoverIn---3_WOg","textCoverOut":"src-components-tour-river----river-module---textCoverOut---2ts4H"};

/***/ }),
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"baseButton":"src-components-ui----OpenCloseButton-module---baseButton---PCA3f","button":"src-components-ui----OpenCloseButton-module---button---3pq08 src-components-ui----OpenCloseButton-module---baseButton---PCA3f","closeButton":"src-components-ui----OpenCloseButton-module---closeButton---1eO7z src-components-ui----OpenCloseButton-module---baseButton---PCA3f","cross":"src-components-ui----OpenCloseButton-module---cross---X7VOm","crossClicked":"src-components-ui----OpenCloseButton-module---crossClicked---2pprp src-components-ui----OpenCloseButton-module---cross---X7VOm","fadeIn":"src-components-ui----OpenCloseButton-module---fadeIn---RdozX","fadeInUp":"src-components-ui----OpenCloseButton-module---fadeInUp---KK_IY","fadeInUpCenter":"src-components-ui----OpenCloseButton-module---fadeInUpCenter---20dsG","fadeInUpSmall":"src-components-ui----OpenCloseButton-module---fadeInUpSmall---MxeO_","textCoverIn":"src-components-ui----OpenCloseButton-module---textCoverIn---2SQKK","textCoverOut":"src-components-ui----OpenCloseButton-module---textCoverOut---14kM4"};

/***/ }),
/* 866 */,
/* 867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"volumeWrapper":"src-components-ui----VolumeControls-module---volumeWrapper---1HYMl","volumeButton":"src-components-ui----VolumeControls-module---volumeButton---3LeiP","volumeBars":"src-components-ui----VolumeControls-module---volumeBars---3jOD6","volumeButtonHalf":"src-components-ui----VolumeControls-module---volumeButtonHalf---DNBDg","volumeButtonMuted":"src-components-ui----VolumeControls-module---volumeButtonMuted---3C3v6","volumeSlider":"src-components-ui----VolumeControls-module---volumeSlider---1cL9S","volume-bar":"src-components-ui----VolumeControls-module---volume-bar---tb8xN","volumeSliderOpen":"src-components-ui----VolumeControls-module---volumeSliderOpen---2XK5r","fadeIn":"src-components-ui----VolumeControls-module---fadeIn---2FT7b","fadeInUp":"src-components-ui----VolumeControls-module---fadeInUp---2q1yC","fadeInUpCenter":"src-components-ui----VolumeControls-module---fadeInUpCenter---3lmgL","fadeInUpSmall":"src-components-ui----VolumeControls-module---fadeInUpSmall---C1OFY","textCoverIn":"src-components-ui----VolumeControls-module---textCoverIn---2ZNCd","textCoverOut":"src-components-ui----VolumeControls-module---textCoverOut---3KZ6o"};

/***/ }),
/* 868 */,
/* 869 */,
/* 870 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mobileBreakPoint":"992px","fadeIn":"src-templates----Tour-module---fadeIn---1imZ0","fadeInUp":"src-templates----Tour-module---fadeInUp---3oqEF","fadeInUpCenter":"src-templates----Tour-module---fadeInUpCenter---11k0z","fadeInUpSmall":"src-templates----Tour-module---fadeInUpSmall---2rkNX","textCoverIn":"src-templates----Tour-module---textCoverIn---3iHzh","textCoverOut":"src-templates----Tour-module---textCoverOut---33vHc"};

/***/ }),
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 0.16.2
	 * DATE: 2018-02-15
	 * UPDATES AND DOCS AT: http://greensock.com
	 *
	 * Requires TweenLite and CSSPlugin version 1.17.0 or later (TweenMax contains both TweenLite and CSSPlugin). ThrowPropsPlugin is required for momentum-based continuation of movement after the mouse/touch is released (ThrowPropsPlugin is a membership benefit of Club GreenSock - http://greensock.com/club/).
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 *
	 * @author: Jack Doyle, jack@greensock.com
	 */
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("utils.Draggable", ["events.EventDispatcher","TweenLite","plugins.CSSPlugin"], function(EventDispatcher, TweenLite, CSSPlugin) {
	
			var _tempVarsXY = {css:{}, data:"_draggable"}, //speed optimization - we reuse the same vars object for x/y TweenLite.set() calls to minimize garbage collection tasks and improve performance.
				_tempVarsX = {css:{}, data:"_draggable"},
				_tempVarsY = {css:{}, data:"_draggable"},
				_tempVarsRotation = {css:{}},
				_globals = _gsScope._gsDefine.globals,
				_tempEvent = {}, //for populating with pageX/pageY in old versions of IE
				_dummyElement = {style:{}},
				_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
				_docElement = _doc.documentElement || {},
				_createElement = function(type) {
					return _doc.createElementNS ? _doc.createElementNS("http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_emptyArray = [],
				_emptyFunc = function() { return false; },
				_RAD2DEG = 180 / Math.PI,
				_max = 999999999999999,
				_getTime = Date.now || function() {return new Date().getTime();},
				_isOldIE = !!(!_doc.addEventListener && _doc.all),
				_placeholderDiv = _doc.createElement("div"),
				_renderQueue = [],
				_lookup = {}, //when a Draggable is created, the target gets a unique _gsDragID property that allows gets associated with the Draggable instance for quick lookups in Draggable.get(). This avoids circular references that could cause gc problems.
				_lookupCount = 0,
				_clickableTagExp = /^(?:a|input|textarea|button|select)$/i,
				_dragCount = 0, //total number of elements currently being dragged
				_prefix,
				_isMultiTouching,
				_isAndroid = (_gsScope.navigator && _gsScope.navigator.userAgent.toLowerCase().indexOf("android") !== -1), //Android handles touch events in an odd way and it's virtually impossible to "feature test" so we resort to UA sniffing
				_lastDragTime = 0,
				_temp1 = {}, // a simple object we reuse and populate (usually x/y properties) to conserve memory and improve performance.
				_windowProxy = {}, //memory/performance optimization - we reuse this object during autoScroll to store window-related bounds/offsets.
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					if (typeof(a) === "string") {
						a = TweenLite.selector(a);
					}
					if (!a || a.nodeType) { //if it's not an array, wrap it in one.
						return [a];
					}
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_copy = function(obj, factor) {
					var copy = {}, p;
					if (factor) {
						for (p in obj) {
							copy[p] = obj[p] * factor;
						}
					} else {
						for (p in obj) {
							copy[p] = obj[p];
						}
					}
					return copy;
				},
				ThrowPropsPlugin,
	
				_renderQueueTick = function() {
					var i = _renderQueue.length;
					while (--i > -1) {
						_renderQueue[i]();
					}
				},
				_addToRenderQueue = function(func) {
					_renderQueue.push(func);
					if (_renderQueue.length === 1) {
						TweenLite.ticker.addEventListener("tick", _renderQueueTick, this, false, 1);
					}
				},
				_removeFromRenderQueue = function(func) {
					var i = _renderQueue.length;
					while (--i > -1) {
						if (_renderQueue[i] === func) {
							_renderQueue.splice(i, 1);
						}
					}
					TweenLite.to(_renderQueueTimeout, 0, {overwrite:"all", delay:15, onComplete:_renderQueueTimeout, data:"_draggable"}); //remove the "tick" listener only after the render queue is empty for 15 seconds (to improve performance). Adding/removing it constantly for every click/touch wouldn't deliver optimal speed, and we also don't want the ticker to keep calling the render method when things are idle for long periods of time (we want to improve battery life on mobile devices).
				},
				_renderQueueTimeout = function() {
					if (!_renderQueue.length) {
						TweenLite.ticker.removeEventListener("tick", _renderQueueTick);
					}
				},
	
				_extend = function(obj, defaults) {
					var p;
					for (p in defaults) {
						if (obj[p] === undefined) {
							obj[p] = defaults[p];
						}
					}
					return obj;
				},
				_getDocScrollTop = function() {
					return (window.pageYOffset != null) ? window.pageYOffset : (_doc.scrollTop != null) ? _doc.scrollTop : _docElement.scrollTop || _doc.body.scrollTop || 0;
				},
				_getDocScrollLeft = function() {
					return (window.pageXOffset != null) ? window.pageXOffset : (_doc.scrollLeft != null) ? _doc.scrollLeft : _docElement.scrollLeft || _doc.body.scrollLeft || 0;
				},
				_addScrollListener = function(e, callback) {
					_addListener(e, "scroll", callback);
					if (!_isRoot(e.parentNode)) {
						_addScrollListener(e.parentNode, callback);
					}
				},
				_removeScrollListener = function(e, callback) {
					_removeListener(e, "scroll", callback);
					if (!_isRoot(e.parentNode)) {
						_removeScrollListener(e.parentNode, callback);
					}
				},
				_isRoot = function (e) {
					return !!(!e || e === _docElement || e === _doc || e === _doc.body || e === window || !e.nodeType || !e.parentNode);
				},
				_getMaxScroll = function(element, axis) {
					var dim = (axis === "x") ? "Width" : "Height",
						scroll = "scroll" + dim,
						client = "client" + dim,
						body = _doc.body;
					return Math.max(0, _isRoot(element) ? Math.max(_docElement[scroll], body[scroll]) - (window["inner" + dim] || _docElement[client] || body[client]) : element[scroll] - element[client]);
				},
				_recordMaxScrolls = function(e) { //records _gsMaxScrollX and _gsMaxScrollY properties for the element and all ancestors up the chain so that we can cap it, otherwise dragging beyond the edges with autoScroll on can endlessly scroll.
					var isRoot = _isRoot(e),
						x = _getMaxScroll(e, "x"),
						y = _getMaxScroll(e, "y");
					if (isRoot) {
						e = _windowProxy;
					} else {
						_recordMaxScrolls(e.parentNode);
					}
					e._gsMaxScrollX = x;
					e._gsMaxScrollY = y;
					e._gsScrollX = e.scrollLeft || 0;
					e._gsScrollY = e.scrollTop || 0;
				},
	
				//just used for IE8 and earlier to normalize events and populate pageX/pageY
				_populateIEEvent = function(e, preventDefault) {
					e = e || window.event;
					_tempEvent.pageX = e.clientX + _doc.body.scrollLeft + _docElement.scrollLeft;
					_tempEvent.pageY = e.clientY + _doc.body.scrollTop + _docElement.scrollTop;
					if (preventDefault) {
						e.returnValue = false;
					}
					return _tempEvent;
				},
	
				//grabs the first element it finds (and we include the window as an element), so if it's selector text, it'll feed that value to TweenLite.selector, if it's a jQuery object or some other selector engine's result, it'll grab the first one, and same for an array. If the value doesn't contain a DOM element, it'll just return null.
				_unwrapElement = function(value) {
					if (!value) {
						return value;
					}
					if (typeof(value) === "string") {
						value = TweenLite.selector(value);
					}
					if (value.length && value !== window && value[0] && value[0].style && !value.nodeType) {
						value = value[0];
					}
					return (value === window || (value.nodeType && value.style)) ? value : null;
				},
	
				_checkPrefix = function(e, p) {
					var s = e.style,
						capped, i, a;
					if (s[p] === undefined) {
						a = ["O","Moz","ms","Ms","Webkit"];
						i = 5;
						capped = p.charAt(0).toUpperCase() + p.substr(1);
						while (--i > -1 && s[a[i]+capped] === undefined) { }
						if (i < 0) {
							return "";
						}
						_prefix = (i === 3) ? "ms" : a[i];
						p = _prefix + capped;
					}
					return p;
				},
	
				_setStyle = function(e, p, value) {
					var s = e.style;
					if (!s) {
						return;
					}
					if (s[p] === undefined) {
						p = _checkPrefix(e, p);
					}
					if (value == null) {
						if (s.removeProperty) {
							s.removeProperty(p.replace(/([A-Z])/g, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					} else if (s[p] !== undefined) {
						s[p] = value;
					}
				},
	
				_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : _emptyFunc,
				_horizExp = /(?:Left|Right|Width)/i,
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || !sfx) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						pix;
					if (neg) {
						v = -v;
					}
					if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position", true) + ";line-height:0;";
						if (sfx === "%" || !node.appendChild) {
							node = t.parentNode || _doc.body;
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = function(t, p) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", true) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, true);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), (v + "").replace(_suffixExp, "")) || 0);
				},
	
				_getStyle = function(element, prop, keepUnits) {
					var rv = (element._gsTransform || {})[prop],
						cs;
					if (rv || rv === 0) {
						return rv;
					} else if (element.style[prop]) {
						rv = element.style[prop];
					} else if ((cs = _getComputedStyle(element))) {
						rv = cs.getPropertyValue(prop.replace(/([A-Z])/g, "-$1").toLowerCase());
						rv = (rv || cs.length) ? rv : cs[prop]; //Opera behaves VERY strangely - length is usually 0 and cs[prop] is the only way to get accurate results EXCEPT when checking for -o-transform which only works with cs.getPropertyValue()!
					} else if (element.currentStyle) {
						rv = element.currentStyle[prop];
					}
					if (rv === "auto" && (prop === "top" || prop === "left")) {
						rv = _calculateOffset(element, prop);
					}
					return keepUnits ? rv : parseFloat(rv) || 0;
				},
	
				_dispatchEvent = function(instance, type, callbackName) {
					var vars = instance.vars,
						callback = vars[callbackName],
						listeners = instance._listeners[type];
					if (typeof(callback) === "function") {
						callback.apply(vars[callbackName + "Scope"] || vars.callbackScope || instance, vars[callbackName + "Params"] || [instance.pointerEvent]);
					}
					if (listeners) {
						instance.dispatchEvent(type);
					}
				},
				_getBounds = function(obj, context) { //accepts any of the following: a DOM element, jQuery object, selector text, or an object defining bounds as {top, left, width, height} or {minX, maxX, minY, maxY}. Returns an object with left, top, width, and height properties.
					var e = _unwrapElement(obj),
						top, left, offset;
					if (!e) {
						if (obj.left !== undefined) {
							offset = _getOffsetTransformOrigin(context); //the bounds should be relative to the origin
							return {left: obj.left - offset.x, top: obj.top - offset.y, width: obj.width, height: obj.height};
						}
						left = obj.min || obj.minX || obj.minRotation || 0;
						top = obj.min || obj.minY || 0;
						return {left:left, top:top, width:(obj.max || obj.maxX || obj.maxRotation || 0) - left, height:(obj.max || obj.maxY || 0) - top};
					}
					return _getElementBounds(e, context);
				},
	
				_svgBorderFactor,
				_svgBorderScales,
				_svgScrollOffset,
				_hasBorderBug,
				_hasReparentBug,//some browsers, like Chrome 49, alter the offsetTop/offsetLeft/offsetParent of elements when a non-identity transform is applied.
				_setEnvironmentVariables = function() { //some browsers factor the border into the SVG coordinate space, some don't (like Firefox). Some apply transforms to them, some don't. We feature-detect here so we know how to handle the border(s). We can't do this immediately - we must wait for the document.body to exist.
					if (!_doc.createElementNS) {
						_svgBorderFactor = 0;
						_svgBorderScales = false;
						return;
					}
					var div = _createElement("div"),
						svg = _doc.createElementNS("http://www.w3.org/2000/svg", "svg"),
						wrapper = _createElement("div"),
						style = div.style,
						parent = _doc.body || _docElement,
						isFlex = (_getStyle(parent, "display", true) === "flex"), //Firefox bug causes getScreenCTM() to return null when parent is display:flex and the element isn't rendered inside the window (like if it's below the scroll position)
						matrix, e1, point, oldValue;
					if (_doc.body && _transformProp) {
						style.position = "absolute";
						parent.appendChild(wrapper);
						wrapper.appendChild(div);
						oldValue = div.offsetParent;
						wrapper.style[_transformProp] = "rotate(1deg)";
						_hasReparentBug = (div.offsetParent === oldValue);
						wrapper.style.position = "absolute";
						style.height = "10px";
						oldValue = div.offsetTop;
						wrapper.style.border = "5px solid red";
						_hasBorderBug = (oldValue !== div.offsetTop); //some browsers, like Firefox 38, cause the offsetTop/Left to be affected by a parent's border.
						parent.removeChild(wrapper);
					}
					style = svg.style;
					svg.setAttributeNS(null, "width", "400px");
					svg.setAttributeNS(null, "height", "400px");
					svg.setAttributeNS(null, "viewBox", "0 0 400 400");
					style.display = "block";
					style.boxSizing = "border-box";
					style.border = "0px solid red";
					style.transform = "none";
					// in some browsers (like certain flavors of Android), the getScreenCTM() matrix is contaminated by the scroll position. We can run some logic here to detect that condition, but we ended up not needing this because we found another workaround using getBoundingClientRect().
					div.style.cssText = "width:100px;height:100px;overflow:scroll;-ms-overflow-style:none;";
					parent.appendChild(div);
					div.appendChild(svg);
					point = svg.createSVGPoint().matrixTransform(svg.getScreenCTM());
					e1 = point.y;
					div.scrollTop = 100;
					point.x = point.y = 0;
					point = point.matrixTransform(svg.getScreenCTM());
					_svgScrollOffset = (e1 - point.y < 100.1) ? 0 : e1 - point.y - 150;
					div.removeChild(svg);
					parent.removeChild(div);
					// -- end _svgScrollOffset calculation.
					parent.appendChild(svg);
					if (isFlex) {
						parent.style.display = "block"; //Firefox bug causes getScreenCTM() to return null when parent is display:flex and the element isn't rendered inside the window (like if it's below the scroll position)
					}
					matrix = svg.getScreenCTM();
					e1 = matrix.e;
					style.border = "50px solid red";
					matrix = svg.getScreenCTM();
					if (e1 === 0 && matrix.e === 0 && matrix.f === 0 && matrix.a === 1) { //Opera has a bunch of bugs - it doesn't adjust the x/y of the matrix, nor does it scale when box-sizing is border-box but it does so elsewhere; to get the correct behavior we set _svgBorderScales to true.
						_svgBorderFactor = 1;
						_svgBorderScales = true;
					} else {
						_svgBorderFactor = (e1 !== matrix.e) ? 1 : 0;
						_svgBorderScales = (matrix.a !== 1);
					}
					if (isFlex) {
						parent.style.display = "flex";
					}
					parent.removeChild(svg);
				},
	
				_supports3D = (_checkPrefix(_tempDiv, "perspective") !== ""),
	
				// start matrix and point conversion methods...
				_transformOriginProp = _checkPrefix(_tempDiv, "transformOrigin").replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
				_transformProp = _checkPrefix(_tempDiv, "transform"),
				_transformPropCSS = _transformProp.replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
				_point1 = {}, //we reuse _point1 and _point2 objects inside matrix and point conversion methods to conserve memory and minimize garbage collection tasks.
				_point2 = {},
				_SVGElement = _gsScope.SVGElement,
				_isSVG = function(e) {
					return !!(_SVGElement && typeof(e.getBBox) === "function" && e.getCTM && (!e.parentNode || (e.parentNode.getBBox && e.parentNode.getCTM)));
				},
				_isIE10orBelow = (((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(navigator.userAgent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(navigator.userAgent)) && parseFloat( RegExp.$1 ) < 11), //Ideally we'd avoid user agent sniffing, but there doesn't seem to be a way to feature-detect and sense a border-related bug that only affects IE10 and IE9.
				_tempTransforms = [],
				_tempElements = [],
				_getSVGOffsets = function(e) { //SVG elements don't always report offsetTop/offsetLeft/offsetParent at all (I'm looking at you, Firefox 29 and Android), so we have to do some work to manufacture those values. You can pass any SVG element and it'll spit back an object with offsetTop, offsetLeft, offsetParent, scaleX, and scaleY properties. We need the scaleX and scaleY to handle the way SVG can resize itself based on the container.
					if (!e.getBoundingClientRect || !e.parentNode || !_transformProp) {
						return {offsetTop:0, offsetLeft:0, scaleX:1, scaleY:1, offsetParent:_docElement};
					}
					if (Draggable.cacheSVGData !== false && e._dCache && e._dCache.lastUpdate === TweenLite.ticker.frame) { //performance optimization. Assume that if the offsets are requested again on the same tick, we can just feed back the values we already calculated (no need to keep recalculating until another tick elapses).
						return e._dCache;
					}
					var curElement = e,
						cache = _cache(e),
						eRect, parentRect, offsetParent, cs, m, i, point1, point2, borderWidth, borderHeight, width, height;
					cache.lastUpdate = TweenLite.ticker.frame;
					if (e.getBBox && !cache.isSVGRoot) { //if it's a nested/child SVG element, we must find the parent SVG canvas and measure the offset from there.
						curElement = e.parentNode;
						eRect = e.getBBox();
						while (curElement && (curElement.nodeName + "").toLowerCase() !== "svg") {
							curElement = curElement.parentNode;
						}
						cs = _getSVGOffsets(curElement);
						cache.offsetTop = eRect.y * cs.scaleY;
						cache.offsetLeft = eRect.x * cs.scaleX;
						cache.scaleX = cs.scaleX;
						cache.scaleY = cs.scaleY;
						cache.offsetParent = curElement || _docElement;
						return cache;
					}
					//only root SVG elements continue here...
					offsetParent = cache.offsetParent;
					if (offsetParent === _doc.body) {
						offsetParent = _docElement; //avoids problems with margins/padding on the body
					}
					//walk up the ancestors and record any non-identity transforms (and reset them to "none") until we reach the offsetParent. We must do this so that the getBoundingClientRect() is accurate for measuring the offsetTop/offsetLeft. We'll revert the values later...
					_tempElements.length = _tempTransforms.length = 0;
					while (curElement) {
						m = _getStyle(curElement, _transformProp, true);
						if (m !== "matrix(1, 0, 0, 1, 0, 0)" && m !== "none" && m !== "translate3d(0px, 0px, 0px)") {
							_tempElements.push(curElement);
							_tempTransforms.push(curElement.style[_transformProp]);
							curElement.style[_transformProp] = "none";
						}
						if (curElement === offsetParent) {
							break;
						}
						curElement = curElement.parentNode;
					}
					parentRect = offsetParent.getBoundingClientRect();
					m = e.getScreenCTM();
					point2 = e.createSVGPoint();
					point1 = point2.matrixTransform(m);
					point2.x = point2.y = 10;
					point2 = point2.matrixTransform(m);
					cache.scaleX = (point2.x - point1.x) / 10;
					cache.scaleY = (point2.y - point1.y) / 10;
					if (_svgBorderFactor === undefined) {
						_setEnvironmentVariables();
					}
					if (cache.borderBox && !_svgBorderScales && e.getAttribute("width")) { //some browsers (like Safari) don't properly scale the matrix to accommodate the border when box-sizing is border-box, so we must calculate it here...
						cs = _getComputedStyle(e) || {};
						borderWidth = (parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth)) || 0;
						borderHeight = (parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth)) || 0;
						width = parseFloat(cs.width) || 0;
						height = parseFloat(cs.height) || 0;
						cache.scaleX *= (width - borderWidth) / width;
						cache.scaleY *= (height - borderHeight) / height;
					}
					if (_svgScrollOffset) { //some browsers (like Chrome for Android) have bugs in the way getScreenCTM() is reported (it doesn't factor in scroll position), so we must revert to a more expensive technique for calculating offsetTop/Left.
						eRect = e.getBoundingClientRect();
						cache.offsetLeft = eRect.left - parentRect.left;
						cache.offsetTop = eRect.top - parentRect.top;
					} else {
						cache.offsetLeft = point1.x - parentRect.left;
						cache.offsetTop = point1.y - parentRect.top;
					}
					cache.offsetParent = offsetParent;
					i = _tempElements.length;
					while (--i > -1) {
						_tempElements[i].style[_transformProp] = _tempTransforms[i];
					}
					return cache;
				},
				_getOffsetTransformOrigin = function(e, decoratee) { //returns the x/y position of the transformOrigin of the element, in its own local coordinate system (pixels), offset from the top left corner.
					decoratee = decoratee || {};
					if (!e || e === _docElement || !e.parentNode || e === window) {
						return {x:0, y:0};
					}
					var cs = _getComputedStyle(e),
						v = (_transformOriginProp && cs) ? cs.getPropertyValue(_transformOriginProp) : "50% 50%",
						a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1];
					if (y === "center" || y == null) {
						y = "50%";
					}
					if (x === "center" || isNaN(parseFloat(x))) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					if (e.getBBox && _isSVG(e)) { //SVG elements must be handled in a special way because their origins are calculated from the top left.
						if (!e._gsTransform) {
							TweenLite.set(e, {x:"+=0", overwrite:false}); //forces creation of the _gsTransform where we store all the transform components including xOrigin and yOrigin for SVG elements, as of GSAP 1.15.0 which also takes care of calculating the origin from the upper left corner of the SVG canvas.
							if (e._gsTransform.xOrigin === undefined) {
								console.log("Draggable requires at least GSAP 1.17.0");
							}
						}
						v = e.getBBox();
						decoratee.x = (e._gsTransform.xOrigin - v.x);
						decoratee.y = (e._gsTransform.yOrigin - v.y);
					} else {
						if (e.getBBox && (x + y).indexOf("%") !== -1) { //Firefox doesn't report offsetWidth/height on <svg> elements.
							e = e.getBBox();
							e = {offsetWidth: e.width, offsetHeight: e.height};
						}
						decoratee.x = ((x.indexOf("%") !== -1) ? e.offsetWidth * parseFloat(x) / 100 : parseFloat(x));
						decoratee.y = ((y.indexOf("%") !== -1) ? e.offsetHeight * parseFloat(y) / 100 : parseFloat(y));
					}
					return decoratee;
				},
				_cache = function(e) { //computes some important values and stores them in a _dCache object attached to the element itself so that we can optimize performance
					if (Draggable.cacheSVGData !== false && e._dCache && e._dCache.lastUpdate === TweenLite.ticker.frame) { //performance optimization. Assume that if the offsets are requested again on the same tick, we can just feed back the values we already calculated (no need to keep recalculating until another tick elapses).
						return e._dCache;
					}
					var cache = e._dCache = e._dCache || {},
						cs = _getComputedStyle(e),
						isSVG = (e.getBBox && _isSVG(e)),
						isSVGRoot = ((e.nodeName + "").toLowerCase() === "svg"),
						curSVG;
					cache.isSVG = isSVG;
					cache.isSVGRoot = isSVGRoot;
					cache.borderBox = (cs.boxSizing === "border-box");
					cache.computedStyle = cs;
					if (isSVGRoot) { //some browsers don't report parentNode on SVG elements.
						curSVG = e.parentNode || _docElement;
						curSVG.insertBefore(_tempDiv, e);
						cache.offsetParent = _tempDiv.offsetParent || _docElement; //in some cases, Firefox still reports offsetParent as null.
						curSVG.removeChild(_tempDiv);
					} else if (isSVG) {
						curSVG = e.parentNode;
						while (curSVG && (curSVG.nodeName + "").toLowerCase() !== "svg") { //offsetParent is always the SVG canvas for SVG elements.
							curSVG = curSVG.parentNode;
						}
						cache.offsetParent = curSVG;
					} else {
						cache.offsetParent = e.offsetParent;
					}
					return cache;
				},
				_getOffset2DMatrix = function(e, offsetOrigin, parentOffsetOrigin, zeroOrigin, isBase) {  //"isBase" helps us discern context - it should only be true when the element is the base one (the one at which we're starting to walk up the chain). It only matters in cases when it's an <svg> element itself because that's a case when we don't apply scaling.
					if (e === window || !e || !e.style || !e.parentNode) {
						return [1,0,0,1,0,0];
					}
					var cache = e._dCache || _cache(e),
						parent = e.parentNode,
						parentCache = parent._dCache || _cache(parent),
						cs = cache.computedStyle,
						parentOffsetParent = cache.isSVG ? parentCache.offsetParent : parent.offsetParent,
						m, isRoot, offsets, rect, t, sx, sy, offsetX, offsetY, parentRect, borderTop, borderLeft, borderTranslateX, borderTranslateY;
					m = (cache.isSVG && (e.style[_transformProp] + "").indexOf("matrix") !== -1) ? e.style[_transformProp] : cs ? cs.getPropertyValue(_transformPropCSS) : e.currentStyle ? e.currentStyle[_transformProp] : "1,0,0,1,0,0"; //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
					if (e.getBBox && (e.getAttribute("transform") + "").indexOf("matrix") !== -1) { //SVG can store transform data in its "transform" attribute instead of the CSS, so look for that here (only accept matrix()).
						m = e.getAttribute("transform");
					}
					m = (m + "").match(/(?:\-|\.|\b)(\d|\.|e\-)+/g) || [1,0,0,1,0,0];
					if (m.length > 6) {
						m = [m[0], m[1], m[4], m[5], m[12], m[13]];
					}
					if (zeroOrigin) {
						m[4] = m[5] = 0;
					} else if (cache.isSVG && (t = e._gsTransform) && (t.xOrigin || t.yOrigin)) {
						//SVGs handle origin very differently. Factor in GSAP's handling of origin values here:
						m[0] = parseFloat(m[0]);
						m[1] = parseFloat(m[1]);
						m[2] = parseFloat(m[2]);
						m[3] = parseFloat(m[3]);
						m[4] = parseFloat(m[4]) - (t.xOrigin - (t.xOrigin * m[0] + t.yOrigin * m[2]));
						m[5] = parseFloat(m[5]) - (t.yOrigin - (t.xOrigin * m[1] + t.yOrigin * m[3]));
					}
					if (offsetOrigin) {
						if (_svgBorderFactor === undefined) {
							_setEnvironmentVariables();
						}
						offsets = (cache.isSVG || cache.isSVGRoot) ? _getSVGOffsets(e) : e;
						if (cache.isSVG) { //don't just rely on "instanceof _SVGElement" because if the SVG is embedded via an object tag, it won't work (SVGElement is mapped to a different object))
							rect = e.getBBox();
							parentRect = (parentCache.isSVGRoot) ? {x:0, y:0} : parent.getBBox();
							offsets = {offsetLeft:rect.x - parentRect.x, offsetTop:rect.y - parentRect.y, offsetParent:cache.offsetParent};
						} else if (cache.isSVGRoot) {
							borderTop = parseInt(cs.borderTopWidth, 10) || 0;
							borderLeft = parseInt(cs.borderLeftWidth, 10) || 0;
							borderTranslateX = ((m[0] - _svgBorderFactor) * borderLeft + m[2] * borderTop);
							borderTranslateY = (m[1] * borderLeft + (m[3] - _svgBorderFactor) * borderTop);
	
							sx = offsetOrigin.x;
							sy = offsetOrigin.y;
							offsetX = (sx - (sx * m[0] + sy * m[2])); //accommodate the SVG root's transforms when the origin isn't in the top left.
							offsetY = (sy - (sx * m[1] + sy * m[3]));
	
							m[4] = parseFloat(m[4]) + offsetX;
							m[5] = parseFloat(m[5]) + offsetY;
							offsetOrigin.x -= offsetX;
							offsetOrigin.y -= offsetY;
							sx = offsets.scaleX;
							sy = offsets.scaleY;
							if (!isBase) { //when getting the matrix for a root <svg> element itself (NOT in the context of an SVG element that's nested inside of it like a <path>), we do NOT apply the scaling!
								offsetOrigin.x *= sx;
								offsetOrigin.y *= sy;
							}
							m[0] *= sx;
							m[1] *= sy;
							m[2] *= sx;
							m[3] *= sy;
							if (!_isIE10orBelow) {
								offsetOrigin.x += borderTranslateX;
								offsetOrigin.y += borderTranslateY;
							}
							if (parentOffsetParent === _doc.body && offsets.offsetParent === _docElement) { //to avoid issues with margin/padding on the <body>, we always set the offsetParent to _docElement in the _getSVGOffsets() function but there's a condition we check later in this function for (parentOffsetParent === offsets.offsetParent) which would fail if we don't run this logic. In other words, parentOffsetParent may be <body> and the <svg>'s offsetParent is also <body> but artificially set to _docElement to avoid margin/padding issues.
								parentOffsetParent = _docElement;
							}
						} else if (!_hasBorderBug && e.offsetParent) {
							offsetOrigin.x += parseInt(_getStyle(e.offsetParent, "borderLeftWidth"), 10) || 0;
							offsetOrigin.y += parseInt(_getStyle(e.offsetParent, "borderTopWidth"), 10) || 0;
						}
						isRoot = (parent === _docElement || parent === _doc.body);
						m[4] = Number(m[4]) + offsetOrigin.x + (offsets.offsetLeft || 0) - parentOffsetOrigin.x - (isRoot ? 0 : parent.scrollLeft || 0);
						m[5] = Number(m[5]) + offsetOrigin.y + (offsets.offsetTop || 0) - parentOffsetOrigin.y - (isRoot ? 0 : parent.scrollTop || 0);
						if (parent && _getStyle(e, "position", cs) === "fixed") { //fixed position elements should factor in the scroll position of the document.
							m[4] += _getDocScrollLeft();
							m[5] += _getDocScrollTop();
						}
						if (parent && parent !== _docElement && parentOffsetParent === offsets.offsetParent && !parentCache.isSVG && (!_hasReparentBug || _getOffset2DMatrix(parent).join("") === "100100")) {
							offsets = (parentCache.isSVGRoot) ? _getSVGOffsets(parent) : parent;
							m[4] -= offsets.offsetLeft || 0;
							m[5] -= offsets.offsetTop || 0;
							if (!_hasBorderBug && parentCache.offsetParent && !cache.isSVG && !cache.isSVGRoot) {
								m[4] -= parseInt(_getStyle(parentCache.offsetParent, "borderLeftWidth"), 10) || 0;
								m[5] -= parseInt(_getStyle(parentCache.offsetParent, "borderTopWidth"), 10) || 0;
							}
						}
					}
					return m;
				},
				_getConcatenatedMatrix = function(e, invert) {
					if (!e || e === window || !e.parentNode) {
						return [1,0,0,1,0,0];
					}
					//note: we keep reusing _point1 and _point2 in order to minimize memory usage and garbage collection chores.
					var originOffset = _getOffsetTransformOrigin(e, _point1),
						parentOriginOffset = _getOffsetTransformOrigin(e.parentNode, _point2),
						m = _getOffset2DMatrix(e, originOffset, parentOriginOffset, false, !invert),
						a, b, c, d, tx, ty, m2, determinant;
					while ((e = e.parentNode) && e.parentNode && e !== _docElement) {
						originOffset = parentOriginOffset;
						parentOriginOffset = _getOffsetTransformOrigin(e.parentNode, (originOffset === _point1) ? _point2 : _point1);
						m2 = _getOffset2DMatrix(e, originOffset, parentOriginOffset);
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						m[0] = a * m2[0] + b * m2[2];
						m[1] = a * m2[1] + b * m2[3];
						m[2] = c * m2[0] + d * m2[2];
						m[3] = c * m2[1] + d * m2[3];
						m[4] = tx * m2[0] + ty * m2[2] + m2[4];
						m[5] = tx * m2[1] + ty * m2[3] + m2[5];
					}
					if (invert) {
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						m[0] = d / determinant;
						m[1] = -b / determinant;
						m[2] = -c / determinant;
						m[3] = a / determinant;
						m[4] = (c * ty - d * tx) / determinant;
						m[5] = -(a * ty - b * tx) / determinant;
					}
					return m;
				},
				_localToGlobal = function(e, p, fromTopLeft, decoratee, zeroOrigin) {
					e = _unwrapElement(e);
					var m = _getConcatenatedMatrix(e, false, zeroOrigin),
						x = p.x,
						y = p.y;
					if (fromTopLeft) {
						_getOffsetTransformOrigin(e, p);
						x -= p.x;
						y -= p.y;
					}
					decoratee = (decoratee === true) ? p : decoratee || {};
					decoratee.x = x * m[0] + y * m[2] + m[4];
					decoratee.y = x * m[1] + y * m[3] + m[5];
					return decoratee;
				},
				_localizePoint = function(p, localToGlobal, globalToLocal) {
					var x = p.x * localToGlobal[0] + p.y * localToGlobal[2] + localToGlobal[4],
						y = p.x * localToGlobal[1] + p.y * localToGlobal[3] + localToGlobal[5];
					p.x = x * globalToLocal[0] + y * globalToLocal[2] + globalToLocal[4];
					p.y = x * globalToLocal[1] + y * globalToLocal[3] + globalToLocal[5];
					return p;
				},
	
				_getElementBounds = function(e, context, fromTopLeft) {
					if (!(e = _unwrapElement(e))) {
						return null;
					}
					context = _unwrapElement(context);
					var isSVG = (e.getBBox && _isSVG(e)),
						origin, left, right, top, bottom, mLocalToGlobal, mGlobalToLocal, p1, p2, p3, p4, bbox, width, height, cache, borderLeft, borderTop, viewBox, viewBoxX, viewBoxY, computedDimensions, cs;
					if (e === window) {
						top = _getDocScrollTop();
						left = _getDocScrollLeft();
						right = left + (_docElement.clientWidth || e.innerWidth || _doc.body.clientWidth || 0);
						bottom = top + (((e.innerHeight || 0) - 20 < _docElement.clientHeight) ? _docElement.clientHeight : e.innerHeight || _doc.body.clientHeight || 0); //some browsers (like Firefox) ignore absolutely positioned elements, and collapse the height of the documentElement, so it could be 8px, for example, if you have just an absolutely positioned div. In that case, we use the innerHeight to resolve this.
					} else if (context === undefined || context === window) {
						return e.getBoundingClientRect();
					} else {
						origin = _getOffsetTransformOrigin(e);
						left = -origin.x;
						top = -origin.y;
						if (isSVG) {
							bbox = e.getBBox();
							width = bbox.width;
							height = bbox.height;
						} else if ((e.nodeName + "").toLowerCase() !== "svg" && e.offsetWidth) { //Chrome dropped support for "offsetWidth" on SVG elements
							width = e.offsetWidth;
							height = e.offsetHeight;
						} else {
							computedDimensions = _getComputedStyle(e);
							width = parseFloat(computedDimensions.width);
							height = parseFloat(computedDimensions.height);
						}
						right = left + width;
						bottom = top + height;
						if (e.nodeName.toLowerCase() === "svg" && !_isOldIE) { //root SVG elements are a special beast because they have 2 types of scaling - transforms on themselves as well as the stretching of the SVG canvas itself based on the outer size and the viewBox. If, for example, the SVG's viewbox is "0 0 100 100" but the CSS is set to width:200px; height:200px, that'd make it appear at 2x scale even though the element itself has no CSS transforms but the offsetWidth/offsetHeight are based on that css, not the viewBox so we need to adjust them accordingly.
							cache = _getSVGOffsets(e);
							cs = cache.computedStyle || {};
							viewBox = (e.getAttribute("viewBox") || "0 0").split(" ");
							viewBoxX = parseFloat(viewBox[0]);
							viewBoxY = parseFloat(viewBox[1]);
							borderLeft = parseFloat(cs.borderLeftWidth) || 0;
							borderTop = parseFloat(cs.borderTopWidth) || 0;
							right -= width - ((width - borderLeft) / cache.scaleX) - viewBoxX;
							bottom -= height - ((height - borderTop) / cache.scaleY) - viewBoxY;
							left -= borderLeft / cache.scaleX - viewBoxX;
							top -= borderTop / cache.scaleY - viewBoxY;
							if (computedDimensions) { //when we had to use computed styles, factor in the border now.
								right += (parseFloat(cs.borderRightWidth) + borderLeft) / cache.scaleX;
								bottom += (borderTop + parseFloat(cs.borderBottomWidth)) / cache.scaleY;
							}
						}
					}
					if (e === context) {
						return {left:left, top:top, width: right - left, height: bottom - top};
					}
					mLocalToGlobal = _getConcatenatedMatrix(e);
					mGlobalToLocal = _getConcatenatedMatrix(context, true);
					p1 = _localizePoint({x:left, y:top}, mLocalToGlobal, mGlobalToLocal);
					p2 = _localizePoint({x:right, y:top}, mLocalToGlobal, mGlobalToLocal);
					p3 = _localizePoint({x:right, y:bottom}, mLocalToGlobal, mGlobalToLocal);
					p4 = _localizePoint({x:left, y:bottom}, mLocalToGlobal, mGlobalToLocal);
					left = Math.min(p1.x, p2.x, p3.x, p4.x);
					top = Math.min(p1.y, p2.y, p3.y, p4.y);
					_temp1.x = _temp1.y = 0;
					if (fromTopLeft) {
						_getOffsetTransformOrigin(context, _temp1);
					}
					return {left:left + _temp1.x, top:top + _temp1.y, width:Math.max(p1.x, p2.x, p3.x, p4.x) - left, height:Math.max(p1.y, p2.y, p3.y, p4.y) - top};
				},
				// end matrix and point conversion methods
	
	
	
				_isArrayLike = function(e) {
					return (e && e.length && e[0] && ((e[0].nodeType && e[0].style && !e.nodeType) || (e[0].length && e[0][0]))) ? true : false; //could be an array of jQuery objects too, so accommodate that.
				},
	
				_flattenArray = function(a) {
					var result = [],
						l = a.length,
						i, e, j;
					for (i = 0; i < l; i++) {
						e = a[i];
						if (_isArrayLike(e)) {
							j = e.length;
							for (j = 0; j < e.length; j++) {
								result.push(e[j]);
							}
						} else if (e && e.length !== 0) {
							result.push(e);
						}
					}
					return result;
				},
	
				_isTouchDevice = (("ontouchstart" in _docElement) && ("orientation" in window)),
				_touchEventLookup = (function(types) { //we create an object that makes it easy to translate touch event types into their "pointer" counterparts if we're in a browser that uses those instead. Like IE10 uses "MSPointerDown" instead of "touchstart", for example.
					var standard = types.split(","),
						converted = ((_tempDiv.onpointerdown !== undefined) ? "pointerdown,pointermove,pointerup,pointercancel" : (_tempDiv.onmspointerdown !== undefined) ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : types).split(","),
						obj = {},
						i = 4;
					while (--i > -1) {
						obj[standard[i]] = converted[i];
						obj[converted[i]] = standard[i];
					}
					return obj;
				}("touchstart,touchmove,touchend,touchcancel")),
	
				_addListener = function(element, type, func, capture) {
					if (element.addEventListener) {
						element.addEventListener(_touchEventLookup[type], func, capture);
						if (type !== _touchEventLookup[type]) { //some browsers actually support both, so must we.
							element.addEventListener(type, func, capture);
						}
					} else if (element.attachEvent) {
						element.attachEvent("on" + type, func);
					}
				},
	
				_removeListener = function(element, type, func) {
					if (element.removeEventListener) {
						element.removeEventListener(_touchEventLookup[type], func);
						if (type !== _touchEventLookup[type]) {
							element.removeEventListener(type, func);
						}
					} else if (element.detachEvent) {
						element.detachEvent("on" + type, func);
					}
				},
	
				_hasTouchID = function(list, ID) {
					var i = list.length;
					while (--i > -1) {
						if (list[i].identifier === ID) {
							return true;
						}
					}
					return false;
				},
	
				_onMultiTouchDocumentEnd = function(e) {
					_isMultiTouching = (e.touches && _dragCount < e.touches.length);
					_removeListener(e.target, "touchend", _onMultiTouchDocumentEnd);
				},
	
				_onMultiTouchDocument = function(e) {
					_isMultiTouching = (e.touches && _dragCount < e.touches.length);
					_addListener(e.target, "touchend", _onMultiTouchDocumentEnd);
				},
	
				_parseThrowProps = function(draggable, snap, max, min, factor, forceZeroVelocity) {
					var vars = {},
						a, i, l;
					if (snap) {
						if (factor !== 1 && snap instanceof Array) { //some data must be altered to make sense, like if the user passes in an array of rotational values in degrees, we must convert it to radians. Or for scrollLeft and scrollTop, we invert the values.
							vars.end = a = [];
							l = snap.length;
							if (typeof(snap[0]) === "object") { //if the array is populated with objects, like points ({x:100, y:200}), make copies before multiplying by the factor, otherwise we'll mess up the originals and the user may reuse it elsewhere.
								for (i = 0; i < l; i++) {
									a[i] = _copy(snap[i], factor);
								}
							} else {
								for (i = 0; i < l; i++) {
									a[i] = snap[i] * factor;
								}
							}
							max += 1.1; //allow 1.1 pixels of wiggle room when snapping in order to work around some browser inconsistencies in the way bounds are reported which can make them roughly a pixel off. For example, if "snap:[-$('#menu').width(), 0]" was defined and #menu had a wrapper that was used as the bounds, some browsers would be one pixel off, making the minimum -752 for example when snap was [-753,0], thus instead of snapping to -753, it would snap to 0 since -753 was below the minimum.
							min -= 1.1;
						} else if (typeof(snap) === "function") {
							vars.end = function(value) {
								var result = snap.call(draggable, value),
									copy, p;
								if (factor !== 1) {
									if (typeof(result) === "object") {
										copy = {};
										for (p in result) {
											copy[p] = result[p] * factor;
										}
										result = copy;
									} else {
										result *= factor;
									}
								}
								return result; //we need to ensure that we can scope the function call to the Draggable instance itself so that users can access important values like maxX, minX, maxY, minY, x, and y from within that function.
							};
						} else {
							vars.end = snap;
						}
					}
					if (max || max === 0) {
						vars.max = max;
					}
					if (min || min === 0) {
						vars.min = min;
					}
					if (forceZeroVelocity) {
						vars.velocity = 0;
					}
					return vars;
				},
	
				_isClickable = function(e) { //sometimes it's convenient to mark an element as clickable by adding a data-clickable="true" attribute (in which case we won't preventDefault() the mouse/touch event). This method checks if the element is an <a>, <input>, or <button> or has an onclick or has the data-clickable or contentEditable attribute set to true (or any of its parent elements).
					var data;
					return (!e || !e.getAttribute || e.nodeName === "BODY") ? false : ((data = e.getAttribute("data-clickable")) === "true" || (data !== "false" && (e.onclick || _clickableTagExp.test(e.nodeName + "") || e.getAttribute("contentEditable") === "true"))) ? true : _isClickable(e.parentNode);
				},
	
				_setSelectable = function(elements, selectable) {
					var i = elements.length,
						e;
					while (--i > -1) {
						e = elements[i];
						e.ondragstart = e.onselectstart = selectable ? null : _emptyFunc;
						_setStyle(e, "userSelect", (selectable ? "text" : "none"));
					}
				},
	
				_addPaddingBR,
				_addPaddingLeft = (function() { //this function is in charge of analyzing browser behavior related to padding. It sets the _addPaddingBR to true if the browser doesn't normally factor in the bottom or right padding on the element inside the scrolling area, and it sets _addPaddingLeft to true if it's a browser that requires the extra offset (offsetLeft) to be added to the paddingRight (like Opera).
					var div = _doc.createElement("div"),
						child = _doc.createElement("div"),
						childStyle = child.style,
						parent = _doc.body || _tempDiv,
						val;
					childStyle.display = "inline-block";
					childStyle.position = "relative";
					div.style.cssText = child.innerHTML = "width:90px; height:40px; padding:10px; overflow:auto; visibility: hidden";
					div.appendChild(child);
					parent.appendChild(div);
					_addPaddingBR = (child.offsetHeight + 18 > div.scrollHeight); //div.scrollHeight should be child.offsetHeight + 20 because of the 10px of padding on each side, but some browsers ignore one side. We allow a 2px margin of error.
					childStyle.width = "100%";
					if (!_transformProp) {
						childStyle.paddingRight = "500px";
						val = div.scrollLeft = div.scrollWidth - div.clientWidth;
						childStyle.left = "-90px";
						val = (val !== div.scrollLeft);
					}
					parent.removeChild(div);
					return val;
				}()),
	
	
	
	
				//The ScrollProxy class wraps an element's contents into another div (we call it "content") that we either add padding when necessary or apply a translate3d() transform in order to overscroll (scroll past the boundaries). This allows us to simply set the scrollTop/scrollLeft (or top/left for easier reverse-axis orientation, which is what we do in Draggable) and it'll do all the work for us. For example, if we tried setting scrollTop to -100 on a normal DOM element, it wouldn't work - it'd look the same as setting it to 0, but if we set scrollTop of a ScrollProxy to -100, it'll give the correct appearance by either setting paddingTop of the wrapper to 100 or applying a 100-pixel translateY.
				ScrollProxy = function(element, vars) {
					element = _unwrapElement(element);
					vars = vars || {};
					var content = _doc.createElement("div"),
						style = content.style,
						node = element.firstChild,
						offsetTop = 0,
						offsetLeft = 0,
						prevTop = element.scrollTop,
						prevLeft = element.scrollLeft,
						scrollWidth = element.scrollWidth,
						scrollHeight = element.scrollHeight,
						extraPadRight = 0,
						maxLeft = 0,
						maxTop = 0,
						elementWidth, elementHeight, contentHeight, nextNode, transformStart, transformEnd;
	
					if (_supports3D && vars.force3D !== false) {
						transformStart = "translate3d(";
						transformEnd = "px,0px)";
					} else if (_transformProp) {
						transformStart = "translate(";
						transformEnd = "px)";
					}
	
					this.scrollTop = function(value, force) {
						if (!arguments.length) {
							return -this.top();
						}
						this.top(-value, force);
					};
	
					this.scrollLeft = function(value, force) {
						if (!arguments.length) {
							return -this.left();
						}
						this.left(-value, force);
					};
	
					this.left = function(value, force) {
						if (!arguments.length) {
							return -(element.scrollLeft + offsetLeft);
						}
						var dif = element.scrollLeft - prevLeft,
							oldOffset = offsetLeft;
						if ((dif > 2 || dif < -2) && !force) { //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
							prevLeft = element.scrollLeft;
							TweenLite.killTweensOf(this, true, {left:1, scrollLeft:1});
							this.left(-prevLeft);
							if (vars.onKill) {
								vars.onKill();
							}
							return;
						}
						value = -value; //invert because scrolling works in the opposite direction
						if (value < 0) {
							offsetLeft = (value - 0.5) | 0;
							value = 0;
						} else if (value > maxLeft) {
							offsetLeft = (value - maxLeft) | 0;
							value = maxLeft;
						} else {
							offsetLeft = 0;
						}
						if (offsetLeft || oldOffset) {
							if (transformStart) {
								if (!this._suspendTransforms) {
									style[_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
								}
							} else {
								style.left = -offsetLeft + "px";
							}
							if (_addPaddingLeft && offsetLeft + extraPadRight >= 0) {
								style.paddingRight = offsetLeft + extraPadRight + "px";
							}
						}
						element.scrollLeft = value | 0;
						prevLeft = element.scrollLeft; //don't merge this with the line above because some browsers adjsut the scrollLeft after it's set, so in order to be 100% accurate in tracking it, we need to ask the browser to report it.
					};
	
					this.top = function(value, force) {
						if (!arguments.length) {
							return -(element.scrollTop + offsetTop);
						}
						var dif = element.scrollTop - prevTop,
							oldOffset = offsetTop;
						if ((dif > 2 || dif < -2) && !force) { //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
							prevTop = element.scrollTop;
							TweenLite.killTweensOf(this, true, {top:1, scrollTop:1});
							this.top(-prevTop);
							if (vars.onKill) {
								vars.onKill();
							}
							return;
						}
						value = -value; //invert because scrolling works in the opposite direction
						if (value < 0) {
							offsetTop = (value - 0.5) | 0;
							value = 0;
						} else if (value > maxTop) {
							offsetTop = (value - maxTop) | 0;
							value = maxTop;
						} else {
							offsetTop = 0;
						}
						if (offsetTop || oldOffset) {
							if (transformStart) {
								if (!this._suspendTransforms) {
									style[_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
								}
							} else {
								style.top = -offsetTop + "px";
							}
						}
						element.scrollTop = value | 0;
						prevTop = element.scrollTop;
					};
	
					this.maxScrollTop = function() {
						return maxTop;
					};
	
					this.maxScrollLeft = function() {
						return maxLeft;
					};
	
					this.disable = function() {
						node = content.firstChild;
						while (node) {
							nextNode = node.nextSibling;
							element.appendChild(node);
							node = nextNode;
						}
						if (element === content.parentNode) { //in case disable() is called when it's already disabled.
							element.removeChild(content);
						}
					};
	
					this.enable = function() {
						node = element.firstChild;
						if (node === content) {
							return;
						}
						while (node) {
							nextNode = node.nextSibling;
							content.appendChild(node);
							node = nextNode;
						}
						element.appendChild(content);
						this.calibrate();
					};
	
					this.calibrate = function(force) {
						var widthMatches = (element.clientWidth === elementWidth),
							x, y;
						prevTop = element.scrollTop;
						prevLeft = element.scrollLeft;
						if (widthMatches && element.clientHeight === elementHeight && content.offsetHeight === contentHeight && scrollWidth === element.scrollWidth && scrollHeight === element.scrollHeight && !force) {
							return; //no need to recalculate things if the width and height haven't changed.
						}
						if (offsetTop || offsetLeft) {
							x = this.left();
							y = this.top();
							this.left(-element.scrollLeft);
							this.top(-element.scrollTop);
						}
						//first, we need to remove any width constraints to see how the content naturally flows so that we can see if it's wider than the containing element. If so, we've got to record the amount of overage so that we can apply that as padding in order for browsers to correctly handle things. Then we switch back to a width of 100% (without that, some browsers don't flow the content correctly)
						if (!widthMatches || force) {
							style.display = "block";
							style.width = "auto";
							style.paddingRight = "0px";
							extraPadRight = Math.max(0, element.scrollWidth - element.clientWidth);
							//if the content is wider than the container, we need to add the paddingLeft and paddingRight in order for things to behave correctly.
							if (extraPadRight) {
								extraPadRight += _getStyle(element, "paddingLeft") + (_addPaddingBR ? _getStyle(element, "paddingRight") : 0);
							}
						}
						style.display = "inline-block";
						style.position = "relative";
						style.overflow = "visible";
						style.verticalAlign = "top";
						style.width = "100%";
						style.paddingRight = extraPadRight + "px";
						//some browsers neglect to factor in the bottom padding when calculating the scrollHeight, so we need to add that padding to the content when that happens. Allow a 2px margin for error
						if (_addPaddingBR) {
							style.paddingBottom = _getStyle(element, "paddingBottom", true);
						}
						if (_isOldIE) {
							style.zoom = "1";
						}
						elementWidth = element.clientWidth;
						elementHeight = element.clientHeight;
						scrollWidth = element.scrollWidth;
						scrollHeight = element.scrollHeight;
						maxLeft = element.scrollWidth - elementWidth;
						maxTop = element.scrollHeight - elementHeight;
						contentHeight = content.offsetHeight;
						style.display = "block";
						if (x || y) {
							this.left(x);
							this.top(y);
						}
					};
	
					this.content = content;
					this.element = element;
					this._suspendTransforms = false;
					this.enable();
				},
	
	
	
	
	
				Draggable = function(target, vars) {
					EventDispatcher.call(this, target);
					target = _unwrapElement(target); //in case the target is a selector object or selector text
					if (!ThrowPropsPlugin) {
						ThrowPropsPlugin = _globals.com.greensock.plugins.ThrowPropsPlugin;
					}
					this.vars = vars = _copy(vars || {});
					this.target = target;
					this.x = this.y = this.rotation = 0;
					this.dragResistance = parseFloat(vars.dragResistance) || 0;
					this.edgeResistance = isNaN(vars.edgeResistance) ? 1 : parseFloat(vars.edgeResistance) || 0;
					this.lockAxis = vars.lockAxis;
					this.autoScroll = vars.autoScroll || 0;
					this.lockedAxis = null;
					this.allowEventDefault = !!vars.allowEventDefault;
					var type = (vars.type || (_isOldIE ? "top,left" : "x,y")).toLowerCase(),
						xyMode = (type.indexOf("x") !== -1 || type.indexOf("y") !== -1),
						rotationMode = (type.indexOf("rotation") !== -1),
						xProp = rotationMode ? "rotation" : xyMode ? "x" : "left",
						yProp = xyMode ? "y" : "top",
						allowX = (type.indexOf("x") !== -1 || type.indexOf("left") !== -1 || type === "scroll"),
						allowY = (type.indexOf("y") !== -1 || type.indexOf("top") !== -1 || type === "scroll"),
						minimumMovement = vars.minimumMovement || 2,
						self = this,
						triggers = _slice(vars.trigger || vars.handle || target),
						killProps = {},
						dragEndTime = 0,
						checkAutoScrollBounds = false,
						autoScrollMarginTop = vars.autoScrollMarginTop || 40,
						autoScrollMarginRight = vars.autoScrollMarginRight || 40,
						autoScrollMarginBottom = vars.autoScrollMarginBottom || 40,
						autoScrollMarginLeft = vars.autoScrollMarginLeft || 40,
						isClickable = vars.clickableTest || _isClickable,
						clickTime = 0,
						enabled, scrollProxy, startPointerX, startPointerY, startElementX, startElementY, hasBounds, hasDragCallback, maxX, minX, maxY, minY, tempVars, cssVars, touch, touchID, rotationOrigin, dirty, old, snapX, snapY, snapXY, isClicking, touchEventTarget, matrix, interrupted, startScrollTop, startScrollLeft, applyObj, allowNativeTouchScrolling, touchDragAxis, isDispatching, clickDispatch, trustedClickDispatch,
	
						onContextMenu = function(e) { //used to prevent long-touch from triggering a context menu.
							if (self.isPressed && e.which < 2) {
								self.endDrag();
							} else {
								e.preventDefault();
								e.stopPropagation();
								return false;
							}
						},
	
						//this method gets called on every tick of TweenLite.ticker which allows us to synchronize the renders to the core engine (which is typically synchronized with the display refresh via requestAnimationFrame). This is an optimization - it's better than applying the values inside the "mousemove" or "touchmove" event handler which may get called many times inbetween refreshes.
						render = function(suppressEvents) {
							if (self.autoScroll && self.isDragging && (checkAutoScrollBounds || dirty)) {
								var e = target,
									autoScrollFactor = self.autoScroll * 15, //multiplying by 15 just gives us a better "feel" speed-wise.
									parent, isRoot, rect, pointerX, pointerY, changeX, changeY, gap;
								checkAutoScrollBounds = false;
								_windowProxy.scrollTop = ((window.pageYOffset != null) ? window.pageYOffset : (_docElement.scrollTop != null) ? _docElement.scrollTop : _doc.body.scrollTop);
								_windowProxy.scrollLeft = ((window.pageXOffset != null) ? window.pageXOffset : (_docElement.scrollLeft != null) ? _docElement.scrollLeft : _doc.body.scrollLeft);
								pointerX = self.pointerX - _windowProxy.scrollLeft;
								pointerY = self.pointerY - _windowProxy.scrollTop;
								while (e && !isRoot) { //walk up the chain and sense wherever the pointer is within 40px of an edge that's scrollable.
									isRoot = _isRoot(e.parentNode);
									parent = isRoot ? _windowProxy : e.parentNode;
									rect = isRoot ? {bottom:Math.max(_docElement.clientHeight, window.innerHeight || 0), right: Math.max(_docElement.clientWidth, window.innerWidth || 0), left:0, top:0} : parent.getBoundingClientRect();
									changeX = changeY = 0;
									if (allowY) {
										gap = parent._gsMaxScrollY - parent.scrollTop;
										if (gap < 0) {
											changeY = gap;
										} else if (pointerY > rect.bottom - autoScrollMarginBottom && gap) {
											checkAutoScrollBounds = true;
											changeY = Math.min(gap, (autoScrollFactor * (1 - Math.max(0, (rect.bottom - pointerY)) / autoScrollMarginBottom)) | 0);
										} else if (pointerY < rect.top + autoScrollMarginTop && parent.scrollTop) {
											checkAutoScrollBounds = true;
											changeY = -Math.min(parent.scrollTop, (autoScrollFactor * (1 - Math.max(0, (pointerY - rect.top)) / autoScrollMarginTop)) | 0);
										}
										if (changeY) {
											parent.scrollTop += changeY;
										}
									}
									if (allowX) {
										gap = parent._gsMaxScrollX - parent.scrollLeft;
										if (gap < 0) {
											changeX = gap;
										} else if (pointerX > rect.right - autoScrollMarginRight && gap) {
											checkAutoScrollBounds = true;
											changeX = Math.min(gap, (autoScrollFactor * (1 - Math.max(0, (rect.right - pointerX)) / autoScrollMarginRight)) | 0);
										} else if (pointerX < rect.left + autoScrollMarginLeft && parent.scrollLeft) {
											checkAutoScrollBounds = true;
											changeX = -Math.min(parent.scrollLeft, (autoScrollFactor * (1 - Math.max(0, (pointerX - rect.left)) / autoScrollMarginLeft)) | 0);
										}
										if (changeX) {
											parent.scrollLeft += changeX;
										}
									}
	
									if (isRoot && (changeX || changeY)) {
										window.scrollTo(parent.scrollLeft, parent.scrollTop);
										setPointerPosition(self.pointerX + changeX, self.pointerY + changeY);
									}
									e = parent;
								}
							}
							if (dirty) {
								var x = self.x,
									y = self.y,
									min = 0.000001;
								if (x < min && x > -min) { //browsers don't handle super small decimals well.
									x = 0;
								}
								if (y < min && y > -min) {
									y = 0;
								}
								if (rotationMode) {
									self.deltaX = x - applyObj.data.rotation;
									applyObj.data.rotation = self.rotation = x;
									applyObj.setRatio(1); //note: instead of doing TweenLite.set(), as a performance optimization we skip right to the method that renders the transforms inside CSSPlugin. For old versions of IE, though, we do a normal TweenLite.set() to leverage its ability to re-reroute to an IE-specific 2D renderer.
								} else {
									if (scrollProxy) {
										if (allowY) {
											self.deltaY = y - scrollProxy.top();
											scrollProxy.top(y);
										}
										if (allowX) {
											self.deltaX = x - scrollProxy.left();
											scrollProxy.left(x);
										}
									} else if (xyMode) {
										if (allowY) {
											self.deltaY = y - applyObj.data.y;
											applyObj.data.y = y;
										}
										if (allowX) {
											self.deltaX = x - applyObj.data.x;
											applyObj.data.x = x;
										}
										applyObj.setRatio(1); //note: instead of doing TweenLite.set(), as a performance optimization we skip right to the method that renders the transforms inside CSSPlugin. For old versions of IE, though, we do a normal TweenLite.set() to leverage its ability to re-reroute to an IE-specific 2D renderer.
									} else {
										if (allowY) {
											self.deltaY = y - parseFloat(target.style.top || 0);
											target.style.top = y + "px";
										}
										if (allowX) {
											self.deltaY = x - parseFloat(target.style.left || 0);
											target.style.left = x + "px";
										}
									}
								}
								if (hasDragCallback && !suppressEvents && !isDispatching) {
									isDispatching = true; //in case onDrag has an update() call (avoid endless loop)
									_dispatchEvent(self, "drag", "onDrag");
									isDispatching = false;
								}
							}
							dirty = false;
						},
	
						//copies the x/y from the element (whether that be transforms, top/left, or ScrollProxy's top/left) to the Draggable's x and y (and rotation if necessary) properties so that they reflect reality and it also (optionally) applies any snapping necessary. This is used by the ThrowPropsPlugin tween in an onUpdate to ensure things are synced and snapped.
						syncXY = function(skipOnUpdate, skipSnap) {
							var x = self.x,
								y = self.y,
								snappedValue;
							if (!target._gsTransform && (xyMode || rotationMode)) { //just in case the _gsTransform got wiped, like if the user called clearProps on the transform or something (very rare), doing an x tween forces a re-parsing of the transforms and population of the _gsTransform.
								TweenLite.set(target, {x:"+=0", overwrite:false, data:"_draggable"});
							}
							if (xyMode) {
								self.y = target._gsTransform.y;
								self.x = target._gsTransform.x;
							} else if (rotationMode) {
								self.x = self.rotation = target._gsTransform.rotation;
							} else if (scrollProxy) {
								self.y = scrollProxy.top();
								self.x = scrollProxy.left();
							} else {
								self.y = parseInt(target.style.top, 10) || 0;
								self.x = parseInt(target.style.left, 10) || 0;
							}
							if ((snapX || snapY || snapXY) && !skipSnap && (self.isDragging || self.isThrowing)) {
								if (snapXY) {
									_temp1.x = self.x;
									_temp1.y = self.y;
									snappedValue = snapXY(_temp1);
									if (snappedValue.x !== self.x) {
										self.x = snappedValue.x;
										dirty = true;
									}
									if (snappedValue.y !== self.y) {
										self.y = snappedValue.y;
										dirty = true;
									}
								}
								if (snapX) {
									snappedValue = snapX(self.x);
									if (snappedValue !== self.x) {
										self.x = snappedValue;
										if (rotationMode) {
											self.rotation = snappedValue;
										}
										dirty = true;
									}
								}
								if (snapY) {
									snappedValue = snapY(self.y);
									if (snappedValue !== self.y) {
										self.y = snappedValue;
									}
									dirty = true;
								}
							}
							if (dirty) {
								render(true);
							}
							if (!skipOnUpdate) {
								self.deltaX = self.x - x;
								self.deltaY = self.y - y;
								_dispatchEvent(self, "throwupdate", "onThrowUpdate");
							}
						},
	
						calculateBounds = function() {
							var bounds, targetBounds, snap, snapIsRaw;
							hasBounds = false;
							if (scrollProxy) {
								scrollProxy.calibrate();
								self.minX = minX = -scrollProxy.maxScrollLeft();
								self.minY = minY = -scrollProxy.maxScrollTop();
								self.maxX = maxX = self.maxY = maxY = 0;
								hasBounds = true;
							} else if (!!vars.bounds) {
								bounds = _getBounds(vars.bounds, target.parentNode); //could be a selector/jQuery object or a DOM element or a generic object like {top:0, left:100, width:1000, height:800} or {minX:100, maxX:1100, minY:0, maxY:800}
								if (rotationMode) {
									self.minX = minX = bounds.left;
									self.maxX = maxX = bounds.left + bounds.width;
									self.minY = minY = self.maxY = maxY = 0;
								} else if (vars.bounds.maxX !== undefined || vars.bounds.maxY !== undefined) {
									bounds = vars.bounds;
									self.minX = minX = bounds.minX;
									self.minY = minY = bounds.minY;
									self.maxX = maxX = bounds.maxX;
									self.maxY = maxY = bounds.maxY;
								} else {
									targetBounds = _getBounds(target, target.parentNode);
									self.minX = minX = _getStyle(target, xProp) + bounds.left - targetBounds.left;
									self.minY = minY = _getStyle(target, yProp) + bounds.top - targetBounds.top;
									self.maxX = maxX = minX + (bounds.width - targetBounds.width);
									self.maxY = maxY = minY + (bounds.height - targetBounds.height);
								}
								if (minX > maxX) {
									self.minX = maxX;
									self.maxX = maxX = minX;
									minX = self.minX;
								}
								if (minY > maxY) {
									self.minY = maxY;
									self.maxY = maxY = minY;
									minY = self.minY;
								}
								if (rotationMode) {
									self.minRotation = minX;
									self.maxRotation = maxX;
								}
								hasBounds = true;
							}
							if (vars.liveSnap) {
								snap = (vars.liveSnap === true) ? (vars.snap || {}) : vars.liveSnap;
								snapIsRaw = (snap instanceof Array || typeof(snap) === "function");
								if (rotationMode) {
									snapX = buildSnapFunc((snapIsRaw ? snap : snap.rotation), minX, maxX, 1);
									snapY = null;
								} else {
									if (snap.points) {
										snapXY = buildPointSnapFunc((snapIsRaw ? snap : snap.points), minX, maxX, minY, maxY, snap.radius, scrollProxy ? -1 : 1);
									} else {
										if (allowX) {
											snapX = buildSnapFunc((snapIsRaw ? snap : snap.x || snap.left || snap.scrollLeft), minX, maxX, scrollProxy ? -1 : 1);
										}
										if (allowY) {
											snapY = buildSnapFunc((snapIsRaw ? snap : snap.y || snap.top || snap.scrollTop), minY, maxY, scrollProxy ? -1 : 1);
										}
									}
								}
							}
	
						},
	
						onThrowComplete = function() {
							self.isThrowing = false;
							_dispatchEvent(self, "throwcomplete", "onThrowComplete");
						},
						onThrowOverwrite = function() {
							self.isThrowing = false;
						},
	
						animate = function(throwProps, forceZeroVelocity) {
							var snap, snapIsRaw, tween, overshootTolerance;
							if (throwProps && ThrowPropsPlugin) {
								if (throwProps === true) {
									snap = vars.snap || vars.liveSnap || {};
									snapIsRaw = (snap instanceof Array || typeof(snap) === "function");
									throwProps = {resistance:(vars.throwResistance || vars.resistance || 1000) / (rotationMode ? 10 : 1)};
									if (rotationMode) {
										throwProps.rotation = _parseThrowProps(self, snapIsRaw ? snap : snap.rotation, maxX, minX, 1, forceZeroVelocity);
									} else {
										if (allowX) {
											throwProps[xProp] = _parseThrowProps(self, snapIsRaw ? snap : snap.points || snap.x || snap.left || snap.scrollLeft, maxX, minX, scrollProxy ? -1 : 1, forceZeroVelocity || (self.lockedAxis === "x"));
										}
										if (allowY) {
											throwProps[yProp] = _parseThrowProps(self, snapIsRaw ? snap : snap.points || snap.y || snap.top || snap.scrollTop, maxY, minY, scrollProxy ? -1 : 1, forceZeroVelocity || (self.lockedAxis === "y"));
										}
										if (snap.points || (snap instanceof Array && typeof(snap[0]) === "object")) {
											throwProps.linkedProps = xProp + "," + yProp;
											throwProps.radius = snap.radius; //note: we also disable liveSnapping while throwing if there's a "radius" defined, otherwise it looks weird to have the item thrown past a snapping point but live-snapping mid-tween. We do this by altering the onUpdateParams so that "skipSnap" parameter is true for syncXY.
										}
									}
								}
								self.isThrowing = true;
								overshootTolerance = (!isNaN(vars.overshootTolerance)) ? vars.overshootTolerance : (vars.edgeResistance === 1) ? 0 : (1 - self.edgeResistance) + 0.2;
								self.tween = tween = ThrowPropsPlugin.to(scrollProxy || target, {throwProps:throwProps, data:"_draggable", ease:(vars.ease || _globals.Power3.easeOut), onComplete:onThrowComplete, onOverwrite:onThrowOverwrite, onUpdate:(vars.fastMode ? _dispatchEvent : syncXY), onUpdateParams:(vars.fastMode ? [self, "onthrowupdate", "onThrowUpdate"] : (snap && snap.radius) ? [false, true] : _emptyArray)}, (isNaN(vars.maxDuration) ? 2 : vars.maxDuration), (!isNaN(vars.minDuration) ? vars.minDuration : (overshootTolerance === 0 || (typeof(throwProps) === "object" && throwProps.resistance > 1000)) ? 0 : 0.5), overshootTolerance);
								if (!vars.fastMode) {
									//to populate the end values, we just scrub the tween to the end, record the values, and then jump back to the beginning.
									if (scrollProxy) {
										scrollProxy._suspendTransforms = true; //Microsoft browsers have a bug that causes them to briefly render the position incorrectly (it flashes to the end state when we seek() the tween even though we jump right back to the current position, and this only seems to happen when we're affecting both top and left), so we set a _suspendTransforms flag to prevent it from actually applying the values in the ScrollProxy.
									}
									tween.render(tween.duration(), true, true);
									syncXY(true, true);
									self.endX = self.x;
									self.endY = self.y;
									if (rotationMode) {
										self.endRotation = self.x;
									}
									tween.play(0);
									syncXY(true, true);
									if (scrollProxy) {
										scrollProxy._suspendTransforms = false;
									}
								}
							} else if (hasBounds) {
								self.applyBounds();
							}
						},
	
						updateMatrix = function(shiftStart) {
							var start = matrix || [1,0,0,1,0,0],
								a, b, c, d, tx, ty, determinant, pointerX, pointerY;
							matrix = _getConcatenatedMatrix(target.parentNode, true);
							if (shiftStart && self.isPressed && start.join(",") !== matrix.join(",")) { //if the matrix changes WHILE the element is pressed, we must adjust the startPointerX and startPointerY accordingly, so we invert the original matrix and figure out where the pointerX and pointerY were in the global space, then apply the new matrix to get the updated coordinates.
								a = start[0];
								b = start[1];
								c = start[2];
								d = start[3];
								tx = start[4];
								ty = start[5];
								determinant = (a * d - b * c);
								pointerX = startPointerX * (d / determinant) + startPointerY * (-c / determinant) + ((c * ty - d * tx) / determinant);
								pointerY = startPointerX * (-b / determinant) + startPointerY * (a / determinant) + (-(a * ty - b * tx) / determinant);
								startPointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
								startPointerX = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
							}
							if (!matrix[1] && !matrix[2] && matrix[0] == 1 && matrix[3] == 1 && matrix[4] == 0 && matrix[5] == 0) { //if there are no transforms, we can optimize performance by not factoring in the matrix
								matrix = null;
							}
	
						},
	
						recordStartPositions = function() {
							var edgeTolerance = 1 - self.edgeResistance;
							updateMatrix(false);
							if (matrix) {
								startPointerX = self.pointerX * matrix[0] + self.pointerY * matrix[2] + matrix[4]; //translate to local coordinate system
								startPointerY = self.pointerX * matrix[1] + self.pointerY * matrix[3] + matrix[5];
							}
							if (dirty) {
								setPointerPosition(self.pointerX, self.pointerY);
								render(true);
							}
							if (scrollProxy) {
								calculateBounds();
								startElementY = scrollProxy.top();
								startElementX = scrollProxy.left();
							} else {
								//if the element is in the process of tweening, don't force snapping to occur because it could make it jump. Imagine the user throwing, then before it's done, clicking on the element in its inbetween state.
								if (isTweening()) {
									syncXY(true, true);
									calculateBounds();
								} else {
									self.applyBounds();
								}
								if (rotationMode) {
									rotationOrigin = self.rotationOrigin = _localToGlobal(target, {x:0, y:0});
									syncXY(true, true);
									startElementX = self.x; //starting rotation (x always refers to rotation in type:"rotation", measured in degrees)
									startElementY = self.y = Math.atan2(rotationOrigin.y - self.pointerY, self.pointerX - rotationOrigin.x) * _RAD2DEG;
								} else {
									startScrollTop = target.parentNode ? target.parentNode.scrollTop || 0 : 0;
									startScrollLeft = target.parentNode ? target.parentNode.scrollLeft || 0 : 0;
									startElementY = _getStyle(target, yProp); //record the starting top and left values so that we can just add the mouse's movement to them later.
									startElementX = _getStyle(target, xProp);
								}
							}
							if (hasBounds && edgeTolerance) {
								if (startElementX > maxX) {
									startElementX = maxX + (startElementX - maxX) / edgeTolerance;
								} else if (startElementX < minX) {
									startElementX = minX - (minX - startElementX) / edgeTolerance;
								}
								if (!rotationMode) {
									if (startElementY > maxY) {
										startElementY = maxY + (startElementY - maxY) / edgeTolerance;
									} else if (startElementY < minY) {
										startElementY = minY - (minY - startElementY) / edgeTolerance;
									}
								}
							}
							self.startX = startElementX;
							self.startY = startElementY;
						},
	
						isTweening = function() {
							return (self.tween && self.tween.isActive());
						},
	
						removePlaceholder = function() {
							if (_placeholderDiv.parentNode && !isTweening() && !self.isDragging) { //_placeholderDiv just props open auto-scrolling containers so they don't collapse as the user drags left/up. We remove it after dragging (and throwing, if necessary) finishes.
								_placeholderDiv.parentNode.removeChild(_placeholderDiv);
							}
						},
	
						buildSnapFunc = function(snap, min, max, factor) {
							if (typeof(snap) === "function") {
								return function(n) {
									var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
									return snap.call(self, (n > max ? max + (n - max) * edgeTolerance : (n < min) ? min + (n - min) * edgeTolerance : n)) * factor;
								};
							}
							if (snap instanceof Array) {
								return function(n) {
									var i = snap.length,
										closest = 0,
										absDif = _max,
										val, dif;
									while (--i > -1) {
										val = snap[i];
										dif = val - n;
										if (dif < 0) {
											dif = -dif;
										}
										if (dif < absDif && val >= min && val <= max) {
											closest = i;
											absDif = dif;
										}
									}
									return snap[closest];
								};
							}
							return isNaN(snap) ? function(n) { return n; } : function() { return snap * factor; };
						},
	
						buildPointSnapFunc = function(snap, minX, maxX, minY, maxY, radius, factor) {
							radius = (radius && radius < _max) ? radius * radius : _max; //so we don't have to Math.sqrt() in the functions. Performance optimization.
							if (typeof(snap) === "function") {
								return function(point) {
									var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance,
										x = point.x,
										y = point.y,
										result, dx, dy; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
									point.x = x = (x > maxX ? maxX + (x - maxX) * edgeTolerance : (x < minX) ? minX + (x - minX) * edgeTolerance : x);
									point.y = y = (y > maxY ? maxY + (y - maxY) * edgeTolerance : (y < minY) ? minY + (y - minY) * edgeTolerance : y);
									result = snap.call(self, point);
									if (result !== point) {
										point.x = result.x;
										point.y = result.y;
									}
									if (factor !== 1) {
										point.x *= factor;
										point.y *= factor;
									}
									if (radius < _max) {
										dx = point.x - x;
										dy = point.y - y;
										if (dx * dx + dy * dy > radius) {
											point.x = x;
											point.y = y;
										}
									}
									return point;
								};
							}
							if (snap instanceof Array) {
								return function(p) {
									var i = snap.length,
										closest = 0,
										minDist = _max,
										x, y, point, dist;
									while (--i > -1) {
										point = snap[i];
										x = point.x - p.x;
										y = point.y - p.y;
										dist = x * x + y * y;
										if (dist < minDist) {
											closest = i;
											minDist = dist;
										}
									}
									return (minDist <= radius) ? snap[closest] : p;
								};
							}
							return function(n) { return n; };
						},
	
						//called when the mouse is pressed (or touch starts)
						onPress = function(e, force) {
							var i;
							if (!enabled || self.isPressed || !e || ((e.type === "mousedown" || e.type === "pointerdown") && !force && _getTime() - clickTime < 30 && _touchEventLookup[self.pointerEvent.type])) { //when we DON'T preventDefault() in order to accommodate touch-scrolling and the user just taps, many browsers also fire a mousedown/mouseup sequence AFTER the touchstart/touchend sequence, thus it'd result in two quick "click" events being dispatched. This line senses that condition and halts it on the subsequent mousedown.
								return;
							}
							interrupted = isTweening();
							self.pointerEvent = e;
							if (_touchEventLookup[e.type]) { //note: on iOS, BOTH touchmove and mousemove are dispatched, but the mousemove has pageY and pageX of 0 which would mess up the calculations and needlessly hurt performance.
								touchEventTarget = (e.type.indexOf("touch") !== -1) ? (e.currentTarget || e.target) : _doc; //pointer-based touches (for Microsoft browsers) don't remain locked to the original target like other browsers, so we must use the document instead. The event type would be "MSPointerDown" or "pointerdown".
								_addListener(touchEventTarget, "touchend", onRelease);
								_addListener(touchEventTarget, "touchmove", onMove);
								_addListener(touchEventTarget, "touchcancel", onRelease);
								_addListener(_doc, "touchstart", _onMultiTouchDocument);
							} else {
								touchEventTarget = null;
								_addListener(_doc, "mousemove", onMove); //attach these to the document instead of the box itself so that if the user's mouse moves too quickly (and off of the box), things still work.
							}
							touchDragAxis = null;
							_addListener(_doc, "mouseup", onRelease);
							if (e && e.target) {
								_addListener(e.target, "mouseup", onRelease); //we also have to listen directly on the element because some browsers don't bubble up the event to the _doc on elements with contentEditable="true"
							}
							isClicking = (isClickable.call(self, e.target) && !vars.dragClickables && !force);
							if (isClicking) {
								_addListener(e.target, "change", onRelease); //in some browsers, when you mousedown on a <select> element, no mouseup gets dispatched! So we listen for a "change" event instead.
								_dispatchEvent(self, "press", "onPress");
								_setSelectable(triggers, true); //accommodates things like inputs and elements with contentEditable="true" (otherwise user couldn't drag to select text)
								return;
							}
							allowNativeTouchScrolling = (!touchEventTarget || allowX === allowY || self.vars.allowNativeTouchScrolling === false) ? false : allowX ? "y" : "x";
							if (_isOldIE) {
								e = _populateIEEvent(e, true);
							} else if (!allowNativeTouchScrolling && !self.allowEventDefault) {
								e.preventDefault();
								if (e.preventManipulation) {
									e.preventManipulation();  //for some Microsoft browsers
								}
							}
							if (e.changedTouches) { //touch events store the data slightly differently
								e = touch = e.changedTouches[0];
								touchID = e.identifier;
							} else if (e.pointerId) {
								touchID = e.pointerId; //for some Microsoft browsers
							} else {
								touch = touchID = null;
							}
							_dragCount++;
							_addToRenderQueue(render); //causes the Draggable to render on each "tick" of TweenLite.ticker (performance optimization - updating values in a mousemove can cause them to happen too frequently, like multiple times between frame redraws which is wasteful, and it also prevents values from updating properly in IE8)
							startPointerY = self.pointerY = e.pageY; //record the starting x and y so that we can calculate the movement from the original in _onMouseMove
							startPointerX = self.pointerX = e.pageX;
							if (allowNativeTouchScrolling || self.autoScroll) {
								_recordMaxScrolls(target.parentNode);
							}
							if (target.parentNode && self.autoScroll && !scrollProxy && !rotationMode && target.parentNode._gsMaxScrollX && !_placeholderDiv.parentNode && !target.getBBox) { //add a placeholder div to prevent the parent container from collapsing when the user drags the element left.
								_placeholderDiv.style.width = target.parentNode.scrollWidth + "px";
								target.parentNode.appendChild(_placeholderDiv);
							}
							recordStartPositions();
							if (self.tween) {
								self.tween.kill();
							}
							self.isThrowing = false;
							TweenLite.killTweensOf(scrollProxy || target, true, killProps); //in case the user tries to drag it before the last tween is done.
							if (scrollProxy) {
								TweenLite.killTweensOf(target, true, {scrollTo:1}); //just in case the original target's scroll position is being tweened somewhere else.
							}
							self.tween = self.lockedAxis = null;
							if (vars.zIndexBoost || (!rotationMode && !scrollProxy && vars.zIndexBoost !== false)) {
								target.style.zIndex = Draggable.zIndex++;
							}
							self.isPressed = true;
							hasDragCallback = !!(vars.onDrag || self._listeners.drag);
							if (!rotationMode) {
								i = triggers.length;
								while (--i > -1) {
									_setStyle(triggers[i], "cursor", vars.cursor || "move");
								}
							}
							_dispatchEvent(self, "press", "onPress");
						},
	
						//called every time the mouse/touch moves
						onMove = function(e) {
							var originalEvent = e,
								touches, pointerX, pointerY, i, dx, dy;
							if (!enabled || _isMultiTouching || !self.isPressed || !e) {
								return;
							}
							self.pointerEvent = e;
							touches = e.changedTouches;
							if (touches) { //touch events store the data slightly differently
								e = touches[0];
								if (e !== touch && e.identifier !== touchID) { //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
									i = touches.length;
									while (--i > -1 && (e = touches[i]).identifier !== touchID) {}
									if (i < 0) {
										return;
									}
								}
							} else if (e.pointerId && touchID && e.pointerId !== touchID) { //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
								return;
							}
							if (_isOldIE) {
								e = _populateIEEvent(e, true);
							} else {
								if (touchEventTarget && allowNativeTouchScrolling && !touchDragAxis) { //Android browsers force us to decide on the first "touchmove" event if we should allow the default (scrolling) behavior or preventDefault(). Otherwise, a "touchcancel" will be fired and then no "touchmove" or "touchend" will fire during the scrolling (no good).
									pointerX = e.pageX;
									pointerY = e.pageY;
									if (matrix) {
										i = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
										pointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
										pointerX = i;
									}
									dx = Math.abs(pointerX - startPointerX);
									dy = Math.abs(pointerY - startPointerY);
									if ((dx !== dy && (dx > minimumMovement || dy > minimumMovement)) || (_isAndroid && allowNativeTouchScrolling === touchDragAxis)) {
										touchDragAxis = (dx > dy && allowX) ? "x" : "y";
										if (self.vars.lockAxisOnTouchScroll !== false) {
											self.lockedAxis = (touchDragAxis === "x") ? "y" : "x";
											if (typeof(self.vars.onLockAxis) === "function") {
												self.vars.onLockAxis.call(self, originalEvent);
											}
										}
										if (_isAndroid && allowNativeTouchScrolling === touchDragAxis) {
											onRelease(originalEvent);
											return;
										}
									}
								}
								if (!self.allowEventDefault && (!allowNativeTouchScrolling || (touchDragAxis && allowNativeTouchScrolling !== touchDragAxis)) && originalEvent.cancelable !== false) {
									originalEvent.preventDefault();
									if (originalEvent.preventManipulation) { //for some Microsoft browsers
										originalEvent.preventManipulation();
									}
								}
							}
							if (self.autoScroll) {
								checkAutoScrollBounds = true;
							}
							setPointerPosition(e.pageX, e.pageY);
						},
	
						setPointerPosition = function(pointerX, pointerY) {
							var dragTolerance = 1 - self.dragResistance,
								edgeTolerance = 1 - self.edgeResistance,
								xChange, yChange, x, y, dif, temp;
	
							self.pointerX = pointerX;
							self.pointerY = pointerY;
							if (rotationMode) {
								y = Math.atan2(rotationOrigin.y - pointerY, pointerX - rotationOrigin.x) * _RAD2DEG;
								dif = self.y - y;
								if (dif > 180) {
									startElementY -= 360;
									self.y = y;
								} else if (dif < -180) {
									startElementY += 360;
									self.y = y;
								}
								if (self.x !== startElementX || Math.abs(startElementY - y) > minimumMovement) {
									self.y = y;
									x = startElementX + (startElementY - y) * dragTolerance;
								} else {
									x = startElementX;
								}
	
							} else {
								if (matrix) {
									temp = pointerX * matrix[0] + pointerY * matrix[2] + matrix[4];
									pointerY = pointerX * matrix[1] + pointerY * matrix[3] + matrix[5];
									pointerX = temp;
								}
								yChange = (pointerY - startPointerY);
								xChange = (pointerX - startPointerX);
								if (yChange < minimumMovement && yChange > -minimumMovement) {
									yChange = 0;
								}
								if (xChange < minimumMovement && xChange > -minimumMovement) {
									xChange = 0;
								}
								if ((self.lockAxis || self.lockedAxis) && (xChange || yChange)) {
									temp = self.lockedAxis;
									if (!temp) {
										self.lockedAxis = temp = (allowX && Math.abs(xChange) > Math.abs(yChange)) ? "y" : allowY ? "x" : null;
										if (temp && typeof(self.vars.onLockAxis) === "function") {
											self.vars.onLockAxis.call(self, self.pointerEvent);
										}
									}
									if (temp === "y") {
										yChange = 0;
									} else if (temp === "x") {
										xChange = 0;
									}
								}
								x = startElementX + xChange * dragTolerance;
								y = startElementY + yChange * dragTolerance;
							}
	
							if ((snapX || snapY || snapXY) && (self.x !== x || (self.y !== y && !rotationMode))) {
								if (snapXY) {
									_temp1.x = x;
									_temp1.y = y;
									temp = snapXY(_temp1);
									x = temp.x;
									y = temp.y;
								}
								if (snapX) {
									x = snapX(x);
								}
								if (snapY) {
									y = snapY(y);
								}
							} else if (hasBounds) {
								if (x > maxX) {
									x = maxX + (x - maxX) * edgeTolerance;
								} else if (x < minX) {
									x = minX + (x - minX) * edgeTolerance;
								}
								if (!rotationMode) {
									if (y > maxY) {
										y = maxY + (y - maxY) * edgeTolerance;
									} else if (y < minY) {
										y = minY + (y - minY) * edgeTolerance;
									}
								}
							}
							if (!rotationMode && !matrix) {
								x = Math.round(x); //helps work around an issue with some Win Touch devices
								y = Math.round(y);
							}
							if (self.x !== x || (self.y !== y && !rotationMode)) {
								if (rotationMode) {
									self.endRotation = self.x = self.endX = x;
									dirty = true;
								} else {
									if (allowY) {
										self.y = self.endY = y;
										dirty = true; //a flag that indicates we need to render the target next time the TweenLite.ticker dispatches a "tick" event (typically on a requestAnimationFrame) - this is a performance optimization (we shouldn't render on every move because sometimes many move events can get dispatched between screen refreshes, and that'd be wasteful to render every time)
									}
									if (allowX) {
										self.x = self.endX = x;
										dirty = true;
									}
								}
								if (!self.isDragging && self.isPressed) {
									self.isDragging = true;
									_dispatchEvent(self, "dragstart", "onDragStart");
								}
							}
						},
	
						//called when the mouse/touch is released
						onRelease = function(e, force) {
							if (!enabled || !self.isPressed || (e && touchID != null && !force && ((e.pointerId && e.pointerId !== touchID) || (e.changedTouches && !_hasTouchID(e.changedTouches, touchID))))) {  //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
								return;
							}
							self.isPressed = false;
							var originalEvent = e,
								wasDragging = self.isDragging,
								placeholderDelayedCall = TweenLite.delayedCall(0.001, removePlaceholder),
								touches, i, syntheticEvent, eventTarget, syntheticClick;
							if (touchEventTarget) {
								_removeListener(touchEventTarget, "touchend", onRelease);
								_removeListener(touchEventTarget, "touchmove", onMove);
								_removeListener(touchEventTarget, "touchcancel", onRelease);
								_removeListener(_doc, "touchstart", _onMultiTouchDocument);
							} else {
								_removeListener(_doc, "mousemove", onMove);
							}
							_removeListener(_doc, "mouseup", onRelease);
							if (e && e.target) {
								_removeListener(e.target, "mouseup", onRelease);
							}
							dirty = false;
							if (isClicking) {
								if (e) {
									_removeListener(e.target, "change", onRelease);
									self.pointerEvent = originalEvent;
								}
								_setSelectable(triggers, false);
								_dispatchEvent(self, "release", "onRelease");
								_dispatchEvent(self, "click", "onClick");
								isClicking = false;
								return;
							}
							_removeFromRenderQueue(render);
							if (!rotationMode) {
								i = triggers.length;
								while (--i > -1) {
									_setStyle(triggers[i], "cursor", vars.cursor || "move");
								}
							}
							if (wasDragging) {
								dragEndTime = _lastDragTime = _getTime();
								self.isDragging = false;
							}
							_dragCount--;
							if (e) {
								if (_isOldIE) {
									e = _populateIEEvent(e, false);
								}
								touches = e.changedTouches;
								if (touches) { //touch events store the data slightly differently
									e = touches[0];
									if (e !== touch && e.identifier !== touchID) { //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
										i = touches.length;
										while (--i > -1 && (e = touches[i]).identifier !== touchID) {}
										if (i < 0) {
											return;
										}
									}
								}
								self.pointerEvent = originalEvent;
								self.pointerX = e.pageX;
								self.pointerY = e.pageY;
							}
							if (originalEvent && !wasDragging) {
								if (interrupted && (vars.snap || vars.bounds)) { //otherwise, if the user clicks on the object while it's animating to a snapped position, and then releases without moving 3 pixels, it will just stay there (it should animate/snap)
									animate(vars.throwProps);
								}
								_dispatchEvent(self, "release", "onRelease");
								if ((!_isAndroid || originalEvent.type !== "touchmove") && originalEvent.type.indexOf("cancel") === -1) { //to accommodate native scrolling on Android devices, we have to immediately call onRelease() on the first touchmove event, but that shouldn't trigger a "click".
									_dispatchEvent(self, "click", "onClick");
									if (_getTime() - clickTime < 300) {
										_dispatchEvent(self, "doubleclick", "onDoubleClick");
									}
									eventTarget = originalEvent.target || originalEvent.srcElement || target; //old IE uses srcElement
									clickTime = _getTime();
									syntheticClick = function() { // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
										if (clickTime !== clickDispatch && self.enabled() && !self.isPressed) {
											if (eventTarget.click) { //some browsers (like mobile Safari) don't properly trigger the click event
												eventTarget.click();
											} else if (_doc.createEvent) {
												syntheticEvent = _doc.createEvent("MouseEvents");
												syntheticEvent.initMouseEvent("click", true, true, window, 1, self.pointerEvent.screenX, self.pointerEvent.screenY, self.pointerX, self.pointerY, false, false, false, false, 0, null);
												eventTarget.dispatchEvent(syntheticEvent);
											}
										}
									};
									if (!_isAndroid && !originalEvent.defaultPrevented) { //iOS Safari requires the synthetic click to happen immediately or else it simply won't work, but Android doesn't play nice.
										TweenLite.delayedCall(0.00001, syntheticClick); //in addition to the iOS bug workaround, there's a Firefox issue with clicking on things like a video to play, so we must fake a click event in a slightly delayed fashion. Previously, we listened for the "click" event with "capture" false which solved the video-click-to-play issue, but it would allow the "click" event to be dispatched twice like if you were using a jQuery.click() because that was handled in the capture phase, thus we had to switch to the capture phase to avoid the double-dispatching, but do the delayed synthetic click.
									}
								}
							} else {
								animate(vars.throwProps); //will skip if throwProps isn't defined or ThrowPropsPlugin isn't loaded.
								if (!_isOldIE && !self.allowEventDefault && originalEvent && (vars.dragClickables || !isClickable.call(self, originalEvent.target)) && wasDragging && (!allowNativeTouchScrolling || (touchDragAxis && allowNativeTouchScrolling === touchDragAxis)) && originalEvent.cancelable !== false) {
									originalEvent.preventDefault();
									if (originalEvent.preventManipulation) {
										originalEvent.preventManipulation();  //for some Microsoft browsers
									}
								}
								_dispatchEvent(self, "release", "onRelease");
							}
							if (isTweening()) {
								placeholderDelayedCall.duration( self.tween.duration() ); //sync the timing so that the placeholder DIV gets
							}
							if (wasDragging) {
								_dispatchEvent(self, "dragend", "onDragEnd");
							}
							return true;
						},
	
						updateScroll = function(e) {
							if (e && self.isDragging && !scrollProxy) {
								var parent = e.target || e.srcElement || target.parentNode,
									deltaX = parent.scrollLeft - parent._gsScrollX,
									deltaY = parent.scrollTop - parent._gsScrollY;
								if (deltaX || deltaY) {
									if (matrix) {
										startPointerX -= deltaX * matrix[0] + deltaY * matrix[2];
										startPointerY -= deltaY * matrix[3] + deltaX * matrix[1];
									} else {
										startPointerX -= deltaX;
										startPointerY -= deltaY;
									}
									parent._gsScrollX += deltaX;
									parent._gsScrollY += deltaY;
									setPointerPosition(self.pointerX, self.pointerY);
								}
							}
						},
	
						onClick = function(e) { //this was a huge pain in the neck to align all the various browsers and their behaviors. Chrome, Firefox, Safari, Opera, Android, and Microsoft Edge all handle events differently! Some will only trigger native behavior (like checkbox toggling) from trusted events. Others don't even support isTrusted, but require 2 events to flow through before triggering native behavior. Edge treats everything as trusted but also mandates that 2 flow through to trigger the correct native behavior.
							var time = _getTime(),
								recentlyClicked = (time - clickTime < 40),
								recentlyDragged = (time - dragEndTime < 40),
								alreadyDispatched = (recentlyClicked && clickDispatch === clickTime),
								isModern = !!e.preventDefault,
								defaultPrevented = (self.pointerEvent && self.pointerEvent.defaultPrevented),
								alreadyDispatchedTrusted = (recentlyClicked && trustedClickDispatch === clickTime),
								trusted = e.isTrusted || (e.isTrusted == null && recentlyClicked && alreadyDispatched); //note: Safari doesn't support isTrusted, and it won't properly execute native behavior (like toggling checkboxes) on the first synthetic "click" event - we must wait for the 2nd and treat it as trusted (but stop propagation at that point). Confusing, I know. Don't you love cross-browser compatibility challenges?
							if (isModern && (alreadyDispatched || (recentlyDragged && self.vars.suppressClickOnDrag !== false) )) {
								e.stopImmediatePropagation();
							}
							if (recentlyClicked && !(self.pointerEvent && self.pointerEvent.defaultPrevented) && (!alreadyDispatched || (trusted !== alreadyDispatchedTrusted))) { //let the first click pass through unhindered. Let the next one only if it's trusted, then no more (stop quick-succession ones)
								if (trusted && alreadyDispatched) {
									trustedClickDispatch = clickTime;
								}
								clickDispatch = clickTime;
								return;
							}
							if (self.isPressed || recentlyDragged || recentlyClicked) {
								if (!isModern) {
									e.returnValue = false;
								} else if (!trusted || !e.detail || !recentlyClicked || defaultPrevented) {
									e.preventDefault();
									if (e.preventManipulation) {
										e.preventManipulation();  //for some Microsoft browsers
									}
								}
							}
						},
	
						localizePoint = function(p) {
							return matrix ? {x:p.x * matrix[0] + p.y * matrix[2] + matrix[4], y:p.x * matrix[1] + p.y * matrix[3] + matrix[5]} : {x:p.x, y:p.y};
						};
	
					old = Draggable.get(this.target);
					if (old) {
						old.kill(); // avoids duplicates (an element can only be controlled by one Draggable)
					}
	
					//give the user access to start/stop dragging...
					this.startDrag = function(e, align) {
						var r1, r2, p1, p2;
						onPress(e || self.pointerEvent, true);
						//if the pointer isn't on top of the element, adjust things accordingly
						if (align && !self.hitTest(e || self.pointerEvent)) {
							r1 = _parseRect(e || self.pointerEvent);
							r2 = _parseRect(target);
							p1 = localizePoint({x:r1.left + r1.width / 2, y:r1.top + r1.height / 2});
							p2 = localizePoint({x:r2.left + r2.width / 2, y:r2.top + r2.height / 2});
							startPointerX -= p1.x - p2.x;
							startPointerY -= p1.y - p2.y;
						}
						if (!self.isDragging) {
							self.isDragging = true;
							_dispatchEvent(self, "dragstart", "onDragStart");
						}
					};
					this.drag = onMove;
					this.endDrag = function(e) {
						onRelease(e || self.pointerEvent, true);
					};
					this.timeSinceDrag = function() {
						return self.isDragging ? 0 : (_getTime() - dragEndTime) / 1000;
					};
					this.timeSinceClick = function() {
						return (_getTime() - clickTime) / 1000;
					};
					this.hitTest = function(target, threshold) {
						return Draggable.hitTest(self.target, target, threshold);
					};
	
					this.getDirection = function(from, diagonalThreshold) { //from can be "start" (default), "velocity", or an element
						var mode = (from === "velocity" && ThrowPropsPlugin) ? from : (typeof(from) === "object" && !rotationMode) ? "element" : "start",
							xChange, yChange, ratio, direction, r1, r2;
						if (mode === "element") {
							r1 = _parseRect(self.target);
							r2 = _parseRect(from);
						}
						xChange = (mode === "start") ? self.x - startElementX : (mode === "velocity") ? ThrowPropsPlugin.getVelocity(this.target, xProp) : (r1.left + r1.width / 2) - (r2.left + r2.width / 2);
						if (rotationMode) {
							return xChange < 0 ? "counter-clockwise" : "clockwise";
						} else {
							diagonalThreshold = diagonalThreshold || 2;
							yChange = (mode === "start") ? self.y - startElementY : (mode === "velocity") ? ThrowPropsPlugin.getVelocity(this.target, yProp) : (r1.top + r1.height / 2) - (r2.top + r2.height / 2);
							ratio = Math.abs(xChange / yChange);
							direction = (ratio < 1 / diagonalThreshold) ? "" : (xChange < 0) ? "left" : "right";
							if (ratio < diagonalThreshold) {
								if (direction !== "") {
									direction += "-";
								}
								direction += (yChange < 0) ? "up" : "down";
							}
						}
						return direction;
					};
	
	
					this.applyBounds = function(newBounds) {
						var x, y, forceZeroVelocity, e, parent, isRoot;
						if (newBounds && vars.bounds !== newBounds) {
							vars.bounds = newBounds;
							return self.update(true);
						}
						syncXY(true);
						calculateBounds();
						if (hasBounds) {
							x = self.x;
							y = self.y;
							if (x > maxX) {
								x = maxX;
							} else if (x < minX) {
								x = minX;
							}
							if (y > maxY) {
								y = maxY;
							} else if (y < minY) {
								y = minY;
							}
							if (self.x !== x || self.y !== y) {
								forceZeroVelocity = true;
								self.x = self.endX = x;
								if (rotationMode) {
									self.endRotation = x;
								} else {
									self.y = self.endY = y;
								}
								dirty = true;
								render(true);
								if (self.autoScroll && !self.isDragging) {
									_recordMaxScrolls(target.parentNode);
									e = target;
									_windowProxy.scrollTop = ((window.pageYOffset != null) ? window.pageYOffset : (_docElement.scrollTop != null) ? _docElement.scrollTop : _doc.body.scrollTop);
									_windowProxy.scrollLeft = ((window.pageXOffset != null) ? window.pageXOffset : (_docElement.scrollLeft != null) ? _docElement.scrollLeft : _doc.body.scrollLeft);
									while (e && !isRoot) { //walk up the chain and sense wherever the scrollTop/scrollLeft exceeds the maximum.
										isRoot = _isRoot(e.parentNode);
										parent = isRoot ? _windowProxy : e.parentNode;
										if (allowY && parent.scrollTop > parent._gsMaxScrollY) {
											parent.scrollTop = parent._gsMaxScrollY;
										}
										if (allowX && parent.scrollLeft > parent._gsMaxScrollX) {
											parent.scrollLeft = parent._gsMaxScrollX;
										}
										e = parent;
									}
								}
							}
							if (self.isThrowing && (forceZeroVelocity || self.endX > maxX || self.endX < minX || self.endY > maxY || self.endY < minY)) {
								animate(vars.throwProps, forceZeroVelocity);
							}
						}
						return self;
					};
	
					this.update = function(applyBounds, sticky, ignoreExternalChanges) {
						var x = self.x,
							y = self.y;
						updateMatrix(!sticky);
						if (applyBounds) {
							self.applyBounds();
						} else {
							if (dirty && ignoreExternalChanges) {
								render(true);
							}
							syncXY(true);
						}
						if (sticky) {
							setPointerPosition(self.pointerX, self.pointerY);
							if (dirty) {
								render(true);
							}
						}
						if (self.isPressed && !sticky && ((allowX && Math.abs(x - self.x) > 0.01) || (allowY && (Math.abs(y - self.y) > 0.01 && !rotationMode)))) {
							recordStartPositions();
						}
						if (self.autoScroll) {
							_recordMaxScrolls(target.parentNode);
							checkAutoScrollBounds = self.isDragging;
							render(true);
						}
						if (self.autoScroll) { //in case reparenting occurred.
							_removeScrollListener(target, updateScroll);
							_addScrollListener(target, updateScroll);
						}
						return self;
					};
	
					this.enable = function(type) {
						var id, i, trigger;
						if (type !== "soft") {
							i = triggers.length;
							while (--i > -1) {
								trigger = triggers[i];
								_addListener(trigger, "mousedown", onPress);
								_addListener(trigger, "touchstart", onPress);
								_addListener(trigger, "click", onClick, true); //note: used to pass true for capture but it prevented click-to-play-video functionality in Firefox.
								if (!rotationMode) {
									_setStyle(trigger, "cursor", vars.cursor || "move");
								}
								_setStyle(trigger, "touchCallout", "none");
								_setStyle(trigger, "touchAction", (allowX === allowY) ? "none" : allowX ? "pan-y" : "pan-x");
								if (_isSVG(trigger)) { // a bug in chrome doesn't respect touch-action on SVG elements - it only works if we set it on the parent SVG.
									_setStyle(trigger.ownerSVGElement || trigger, "touchAction", (allowX === allowY) ? "none" : allowX ? "pan-y" : "pan-x");
								}
								if (!this.vars.allowContextMenu) {
									_addListener(trigger, "contextmenu", onContextMenu);
								}
							}
							_setSelectable(triggers, false);
						}
						_addScrollListener(target, updateScroll);
						enabled = true;
						if (ThrowPropsPlugin && type !== "soft") {
							ThrowPropsPlugin.track(scrollProxy || target, (xyMode ? "x,y" : rotationMode ? "rotation" : "top,left"));
						}
						if (scrollProxy) {
							scrollProxy.enable();
						}
						target._gsDragID = id = "d" + (_lookupCount++);
						_lookup[id] = this;
						if (scrollProxy) {
							scrollProxy.element._gsDragID = id;
						}
						TweenLite.set(target, {x:"+=0", overwrite:false, data:"_draggable"}); //simply ensures that there's a _gsTransform on the element.
						applyObj = {
							t:target,
							data:_isOldIE ? cssVars : target._gsTransform,
							tween:{},
							setRatio:(_isOldIE ? function() { TweenLite.set(target, tempVars); } : CSSPlugin._internals.setTransformRatio || CSSPlugin._internals.set3DTransformRatio)
						};
						recordStartPositions();
						self.update(true);
						return self;
					};
	
					this.disable = function(type) {
						var dragging = self.isDragging,
							i, trigger;
						if (!rotationMode) {
							i = triggers.length;
							while (--i > -1) {
								_setStyle(triggers[i], "cursor", null);
							}
						}
						if (type !== "soft") {
							i = triggers.length;
							while (--i > -1) {
								trigger = triggers[i];
								_setStyle(trigger, "touchCallout", null);
								_setStyle(trigger, "touchAction", null);
								_removeListener(trigger, "mousedown", onPress);
								_removeListener(trigger, "touchstart", onPress);
								_removeListener(trigger, "click", onClick);
								_removeListener(trigger, "contextmenu", onContextMenu);
							}
							_setSelectable(triggers, true);
							if (touchEventTarget) {
								_removeListener(touchEventTarget, "touchcancel", onRelease);
								_removeListener(touchEventTarget, "touchend", onRelease);
								_removeListener(touchEventTarget, "touchmove", onMove);
							}
							_removeListener(_doc, "mouseup", onRelease);
							_removeListener(_doc, "mousemove", onMove);
						}
						_removeScrollListener(target, updateScroll);
						enabled = false;
						if (ThrowPropsPlugin && type !== "soft") {
							ThrowPropsPlugin.untrack(scrollProxy || target, (xyMode ? "x,y" : rotationMode ? "rotation" : "top,left"));
						}
						if (scrollProxy) {
							scrollProxy.disable();
						}
						_removeFromRenderQueue(render);
						self.isDragging = self.isPressed = isClicking = false;
						if (dragging) {
							_dispatchEvent(self, "dragend", "onDragEnd");
						}
						return self;
					};
	
					this.enabled = function(value, type) {
						return arguments.length ? (value ? self.enable(type) : self.disable(type)) : enabled;
					};
	
					this.kill = function() {
						self.isThrowing = false;
						TweenLite.killTweensOf(scrollProxy || target, true, killProps);
						self.disable();
						delete _lookup[target._gsDragID];
						return self;
					};
	
					if (type.indexOf("scroll") !== -1) {
						scrollProxy = this.scrollProxy = new ScrollProxy(target, _extend({onKill:function() { //ScrollProxy's onKill() gets called if/when the ScrollProxy senses that the user interacted with the scroll position manually (like using the scrollbar). IE9 doesn't fire the "mouseup" properly when users drag the scrollbar of an element, so this works around that issue.
							if (self.isPressed) {
								onRelease(null);
							}}}, vars));
						//a bug in many Android devices' stock browser causes scrollTop to get forced back to 0 after it is altered via JS, so we set overflow to "hidden" on mobile/touch devices (they hide the scroll bar anyway). That works around the bug. (This bug is discussed at https://code.google.com/p/android/issues/detail?id=19625)
						target.style.overflowY = (allowY && !_isTouchDevice) ? "auto" : "hidden";
						target.style.overflowX = (allowX && !_isTouchDevice) ? "auto" : "hidden";
						target = scrollProxy.content;
					}
	
					if (vars.force3D !== false) {
						TweenLite.set(target, {force3D:true}); //improve performance by forcing a GPU layer when possible
					}
					if (rotationMode) {
						killProps.rotation = 1;
					} else {
						if (allowX) {
							killProps[xProp] = 1;
						}
						if (allowY) {
							killProps[yProp] = 1;
						}
					}
					if (rotationMode) {
						tempVars = _tempVarsRotation;
						cssVars = tempVars.css;
						tempVars.overwrite = false;
					} else if (xyMode) {
						tempVars = (allowX && allowY) ? _tempVarsXY : allowX ? _tempVarsX : _tempVarsY;
						cssVars = tempVars.css;
						tempVars.overwrite = false;
					}
	
					this.enable();
				},
				p = Draggable.prototype = new EventDispatcher();
	
			p.constructor = Draggable;
			p.pointerX = p.pointerY = p.startX = p.startY = p.deltaX = p.deltaY = 0;
			p.isDragging = p.isPressed = false;
			Draggable.version = "0.16.1";
			Draggable.zIndex = 1000;
	
			_addListener(_doc, "touchcancel", function() {
				//some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document. Very strange indeed.
			});
			_addListener(_doc, "contextmenu", function(e) {
				var p;
				for (p in _lookup) {
					if (_lookup[p].isPressed) {
						_lookup[p].endDrag();
					}
				}
			});
	
			Draggable.create = function(targets, vars) {
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets);
				}
				var a = (!targets || targets.length === 0) ? [] : _isArrayLike(targets) ? _flattenArray(targets) : [targets],
					i = a.length;
				while (--i > -1) {
					a[i] = new Draggable(a[i], vars);
				}
				return a;
			};
	
			Draggable.get = function(target) {
				return _lookup[(_unwrapElement(target) || {})._gsDragID];
			};
	
			Draggable.timeSinceDrag = function() {
				return (_getTime() - _lastDragTime) / 1000;
			};
	
			var _tempRect = {}, //reuse to reduce garbage collection tasks
				_oldIERect = function(e) { //IE8 doesn't support getBoundingClientRect(), so we use this as a backup.
					var top = 0,
						left = 0,
						width, height;
					e = _unwrapElement(e);
					width = e.offsetWidth;
					height = e.offsetHeight;
					while(e) {
						top += e.offsetTop;
						left += e.offsetLeft;
						e = e.offsetParent;
					}
					return {top: top, left: left, width: width, height: height};
				},
				_parseRect = function(e, undefined) { //accepts a DOM element, a mouse event, or a rectangle object and returns the corresponding rectangle with left, right, width, height, top, and bottom properties
					if (e === window) {
						_tempRect.left = _tempRect.top = 0;
						_tempRect.width = _tempRect.right = _docElement.clientWidth || e.innerWidth || _doc.body.clientWidth || 0;
						_tempRect.height = _tempRect.bottom = ((e.innerHeight || 0) - 20 < _docElement.clientHeight) ? _docElement.clientHeight : e.innerHeight || _doc.body.clientHeight || 0;
						return _tempRect;
					}
					var r = (e.pageX !== undefined) ? {left:e.pageX - _getDocScrollLeft(), top:e.pageY - _getDocScrollTop(), right:e.pageX - _getDocScrollLeft() + 1, bottom:e.pageY - _getDocScrollTop() + 1} : (!e.nodeType && e.left !== undefined && e.top !== undefined) ? e : _isOldIE ? _oldIERect(e) : _unwrapElement(e).getBoundingClientRect();
					if (r.right === undefined && r.width !== undefined) {
						r.right = r.left + r.width;
						r.bottom = r.top + r.height;
					} else if (r.width === undefined) { //some browsers don't include width and height properties. We can't just set them directly on r because some browsers throw errors, so create a new generic object.
						r = {width: r.right - r.left, height: r.bottom - r.top, right: r.right, left: r.left, bottom: r.bottom, top: r.top};
					}
					return r;
				};
	
			Draggable.hitTest = function(obj1, obj2, threshold) {
				if (obj1 === obj2) {
					return false;
				}
				var r1 = _parseRect(obj1),
					r2 = _parseRect(obj2),
					isOutside = (r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top),
					overlap, area, isRatio;
				if (isOutside || !threshold) {
					return !isOutside;
				}
				isRatio = ((threshold + "").indexOf("%") !== -1);
				threshold = parseFloat(threshold) || 0;
				overlap = {left:Math.max(r1.left, r2.left), top:Math.max(r1.top, r2.top)};
				overlap.width = Math.min(r1.right, r2.right) - overlap.left;
				overlap.height = Math.min(r1.bottom, r2.bottom) - overlap.top;
				if (overlap.width < 0 || overlap.height < 0) {
					return false;
				}
				if (isRatio) {
					threshold *= 0.01;
					area = overlap.width * overlap.height;
					return (area >= r1.width * r1.height * threshold || area >= r2.width * r2.height * threshold);
				}
				return (overlap.width > threshold && overlap.height > threshold);
			};
	
			_placeholderDiv.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;";
	
			return Draggable;
	
		}, true);
	
	}); if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); }
	
	//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
	(function(name) {
		"use strict";
		var getGlobal = function() {
			return (_gsScope.GreenSockGlobals || _gsScope)[name];
		};
		if (typeof(module) !== "undefined" && module.exports) { //node
			__webpack_require__(16);
			__webpack_require__(47);
			module.exports = getGlobal();
		} else if (true) { //AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	}("Draggable"));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */
/***/ (function(module, exports) {

	module.exports = [{"featureType":"administrative","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#f1eced"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#cfe6ec"},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#d8e2ce"},{"visibility":"on"}]},{"featureType":"poi.park","elementType":"labels.text","stylers":[{"color":"#8fb3ce"},{"visibility":"off"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#777c71"},{"visibility":"on"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#e1ecef"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"color":"#8fb3ce"},{"visibility":"on"}]}]

/***/ })
]);


// WEBPACK FOOTER //
// component---src-templates-tour-js-22e8abaa9834f0c449cb.js